/*! For license information please see compiler.js.LICENSE.txt */
(()=>{
var __webpack_modules__={515:function(e){
e.exports=function(e){
var t={};function n(r){
if(t[r]){
return t[r].exports;
}var s=t[r]={i:r,l:!1,exports:{}};return e[r].call(s.exports,s,s.exports,n),s.l=!0,s.exports;
}return n.m=e,n.c=t,n.d=function(e,t,r){
n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r});
},n.r=function(e){
"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0});
},n.t=function(e,t){
if(1&t&&(e=n(e)),8&t){
return e;
}if(4&t&&"object"==typeof e&&e&&e.__esModule){
return e;
}var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e){
for(var s in e){
n.d(r,s,function(t){
return e[t];
}.bind(null,s));
}
}return r;
},n.n=function(e){
var t=e&&e.__esModule?function(){
return e.default;
}:function(){
return e;
};return n.d(t,"a",t),t;
},n.o=function(e,t){
return Object.prototype.hasOwnProperty.call(e,t);
},n.p="",n(n.s=0);
}([function(e,t,n){
"use strict";n.r(t),n.d(t,"encode",(function(){
return T;
})),n.d(t,"decode",(function(){
return U;
})),n.d(t,"decodeAsync",(function(){
return K;
})),n.d(t,"decodeArrayStream",(function(){
return X;
})),n.d(t,"decodeStream",(function(){
return Y;
})),n.d(t,"Decoder",(function(){
return P;
})),n.d(t,"Encoder",(function(){
return N;
})),n.d(t,"ExtensionCodec",(function(){
return I;
})),n.d(t,"ExtData",(function(){
return p;
})),n.d(t,"EXT_TIMESTAMP",(function(){
return g;
})),n.d(t,"encodeDateToTimeSpec",(function(){
return x;
})),n.d(t,"encodeTimeSpecToTimestamp",(function(){
return b;
})),n.d(t,"decodeTimestampToTimeSpec",(function(){
return w;
})),n.d(t,"encodeTimestampExtension",(function(){
return y;
})),n.d(t,"decodeTimestampExtension",(function(){
return v;
}));var r=function(e,t){
var n="function"==typeof Symbol&&e[Symbol.iterator];if(!n){
return e;
}var r,s,i=n.call(e),a=[];try{
for(;(void 0===t||t-- >0)&&!(r=i.next()).done;){
a.push(r.value);
}
}catch(e){
s={error:e};
}finally{
try{
r&&!r.done&&(n=i.return)&&n.call(i);
}finally{
if(s){
throw s.error;
}
}
}return a;
},s=function(){
for(var e=[],t=0;t<arguments.length;t++){
e=e.concat(r(arguments[t]));
}return e;
},i="undefined"!=typeof process&&"undefined"!=typeof TextEncoder&&"undefined"!=typeof TextDecoder;function a(e){
for(var t=e.length,n=0,r=0;r<t;){
var s=e.charCodeAt(r++);if(0!=(4294967168&s)){
if(0==(4294965248&s)){
n+=2;
}else{
if(s>=55296&&s<=56319&&r<t){
var i=e.charCodeAt(r);56320==(64512&i)&&(++r,s=((1023&s)<<10)+(1023&i)+65536);
}n+=0==(4294901760&s)?3:4;
}
}else {
n++;
}
}return n;
}var o=i?new TextEncoder:void 0,u="undefined"!=typeof process?200:0,l=(null==o?void 0:o.encodeInto)?function(e,t,n){
o.encodeInto(e,t.subarray(n));
}:function(e,t,n){
t.set(o.encode(e),n);
};function c(e,t,n){
for(var r=t,i=r+n,a=[],o="";r<i;){
var u=e[r++];if(0==(128&u)){
a.push(u);
}else if(192==(224&u)){
var l=63&e[r++];a.push((31&u)<<6|l);
}else if(224==(240&u)){
l=63&e[r++];var c=63&e[r++];a.push((31&u)<<12|l<<6|c);
}else if(240==(248&u)){
var h=(7&u)<<18|(l=63&e[r++])<<12|(c=63&e[r++])<<6|63&e[r++];h>65535&&(h-=65536,a.push(h>>>10&1023|55296),h=56320|1023&h),a.push(h);
}else {
a.push(u);
}a.length>=4096&&(o+=String.fromCharCode.apply(String,s(a)),a.length=0);
}return a.length>0&&(o+=String.fromCharCode.apply(String,s(a))),o;
}var h=i?new TextDecoder:null,d="undefined"!=typeof process?200:0,p=function(e,t){
this.type=e,this.data=t;
};function f(e,t,n){
var r=Math.floor(n/4294967296),s=n;e.setUint32(t,r),e.setUint32(t+4,s);
}function m(e,t){
return 4294967296*e.getInt32(t)+e.getUint32(t+4);
}var g=-1;function b(e){
var t,n=e.sec,r=e.nsec;if(n>=0&&r>=0&&n<=17179869183){
if(0===r&&n<=4294967295){
var s=new Uint8Array(4);return(t=new DataView(s.buffer)).setUint32(0,n),s;
}var i=n/4294967296,a=4294967295&n;return s=new Uint8Array(8),(t=new DataView(s.buffer)).setUint32(0,r<<2|3&i),t.setUint32(4,a),s;
}return s=new Uint8Array(12),(t=new DataView(s.buffer)).setUint32(0,r),f(t,4,n),s;
}function x(e){
var t=e.getTime(),n=Math.floor(t/1e3),r=1e6*(t-1e3*n),s=Math.floor(r/1e9);return{sec:n+s,nsec:r-1e9*s};
}function y(e){
return e instanceof Date?b(x(e)):null;
}function w(e){
var t=new DataView(e.buffer,e.byteOffset,e.byteLength);switch(e.byteLength){
case 4:return{sec:t.getUint32(0),nsec:0};case 8:var n=t.getUint32(0);return{sec:4294967296*(3&n)+t.getUint32(4),nsec:n>>>2};case 12:return{sec:m(t,4),nsec:t.getUint32(0)};default:throw new Error("Unrecognized data size for timestamp: "+e.length);
}
}function v(e){
var t=w(e);return new Date(1e3*t.sec+t.nsec/1e6);
}var k={type:g,encode:y,decode:v},I=function(){
function e(){
this.builtInEncoders=[],this.builtInDecoders=[],this.encoders=[],this.decoders=[],this.register(k);
}return e.prototype.register=function(e){
var t=e.type,n=e.encode,r=e.decode;if(t>=0){
this.encoders[t]=n,this.decoders[t]=r;
}else{
var s=1+t;this.builtInEncoders[s]=n,this.builtInDecoders[s]=r;
}
},e.prototype.tryToEncode=function(e,t){
for(var n=0;n<this.builtInEncoders.length;n++){
if(null!=(r=this.builtInEncoders[n])&&null!=(s=r(e,t))){
return new p(-1-n,s);
}
}for(n=0;n<this.encoders.length;n++){
var r,s;if(null!=(r=this.encoders[n])&&null!=(s=r(e,t))){
return new p(n,s);
}
}return e instanceof p?e:null;
},e.prototype.decode=function(e,t,n){
var r=t<0?this.builtInDecoders[-1-t]:this.decoders[t];return r?r(e,t,n):new p(t,e);
},e.defaultCodec=new e,e;
}();function S(e){
return e instanceof Uint8Array?e:ArrayBuffer.isView(e)?new Uint8Array(e.buffer,e.byteOffset,e.byteLength):e instanceof ArrayBuffer?new Uint8Array(e):Uint8Array.from(e);
}var C=function(e){
var t="function"==typeof Symbol&&Symbol.iterator,n=t&&e[t],r=0;if(n){
return n.call(e);
}if(e&&"number"==typeof e.length){
return{next:function(){
return e&&r>=e.length&&(e=void 0),{value:e&&e[r++],done:!e};
}};
}throw new TypeError(t?"Object is not iterable.":"Symbol.iterator is not defined.");
},N=function(){
function e(e,t,n,r,s,i,a){
void 0===e&&(e=I.defaultCodec),void 0===n&&(n=100),void 0===r&&(r=2048),void 0===s&&(s=!1),void 0===i&&(i=!1),void 0===a&&(a=!1),this.extensionCodec=e,this.context=t,this.maxDepth=n,this.initialBufferSize=r,this.sortKeys=s,this.forceFloat32=i,this.ignoreUndefined=a,this.pos=0,this.view=new DataView(new ArrayBuffer(this.initialBufferSize)),this.bytes=new Uint8Array(this.view.buffer);
}return e.prototype.encode=function(e,t){
if(t>this.maxDepth){
throw new Error("Too deep objects in depth "+t);
}null==e?this.encodeNil():"boolean"==typeof e?this.encodeBoolean(e):"number"==typeof e?this.encodeNumber(e):"string"==typeof e?this.encodeString(e):this.encodeObject(e,t);
},e.prototype.getUint8Array=function(){
return this.bytes.subarray(0,this.pos);
},e.prototype.ensureBufferSizeToWrite=function(e){
var t=this.pos+e;this.view.byteLength<t&&this.resizeBuffer(2*t);
},e.prototype.resizeBuffer=function(e){
var t=new ArrayBuffer(e),n=new Uint8Array(t),r=new DataView(t);n.set(this.bytes),this.view=r,this.bytes=n;
},e.prototype.encodeNil=function(){
this.writeU8(192);
},e.prototype.encodeBoolean=function(e){
!1===e?this.writeU8(194):this.writeU8(195);
},e.prototype.encodeNumber=function(e){
Number.isSafeInteger(e)?e>=0?e<128?this.writeU8(e):e<256?(this.writeU8(204),this.writeU8(e)):e<65536?(this.writeU8(205),this.writeU16(e)):e<4294967296?(this.writeU8(206),this.writeU32(e)):(this.writeU8(207),this.writeU64(e)):e>=-32?this.writeU8(224|e+32):e>=-128?(this.writeU8(208),this.writeI8(e)):e>=-32768?(this.writeU8(209),this.writeI16(e)):e>=-2147483648?(this.writeU8(210),this.writeI32(e)):(this.writeU8(211),this.writeI64(e)):this.forceFloat32?(this.writeU8(202),this.writeF32(e)):(this.writeU8(203),this.writeF64(e));
},e.prototype.writeStringHeader=function(e){
if(e<32){
this.writeU8(160+e);
}else if(e<256){
this.writeU8(217),this.writeU8(e);
}else if(e<65536){
this.writeU8(218),this.writeU16(e);
}else{
if(!(e<4294967296)){
throw new Error("Too long string: "+e+" bytes in UTF-8");
}this.writeU8(219),this.writeU32(e);
}
},e.prototype.encodeString=function(e){
var t=e.length;if(i&&t>u){
var n=a(e);this.ensureBufferSizeToWrite(5+n),this.writeStringHeader(n),l(e,this.bytes,this.pos),this.pos+=n;
}else {
n=a(e),this.ensureBufferSizeToWrite(5+n),this.writeStringHeader(n),function(e,t,n){
for(var r=e.length,s=n,i=0;i<r;){
var a=e.charCodeAt(i++);if(0!=(4294967168&a)){
if(0==(4294965248&a)){
t[s++]=a>>6&31|192;
}else{
if(a>=55296&&a<=56319&&i<r){
var o=e.charCodeAt(i);56320==(64512&o)&&(++i,a=((1023&a)<<10)+(1023&o)+65536);
}0==(4294901760&a)?(t[s++]=a>>12&15|224,t[s++]=a>>6&63|128):(t[s++]=a>>18&7|240,t[s++]=a>>12&63|128,t[s++]=a>>6&63|128);
}t[s++]=63&a|128;
}else {
t[s++]=a;
}
}
}(e,this.bytes,this.pos),this.pos+=n;
}
},e.prototype.encodeObject=function(e,t){
var n=this.extensionCodec.tryToEncode(e,this.context);if(null!=n){
this.encodeExtension(n);
}else if(Array.isArray(e)){
this.encodeArray(e,t);
}else if(ArrayBuffer.isView(e)){
this.encodeBinary(e);
}else{
if("object"!=typeof e){
throw new Error("Unrecognized object: "+Object.prototype.toString.apply(e));
}this.encodeMap(e,t);
}
},e.prototype.encodeBinary=function(e){
var t=e.byteLength;if(t<256){
this.writeU8(196),this.writeU8(t);
}else if(t<65536){
this.writeU8(197),this.writeU16(t);
}else{
if(!(t<4294967296)){
throw new Error("Too large binary: "+t);
}this.writeU8(198),this.writeU32(t);
}var n=S(e);this.writeU8a(n);
},e.prototype.encodeArray=function(e,t){
var n,r,s=e.length;if(s<16){
this.writeU8(144+s);
}else if(s<65536){
this.writeU8(220),this.writeU16(s);
}else{
if(!(s<4294967296)){
throw new Error("Too large array: "+s);
}this.writeU8(221),this.writeU32(s);
}try{
for(var i=C(e),a=i.next();!a.done;a=i.next()){
var o=a.value;this.encode(o,t+1);
}
}catch(e){
n={error:e};
}finally{
try{
a&&!a.done&&(r=i.return)&&r.call(i);
}finally{
if(n){
throw n.error;
}
}
}
},e.prototype.countWithoutUndefined=function(e,t){
var n,r,s=0;try{
for(var i=C(t),a=i.next();!a.done;a=i.next()){
void 0!==e[a.value]&&s++;
}
}catch(e){
n={error:e};
}finally{
try{
a&&!a.done&&(r=i.return)&&r.call(i);
}finally{
if(n){
throw n.error;
}
}
}return s;
},e.prototype.encodeMap=function(e,t){
var n,r,s=Object.keys(e);this.sortKeys&&s.sort();var i=this.ignoreUndefined?this.countWithoutUndefined(e,s):s.length;if(i<16){
this.writeU8(128+i);
}else if(i<65536){
this.writeU8(222),this.writeU16(i);
}else{
if(!(i<4294967296)){
throw new Error("Too large map object: "+i);
}this.writeU8(223),this.writeU32(i);
}try{
for(var a=C(s),o=a.next();!o.done;o=a.next()){
var u=o.value,l=e[u];this.ignoreUndefined&&void 0===l||(this.encodeString(u),this.encode(l,t+1));
}
}catch(e){
n={error:e};
}finally{
try{
o&&!o.done&&(r=a.return)&&r.call(a);
}finally{
if(n){
throw n.error;
}
}
}
},e.prototype.encodeExtension=function(e){
var t=e.data.length;if(1===t){
this.writeU8(212);
}else if(2===t){
this.writeU8(213);
}else if(4===t){
this.writeU8(214);
}else if(8===t){
this.writeU8(215);
}else if(16===t){
this.writeU8(216);
}else if(t<256){
this.writeU8(199),this.writeU8(t);
}else if(t<65536){
this.writeU8(200),this.writeU16(t);
}else{
if(!(t<4294967296)){
throw new Error("Too large extension object: "+t);
}this.writeU8(201),this.writeU32(t);
}this.writeI8(e.type),this.writeU8a(e.data);
},e.prototype.writeU8=function(e){
this.ensureBufferSizeToWrite(1),this.view.setUint8(this.pos,e),this.pos++;
},e.prototype.writeU8a=function(e){
var t=e.length;this.ensureBufferSizeToWrite(t),this.bytes.set(e,this.pos),this.pos+=t;
},e.prototype.writeI8=function(e){
this.ensureBufferSizeToWrite(1),this.view.setInt8(this.pos,e),this.pos++;
},e.prototype.writeU16=function(e){
this.ensureBufferSizeToWrite(2),this.view.setUint16(this.pos,e),this.pos+=2;
},e.prototype.writeI16=function(e){
this.ensureBufferSizeToWrite(2),this.view.setInt16(this.pos,e),this.pos+=2;
},e.prototype.writeU32=function(e){
this.ensureBufferSizeToWrite(4),this.view.setUint32(this.pos,e),this.pos+=4;
},e.prototype.writeI32=function(e){
this.ensureBufferSizeToWrite(4),this.view.setInt32(this.pos,e),this.pos+=4;
},e.prototype.writeF32=function(e){
this.ensureBufferSizeToWrite(4),this.view.setFloat32(this.pos,e),this.pos+=4;
},e.prototype.writeF64=function(e){
this.ensureBufferSizeToWrite(8),this.view.setFloat64(this.pos,e),this.pos+=8;
},e.prototype.writeU64=function(e){
this.ensureBufferSizeToWrite(8),function(e,t,n){
var r=n/4294967296,s=n;e.setUint32(t,r),e.setUint32(t+4,s);
}(this.view,this.pos,e),this.pos+=8;
},e.prototype.writeI64=function(e){
this.ensureBufferSizeToWrite(8),f(this.view,this.pos,e),this.pos+=8;
},e;
}(),$={};function T(e,t){
void 0===t&&(t=$);var n=new N(t.extensionCodec,t.context,t.maxDepth,t.initialBufferSize,t.sortKeys,t.forceFloat32,t.ignoreUndefined);return n.encode(e,1),n.getUint8Array();
}function E(e){
return(e<0?"-":"")+"0x"+Math.abs(e).toString(16).padStart(2,"0");
}var R=function(){
function e(e,t){
void 0===e&&(e=16),void 0===t&&(t=16),this.maxKeyLength=e,this.maxLengthPerKey=t,this.caches=[];for(var n=0;n<this.maxKeyLength;n++){
this.caches.push([]);
}
}return e.prototype.canBeCached=function(e){
return e>0&&e<=this.maxKeyLength;
},e.prototype.get=function(e,t,n){
var r=this.caches[n-1],s=r.length;e:for(var i=0;i<s;i++){
for(var a=r[i],o=a.bytes,u=0;u<n;u++){
if(o[u]!==e[t+u]){
continue e;
}
}return a.value;
}return null;
},e.prototype.store=function(e,t){
var n=this.caches[e.length-1],r={bytes:e,value:t};n.length>=this.maxLengthPerKey?n[Math.random()*n.length|0]=r:n.push(r);
},e.prototype.decode=function(e,t,n){
var r=this.get(e,t,n);if(null!=r){
return r;
}var s=c(e,t,n),i=Uint8Array.prototype.slice.call(e,t,t+n);return this.store(i,s),s;
},e;
}(),A=function(e,t){
var n,r,s,i,a={label:0,sent:function(){
if(1&s[0]){
throw s[1];
}return s[1];
},trys:[],ops:[]};return i={next:o(0),throw:o(1),return:o(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){
return this;
}),i;function o(i){
return function(o){
return function(i){
if(n){
throw new TypeError("Generator is already executing.");
}for(;a;){
try{
if(n=1,r&&(s=2&i[0]?r.return:i[0]?r.throw||((s=r.return)&&s.call(r),0):r.next)&&!(s=s.call(r,i[1])).done){
return s;
}switch(r=0,s&&(i=[2&i[0],s.value]),i[0]){
case 0:case 1:s=i;break;case 4:return a.label++,{value:i[1],done:!1};case 5:a.label++,r=i[1],i=[0];continue;case 7:i=a.ops.pop(),a.trys.pop();continue;default:if(!((s=(s=a.trys).length>0&&s[s.length-1])||6!==i[0]&&2!==i[0])){
a=0;continue;
}if(3===i[0]&&(!s||i[1]>s[0]&&i[1]<s[3])){
a.label=i[1];break;
}if(6===i[0]&&a.label<s[1]){
a.label=s[1],s=i;break;
}if(s&&a.label<s[2]){
a.label=s[2],a.ops.push(i);break;
}s[2]&&a.ops.pop(),a.trys.pop();continue;
}i=t.call(e,a);
}catch(e){
i=[6,e],r=0;
}finally{
n=s=0;
}
}if(5&i[0]){
throw i[1];
}return{value:i[0]?i[1]:void 0,done:!0};
}([i,o]);
};
}
},F=function(e){
if(!Symbol.asyncIterator){
throw new TypeError("Symbol.asyncIterator is not defined.");
}var t,n=e[Symbol.asyncIterator];return n?n.call(e):(e="function"==typeof __values?__values(e):e[Symbol.iterator](),t={},r("next"),r("throw"),r("return"),t[Symbol.asyncIterator]=function(){
return this;
},t);function r(n){
t[n]=e[n]&&function(t){
return new Promise((function(r,s){
!function(e,t,n,r){
Promise.resolve(r).then((function(t){
e({value:t,done:n});
}),t);
}(r,s,(t=e[n](t)).done,t.value);
}));
};
}
},_=function(e){
return this instanceof _?(this.v=e,this):new _(e);
},D=new DataView(new ArrayBuffer(0)),O=new Uint8Array(D.buffer),M=function(){
try{
D.getInt8(0);
}catch(e){
return e.constructor;
}throw new Error("never reached");
}(),L=new M("Insufficient data"),z=new R,P=function(){
function e(e,t,n,r,s,i,a,o){
void 0===e&&(e=I.defaultCodec),void 0===n&&(n=4294967295),void 0===r&&(r=4294967295),void 0===s&&(s=4294967295),void 0===i&&(i=4294967295),void 0===a&&(a=4294967295),void 0===o&&(o=z),this.extensionCodec=e,this.context=t,this.maxStrLength=n,this.maxBinLength=r,this.maxArrayLength=s,this.maxMapLength=i,this.maxExtLength=a,this.cachedKeyDecoder=o,this.totalPos=0,this.pos=0,this.view=D,this.bytes=O,this.headByte=-1,this.stack=[];
}return e.prototype.setBuffer=function(e){
this.bytes=S(e),this.view=function(e){
if(e instanceof ArrayBuffer){
return new DataView(e);
}var t=S(e);return new DataView(t.buffer,t.byteOffset,t.byteLength);
}(this.bytes),this.pos=0;
},e.prototype.appendBuffer=function(e){
if(-1!==this.headByte||this.hasRemaining()){
var t=this.bytes.subarray(this.pos),n=S(e),r=new Uint8Array(t.length+n.length);r.set(t),r.set(n,t.length),this.setBuffer(r);
}else {
this.setBuffer(e);
}
},e.prototype.hasRemaining=function(e){
return void 0===e&&(e=1),this.view.byteLength-this.pos>=e;
},e.prototype.createNoExtraBytesError=function(e){
var t=this.view,n=this.pos;return new RangeError("Extra "+(t.byteLength-n)+" byte(s) found at buffer["+e+"]");
},e.prototype.decodeSingleSync=function(){
var e=this.decodeSync();if(this.hasRemaining()){
throw this.createNoExtraBytesError(this.pos);
}return e;
},e.prototype.decodeSingleAsync=function(e){
var t,n,r,s;return function(e,t,n,r){
return new(n||(n=Promise))((function(s,i){
function a(e){
try{
u(r.next(e));
}catch(e){
i(e);
}
}function o(e){
try{
u(r.throw(e));
}catch(e){
i(e);
}
}function u(e){
var t;e.done?s(e.value):(t=e.value,t instanceof n?t:new n((function(e){
e(t);
}))).then(a,o);
}u((r=r.apply(e,t||[])).next());
}));
}(this,void 0,void 0,(function(){
var i,a,o,u,l,c,h,d;return A(this,(function(p){
switch(p.label){
case 0:i=!1,p.label=1;case 1:p.trys.push([1,6,7,12]),t=F(e),p.label=2;case 2:return[4,t.next()];case 3:if((n=p.sent()).done){
return[3,5];
}if(o=n.value,i){
throw this.createNoExtraBytesError(this.totalPos);
}this.appendBuffer(o);try{
a=this.decodeSync(),i=!0;
}catch(e){
if(!(e instanceof M)){
throw e;
}
}this.totalPos+=this.pos,p.label=4;case 4:return[3,2];case 5:return[3,12];case 6:return u=p.sent(),r={error:u},[3,12];case 7:return p.trys.push([7,,10,11]),n&&!n.done&&(s=t.return)?[4,s.call(t)]:[3,9];case 8:p.sent(),p.label=9;case 9:return[3,11];case 10:if(r){
throw r.error;
}return[7];case 11:return[7];case 12:if(i){
if(this.hasRemaining()){
throw this.createNoExtraBytesError(this.totalPos);
}return[2,a];
}throw c=(l=this).headByte,h=l.pos,d=l.totalPos,new RangeError("Insufficient data in parcing "+E(c)+" at "+d+" ("+h+" in the current buffer)");
}
}));
}));
},e.prototype.decodeArrayStream=function(e){
return this.decodeMultiAsync(e,!0);
},e.prototype.decodeStream=function(e){
return this.decodeMultiAsync(e,!1);
},e.prototype.decodeMultiAsync=function(e,t){
return function(e,t,n){
if(!Symbol.asyncIterator){
throw new TypeError("Symbol.asyncIterator is not defined.");
}var r,s=n.apply(e,t||[]),i=[];return r={},a("next"),a("throw"),a("return"),r[Symbol.asyncIterator]=function(){
return this;
},r;function a(e){
s[e]&&(r[e]=function(t){
return new Promise((function(n,r){
i.push([e,t,n,r])>1||o(e,t);
}));
});
}function o(e,t){
try{
(n=s[e](t)).value instanceof _?Promise.resolve(n.value.v).then(u,l):c(i[0][2],n);
}catch(e){
c(i[0][3],e);
}var n;
}function u(e){
o("next",e);
}function l(e){
o("throw",e);
}function c(e,t){
e(t),i.shift(),i.length&&o(i[0][0],i[0][1]);
}
}(this,arguments,(function(){
var n,r,s,i,a,o,u,l,c;return A(this,(function(h){
switch(h.label){
case 0:n=t,r=-1,h.label=1;case 1:h.trys.push([1,13,14,19]),s=F(e),h.label=2;case 2:return[4,_(s.next())];case 3:if((i=h.sent()).done){
return[3,12];
}if(a=i.value,t&&0===r){
throw this.createNoExtraBytesError(this.totalPos);
}this.appendBuffer(a),n&&(r=this.readArraySize(),n=!1,this.complete()),h.label=4;case 4:h.trys.push([4,9,,10]),h.label=5;case 5:return[4,_(this.decodeSync())];case 6:return[4,h.sent()];case 7:return h.sent(),0==--r?[3,8]:[3,5];case 8:return[3,10];case 9:if(!((o=h.sent())instanceof M)){
throw o;
}return[3,10];case 10:this.totalPos+=this.pos,h.label=11;case 11:return[3,2];case 12:return[3,19];case 13:return u=h.sent(),l={error:u},[3,19];case 14:return h.trys.push([14,,17,18]),i&&!i.done&&(c=s.return)?[4,_(c.call(s))]:[3,16];case 15:h.sent(),h.label=16;case 16:return[3,18];case 17:if(l){
throw l.error;
}return[7];case 18:return[7];case 19:return[2];
}
}));
}));
},e.prototype.decodeSync=function(){
e:for(;;){
var e=this.readHeadByte(),t=void 0;if(e>=224){
t=e-256;
}else if(e<192){
if(e<128){
t=e;
}else if(e<144){
if(0!=(r=e-128)){
this.pushMapState(r),this.complete();continue e;
}t={};
}else if(e<160){
if(0!=(r=e-144)){
this.pushArrayState(r),this.complete();continue e;
}t=[];
}else{
var n=e-160;t=this.decodeUtf8String(n,0);
}
}else if(192===e){
t=null;
}else if(194===e){
t=!1;
}else if(195===e){
t=!0;
}else if(202===e){
t=this.readF32();
}else if(203===e){
t=this.readF64();
}else if(204===e){
t=this.readU8();
}else if(205===e){
t=this.readU16();
}else if(206===e){
t=this.readU32();
}else if(207===e){
t=this.readU64();
}else if(208===e){
t=this.readI8();
}else if(209===e){
t=this.readI16();
}else if(210===e){
t=this.readI32();
}else if(211===e){
t=this.readI64();
}else if(217===e){
n=this.lookU8(),t=this.decodeUtf8String(n,1);
}else if(218===e){
n=this.lookU16(),t=this.decodeUtf8String(n,2);
}else if(219===e){
n=this.lookU32(),t=this.decodeUtf8String(n,4);
}else if(220===e){
if(0!==(r=this.readU16())){
this.pushArrayState(r),this.complete();continue e;
}t=[];
}else if(221===e){
if(0!==(r=this.readU32())){
this.pushArrayState(r),this.complete();continue e;
}t=[];
}else if(222===e){
if(0!==(r=this.readU16())){
this.pushMapState(r),this.complete();continue e;
}t={};
}else if(223===e){
if(0!==(r=this.readU32())){
this.pushMapState(r),this.complete();continue e;
}t={};
}else if(196===e){
var r=this.lookU8();t=this.decodeBinary(r,1);
}else if(197===e){
r=this.lookU16(),t=this.decodeBinary(r,2);
}else if(198===e){
r=this.lookU32(),t=this.decodeBinary(r,4);
}else if(212===e){
t=this.decodeExtension(1,0);
}else if(213===e){
t=this.decodeExtension(2,0);
}else if(214===e){
t=this.decodeExtension(4,0);
}else if(215===e){
t=this.decodeExtension(8,0);
}else if(216===e){
t=this.decodeExtension(16,0);
}else if(199===e){
r=this.lookU8(),t=this.decodeExtension(r,1);
}else if(200===e){
r=this.lookU16(),t=this.decodeExtension(r,2);
}else{
if(201!==e){
throw new Error("Unrecognized type byte: "+E(e));
}r=this.lookU32(),t=this.decodeExtension(r,4);
}this.complete();for(var s=this.stack;s.length>0;){
var i=s[s.length-1];if(0===i.type){
if(i.array[i.position]=t,i.position++,i.position!==i.size){
continue e;
}s.pop(),t=i.array;
}else{
if(1===i.type){
if(void 0,"string"!=(a=typeof t)&&"number"!==a){
throw new Error("The type of key must be string or number but "+typeof t);
}i.key=t,i.type=2;continue e;
}if(i.map[i.key]=t,i.readCount++,i.readCount!==i.size){
i.key=null,i.type=1;continue e;
}s.pop(),t=i.map;
}
}return t;
}var a;
},e.prototype.readHeadByte=function(){
return-1===this.headByte&&(this.headByte=this.readU8()),this.headByte;
},e.prototype.complete=function(){
this.headByte=-1;
},e.prototype.readArraySize=function(){
var e=this.readHeadByte();switch(e){
case 220:return this.readU16();case 221:return this.readU32();default:if(e<160){
return e-144;
}throw new Error("Unrecognized array type byte: "+E(e));
}
},e.prototype.pushMapState=function(e){
if(e>this.maxMapLength){
throw new Error("Max length exceeded: map length ("+e+") > maxMapLengthLength ("+this.maxMapLength+")");
}this.stack.push({type:1,size:e,key:null,readCount:0,map:{}});
},e.prototype.pushArrayState=function(e){
if(e>this.maxArrayLength){
throw new Error("Max length exceeded: array length ("+e+") > maxArrayLength ("+this.maxArrayLength+")");
}this.stack.push({type:0,size:e,array:new Array(e),position:0});
},e.prototype.decodeUtf8String=function(e,t){
var n;if(e>this.maxStrLength){
throw new Error("Max length exceeded: UTF-8 byte length ("+e+") > maxStrLength ("+this.maxStrLength+")");
}if(this.bytes.byteLength<this.pos+t+e){
throw L;
}var r,s=this.pos+t;return r=this.stateIsMapKey()&&(null===(n=this.cachedKeyDecoder)||void 0===n?void 0:n.canBeCached(e))?this.cachedKeyDecoder.decode(this.bytes,s,e):i&&e>d?function(e,t,n){
var r=e.subarray(t,t+n);return h.decode(r);
}(this.bytes,s,e):c(this.bytes,s,e),this.pos+=t+e,r;
},e.prototype.stateIsMapKey=function(){
return this.stack.length>0&&1===this.stack[this.stack.length-1].type;
},e.prototype.decodeBinary=function(e,t){
if(e>this.maxBinLength){
throw new Error("Max length exceeded: bin length ("+e+") > maxBinLength ("+this.maxBinLength+")");
}if(!this.hasRemaining(e+t)){
throw L;
}var n=this.pos+t,r=this.bytes.subarray(n,n+e);return this.pos+=t+e,r;
},e.prototype.decodeExtension=function(e,t){
if(e>this.maxExtLength){
throw new Error("Max length exceeded: ext length ("+e+") > maxExtLength ("+this.maxExtLength+")");
}var n=this.view.getInt8(this.pos+t),r=this.decodeBinary(e,t+1);return this.extensionCodec.decode(r,n,this.context);
},e.prototype.lookU8=function(){
return this.view.getUint8(this.pos);
},e.prototype.lookU16=function(){
return this.view.getUint16(this.pos);
},e.prototype.lookU32=function(){
return this.view.getUint32(this.pos);
},e.prototype.readU8=function(){
var e=this.view.getUint8(this.pos);return this.pos++,e;
},e.prototype.readI8=function(){
var e=this.view.getInt8(this.pos);return this.pos++,e;
},e.prototype.readU16=function(){
var e=this.view.getUint16(this.pos);return this.pos+=2,e;
},e.prototype.readI16=function(){
var e=this.view.getInt16(this.pos);return this.pos+=2,e;
},e.prototype.readU32=function(){
var e=this.view.getUint32(this.pos);return this.pos+=4,e;
},e.prototype.readI32=function(){
var e=this.view.getInt32(this.pos);return this.pos+=4,e;
},e.prototype.readU64=function(){
var e,t,n=(e=this.view,t=this.pos,4294967296*e.getUint32(t)+e.getUint32(t+4));return this.pos+=8,n;
},e.prototype.readI64=function(){
var e=m(this.view,this.pos);return this.pos+=8,e;
},e.prototype.readF32=function(){
var e=this.view.getFloat32(this.pos);return this.pos+=4,e;
},e.prototype.readF64=function(){
var e=this.view.getFloat64(this.pos);return this.pos+=8,e;
},e;
}(),B={};function U(e,t){
void 0===t&&(t=B);var n=new P(t.extensionCodec,t.context,t.maxStrLength,t.maxBinLength,t.maxArrayLength,t.maxMapLength,t.maxExtLength);return n.setBuffer(e),n.decodeSingleSync();
}var W=function(e,t){
var n,r,s,i,a={label:0,sent:function(){
if(1&s[0]){
throw s[1];
}return s[1];
},trys:[],ops:[]};return i={next:o(0),throw:o(1),return:o(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){
return this;
}),i;function o(i){
return function(o){
return function(i){
if(n){
throw new TypeError("Generator is already executing.");
}for(;a;){
try{
if(n=1,r&&(s=2&i[0]?r.return:i[0]?r.throw||((s=r.return)&&s.call(r),0):r.next)&&!(s=s.call(r,i[1])).done){
return s;
}switch(r=0,s&&(i=[2&i[0],s.value]),i[0]){
case 0:case 1:s=i;break;case 4:return a.label++,{value:i[1],done:!1};case 5:a.label++,r=i[1],i=[0];continue;case 7:i=a.ops.pop(),a.trys.pop();continue;default:if(!((s=(s=a.trys).length>0&&s[s.length-1])||6!==i[0]&&2!==i[0])){
a=0;continue;
}if(3===i[0]&&(!s||i[1]>s[0]&&i[1]<s[3])){
a.label=i[1];break;
}if(6===i[0]&&a.label<s[1]){
a.label=s[1],s=i;break;
}if(s&&a.label<s[2]){
a.label=s[2],a.ops.push(i);break;
}s[2]&&a.ops.pop(),a.trys.pop();continue;
}i=t.call(e,a);
}catch(e){
i=[6,e],r=0;
}finally{
n=s=0;
}
}if(5&i[0]){
throw i[1];
}return{value:i[0]?i[1]:void 0,done:!0};
}([i,o]);
};
}
},V=function(e){
return this instanceof V?(this.v=e,this):new V(e);
},G=function(e,t,n){
if(!Symbol.asyncIterator){
throw new TypeError("Symbol.asyncIterator is not defined.");
}var r,s=n.apply(e,t||[]),i=[];return r={},a("next"),a("throw"),a("return"),r[Symbol.asyncIterator]=function(){
return this;
},r;function a(e){
s[e]&&(r[e]=function(t){
return new Promise((function(n,r){
i.push([e,t,n,r])>1||o(e,t);
}));
});
}function o(e,t){
try{
(n=s[e](t)).value instanceof V?Promise.resolve(n.value.v).then(u,l):c(i[0][2],n);
}catch(e){
c(i[0][3],e);
}var n;
}function u(e){
o("next",e);
}function l(e){
o("throw",e);
}function c(e,t){
e(t),i.shift(),i.length&&o(i[0][0],i[0][1]);
}
};function j(e){
return null!=e[Symbol.asyncIterator]?e:function(e){
return G(this,arguments,(function(){
var t,n,r,s;return W(this,(function(i){
switch(i.label){
case 0:t=e.getReader(),i.label=1;case 1:i.trys.push([1,,9,10]),i.label=2;case 2:return[4,V(t.read())];case 3:return n=i.sent(),r=n.done,s=n.value,r?[4,V(void 0)]:[3,5];case 4:return[2,i.sent()];case 5:return function(e){
if(null==e){
throw new Error("Assertion Failure: value must not be null nor undefined");
}
}(s),[4,V(s)];case 6:return[4,i.sent()];case 7:return i.sent(),[3,2];case 8:return[3,10];case 9:return t.releaseLock(),[7];case 10:return[2];
}
}));
}));
}(e);
}var H=function(e,t,n,r){
return new(n||(n=Promise))((function(s,i){
function a(e){
try{
u(r.next(e));
}catch(e){
i(e);
}
}function o(e){
try{
u(r.throw(e));
}catch(e){
i(e);
}
}function u(e){
var t;e.done?s(e.value):(t=e.value,t instanceof n?t:new n((function(e){
e(t);
}))).then(a,o);
}u((r=r.apply(e,t||[])).next());
}));
},q=function(e,t){
var n,r,s,i,a={label:0,sent:function(){
if(1&s[0]){
throw s[1];
}return s[1];
},trys:[],ops:[]};return i={next:o(0),throw:o(1),return:o(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){
return this;
}),i;function o(i){
return function(o){
return function(i){
if(n){
throw new TypeError("Generator is already executing.");
}for(;a;){
try{
if(n=1,r&&(s=2&i[0]?r.return:i[0]?r.throw||((s=r.return)&&s.call(r),0):r.next)&&!(s=s.call(r,i[1])).done){
return s;
}switch(r=0,s&&(i=[2&i[0],s.value]),i[0]){
case 0:case 1:s=i;break;case 4:return a.label++,{value:i[1],done:!1};case 5:a.label++,r=i[1],i=[0];continue;case 7:i=a.ops.pop(),a.trys.pop();continue;default:if(!((s=(s=a.trys).length>0&&s[s.length-1])||6!==i[0]&&2!==i[0])){
a=0;continue;
}if(3===i[0]&&(!s||i[1]>s[0]&&i[1]<s[3])){
a.label=i[1];break;
}if(6===i[0]&&a.label<s[1]){
a.label=s[1],s=i;break;
}if(s&&a.label<s[2]){
a.label=s[2],a.ops.push(i);break;
}s[2]&&a.ops.pop(),a.trys.pop();continue;
}i=t.call(e,a);
}catch(e){
i=[6,e],r=0;
}finally{
n=s=0;
}
}if(5&i[0]){
throw i[1];
}return{value:i[0]?i[1]:void 0,done:!0};
}([i,o]);
};
}
};function K(e,t){
return void 0===t&&(t=B),H(this,void 0,void 0,(function(){
var n;return q(this,(function(r){
return n=j(e),[2,new P(t.extensionCodec,t.context,t.maxStrLength,t.maxBinLength,t.maxArrayLength,t.maxMapLength,t.maxExtLength).decodeSingleAsync(n)];
}));
}));
}function X(e,t){
void 0===t&&(t=B);var n=j(e);return new P(t.extensionCodec,t.context,t.maxStrLength,t.maxBinLength,t.maxArrayLength,t.maxMapLength,t.maxExtLength).decodeArrayStream(n);
}function Y(e,t){
void 0===t&&(t=B);var n=j(e);return new P(t.extensionCodec,t.context,t.maxStrLength,t.maxBinLength,t.maxArrayLength,t.maxMapLength,t.maxExtLength).decodeStream(n);
}
}]);
},808:e=>{
e.exports=n;var t=null;try{
t=new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([0,97,115,109,1,0,0,0,1,13,2,96,0,1,127,96,4,127,127,127,127,1,127,3,7,6,0,1,1,1,1,1,6,6,1,127,1,65,0,11,7,50,6,3,109,117,108,0,1,5,100,105,118,95,115,0,2,5,100,105,118,95,117,0,3,5,114,101,109,95,115,0,4,5,114,101,109,95,117,0,5,8,103,101,116,95,104,105,103,104,0,0,10,191,1,6,4,0,35,0,11,36,1,1,126,32,0,173,32,1,173,66,32,134,132,32,2,173,32,3,173,66,32,134,132,126,34,4,66,32,135,167,36,0,32,4,167,11,36,1,1,126,32,0,173,32,1,173,66,32,134,132,32,2,173,32,3,173,66,32,134,132,127,34,4,66,32,135,167,36,0,32,4,167,11,36,1,1,126,32,0,173,32,1,173,66,32,134,132,32,2,173,32,3,173,66,32,134,132,128,34,4,66,32,135,167,36,0,32,4,167,11,36,1,1,126,32,0,173,32,1,173,66,32,134,132,32,2,173,32,3,173,66,32,134,132,129,34,4,66,32,135,167,36,0,32,4,167,11,36,1,1,126,32,0,173,32,1,173,66,32,134,132,32,2,173,32,3,173,66,32,134,132,130,34,4,66,32,135,167,36,0,32,4,167,11])),{}).exports;
}catch(e){}function n(e,t,n){
this.low=0|e,this.high=0|t,this.unsigned=!!n;
}function r(e){
return!0===(e&&e.__isLong__);
}n.prototype.__isLong__,Object.defineProperty(n.prototype,"__isLong__",{value:!0}),n.isLong=r;var s={},i={};function a(e,t){
var n,r,a;return t?(a=0<=(e>>>=0)&&e<256)&&(r=i[e])?r:(n=u(e,(0|e)<0?-1:0,!0),a&&(i[e]=n),n):(a=-128<=(e|=0)&&e<128)&&(r=s[e])?r:(n=u(e,e<0?-1:0,!1),a&&(s[e]=n),n);
}function o(e,t){
if(isNaN(e)){
return t?b:g;
}if(t){
if(e<0){
return b;
}if(e>=p){
return k;
}
}else{
if(e<=-f){
return I;
}if(e+1>=f){
return v;
}
}return e<0?o(-e,t).neg():u(e%d|0,e/d|0,t);
}function u(e,t,r){
return new n(e,t,r);
}n.fromInt=a,n.fromNumber=o,n.fromBits=u;var l=Math.pow;function c(e,t,n){
if(0===e.length){
throw Error("empty string");
}if("NaN"===e||"Infinity"===e||"+Infinity"===e||"-Infinity"===e){
return g;
}if("number"==typeof t?(n=t,t=!1):t=!!t,(n=n||10)<2||36<n){
throw RangeError("radix");
}var r;if((r=e.indexOf("-"))>0){
throw Error("interior hyphen");
}if(0===r){
return c(e.substring(1),t,n).neg();
}for(var s=o(l(n,8)),i=g,a=0;a<e.length;a+=8){
var u=Math.min(8,e.length-a),h=parseInt(e.substring(a,a+u),n);if(u<8){
var d=o(l(n,u));i=i.mul(d).add(o(h));
}else {
i=(i=i.mul(s)).add(o(h));
}
}return i.unsigned=t,i;
}function h(e,t){
return"number"==typeof e?o(e,t):"string"==typeof e?c(e,t):u(e.low,e.high,"boolean"==typeof t?t:e.unsigned);
}n.fromString=c,n.fromValue=h;var d=4294967296,p=d*d,f=p/2,m=a(1<<24),g=a(0);n.ZERO=g;var b=a(0,!0);n.UZERO=b;var x=a(1);n.ONE=x;var y=a(1,!0);n.UONE=y;var w=a(-1);n.NEG_ONE=w;var v=u(-1,2147483647,!1);n.MAX_VALUE=v;var k=u(-1,-1,!0);n.MAX_UNSIGNED_VALUE=k;var I=u(0,-2147483648,!1);n.MIN_VALUE=I;var S=n.prototype;S.toInt=function(){
return this.unsigned?this.low>>>0:this.low;
},S.toNumber=function(){
return this.unsigned?(this.high>>>0)*d+(this.low>>>0):this.high*d+(this.low>>>0);
},S.toString=function(e){
if((e=e||10)<2||36<e){
throw RangeError("radix");
}if(this.isZero()){
return"0";
}if(this.isNegative()){
if(this.eq(I)){
var t=o(e),n=this.div(t),r=n.mul(t).sub(this);return n.toString(e)+r.toInt().toString(e);
}return"-"+this.neg().toString(e);
}for(var s=o(l(e,6),this.unsigned),i=this,a="";;){
var u=i.div(s),c=(i.sub(u.mul(s)).toInt()>>>0).toString(e);if((i=u).isZero()){
return c+a;
}for(;c.length<6;){
c="0"+c;
}a=""+c+a;
}
},S.getHighBits=function(){
return this.high;
},S.getHighBitsUnsigned=function(){
return this.high>>>0;
},S.getLowBits=function(){
return this.low;
},S.getLowBitsUnsigned=function(){
return this.low>>>0;
},S.getNumBitsAbs=function(){
if(this.isNegative()){
return this.eq(I)?64:this.neg().getNumBitsAbs();
}for(var e=0!=this.high?this.high:this.low,t=31;t>0&&0==(e&1<<t);t--){}return 0!=this.high?t+33:t+1;
},S.isZero=function(){
return 0===this.high&&0===this.low;
},S.eqz=S.isZero,S.isNegative=function(){
return!this.unsigned&&this.high<0;
},S.isPositive=function(){
return this.unsigned||this.high>=0;
},S.isOdd=function(){
return 1==(1&this.low);
},S.isEven=function(){
return 0==(1&this.low);
},S.equals=function(e){
return r(e)||(e=h(e)),(this.unsigned===e.unsigned||this.high>>>31!=1||e.high>>>31!=1)&&this.high===e.high&&this.low===e.low;
},S.eq=S.equals,S.notEquals=function(e){
return!this.eq(e);
},S.neq=S.notEquals,S.ne=S.notEquals,S.lessThan=function(e){
return this.comp(e)<0;
},S.lt=S.lessThan,S.lessThanOrEqual=function(e){
return this.comp(e)<=0;
},S.lte=S.lessThanOrEqual,S.le=S.lessThanOrEqual,S.greaterThan=function(e){
return this.comp(e)>0;
},S.gt=S.greaterThan,S.greaterThanOrEqual=function(e){
return this.comp(e)>=0;
},S.gte=S.greaterThanOrEqual,S.ge=S.greaterThanOrEqual,S.compare=function(e){
if(r(e)||(e=h(e)),this.eq(e)){
return 0;
}var t=this.isNegative(),n=e.isNegative();return t&&!n?-1:!t&&n?1:this.unsigned?e.high>>>0>this.high>>>0||e.high===this.high&&e.low>>>0>this.low>>>0?-1:1:this.sub(e).isNegative()?-1:1;
},S.comp=S.compare,S.negate=function(){
return!this.unsigned&&this.eq(I)?I:this.not().add(x);
},S.neg=S.negate,S.add=function(e){
r(e)||(e=h(e));var t=this.high>>>16,n=65535&this.high,s=this.low>>>16,i=65535&this.low,a=e.high>>>16,o=65535&e.high,l=e.low>>>16,c=0,d=0,p=0,f=0;return p+=(f+=i+(65535&e.low))>>>16,d+=(p+=s+l)>>>16,c+=(d+=n+o)>>>16,c+=t+a,u((p&=65535)<<16|(f&=65535),(c&=65535)<<16|(d&=65535),this.unsigned);
},S.subtract=function(e){
return r(e)||(e=h(e)),this.add(e.neg());
},S.sub=S.subtract,S.multiply=function(e){
if(this.isZero()){
return g;
}if(r(e)||(e=h(e)),t){
return u(t.mul(this.low,this.high,e.low,e.high),t.get_high(),this.unsigned);
}if(e.isZero()){
return g;
}if(this.eq(I)){
return e.isOdd()?I:g;
}if(e.eq(I)){
return this.isOdd()?I:g;
}if(this.isNegative()){
return e.isNegative()?this.neg().mul(e.neg()):this.neg().mul(e).neg();
}if(e.isNegative()){
return this.mul(e.neg()).neg();
}if(this.lt(m)&&e.lt(m)){
return o(this.toNumber()*e.toNumber(),this.unsigned);
}var n=this.high>>>16,s=65535&this.high,i=this.low>>>16,a=65535&this.low,l=e.high>>>16,c=65535&e.high,d=e.low>>>16,p=65535&e.low,f=0,b=0,x=0,y=0;return x+=(y+=a*p)>>>16,b+=(x+=i*p)>>>16,x&=65535,b+=(x+=a*d)>>>16,f+=(b+=s*p)>>>16,b&=65535,f+=(b+=i*d)>>>16,b&=65535,f+=(b+=a*c)>>>16,f+=n*p+s*d+i*c+a*l,u((x&=65535)<<16|(y&=65535),(f&=65535)<<16|(b&=65535),this.unsigned);
},S.mul=S.multiply,S.divide=function(e){
if(r(e)||(e=h(e)),e.isZero()){
throw Error("division by zero");
}var n,s,i;if(t){
return this.unsigned||-2147483648!==this.high||-1!==e.low||-1!==e.high?u((this.unsigned?t.div_u:t.div_s)(this.low,this.high,e.low,e.high),t.get_high(),this.unsigned):this;
}if(this.isZero()){
return this.unsigned?b:g;
}if(this.unsigned){
if(e.unsigned||(e=e.toUnsigned()),e.gt(this)){
return b;
}if(e.gt(this.shru(1))){
return y;
}i=b;
}else{
if(this.eq(I)){
return e.eq(x)||e.eq(w)?I:e.eq(I)?x:(n=this.shr(1).div(e).shl(1)).eq(g)?e.isNegative()?x:w:(s=this.sub(e.mul(n)),i=n.add(s.div(e)));
}if(e.eq(I)){
return this.unsigned?b:g;
}if(this.isNegative()){
return e.isNegative()?this.neg().div(e.neg()):this.neg().div(e).neg();
}if(e.isNegative()){
return this.div(e.neg()).neg();
}i=g;
}for(s=this;s.gte(e);){
n=Math.max(1,Math.floor(s.toNumber()/e.toNumber()));for(var a=Math.ceil(Math.log(n)/Math.LN2),c=a<=48?1:l(2,a-48),d=o(n),p=d.mul(e);p.isNegative()||p.gt(s);){
p=(d=o(n-=c,this.unsigned)).mul(e);
}d.isZero()&&(d=x),i=i.add(d),s=s.sub(p);
}return i;
},S.div=S.divide,S.modulo=function(e){
return r(e)||(e=h(e)),t?u((this.unsigned?t.rem_u:t.rem_s)(this.low,this.high,e.low,e.high),t.get_high(),this.unsigned):this.sub(this.div(e).mul(e));
},S.mod=S.modulo,S.rem=S.modulo,S.not=function(){
return u(~this.low,~this.high,this.unsigned);
},S.and=function(e){
return r(e)||(e=h(e)),u(this.low&e.low,this.high&e.high,this.unsigned);
},S.or=function(e){
return r(e)||(e=h(e)),u(this.low|e.low,this.high|e.high,this.unsigned);
},S.xor=function(e){
return r(e)||(e=h(e)),u(this.low^e.low,this.high^e.high,this.unsigned);
},S.shiftLeft=function(e){
return r(e)&&(e=e.toInt()),0==(e&=63)?this:e<32?u(this.low<<e,this.high<<e|this.low>>>32-e,this.unsigned):u(0,this.low<<e-32,this.unsigned);
},S.shl=S.shiftLeft,S.shiftRight=function(e){
return r(e)&&(e=e.toInt()),0==(e&=63)?this:e<32?u(this.low>>>e|this.high<<32-e,this.high>>e,this.unsigned):u(this.high>>e-32,this.high>=0?0:-1,this.unsigned);
},S.shr=S.shiftRight,S.shiftRightUnsigned=function(e){
if(r(e)&&(e=e.toInt()),0==(e&=63)){
return this;
}var t=this.high;return e<32?u(this.low>>>e|t<<32-e,t>>>e,this.unsigned):u(32===e?t:t>>>e-32,0,this.unsigned);
},S.shru=S.shiftRightUnsigned,S.shr_u=S.shiftRightUnsigned,S.toSigned=function(){
return this.unsigned?u(this.low,this.high,!1):this;
},S.toUnsigned=function(){
return this.unsigned?this:u(this.low,this.high,!0);
},S.toBytes=function(e){
return e?this.toBytesLE():this.toBytesBE();
},S.toBytesLE=function(){
var e=this.high,t=this.low;return[255&t,t>>>8&255,t>>>16&255,t>>>24,255&e,e>>>8&255,e>>>16&255,e>>>24];
},S.toBytesBE=function(){
var e=this.high,t=this.low;return[e>>>24,e>>>16&255,e>>>8&255,255&e,t>>>24,t>>>16&255,t>>>8&255,255&t];
},n.fromBytes=function(e,t,r){
return r?n.fromBytesLE(e,t):n.fromBytesBE(e,t);
},n.fromBytesLE=function(e,t){
return new n(e[0]|e[1]<<8|e[2]<<16|e[3]<<24,e[4]|e[5]<<8|e[6]<<16|e[7]<<24,t);
},n.fromBytesBE=function(e,t){
return new n(e[4]<<24|e[5]<<16|e[6]<<8|e[7],e[0]<<24|e[1]<<16|e[2]<<8|e[3],t);
};
},397:(__unused_webpack_module,exports,__webpack_require__)=>{
"use strict";var numeric=exports;void 0!==__webpack_require__.g&&(__webpack_require__.g.numeric=numeric),numeric.version="1.2.6",numeric.bench=function(e,t){
var n,r,s;for(void 0===t&&(t=15),r=.5,n=new Date;;){
for(s=r*=2;s>3;s-=4){
e(),e(),e(),e();
}for(;s>0;){
e(),s--;
}if(new Date-n>t){
break;
}
}for(s=r;s>3;s-=4){
e(),e(),e(),e();
}for(;s>0;){
e(),s--;
}return 1e3*(3*r-1)/(new Date-n);
},numeric._myIndexOf=function(e){
var t,n=this.length;for(t=0;t<n;++t){
if(this[t]===e){
return t;
}
}return-1;
},numeric.myIndexOf=Array.prototype.indexOf?Array.prototype.indexOf:numeric._myIndexOf,numeric.Function=Function,numeric.precision=4,numeric.largeArray=50,numeric.prettyPrint=function(e){
function t(e){
if(0===e){
return"0";
}if(isNaN(e)){
return"NaN";
}if(e<0){
return"-"+t(-e);
}if(isFinite(e)){
var n=Math.floor(Math.log(e)/Math.log(10)),r=e/Math.pow(10,n),s=r.toPrecision(numeric.precision);return 10===parseFloat(s)&&(n++,s=(r=1).toPrecision(numeric.precision)),parseFloat(s).toString()+"e"+n.toString();
}return"Infinity";
}var n=[];return function e(r){
var s;if(void 0===r){
return n.push(Array(numeric.precision+8).join(" ")),!1;
}if("string"==typeof r){
return n.push('"'+r+'"'),!1;
}if("boolean"==typeof r){
return n.push(r.toString()),!1;
}if("number"==typeof r){
var i=t(r),a=r.toPrecision(numeric.precision),o=parseFloat(r.toString()).toString(),u=[i,a,o,parseFloat(a).toString(),parseFloat(o).toString()];for(s=1;s<u.length;s++){
u[s].length<i.length&&(i=u[s]);
}return n.push(Array(numeric.precision+8-i.length).join(" ")+i),!1;
}if(null===r){
return n.push("null"),!1;
}if("function"==typeof r){
n.push(r.toString());var l=!1;for(s in r){
r.hasOwnProperty(s)&&(l?n.push(",\n"):n.push("\n{"),l=!0,n.push(s),n.push(": \n"),e(r[s]));
}return l&&n.push("}\n"),!0;
}if(r instanceof Array){
if(r.length>numeric.largeArray){
return n.push("...Large Array..."),!0;
}for(l=!1,n.push("["),s=0;s<r.length;s++){
s>0&&(n.push(","),l&&n.push("\n ")),l=e(r[s]);
}return n.push("]"),!0;
}for(s in n.push("{"),l=!1,r){
r.hasOwnProperty(s)&&(l&&n.push(",\n"),l=!0,n.push(s),n.push(": \n"),e(r[s]));
}return n.push("}"),!0;
}(e),n.join("");
},numeric.parseDate=function(e){
return function e(t){
if("string"==typeof t){
return Date.parse(t.replace(/-/g,"/"));
}if(!(t instanceof Array)){
throw new Error("parseDate: parameter must be arrays of strings");
}var n,r=[];for(n=0;n<t.length;n++){
r[n]=e(t[n]);
}return r;
}(e);
},numeric.parseFloat=function(e){
return function e(t){
if("string"==typeof t){
return parseFloat(t);
}if(!(t instanceof Array)){
throw new Error("parseFloat: parameter must be arrays of strings");
}var n,r=[];for(n=0;n<t.length;n++){
r[n]=e(t[n]);
}return r;
}(e);
},numeric.parseCSV=function(e){
var t,n,r,s=e.split("\n"),i=[],a=/(([^'",]*)|('[^']*')|("[^"]*")),/g,o=/^\s*(([+-]?[0-9]+(\.[0-9]*)?(e[+-]?[0-9]+)?)|([+-]?[0-9]*(\.[0-9]+)?(e[+-]?[0-9]+)?))\s*$/,u=0;for(n=0;n<s.length;n++){
var l,c=(s[n]+",").match(a);if(c.length>0){
for(i[u]=[],t=0;t<c.length;t++){
l=(r=c[t]).substr(0,r.length-1),o.test(l)?i[u][t]=parseFloat(l):i[u][t]=l;
}u++;
}
}return i;
},numeric.toCSV=function(e){
var t,n,r,s,i,a=numeric.dim(e);for(r=a[0],a[1],i=[],t=0;t<r;t++){
for(s=[],n=0;n<r;n++){
s[n]=e[t][n].toString();
}i[t]=s.join(", ");
}return i.join("\n")+"\n";
},numeric.getURL=function(e){
var t=new XMLHttpRequest;return t.open("GET",e,!1),t.send(),t;
},numeric.imageURL=function(e){
function t(e,t,n){
void 0===t&&(t=0),void 0===n&&(n=e.length);var r,s=[0,1996959894,3993919788,2567524794,124634137,1886057615,3915621685,2657392035,249268274,2044508324,3772115230,2547177864,162941995,2125561021,3887607047,2428444049,498536548,1789927666,4089016648,2227061214,450548861,1843258603,4107580753,2211677639,325883990,1684777152,4251122042,2321926636,335633487,1661365465,4195302755,2366115317,997073096,1281953886,3579855332,2724688242,1006888145,1258607687,3524101629,2768942443,901097722,1119000684,3686517206,2898065728,853044451,1172266101,3705015759,2882616665,651767980,1373503546,3369554304,3218104598,565507253,1454621731,3485111705,3099436303,671266974,1594198024,3322730930,2970347812,795835527,1483230225,3244367275,3060149565,1994146192,31158534,2563907772,4023717930,1907459465,112637215,2680153253,3904427059,2013776290,251722036,2517215374,3775830040,2137656763,141376813,2439277719,3865271297,1802195444,476864866,2238001368,4066508878,1812370925,453092731,2181625025,4111451223,1706088902,314042704,2344532202,4240017532,1658658271,366619977,2362670323,4224994405,1303535960,984961486,2747007092,3569037538,1256170817,1037604311,2765210733,3554079995,1131014506,879679996,2909243462,3663771856,1141124467,855842277,2852801631,3708648649,1342533948,654459306,3188396048,3373015174,1466479909,544179635,3110523913,3462522015,1591671054,702138776,2966460450,3352799412,1504918807,783551873,3082640443,3233442989,3988292384,2596254646,62317068,1957810842,3939845945,2647816111,81470997,1943803523,3814918930,2489596804,225274430,2053790376,3826175755,2466906013,167816743,2097651377,4027552580,2265490386,503444072,1762050814,4150417245,2154129355,426522225,1852507879,4275313526,2312317920,282753626,1742555852,4189708143,2394877945,397917763,1622183637,3604390888,2714866558,953729732,1340076626,3518719985,2797360999,1068828381,1219638859,3624741850,2936675148,906185462,1090812512,3747672003,2825379669,829329135,1181335161,3412177804,3160834842,628085408,1382605366,3423369109,3138078467,570562233,1426400815,3317316542,2998733608,733239954,1555261956,3268935591,3050360625,752459403,1541320221,2607071920,3965973030,1969922972,40735498,2617837225,3943577151,1913087877,83908371,2512341634,3803740692,2075208622,213261112,2463272603,3855990285,2094854071,198958881,2262029012,4057260610,1759359992,534414190,2176718541,4139329115,1873836001,414664567,2282248934,4279200368,1711684554,285281116,2405801727,4167216745,1634467795,376229701,2685067896,3608007406,1308918612,956543938,2808555105,3495958263,1231636301,1047427035,2932959818,3654703836,1088359270,936918e3,2847714899,3736837829,1202900863,817233897,3183342108,3401237130,1404277552,615818150,3134207493,3453421203,1423857449,601450431,3009837614,3294710456,1567103746,711928724,3020668471,3272380065,1510334235,755167117],i=-1;for(e.length,r=t;r<n;r++){
i=i>>>8^s[255&(i^e[r])];
}return-1^i;
}var n,r,s,i,a,o,u,l,c,h,d=e[0].length,p=e[0][0].length,f=[137,80,78,71,13,10,26,10,0,0,0,13,73,72,68,82,p>>24&255,p>>16&255,p>>8&255,255&p,d>>24&255,d>>16&255,d>>8&255,255&d,8,2,0,0,0,-1,-2,-3,-4,-5,-6,-7,-8,73,68,65,84,8,29];for(h=t(f,12,29),f[29]=h>>24&255,f[30]=h>>16&255,f[31]=h>>8&255,f[32]=255&h,n=1,r=0,u=0;u<d;u++){
for(u<d-1?f.push(0):f.push(1),a=3*p+1+(0===u)&255,o=3*p+1+(0===u)>>8&255,f.push(a),f.push(o),f.push(255&~a),f.push(255&~o),0===u&&f.push(0),l=0;l<p;l++){
for(s=0;s<3;s++){
r=(r+(n=(n+(a=(a=e[s][u][l])>255?255:a<0?0:Math.round(a)))%65521))%65521,f.push(a);
}
}f.push(0);
}return c=(r<<16)+n,f.push(c>>24&255),f.push(c>>16&255),f.push(c>>8&255),f.push(255&c),i=f.length-41,f[33]=i>>24&255,f[34]=i>>16&255,f[35]=i>>8&255,f[36]=255&i,h=t(f,37),f.push(h>>24&255),f.push(h>>16&255),f.push(h>>8&255),f.push(255&h),f.push(0),f.push(0),f.push(0),f.push(0),f.push(73),f.push(69),f.push(78),f.push(68),f.push(174),f.push(66),f.push(96),f.push(130),"data:image/png;base64,"+function(e){
var t,n,r,s,i,a,o,u=e.length,l="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",c="";for(t=0;t<u;t+=3){
i=((3&(n=e[t]))<<4)+((r=e[t+1])>>4),a=((15&r)<<2)+((s=e[t+2])>>6),o=63&s,t+1>=u?a=o=64:t+2>=u&&(o=64),c+=l.charAt(n>>2)+l.charAt(i)+l.charAt(a)+l.charAt(o);
}return c;
}(f);
},numeric._dim=function(e){
for(var t=[];"object"==typeof e;){
t.push(e.length),e=e[0];
}return t;
},numeric.dim=function(e){
var t;return"object"==typeof e?"object"==typeof(t=e[0])?"object"==typeof t[0]?numeric._dim(e):[e.length,t.length]:[e.length]:[];
},numeric.mapreduce=function(e,t){
return Function("x","accum","_s","_k",'if(typeof accum === "undefined") accum = '+t+';\nif(typeof x === "number") { var xi = x; '+e+'; return accum; }\nif(typeof _s === "undefined") _s = numeric.dim(x);\nif(typeof _k === "undefined") _k = 0;\nvar _n = _s[_k];\nvar i,xi;\nif(_k < _s.length-1) {\n    for(i=_n-1;i>=0;i--) {\n        accum = arguments.callee(x[i],accum,_s,_k+1);\n    }    return accum;\n}\nfor(i=_n-1;i>=1;i-=2) { \n    xi = x[i];\n    '+e+";\n    xi = x[i-1];\n    "+e+";\n}\nif(i === 0) {\n    xi = x[i];\n    "+e+"\n}\nreturn accum;");
},numeric.mapreduce2=function(e,t){
return Function("x","var n = x.length;\nvar i,xi;\n"+t+";\nfor(i=n-1;i!==-1;--i) { \n    xi = x[i];\n    "+e+";\n}\nreturn accum;");
},numeric.same=function e(t,n){
var r,s;if(!(t instanceof Array&&n instanceof Array)){
return!1;
}if((s=t.length)!==n.length){
return!1;
}for(r=0;r<s;r++){
if(t[r]!==n[r]){
if("object"!=typeof t[r]){
return!1;
}if(!e(t[r],n[r])){
return!1;
}
}
}return!0;
},numeric.rep=function(e,t,n){
void 0===n&&(n=0);var r,s=e[n],i=Array(s);if(n===e.length-1){
for(r=s-2;r>=0;r-=2){
i[r+1]=t,i[r]=t;
}return-1===r&&(i[0]=t),i;
}for(r=s-1;r>=0;r--){
i[r]=numeric.rep(e,t,n+1);
}return i;
},numeric.dotMMsmall=function(e,t){
var n,r,s,i,a,o,u,l,c,h,d;for(i=e.length,a=t.length,o=t[0].length,u=Array(i),n=i-1;n>=0;n--){
for(l=Array(o),c=e[n],s=o-1;s>=0;s--){
for(h=c[a-1]*t[a-1][s],r=a-2;r>=1;r-=2){
d=r-1,h+=c[r]*t[r][s]+c[d]*t[d][s];
}0===r&&(h+=c[0]*t[0][s]),l[s]=h;
}u[n]=l;
}return u;
},numeric._getCol=function(e,t,n){
var r;for(r=e.length-1;r>0;--r){
n[r]=e[r][t],n[--r]=e[r][t];
}0===r&&(n[0]=e[0][t]);
},numeric.dotMMbig=function(e,t){
var n,r,s,i=numeric._getCol,a=t.length,o=Array(a),u=e.length,l=t[0].length,c=new Array(u),h=numeric.dotVV;for(--a,r=--u;-1!==r;--r){
c[r]=Array(l);
}for(r=--l;-1!==r;--r){
for(i(t,r,o),s=u;-1!==s;--s){
n=e[s],c[s][r]=h(n,o);
}
}return c;
},numeric.dotMV=function(e,t){
var n,r=e.length,s=(t.length,Array(r)),i=numeric.dotVV;for(n=r-1;n>=0;n--){
s[n]=i(e[n],t);
}return s;
},numeric.dotVM=function(e,t){
var n,r,s,i,a,o,u;for(s=e.length,i=t[0].length,a=Array(i),r=i-1;r>=0;r--){
for(o=e[s-1]*t[s-1][r],n=s-2;n>=1;n-=2){
u=n-1,o+=e[n]*t[n][r]+e[u]*t[u][r];
}0===n&&(o+=e[0]*t[0][r]),a[r]=o;
}return a;
},numeric.dotVV=function(e,t){
var n,r,s=e.length,i=e[s-1]*t[s-1];for(n=s-2;n>=1;n-=2){
r=n-1,i+=e[n]*t[n]+e[r]*t[r];
}return 0===n&&(i+=e[0]*t[0]),i;
},numeric.dot=function(e,t){
var n=numeric.dim;switch(1e3*n(e).length+n(t).length){
case 2002:return t.length<10?numeric.dotMMsmall(e,t):numeric.dotMMbig(e,t);case 2001:return numeric.dotMV(e,t);case 1002:return numeric.dotVM(e,t);case 1001:return numeric.dotVV(e,t);case 1e3:return numeric.mulVS(e,t);case 1:return numeric.mulSV(e,t);case 0:return e*t;default:throw new Error("numeric.dot only works on vectors and matrices");
}
},numeric.diag=function(e){
var t,n,r,s,i=e.length,a=Array(i);for(t=i-1;t>=0;t--){
for(s=Array(i),n=t+2,r=i-1;r>=n;r-=2){
s[r]=0,s[r-1]=0;
}for(r>t&&(s[r]=0),s[t]=e[t],r=t-1;r>=1;r-=2){
s[r]=0,s[r-1]=0;
}0===r&&(s[0]=0),a[t]=s;
}return a;
},numeric.getDiag=function(e){
var t,n=Math.min(e.length,e[0].length),r=Array(n);for(t=n-1;t>=1;--t){
r[t]=e[t][t],r[--t]=e[t][t];
}return 0===t&&(r[0]=e[0][0]),r;
},numeric.identity=function(e){
return numeric.diag(numeric.rep([e],1));
},numeric.pointwise=function(e,t,n){
void 0===n&&(n="");var r,s,i=[],a=/\[i\]$/,o="",u=!1;for(r=0;r<e.length;r++){
a.test(e[r])?o=s=e[r].substring(0,e[r].length-3):s=e[r],"ret"===s&&(u=!0),i.push(s);
}return i[e.length]="_s",i[e.length+1]="_k",i[e.length+2]='if(typeof _s === "undefined") _s = numeric.dim('+o+');\nif(typeof _k === "undefined") _k = 0;\nvar _n = _s[_k];\nvar i'+(u?"":", ret = Array(_n)")+";\nif(_k < _s.length-1) {\n    for(i=_n-1;i>=0;i--) ret[i] = arguments.callee("+e.join(",")+",_s,_k+1);\n    return ret;\n}\n"+n+"\nfor(i=_n-1;i!==-1;--i) {\n    "+t+"\n}\nreturn ret;",Function.apply(null,i);
},numeric.pointwise2=function(e,t,n){
void 0===n&&(n="");var r,s,i=[],a=/\[i\]$/,o="",u=!1;for(r=0;r<e.length;r++){
a.test(e[r])?o=s=e[r].substring(0,e[r].length-3):s=e[r],"ret"===s&&(u=!0),i.push(s);
}return i[e.length]="var _n = "+o+".length;\nvar i"+(u?"":", ret = Array(_n)")+";\n"+n+"\nfor(i=_n-1;i!==-1;--i) {\n"+t+"\n}\nreturn ret;",Function.apply(null,i);
},numeric._biforeach=function e(t,n,r,s,i){
var a;if(s!==r.length-1){
for(a=r[s]-1;a>=0;a--){
e("object"==typeof t?t[a]:t,"object"==typeof n?n[a]:n,r,s+1,i);
}
}else {
i(t,n);
}
},numeric._biforeach2=function e(t,n,r,s,i){
if(s===r.length-1){
return i(t,n);
}var a,o=r[s],u=Array(o);for(a=o-1;a>=0;--a){
u[a]=e("object"==typeof t?t[a]:t,"object"==typeof n?n[a]:n,r,s+1,i);
}return u;
},numeric._foreach=function e(t,n,r,s){
var i;if(r!==n.length-1){
for(i=n[r]-1;i>=0;i--){
e(t[i],n,r+1,s);
}
}else {
s(t);
}
},numeric._foreach2=function e(t,n,r,s){
if(r===n.length-1){
return s(t);
}var i,a=n[r],o=Array(a);for(i=a-1;i>=0;i--){
o[i]=e(t[i],n,r+1,s);
}return o;
},numeric.ops2={add:"+",sub:"-",mul:"*",div:"/",mod:"%",and:"&&",or:"||",eq:"===",neq:"!==",lt:"<",gt:">",leq:"<=",geq:">=",band:"&",bor:"|",bxor:"^",lshift:"<<",rshift:">>",rrshift:">>>"},numeric.opseq={addeq:"+=",subeq:"-=",muleq:"*=",diveq:"/=",modeq:"%=",lshifteq:"<<=",rshifteq:">>=",rrshifteq:">>>=",bandeq:"&=",boreq:"|=",bxoreq:"^="},numeric.mathfuns=["abs","acos","asin","atan","ceil","cos","exp","floor","log","round","sin","sqrt","tan","isNaN","isFinite"],numeric.mathfuns2=["atan2","pow","max","min"],numeric.ops1={neg:"-",not:"!",bnot:"~",clone:""},numeric.mapreducers={any:["if(xi) return true;","var accum = false;"],all:["if(!xi) return false;","var accum = true;"],sum:["accum += xi;","var accum = 0;"],prod:["accum *= xi;","var accum = 1;"],norm2Squared:["accum += xi*xi;","var accum = 0;"],norminf:["accum = max(accum,abs(xi));","var accum = 0, max = Math.max, abs = Math.abs;"],norm1:["accum += abs(xi)","var accum = 0, abs = Math.abs;"],sup:["accum = max(accum,xi);","var accum = -Infinity, max = Math.max;"],inf:["accum = min(accum,xi);","var accum = Infinity, min = Math.min;"]},function(){
var e,t;for(e=0;e<numeric.mathfuns2.length;++e){
t=numeric.mathfuns2[e],numeric.ops2[t]=t;
}for(e in numeric.ops2){
if(numeric.ops2.hasOwnProperty(e)){
t=numeric.ops2[e];var n,r,s="";-1!==numeric.myIndexOf.call(numeric.mathfuns2,e)?(s="var "+t+" = Math."+t+";\n",n=function(e,n,r){
return e+" = "+t+"("+n+","+r+")";
},r=function(e,n){
return e+" = "+t+"("+e+","+n+")";
}):(n=function(e,n,r){
return e+" = "+n+" "+t+" "+r;
},r=numeric.opseq.hasOwnProperty(e+"eq")?function(e,n){
return e+" "+t+"= "+n;
}:function(e,n){
return e+" = "+e+" "+t+" "+n;
}),numeric[e+"VV"]=numeric.pointwise2(["x[i]","y[i]"],n("ret[i]","x[i]","y[i]"),s),numeric[e+"SV"]=numeric.pointwise2(["x","y[i]"],n("ret[i]","x","y[i]"),s),numeric[e+"VS"]=numeric.pointwise2(["x[i]","y"],n("ret[i]","x[i]","y"),s),numeric[e]=Function("var n = arguments.length, i, x = arguments[0], y;\nvar VV = numeric."+e+"VV, VS = numeric."+e+"VS, SV = numeric."+e+'SV;\nvar dim = numeric.dim;\nfor(i=1;i!==n;++i) { \n  y = arguments[i];\n  if(typeof x === "object") {\n      if(typeof y === "object") x = numeric._biforeach2(x,y,dim(x),0,VV);\n      else x = numeric._biforeach2(x,y,dim(x),0,VS);\n  } else if(typeof y === "object") x = numeric._biforeach2(x,y,dim(y),0,SV);\n  else '+r("x","y")+"\n}\nreturn x;\n"),numeric[t]=numeric[e],numeric[e+"eqV"]=numeric.pointwise2(["ret[i]","x[i]"],r("ret[i]","x[i]"),s),numeric[e+"eqS"]=numeric.pointwise2(["ret[i]","x"],r("ret[i]","x"),s),numeric[e+"eq"]=Function("var n = arguments.length, i, x = arguments[0], y;\nvar V = numeric."+e+"eqV, S = numeric."+e+'eqS\nvar s = numeric.dim(x);\nfor(i=1;i!==n;++i) { \n  y = arguments[i];\n  if(typeof y === "object") numeric._biforeach(x,y,s,0,V);\n  else numeric._biforeach(x,y,s,0,S);\n}\nreturn x;\n');
}
}for(e=0;e<numeric.mathfuns2.length;++e){
t=numeric.mathfuns2[e],delete numeric.ops2[t];
}for(e=0;e<numeric.mathfuns.length;++e){
t=numeric.mathfuns[e],numeric.ops1[t]=t;
}for(e in numeric.ops1){
numeric.ops1.hasOwnProperty(e)&&(s="",t=numeric.ops1[e],-1!==numeric.myIndexOf.call(numeric.mathfuns,e)&&Math.hasOwnProperty(t)&&(s="var "+t+" = Math."+t+";\n"),numeric[e+"eqV"]=numeric.pointwise2(["ret[i]"],"ret[i] = "+t+"(ret[i]);",s),numeric[e+"eq"]=Function("x",'if(typeof x !== "object") return '+t+"x\nvar i;\nvar V = numeric."+e+"eqV;\nvar s = numeric.dim(x);\nnumeric._foreach(x,s,0,V);\nreturn x;\n"),numeric[e+"V"]=numeric.pointwise2(["x[i]"],"ret[i] = "+t+"(x[i]);",s),numeric[e]=Function("x",'if(typeof x !== "object") return '+t+"(x)\nvar i;\nvar V = numeric."+e+"V;\nvar s = numeric.dim(x);\nreturn numeric._foreach2(x,s,0,V);\n"));
}for(e=0;e<numeric.mathfuns.length;++e){
t=numeric.mathfuns[e],delete numeric.ops1[t];
}for(e in numeric.mapreducers){
numeric.mapreducers.hasOwnProperty(e)&&(t=numeric.mapreducers[e],numeric[e+"V"]=numeric.mapreduce2(t[0],t[1]),numeric[e]=Function("x","s","k",t[1]+'if(typeof x !== "object") {    xi = x;\n'+t[0]+';\n    return accum;\n}if(typeof s === "undefined") s = numeric.dim(x);\nif(typeof k === "undefined") k = 0;\nif(k === s.length-1) return numeric.'+e+"V(x);\nvar xi;\nvar n = x.length, i;\nfor(i=n-1;i!==-1;--i) {\n   xi = arguments.callee(x[i]);\n"+t[0]+";\n}\nreturn accum;\n"));
}
}(),numeric.truncVV=numeric.pointwise(["x[i]","y[i]"],"ret[i] = round(x[i]/y[i])*y[i];","var round = Math.round;"),numeric.truncVS=numeric.pointwise(["x[i]","y"],"ret[i] = round(x[i]/y)*y;","var round = Math.round;"),numeric.truncSV=numeric.pointwise(["x","y[i]"],"ret[i] = round(x/y[i])*y[i];","var round = Math.round;"),numeric.trunc=function(e,t){
return"object"==typeof e?"object"==typeof t?numeric.truncVV(e,t):numeric.truncVS(e,t):"object"==typeof t?numeric.truncSV(e,t):Math.round(e/t)*t;
},numeric.inv=function(e){
var t,n,r,s,i,a,o,u=numeric.dim(e),l=Math.abs,c=u[0],h=u[1],d=numeric.clone(e),p=numeric.identity(c);for(a=0;a<h;++a){
var f=-1,m=-1;for(i=a;i!==c;++i){
(o=l(d[i][a]))>m&&(f=i,m=o);
}for(n=d[f],d[f]=d[a],d[a]=n,s=p[f],p[f]=p[a],p[a]=s,e=n[a],o=a;o!==h;++o){
n[o]/=e;
}for(o=h-1;-1!==o;--o){
s[o]/=e;
}for(i=c-1;-1!==i;--i){
if(i!==a){
for(t=d[i],r=p[i],e=t[a],o=a+1;o!==h;++o){
t[o]-=n[o]*e;
}for(o=h-1;o>0;--o){
r[o]-=s[o]*e,r[--o]-=s[o]*e;
}0===o&&(r[0]-=s[0]*e);
}
}
}return p;
},numeric.det=function(e){
var t=numeric.dim(e);if(2!==t.length||t[0]!==t[1]){
throw new Error("numeric: det() only works on square matrices");
}var n,r,s,i,a,o,u,l,c=t[0],h=1,d=numeric.clone(e);for(r=0;r<c-1;r++){
for(s=r,n=r+1;n<c;n++){
Math.abs(d[n][r])>Math.abs(d[s][r])&&(s=n);
}for(s!==r&&(u=d[s],d[s]=d[r],d[r]=u,h*=-1),i=d[r],n=r+1;n<c;n++){
for(o=(a=d[n])[r]/i[r],s=r+1;s<c-1;s+=2){
l=s+1,a[s]-=i[s]*o,a[l]-=i[l]*o;
}s!==c&&(a[s]-=i[s]*o);
}if(0===i[r]){
return 0;
}h*=i[r];
}return h*d[r][r];
},numeric.transpose=function(e){
var t,n,r,s,i,a=e.length,o=e[0].length,u=Array(o);for(n=0;n<o;n++){
u[n]=Array(a);
}for(t=a-1;t>=1;t-=2){
for(s=e[t],r=e[t-1],n=o-1;n>=1;--n){
(i=u[n])[t]=s[n],i[t-1]=r[n],(i=u[--n])[t]=s[n],i[t-1]=r[n];
}0===n&&((i=u[0])[t]=s[0],i[t-1]=r[0]);
}if(0===t){
for(r=e[0],n=o-1;n>=1;--n){
u[n][0]=r[n],u[--n][0]=r[n];
}0===n&&(u[0][0]=r[0]);
}return u;
},numeric.negtranspose=function(e){
var t,n,r,s,i,a=e.length,o=e[0].length,u=Array(o);for(n=0;n<o;n++){
u[n]=Array(a);
}for(t=a-1;t>=1;t-=2){
for(s=e[t],r=e[t-1],n=o-1;n>=1;--n){
(i=u[n])[t]=-s[n],i[t-1]=-r[n],(i=u[--n])[t]=-s[n],i[t-1]=-r[n];
}0===n&&((i=u[0])[t]=-s[0],i[t-1]=-r[0]);
}if(0===t){
for(r=e[0],n=o-1;n>=1;--n){
u[n][0]=-r[n],u[--n][0]=-r[n];
}0===n&&(u[0][0]=-r[0]);
}return u;
},numeric._random=function e(t,n){
var r,s,i=t[n],a=Array(i);if(n===t.length-1){
for(s=Math.random,r=i-1;r>=1;r-=2){
a[r]=s(),a[r-1]=s();
}return 0===r&&(a[0]=s()),a;
}for(r=i-1;r>=0;r--){
a[r]=e(t,n+1);
}return a;
},numeric.random=function(e){
return numeric._random(e,0);
},numeric.norm2=function(e){
return Math.sqrt(numeric.norm2Squared(e));
},numeric.linspace=function(e,t,n){
if(void 0===n&&(n=Math.max(Math.round(t-e)+1,1)),n<2){
return 1===n?[e]:[];
}var r,s=Array(n);for(r=--n;r>=0;r--){
s[r]=(r*t+(n-r)*e)/n;
}return s;
},numeric.getBlock=function(e,t,n){
var r=numeric.dim(e);return function e(s,i){
var a,o=t[i],u=n[i]-o,l=Array(u);if(i===r.length-1){
for(a=u;a>=0;a--){
l[a]=s[a+o];
}return l;
}for(a=u;a>=0;a--){
l[a]=e(s[a+o],i+1);
}return l;
}(e,0);
},numeric.setBlock=function(e,t,n,r){
var s=numeric.dim(e);return function e(r,i,a){
var o,u=t[a],l=n[a]-u;if(a===s.length-1){
for(o=l;o>=0;o--){
r[o+u]=i[o];
}
}for(o=l;o>=0;o--){
e(r[o+u],i[o],a+1);
}
}(e,r,0),e;
},numeric.getRange=function(e,t,n){
var r,s,i,a,o=t.length,u=n.length,l=Array(o);for(r=o-1;-1!==r;--r){
for(l[r]=Array(u),i=l[r],a=e[t[r]],s=u-1;-1!==s;--s){
i[s]=a[n[s]];
}
}return l;
},numeric.blockMatrix=function(e){
var t=numeric.dim(e);if(t.length<4){
return numeric.blockMatrix([e]);
}var n,r,s,i,a,o=t[0],u=t[1];for(n=0,r=0,s=0;s<o;++s){
n+=e[s][0].length;
}for(i=0;i<u;++i){
r+=e[0][i][0].length;
}var l=Array(n);for(s=0;s<n;++s){
l[s]=Array(r);
}var c,h,d,p,f,m=0;for(s=0;s<o;++s){
for(c=r,i=u-1;-1!==i;--i){
for(c-=(a=e[s][i])[0].length,d=a.length-1;-1!==d;--d){
for(f=a[d],h=l[m+d],p=f.length-1;-1!==p;--p){
h[c+p]=f[p];
}
}
}m+=e[s][0].length;
}return l;
},numeric.tensor=function(e,t){
if("number"==typeof e||"number"==typeof t){
return numeric.mul(e,t);
}var n=numeric.dim(e),r=numeric.dim(t);if(1!==n.length||1!==r.length){
throw new Error("numeric: tensor product is only defined for vectors");
}var s,i,a,o,u=n[0],l=r[0],c=Array(u);for(i=u-1;i>=0;i--){
for(s=Array(l),o=e[i],a=l-1;a>=3;--a){
s[a]=o*t[a],s[--a]=o*t[a],s[--a]=o*t[a],s[--a]=o*t[a];
}for(;a>=0;){
s[a]=o*t[a],--a;
}c[i]=s;
}return c;
},numeric.T=function(e,t){
this.x=e,this.y=t;
},numeric.t=function(e,t){
return new numeric.T(e,t);
},numeric.Tbinop=function(e,t,n,r,s){
var i;if(numeric.indexOf,"string"!=typeof s){
for(i in s="",numeric){
numeric.hasOwnProperty(i)&&(e.indexOf(i)>=0||t.indexOf(i)>=0||n.indexOf(i)>=0||r.indexOf(i)>=0)&&i.length>1&&(s+="var "+i+" = numeric."+i+";\n");
}
}return Function(["y"],"var x = this;\nif(!(y instanceof numeric.T)) { y = new numeric.T(y); }\n"+s+"\nif(x.y) {  if(y.y) {    return new numeric.T("+r+");\n  }\n  return new numeric.T("+n+");\n}\nif(y.y) {\n  return new numeric.T("+t+");\n}\nreturn new numeric.T("+e+");\n");
},numeric.T.prototype.add=numeric.Tbinop("add(x.x,y.x)","add(x.x,y.x),y.y","add(x.x,y.x),x.y","add(x.x,y.x),add(x.y,y.y)"),numeric.T.prototype.sub=numeric.Tbinop("sub(x.x,y.x)","sub(x.x,y.x),neg(y.y)","sub(x.x,y.x),x.y","sub(x.x,y.x),sub(x.y,y.y)"),numeric.T.prototype.mul=numeric.Tbinop("mul(x.x,y.x)","mul(x.x,y.x),mul(x.x,y.y)","mul(x.x,y.x),mul(x.y,y.x)","sub(mul(x.x,y.x),mul(x.y,y.y)),add(mul(x.x,y.y),mul(x.y,y.x))"),numeric.T.prototype.reciprocal=function(){
var e=numeric.mul,t=numeric.div;if(this.y){
var n=numeric.add(e(this.x,this.x),e(this.y,this.y));return new numeric.T(t(this.x,n),t(numeric.neg(this.y),n));
}return new T(t(1,this.x));
},numeric.T.prototype.div=function(e){
if(e instanceof numeric.T||(e=new numeric.T(e)),e.y){
return this.mul(e.reciprocal());
}var t=numeric.div;return this.y?new numeric.T(t(this.x,e.x),t(this.y,e.x)):new numeric.T(t(this.x,e.x));
},numeric.T.prototype.dot=numeric.Tbinop("dot(x.x,y.x)","dot(x.x,y.x),dot(x.x,y.y)","dot(x.x,y.x),dot(x.y,y.x)","sub(dot(x.x,y.x),dot(x.y,y.y)),add(dot(x.x,y.y),dot(x.y,y.x))"),numeric.T.prototype.transpose=function(){
var e=numeric.transpose,t=this.x,n=this.y;return n?new numeric.T(e(t),e(n)):new numeric.T(e(t));
},numeric.T.prototype.transjugate=function(){
var e=numeric.transpose,t=this.x,n=this.y;return n?new numeric.T(e(t),numeric.negtranspose(n)):new numeric.T(e(t));
},numeric.Tunop=function(e,t,n){
return"string"!=typeof n&&(n=""),Function("var x = this;\n"+n+"\nif(x.y) {  "+t+";\n}\n"+e+";\n");
},numeric.T.prototype.exp=numeric.Tunop("return new numeric.T(ex)","return new numeric.T(mul(cos(x.y),ex),mul(sin(x.y),ex))","var ex = numeric.exp(x.x), cos = numeric.cos, sin = numeric.sin, mul = numeric.mul;"),numeric.T.prototype.conj=numeric.Tunop("return new numeric.T(x.x);","return new numeric.T(x.x,numeric.neg(x.y));"),numeric.T.prototype.neg=numeric.Tunop("return new numeric.T(neg(x.x));","return new numeric.T(neg(x.x),neg(x.y));","var neg = numeric.neg;"),numeric.T.prototype.sin=numeric.Tunop("return new numeric.T(numeric.sin(x.x))","return x.exp().sub(x.neg().exp()).div(new numeric.T(0,2));"),numeric.T.prototype.cos=numeric.Tunop("return new numeric.T(numeric.cos(x.x))","return x.exp().add(x.neg().exp()).div(2);"),numeric.T.prototype.abs=numeric.Tunop("return new numeric.T(numeric.abs(x.x));","return new numeric.T(numeric.sqrt(numeric.add(mul(x.x,x.x),mul(x.y,x.y))));","var mul = numeric.mul;"),numeric.T.prototype.log=numeric.Tunop("return new numeric.T(numeric.log(x.x));","var theta = new numeric.T(numeric.atan2(x.y,x.x)), r = x.abs();\nreturn new numeric.T(numeric.log(r.x),theta.x);"),numeric.T.prototype.norm2=numeric.Tunop("return numeric.norm2(x.x);","var f = numeric.norm2Squared;\nreturn Math.sqrt(f(x.x)+f(x.y));"),numeric.T.prototype.inv=function(){
var e=this;if(void 0===e.y){
return new numeric.T(numeric.inv(e.x));
}var t,n,r,s,i,a,o,u,l,c,h,d,p,f,m,g,b,x,y=e.x.length,w=numeric.identity(y),v=numeric.rep([y,y],0),k=numeric.clone(e.x),I=numeric.clone(e.y);for(l=0;l<y;l++){
for(d=(f=k[l][l])*f+(m=I[l][l])*m,h=l,c=l+1;c<y;c++){
(p=(f=k[c][l])*f+(m=I[c][l])*m)>d&&(h=c,d=p);
}for(h!==l&&(x=k[l],k[l]=k[h],k[h]=x,x=I[l],I[l]=I[h],I[h]=x,x=w[l],w[l]=w[h],w[h]=x,x=v[l],v[l]=v[h],v[h]=x),t=k[l],n=I[l],i=w[l],a=v[l],f=t[l],m=n[l],c=l+1;c<y;c++){
g=t[c],b=n[c],t[c]=(g*f+b*m)/d,n[c]=(b*f-g*m)/d;
}for(c=0;c<y;c++){
g=i[c],b=a[c],i[c]=(g*f+b*m)/d,a[c]=(b*f-g*m)/d;
}for(c=l+1;c<y;c++){
for(r=k[c],s=I[c],o=w[c],u=v[c],f=r[l],m=s[l],h=l+1;h<y;h++){
g=t[h],b=n[h],r[h]-=g*f-b*m,s[h]-=b*f+g*m;
}for(h=0;h<y;h++){
g=i[h],b=a[h],o[h]-=g*f-b*m,u[h]-=b*f+g*m;
}
}
}for(l=y-1;l>0;l--){
for(i=w[l],a=v[l],c=l-1;c>=0;c--){
for(o=w[c],u=v[c],f=k[c][l],m=I[c][l],h=y-1;h>=0;h--){
g=i[h],b=a[h],o[h]-=f*g-m*b,u[h]-=f*b+m*g;
}
}
}return new numeric.T(w,v);
},numeric.T.prototype.get=function(e){
var t,n=this.x,r=this.y,s=0,i=e.length;if(r){
for(;s<i;){
n=n[t=e[s]],r=r[t],s++;
}return new numeric.T(n,r);
}for(;s<i;){
n=n[t=e[s]],s++;
}return new numeric.T(n);
},numeric.T.prototype.set=function(e,t){
var n,r=this.x,s=this.y,i=0,a=e.length,o=t.x,u=t.y;if(0===a){
return u?this.y=u:s&&(this.y=void 0),this.x=r,this;
}if(u){
for(s||(s=numeric.rep(numeric.dim(r),0),this.y=s);i<a-1;){
r=r[n=e[i]],s=s[n],i++;
}return r[n=e[i]]=o,s[n]=u,this;
}if(s){
for(;i<a-1;){
r=r[n=e[i]],s=s[n],i++;
}return r[n=e[i]]=o,s[n]=o instanceof Array?numeric.rep(numeric.dim(o),0):0,this;
}for(;i<a-1;){
r=r[n=e[i]],i++;
}return r[n=e[i]]=o,this;
},numeric.T.prototype.getRows=function(e,t){
var n,r,s=t-e+1,i=Array(s),a=this.x,o=this.y;for(n=e;n<=t;n++){
i[n-e]=a[n];
}if(o){
for(r=Array(s),n=e;n<=t;n++){
r[n-e]=o[n];
}return new numeric.T(i,r);
}return new numeric.T(i);
},numeric.T.prototype.setRows=function(e,t,n){
var r,s=this.x,i=this.y,a=n.x,o=n.y;for(r=e;r<=t;r++){
s[r]=a[r-e];
}if(o){
for(i||(i=numeric.rep(numeric.dim(s),0),this.y=i),r=e;r<=t;r++){
i[r]=o[r-e];
}
}else if(i){
for(r=e;r<=t;r++){
i[r]=numeric.rep([a[r-e].length],0);
}
}return this;
},numeric.T.prototype.getRow=function(e){
var t=this.x,n=this.y;return n?new numeric.T(t[e],n[e]):new numeric.T(t[e]);
},numeric.T.prototype.setRow=function(e,t){
var n=this.x,r=this.y,s=t.x,i=t.y;return n[e]=s,i?(r||(r=numeric.rep(numeric.dim(n),0),this.y=r),r[e]=i):r&&(r=numeric.rep([s.length],0)),this;
},numeric.T.prototype.getBlock=function(e,t){
var n=this.x,r=this.y,s=numeric.getBlock;return r?new numeric.T(s(n,e,t),s(r,e,t)):new numeric.T(s(n,e,t));
},numeric.T.prototype.setBlock=function(e,t,n){
n instanceof numeric.T||(n=new numeric.T(n));var r=this.x,s=this.y,i=numeric.setBlock,a=n.x,o=n.y;if(o){
return s||(this.y=numeric.rep(numeric.dim(this),0),s=this.y),i(r,e,t,a),i(s,e,t,o),this;
}i(r,e,t,a),s&&i(s,e,t,numeric.rep(numeric.dim(a),0));
},numeric.T.rep=function(e,t){
var n=numeric.T;t instanceof n||(t=new n(t));var r=t.x,s=t.y,i=numeric.rep;return s?new n(i(e,r),i(e,s)):new n(i(e,r));
},numeric.T.diag=function(e){
e instanceof numeric.T||(e=new numeric.T(e));var t=e.x,n=e.y,r=numeric.diag;return n?new numeric.T(r(t),r(n)):new numeric.T(r(t));
},numeric.T.eig=function(){
if(this.y){
throw new Error("eig: not implemented for complex matrices.");
}return numeric.eig(this.x);
},numeric.T.identity=function(e){
return new numeric.T(numeric.identity(e));
},numeric.T.prototype.getDiag=function(){
var e=numeric,t=this.x,n=this.y;return n?new e.T(e.getDiag(t),e.getDiag(n)):new e.T(e.getDiag(t));
},numeric.house=function(e){
var t=numeric.clone(e),n=(e[0]>=0?1:-1)*numeric.norm2(e);t[0]+=n;var r=numeric.norm2(t);if(0===r){
throw new Error("eig: internal error");
}return numeric.div(t,r);
},numeric.toUpperHessenberg=function(e){
var t=numeric.dim(e);if(2!==t.length||t[0]!==t[1]){
throw new Error("numeric: toUpperHessenberg() only works on square matrices");
}var n,r,s,i,a,o,u,l,c,h,d=t[0],p=numeric.clone(e),f=numeric.identity(d);for(r=0;r<d-2;r++){
for(i=Array(d-r-1),n=r+1;n<d;n++){
i[n-r-1]=p[n][r];
}if(numeric.norm2(i)>0){
for(a=numeric.house(i),o=numeric.getBlock(p,[r+1,r],[d-1,d-1]),u=numeric.tensor(a,numeric.dot(a,o)),n=r+1;n<d;n++){
for(l=p[n],c=u[n-r-1],s=r;s<d;s++){
l[s]-=2*c[s-r];
}
}for(o=numeric.getBlock(p,[0,r+1],[d-1,d-1]),u=numeric.tensor(numeric.dot(o,a),a),n=0;n<d;n++){
for(l=p[n],c=u[n],s=r+1;s<d;s++){
l[s]-=2*c[s-r-1];
}
}for(o=Array(d-r-1),n=r+1;n<d;n++){
o[n-r-1]=f[n];
}for(u=numeric.tensor(a,numeric.dot(a,o)),n=r+1;n<d;n++){
for(h=f[n],c=u[n-r-1],s=0;s<d;s++){
h[s]-=2*c[s];
}
}
}
}return{H:p,Q:f};
},numeric.epsilon=2220446049250313e-31,numeric.QRFrancis=function(e,t){
void 0===t&&(t=1e4),e=numeric.clone(e),numeric.clone(e);var n,r,s,i,a,o,u,l,c,h,d,p,f,m,g,b,x,y,w=numeric.dim(e)[0],v=numeric.identity(w);if(w<3){
return{Q:v,B:[[0,w-1]]};
}var k=numeric.epsilon;for(y=0;y<t;y++){
for(b=0;b<w-1;b++){
if(Math.abs(e[b+1][b])<k*(Math.abs(e[b][b])+Math.abs(e[b+1][b+1]))){
var I=numeric.QRFrancis(numeric.getBlock(e,[0,0],[b,b]),t),S=numeric.QRFrancis(numeric.getBlock(e,[b+1,b+1],[w-1,w-1]),t);for(p=Array(b+1),g=0;g<=b;g++){
p[g]=v[g];
}for(f=numeric.dot(I.Q,p),g=0;g<=b;g++){
v[g]=f[g];
}for(p=Array(w-b-1),g=b+1;g<w;g++){
p[g-b-1]=v[g];
}for(f=numeric.dot(S.Q,p),g=b+1;g<w;g++){
v[g]=f[g-b-1];
}return{Q:v,B:I.B.concat(numeric.add(S.B,b+1))};
}
}var C,N,$;for(s=e[w-2][w-2],i=e[w-2][w-1],a=e[w-1][w-2],l=s+(o=e[w-1][w-1]),u=s*o-i*a,c=numeric.getBlock(e,[0,0],[2,2]),l*l>=4*u?(C=.5*(l+Math.sqrt(l*l-4*u)),N=.5*(l-Math.sqrt(l*l-4*u)),c=numeric.add(numeric.sub(numeric.dot(c,c),numeric.mul(c,C+N)),numeric.diag(numeric.rep([3],C*N)))):c=numeric.add(numeric.sub(numeric.dot(c,c),numeric.mul(c,l)),numeric.diag(numeric.rep([3],u))),n=[c[0][0],c[1][0],c[2][0]],r=numeric.house(n),p=[e[0],e[1],e[2]],f=numeric.tensor(r,numeric.dot(r,p)),g=0;g<3;g++){
for(d=e[g],m=f[g],x=0;x<w;x++){
d[x]-=2*m[x];
}
}for(p=numeric.getBlock(e,[0,0],[w-1,2]),f=numeric.tensor(numeric.dot(p,r),r),g=0;g<w;g++){
for(d=e[g],m=f[g],x=0;x<3;x++){
d[x]-=2*m[x];
}
}for(p=[v[0],v[1],v[2]],f=numeric.tensor(r,numeric.dot(r,p)),g=0;g<3;g++){
for(h=v[g],m=f[g],x=0;x<w;x++){
h[x]-=2*m[x];
}
}for(b=0;b<w-2;b++){
for(x=b;x<=b+1;x++){
if(Math.abs(e[x+1][x])<k*(Math.abs(e[x][x])+Math.abs(e[x+1][x+1]))){
for(I=numeric.QRFrancis(numeric.getBlock(e,[0,0],[x,x]),t),S=numeric.QRFrancis(numeric.getBlock(e,[x+1,x+1],[w-1,w-1]),t),p=Array(x+1),g=0;g<=x;g++){
p[g]=v[g];
}for(f=numeric.dot(I.Q,p),g=0;g<=x;g++){
v[g]=f[g];
}for(p=Array(w-x-1),g=x+1;g<w;g++){
p[g-x-1]=v[g];
}for(f=numeric.dot(S.Q,p),g=x+1;g<w;g++){
v[g]=f[g-x-1];
}return{Q:v,B:I.B.concat(numeric.add(S.B,x+1))};
}
}for($=Math.min(w-1,b+3),n=Array($-b),g=b+1;g<=$;g++){
n[g-b-1]=e[g][b];
}for(r=numeric.house(n),p=numeric.getBlock(e,[b+1,b],[$,w-1]),f=numeric.tensor(r,numeric.dot(r,p)),g=b+1;g<=$;g++){
for(d=e[g],m=f[g-b-1],x=b;x<w;x++){
d[x]-=2*m[x-b];
}
}for(p=numeric.getBlock(e,[0,b+1],[w-1,$]),f=numeric.tensor(numeric.dot(p,r),r),g=0;g<w;g++){
for(d=e[g],m=f[g],x=b+1;x<=$;x++){
d[x]-=2*m[x-b-1];
}
}for(p=Array($-b),g=b+1;g<=$;g++){
p[g-b-1]=v[g];
}for(f=numeric.tensor(r,numeric.dot(r,p)),g=b+1;g<=$;g++){
for(h=v[g],m=f[g-b-1],x=0;x<w;x++){
h[x]-=2*m[x];
}
}
}
}throw new Error("numeric: eigenvalue iteration does not converge -- increase maxiter?");
},numeric.eig=function(e,t){
var n,r,s,i,a,o,u,l,c,h,d,p,f,m,g,b,x=numeric.toUpperHessenberg(e),y=numeric.QRFrancis(x.H,t),w=numeric.T,v=e.length,k=y.B,I=numeric.dot(y.Q,numeric.dot(x.H,numeric.transpose(y.Q))),S=new w(numeric.dot(y.Q,x.Q)),C=k.length,N=Math.sqrt;for(r=0;r<C;r++){
if((n=k[r][0])===k[r][1]){}else{
if(i=n+1,a=I[n][n],o=I[n][i],u=I[i][n],l=I[i][i],0===o&&0===u){
continue;
}(h=(c=-a-l)*c-4*(a*l-o*u))>=0?((g=(a-(d=c<0?-.5*(c-N(h)):-.5*(c+N(h))))*(a-d)+o*o)>(b=u*u+(l-d)*(l-d))?(f=(a-d)/(g=N(g)),m=o/g):(f=u/(b=N(b)),m=(l-d)/b),s=new w([[m,-f],[f,m]]),S.setRows(n,i,s.dot(S.getRows(n,i)))):(d=-.5*c,p=.5*N(-h),(g=(a-d)*(a-d)+o*o)>(b=u*u+(l-d)*(l-d))?(f=(a-d)/(g=N(g+p*p)),m=o/g,d=0,p/=g):(f=u/(b=N(b+p*p)),m=(l-d)/b,d=p/b,p=0),s=new w([[m,-f],[f,m]],[[d,p],[p,-d]]),S.setRows(n,i,s.dot(S.getRows(n,i))));
}
}var $=S.dot(e).dot(S.transjugate()),T=(v=e.length,numeric.T.identity(v));for(i=0;i<v;i++){
if(i>0){
for(r=i-1;r>=0;r--){
var E=$.get([r,r]),R=$.get([i,i]);numeric.neq(E.x,R.x)||numeric.neq(E.y,R.y)?(d=$.getRow(r).getBlock([r],[i-1]),p=T.getRow(i).getBlock([r],[i-1]),T.set([i,r],$.get([r,i]).neg().sub(d.dot(p)).div(E.sub(R)))):T.setRow(i,T.getRow(r));
}
}
}for(i=0;i<v;i++){
d=T.getRow(i),T.setRow(i,d.div(d.norm2()));
}return T=T.transpose(),T=S.transjugate().dot(T),{lambda:$.getDiag(),E:T};
},numeric.ccsSparse=function(e){
var t,n,r,s=e.length,i=[];for(n=s-1;-1!==n;--n){
for(r in t=e[n]){
for(r=parseInt(r);r>=i.length;){
i[i.length]=0;
}0!==t[r]&&i[r]++;
}
}var a=i.length,o=Array(a+1);for(o[0]=0,n=0;n<a;++n){
o[n+1]=o[n]+i[n];
}var u=Array(o[a]),l=Array(o[a]);for(n=s-1;-1!==n;--n){
for(r in t=e[n]){
0!==t[r]&&(i[r]--,u[o[r]+i[r]]=n,l[o[r]+i[r]]=t[r]);
}
}return[o,u,l];
},numeric.ccsFull=function(e){
var t,n,r,s,i=e[0],a=e[1],o=e[2],u=numeric.ccsDim(e),l=u[0],c=u[1],h=numeric.rep([l,c],0);for(t=0;t<c;t++){
for(r=i[t],s=i[t+1],n=r;n<s;++n){
h[a[n]][t]=o[n];
}
}return h;
},numeric.ccsTSolve=function(e,t,n,r,s){
var i,a,o,u,l,c,h,d=e[0],p=e[1],f=e[2],m=d.length-1,g=Math.max,b=0;function x(e){
var t;if(0===n[e]){
for(n[e]=1,t=d[e];t<d[e+1];++t){
x(p[t]);
}s[b]=e,++b;
}
}for(void 0===r&&(n=numeric.rep([m],0)),void 0===r&&(r=numeric.linspace(0,n.length-1)),void 0===s&&(s=[]),i=r.length-1;-1!==i;--i){
x(r[i]);
}for(s.length=b,i=s.length-1;-1!==i;--i){
n[s[i]]=0;
}for(i=r.length-1;-1!==i;--i){
a=r[i],n[a]=t[a];
}for(i=s.length-1;-1!==i;--i){
for(a=s[i],o=d[a],u=g(d[a+1],o),l=o;l!==u;++l){
if(p[l]===a){
n[a]/=f[l];break;
}
}for(h=n[a],l=o;l!==u;++l){
(c=p[l])!==a&&(n[c]-=h*f[l]);
}
}return n;
},numeric.ccsDFS=function(e){
this.k=Array(e),this.k1=Array(e),this.j=Array(e);
},numeric.ccsDFS.prototype.dfs=function(e,t,n,r,s,i){
var a,o,u,l=0,c=s.length,h=this.k,d=this.k1,p=this.j;if(0===r[e]){
for(r[e]=1,p[0]=e,h[0]=o=t[e],d[0]=u=t[e+1];;){
if(o>=u){
if(s[c]=p[l],0===l){
return;
}++c,o=h[--l],u=d[l];
}else {
0===r[a=i[n[o]]]?(r[a]=1,h[l]=o,p[++l]=a,o=t[a],d[l]=u=t[a+1]):++o;
}
}
}
},numeric.ccsLPSolve=function(e,t,n,r,s,i,a){
var o,u,l,c,h,d,p,f,m,g=e[0],b=e[1],x=e[2],y=(g.length,t[0]),w=t[1],v=t[2];for(u=y[s],l=y[s+1],r.length=0,o=u;o<l;++o){
a.dfs(i[w[o]],g,b,n,r,i);
}for(o=r.length-1;-1!==o;--o){
n[r[o]]=0;
}for(o=u;o!==l;++o){
n[c=i[w[o]]]=v[o];
}for(o=r.length-1;-1!==o;--o){
for(h=g[c=r[o]],d=g[c+1],p=h;p<d;++p){
if(i[b[p]]===c){
n[c]/=x[p];break;
}
}for(m=n[c],p=h;p<d;++p){
(f=i[b[p]])!==c&&(n[f]-=m*x[p]);
}
}return n;
},numeric.ccsLUP1=function(e,t){
var n,r,s,i,a,o,u,l=e[0].length-1,c=[numeric.rep([l+1],0),[],[]],h=[numeric.rep([l+1],0),[],[]],d=c[0],p=c[1],f=c[2],m=h[0],g=h[1],b=h[2],x=numeric.rep([l],0),y=numeric.rep([l],0),w=numeric.ccsLPSolve,v=(Math.max,Math.abs),k=numeric.linspace(0,l-1),I=numeric.linspace(0,l-1),S=new numeric.ccsDFS(l);for(void 0===t&&(t=1),n=0;n<l;++n){
for(w(c,e,x,y,n,I,S),i=-1,a=-1,r=y.length-1;-1!==r;--r){
(s=y[r])<=n||(o=v(x[s]))>i&&(a=s,i=o);
}for(v(x[n])<t*i&&(r=k[n],i=k[a],k[n]=i,I[i]=n,k[a]=r,I[r]=a,i=x[n],x[n]=x[a],x[a]=i),i=d[n],a=m[n],u=x[n],p[i]=k[n],f[i]=1,++i,r=y.length-1;-1!==r;--r){
o=x[s=y[r]],y[r]=0,x[s]=0,s<=n?(g[a]=s,b[a]=o,++a):(p[i]=k[s],f[i]=o/u,++i);
}d[n+1]=i,m[n+1]=a;
}for(r=p.length-1;-1!==r;--r){
p[r]=I[p[r]];
}return{L:c,U:h,P:k,Pinv:I};
},numeric.ccsDFS0=function(e){
this.k=Array(e),this.k1=Array(e),this.j=Array(e);
},numeric.ccsDFS0.prototype.dfs=function(e,t,n,r,s,i,a){
var o,u,l,c=0,h=s.length,d=this.k,p=this.k1,f=this.j;if(0===r[e]){
for(r[e]=1,f[0]=e,d[0]=u=t[i[e]],p[0]=l=t[i[e]+1];;){
if(isNaN(u)){
throw new Error("Ow!");
}if(u>=l){
if(s[h]=i[f[c]],0===c){
return;
}++h,u=d[--c],l=p[c];
}else {
0===r[o=n[u]]?(r[o]=1,d[c]=u,f[++c]=o,u=t[o=i[o]],p[c]=l=t[o+1]):++u;
}
}
}
},numeric.ccsLPSolve0=function(e,t,n,r,s,i,a,o){
var u,l,c,h,d,p,f,m,g,b=e[0],x=e[1],y=e[2],w=(b.length,t[0]),v=t[1],k=t[2];for(l=w[s],c=w[s+1],r.length=0,u=l;u<c;++u){
o.dfs(v[u],b,x,n,r,i,a);
}for(u=r.length-1;-1!==u;--u){
n[a[h=r[u]]]=0;
}for(u=l;u!==c;++u){
n[h=v[u]]=k[u];
}for(u=r.length-1;-1!==u;--u){
for(m=a[h=r[u]],d=b[h],p=b[h+1],f=d;f<p;++f){
if(x[f]===m){
n[m]/=y[f];break;
}
}for(g=n[m],f=d;f<p;++f){
n[x[f]]-=g*y[f];
}n[m]=g;
}
},numeric.ccsLUP0=function(e,t){
var n,r,s,i,a,o,u,l=e[0].length-1,c=[numeric.rep([l+1],0),[],[]],h=[numeric.rep([l+1],0),[],[]],d=c[0],p=c[1],f=c[2],m=h[0],g=h[1],b=h[2],x=numeric.rep([l],0),y=numeric.rep([l],0),w=numeric.ccsLPSolve0,v=(Math.max,Math.abs),k=numeric.linspace(0,l-1),I=numeric.linspace(0,l-1),S=new numeric.ccsDFS0(l);for(void 0===t&&(t=1),n=0;n<l;++n){
for(w(c,e,x,y,n,I,k,S),i=-1,a=-1,r=y.length-1;-1!==r;--r){
(s=y[r])<=n||(o=v(x[k[s]]))>i&&(a=s,i=o);
}for(v(x[k[n]])<t*i&&(r=k[n],i=k[a],k[n]=i,I[i]=n,k[a]=r,I[r]=a),i=d[n],a=m[n],u=x[k[n]],p[i]=k[n],f[i]=1,++i,r=y.length-1;-1!==r;--r){
o=x[k[s=y[r]]],y[r]=0,x[k[s]]=0,s<=n?(g[a]=s,b[a]=o,++a):(p[i]=k[s],f[i]=o/u,++i);
}d[n+1]=i,m[n+1]=a;
}for(r=p.length-1;-1!==r;--r){
p[r]=I[p[r]];
}return{L:c,U:h,P:k,Pinv:I};
},numeric.ccsLUP=numeric.ccsLUP0,numeric.ccsDim=function(e){
return[numeric.sup(e[1])+1,e[0].length-1];
},numeric.ccsGetBlock=function(e,t,n){
var r=numeric.ccsDim(e),s=r[0],i=r[1];void 0===t?t=numeric.linspace(0,s-1):"number"==typeof t&&(t=[t]),void 0===n?n=numeric.linspace(0,i-1):"number"==typeof n&&(n=[n]);var a,o,u,l,c=t.length,h=n.length,d=numeric.rep([i],0),p=[],f=[],m=[d,p,f],g=e[0],b=e[1],x=e[2],y=numeric.rep([s],0),w=0,v=numeric.rep([s],0);for(o=0;o<h;++o){
var k=g[l=n[o]],I=g[l+1];for(a=k;a<I;++a){
v[u=b[a]]=1,y[u]=x[a];
}for(a=0;a<c;++a){
v[t[a]]&&(p[w]=a,f[w]=y[t[a]],++w);
}for(a=k;a<I;++a){
v[u=b[a]]=0;
}d[o+1]=w;
}return m;
},numeric.ccsDot=function(e,t){
var n,r,s,i,a,o,u,l,c,h,d,p=e[0],f=e[1],m=e[2],g=t[0],b=t[1],x=t[2],y=numeric.ccsDim(e),w=numeric.ccsDim(t),v=y[0],k=(y[1],w[1]),I=numeric.rep([v],0),S=numeric.rep([v],0),C=Array(v),N=numeric.rep([k],0),$=[],T=[],E=[N,$,T];for(s=0;s!==k;++s){
for(i=g[s],a=g[s+1],c=0,r=i;r<a;++r){
for(h=b[r],d=x[r],o=p[h],u=p[h+1],n=o;n<u;++n){
0===S[l=f[n]]&&(C[c]=l,S[l]=1,c+=1),I[l]=I[l]+m[n]*d;
}
}for(a=(i=N[s])+c,N[s+1]=a,r=c-1;-1!==r;--r){
d=i+r,n=C[r],$[d]=n,T[d]=I[n],S[n]=0,I[n]=0;
}N[s+1]=N[s]+c;
}return E;
},numeric.ccsLUPSolve=function(e,t){
var n=e.L,r=e.U,s=(e.P,t[0]),i=!1;"object"!=typeof s&&(s=(t=[[0,t.length],numeric.linspace(0,t.length-1),t])[0],i=!0);var a,o,u,l,c,h,d=t[1],p=t[2],f=n[0].length-1,m=s.length-1,g=numeric.rep([f],0),b=Array(f),x=numeric.rep([f],0),y=Array(f),w=numeric.rep([m+1],0),v=[],k=[],I=numeric.ccsTSolve,S=0;for(a=0;a<m;++a){
for(c=0,u=s[a],l=s[a+1],o=u;o<l;++o){
h=e.Pinv[d[o]],y[c]=h,x[h]=p[o],++c;
}for(y.length=c,I(n,x,g,y,b),o=y.length-1;-1!==o;--o){
x[y[o]]=0;
}if(I(r,g,x,b,y),i){
return x;
}for(o=b.length-1;-1!==o;--o){
g[b[o]]=0;
}for(o=y.length-1;-1!==o;--o){
h=y[o],v[S]=h,k[S]=x[h],x[h]=0,++S;
}w[a+1]=S;
}return[w,v,k];
},numeric.ccsbinop=function(e,t){
return void 0===t&&(t=""),Function("X","Y","var Xi = X[0], Xj = X[1], Xv = X[2];\nvar Yi = Y[0], Yj = Y[1], Yv = Y[2];\nvar n = Xi.length-1,m = Math.max(numeric.sup(Xj),numeric.sup(Yj))+1;\nvar Zi = numeric.rep([n+1],0), Zj = [], Zv = [];\nvar x = numeric.rep([m],0),y = numeric.rep([m],0);\nvar xk,yk,zk;\nvar i,j,j0,j1,k,p=0;\n"+t+"for(i=0;i<n;++i) {\n  j0 = Xi[i]; j1 = Xi[i+1];\n  for(j=j0;j!==j1;++j) {\n    k = Xj[j];\n    x[k] = 1;\n    Zj[p] = k;\n    ++p;\n  }\n  j0 = Yi[i]; j1 = Yi[i+1];\n  for(j=j0;j!==j1;++j) {\n    k = Yj[j];\n    y[k] = Yv[j];\n    if(x[k] === 0) {\n      Zj[p] = k;\n      ++p;\n    }\n  }\n  Zi[i+1] = p;\n  j0 = Xi[i]; j1 = Xi[i+1];\n  for(j=j0;j!==j1;++j) x[Xj[j]] = Xv[j];\n  j0 = Zi[i]; j1 = Zi[i+1];\n  for(j=j0;j!==j1;++j) {\n    k = Zj[j];\n    xk = x[k];\n    yk = y[k];\n"+e+"\n    Zv[j] = zk;\n  }\n  j0 = Xi[i]; j1 = Xi[i+1];\n  for(j=j0;j!==j1;++j) x[Xj[j]] = 0;\n  j0 = Yi[i]; j1 = Yi[i+1];\n  for(j=j0;j!==j1;++j) y[Yj[j]] = 0;\n}\nreturn [Zi,Zj,Zv];");
},function(){
var k,A,B,C;for(k in numeric.ops2){
A=isFinite(eval("1"+numeric.ops2[k]+"0"))?"[Y[0],Y[1],numeric."+k+"(X,Y[2])]":"NaN",B=isFinite(eval("0"+numeric.ops2[k]+"1"))?"[X[0],X[1],numeric."+k+"(X[2],Y)]":"NaN",C=isFinite(eval("1"+numeric.ops2[k]+"0"))&&isFinite(eval("0"+numeric.ops2[k]+"1"))?"numeric.ccs"+k+"MM(X,Y)":"NaN",numeric["ccs"+k+"MM"]=numeric.ccsbinop("zk = xk "+numeric.ops2[k]+"yk;"),numeric["ccs"+k]=Function("X","Y",'if(typeof X === "number") return '+A+';\nif(typeof Y === "number") return '+B+";\nreturn "+C+";\n");
}
}(),numeric.ccsScatter=function(e){
var t,n=e[0],r=e[1],s=e[2],i=numeric.sup(r)+1,a=n.length,o=numeric.rep([i],0),u=Array(a),l=Array(a),c=numeric.rep([i],0);for(t=0;t<a;++t){
c[r[t]]++;
}for(t=0;t<i;++t){
o[t+1]=o[t]+c[t];
}var h,d,p=o.slice(0);for(t=0;t<a;++t){
u[h=p[d=r[t]]]=n[t],l[h]=s[t],p[d]=p[d]+1;
}return[o,u,l];
},numeric.ccsGather=function(e){
var t,n,r,s,i,a=e[0],o=e[1],u=e[2],l=a.length-1,c=o.length,h=Array(c),d=Array(c),p=Array(c);for(i=0,t=0;t<l;++t){
for(r=a[t],s=a[t+1],n=r;n!==s;++n){
d[i]=t,h[i]=o[n],p[i]=u[n],++i;
}
}return[h,d,p];
},numeric.sdim=function e(t,n,r){
if(void 0===n&&(n=[]),"object"!=typeof t){
return n;
}var s;for(s in void 0===r&&(r=0),r in n||(n[r]=0),t.length>n[r]&&(n[r]=t.length),t){
t.hasOwnProperty(s)&&e(t[s],n,r+1);
}return n;
},numeric.sclone=function e(t,n,r){
void 0===n&&(n=0),void 0===r&&(r=numeric.sdim(t).length);var s,i=Array(t.length);if(n===r-1){
for(s in t){
t.hasOwnProperty(s)&&(i[s]=t[s]);
}return i;
}for(s in t){
t.hasOwnProperty(s)&&(i[s]=e(t[s],n+1,r));
}return i;
},numeric.sdiag=function(e){
var t,n,r=e.length,s=Array(r);for(t=r-1;t>=1;t-=2){
n=t-1,s[t]=[],s[t][t]=e[t],s[n]=[],s[n][n]=e[n];
}return 0===t&&(s[0]=[],s[0][0]=e[t]),s;
},numeric.sidentity=function(e){
return numeric.sdiag(numeric.rep([e],1));
},numeric.stranspose=function(e){
var t,n,r,s=[];for(t in e.length,e){
if(e.hasOwnProperty(t)){
for(n in r=e[t]){
r.hasOwnProperty(n)&&("object"!=typeof s[n]&&(s[n]=[]),s[n][t]=r[n]);
}
}
}return s;
},numeric.sLUP=function(e,t){
throw new Error("The function numeric.sLUP had a bug in it and has been removed. Please use the new numeric.ccsLUP function instead.");
},numeric.sdotMM=function(e,t){
var n,r,s,i,a,o,u,l=e.length,c=(t.length,numeric.stranspose(t)),h=c.length,d=Array(l);for(s=l-1;s>=0;s--){
for(u=[],n=e[s],a=h-1;a>=0;a--){
for(i in o=0,r=c[a],n){
n.hasOwnProperty(i)&&i in r&&(o+=n[i]*r[i]);
}o&&(u[a]=o);
}d[s]=u;
}return d;
},numeric.sdotMV=function(e,t){
var n,r,s,i,a=e.length,o=Array(a);for(r=a-1;r>=0;r--){
for(s in i=0,n=e[r]){
n.hasOwnProperty(s)&&t[s]&&(i+=n[s]*t[s]);
}i&&(o[r]=i);
}return o;
},numeric.sdotVM=function(e,t){
var n,r,s,i,a=[];for(n in e){
if(e.hasOwnProperty(n)){
for(r in s=t[n],i=e[n],s){
s.hasOwnProperty(r)&&(a[r]||(a[r]=0),a[r]+=i*s[r]);
}
}
}return a;
},numeric.sdotVV=function(e,t){
var n,r=0;for(n in e){
e[n]&&t[n]&&(r+=e[n]*t[n]);
}return r;
},numeric.sdot=function(e,t){
var n=numeric.sdim(e).length,r=numeric.sdim(t).length;switch(1e3*n+r){
case 0:return e*t;case 1001:return numeric.sdotVV(e,t);case 2001:return numeric.sdotMV(e,t);case 1002:return numeric.sdotVM(e,t);case 2002:return numeric.sdotMM(e,t);default:throw new Error("numeric.sdot not implemented for tensors of order "+n+" and "+r);
}
},numeric.sscatter=function(e){
var t,n,r,s,i=e[0].length,a=e.length,o=[];for(n=i-1;n>=0;--n){
if(e[a-1][n]){
for(s=o,r=0;r<a-2;r++){
s[t=e[r][n]]||(s[t]=[]),s=s[t];
}s[e[r][n]]=e[r+1][n];
}
}return o;
},numeric.sgather=function e(t,n,r){
var s,i,a;for(i in void 0===n&&(n=[]),void 0===r&&(r=[]),s=r.length,t){
if(t.hasOwnProperty(i)){
if(r[s]=parseInt(i),"number"==typeof(a=t[i])){
if(a){
if(0===n.length){
for(i=s+1;i>=0;--i){
n[i]=[];
}
}for(i=s;i>=0;--i){
n[i].push(r[i]);
}n[s+1].push(a);
}
}else {
e(a,n,r);
}
}
}return r.length>s&&r.pop(),n;
},numeric.cLU=function(e){
var t,n,r,s,i,a,o=e[0],u=e[1],l=e[2],c=o.length,h=0;for(t=0;t<c;t++){
o[t]>h&&(h=o[t]);
}h++;var d,p=Array(h),f=Array(h),m=numeric.rep([h],1/0),g=numeric.rep([h],-1/0);for(r=0;r<c;r++){
t=o[r],(n=u[r])<m[t]&&(m[t]=n),n>g[t]&&(g[t]=n);
}for(t=0;t<h-1;t++){
g[t]>g[t+1]&&(g[t+1]=g[t]);
}for(t=h-1;t>=1;t--){
m[t]<m[t-1]&&(m[t-1]=m[t]);
}for(t=0;t<h;t++){
f[t]=numeric.rep([g[t]-m[t]+1],0),p[t]=numeric.rep([t-m[t]],0),m[t],g[t];
}for(r=0;r<c;r++){
f[t=o[r]][u[r]-m[t]]=l[r];
}for(t=0;t<h-1;t++){
for(s=t-m[t],y=f[t],n=t+1;m[n]<=t&&n<h;n++){
if(i=t-m[n],a=g[t]-t,d=(w=f[n])[i]/y[s]){
for(r=1;r<=a;r++){
w[r+i]-=d*y[r+s];
}p[n][t-m[n]]=d;
}
}
}var b,x,y=[],w=[],v=[],k=[],I=[],S=[];for(c=0,b=0,t=0;t<h;t++){
for(s=m[t],i=g[t],x=f[t],n=t;n<=i;n++){
x[n-s]&&(y[c]=t,w[c]=n,v[c]=x[n-s],c++);
}for(x=p[t],n=s;n<t;n++){
x[n-s]&&(k[b]=t,I[b]=n,S[b]=x[n-s],b++);
}k[b]=t,I[b]=t,S[b]=1,b++;
}return{U:[y,w,v],L:[k,I,S]};
},numeric.cLUsolve=function(e,t){
var n,r,s=e.L,i=e.U,a=numeric.clone(t),o=s[0],u=s[1],l=s[2],c=i[0],h=i[1],d=i[2],p=c.length,f=(o.length,a.length);for(r=0,n=0;n<f;n++){
for(;u[r]<n;){
a[n]-=l[r]*a[u[r]],r++;
}r++;
}for(r=p-1,n=f-1;n>=0;n--){
for(;h[r]>n;){
a[n]-=d[r]*a[h[r]],r--;
}a[n]/=d[r],r--;
}return a;
},numeric.cgrid=function(e,t){
"number"==typeof e&&(e=[e,e]);var n,r,s,i=numeric.rep(e,-1);for("function"!=typeof t&&(t="L"===t?function(t,n){
return t>=e[0]/2||n<e[1]/2;
}:function(e,t){
return!0;
}),s=0,n=1;n<e[0]-1;n++){
for(r=1;r<e[1]-1;r++){
t(n,r)&&(i[n][r]=s,s++);
}
}return i;
},numeric.cdelsq=function(e){
var t,n,r,s,i,a=[[-1,0],[0,-1],[0,1],[1,0]],o=numeric.dim(e),u=o[0],l=o[1],c=[],h=[],d=[];for(t=1;t<u-1;t++){
for(n=1;n<l-1;n++){
if(!(e[t][n]<0)){
for(r=0;r<4;r++){
s=t+a[r][0],i=n+a[r][1],e[s][i]<0||(c.push(e[t][n]),h.push(e[s][i]),d.push(-1));
}c.push(e[t][n]),h.push(e[t][n]),d.push(4);
}
}
}return[c,h,d];
},numeric.cdotMV=function(e,t){
var n,r,s,i=e[0],a=e[1],o=e[2],u=i.length;for(s=0,r=0;r<u;r++){
i[r]>s&&(s=i[r]);
}for(s++,n=numeric.rep([s],0),r=0;r<u;r++){
n[i[r]]+=o[r]*t[a[r]];
}return n;
},numeric.Spline=function(e,t,n,r,s){
this.x=e,this.yl=t,this.yr=n,this.kl=r,this.kr=s;
},numeric.Spline.prototype._at=function(e,t){
var n,r,s,i=this.x,a=this.yl,o=this.yr,u=this.kl,l=this.kr,c=numeric.add,h=numeric.sub,d=numeric.mul;n=h(d(u[t],i[t+1]-i[t]),h(o[t+1],a[t])),r=c(d(l[t+1],i[t]-i[t+1]),h(o[t+1],a[t]));var p=(s=(e-i[t])/(i[t+1]-i[t]))*(1-s);return c(c(c(d(1-s,a[t]),d(s,o[t+1])),d(n,p*(1-s))),d(r,p*s));
},numeric.Spline.prototype.at=function(e){
if("number"==typeof e){
var t,n,r,s=this.x,i=s.length,a=Math.floor;for(t=0,n=i-1;n-t>1;){
s[r=a((t+n)/2)]<=e?t=r:n=r;
}return this._at(e,t);
}i=e.length;var o,u=Array(i);for(o=i-1;-1!==o;--o){
u[o]=this.at(e[o]);
}return u;
},numeric.Spline.prototype.diff=function(){
var e,t,n,r=this.x,s=this.yl,i=this.yr,a=this.kl,o=this.kr,u=s.length,l=a,c=o,h=Array(u),d=Array(u),p=numeric.add,f=numeric.mul,m=numeric.div,g=numeric.sub;for(e=u-1;-1!==e;--e){
t=r[e+1]-r[e],n=g(i[e+1],s[e]),h[e]=m(p(f(n,6),f(a[e],-4*t),f(o[e+1],-2*t)),t*t),d[e+1]=m(p(f(n,-6),f(a[e],2*t),f(o[e+1],4*t)),t*t);
}return new numeric.Spline(r,l,c,h,d);
},numeric.Spline.prototype.roots=function(){
function e(e){
return e*e;
}var t=[],n=this.x,r=this.yl,s=this.yr,i=this.kl,a=this.kr;"number"==typeof r[0]&&(r=[r],s=[s],i=[i],a=[a]);var o,u,l,c,h,d,p,f,m,g,b,x,y,w,v,k,I,S,C,N,$,T,E,R=r.length,A=n.length-1,F=(t=Array(R),Math.sqrt);for(o=0;o!==R;++o){
for(c=r[o],h=s[o],d=i[o],p=a[o],f=[],u=0;u!==A;u++){
for(u>0&&h[u]*c[u]<0&&f.push(n[u]),k=n[u+1]-n[u],n[u],b=c[u],x=h[u+1],m=d[u]/k,y=(g=p[u+1]/k)+3*b+2*m-3*x,w=3*(g+m+2*(b-x)),(v=e(m-g+3*(b-x))+12*g*b)<=0?I=(S=y/w)>n[u]&&S<n[u+1]?[n[u],S,n[u+1]]:[n[u],n[u+1]]:(S=(y-F(v))/w,C=(y+F(v))/w,I=[n[u]],S>n[u]&&S<n[u+1]&&I.push(S),C>n[u]&&C<n[u+1]&&I.push(C),I.push(n[u+1])),$=I[0],S=this._at($,u),l=0;l<I.length-1;l++){
if(T=I[l+1],C=this._at(T,u),0!==S){
if(0===C||S*C>0){
$=T,S=C;
}else{
for(var _=0;!((E=(S*T-C*$)/(S-C))<=$||E>=T);){
if((N=this._at(E,u))*C>0){
T=E,C=N,-1===_&&(S*=.5),_=-1;
}else{
if(!(N*S>0)){
break;
}$=E,S=N,1===_&&(C*=.5),_=1;
}
}f.push(E),$=I[l+1],S=this._at($,u);
}
}else {
f.push($),$=T,S=C;
}
}0===C&&f.push(T);
}t[o]=f;
}return"number"==typeof this.yl[0]?t[0]:t;
},numeric.spline=function(e,t,n,r){
var s,i=e.length,a=[],o=[],u=[],l=numeric.sub,c=numeric.mul,h=numeric.add;for(s=i-2;s>=0;s--){
o[s]=e[s+1]-e[s],u[s]=l(t[s+1],t[s]);
}"string"!=typeof n&&"string"!=typeof r||(n=r="periodic");var d=[[],[],[]];switch(typeof n){
case"undefined":a[0]=c(3/(o[0]*o[0]),u[0]),d[0].push(0,0),d[1].push(0,1),d[2].push(2/o[0],1/o[0]);break;case"string":a[0]=h(c(3/(o[i-2]*o[i-2]),u[i-2]),c(3/(o[0]*o[0]),u[0])),d[0].push(0,0,0),d[1].push(i-2,0,1),d[2].push(1/o[i-2],2/o[i-2]+2/o[0],1/o[0]);break;default:a[0]=n,d[0].push(0),d[1].push(0),d[2].push(1);
}for(s=1;s<i-1;s++){
a[s]=h(c(3/(o[s-1]*o[s-1]),u[s-1]),c(3/(o[s]*o[s]),u[s])),d[0].push(s,s,s),d[1].push(s-1,s,s+1),d[2].push(1/o[s-1],2/o[s-1]+2/o[s],1/o[s]);
}switch(typeof r){
case"undefined":a[i-1]=c(3/(o[i-2]*o[i-2]),u[i-2]),d[0].push(i-1,i-1),d[1].push(i-2,i-1),d[2].push(1/o[i-2],2/o[i-2]);break;case"string":d[1][d[1].length-1]=0;break;default:a[i-1]=r,d[0].push(i-1),d[1].push(i-1),d[2].push(1);
}a="number"!=typeof a[0]?numeric.transpose(a):[a];var p=Array(a.length);if("string"==typeof n){
for(s=p.length-1;-1!==s;--s){
p[s]=numeric.ccsLUPSolve(numeric.ccsLUP(numeric.ccsScatter(d)),a[s]),p[s][i-1]=p[s][0];
}
}else {
for(s=p.length-1;-1!==s;--s){
p[s]=numeric.cLUsolve(numeric.cLU(d),a[s]);
}
}return p="number"==typeof t[0]?p[0]:numeric.transpose(p),new numeric.Spline(e,t,t,p,p);
},numeric.fftpow2=function e(t,n){
var r=t.length;if(1!==r){
var s,i,a=Math.cos,o=Math.sin,u=Array(r/2),l=Array(r/2),c=Array(r/2),h=Array(r/2);for(i=r/2,s=r-1;-1!==s;--s){
c[--i]=t[s],h[i]=n[s],--s,u[i]=t[s],l[i]=n[s];
}e(u,l),e(c,h),i=r/2;var d,p,f,m=-6.283185307179586/r;for(s=r-1;-1!==s;--s){
-1==--i&&(i=r/2-1),p=a(d=m*s),f=o(d),t[s]=u[i]+p*c[i]-f*h[i],n[s]=l[i]+p*h[i]+f*c[i];
}
}
},numeric._ifftpow2=function e(t,n){
var r=t.length;if(1!==r){
var s,i,a=Math.cos,o=Math.sin,u=Array(r/2),l=Array(r/2),c=Array(r/2),h=Array(r/2);for(i=r/2,s=r-1;-1!==s;--s){
c[--i]=t[s],h[i]=n[s],--s,u[i]=t[s],l[i]=n[s];
}e(u,l),e(c,h),i=r/2;var d,p,f,m=6.283185307179586/r;for(s=r-1;-1!==s;--s){
-1==--i&&(i=r/2-1),p=a(d=m*s),f=o(d),t[s]=u[i]+p*c[i]-f*h[i],n[s]=l[i]+p*h[i]+f*c[i];
}
}
},numeric.ifftpow2=function(e,t){
numeric._ifftpow2(e,t),numeric.diveq(e,e.length),numeric.diveq(t,t.length);
},numeric.convpow2=function(e,t,n,r){
var s,i,a,o,u;for(numeric.fftpow2(e,t),numeric.fftpow2(n,r),s=e.length-1;-1!==s;--s){
i=e[s],o=t[s],a=n[s],u=r[s],e[s]=i*a-o*u,t[s]=i*u+o*a;
}numeric.ifftpow2(e,t);
},numeric.T.prototype.fft=function(){
var e,t,n=this.x,r=this.y,s=n.length,i=Math.log,a=i(2),o=Math.ceil(i(2*s-1)/a),u=Math.pow(2,o),l=numeric.rep([u],0),c=numeric.rep([u],0),h=Math.cos,d=Math.sin,p=-3.141592653589793/s,f=numeric.rep([u],0),m=numeric.rep([u],0);for(Math.floor(s/2),e=0;e<s;e++){
f[e]=n[e];
}if(void 0!==r){
for(e=0;e<s;e++){
m[e]=r[e];
}
}for(l[0]=1,e=1;e<=u/2;e++){
t=p*e*e,l[e]=h(t),c[e]=d(t),l[u-e]=h(t),c[u-e]=d(t);
}var g=new numeric.T(f,m),b=new numeric.T(l,c);return g=g.mul(b),numeric.convpow2(g.x,g.y,numeric.clone(b.x),numeric.neg(b.y)),(g=g.mul(b)).x.length=s,g.y.length=s,g;
},numeric.T.prototype.ifft=function(){
var e,t,n=this.x,r=this.y,s=n.length,i=Math.log,a=i(2),o=Math.ceil(i(2*s-1)/a),u=Math.pow(2,o),l=numeric.rep([u],0),c=numeric.rep([u],0),h=Math.cos,d=Math.sin,p=3.141592653589793/s,f=numeric.rep([u],0),m=numeric.rep([u],0);for(Math.floor(s/2),e=0;e<s;e++){
f[e]=n[e];
}if(void 0!==r){
for(e=0;e<s;e++){
m[e]=r[e];
}
}for(l[0]=1,e=1;e<=u/2;e++){
t=p*e*e,l[e]=h(t),c[e]=d(t),l[u-e]=h(t),c[u-e]=d(t);
}var g=new numeric.T(f,m),b=new numeric.T(l,c);return g=g.mul(b),numeric.convpow2(g.x,g.y,numeric.clone(b.x),numeric.neg(b.y)),(g=g.mul(b)).x.length=s,g.y.length=s,g.div(s);
},numeric.gradient=function(e,t){
var n=t.length,r=e(t);if(isNaN(r)){
throw new Error("gradient: f(x) is a NaN!");
}var s,i,a,o,u,l,c,h,d,p=Math.max,f=numeric.clone(t),m=Array(n),g=(numeric.div,numeric.sub,p=Math.max,Math.abs),b=Math.min,x=0;for(s=0;s<n;s++){
for(var y=p(1e-6*r,1e-8);;){
if(++x>20){
throw new Error("Numerical gradient fails");
}if(f[s]=t[s]+y,i=e(f),f[s]=t[s]-y,a=e(f),f[s]=t[s],isNaN(i)||isNaN(a)){
y/=16;
}else{
if(m[s]=(i-a)/(2*y),o=t[s]-y,u=t[s],l=t[s]+y,c=(i-r)/y,h=(r-a)/y,d=p(g(m[s]),g(r),g(i),g(a),g(o),g(u),g(l),1e-8),!(b(p(g(c-m[s]),g(h-m[s]),g(c-h))/d,y/d)>.001)){
break;
}y/=16;
}
}
}return m;
},numeric.uncmin=function(e,t,n,r,s,i,a){
var o=numeric.gradient;void 0===a&&(a={}),void 0===n&&(n=1e-8),void 0===r&&(r=function(t){
return o(e,t);
}),void 0===s&&(s=1e3);var u,l,c=(t=numeric.clone(t)).length,h=e(t);if(isNaN(h)){
throw new Error("uncmin: f(x0) is a NaN!");
}var d=Math.max,p=numeric.norm2;n=d(n,numeric.epsilon);var f,m,g,b,x,y,w,v,k,I,S=a.Hinv||numeric.identity(c),C=numeric.dot,N=(numeric.inv,numeric.sub),$=numeric.add,T=numeric.tensor,E=numeric.div,R=numeric.mul,A=numeric.all,F=numeric.isFinite,_=numeric.neg,D=0,O="";for(m=r(t);D<s;){
if("function"==typeof i&&i(D,t,h,m,S)){
O="Callback returned true";break;
}if(!A(F(m))){
O="Gradient has Infinity or NaN";break;
}if(!A(F(f=_(C(S,m))))){
O="Search direction has Infinity or NaN";break;
}if((I=p(f))<n){
O="Newton step smaller than tol";break;
}for(k=1,l=C(m,f),x=t;D<s&&!(k*I<n)&&(x=$(t,b=R(f,k)),(u=e(x))-h>=.1*k*l||isNaN(u));){
k*=.5,++D;
}if(k*I<n){
O="Line search step size smaller than tol";break;
}if(D===s){
O="maxit reached during line search";break;
}v=C(y=N(g=r(x),m),b),w=C(S,y),S=N($(S,R((v+C(y,w))/(v*v),T(b,b))),E($(T(w,b),T(b,w)),v)),t=x,h=u,m=g,++D;
}return{solution:t,f:h,gradient:m,invHessian:S,iterations:D,message:O};
},numeric.Dopri=function(e,t,n,r,s,i,a){
this.x=e,this.y=t,this.f=n,this.ymid=r,this.iterations=s,this.events=a,this.message=i;
},numeric.Dopri.prototype._at=function(e,t){
function n(e){
return e*e;
}var r,s,i,a,o,u,l,c,h,d=this,p=d.x,f=d.y,m=d.f,g=d.ymid,b=(p.length,Math.floor,numeric.add),x=numeric.mul,y=numeric.sub;return r=p[t],s=p[t+1],a=f[t],o=f[t+1],i=r+.5*(s-r),u=g[t],l=y(m[t],x(a,1/(r-i)+2/(r-s))),c=y(m[t+1],x(o,1/(s-i)+2/(s-r))),b(b(b(b(x(a,(h=[n(e-s)*(e-i)/n(r-s)/(r-i),n(e-r)*n(e-s)/n(r-i)/n(s-i),n(e-r)*(e-i)/n(s-r)/(s-i),(e-r)*n(e-s)*(e-i)/n(r-s)/(r-i),(e-s)*n(e-r)*(e-i)/n(r-s)/(s-i)])[0]),x(u,h[1])),x(o,h[2])),x(l,h[3])),x(c,h[4]));
},numeric.Dopri.prototype.at=function(e){
var t,n,r,s=Math.floor;if("number"!=typeof e){
var i=e.length,a=Array(i);for(t=i-1;-1!==t;--t){
a[t]=this.at(e[t]);
}return a;
}var o=this.x;for(t=0,n=o.length-1;n-t>1;){
o[r=s(.5*(t+n))]<=e?t=r:n=r;
}return this._at(e,t);
},numeric.dopri=function(e,t,n,r,s,i,a){
void 0===s&&(s=1e-6),void 0===i&&(i=1e3);var o,u,l,c,h,d,p,f,m,g,b,x,y,w=[e],v=[n],k=[r(e,n)],I=[],S=[3/40,9/40],C=[44/45,-56/15,32/9],N=[19372/6561,-25360/2187,64448/6561,-212/729],$=[9017/3168,-355/33,46732/5247,49/176,-5103/18656],T=[35/384,0,500/1113,125/192,-2187/6784,11/84],E=[.10013431883002395,0,.3918321794184259,-.02982460176594817,.05893268337240795,-.04497888809104361,5618549.5/235043384],R=[.2,.3,.8,8/9,1,1],A=[-71/57600,0,71/16695,-71/1920,17253/339200,-22/525,1/40],F=0,_=(t-e)/10,D=0,O=numeric.add,M=numeric.mul,L=(Math.max,Math.min),z=Math.abs,P=numeric.norminf,B=Math.pow,U=numeric.any,W=numeric.lt,V=numeric.and,G=(numeric.sub,new numeric.Dopri(w,v,k,I,-1,""));for("function"==typeof a&&(b=a(e,n));e<t&&D<i;){
if(++D,e+_>t&&(_=t-e),o=r(e+R[0]*_,O(n,M(.2*_,k[F]))),u=r(e+R[1]*_,O(O(n,M(S[0]*_,k[F])),M(S[1]*_,o))),l=r(e+R[2]*_,O(O(O(n,M(C[0]*_,k[F])),M(C[1]*_,o)),M(C[2]*_,u))),c=r(e+R[3]*_,O(O(O(O(n,M(N[0]*_,k[F])),M(N[1]*_,o)),M(N[2]*_,u)),M(N[3]*_,l))),h=r(e+R[4]*_,O(O(O(O(O(n,M($[0]*_,k[F])),M($[1]*_,o)),M($[2]*_,u)),M($[3]*_,l)),M($[4]*_,c))),d=r(e+_,m=O(O(O(O(O(n,M(k[F],_*T[0])),M(u,_*T[2])),M(l,_*T[3])),M(c,_*T[4])),M(h,_*T[5]))),(g="number"==typeof(p=O(O(O(O(O(M(k[F],_*A[0]),M(u,_*A[2])),M(l,_*A[3])),M(c,_*A[4])),M(h,_*A[5])),M(d,_*A[6])))?z(p):P(p))>s){
if(e+(_=.2*_*B(s/g,.25))===e){
G.msg="Step size became too small";break;
}
}else{
if(I[F]=O(O(O(O(O(O(n,M(k[F],_*E[0])),M(u,_*E[2])),M(l,_*E[3])),M(c,_*E[4])),M(h,_*E[5])),M(d,_*E[6])),w[++F]=e+_,v[F]=m,k[F]=d,"function"==typeof a){
var j,H,q=e,K=e+.5*_;if(x=a(K,I[F-1]),U(y=V(W(b,0),W(0,x)))||(q=K,b=x,x=a(K=e+_,m),y=V(W(b,0),W(0,x))),U(y)){
for(var X,Y,Z=0,J=1,Q=1;;){
if("number"==typeof b){
H=(Q*x*q-J*b*K)/(Q*x-J*b);
}else {
for(H=K,f=b.length-1;-1!==f;--f){
b[f]<0&&x[f]>0&&(H=L(H,(Q*x[f]*q-J*b[f]*K)/(Q*x[f]-J*b[f])));
}
}if(H<=q||H>=K){
break;
}Y=a(H,j=G._at(H,F-1)),U(X=V(W(b,0),W(0,Y)))?(K=H,x=Y,y=X,Q=1,-1===Z?J*=.5:J=1,Z=-1):(q=H,b=Y,J=1,1===Z?Q*=.5:Q=1,Z=1);
}return m=G._at(.5*(e+H),F-1),G.f[F]=r(H,j),G.x[F]=H,G.y[F]=j,G.ymid[F-1]=m,G.events=y,G.iterations=D,G;
}
}e+=_,n=m,b=x,_=L(.8*_*B(s/g,.25),4*_);
}
}return G.iterations=D,G;
},numeric.LU=function(e,t){
t=t||!1;var n,r,s,i,a,o,u,l,c,h=Math.abs,d=e.length,p=d-1,f=new Array(d);for(t||(e=numeric.clone(e)),s=0;s<d;++s){
for(u=s,c=h((o=e[s])[s]),r=s+1;r<d;++r){
c<(i=h(e[r][s]))&&(c=i,u=r);
}for(f[s]=u,u!=s&&(e[s]=e[u],e[u]=o,o=e[s]),a=o[s],n=s+1;n<d;++n){
e[n][s]/=a;
}for(n=s+1;n<d;++n){
for(l=e[n],r=s+1;r<p;++r){
l[r]-=l[s]*o[r],l[++r]-=l[s]*o[r];
}r===p&&(l[r]-=l[s]*o[r]);
}
}return{LU:e,P:f};
},numeric.LUsolve=function(e,t){
var n,r,s,i,a,o=e.LU,u=o.length,l=numeric.clone(t),c=e.P;for(n=u-1;-1!==n;--n){
l[n]=t[n];
}for(n=0;n<u;++n){
for(s=c[n],c[n]!==n&&(a=l[n],l[n]=l[s],l[s]=a),i=o[n],r=0;r<n;++r){
l[n]-=l[r]*i[r];
}
}for(n=u-1;n>=0;--n){
for(i=o[n],r=n+1;r<u;++r){
l[n]-=l[r]*i[r];
}l[n]/=i[n];
}return l;
},numeric.solve=function(e,t,n){
return numeric.LUsolve(numeric.LU(e,n),t);
},numeric.echelonize=function(e){
var t,n,r,s,i,a,o,u,l=numeric.dim(e),c=l[0],h=l[1],d=numeric.identity(c),p=Array(c),f=Math.abs,m=numeric.diveq;for(e=numeric.clone(e),t=0;t<c;++t){
for(r=0,i=e[t],a=d[t],n=1;n<h;++n){
f(i[r])<f(i[n])&&(r=n);
}for(p[t]=r,m(a,i[r]),m(i,i[r]),n=0;n<c;++n){
if(n!==t){
for(u=(o=e[n])[r],s=h-1;-1!==s;--s){
o[s]-=i[s]*u;
}for(o=d[n],s=c-1;-1!==s;--s){
o[s]-=a[s]*u;
}
}
}
}return{I:d,A:e,P:p};
},numeric.__solveLP=function(e,t,n,r,s,i,a){
var o,u,l,c,h=numeric.sum,d=(numeric.log,numeric.mul),p=numeric.sub,f=numeric.dot,m=numeric.div,g=numeric.add,b=e.length,x=n.length,y=!1,w=1,v=(numeric.transpose(t),numeric.svd,numeric.transpose),k=(numeric.leq,Math.sqrt),I=Math.abs,S=(numeric.muleq,numeric.norminf,numeric.any,Math.min),C=numeric.all,N=numeric.gt,$=Array(b),T=Array(x),E=(numeric.rep([x],1),numeric.solve),R=p(n,f(t,i)),A=f(e,e);for(l=0;l<s;++l){
var F,_;for(F=x-1;-1!==F;--F){
T[F]=m(t[F],R[F]);
}var D=v(T);for(F=b-1;-1!==F;--F){
$[F]=h(D[F]);
}w=.25*I(A/f(e,$));var O=100*k(A/f($,$));for((!isFinite(w)||w>O)&&(w=O),c=g(e,d(w,$)),u=f(D,T),F=b-1;-1!==F;--F){
u[F][F]+=1;
}_=E(u,m(c,w),!0);var M=m(R,f(t,_)),L=1;for(F=x-1;-1!==F;--F){
M[F]<0&&(L=S(L,-.999*M[F]));
}if(o=p(i,d(_,L)),!C(N(R=p(n,f(t,o)),0))){
return{solution:i,message:"",iterations:l};
}if(i=o,w<r){
return{solution:o,message:"",iterations:l};
}if(a){
var z=f(e,c),P=f(t,c);for(y=!0,F=x-1;-1!==F;--F){
if(z*P[F]<0){
y=!1;break;
}
}
}else {
y=!(i[b-1]>=0);
}if(y){
return{solution:o,message:"Unbounded",iterations:l};
}
}return{solution:i,message:"maximum iteration count exceeded",iterations:l};
},numeric._solveLP=function(e,t,n,r,s){
var i=e.length,a=n.length,o=(numeric.sum,numeric.log,numeric.mul,numeric.sub),u=numeric.dot,l=(numeric.div,numeric.add,numeric.rep([i],0).concat([1])),c=numeric.rep([a,1],-1),h=numeric.blockMatrix([[t,c]]),d=n,p=numeric.rep([i],0).concat(Math.max(0,numeric.sup(numeric.neg(n)))+1),f=numeric.__solveLP(l,h,d,r,s,p,!1),m=numeric.clone(f.solution);if(m.length=i,numeric.inf(o(n,u(t,m)))<0){
return{solution:NaN,message:"Infeasible",iterations:f.iterations};
}var g=numeric.__solveLP(e,t,n,r,s-f.iterations,m,!0);return g.iterations+=f.iterations,g;
},numeric.solveLP=function(e,t,n,r,s,i,a){
if(void 0===a&&(a=1e3),void 0===i&&(i=numeric.epsilon),void 0===r){
return numeric._solveLP(e,t,n,i,a);
}var o,u=r.length,l=r[0].length,c=t.length,h=numeric.echelonize(r),d=numeric.rep([l],0),p=h.P,f=[];for(o=p.length-1;-1!==o;--o){
d[p[o]]=1;
}for(o=l-1;-1!==o;--o){
0===d[o]&&f.push(o);
}var m=numeric.getRange,g=numeric.linspace(0,u-1),b=numeric.linspace(0,c-1),x=m(r,g,f),y=m(t,b,p),w=m(t,b,f),v=numeric.dot,k=numeric.sub,I=v(y,h.I),S=k(w,v(I,x)),C=k(n,v(I,s)),N=Array(p.length),$=Array(f.length);for(o=p.length-1;-1!==o;--o){
N[o]=e[p[o]];
}for(o=f.length-1;-1!==o;--o){
$[o]=e[f[o]];
}var T=k($,v(N,v(h.I,x))),E=numeric._solveLP(T,S,C,i,a),R=E.solution;if(R!=R){
return E;
}var A=v(h.I,k(s,v(x,R))),F=Array(e.length);for(o=p.length-1;-1!==o;--o){
F[p[o]]=A[o];
}for(o=f.length-1;-1!==o;--o){
F[f[o]]=R[o];
}return{solution:F,message:E.message,iterations:E.iterations};
},numeric.MPStoLP=function(e){
e instanceof String&&e.split("\n");var t,n,r,s,i=0,a=["Initial state","NAME","ROWS","COLUMNS","RHS","BOUNDS","ENDATA"],o=e.length,u=0,l={},c=[],h=0,d={},p=0,f=[],m=[],g=[];function b(n){
throw new Error("MPStoLP: "+n+"\nLine "+t+": "+e[t]+"\nCurrent state: "+a[i]+"\n");
}for(t=0;t<o;++t){
var x=(r=e[t]).match(/\S*/g),y=[];for(n=0;n<x.length;++n){
""!==x[n]&&y.push(x[n]);
}if(0!==y.length){
for(n=0;n<a.length&&r.substr(0,a[n].length)!==a[n];++n){}if(n<a.length){
if(i=n,1===n&&(s=y[1]),6===n){
return{name:s,c:f,A:numeric.transpose(m),b:g,rows:l,vars:d};
}
}else {
switch(i){
case 0:case 1:b("Unexpected line");case 2:switch(y[0]){
case"N":0===u?u=y[1]:b("Two or more N rows");break;case"L":l[y[1]]=h,c[h]=1,g[h]=0,++h;break;case"G":l[y[1]]=h,c[h]=-1,g[h]=0,++h;break;case"E":l[y[1]]=h,c[h]=0,g[h]=0,++h;break;default:b("Parse error "+numeric.prettyPrint(y));
}break;case 3:d.hasOwnProperty(y[0])||(d[y[0]]=p,f[p]=0,m[p]=numeric.rep([h],0),++p);var w=d[y[0]];for(n=1;n<y.length;n+=2){
if(y[n]!==u){
var v=l[y[n]];m[w][v]=(c[v]<0?-1:1)*parseFloat(y[n+1]);
}else {
f[w]=parseFloat(y[n+1]);
}
}break;case 4:for(n=1;n<y.length;n+=2){
g[l[y[n]]]=(c[l[y[n]]]<0?-1:1)*parseFloat(y[n+1]);
}break;case 5:break;case 6:b("Internal error");
}
}
}
}b("Reached end of file without ENDATA");
},numeric.seedrandom={pow:Math.pow,random:Math.random},function(e,t,n,r,s,i,a){
function o(e){
var t,r,s=this,i=e.length,a=0,o=s.i=s.j=s.m=0;for(s.S=[],s.c=[],i||(e=[i++]);a<n;){
s.S[a]=a++;
}for(a=0;a<n;a++){
o=c(o+(t=s.S[a])+e[a%i]),r=s.S[o],s.S[a]=r,s.S[o]=t;
}s.g=function(e){
var t=s.S,r=c(s.i+1),i=t[r],a=c(s.j+i),o=t[a];t[r]=o,t[a]=i;for(var u=t[c(i+o)];--e;){
r=c(r+1),o=t[a=c(a+(i=t[r]))],t[r]=o,t[a]=i,u=u*n+t[c(i+o)];
}return s.i=r,s.j=a,u;
},s.g(n);
}function u(e,t,n,r,s){
if(n=[],s=typeof e,t&&"object"==s){
for(r in e){
if(r.indexOf("S")<5){
try{
n.push(u(e[r],t-1));
}catch(e){}
}
}
}return n.length?n:e+("string"!=s?"\0":"");
}function l(e,t,n,r){
for(e+="",n=0,r=0;r<e.length;r++){
t[c(r)]=c((n^=19*t[c(r)])+e.charCodeAt(r));
}for(r in e="",t){
e+=String.fromCharCode(t[r]);
}return e;
}function c(e){
return e&n-1;
}t.seedrandom=function(r,c){
var h,d=[];return r=l(u(c?[r,e]:arguments.length?r:[(new Date).getTime(),e,window],3),d),l((h=new o(d)).S,e),t.random=function(){
for(var e=h.g(6),t=a,r=0;e<s;){
e=(e+r)*n,t*=n,r=h.g(1);
}for(;e>=i;){
e/=2,t/=2,r>>>=1;
}return(e+r)/t;
},r;
},a=t.pow(n,6),s=t.pow(2,s),i=2*s,l(t.random(),e);
}([],numeric.seedrandom,256,0,52),function(e){
function t(e){
if("object"!=typeof e){
return e;
}var n,r=[],s=e.length;for(n=0;n<s;n++){
r[n+1]=t(e[n]);
}return r;
}function n(e){
if("object"!=typeof e){
return e;
}var t,r=[],s=e.length;for(t=1;t<s;t++){
r[t-1]=n(e[t]);
}return r;
}e.solveQP=function(e,r,s,i,a,o){
e=t(e),r=t(r),s=t(s);var u,l,c,h,d,p=[],f=[],m=[],g=[],b=[];if(a=a||0,o=o?t(o):[void 0,0],i=i?t(i):[],l=e.length-1,c=s[1].length-1,!i){
for(u=1;u<=c;u+=1){
i[u]=0;
}
}for(u=1;u<=c;u+=1){
f[u]=0;
}for(h=Math.min(l,c),u=1;u<=l;u+=1){
m[u]=0;
}for(p[1]=0,u=1;u<=2*l+h*(h+5)/2+2*c+1;u+=1){
g[u]=0;
}for(u=1;u<=2;u+=1){
b[u]=0;
}return function(e,t,n,r,s,i,a,o,u,l,c,h,d,p,f,m){
var g,b,x,y,w,v,k,I,S,C,N,$,T,E,R,A,F,_,D,O,M,L,z,P,B,U,W;T=Math.min(r,l),x=2*r+T*(T+5)/2+2*l+1,P=1e-60;do{
B=1+.1*(P+=P),U=1+.2*P;
}while(B<=1||U<=1);for(g=1;g<=r;g+=1){
f[g]=t[g];
}for(g=r+1;g<=x;g+=1){
f[g]=0;
}for(g=1;g<=l;g+=1){
h[g]=0;
}if(w=[],0===m[1]){
if(function(e,t,n,r){
var s,i,a,o,u,l;for(i=1;i<=n;i+=1){
if(r[1]=i,l=0,(a=i-1)<1){
if((l=e[i][i]-l)<=0){
break;
}e[i][i]=Math.sqrt(l);
}else{
for(o=1;o<=a;o+=1){
for(u=e[o][i],s=1;s<o;s+=1){
u-=e[s][i]*e[s][o];
}u/=e[o][o],e[o][i]=u,l+=u*u;
}if((l=e[i][i]-l)<=0){
break;
}e[i][i]=Math.sqrt(l);
}r[1]=0;
}
}(e,0,r,w),0!==w[1]){
return void(m[1]=2);
}!function(e,t,n,r){
var s,i,a,o;for(i=1;i<=n;i+=1){
for(o=0,s=1;s<i;s+=1){
o+=e[s][i]*r[s];
}r[i]=(r[i]-o)/e[i][i];
}for(a=1;a<=n;a+=1){
for(r[i=n+1-a]=r[i]/e[i][i],o=-r[i],s=1;s<i;s+=1){
r[s]=r[s]+o*e[s][i];
}
}
}(e,0,r,t),function(e,t,n){
var r,s,i,a,o;for(i=1;i<=n;i+=1){
for(e[i][i]=1/e[i][i],o=-e[i][i],r=1;r<i;r+=1){
e[r][i]=o*e[r][i];
}if(n<(a=i+1)){
break;
}for(s=a;s<=n;s+=1){
for(o=e[i][s],e[i][s]=0,r=1;r<=i;r+=1){
e[r][s]=e[r][s]+o*e[r][i];
}
}
}
}(e,0,r);
}else{
for(b=1;b<=r;b+=1){
for(s[b]=0,g=1;g<=b;g+=1){
s[b]=s[b]+e[g][b]*t[g];
}
}for(b=1;b<=r;b+=1){
for(t[b]=0,g=b;g<=r;g+=1){
t[b]=t[b]+e[b][g]*s[g];
}
}
}for(i[1]=0,b=1;b<=r;b+=1){
for(s[b]=t[b],i[1]=i[1]+f[b]*s[b],f[b]=0,g=b+1;g<=r;g+=1){
e[g][b]=0;
}
}for(i[1]=-i[1]/2,m[1]=0,E=(C=(S=(N=(I=(k=r)+r)+T)+T+1)+T*(T+1)/2)+l,g=1;g<=l;g+=1){
for(A=0,b=1;b<=r;b+=1){
A+=a[b][g]*a[b][g];
}f[E+g]=Math.sqrt(A);
}function V(){
for(p[1]=p[1]+1,x=C,g=1;g<=l;g+=1){
for(x+=1,A=-o[g],b=1;b<=r;b+=1){
A+=a[b][g]*s[b];
}if(Math.abs(A)<P&&(A=0),g>c){
f[x]=A;
}else if(f[x]=-Math.abs(A),A>0){
for(b=1;b<=r;b+=1){
a[b][g]=-a[b][g];
}o[g]=-o[g];
}
}for(g=1;g<=d;g+=1){
f[C+h[g]]=0;
}for($=0,R=0,g=1;g<=l;g+=1){
f[C+g]<R*f[E+g]&&($=g,R=f[C+g]/f[E+g]);
}return 0===$?999:0;
}function G(){
for(g=1;g<=r;g+=1){
for(A=0,b=1;b<=r;b+=1){
A+=e[b][g]*a[b][$];
}f[g]=A;
}for(y=k,g=1;g<=r;g+=1){
f[y+g]=0;
}for(b=d+1;b<=r;b+=1){
for(g=1;g<=r;g+=1){
f[y+g]=f[y+g]+e[g][b]*f[b];
}
}for(L=!0,g=d;g>=1;g-=1){
for(A=f[g],y=(x=S+g*(g+3)/2)-g,b=g+1;b<=d;b+=1){
A-=f[x]*f[I+b],x+=b;
}if(A/=f[y],f[I+g]=A,h[g]<c){
break;
}if(A<0){
break;
}L=!1,v=g;
}if(!L){
for(F=f[N+v]/f[I+v],g=1;g<=d&&!(h[g]<c)&&!(f[I+g]<0);g+=1){
(R=f[N+g]/f[I+g])<F&&(F=R,v=g);
}
}for(A=0,g=k+1;g<=k+r;g+=1){
A+=f[g]*f[g];
}if(Math.abs(A)<=P){
if(L){
return m[1]=1,999;
}for(g=1;g<=d;g+=1){
f[N+g]=f[N+g]-F*f[I+g];
}return f[N+d+1]=f[N+d+1]+F,700;
}for(A=0,g=1;g<=r;g+=1){
A+=f[k+g]*a[g][$];
}for(_=-f[C+$]/A,z=!0,L||F<_&&(_=F,z=!1),g=1;g<=r;g+=1){
s[g]=s[g]+_*f[k+g],Math.abs(s[g])<P&&(s[g]=0);
}for(i[1]=i[1]+_*A*(_/2+f[N+d+1]),g=1;g<=d;g+=1){
f[N+g]=f[N+g]-_*f[I+g];
}if(f[N+d+1]=f[N+d+1]+_,!z){
for(A=-o[$],b=1;b<=r;b+=1){
A+=s[b]*a[b][$];
}if($>c){
f[C+$]=A;
}else if(f[C+$]=-Math.abs(A),A>0){
for(b=1;b<=r;b+=1){
a[b][$]=-a[b][$];
}o[$]=-o[$];
}return 700;
}for(h[d+=1]=$,x=S+(d-1)*d/2+1,g=1;g<=d-1;g+=1){
f[x]=f[g],x+=1;
}if(d===r){
f[x]=f[r];
}else{
for(g=r;g>=d+1&&0!==f[g]&&(D=Math.max(Math.abs(f[g-1]),Math.abs(f[g])),O=Math.min(Math.abs(f[g-1]),Math.abs(f[g])),R=f[g-1]>=0?Math.abs(D*Math.sqrt(1+O*O/(D*D))):-Math.abs(D*Math.sqrt(1+O*O/(D*D))),D=f[g-1]/R,O=f[g]/R,1!==D);g-=1){
if(0===D){
for(f[g-1]=O*R,b=1;b<=r;b+=1){
R=e[b][g-1],e[b][g-1]=e[b][g],e[b][g]=R;
}
}else {
for(f[g-1]=R,M=O/(1+D),b=1;b<=r;b+=1){
R=D*e[b][g-1]+O*e[b][g],e[b][g]=M*(e[b][g-1]+R)-e[b][g],e[b][g-1]=R;
}
}
}f[x]=f[d];
}return 0;
}function j(){
if(0===f[y=(x=S+v*(v+1)/2+1)+v]){
return 798;
}if(D=Math.max(Math.abs(f[y-1]),Math.abs(f[y])),O=Math.min(Math.abs(f[y-1]),Math.abs(f[y])),R=f[y-1]>=0?Math.abs(D*Math.sqrt(1+O*O/(D*D))):-Math.abs(D*Math.sqrt(1+O*O/(D*D))),D=f[y-1]/R,O=f[y]/R,1===D){
return 798;
}if(0===D){
for(g=v+1;g<=d;g+=1){
R=f[y-1],f[y-1]=f[y],f[y]=R,y+=g;
}for(g=1;g<=r;g+=1){
R=e[g][v],e[g][v]=e[g][v+1],e[g][v+1]=R;
}
}else{
for(M=O/(1+D),g=v+1;g<=d;g+=1){
R=D*f[y-1]+O*f[y],f[y]=M*(f[y-1]+R)-f[y],f[y-1]=R,y+=g;
}for(g=1;g<=r;g+=1){
R=D*e[g][v]+O*e[g][v+1],e[g][v+1]=M*(e[g][v]+R)-e[g][v+1],e[g][v]=R;
}
}return 0;
}function H(){
for(y=x-v,g=1;g<=v;g+=1){
f[y]=f[x],x+=1,y+=1;
}return f[N+v]=f[N+v+1],h[v]=h[v+1],(v+=1)<d?797:0;
}function q(){
return f[N+d]=f[N+d+1],f[N+d+1]=0,h[d]=0,d-=1,p[2]=p[2]+1,0;
}for(d=0,p[1]=0,p[2]=0,W=0;;){
if(999===(W=V())){
return;
}for(;0!==(W=G());){
if(999===W){
return;
}if(700===W){
if(v===d){
q();
}else{
for(;j(),797===(W=H());){}q();
}
}
}
}
}(e,r,0,l,m,p,s,i,0,c,a,f,0,b,g,o),d="",1===o[1]&&(d="constraints are inconsistent, no solution!"),2===o[1]&&(d="matrix D in quadratic function is not positive definite!"),{solution:n(m),value:n(p),unconstrained_solution:n(r),iterations:n(b),iact:n(f),message:d};
};
}(numeric),numeric.svd=function(e){
var t,n=numeric.epsilon,r=1e-64/n,s=0,i=0,a=0,o=0,u=0,l=numeric.clone(e),c=l.length,h=l[0].length;if(c<h){
throw"Need more rows than columns";
}var d=new Array(h),p=new Array(h);for(i=0;i<h;i++){
d[i]=p[i]=0;
}var f=numeric.rep([h,h],0);function m(e,t){
return(e=Math.abs(e))>(t=Math.abs(t))?e*Math.sqrt(1+t*t/e/e):0==t?e:t*Math.sqrt(1+e*e/t/t);
}var g=0,b=0,x=0,y=0,w=0,v=0,k=0;for(i=0;i<h;i++){
for(d[i]=b,k=0,u=i+1,a=i;a<c;a++){
k+=l[a][i]*l[a][i];
}if(k<=r){
b=0;
}else {
for(g=l[i][i],b=Math.sqrt(k),g>=0&&(b=-b),x=g*b-k,l[i][i]=g-b,a=u;a<h;a++){
for(k=0,o=i;o<c;o++){
k+=l[o][i]*l[o][a];
}for(g=k/x,o=i;o<c;o++){
l[o][a]+=g*l[o][i];
}
}
}for(p[i]=b,k=0,a=u;a<h;a++){
k+=l[i][a]*l[i][a];
}if(k<=r){
b=0;
}else{
for(g=l[i][i+1],b=Math.sqrt(k),g>=0&&(b=-b),x=g*b-k,l[i][i+1]=g-b,a=u;a<h;a++){
d[a]=l[i][a]/x;
}for(a=u;a<c;a++){
for(k=0,o=u;o<h;o++){
k+=l[a][o]*l[i][o];
}for(o=u;o<h;o++){
l[a][o]+=k*d[o];
}
}
}(w=Math.abs(p[i])+Math.abs(d[i]))>y&&(y=w);
}for(i=h-1;-1!=i;i+=-1){
if(0!=b){
for(x=b*l[i][i+1],a=u;a<h;a++){
f[a][i]=l[i][a]/x;
}for(a=u;a<h;a++){
for(k=0,o=u;o<h;o++){
k+=l[i][o]*f[o][a];
}for(o=u;o<h;o++){
f[o][a]+=k*f[o][i];
}
}
}for(a=u;a<h;a++){
f[i][a]=0,f[a][i]=0;
}f[i][i]=1,b=d[i],u=i;
}for(i=h-1;-1!=i;i+=-1){
for(u=i+1,b=p[i],a=u;a<h;a++){
l[i][a]=0;
}if(0!=b){
for(x=l[i][i]*b,a=u;a<h;a++){
for(k=0,o=u;o<c;o++){
k+=l[o][i]*l[o][a];
}for(g=k/x,o=i;o<c;o++){
l[o][a]+=g*l[o][i];
}
}for(a=i;a<c;a++){
l[a][i]=l[a][i]/b;
}
}else {
for(a=i;a<c;a++){
l[a][i]=0;
}
}l[i][i]+=1;
}for(n*=y,o=h-1;-1!=o;o+=-1){
for(var I=0;I<50;I++){
var S=!1;for(u=o;-1!=u;u+=-1){
if(Math.abs(d[u])<=n){
S=!0;break;
}if(Math.abs(p[u-1])<=n){
break;
}
}if(!S){
s=0,k=1;var C=u-1;for(i=u;i<o+1&&(g=k*d[i],d[i]=s*d[i],!(Math.abs(g)<=n));i++){
for(x=m(g,b=p[i]),p[i]=x,s=b/x,k=-g/x,a=0;a<c;a++){
w=l[a][C],v=l[a][i],l[a][C]=w*s+v*k,l[a][i]=-w*k+v*s;
}
}
}if(v=p[o],u==o){
if(v<0){
for(p[o]=-v,a=0;a<h;a++){
f[a][o]=-f[a][o];
}
}break;
}if(I>=49){
throw"Error: no convergence.";
}for(y=p[u],b=m(g=(((w=p[o-1])-v)*(w+v)+((b=d[o-1])-(x=d[o]))*(b+x))/(2*x*w),1),g=g<0?((y-v)*(y+v)+x*(w/(g-b)-x))/y:((y-v)*(y+v)+x*(w/(g+b)-x))/y,s=1,k=1,i=u+1;i<o+1;i++){
for(b=d[i],w=p[i],x=k*b,b*=s,v=m(g,x),d[i-1]=v,g=y*(s=g/v)+b*(k=x/v),b=-y*k+b*s,x=w*k,w*=s,a=0;a<h;a++){
y=f[a][i-1],v=f[a][i],f[a][i-1]=y*s+v*k,f[a][i]=-y*k+v*s;
}for(v=m(g,x),p[i-1]=v,g=(s=g/v)*b+(k=x/v)*w,y=-k*b+s*w,a=0;a<c;a++){
w=l[a][i-1],v=l[a][i],l[a][i-1]=w*s+v*k,l[a][i]=-w*k+v*s;
}
}d[u]=0,d[o]=g,p[o]=y;
}
}for(i=0;i<p.length;i++){
p[i]<n&&(p[i]=0);
}for(i=0;i<h;i++){
for(a=i-1;a>=0;a--){
if(p[a]<p[i]){
for(s=p[a],p[a]=p[i],p[i]=s,o=0;o<l.length;o++){
t=l[o][i],l[o][i]=l[o][a],l[o][a]=t;
}for(o=0;o<f.length;o++){
t=f[o][i],f[o][i]=f[o][a],f[o][a]=t;
}i=a;
}
}
}return{U:l,S:p,V:f};
};
},313:(e,t,n)=>{
var r=n(421),s=n(824),i=n(244),a=n(330),o=n(28),u=n(929),l=n(154);l.alea=r,l.xor128=s,l.xorwow=i,l.xorshift7=a,l.xor4096=o,l.tychei=u,e.exports=l;
},421:function(e,t,n){
var r;!function(e,s,i){
function a(e){
var t,n=this,r=(t=4022871197,function(e){
e=String(e);for(var n=0;n<e.length;n++){
var r=.02519603282416938*(t+=e.charCodeAt(n));r-=t=r>>>0,t=(r*=t)>>>0,t+=4294967296*(r-=t);
}return 2.3283064365386963e-10*(t>>>0);
});n.next=function(){
var e=2091639*n.s0+2.3283064365386963e-10*n.c;return n.s0=n.s1,n.s1=n.s2,n.s2=e-(n.c=0|e);
},n.c=1,n.s0=r(" "),n.s1=r(" "),n.s2=r(" "),n.s0-=r(e),n.s0<0&&(n.s0+=1),n.s1-=r(e),n.s1<0&&(n.s1+=1),n.s2-=r(e),n.s2<0&&(n.s2+=1),r=null;
}function o(e,t){
return t.c=e.c,t.s0=e.s0,t.s1=e.s1,t.s2=e.s2,t;
}function u(e,t){
var n=new a(e),r=t&&t.state,s=n.next;return s.int32=function(){
return 4294967296*n.next()|0;
},s.double=function(){
return s()+11102230246251565e-32*(2097152*s()|0);
},s.quick=s,r&&("object"==typeof r&&o(r,n),s.state=function(){
return o(n,{});
}),s;
}s&&s.exports?s.exports=u:n.amdD&&n.amdO?void 0===(r=function(){
return u;
}.call(t,n,t,s))||(s.exports=r):this.alea=u;
}(0,e=n.nmd(e),n.amdD);
},929:function(e,t,n){
var r;!function(e,s,i){
function a(e){
var t=this,n="";t.next=function(){
var e=t.b,n=t.c,r=t.d,s=t.a;return e=e<<25^e>>>7^n,n=n-r|0,r=r<<24^r>>>8^s,s=s-e|0,t.b=e=e<<20^e>>>12^n,t.c=n=n-r|0,t.d=r<<16^n>>>16^s,t.a=s-e|0;
},t.a=0,t.b=0,t.c=-1640531527,t.d=1367130551,e===Math.floor(e)?(t.a=e/4294967296|0,t.b=0|e):n+=e;for(var r=0;r<n.length+20;r++){
t.b^=0|n.charCodeAt(r),t.next();
}
}function o(e,t){
return t.a=e.a,t.b=e.b,t.c=e.c,t.d=e.d,t;
}function u(e,t){
var n=new a(e),r=t&&t.state,s=function(){
return(n.next()>>>0)/4294967296;
};return s.double=function(){
do{
var e=((n.next()>>>11)+(n.next()>>>0)/4294967296)/(1<<21);
}while(0===e);return e;
},s.int32=n.next,s.quick=s,r&&("object"==typeof r&&o(r,n),s.state=function(){
return o(n,{});
}),s;
}s&&s.exports?s.exports=u:n.amdD&&n.amdO?void 0===(r=function(){
return u;
}.call(t,n,t,s))||(s.exports=r):this.tychei=u;
}(0,e=n.nmd(e),n.amdD);
},824:function(e,t,n){
var r;!function(e,s,i){
function a(e){
var t=this,n="";t.x=0,t.y=0,t.z=0,t.w=0,t.next=function(){
var e=t.x^t.x<<11;return t.x=t.y,t.y=t.z,t.z=t.w,t.w^=t.w>>>19^e^e>>>8;
},e===(0|e)?t.x=e:n+=e;for(var r=0;r<n.length+64;r++){
t.x^=0|n.charCodeAt(r),t.next();
}
}function o(e,t){
return t.x=e.x,t.y=e.y,t.z=e.z,t.w=e.w,t;
}function u(e,t){
var n=new a(e),r=t&&t.state,s=function(){
return(n.next()>>>0)/4294967296;
};return s.double=function(){
do{
var e=((n.next()>>>11)+(n.next()>>>0)/4294967296)/(1<<21);
}while(0===e);return e;
},s.int32=n.next,s.quick=s,r&&("object"==typeof r&&o(r,n),s.state=function(){
return o(n,{});
}),s;
}s&&s.exports?s.exports=u:n.amdD&&n.amdO?void 0===(r=function(){
return u;
}.call(t,n,t,s))||(s.exports=r):this.xor128=u;
}(0,e=n.nmd(e),n.amdD);
},28:function(e,t,n){
var r;!function(e,s,i){
function a(e){
var t=this;t.next=function(){
var e,n,r=t.w,s=t.X,i=t.i;return t.w=r=r+1640531527|0,n=s[i+34&127],e=s[i=i+1&127],n^=n<<13,e^=e<<17,n^=n>>>15,e^=e>>>12,n=s[i]=n^e,t.i=i,n+(r^r>>>16)|0;
},function(e,t){
var n,r,s,i,a,o=[],u=128;for(t===(0|t)?(r=t,t=null):(t+="\0",r=0,u=Math.max(u,t.length)),s=0,i=-32;i<u;++i){
t&&(r^=t.charCodeAt((i+32)%t.length)),0===i&&(a=r),r^=r<<10,r^=r>>>15,r^=r<<4,r^=r>>>13,i>=0&&(a=a+1640531527|0,s=0==(n=o[127&i]^=r+a)?s+1:0);
}for(s>=128&&(o[127&(t&&t.length||0)]=-1),s=127,i=512;i>0;--i){
r=o[s+34&127],n=o[s=s+1&127],r^=r<<13,n^=n<<17,r^=r>>>15,n^=n>>>12,o[s]=r^n;
}e.w=a,e.X=o,e.i=s;
}(t,e);
}function o(e,t){
return t.i=e.i,t.w=e.w,t.X=e.X.slice(),t;
}function u(e,t){
null==e&&(e=+new Date);var n=new a(e),r=t&&t.state,s=function(){
return(n.next()>>>0)/4294967296;
};return s.double=function(){
do{
var e=((n.next()>>>11)+(n.next()>>>0)/4294967296)/(1<<21);
}while(0===e);return e;
},s.int32=n.next,s.quick=s,r&&(r.X&&o(r,n),s.state=function(){
return o(n,{});
}),s;
}s&&s.exports?s.exports=u:n.amdD&&n.amdO?void 0===(r=function(){
return u;
}.call(t,n,t,s))||(s.exports=r):this.xor4096=u;
}(0,e=n.nmd(e),n.amdD);
},330:function(e,t,n){
var r;!function(e,s,i){
function a(e){
var t=this;t.next=function(){
var e,n,r=t.x,s=t.i;return e=r[s],n=(e^=e>>>7)^e<<24,n^=(e=r[s+1&7])^e>>>10,n^=(e=r[s+3&7])^e>>>3,n^=(e=r[s+4&7])^e<<7,e=r[s+7&7],n^=(e^=e<<13)^e<<9,r[s]=n,t.i=s+1&7,n;
},function(e,t){
var n,r=[];if(t===(0|t)){
r[0]=t;
}else {
for(t=""+t,n=0;n<t.length;++n){
r[7&n]=r[7&n]<<15^t.charCodeAt(n)+r[n+1&7]<<13;
}
}for(;r.length<8;){
r.push(0);
}for(n=0;n<8&&0===r[n];++n){}for(8==n?r[7]=-1:r[n],e.x=r,e.i=0,n=256;n>0;--n){
e.next();
}
}(t,e);
}function o(e,t){
return t.x=e.x.slice(),t.i=e.i,t;
}function u(e,t){
null==e&&(e=+new Date);var n=new a(e),r=t&&t.state,s=function(){
return(n.next()>>>0)/4294967296;
};return s.double=function(){
do{
var e=((n.next()>>>11)+(n.next()>>>0)/4294967296)/(1<<21);
}while(0===e);return e;
},s.int32=n.next,s.quick=s,r&&(r.x&&o(r,n),s.state=function(){
return o(n,{});
}),s;
}s&&s.exports?s.exports=u:n.amdD&&n.amdO?void 0===(r=function(){
return u;
}.call(t,n,t,s))||(s.exports=r):this.xorshift7=u;
}(0,e=n.nmd(e),n.amdD);
},244:function(e,t,n){
var r;!function(e,s,i){
function a(e){
var t=this,n="";t.next=function(){
var e=t.x^t.x>>>2;return t.x=t.y,t.y=t.z,t.z=t.w,t.w=t.v,(t.d=t.d+362437|0)+(t.v=t.v^t.v<<4^e^e<<1)|0;
},t.x=0,t.y=0,t.z=0,t.w=0,t.v=0,e===(0|e)?t.x=e:n+=e;for(var r=0;r<n.length+64;r++){
t.x^=0|n.charCodeAt(r),r==n.length&&(t.d=t.x<<10^t.x>>>4),t.next();
}
}function o(e,t){
return t.x=e.x,t.y=e.y,t.z=e.z,t.w=e.w,t.v=e.v,t.d=e.d,t;
}function u(e,t){
var n=new a(e),r=t&&t.state,s=function(){
return(n.next()>>>0)/4294967296;
};return s.double=function(){
do{
var e=((n.next()>>>11)+(n.next()>>>0)/4294967296)/(1<<21);
}while(0===e);return e;
},s.int32=n.next,s.quick=s,r&&("object"==typeof r&&o(r,n),s.state=function(){
return o(n,{});
}),s;
}s&&s.exports?s.exports=u:n.amdD&&n.amdO?void 0===(r=function(){
return u;
}.call(t,n,t,s))||(s.exports=r):this.xorwow=u;
}(0,e=n.nmd(e),n.amdD);
},154:function(e,t,n){
var r;!function(s,i,a){
var o,u=256,l=a.pow(u,6),c=a.pow(2,52),h=2*c,d=u-1;function p(e,t,n){
var r=[],d=b(g((t=1==t?{entropy:!0}:t||{}).entropy?[e,x(i)]:null==e?function(){
try{
var e;return o&&(e=o.randomBytes)?e=e(u):(e=new Uint8Array(u),(s.crypto||s.msCrypto).getRandomValues(e)),x(e);
}catch(e){
var t=s.navigator,n=t&&t.plugins;return[+new Date,s,n,s.screen,x(i)];
}
}():e,3),r),p=new f(r),y=function(){
for(var e=p.g(6),t=l,n=0;e<c;){
e=(e+n)*u,t*=u,n=p.g(1);
}for(;e>=h;){
e/=2,t/=2,n>>>=1;
}return(e+n)/t;
};return y.int32=function(){
return 0|p.g(4);
},y.quick=function(){
return p.g(4)/4294967296;
},y.double=y,b(x(p.S),i),(t.pass||n||function(e,t,n,r){
return r&&(r.S&&m(r,p),e.state=function(){
return m(p,{});
}),n?(a.random=e,t):e;
})(y,d,"global"in t?t.global:this==a,t.state);
}function f(e){
var t,n=e.length,r=this,s=0,i=r.i=r.j=0,a=r.S=[];for(n||(e=[n++]);s<u;){
a[s]=s++;
}for(s=0;s<u;s++){
a[s]=a[i=d&i+e[s%n]+(t=a[s])],a[i]=t;
}(r.g=function(e){
for(var t,n=0,s=r.i,i=r.j,a=r.S;e--;){
t=a[s=d&s+1],n=n*u+a[d&(a[s]=a[i=d&i+t])+(a[i]=t)];
}return r.i=s,r.j=i,n;
})(u);
}function m(e,t){
return t.i=e.i,t.j=e.j,t.S=e.S.slice(),t;
}function g(e,t){
var n,r=[],s=typeof e;if(t&&"object"==s){
for(n in e){
try{
r.push(g(e[n],t-1));
}catch(e){}
}
}return r.length?r:"string"==s?e:e+"\0";
}function b(e,t){
for(var n,r=e+"",s=0;s<r.length;){
t[d&s]=d&(n^=19*t[d&s])+r.charCodeAt(s++);
}return x(t);
}function x(e){
return String.fromCharCode.apply(0,e);
}if(b(a.random(),i),e.exports){
e.exports=p;try{
o=n(660);
}catch(e){}
}else {
void 0===(r=function(){
return p;
}.call(t,n,t,e))||(e.exports=r);
}
}("undefined"!=typeof self?self:this,[],Math);
},327:()=>{},843:()=>{},796:()=>{},451:()=>{},182:()=>{},660:()=>{}},__webpack_module_cache__={};function __webpack_require__(e){
var t=__webpack_module_cache__[e];if(void 0!==t){
return t.exports;
}var n=__webpack_module_cache__[e]={id:e,loaded:!1,exports:{}};return __webpack_modules__[e].call(n.exports,n,n.exports,__webpack_require__),n.loaded=!0,n.exports;
}__webpack_require__.amdD=function(){
throw new Error("define cannot be used indirect");
},__webpack_require__.amdO={},__webpack_require__.n=e=>{
var t=e&&e.__esModule?()=>e.default:()=>e;return __webpack_require__.d(t,{a:t}),t;
},__webpack_require__.d=(e,t)=>{
for(var n in t){
__webpack_require__.o(t,n)&&!__webpack_require__.o(e,n)&&Object.defineProperty(e,n,{enumerable:!0,get:t[n]});
}
},__webpack_require__.g=function(){
if("object"==typeof globalThis){
return globalThis;
}try{
return this||new Function("return this")();
}catch(e){
if("object"==typeof window){
return window;
}
}
}(),__webpack_require__.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),__webpack_require__.r=e=>{
"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0});
},__webpack_require__.nmd=e=>(e.paths=[],e.children||(e.children=[]),e);var __webpack_exports__={};(()=>{
"use strict";var e={};__webpack_require__.r(e),__webpack_require__.d(e,{assertParamsValid:()=>ua,computeFlatOffset:()=>va,computeOutShape:()=>ca,getNormalizedAxes:()=>fa,isSliceContinous:()=>wa,maskToAxes:()=>la,parseSliceParams:()=>ka,sliceInfo:()=>Ia,startForAxis:()=>xa,startIndicesWithElidedDims:()=>ma,stopForAxis:()=>ya,stopIndicesWithElidedDims:()=>ga,stridesForAxis:()=>ba,stridesWithElidedDims:()=>ha});var t={};__webpack_require__.r(t),__webpack_require__.d(t,{collectGatherOpShapeInfo:()=>zc,computeOutShape:()=>Lc,segOpComputeOptimalWindowSize:()=>Mc});var n={};__webpack_require__.r(n),__webpack_require__.d(n,{ERF_A1:()=>ec,ERF_A2:()=>tc,ERF_A3:()=>nc,ERF_A4:()=>rc,ERF_A5:()=>sc,ERF_P:()=>Ql,PARALLELIZE_THRESHOLD:()=>Pl,RowPartitionType:()=>Dl,SELU_SCALE:()=>Jl,SELU_SCALEALPHA:()=>Zl,applyActivation:()=>zu,assertAndGetBroadcastShape:()=>Hi,assertAxesAreInnerMostDims:()=>Bo,assertParamsConsistent:()=>Fl,assignToTypedArray:()=>cc,axesAreInnerMostDims:()=>Mo,calculateShapes:()=>Yl,checkEinsumDimSizes:()=>yc,checkPadOnDimRoundingMode:()=>Wa,combineLocations:()=>Lo,combineRaggedTensorToTensorShapes:()=>Ol,complexWithEvenIndex:()=>oc,complexWithOddIndex:()=>uc,computeConv2DInfo:()=>Aa,computeConv3DInfo:()=>Fa,computeDefaultPad:()=>_a,computeDilation2DInfo:()=>Ta,computeOptimalWindowSize:()=>Bl,computeOutAndReduceShapes:()=>zo,computeOutShape:()=>_l,computePool2DInfo:()=>Ea,computePool3DInfo:()=>Ra,convertConv2DDataFormat:()=>Ua,decodeEinsumEquation:()=>bc,eitherStridesOrDilationsAreOne:()=>Pa,expandShapeToKeepDim:()=>Po,exponent:()=>dc,exponents:()=>hc,fromStringArrayToUint8:()=>Bc,fromUint8ToStringArray:()=>Pc,getAxesPermutation:()=>Uo,getBroadcastDims:()=>Gi,getComplexWithIndex:()=>lc,getEinsumComputePath:()=>wc,getEinsumPermutation:()=>xc,getFusedBiasGradient:()=>Lu,getFusedDyActivation:()=>Mu,getImageCenter:()=>Ul,getInnerMostAxes:()=>Vo,getPermuted:()=>Vl,getRaggedRank:()=>Ll,getReductionAxes:()=>ji,getReshaped:()=>Wl,getReshapedPermuted:()=>Gl,getRowPartitionTypesHelper:()=>Ml,getSliceBeginCoords:()=>jl,getSliceSize:()=>Hl,getSparseFillEmptyRowsIndicesDenseShapeMismatch:()=>Sc,getSparseFillEmptyRowsNegativeIndexErrorMessage:()=>Cc,getSparseFillEmptyRowsOutOfRangeIndexErrorMessage:()=>Nc,getSparseReshapeEmptyTensorZeroOutputDimErrorMessage:()=>Ec,getSparseReshapeInputOutputMismatchErrorMessage:()=>Ac,getSparseReshapeInputOutputMultipleErrorMessage:()=>Rc,getSparseReshapeMultipleNegativeOneOutputDimErrorMessage:()=>$c,getSparseReshapeNegativeOutputDimErrorMessage:()=>Tc,getSparseSegmentReductionIndicesOutOfRangeErrorMessage:()=>Oc,getSparseSegmentReductionNegativeSegmentIdsErrorMessage:()=>Fc,getSparseSegmentReductionNonIncreasingSegmentIdsErrorMessage:()=>_c,getSparseSegmentReductionSegmentIdOutOfRangeErrorMessage:()=>Dc,getUndoAxesPermutation:()=>Wo,isIdentityPermutation:()=>vc,log:()=>ur,mergeRealAndImagArrays:()=>ic,prepareAndValidate:()=>ql,prepareSplitSize:()=>Ic,segment_util:()=>t,shouldFuse:()=>Pu,slice_util:()=>e,splitRealAndImagArrays:()=>ac,stridesOrDilationsArePositive:()=>Ba,tupleValuesAreOne:()=>za,upcastType:()=>ls,validateDefaultValueShape:()=>zl,validateInput:()=>Xl,validateUpdateShape:()=>Kl,warn:()=>or});var r={};__webpack_require__.r(r),__webpack_require__.d(r,{addImpl:()=>pw,bincountImpl:()=>iv,bincountReduceImpl:()=>av,bitwiseAndImpl:()=>uv,castImpl:()=>uw,ceilImpl:()=>hv,concatImpl:()=>bv,equalImpl:()=>tk,expImpl:()=>dk,expm1Impl:()=>bk,floorImpl:()=>Dk,gatherNdImpl:()=>Wk,gatherV2Impl:()=>Gk,greaterEqualImpl:()=>Xk,greaterImpl:()=>Hk,lessEqualImpl:()=>uI,lessImpl:()=>iI,linSpaceImpl:()=>hI,logImpl:()=>pI,maxImpl:()=>TI,maximumImpl:()=>AI,minimumImpl:()=>UI,multiplyImpl:()=>qv,negImpl:()=>ZI,notEqualImpl:()=>iS,prodImpl:()=>xS,raggedGatherImpl:()=>vS,raggedRangeImpl:()=>SS,raggedTensorToTensorImpl:()=>RS,rangeImpl:()=>FS,rsqrtImpl:()=>GS,scatterImpl:()=>qS,sigmoidImpl:()=>Qy,simpleAbsImpl:()=>kw,sliceImpl:()=>tv,sparseFillEmptyRowsImpl:()=>pC,sparseReshapeImpl:()=>mC,sparseSegmentReductionImpl:()=>bC,sqrtImpl:()=>kC,staticRegexReplaceImpl:()=>EC,stridedSliceImpl:()=>_C,stringNGramsImpl:()=>MC,stringSplitImpl:()=>PC,stringToHashBucketFastImpl:()=>UC,subImpl:()=>Ik,tileImpl:()=>HC,topKImpl:()=>XC,transposeImpl:()=>Ew,uniqueImpl:()=>tN});var s=__webpack_require__(515);class i{
constructor(e,t){
this.backend=e,this.dataMover=t,this.data=new WeakMap,this.dataIdsCount=0;
}get(e){
return this.data.has(e)||this.dataMover.moveData(this.backend,e),this.data.get(e);
}set(e,t){
this.dataIdsCount++,this.data.set(e,t);
}has(e){
return this.data.has(e);
}delete(e){
return this.dataIdsCount--,this.data.delete(e);
}numDataIds(){
return this.dataIdsCount;
}
}class a{
refCount(e){
return o("refCount");
}incRef(e){
return o("incRef");
}timerAvailable(){
return!0;
}time(e){
return o("time");
}read(e){
return o("read");
}readSync(e){
return o("readSync");
}readToGPU(e,t){
return o("readToGPU");
}numDataIds(){
return o("numDataIds");
}disposeData(e,t){
return o("disposeData");
}write(e,t,n){
return o("write");
}move(e,t,n,r,s){
return o("move");
}createTensorFromGPUData(e,t,n){
return o("createTensorFromGPUData");
}memory(){
return o("memory");
}floatPrecision(){
return o("floatPrecision");
}epsilon(){
return 32===this.floatPrecision()?1e-7:1e-4;
}dispose(){
return o("dispose");
}
}function o(e){
throw new Error(`'${e}' not yet implemented or not found in the registry. This kernel may not be supported by the tfjs backend you have chosen`);
}function u(e){
let t=e.length,n=0;for(;t>0;){
n=Math.random()*t|0,t--,h(e,t,n);
}
}function l(e,t,n){
return Math.max(e,Math.min(t,n));
}function c(e){
return e%2==0?e:e+1;
}function h(e,t,n){
const r=e[t];e[t]=e[n],e[n]=r;
}function d(e,t){
if(!e){
throw new Error("string"==typeof t?t:t());
}
}function p(e,t,n=""){
d(g(e,t),(()=>n+` Shapes ${e} and ${t} must match`));
}function f(e){
d(null!=e,(()=>"The input to the tensor constructor must be a non-null value."));
}function m(e){
if(0===e.length){
return 1;
}let t=e[0];for(let n=1;n<e.length;n++){
t*=e[n];
}return t;
}function g(e,t){
if(e===t){
return!0;
}if(null==e||null==t){
return!1;
}if(e.length!==t.length){
return!1;
}for(let n=0;n<e.length;n++){
if(e[n]!==t[n]){
return!1;
}
}return!0;
}function b(e){
return e%1==0;
}function x(e){
const t=Math.ceil(Math.sqrt(e));return[t,Math.ceil(e/t)];
}function y(e,t){
return t<=e.length?e:e+" ".repeat(t-e.length);
}function w(e,t=(e=>0),n,r){
return new Promise(((s,i)=>{
let a=0;const o=()=>{
if(e()){
return void s();
}a++;const u=t(a);null!=n&&a>=n?i():null!=r?r(o,u):setTimeout(o,u);
};o();
}));
}function v(e,t){
let n=1,r=-1;for(let t=0;t<e.length;++t){
if(e[t]>=0){
n*=e[t];
}else if(-1===e[t]){
if(-1!==r){
throw Error(`Shapes can only have 1 implicit size. Found -1 at dim ${r} and dim ${t}`);
}r=t;
}else if(e[t]<0){
throw Error(`Shapes can not be < 0. Found ${e[t]} at dim ${t}`);
}
}if(-1===r){
if(t>0&&t!==n){
throw Error(`Size(${t}) must match the product of shape ${e}`);
}return e;
}if(0===n){
throw Error(`Cannot infer the missing size in [${e}] when there are 0 elements`);
}if(t%n!=0){
throw Error(`The implicit shape can't be a fractional number. Got ${t} / ${n}`);
}const s=e.slice();return s[r]=t/n,s;
}function k(e,t){
const n=t.length;return d((e=null==e?t.map(((e,t)=>t)):[].concat(e)).every((e=>e>=-n&&e<n)),(()=>`All values in axis param must be in range [-${n}, ${n}) but got axis ${e}`)),d(e.every((e=>b(e))),(()=>`All values in axis param must be integers but got axis ${e}`)),e.map((e=>e<0?n+e:e));
}function I(e,t){
const n=[],r=[],s=null!=t&&Array.isArray(t)&&0===t.length,i=null==t||s?null:k(t,e).sort();let a=0;for(let t=0;t<e.length;++t){
if(null!=i){
if(i[a]===t&&1!==e[t]){
throw new Error(`Can't squeeze axis ${t} since its dim '${e[t]}' is not 1`);
}(null==i[a]||i[a]>t)&&1===e[t]&&(n.push(e[t]),r.push(t)),i[a]<=t&&a++;
}1!==e[t]&&(n.push(e[t]),r.push(t));
}return{newShape:n,keptDims:r};
}function S(e,t){
return C(e,t);
}function C(e,t){
let n=null;if(null==e||"float32"===e){
n=new Float32Array(t);
}else if("int32"===e){
n=new Int32Array(t);
}else if("bool"===e){
n=new Uint8Array(t);
}else{
if("string"!==e){
throw new Error(`Unknown data type ${e}`);
}n=new Array(t);
}return n;
}function N(e,t){
return!("complex64"===t||"float32"===t&&"complex64"!==e||"int32"===t&&"float32"!==e&&"complex64"!==e||"bool"===t&&"bool"===e);
}function $(e){
if("float32"===e||"int32"===e){
return 4;
}if("complex64"===e){
return 8;
}if("bool"===e){
return 1;
}throw new Error(`Unknown dtype ${e}`);
}function T(e){
return"string"==typeof e||e instanceof String;
}function E(e){
return"number"==typeof e;
}function R(e){
return Array.isArray(e)?R(e[0]):e instanceof Float32Array?"float32":e instanceof Int32Array||e instanceof Uint8Array||e instanceof Uint8ClampedArray?"int32":E(e)?"float32":T(e)?"string":"boolean"==typeof e?"bool":"float32";
}function A(e){
return!!(e&&e.constructor&&e.call&&e.apply);
}function F(e,t){
for(let n=t;n<e;++n){
if(e%n==0){
return n;
}
}return e;
}function _(e){
const t=e.length;if(t<2){
return[];
}const n=new Array(t-1);n[t-2]=e[t-1];for(let r=t-3;r>=0;--r){
n[r]=n[r+1]*e[r+1];
}return n;
}function D(e,t,n,r=!1){
const s=[];if(1===t.length){
const i=t[0]*(r?2:1);for(let t=0;t<i;t++){
s[t]=n[e+t];
}
}else{
const i=t[0],a=t.slice(1),o=a.reduce(((e,t)=>e*t))*(r?2:1);for(let t=0;t<i;t++){
s[t]=D(e+t*o,a,n,r);
}
}return s;
}function O(e,t,n=!1){
if(0===e.length){
return t[0];
}const r=e.reduce(((e,t)=>e*t))*(n?2:1);if(0===r){
return[];
}if(r!==t.length){
throw new Error(`[${e}] does not match the input size ${t.length}${n?" for a complex tensor":""}.`);
}return D(0,e,t,n);
}function M(e,t){
const n=L(e,t);for(let e=0;e<n.length;e++){
n[e]=1;
}return n;
}function L(e,t){
if(null==t||"float32"===t||"complex64"===t){
return new Float32Array(e);
}if("int32"===t){
return new Int32Array(e);
}if("bool"===t){
return new Uint8Array(e);
}throw new Error(`Unknown data type ${t}`);
}function z(e,t){
const n=e.reduce(((e,t)=>e*t),1);if(null==t||"float32"===t){
return O(e,new Float32Array(n));
}if("int32"===t){
return O(e,new Int32Array(n));
}if("bool"===t){
return O(e,new Uint8Array(n));
}throw new Error(`Unknown data type ${t}`);
}function P(e){
e.forEach((t=>{
d(Number.isInteger(t)&&t>=0,(()=>`Tensor must have a shape comprised of positive integers but got shape [${e}].`));
}));
}function B(e,t,n){
if(0===t){
return 0;
}if(1===t){
return e[0];
}let r=e[e.length-1];for(let t=0;t<e.length-1;++t){
r+=n[t]*e[t];
}return r;
}function U(e,t,n){
if(0===t){
return[];
}if(1===t){
return[e];
}const r=new Array(t);for(let t=0;t<r.length-1;++t){
r[t]=Math.floor(e/n[t]),e-=r[t]*n[t];
}return r[r.length-1]=e,r;
}function W(e){
return e&&e.then&&"function"==typeof e.then;
}const V="tfjsflags";class G{
constructor(e){
this.global=e,this.flags={},this.flagRegistry={},this.urlFlags={},this.getQueryParams=j,this.populateURLFlags();
}setPlatform(e,t){
null!=this.platform&&(H().getBool("IS_TEST")||H().getBool("PROD")||console.warn(`Platform ${this.platformName} has already been set. Overwriting the platform with ${e}.`)),this.platformName=e,this.platform=t;
}registerFlag(e,t,n){
if(this.flagRegistry[e]={evaluationFn:t,setHook:n},null!=this.urlFlags[e]){
const t=this.urlFlags[e];H().getBool("IS_TEST")||H().getBool("PROD")||console.warn(`Setting feature override from URL ${e}: ${t}.`),this.set(e,t);
}
}async getAsync(e){
return e in this.flags||(this.flags[e]=await this.evaluateFlag(e)),this.flags[e];
}get(e){
if(e in this.flags){
return this.flags[e];
}const t=this.evaluateFlag(e);if(W(t)){
throw new Error(`Flag ${e} cannot be synchronously evaluated. Please use getAsync() instead.`);
}return this.flags[e]=t,this.flags[e];
}getNumber(e){
return this.get(e);
}getBool(e){
return this.get(e);
}getString(e){
return this.get(e);
}getFlags(){
return this.flags;
}get features(){
return this.flags;
}set(e,t){
if(null==this.flagRegistry[e]){
throw new Error(`Cannot set flag ${e} as it has not been registered.`);
}this.flags[e]=t,null!=this.flagRegistry[e].setHook&&this.flagRegistry[e].setHook(t);
}evaluateFlag(e){
if(null==this.flagRegistry[e]){
throw new Error(`Cannot evaluate flag '${e}': no evaluation function found.`);
}return this.flagRegistry[e].evaluationFn();
}setFlags(e){
this.flags=Object.assign({},e);
}reset(){
this.flags={},this.urlFlags={},this.populateURLFlags();
}populateURLFlags(){
if(void 0===this.global||void 0===this.global.location||void 0===this.global.location.search){
return;
}const e=this.getQueryParams(this.global.location.search);V in e&&e[V].split(",").forEach((e=>{
const[t,n]=e.split(":");this.urlFlags[t]=function(e,t){
const n=t.toLowerCase();return"true"===n||"false"===n?"true"===n:""+ +n===n?+n:t;
}(0,n);
}));
}
}function j(e){
const t={};return e.replace(/[?&]([^=?&]+)(?:=([^&]*))?/g,((e,...n)=>(function(e,t,n){
e[decodeURIComponent(t)]=decodeURIComponent(n||"");
}(t,n[0],n[1]),n.join("=")))),t;
}function H(){
return K;
}let q,K=null;function X(){
if(null==q){
let e;if("undefined"!=typeof window){
e=window;
}else if(void 0!==__webpack_require__.g){
e=__webpack_require__.g;
}else if("undefined"!=typeof process){
e=process;
}else{
if("undefined"==typeof self){
throw new Error("Could not find a global object");
}e=self;
}q=e;
}return q;
}function Y(e,t){
const n=function(){
const e=X();return null==e._tfGlobals&&(e._tfGlobals=new Map),e._tfGlobals;
}();if(n.has(e)){
return n.get(e);
}{const r=t();return n.set(e,r),n.get(e);}
}const Z="Abs",J="Acos",Q="Acosh",ee="Add",te="AddN",ne="All",re="Any",se="ArgMax",ie="ArgMin",ae="Asin",oe="Asinh",ue="Atan",le="Atanh",ce="Atan2",he="AvgPool",de="AvgPoolGrad",pe="AvgPool3D",fe="AvgPool3DGrad",me="BatchMatMul",ge="BatchToSpaceND",be="Bincount",xe="BitwiseAnd",ye="BroadcastArgs",we="Cast",ve="Ceil",ke="ClipByValue",Ie="Complex",Se="ComplexAbs",Ce="Concat",Ne="Conv2D",$e="Conv2DBackpropFilter",Te="Conv2DBackpropInput",Ee="Conv3D",Re="Conv3DBackpropFilterV2",Ae="Conv3DBackpropInputV2",Fe="Cos",_e="Cosh",De="Cumprod",Oe="Cumsum",Me="CropAndResize",Le="DenseBincount",ze="DepthToSpace",Pe="DepthwiseConv2dNative",Be="DepthwiseConv2dNativeBackpropFilter",Ue="DepthwiseConv2dNativeBackpropInput",We="Diag",Ve="Dilation2D",Ge="Dilation2DBackpropInput",je="Dilation2DBackpropFilter",He="RealDiv",qe="Einsum",Ke="Elu",Xe="EluGrad",Ye="Erf",Ze="Equal",Je="Exp",Qe="ExpandDims",et="Expm1",tt="FFT",nt="Fill",rt="FlipLeftRight",st="Floor",it="FloorDiv",at="FusedBatchNorm",ot="GatherV2",ut="GatherNd",lt="Greater",ct="GreaterEqual",ht="Identity",dt="IFFT",pt="Imag",ft="IsFinite",mt="IsInf",gt="IsNan",bt="LeakyRelu",xt="Less",yt="LessEqual",wt="LinSpace",vt="Log",kt="Log1p",It="LogicalAnd",St="LogicalNot",Ct="LogicalOr",Nt="LRN",$t="LRNGrad",Tt="Max",Et="Maximum",Rt="MaxPool",At="MaxPoolGrad",Ft="MaxPool3D",_t="MaxPool3DGrad",Dt="MaxPoolWithArgmax",Ot="Mean",Mt="Min",Lt="Minimum",zt="MirrorPad",Pt="Mod",Bt="Multinomial",Ut="Multiply",Wt="Neg",Vt="NotEqual",Gt="NonMaxSuppressionV3",jt="NonMaxSuppressionV4",Ht="NonMaxSuppressionV5",qt="OnesLike",Kt="OneHot",Xt="Pack",Yt="PadV2",Zt="Pow",Jt="Prelu",Qt="Prod",en="RaggedGather",tn="RaggedRange",nn="RaggedTensorToTensor",rn="Range",sn="Real",an="Reciprocal",on="Relu",un="Reshape",ln="ResizeNearestNeighbor",cn="ResizeNearestNeighborGrad",hn="ResizeBilinear",dn="ResizeBilinearGrad",pn="Relu6",fn="Reverse",mn="Round",gn="Rsqrt",bn="ScatterNd",xn="TensorScatterUpdate",yn="SearchSorted",wn="Select",vn="Selu",kn="Slice",In="Sin",Sn="Sinh",Cn="Sign",Nn="Sigmoid",$n="Softplus",Tn="Sqrt",En="Sum",Rn="SpaceToBatchND",An="SplitV",Fn="Softmax",_n="SparseFillEmptyRows",Dn="SparseReshape",On="SparseSegmentMean",Mn="SparseSegmentSum",Ln="SparseToDense",zn="SquaredDifference",Pn="Square",Bn="StaticRegexReplace",Un="StridedSlice",Wn="StringNGrams",Vn="StringSplit",Gn="StringToHashBucketFast",jn="Sub",Hn="Tan",qn="Tanh",Kn="Tile",Xn="TopK",Yn="Transform",Zn="Transpose",Jn="Unique",Qn="Unpack",er="UnsortedSegmentSum",tr="ZerosLike",nr="Step",rr="RotateWithOffset",sr="_FusedMatMul",ir="FusedConv2D",ar="FusedDepthwiseConv2D";function or(...e){
H().getBool("IS_TEST")||H().getBool("PROD")||console.warn(...e);
}function ur(...e){
H().getBool("IS_TEST")||H().getBool("PROD")||console.log(...e);
}const lr=Y("kernelRegistry",(()=>new Map)),cr=Y("gradRegistry",(()=>new Map));function hr(e,t){
const n=gr(e,t);return lr.get(n);
}function dr(e){
return cr.get(e);
}function pr(e){
const t=lr.entries(),n=[];for(;;){
const{done:r,value:s}=t.next();if(r){
break;
}const[i,a]=s,[o]=i.split("_");o===e&&n.push(a);
}return n;
}function fr(e){
const{kernelName:t,backendName:n}=e,r=gr(t,n);lr.has(r)&&or(`The kernel '${t}' for backend '${n}' is already registered`),lr.set(r,e);
}function mr(e){
const{kernelName:t}=e;cr.has(t)&&H().getBool("DEBUG")&&or(`Overriding the gradient for '${t}'`),cr.set(t,e);
}function gr(e,t){
return`${t}_${e}`;
}function br(e){
return e instanceof Float32Array||e instanceof Int32Array||e instanceof Uint8Array||e instanceof Uint8ClampedArray;
}var xr=__webpack_require__(808);const yr=__webpack_require__.n(xr)()||xr;function wr(e){
return yr.fromString(e,!0,16);
}const vr=wr("c3a5c85c97cb3127"),kr=wr("b492b66fbe98f273"),Ir=wr("9ae16a3b2f90404f");function Sr(e){
return e.xor(e.shru(47));
}function Cr(e,t,n){
const r=e.slice(t,t+n);return yr.fromBytes(Array.from(r),!0,!0);
}function Nr(e,t){
return Cr(e,t,8);
}function $r(e,t){
return Cr(e,t,4);
}function Tr(e,t){
return 0===t?e:e.shru(t).or(e.shl(64-t));
}function Er(e,t,n=wr("9ddfea08eb382d69")){
let r=e.xor(t).mul(n);r=r.xor(r.shru(47));let s=t.xor(r).mul(n);return s=s.xor(s.shru(47)),s=s.mul(n),s;
}function Rr(e,t,n,r){
return function(e,t,n,r,s,i){
s=s.add(e),i=Tr(i.add(s).add(r),21);const a=s;return s=(s=s.add(t)).add(n),i=i.add(Tr(s,44)),[s.add(r),i.add(a)];
}(Nr(e,t),Nr(e,t+8),Nr(e,t+16),Nr(e,t+24),n,r);
}function Ar(e,t=e.length){
const n=yr.fromNumber(81,!0);if(t<=32){
return t<=16?function(e,t=e.length){
if(t>=8){
const n=Ir.add(2*t),r=Nr(e,0).add(Ir),s=Nr(e,t-8);return Er(Tr(s,37).mul(n).add(r),Tr(r,25).add(s).mul(n),n);
}if(t>=4){
const n=Ir.add(2*t);return Er($r(e,0).shl(3).add(t),$r(e,t-4),n);
}if(t>0){
const n=e[0]+(e[t>>1]<<8),r=t+(e[t-1]<<2);return Sr(Ir.mul(n).xor(vr.mul(r))).mul(Ir);
}return Ir;
}(e,t):function(e,t=e.length){
const n=Ir.add(2*t),r=Nr(e,0).mul(kr),s=Nr(e,8),i=Nr(e,t-8).mul(n),a=Nr(e,t-16).mul(Ir);return Er(Tr(r.add(s),43).add(Tr(i,30)).add(a),r.add(Tr(s.add(Ir),18)).add(i),n);
}(e,t);
}if(t<=64){
return function(e,t=e.length){
const n=Ir.add(2*t),r=Nr(e,0).mul(Ir),s=Nr(e,8),i=Nr(e,t-8).mul(n),a=Nr(e,t-16).mul(Ir),o=Tr(r.add(s),43).add(Tr(i,30)).add(a),u=Er(o,r.add(Tr(s.add(Ir),18)).add(i),n),l=Nr(e,16).mul(n),c=Nr(e,24),h=o.add(Nr(e,t-32)).mul(n),d=u.add(Nr(e,t-24)).mul(n);return Er(Tr(l.add(c),43).add(Tr(h,30)).add(d),l.add(Tr(c.add(r),18)).add(h),n);
}(e,t);
}let r=n,s=n.mul(kr).add(113),i=Sr(s.mul(Ir).add(113)).mul(Ir),a=[yr.UZERO,yr.UZERO],o=[yr.UZERO,yr.UZERO];r=r.mul(Ir).add(Nr(e,0));let u=0;const l=64*(t-1>>6),c=l+(t-1&63)-63;do{
r=Tr(r.add(s).add(a[0]).add(Nr(e,u+8)),37).mul(kr),s=Tr(s.add(a[1]).add(Nr(e,u+48)),42).mul(kr),r=r.xor(o[1]),s=s.add(a[0]).add(Nr(e,u+40)),i=Tr(i.add(o[0]),33).mul(kr),a=Rr(e,u,a[1].mul(kr),r.add(o[0])),o=Rr(e,u+32,i.add(o[1]),s.add(Nr(e,u+16))),[i,r]=[r,i],u+=64;
}while(u!==l);const h=kr.add(i.and(255).shl(1));return u=c,o[0]=o[0].add(t-1&63),a[0]=a[0].add(o[0]),o[0]=o[0].add(a[0]),r=Tr(r.add(s).add(a[0]).add(Nr(e,u+8)),37).mul(h),s=Tr(s.add(a[1]).add(Nr(e,u+48)),42).mul(h),r=r.xor(o[1].mul(9)),s=s.add(a[0].mul(9).add(Nr(e,u+40))),i=Tr(i.add(o[0]),33).mul(h),a=Rr(e,u,a[1].mul(h),r.add(o[0])),o=Rr(e,u+32,i.add(o[1]),s.add(Nr(e,u+16))),[i,r]=[r,i],Er(Er(a[0],o[0],h).add(Sr(s).mul(vr)).add(i),Er(a[1],o[1],h).add(r),h);
}function Fr(e,t){
return"string"===t?Or(e):_r([e],t);
}function _r(e,t){
if("string"===t){
throw new Error("Cannot convert a string[] to a TypedArray");
}if(Array.isArray(e)&&(e=zr(e)),H().getBool("DEBUG")&&function(e,t){
for(let n=0;n<e.length;n++){
const r=e[n];if(isNaN(r)||!isFinite(r)){
throw Error(`A tensor of type ${t} being uploaded contains ${r}.`);
}
}
}(e,t),function(e,t){
return e instanceof Float32Array&&"float32"===t||e instanceof Int32Array&&"int32"===t||e instanceof Uint8Array&&"bool"===t;
}(e,t)){
return e;
}if(null==t||"float32"===t||"complex64"===t){
return new Float32Array(e);
}if("int32"===t){
return new Int32Array(e);
}if("bool"===t){
const t=new Uint8Array(e.length);for(let n=0;n<t.length;++n){
0!==Math.round(e[n])&&(t[n]=1);
}return t;
}throw new Error(`Unknown data type ${t}`);
}function Dr(){
return H().platform.now();
}function Or(e,t="utf-8"){
return t=t||"utf-8",H().platform.encode(e,t);
}function Mr(e,t="utf-8"){
return t=t||"utf-8",H().platform.decode(e,t);
}function Lr(e){
return null!=H().platform.isTypedArray?H().platform.isTypedArray(e):br(e);
}function zr(e,t=[],n=!1){
if(null==t&&(t=[]),"boolean"==typeof e||"number"==typeof e||"string"==typeof e||W(e)||null==e||Lr(e)&&n){
t.push(e);
}else if(Array.isArray(e)||Lr(e)){
for(let r=0;r<e.length;++r){
zr(e[r],t,n);
}
}else{
let r=-1;for(const t of Object.keys(e)){
/^([1-9]+[0-9]*|0)$/.test(t)&&(r=Math.max(r,Number(t)));
}for(let s=0;s<=r;s++){
zr(e[s],t,n);
}
}return t;
}class Pr{
constructor(e,t){
this.backendTimer=e,this.logger=t,null==t&&(this.logger=new Ur);
}profileKernel(e,t,n){
let r;const s=()=>{
r=n();
};let i;const a=Dr();if(this.backendTimer.timerAvailable()){
i=this.backendTimer.time(s);
}else{
s();for(const e of r){
e.dataSync();
}i=Promise.resolve({kernelMs:Dr()-a});
}if(H().getBool("CHECK_COMPUTATION_FOR_ERRORS")){
for(let t=0;t<r.length;t++){
const n=r[t];n.data().then((t=>{
Br(t,n.dtype,e);
}));
}
}return{kernelName:e,outputs:r,inputs:t,timeMs:i.then((e=>e.kernelMs)),extraInfo:i.then((e=>null!=e.getExtraProfileInfo?e.getExtraProfileInfo():""))};
}logKernelProfile(e){
const{kernelName:t,outputs:n,timeMs:r,inputs:s,extraInfo:i}=e;n.forEach((e=>{
Promise.all([e.data(),r,i]).then((n=>{
this.logger.logKernelProfile(t,e,n[0],n[1],s,n[2]);
}));
}));
}
}function Br(e,t,n){
if("float32"!==t){
return!1;
}for(let t=0;t<e.length;t++){
const r=e[t];if(isNaN(r)||!isFinite(r)){
return console.warn(`Found ${r} in the result of '${n}'`),!0;
}
}return!1;
}class Ur{
logKernelProfile(e,t,n,r,s,i){
const a="number"==typeof r?y(`${r}ms`,9):r.error,o=y(e,25),u=t.rank,l=t.size,c=y(t.shape.toString(),14);let h="";for(const e in s){
const n=s[e];if(null!=n){
const r=n.shape||t.shape,s=r.length;h+=`${e}: ${s}D ${s>0?r:""} `;
}
}console.log(`%c${o}\t%c${a}\t%c${u}D ${c}\t%c${l}\t%c${h}\t%c${i}`,"font-weight:bold","color:red","color:blue","color: orange","color: green","color: steelblue");
}
}const Wr=20,Vr=3,Gr=7;function jr(e,t,n,r){
const s=_(t),i=function(e,t,n,r){
const s=m(t),i=r[r.length-1],a=new Array(i).fill(0),o=t.length,u="complex64"===n?Xr(e):e;if(o>1){
for(let e=0;e<s/i;e++){
const t=e*i;for(let e=0;e<i;e++){
a[e]=Math.max(a[e],Hr(u[t+e],0,n).length);
}
}
}return a;
}(e,t,n,s),a=t.length,o=Kr(e,t,n,s,i),u=["Tensor"];return r&&(u.push(`  dtype: ${n}`),u.push(`  rank: ${a}`),u.push(`  shape: [${t}]`),u.push("  values:")),u.push(o.map((e=>"    "+e)).join("\n")),u.join("\n");
}function Hr(e,t,n){
let r;return r=Array.isArray(e)?`${parseFloat(e[0].toFixed(Gr))} + ${parseFloat(e[1].toFixed(Gr))}j`:T(e)?`'${e}'`:"bool"===n?qr(e):parseFloat(e.toFixed(Gr)).toString(),y(r,t);
}function qr(e){
return 0===e?"false":"true";
}function Kr(e,t,n,r,s,i=!0){
const a="complex64"===n?2:1,o=t[0],u=t.length;if(0===u){
return"complex64"===n?[Hr(Xr(e)[0],0,n)]:"bool"===n?[qr(e[0])]:[e[0].toString()];
}if(1===u){
if(o>Wr){
const t=Vr*a;let r=Array.from(e.slice(0,t)),i=Array.from(e.slice((o-Vr)*a,o*a));return"complex64"===n&&(r=Xr(r),i=Xr(i)),["["+r.map(((e,t)=>Hr(e,s[t],n))).join(", ")+", ..., "+i.map(((e,t)=>Hr(e,s[o-Vr+t],n))).join(", ")+"]"];
}return["["+("complex64"===n?Xr(e):Array.from(e)).map(((e,t)=>Hr(e,s[t],n))).join(", ")+"]"];
}const l=t.slice(1),c=r.slice(1),h=r[0]*a,d=[];if(o>Wr){
for(let t=0;t<Vr;t++){
const r=t*h,i=r+h;d.push(...Kr(e.slice(r,i),l,n,c,s,!1));
}d.push("...");for(let t=o-Vr;t<o;t++){
const r=t*h,i=r+h;d.push(...Kr(e.slice(r,i),l,n,c,s,t===o-1));
}
}else {
for(let t=0;t<o;t++){
const r=t*h,i=r+h;d.push(...Kr(e.slice(r,i),l,n,c,s,t===o-1));
}
}const p=2===u?",":"";d[0]="["+(o>0?d[0]+p:"");for(let e=1;e<d.length-1;e++){
d[e]=" "+d[e]+p;
}let f=",\n";for(let e=2;e<u;e++){
f+="\n";
}return d[d.length-1]=" "+d[d.length-1]+"]"+(i?"":f),d;
}function Xr(e){
const t=[];for(let n=0;n<e.length;n+=2){
t.push([e[n],e[n+1]]);
}return t;
}class Yr{
constructor(e,t,n){
if(this.dtype=t,this.shape=e.slice(),this.size=m(e),null!=n){
const e=n.length;d(e===this.size,(()=>`Length of values '${e}' does not match the size inferred by the shape '${this.size}'.`));
}if("complex64"===t){
throw new Error("complex64 dtype TensorBuffers are not supported. Please create a TensorBuffer for the real and imaginary parts separately and call tf.complex(real, imag).");
}this.values=n||C(t,this.size),this.strides=_(e);
}set(e,...t){
0===t.length&&(t=[0]),d(t.length===this.rank,(()=>`The number of provided coordinates (${t.length}) must match the rank (${this.rank})`));const n=this.locToIndex(t);this.values[n]=e;
}get(...e){
0===e.length&&(e=[0]);let t=0;for(const n of e){
if(n<0||n>=this.shape[t]){
const t=`Requested out of range element at ${e}.   Buffer shape=${this.shape}`;throw new Error(t);
}t++;
}let n=e[e.length-1];for(let t=0;t<e.length-1;++t){
n+=this.strides[t]*e[t];
}return this.values[n];
}locToIndex(e){
if(0===this.rank){
return 0;
}if(1===this.rank){
return e[0];
}let t=e[e.length-1];for(let n=0;n<e.length-1;++n){
t+=this.strides[n]*e[n];
}return t;
}indexToLoc(e){
if(0===this.rank){
return[];
}if(1===this.rank){
return[e];
}const t=new Array(this.shape.length);for(let n=0;n<t.length-1;++n){
t[n]=Math.floor(e/this.strides[n]),e-=t[n]*this.strides[n];
}return t[t.length-1]=e,t;
}get rank(){
return this.shape.length;
}toTensor(){
return Zr().makeTensor(this.values,this.shape,this.dtype);
}
}let Zr=null,Jr=null,Qr=null;class es{
constructor(e,t,n,r){
this.kept=!1,this.isDisposedInternal=!1,this.shape=e.slice(),this.dtype=t||"float32",this.size=m(e),this.strides=_(e),this.dataId=n,this.id=r,this.rankType=this.rank<5?this.rank.toString():"higher";
}get rank(){
return this.shape.length;
}async buffer(){
const e=await this.data();return Jr.buffer(this.shape,this.dtype,e);
}bufferSync(){
return Jr.buffer(this.shape,this.dtype,this.dataSync());
}async array(){
const e=await this.data();return O(this.shape,e,"complex64"===this.dtype);
}arraySync(){
return O(this.shape,this.dataSync(),"complex64"===this.dtype);
}async data(){
this.throwIfDisposed();const e=Zr().read(this.dataId);if("string"===this.dtype){
const t=await e;try{
return t.map((e=>Mr(e)));
}catch(e){
throw new Error("Failed to decode the string bytes into utf-8. To get the original bytes, call tensor.bytes().");
}
}return e;
}dataToGPU(e){
return this.throwIfDisposed(),Zr().readToGPU(this.dataId,e);
}dataSync(){
this.throwIfDisposed();const e=Zr().readSync(this.dataId);if("string"===this.dtype){
try{
return e.map((e=>Mr(e)));
}catch(e){
throw new Error("Failed to decode the string bytes into utf-8. To get the original bytes, call tensor.bytes().");
}
}return e;
}async bytes(){
this.throwIfDisposed();const e=await Zr().read(this.dataId);return"string"===this.dtype?e:new Uint8Array(e.buffer);
}dispose(){
this.isDisposed||(Zr().disposeTensor(this),this.isDisposedInternal=!0);
}get isDisposed(){
return this.isDisposedInternal;
}throwIfDisposed(){
if(this.isDisposed){
throw new Error("Tensor is disposed.");
}
}print(e=!1){
return Jr.print(this,e);
}clone(){
return this.throwIfDisposed(),Jr.clone(this);
}toString(e=!1){
return jr(this.dataSync(),this.shape,this.dtype,e);
}cast(e){
return this.throwIfDisposed(),Jr.cast(this,e);
}variable(e=!0,t,n){
return this.throwIfDisposed(),Zr().makeVariable(this,e,t,n);
}
}function ts(){
return Y("Tensor",(()=>es));
}Object.defineProperty(es,Symbol.hasInstance,{value:e=>!!e&&null!=e.data&&null!=e.dataSync&&null!=e.throwIfDisposed}),ts();class ns extends es{
constructor(e,t,n,r){
super(e.shape,e.dtype,e.dataId,r),this.trainable=t,this.name=n;
}assign(e){
if(e.dtype!==this.dtype){
throw new Error(`dtype of the new value (${e.dtype}) and previous value (${this.dtype}) must match`);
}if(!g(e.shape,this.shape)){
throw new Error(`shape of the new value (${e.shape}) and previous value (${this.shape}) must match`);
}Zr().disposeTensor(this),this.dataId=e.dataId,Zr().incRef(this,null);
}dispose(){
Zr().disposeVariable(this),this.isDisposedInternal=!0;
}
}var rs,ss,is,as,os;Object.defineProperty(ns,Symbol.hasInstance,{value:e=>e instanceof es&&null!=e.assign&&e.assign instanceof Function}),function(e){
e.R0="R0",e.R1="R1",e.R2="R2",e.R3="R3",e.R4="R4",e.R5="R5",e.R6="R6";
}(rs||(rs={})),function(e){
e.float32="float32",e.int32="int32",e.bool="int32",e.complex64="complex64";
}(ss||(ss={})),function(e){
e.float32="float32",e.int32="int32",e.bool="bool",e.complex64="complex64";
}(is||(is={})),function(e){
e.float32="float32",e.int32="float32",e.bool="float32",e.complex64="complex64";
}(as||(as={})),function(e){
e.float32="complex64",e.int32="complex64",e.bool="complex64",e.complex64="complex64";
}(os||(os={}));const us={float32:as,int32:ss,bool:is,complex64:os};function ls(e,t){
if("string"===e||"string"===t){
if("string"===e&&"string"===t){
return"string";
}throw new Error(`Can not upcast ${e} with ${t}`);
}return us[e][t];
}function cs(e){
return ls(e,"int32");
}function hs(e){
return null!=e&&"object"==typeof e&&"texture"in e&&e.texture instanceof WebGLTexture;
}function ds(e){
return"undefined"!=typeof GPUBuffer&&null!=e&&"object"==typeof e&&"buffer"in e&&e.buffer instanceof GPUBuffer;
}function ps(e,t){
if(e.dtype===t.dtype){
return[e,t];
}const n=ls(e.dtype,t.dtype);return[e.cast(n),t.cast(n)];
}function fs(e,t){
return t.some((t=>t.id===e.id));
}function ms(e){
const t=[];return gs(e,t,new Set),t;
}function gs(e,t,n){
if(null==e){
return;
}if(e instanceof es){
return void t.push(e);
}if(r=e,!Array.isArray(r)&&"object"!=typeof r){
return;
}var r;const s=e;for(const e in s){
const r=s[e];n.has(r)||(n.add(r),gs(r,t,n));
}
}function bs(e){
return null!=e.kernelName;
}class xs{
constructor(){
this.registeredVariables={},this.nextTapeNodeId=0,this.numBytes=0,this.numTensors=0,this.numStringTensors=0,this.numDataBuffers=0,this.gradientDepth=0,this.kernelDepth=0,this.scopeStack=[],this.numDataMovesStack=[],this.nextScopeId=0,this.tensorInfo=new WeakMap,this.profiling=!1,this.activeProfile={newBytes:0,newTensors:0,peakBytes:0,kernels:[],result:null,get kernelNames(){
return Array.from(new Set(this.kernels.map((e=>e.name))));
}};
}dispose(){
for(const e in this.registeredVariables){
this.registeredVariables[e].dispose();
}
}
}class ys{
constructor(e){
this.ENV=e,this.registry={},this.registryFactory={},this.pendingBackendInitId=0,this.state=new xs;
}async ready(){
if(null!=this.pendingBackendInit){
return this.pendingBackendInit.then((()=>{}));
}if(null!=this.backendInstance){
return;
}const e=this.getSortedBackends();for(let t=0;t<e.length;t++){
const n=e[t];if(await this.initializeBackend(n).success){
return void await this.setBackend(n);
}
}throw new Error("Could not initialize any backends, all backend initializations failed.");
}get backend(){
if(null!=this.pendingBackendInit){
throw new Error(`Backend '${this.backendName}' has not yet been initialized. Make sure to await tf.ready() or await tf.setBackend() before calling other methods`);
}if(null==this.backendInstance){
const{name:e,asyncInit:t}=this.initializeBackendsAndReturnBest();if(t){
throw new Error(`The highest priority backend '${e}' has not yet been initialized. Make sure to await tf.ready() or await tf.setBackend() before calling other methods`);
}this.setBackend(e);
}return this.backendInstance;
}backendNames(){
return Object.keys(this.registryFactory);
}findBackend(e){
if(!(e in this.registry)){
if(!(e in this.registryFactory)){
return null;
}{const{asyncInit:t}=this.initializeBackend(e);if(t){
return null;
}}
}return this.registry[e];
}findBackendFactory(e){
return e in this.registryFactory?this.registryFactory[e].factory:null;
}registerBackend(e,t,n=1){
return e in this.registryFactory?(or(`${e} backend was already registered. Reusing existing backend factory.`),!1):(this.registryFactory[e]={factory:t,priority:n},!0);
}async setBackend(e){
if(null==this.registryFactory[e]){
throw new Error(`Backend name '${e}' not found in registry`);
}if(this.backendName=e,null==this.registry[e]){
this.backendInstance=null;const{success:t,asyncInit:n}=this.initializeBackend(e);if(!(n?await t:t)){
return!1;
}
}return this.backendInstance=this.registry[e],this.setupRegisteredKernels(),this.profiler=new Pr(this.backendInstance),!0;
}setupRegisteredKernels(){
pr(this.backendName).forEach((e=>{
null!=e.setupFunc&&e.setupFunc(this.backendInstance);
}));
}disposeRegisteredKernels(e){
pr(e).forEach((t=>{
null!=t.disposeFunc&&t.disposeFunc(this.registry[e]);
}));
}initializeBackend(e){
const t=this.registryFactory[e];if(null==t){
throw new Error(`Cannot initialize backend ${e}, no registration found.`);
}try{
const n=t.factory();if(!n||n instanceof a||"function"!=typeof n.then){
return this.registry[e]=n,{success:!0,asyncInit:!1};
}{const t=++this.pendingBackendInitId,r=n.then((n=>!(t<this.pendingBackendInitId||(this.registry[e]=n,this.pendingBackendInit=null,0)))).catch((n=>(t<this.pendingBackendInitId||(this.pendingBackendInit=null,or(`Initialization of backend ${e} failed`),or(n.stack||n.message)),!1)));return this.pendingBackendInit=r,{success:r,asyncInit:!0};}
}catch(t){
return or(`Initialization of backend ${e} failed`),or(t.stack||t.message),{success:!1,asyncInit:!1};
}
}removeBackend(e){
if(!(e in this.registryFactory)){
throw new Error(`${e} backend not found in registry`);
}this.backendName===e&&null!=this.pendingBackendInit&&this.pendingBackendInitId++,e in this.registry&&(this.disposeRegisteredKernels(e),this.registry[e].dispose(),delete this.registry[e]),delete this.registryFactory[e],this.backendName===e&&(this.pendingBackendInit=null,this.backendName=null,this.backendInstance=null);
}getSortedBackends(){
if(0===Object.keys(this.registryFactory).length){
throw new Error("No backend found in registry.");
}return Object.keys(this.registryFactory).sort(((e,t)=>this.registryFactory[t].priority-this.registryFactory[e].priority));
}initializeBackendsAndReturnBest(){
const e=this.getSortedBackends();for(let t=0;t<e.length;t++){
const n=e[t],{success:r,asyncInit:s}=this.initializeBackend(n);if(s||r){
return{name:n,asyncInit:s};
}
}throw new Error("Could not initialize any backends, all backend initializations failed.");
}moveData(e,t){
const n=this.state.tensorInfo.get(t),r=n.backend,s=this.readSync(t),i=r.refCount(t);r.disposeData(t,!0),n.backend=e,e.move(t,s,n.shape,n.dtype,i),this.shouldCheckForMemLeaks()&&this.state.numDataMovesStack[this.state.numDataMovesStack.length-1]++;
}tidy(e,t){
let n,r=null;if(null==t){
if("function"!=typeof e){
throw new Error("Please provide a function to tidy()");
}t=e;
}else{
if("string"!=typeof e&&!(e instanceof String)){
throw new Error("When calling with two arguments, the first argument to tidy() must be a string");
}if("function"!=typeof t){
throw new Error("When calling with two arguments, the 2nd argument to tidy() must be a function");
}r=e;
}return this.scopedRun((()=>this.startScope(r)),(()=>this.endScope(n)),(()=>(n=t(),n instanceof Promise&&console.error("Cannot return a Promise inside of tidy."),n)));
}scopedRun(e,t,n){
e();try{
const e=n();return t(),e;
}catch(e){
throw t(),e;
}
}nextTensorId(){
return ys.nextTensorId++;
}nextVariableId(){
return ys.nextVariableId++;
}clone(e){
const t=vs.runKernel(ht,{x:e}),n={x:e};return this.addTapeNode(this.state.activeScope.name,n,[t],(e=>({x:()=>{
const t={x:e};return vs.runKernel(we,t,{dtype:"float32"});
}})),[],{}),t;
}runKernel(e,t,n){
if(null==this.backendName&&this.backend,null==hr(e,this.backendName)){
throw new Error(`Kernel '${e}' not registered for backend '${this.backendName}'`);
}return this.runKernelFunc({kernelName:e,inputs:t,attrs:n});
}shouldCheckForMemLeaks(){
return this.ENV.getBool("IS_TEST");
}checkKernelForMemLeak(e,t,n){
const r=this.backend.numDataIds();let s=0;n.forEach((e=>{
s+="complex64"===e.dtype?3:1;
}));const i=this.state.numDataMovesStack[this.state.numDataMovesStack.length-1],a=r-t-s-i;if(a>0){
throw new Error(`Backend '${this.backendName}' has an internal memory leak (${a} data ids) after running '${e}'`);
}
}runKernelFunc(e){
let t,n=[];const r=this.isTapeOn(),s=this.state.numBytes,i=this.state.numTensors;let a,o;this.shouldCheckForMemLeaks()&&this.state.numDataMovesStack.push(0),null==this.backendName&&this.backend;const u=bs(e)?e.kernelName:null!=this.state.activeScope?this.state.activeScope.name:"";if(bs(e)){
const{kernelName:t,inputs:s,attrs:i}=e;null==this.backendName&&this.backend;const u=hr(t,this.backendName);d(null!=u,(()=>`Cannot find registered kernel '${t}' for backend '${this.backendName}'`)),a=()=>{
const e=this.backend.numDataIds();o=u.kernelFunc({inputs:s,attrs:i,backend:this.backend});const a=Array.isArray(o)?o:[o];this.shouldCheckForMemLeaks()&&this.checkKernelForMemLeak(t,e,a);const l=a.map((e=>null!=e.rank?e:this.makeTensorFromTensorInfo(e)));if(r){
const e=this.getTensorsForGradient(t,s,l);n=this.saveTensorsForBackwardMode(e);
}return l;
};
}else{
const{forwardFunc:t}=e,s=e=>{
r&&(n=e.map((e=>this.keep(this.clone(e)))));
};a=()=>{
const e=this.backend.numDataIds();o=this.tidy((()=>t(this.backend,s)));const n=Array.isArray(o)?o:[o];return this.shouldCheckForMemLeaks()&&this.checkKernelForMemLeak(u,e,n),n;
};
}const{inputs:l,attrs:c}=e,h=bs(e)?null:e.backwardsFunc;let p;return this.scopedRun((()=>this.state.kernelDepth++),(()=>this.state.kernelDepth--),(()=>{
this.ENV.getBool("DEBUG")||this.state.profiling?(p=this.profiler.profileKernel(u,l,(()=>a())),this.ENV.getBool("DEBUG")&&this.profiler.logKernelProfile(p),t=p.outputs):t=a();
})),r&&this.addTapeNode(u,l,t,h,n,c),this.state.profiling&&this.state.activeProfile.kernels.push({name:u,bytesAdded:this.state.numBytes-s,totalBytesSnapshot:this.state.numBytes,tensorsAdded:this.state.numTensors-i,totalTensorsSnapshot:this.state.numTensors,inputShapes:Object.keys(l).map((e=>null!=l[e]?l[e].shape:null)),outputShapes:t.map((e=>e.shape)),kernelTimeMs:p.timeMs,extraInfo:p.extraInfo}),Array.isArray(o)?t:t[0];
}saveTensorsForBackwardMode(e){
return e.map((e=>this.keep(this.clone(e))));
}getTensorsForGradient(e,t,n){
const r=dr(e);if(null!=r){
const e=r.inputsToSave||[],s=r.outputsToSave||[];let i;r.saveAllInputs?(d(Array.isArray(t),(()=>"saveAllInputs is true, expected inputs to be an array.")),i=Object.keys(t).map((e=>t[e]))):i=e.map((e=>t[e]));const a=n.filter(((e,t)=>s[t]));return i.concat(a);
}return[];
}makeTensor(e,t,n,r){
if(null==e){
throw new Error("Values passed to engine.makeTensor() are null");
}n=n||"float32",r=r||this.backend;let s=e;"string"===n&&T(e[0])&&(s=e.map((e=>Or(e))));const i=r.write(s,t,n),a=new es(t,n,i,this.nextTensorId());if(this.trackTensor(a,r),"string"===n){
const e=this.state.tensorInfo.get(i),t=function(e){
if(null==e){
return 0;
}let t=0;return e.forEach((e=>t+=e.length)),t;
}(s);this.state.numBytes+=t-e.bytes,e.bytes=t;
}return a;
}makeTensorFromDataId(e,t,n,r){
const s={dataId:e,shape:t,dtype:n=n||"float32"};return this.makeTensorFromTensorInfo(s,r);
}makeTensorFromTensorInfo(e,t){
const{dataId:n,shape:r,dtype:s}=e,i=new es(r,s,n,this.nextTensorId());return this.trackTensor(i,t),i;
}makeVariable(e,t=!0,n,r){
n=n||this.nextVariableId().toString(),null!=r&&r!==e.dtype&&(e=e.cast(r));const s=new ns(e,t,n,this.nextTensorId());if(null!=this.state.registeredVariables[s.name]){
throw new Error(`Variable with name ${s.name} was already registered`);
}return this.state.registeredVariables[s.name]=s,this.incRef(s,this.backend),s;
}trackTensor(e,t){
this.state.numTensors++,"string"===e.dtype&&this.state.numStringTensors++;let n=0;"complex64"!==e.dtype&&"string"!==e.dtype&&(n=e.size*$(e.dtype)),this.state.numBytes+=n,this.state.tensorInfo.has(e.dataId)||(this.state.numDataBuffers++,this.state.tensorInfo.set(e.dataId,{backend:t||this.backend,dtype:e.dtype,shape:e.shape,bytes:n})),e instanceof ns||this.track(e);
}incRef(e,t){
this.trackTensor(e,t),this.backend.incRef(e.dataId);
}removeDataId(e,t){
this.state.tensorInfo.has(e)&&this.state.tensorInfo.get(e).backend===t&&(this.state.tensorInfo.delete(e),this.state.numDataBuffers--);
}disposeTensor(e){
if(!this.state.tensorInfo.has(e.dataId)){
return;
}const t=this.state.tensorInfo.get(e.dataId);if(this.state.numTensors--,"string"===e.dtype&&(this.state.numStringTensors--,this.state.numBytes-=t.bytes),"complex64"!==e.dtype&&"string"!==e.dtype){
const t=e.size*$(e.dtype);this.state.numBytes-=t;
}t.backend.disposeData(e.dataId)&&this.removeDataId(e.dataId,t.backend);
}disposeVariables(){
for(const e in this.state.registeredVariables){
const t=this.state.registeredVariables[e];this.disposeVariable(t);
}
}disposeVariable(e){
this.disposeTensor(e),null!=this.state.registeredVariables[e.name]&&delete this.state.registeredVariables[e.name];
}memory(){
const e=this.backend.memory();return e.numTensors=this.state.numTensors,e.numDataBuffers=this.state.numDataBuffers,e.numBytes=this.state.numBytes,this.state.numStringTensors>0&&(e.unreliable=!0,null==e.reasons&&(e.reasons=[]),e.reasons.push("Memory usage by string tensors is approximate (2 bytes per character)")),e;
}async profile(e){
this.state.profiling=!0;const t=this.state.numBytes,n=this.state.numTensors;this.state.activeProfile.kernels=[],this.state.activeProfile.result=await e(),this.state.profiling=!1,this.state.activeProfile.peakBytes=Math.max(...this.state.activeProfile.kernels.map((e=>e.totalBytesSnapshot))),this.state.activeProfile.newBytes=this.state.numBytes-t,this.state.activeProfile.newTensors=this.state.numTensors-n;for(const e of this.state.activeProfile.kernels){
e.kernelTimeMs=await e.kernelTimeMs,e.extraInfo=await e.extraInfo;
}return this.state.activeProfile;
}isTapeOn(){
return this.state.gradientDepth>0&&0===this.state.kernelDepth;
}addTapeNode(e,t,n,r,s,i){
const a={id:this.state.nextTapeNodeId++,kernelName:e,inputs:t,outputs:n,saved:s},o=dr(e);null!=o&&(r=o.gradFunc),null!=r&&(a.gradient=e=>(e=e.map(((e,t)=>{
if(null==e){
const e=n[t],r=L(e.size,e.dtype);return this.makeTensor(r,e.shape,e.dtype);
}return e;
})),r(e.length>1?e:e[0],s,i))),this.state.activeTape.push(a);
}keep(e){
return e.kept=!0,e;
}startTape(){
0===this.state.gradientDepth&&(this.state.activeTape=[]),this.state.gradientDepth++;
}endTape(){
this.state.gradientDepth--;
}startScope(e){
const t={track:[],name:"unnamed scope",id:this.state.nextScopeId++};e&&(t.name=e),this.state.scopeStack.push(t),this.state.activeScope=t;
}endScope(e){
const t=ms(e),n=new Set(t.map((e=>e.id)));for(let e=0;e<this.state.activeScope.track.length;e++){
const t=this.state.activeScope.track[e];t.kept||n.has(t.id)||t.dispose();
}const r=this.state.scopeStack.pop();this.state.activeScope=0===this.state.scopeStack.length?null:this.state.scopeStack[this.state.scopeStack.length-1],t.forEach((e=>{
e.kept||e.scopeId!==r.id||this.track(e);
}));
}gradients(e,t,n,r=!1){
if(d(t.length>0,(()=>"gradients() received an empty list of xs.")),null!=n&&"float32"!==n.dtype){
throw new Error(`dy must have 'float32' dtype, but has '${n.dtype}'`);
}const s=this.scopedRun((()=>this.startTape()),(()=>this.endTape()),(()=>this.tidy("forward",e)));d(s instanceof es,(()=>"The result y returned by f() must be a tensor."));const i=function(e,t,n){
const r={},s={};for(let e=0;e<t.length;e++){
r[t[e].id]=!0;
}for(let n=0;n<e.length;n++){
const i=e[n],a=i.inputs;for(const e in a){
const n=a[e];let o=!1;for(let e=0;e<t.length;e++){
if(r[n.id]){
i.outputs.forEach((e=>r[e.id]=!0)),o=!0,s[i.id]=!0;break;
}
}if(o){
break;
}
}
}const i={};i[n.id]=!0;const a={};for(let t=e.length-1;t>=0;t--){
const n=e[t],r=n.inputs;for(let e=0;e<n.outputs.length;e++){
if(i[n.outputs[e].id]){
for(const e in r){
i[r[e].id]=!0,a[n.id]=!0;
}break;
}
}
}const o=[];for(let t=0;t<e.length;t++){
const n=e[t];if(s[n.id]&&a[n.id]){
const e={};for(const t in n.inputs){
const s=n.inputs[t];r[s.id]&&(e[t]=s);
}const t=Object.assign({},n);t.inputs=e,t.outputs=n.outputs,o.push(t);
}
}return o;
}(this.state.activeTape,t,s);if(!r&&0===i.length&&t.length>0){
throw new Error("Cannot compute gradient of y=f(x) with respect to x. Make sure that the f you passed encloses all operations that lead from x to y.");
}return this.tidy("backward",(()=>{
const e={};e[s.id]=null==n?function(e){
const t=M(m(e),"float32");return vs.makeTensor(t,e,"float32");
}(s.shape):n,function(e,t,n,r){
for(let s=t.length-1;s>=0;s--){
const i=t[s],a=[];if(i.outputs.forEach((t=>{
const n=e[t.id];null!=n?a.push(n):a.push(null);
})),null==i.gradient){
throw new Error(`Cannot compute gradient: gradient function not found for ${i.kernelName}.`);
}const o=i.gradient(a);for(const t in i.inputs){
if(!(t in o)){
throw new Error(`Cannot backprop through input ${t}. Available gradients found: ${Object.keys(o)}.`);
}const s=n((()=>o[t]()));if("float32"!==s.dtype){
throw new Error(`Error in gradient for op ${i.kernelName}. The gradient of input ${t} must have 'float32' dtype, but has '${s.dtype}'`);
}const a=i.inputs[t];if(!g(s.shape,a.shape)){
throw new Error(`Error in gradient for op ${i.kernelName}. The gradient of input '${t}' has shape '${s.shape}', which does not match the shape of the input '${a.shape}'`);
}if(null==e[a.id]){
e[a.id]=s;
}else{
const t=e[a.id];e[a.id]=r(t,s),t.dispose();
}
}
}
}(e,i,(e=>this.tidy(e)),ks);const r=t.map((t=>e[t.id]));return 0===this.state.gradientDepth&&(this.state.activeTape.forEach((e=>{
for(const t of e.saved){
t.dispose();
}
})),this.state.activeTape=null),{value:s,grads:r};
}));
}customGrad(e){
return d(A(e),(()=>"The f passed in customGrad(f) must be a function.")),(...t)=>{
let n;d(t.every((e=>e instanceof es)),(()=>"The args passed in customGrad(f)(x1, x2,...) must all be tensors"));const r={};return t.forEach(((e,t)=>{
r[t]=e;
})),this.runKernelFunc({forwardFunc:(r,s)=>(n=e(...t,s),d(n.value instanceof es,(()=>"The function f passed in customGrad(f) must return an object where `obj.value` is a tensor")),d(A(n.gradFunc),(()=>"The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function.")),n.value),backwardsFunc:(e,r)=>{
const s=n.gradFunc(e,r),i=Array.isArray(s)?s:[s];d(i.length===t.length,(()=>"The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function that returns the same number of tensors as inputs passed to f(...).")),d(i.every((e=>e instanceof es)),(()=>"The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function that returns a list of only tensors."));const a={};return i.forEach(((e,t)=>{
a[t]=()=>e;
})),a;
},inputs:r});
};
}readSync(e){
return this.state.tensorInfo.get(e).backend.readSync(e);
}read(e){
return this.state.tensorInfo.get(e).backend.read(e);
}readToGPU(e,t){
return this.state.tensorInfo.get(e).backend.readToGPU(e,t);
}async time(e){
const t=Dr(),n=await this.backend.time(e);return n.wallMs=Dr()-t,n;
}track(e){
return null!=this.state.activeScope&&(e.scopeId=this.state.activeScope.id,this.state.activeScope.track.push(e)),e;
}get registeredVariables(){
return this.state.registeredVariables;
}reset(){
this.pendingBackendInitId++,this.state.dispose(),this.ENV.reset(),this.state=new xs;for(const e in this.registry){
this.disposeRegisteredKernels(e),this.registry[e].dispose(),delete this.registry[e];
}this.backendName=null,this.backendInstance=null,this.pendingBackendInit=null;
}
}function ws(){
const e=X();if(null==e._tfengine){
const t=new G(e);e._tfengine=new ys(t);
}var t;return t=e._tfengine.ENV,K=t,Zr=()=>e._tfengine,e._tfengine;
}ys.nextTensorId=0,ys.nextVariableId=0;const vs=ws();function ks(e,t){
const n={a:e,b:t};return vs.runKernel(ee,n);
}function Is(e){
if(e||"undefined"!=typeof navigator&&null!=navigator){
if(e||(e=navigator),"ReactNative"===e.product){
return!0;
}const t=e.userAgent||e.vendor||("undefined"!=typeof window?window.opera:"");if(!t){
const t=e;return t.userAgentData&&t.userAgentData.mobile;
}return/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(t)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(t.substr(0,4));
}return!1;
}function Ss(){
return"undefined"!=typeof window&&null!=window.document||"undefined"!=typeof WorkerGlobalScope;
}const Cs=H();function Ns(e,t){
let n=e;if(Lr(e)){
return"string"===t?[]:[e.length];
}if(hs(e)){
const t=e.channels||"RGBA";return[e.height,e.width*t.length];
}if(ds(e)){
return[e.buffer.size/(null==t?4:$(t))];
}if(!Array.isArray(e)){
return[];
}const r=[];for(;Array.isArray(n)||Lr(n)&&"string"!==t;){
r.push(n.length),n=n[0];
}return Array.isArray(e)&&H().getBool("TENSORLIKE_CHECK_SHAPE_CONSISTENCY")&&$s(e,r,[]),r;
}function $s(e,t,n){
if(n=n||[],!Array.isArray(e)&&!Lr(e)){
return void d(0===t.length,(()=>`Element arr[${n.join("][")}] is a primitive, but should be an array/TypedArray of ${t[0]} elements`));
}d(t.length>0,(()=>`Element arr[${n.join("][")}] should be a primitive, but is an array of ${e.length} elements`)),d(e.length===t[0],(()=>`Element arr[${n.join("][")}] should have ${t[0]} elements, but has ${e.length} elements`));const r=t.slice(1);for(let t=0;t<e.length;++t){
$s(e[t],r,n.concat(t));
}
}function Ts(e,t,n,r){
if("string_or_numeric"!==e){
if(null==e){
throw new Error("Expected dtype cannot be null.");
}if("numeric"!==e&&e!==t||"numeric"===e&&"string"===t){
throw new Error(`Argument '${n}' passed to '${r}' must be ${e} tensor, but got ${t} tensor`);
}
}
}function Es(e,t,n,r="numeric"){
if(e instanceof es){
return Ts(r,e.dtype,t,n),e;
}let s=R(e);if("string"!==s&&["bool","int32","float32"].indexOf(r)>=0&&(s=r),Ts(r,s,t,n),null==e||!Lr(e)&&!Array.isArray(e)&&"number"!=typeof e&&"boolean"!=typeof e&&"string"!=typeof e){
const r=null==e?"null":e.constructor.name;throw new Error(`Argument '${t}' passed to '${n}' must be a Tensor or TensorLike, but got '${r}'`);
}const i=Ns(e,s);Lr(e)||Array.isArray(e)||(e=[e]);const a="string"!==s?_r(e,s):zr(e,[],!0);return vs.makeTensor(a,i,s);
}function Rs(e,t,n,r="numeric"){
if(!Array.isArray(e)){
throw new Error(`Argument ${t} passed to ${n} must be a \`Tensor[]\` or \`TensorLike[]\``);
}return e.map(((e,s)=>Es(e,`${t}[${s}]`,n,r)));
}function As(e){
const t=Object.keys(e);if(1!==t.length){
throw new Error(`Please provide an object with a single key (operation name) mapping to a function. Got an object with ${t.length} keys.`);
}let n=t[0];const r=e[n];n.endsWith("_")&&(n=n.substring(0,n.length-1)),n+="__op";const s=(...e)=>{
vs.startScope(n);try{
const t=r(...e);return W(t)&&console.error("Cannot return a Promise inside of tidy."),vs.endScope(t),t;
}catch(e){
throw vs.endScope(null),e;
}
};return Object.defineProperty(s,"name",{value:n,configurable:!0}),s;
}Cs.registerFlag("DEBUG",(()=>!1),(e=>{
e&&console.warn("Debugging mode is ON. The output of every math call will be downloaded to CPU and checked for NaNs. This significantly impacts performance.");
})),Cs.registerFlag("IS_BROWSER",(()=>Ss())),Cs.registerFlag("IS_NODE",(()=>"undefined"!=typeof process&&void 0!==process.versions&&void 0!==process.versions.node)),Cs.registerFlag("IS_CHROME",(()=>"undefined"!=typeof navigator&&null!=navigator&&null!=navigator.userAgent&&/Chrome/.test(navigator.userAgent)&&/Google Inc/.test(navigator.vendor))),Cs.registerFlag("IS_SAFARI",(()=>"undefined"!=typeof navigator&&null!=navigator&&null!=navigator.userAgent&&/Safari/.test(navigator.userAgent)&&/Apple/.test(navigator.vendor))),Cs.registerFlag("PROD",(()=>!1)),Cs.registerFlag("TENSORLIKE_CHECK_SHAPE_CONSISTENCY",(()=>Cs.getBool("DEBUG"))),Cs.registerFlag("DEPRECATION_WARNINGS_ENABLED",(()=>!0)),Cs.registerFlag("IS_TEST",(()=>!1)),Cs.registerFlag("CHECK_COMPUTATION_FOR_ERRORS",(()=>Cs.getBool("DEBUG"))),Cs.registerFlag("WRAP_TO_IMAGEBITMAP",(()=>!1)),Cs.registerFlag("CANVAS2D_WILL_READ_FREQUENTLY_FOR_GPU",(()=>!1)),Cs.registerFlag("USE_SETTIMEOUTCUSTOM",(()=>!1));const Fs=As({complex_:function(e,t){
const n=Es(e,"real","complex"),r=Es(t,"imag","complex");p(n.shape,r.shape,`real and imag shapes, ${n.shape} and ${r.shape}, must match in call to tf.complex().`);const s={real:n,imag:r};return vs.runKernel(Ie,s);
}});function _s(e,t,n,r){
if(null==r){
r=R(e);
}else if("complex64"===r){
throw new Error("Cannot construct a complex64 tensor directly. Please use tf.complex(real, imag).");
}if(ds(e)||hs(e)){
if("float32"!==r&&"int32"!==r){
throw new Error(`Creating tensor from GPU data only supports 'float32'|'int32' dtype, while the dtype is ${r}.`);
}return vs.backend.createTensorFromGPUData(e,t||n,r);
}if(!Lr(e)&&!Array.isArray(e)&&"number"!=typeof e&&"boolean"!=typeof e&&"string"!=typeof e){
throw new Error("values passed to tensor(values) must be a number/boolean/string or an array of numbers/booleans/strings, or a TypedArray");
}if(null!=t){
P(t);const e=m(t),r=m(n);d(e===r,(()=>`Based on the provided shape, [${t}], the tensor should have ${e} values but has ${r}`));for(let e=0;e<n.length;++e){
const r=n[e],s=e!==n.length-1||r!==m(t.slice(e));d(n[e]===t[e]||!s,(()=>`Error creating a new Tensor. Inferred shape (${n}) does not match the provided shape (${t}). `));
}
}return Lr(e)||Array.isArray(e)||(e=[e]),t=t||n,e="string"!==r?_r(e,r):zr(e,[],!0),vs.makeTensor(e,t,r);
}function Ds(e,t,n){
return _s(e,t,Ns(e,n),n);
}class Os{
static join(e){
return new Os(e).slice();
}constructor(e){
if(this.shards=[],this.previousShardIndex=0,null==e){
return;
}if(e instanceof Array||(e=[e]),0===(e=e.map((e=>Lr(e)?e.buffer:e))).length){
return;
}this.bufferUniformSize=e[0].byteLength;let t=0;for(let n=0;n<e.length;n++){
const r=e[n];n!==e.length-1&&r.byteLength!==this.bufferUniformSize&&(this.bufferUniformSize=void 0);const s=t+r.byteLength;this.shards.push({buffer:r,start:t,end:s}),t=s;
}0===this.shards.length&&(this.byteLength=0),this.byteLength=this.shards[this.shards.length-1].end;
}slice(e=0,t=this.byteLength){
if(0===this.shards.length){
return new ArrayBuffer(0);
}if(e=isNaN(Number(e))?0:e,t=isNaN(Number(t))?0:t,e=Math.max(0,e),(t=Math.min(this.byteLength,t))<=e){
return new ArrayBuffer(0);
}const n=this.findShardForByte(e);if(-1===n){
throw new Error(`Could not find start shard for byte ${e}`);
}const r=new ArrayBuffer(t-e),s=new Uint8Array(r);let i=0;for(let r=n;r<this.shards.length;r++){
const n=this.shards[r],a=e+i-n.start,o=i,u=Math.min(t,n.end)-n.start,l=new Uint8Array(n.buffer,a,u-a);if(s.set(l,o),i+=l.length,t<n.end){
break;
}
}return r;
}findShardForByte(e){
if(0===this.shards.length||e<0||e>=this.byteLength){
return-1;
}if(null!=this.bufferUniformSize){
return this.previousShardIndex=Math.floor(e/this.bufferUniformSize),this.previousShardIndex;
}function t(t){
return e<t.start?-1:e>=t.end?1:0;
}if(0===t(this.shards[this.previousShardIndex])){
return this.previousShardIndex;
}const n=function(e,t){
let n=0,r=e.length;for(;n<=r;){
const s=Math.floor((r-n)/2)+n,i=t(e[s]);if(0===i){
return s;
}i<0?r=s:n=s+1;
}return-1;
}(this.shards,t);return-1===n?-1:(this.previousShardIndex=n,this.previousShardIndex);
}
}async function Ms(e,t){
const n=[],r=[],s=Array.isArray(e)?e.map((e=>e.name)):Object.keys(e);for(let i=0;i<s.length;++i){
const a=s[i],o=Array.isArray(e)?e[i].tensor:e[a];if("float32"!==o.dtype&&"int32"!==o.dtype&&"bool"!==o.dtype&&"string"!==o.dtype&&"complex64"!==o.dtype){
throw new Error(`Unsupported dtype in weight '${a}': ${o.dtype}`);
}const u={name:a,shape:o.shape,dtype:o.dtype};if("string"===o.dtype){
const e=new Promise((async e=>{
const t=await o.bytes(),n=t.reduce(((e,t)=>e+t.length),0)+4*t.length,r=new Uint8Array(n);let s=0;for(let e=0;e<t.length;e++){
const n=t[e],i=new Uint8Array(new Uint32Array([n.length]).buffer);r.set(i,s),s+=4,r.set(n,s),s+=n.length;
}e(r);
}));r.push(e);
}else {
r.push(o.data());
}null!=t&&(u.group=t),n.push(u);
}return{data:Ls(await Promise.all(r)),specs:n};
}function Ls(e){
if(null===e){
throw new Error(`Invalid input value: ${JSON.stringify(e)}`);
}let t=0;const n=[];e.forEach((e=>{
if(t+=e.byteLength,n.push(e.byteLength===e.buffer.byteLength?e:new e.constructor(e)),!(e instanceof Float32Array||e instanceof Int32Array||e instanceof Uint8Array)){
throw new Error(`Unsupported TypedArray subtype: ${e.constructor.name}`);
}
}));const r=new Uint8Array(t);let s=0;return n.forEach((e=>{
r.set(new Uint8Array(e.buffer),s),s+=e.byteLength;
})),r.buffer;
}const zs="undefined"!=typeof Buffer&&("undefined"==typeof Blob||"undefined"==typeof atob||"undefined"==typeof btoa);function Ps(e){
return zs?Buffer.byteLength(e,"utf8"):new Blob([e]).size;
}function Bs(e,t){
const n={modelTopology:e.modelTopology,format:e.format,generatedBy:e.generatedBy,convertedBy:e.convertedBy,weightsManifest:t};return null!=e.signature&&(n.signature=e.signature),null!=e.userDefinedMetadata&&(n.userDefinedMetadata=e.userDefinedMetadata),null!=e.modelInitializer&&(n.modelInitializer=e.modelInitializer),null!=e.initializerSignature&&(n.initializerSignature=e.initializerSignature),null!=e.trainingConfig&&(n.trainingConfig=e.trainingConfig),n;
}function Us(e){
if(e.modelTopology instanceof ArrayBuffer){
throw new Error("Expected JSON model topology, received ArrayBuffer.");
}return{dateSaved:new Date,modelTopologyType:"JSON",modelTopologyBytes:null==e.modelTopology?0:Ps(JSON.stringify(e.modelTopology)),weightSpecsBytes:null==e.weightSpecs?0:Ps(JSON.stringify(e.weightSpecs)),weightDataBytes:null==e.weightData?0:new Os(e.weightData).byteLength};
}class Ws{
constructor(){
this.saveRouters=[],this.loadRouters=[];
}static getInstance(){
return null==Ws.instance&&(Ws.instance=new Ws),Ws.instance;
}static registerSaveRouter(e){
Ws.getInstance().saveRouters.push(e);
}static registerLoadRouter(e){
Ws.getInstance().loadRouters.push(e);
}static getSaveHandlers(e){
return Ws.getHandlers(e,"save");
}static getLoadHandlers(e,t){
return Ws.getHandlers(e,"load",t);
}static getHandlers(e,t,n){
const r=[];return("load"===t?Ws.getInstance().loadRouters:Ws.getInstance().saveRouters).forEach((t=>{
const s=t(e,n);null!==s&&r.push(s);
})),r;
}
}const Vs="tensorflowjs",Gs="models_store",js="model_info_store";function Hs(){
if(!H().getBool("IS_BROWSER")){
throw new Error("Failed to obtain IndexedDB factory because the current environmentis not a web browser.");
}const e="undefined"==typeof window?self:window,t=e.indexedDB||e.mozIndexedDB||e.webkitIndexedDB||e.msIndexedDB||e.shimIndexedDB;if(null==t){
throw new Error("The current browser does not appear to support IndexedDB.");
}return t;
}function qs(e){
const t=e.result;t.createObjectStore(Gs,{keyPath:"modelPath"}),t.createObjectStore(js,{keyPath:"modelPath"});
}class Ks{
constructor(e){
if(this.indexedDB=Hs(),null==e||!e){
throw new Error("For IndexedDB, modelPath must not be null, undefined or empty.");
}this.modelPath=e;
}async save(e){
if(e.modelTopology instanceof ArrayBuffer){
throw new Error("BrowserLocalStorage.save() does not support saving model topology in binary formats yet.");
}return this.databaseAction(this.modelPath,e);
}async load(){
return this.databaseAction(this.modelPath);
}databaseAction(e,t){
return new Promise(((e,n)=>{
const r=this.indexedDB.open(Vs,1);r.onupgradeneeded=()=>qs(r),r.onsuccess=()=>{
const s=r.result;if(null==t){
const t=s.transaction(Gs,"readonly"),r=t.objectStore(Gs).get(this.modelPath);r.onsuccess=()=>{
if(null==r.result){
return s.close(),n(new Error(`Cannot find model with path '${this.modelPath}' in IndexedDB.`));
}e(r.result.modelArtifacts);
},r.onerror=e=>(s.close(),n(r.error)),t.oncomplete=()=>s.close();
}else{
t.weightData=Os.join(t.weightData);const r=Us(t),i=s.transaction(js,"readwrite");let a,o,u=i.objectStore(js);try{
a=u.put({modelPath:this.modelPath,modelArtifactsInfo:r});
}catch(e){
return n(e);
}a.onsuccess=()=>{
o=s.transaction(Gs,"readwrite");const a=o.objectStore(Gs);let l;try{
l=a.put({modelPath:this.modelPath,modelArtifacts:t,modelArtifactsInfo:r});
}catch(e){
return n(e);
}l.onsuccess=()=>e({modelArtifactsInfo:r}),l.onerror=e=>{
u=i.objectStore(js);const t=u.delete(this.modelPath);t.onsuccess=()=>(s.close(),n(l.error)),t.onerror=e=>(s.close(),n(l.error));
};
},a.onerror=e=>(s.close(),n(a.error)),i.oncomplete=()=>{
null==o?s.close():o.oncomplete=()=>s.close();
};
}
},r.onerror=e=>n(r.error);
}));
}
}Ks.URL_SCHEME="indexeddb://";const Xs=e=>{
return H().getBool("IS_BROWSER")&&!Array.isArray(e)&&e.startsWith(Ks.URL_SCHEME)?(t=e.slice(Ks.URL_SCHEME.length),new Ks(t)):null;var t;
};Ws.registerSaveRouter(Xs),Ws.registerLoadRouter(Xs);class Ys{
constructor(){
this.indexedDB=Hs();
}async listModels(){
return new Promise(((e,t)=>{
const n=this.indexedDB.open(Vs,1);n.onupgradeneeded=()=>qs(n),n.onsuccess=()=>{
const r=n.result,s=r.transaction(js,"readonly"),i=s.objectStore(js).getAll();i.onsuccess=()=>{
const t={};for(const e of i.result){
t[e.modelPath]=e.modelArtifactsInfo;
}e(t);
},i.onerror=e=>(r.close(),t(i.error)),s.oncomplete=()=>r.close();
},n.onerror=e=>t(n.error);
}));
}async removeModel(e){
var t;return e=(t=e).startsWith(Ks.URL_SCHEME)?t.slice(Ks.URL_SCHEME.length):t,new Promise(((t,n)=>{
const r=this.indexedDB.open(Vs,1);r.onupgradeneeded=()=>qs(r),r.onsuccess=()=>{
const s=r.result,i=s.transaction(js,"readwrite"),a=i.objectStore(js),o=a.get(e);let u;o.onsuccess=()=>{
if(null==o.result){
return s.close(),n(new Error(`Cannot find model with path '${e}' in IndexedDB.`));
}{const r=a.delete(e),i=()=>{
u=s.transaction(Gs,"readwrite");const r=u.objectStore(Gs).delete(e);r.onsuccess=()=>t(o.result.modelArtifactsInfo),r.onerror=e=>n(o.error);
};r.onsuccess=i,r.onerror=e=>(i(),s.close(),n(o.error));}
},o.onerror=e=>(s.close(),n(o.error)),i.oncomplete=()=>{
null==u?s.close():u.oncomplete=()=>s.close();
};
},r.onerror=e=>n(r.error);
}));
}
}const Zs="/",Js="tensorflowjs_models",Qs="info",ei="model_topology",ti="weight_specs",ni="weight_data",ri="model_metadata";function si(e){
return{info:[Js,e,Qs].join(Zs),topology:[Js,e,ei].join(Zs),weightSpecs:[Js,e,ti].join(Zs),weightData:[Js,e,ni].join(Zs),modelMetadata:[Js,e,ri].join(Zs)};
}function ii(e){
for(const t of Object.values(e)){
window.localStorage.removeItem(t);
}
}function ai(e){
const t=e.split(Zs);if(t.length<3){
throw new Error(`Invalid key format: ${e}`);
}return t.slice(1,t.length-1).join(Zs);
}class oi{
constructor(e){
if(!H().getBool("IS_BROWSER")||"undefined"==typeof window||void 0===window.localStorage){
throw new Error("The current environment does not support local storage.");
}if(this.LS=window.localStorage,null==e||!e){
throw new Error("For local storage, modelPath must not be null, undefined or empty.");
}this.modelPath=e,this.keys=si(this.modelPath);
}async save(e){
if(e.modelTopology instanceof ArrayBuffer){
throw new Error("BrowserLocalStorage.save() does not support saving model topology in binary formats yet.");
}{const t=JSON.stringify(e.modelTopology),n=JSON.stringify(e.weightSpecs),r=Us(e),s=Os.join(e.weightData);try{
this.LS.setItem(this.keys.info,JSON.stringify(r)),this.LS.setItem(this.keys.topology,t),this.LS.setItem(this.keys.weightSpecs,n),this.LS.setItem(this.keys.weightData,function(e){
if(zs){
return Buffer.from(e).toString("base64");
}const t=new Uint8Array(e);let n="";for(let e=0,r=t.length;e<r;e++){
n+=String.fromCharCode(t[e]);
}return btoa(n);
}(s));const i={format:e.format,generatedBy:e.generatedBy,convertedBy:e.convertedBy,signature:null!=e.signature?e.signature:void 0,userDefinedMetadata:null!=e.userDefinedMetadata?e.userDefinedMetadata:void 0,modelInitializer:null!=e.modelInitializer?e.modelInitializer:void 0,initializerSignature:null!=e.initializerSignature?e.initializerSignature:void 0,trainingConfig:null!=e.trainingConfig?e.trainingConfig:void 0};return this.LS.setItem(this.keys.modelMetadata,JSON.stringify(i)),{modelArtifactsInfo:r};
}catch(e){
throw ii(this.keys),new Error(`Failed to save model '${this.modelPath}' to local storage: size quota being exceeded is a possible cause of this failure: modelTopologyBytes=${r.modelTopologyBytes}, weightSpecsBytes=${r.weightSpecsBytes}, weightDataBytes=${r.weightDataBytes}.`);
}}
}async load(){
const e=JSON.parse(this.LS.getItem(this.keys.info));if(null==e){
throw new Error(`In local storage, there is no model with name '${this.modelPath}'`);
}if("JSON"!==e.modelTopologyType){
throw new Error("BrowserLocalStorage does not support loading non-JSON model topology yet.");
}const t={},n=JSON.parse(this.LS.getItem(this.keys.topology));if(null==n){
throw new Error(`In local storage, the topology of model '${this.modelPath}' is missing.`);
}t.modelTopology=n;const r=JSON.parse(this.LS.getItem(this.keys.weightSpecs));if(null==r){
throw new Error(`In local storage, the weight specs of model '${this.modelPath}' are missing.`);
}t.weightSpecs=r;const s=this.LS.getItem(this.keys.modelMetadata);if(null!=s){
const e=JSON.parse(s);t.format=e.format,t.generatedBy=e.generatedBy,t.convertedBy=e.convertedBy,null!=e.signature&&(t.signature=e.signature),null!=e.userDefinedMetadata&&(t.userDefinedMetadata=e.userDefinedMetadata),null!=e.modelInitializer&&(t.modelInitializer=e.modelInitializer),null!=e.initializerSignature&&(t.initializerSignature=e.initializerSignature),null!=e.trainingConfig&&(t.trainingConfig=e.trainingConfig);
}const i=this.LS.getItem(this.keys.weightData);if(null==i){
throw new Error(`In local storage, the binary weight values of model '${this.modelPath}' are missing.`);
}return t.weightData=function(e){
if(zs){
const t=Buffer.from(e,"base64");return t.buffer.slice(t.byteOffset,t.byteOffset+t.byteLength);
}const t=atob(e),n=new Uint8Array(t.length);for(let e=0;e<t.length;++e){
n.set([t.charCodeAt(e)],e);
}return n.buffer;
}(i),t;
}
}oi.URL_SCHEME="localstorage://";const ui=e=>{
return H().getBool("IS_BROWSER")&&!Array.isArray(e)&&e.startsWith(oi.URL_SCHEME)?(t=e.slice(oi.URL_SCHEME.length),new oi(t)):null;var t;
};Ws.registerSaveRouter(ui),Ws.registerLoadRouter(ui);class li{
constructor(){
d(H().getBool("IS_BROWSER"),(()=>"Current environment is not a web browser")),d("undefined"==typeof window||void 0!==window.localStorage,(()=>"Current browser does not appear to support localStorage")),this.LS=window.localStorage;
}async listModels(){
const e={},t=Js+Zs,n=Zs+Qs;for(let r=0;r<this.LS.length;++r){
const s=this.LS.key(r);s.startsWith(t)&&s.endsWith(n)&&(e[ai(s)]=JSON.parse(this.LS.getItem(s)));
}return e;
}async removeModel(e){
var t;const n=si(e=(t=e).startsWith(oi.URL_SCHEME)?t.slice(oi.URL_SCHEME.length):t);if(null==this.LS.getItem(n.info)){
throw new Error(`Cannot find model at path '${e}'`);
}const r=JSON.parse(this.LS.getItem(n.info));return ii(n),r;
}
}class ci{
constructor(){
this.managers={};
}static getInstance(){
return null==ci.instance&&(ci.instance=new ci),ci.instance;
}static registerManager(e,t){
d(null!=e,(()=>"scheme must not be undefined or null.")),e.endsWith("://")&&(e=e.slice(0,e.indexOf("://"))),d(e.length>0,(()=>"scheme must not be an empty string."));const n=ci.getInstance();d(null==n.managers[e],(()=>`A model store manager is already registered for scheme '${e}'.`)),n.managers[e]=t;
}static getManager(e){
const t=ci.getInstance().managers[e];if(null==t){
throw new Error(`Cannot find model manager for scheme '${e}'`);
}return t;
}static getSchemes(){
return Object.keys(ci.getInstance().managers);
}
}class hi{
constructor(){
this.messageName="setTimeoutCustom",this.functionRefs=[],this.handledMessageCount=0,this.hasEventListener=!1;
}fetch(e,t){
return fetch(e,t);
}now(){
return performance.now();
}encode(e,t){
if("utf-8"!==t&&"utf8"!==t){
throw new Error(`Browser's encoder only supports utf-8, but got ${t}`);
}return null==this.textEncoder&&(this.textEncoder=new TextEncoder),this.textEncoder.encode(e);
}decode(e,t){
return new TextDecoder(t).decode(e);
}setTimeoutCustom(e,t){
"undefined"!=typeof window&&H().getBool("USE_SETTIMEOUTCUSTOM")?(this.functionRefs.push(e),setTimeout((()=>{
window.postMessage({name:this.messageName,index:this.functionRefs.length-1},"*");
}),t),this.hasEventListener||(this.hasEventListener=!0,window.addEventListener("message",(e=>{
e.source===window&&e.data.name===this.messageName&&(e.stopPropagation(),(0,this.functionRefs[e.data.index])(),this.handledMessageCount++,this.handledMessageCount===this.functionRefs.length&&(this.functionRefs=[],this.handledMessageCount=0));
}),!0))):setTimeout(e,t);
}isTypedArray(e){
return br(e);
}
}if(H().get("IS_BROWSER")){
H().setPlatform("browser",new hi);try{
ci.registerManager(oi.URL_SCHEME,new li);
}catch(e){}try{
ci.registerManager(Ks.URL_SCHEME,new Ys);
}catch(e){}
}let di;function pi(e,t="float32",n){
return t=t||"float32",P(e),new Yr(e,t,n);
}H().get("IS_NODE")&&!H().get("IS_BROWSER")&&H().setPlatform("node",new class{
constructor(){
this.util=__webpack_require__(843),this.textEncoder=new this.util.TextEncoder;
}fetch(e,t){
return null!=H().global.fetch?H().global.fetch(e,t):(null==di&&(di=__webpack_require__(327)),di(e,t));
}now(){
const e=process.hrtime();return 1e3*e[0]+e[1]/1e6;
}encode(e,t){
if("utf-8"!==t&&"utf8"!==t){
throw new Error(`Node built-in encoder only supports utf-8, but got ${t}`);
}return this.textEncoder.encode(e);
}decode(e,t){
return 0===e.length?"":new this.util.TextDecoder(t).decode(e);
}isTypedArray(e){
return this.util.types.isFloat32Array(e)||this.util.types.isInt32Array(e)||this.util.types.isUint8Array(e)||this.util.types.isUint8ClampedArray(e);
}
});const fi=As({cast_:function(e,t){
const n=Es(e,"x","cast");if(!function(e){
return"bool"===e||"complex64"===e||"float32"===e||"int32"===e||"string"===e;
}(t)){
throw new Error(`Failed to cast to unknown dtype ${t}`);
}if("string"===t&&"string"!==n.dtype||"string"!==t&&"string"===n.dtype){
throw new Error("Only strings can be casted to strings");
}const r={x:n},s={dtype:t};return vs.runKernel(we,r,s);
}}),mi=As({clone_:function(e){
const t={x:Es(e,"x","clone","string_or_numeric")};return vs.runKernel(ht,t);
}});function gi(){
return vs;
}function bi(){
return vs.memory();
}function xi(e,t){
return vs.tidy(e,t);
}function yi(e){
ms(e).forEach((e=>e.dispose()));
}function wi(e){
return vs.keep(e);
}function vi(e,t,n=1){
return vs.registerBackend(e,t,n);
}ws(),Jr={buffer:pi,cast:fi,clone:mi,print:function(e,t=!1){
console.log(e.toString(t));
}},Qr=function(e){
H().getBool("DEPRECATION_WARNINGS_ENABLED")&&console.warn(e+" You can disable deprecation warnings with tf.disableDeprecationWarnings().");
};const ki=As({add_:function(e,t){
let n=Es(e,"a","add"),r=Es(t,"b","add");[n,r]=ps(n,r);const s={a:n,b:r};return vs.runKernel(ee,s);
}}),Ii=As({floorDiv_:function(e,t){
let n=Es(e,"a","floorDiv"),r=Es(t,"b","floorDiv");[n,r]=ps(n,r);const s={a:n,b:r};return vs.runKernel(it,s);
}}),Si=As({div_:function(e,t){
let n=Es(e,"a","div"),r=Es(t,"b","div");if([n,r]=ps(n,r),"int32"===n.dtype&&"int32"===r.dtype){
return Ii(n,r);
}const s={a:n,b:r};return vs.runKernel(He,s,{});
}}),Ci=As({mul_:function(e,t){
let n=Es(e,"a","mul"),r=Es(t,"b","mul");[n,r]=ps(n,r);const s={a:n,b:r};return vs.runKernel(Ut,s);
}}),Ni=As({sqrt_:function(e){
const t={x:Es(e,"x","sqrt","float32")};return vs.runKernel(Tn,t);
}}),$i=As({square_:function(e){
const t=Es(e,"x","square");return vs.runKernel("Square",{x:t},{});
}}),Ti=As({zerosLike_:function(e){
const t={x:Es(e,"x","zerosLike")};return vs.runKernel(tr,t);
}});function Ei(e){
return vs.customGrad(e);
}function Ri(e,t){
if((Lr(e)&&"string"!==t||Array.isArray(e))&&"complex64"!==t){
throw new Error("Error creating a new Scalar: value must be a primitive (number|boolean|string)");
}if("string"===t&&Lr(e)&&!(e instanceof Uint8Array)){
throw new Error("When making a scalar from encoded string, the value must be `Uint8Array`.");
}return _s(e,[],[],t);
}const Ai=new Map,Fi=new Map;class _i{
getClassName(){
return this.constructor.className;
}static fromConfig(e,t){
return new e(t);
}
}class Di{
constructor(){
this.classNameMap={};
}static getMap(){
return null==Di.instance&&(Di.instance=new Di),Di.instance;
}static register(e){
Di.getMap().classNameMap[e.className]=[e,e.fromConfig];
}
}function Oi(e,t,n){
d(null!=e.className,(()=>"Class being registered does not have the static className property defined.")),d("string"==typeof e.className,(()=>"className is required to be a string, but got type "+typeof e.className)),d(e.className.length>0,(()=>"Class being registered has an empty-string as its className, which is disallowed.")),void 0===t&&(t="Custom"),void 0===n&&(n=e.className);const r=t+">"+n;return Di.register(e),Ai.set(r,e),Fi.set(e,r),e;
}class Mi extends _i{
minimize(e,t=!1,n){
const{value:r,grads:s}=this.computeGradients(e,n);if(null!=n){
const e=n.map((e=>({name:e.name,tensor:s[e.name]})));this.applyGradients(e);
}else {
this.applyGradients(s);
}return yi(s),t?r:(r.dispose(),null);
}get iterations(){
return null==this.iterations_&&(this.iterations_=0),this.iterations_;
}incrementIterations(){
this.iterations_=this.iterations+1;
}computeGradients(e,t){
return function(e,t){
d(A(e),(()=>"The f passed in variableGrads(f) must be a function")),d(null==t||Array.isArray(t)&&t.every((e=>e instanceof ns)),(()=>"The varList passed in variableGrads(f, varList) must be an array of variables"));const n=null!=t;if(!n){
t=[];for(const e in vs.registeredVariables){
t.push(vs.registeredVariables[e]);
}
}const r=n?t.filter((e=>!e.trainable)):null,s=t.length;d((t=t.filter((e=>e.trainable))).length>0,(()=>`variableGrads() expects at least one of the input variables to be trainable, but none of the ${s} variables is trainable.`));const{value:i,grads:a}=vs.gradients(e,t,null,!0);d(a.some((e=>null!=e)),(()=>"Cannot find a connection between any variable and the result of the loss function y=f(x). Please make sure the operations that use variables are inside the function f passed to minimize().")),d(0===i.rank,(()=>`The f passed in variableGrads(f) must return a scalar, but it returned a rank-${i.rank} tensor`));const o={};return t.forEach(((e,t)=>{
null!=a[t]&&(o[e.name]=a[t]);
})),null!=r&&r.forEach((e=>o[e.name]=null)),{value:i,grads:o};
}(e,t);
}dispose(){
null!=this.iterations_&&yi(this.iterations_);
}async saveIterations(){
return null==this.iterations_&&(this.iterations_=0),{name:"iter",tensor:Ri(this.iterations_,"int32")};
}async getWeights(){
throw new Error("getWeights() is not implemented for this optimizer yet.");
}async setWeights(e){
throw new Error(`setWeights() is not implemented for this optimizer class ${this.getClassName()}`);
}async extractIterations(e){
return this.iterations_=(await e[0].tensor.data())[0],e.slice(1);
}
}Object.defineProperty(Mi,Symbol.hasInstance,{value:e=>null!=e.minimize&&null!=e.computeGradients&&null!=e.applyGradients});class Li extends Mi{
static get className(){
return"Adadelta";
}constructor(e,t,n=null){
super(),this.learningRate=e,this.rho=t,this.epsilon=n,this.accumulatedGrads=[],this.accumulatedUpdates=[],null==n&&(this.epsilon=vs.backend.epsilon());
}applyGradients(e){
(Array.isArray(e)?e.map((e=>e.name)):Object.keys(e)).forEach(((t,n)=>{
const r=vs.registeredVariables[t];null==this.accumulatedGrads[n]&&(this.accumulatedGrads[n]={originalName:`${t}/accum_grad`,variable:xi((()=>Ti(r).variable(!1)))}),null==this.accumulatedUpdates[n]&&(this.accumulatedUpdates[n]={originalName:`${t}/accum_var`,variable:xi((()=>Ti(r).variable(!1)))});const s=Array.isArray(e)?e[n].tensor:e[t];if(null==s){
return;
}const i=this.accumulatedGrads[n].variable,a=this.accumulatedUpdates[n].variable;xi((()=>{
const e=ki(Ci(i,this.rho),Ci($i(s),1-this.rho)),t=Ci(Si(Ni(ki(a,this.epsilon)),Ni(ki(i,this.epsilon))),s),n=ki(Ci(a,this.rho),Ci($i(t),1-this.rho));i.assign(e),a.assign(n);const o=ki(Ci(t,-this.learningRate),r);r.assign(o);
}));
})),this.incrementIterations();
}dispose(){
null!=this.accumulatedUpdates&&(yi(this.accumulatedGrads.map((e=>e.variable))),yi(this.accumulatedUpdates.map((e=>e.variable))));
}async getWeights(){
const e=[...this.accumulatedGrads,...this.accumulatedUpdates];return[await this.saveIterations()].concat(e.map((e=>({name:e.originalName,tensor:e.variable}))));
}async setWeights(e){
const t=(e=await this.extractIterations(e)).length/2;this.accumulatedGrads=e.slice(0,t).map((e=>({originalName:e.name,variable:e.tensor.variable(!1)}))),this.accumulatedUpdates=e.slice(t,2*t).map((e=>({originalName:e.name,variable:e.tensor.variable(!1)})));
}getConfig(){
return{learningRate:this.learningRate,rho:this.rho,epsilon:this.epsilon};
}static fromConfig(e,t){
return new e(t.learningRate,t.rho,t.epsilon);
}
}function zi(e,t,n){
P(e);const r={shape:e,value:t,dtype:n=n||R(t)};return vs.runKernel(nt,{},r);
}class Pi extends Mi{
static get className(){
return"Adagrad";
}constructor(e,t=.1){
super(),this.learningRate=e,this.initialAccumulatorValue=t,this.accumulatedGrads=[];
}applyGradients(e){
(Array.isArray(e)?e.map((e=>e.name)):Object.keys(e)).forEach(((t,n)=>{
const r=vs.registeredVariables[t];if(null==this.accumulatedGrads[n]){
const e=!1;this.accumulatedGrads[n]={originalName:`${t}/accumulator`,variable:xi((()=>zi(r.shape,this.initialAccumulatorValue).variable(e)))};
}const s=Array.isArray(e)?e[n].tensor:e[t];if(null==s){
return;
}const i=this.accumulatedGrads[n].variable;xi((()=>{
const e=ki(i,$i(s));i.assign(e);const t=ki(Ci(Si(s,Ni(ki(e,vs.backend.epsilon()))),-this.learningRate),r);r.assign(t);
}));
})),this.incrementIterations();
}dispose(){
null!=this.accumulatedGrads&&yi(this.accumulatedGrads.map((e=>e.variable)));
}async getWeights(){
return[await this.saveIterations()].concat(this.accumulatedGrads.map((e=>({name:e.originalName,tensor:e.variable}))));
}async setWeights(e){
e=await this.extractIterations(e),this.accumulatedGrads=e.map((e=>({originalName:e.name,variable:e.tensor.variable(!1)})));
}getConfig(){
return{learningRate:this.learningRate,initialAccumulatorValue:this.initialAccumulatorValue};
}static fromConfig(e,t){
return new e(t.learningRate,t.initialAccumulatorValue);
}
}const Bi=As({pow_:function(e,t){
let n=Es(e,"base","pow"),r=Es(t,"exp","pow");[n,r]=ps(n,r);const s={a:n,b:r};return vs.runKernel(Zt,s);
}}),Ui=As({sub_:function(e,t){
let n=Es(e,"a","sub"),r=Es(t,"b","sub");[n,r]=ps(n,r);const s={a:n,b:r};return vs.runKernel(jn,s);
}});class Wi extends Mi{
static get className(){
return"Adam";
}constructor(e,t,n,r=null){
super(),this.learningRate=e,this.beta1=t,this.beta2=n,this.epsilon=r,this.accumulatedFirstMoment=[],this.accumulatedSecondMoment=[],xi((()=>{
this.accBeta1=Ri(t).variable(),this.accBeta2=Ri(n).variable();
})),null==r&&(this.epsilon=vs.backend.epsilon());
}applyGradients(e){
const t=Array.isArray(e)?e.map((e=>e.name)):Object.keys(e);xi((()=>{
const n=Ui(1,this.accBeta1),r=Ui(1,this.accBeta2);t.forEach(((t,s)=>{
const i=vs.registeredVariables[t];null==this.accumulatedFirstMoment[s]&&(this.accumulatedFirstMoment[s]={originalName:`${t}/m`,variable:xi((()=>Ti(i).variable(!1)))}),null==this.accumulatedSecondMoment[s]&&(this.accumulatedSecondMoment[s]={originalName:`${t}/v`,variable:xi((()=>Ti(i).variable(!1)))});const a=Array.isArray(e)?e[s].tensor:e[t];if(null==a){
return;
}const o=this.accumulatedFirstMoment[s].variable,u=this.accumulatedSecondMoment[s].variable,l=ki(Ci(o,this.beta1),Ci(a,1-this.beta1)),c=ki(Ci(u,this.beta2),Ci($i(a),1-this.beta2)),h=Si(l,n),d=Si(c,r);o.assign(l),u.assign(c);const p=ki(Ci(Si(h,ki(Ni(d),this.epsilon)),-this.learningRate),i);i.assign(p);
})),this.accBeta1.assign(Ci(this.accBeta1,this.beta1)),this.accBeta2.assign(Ci(this.accBeta2,this.beta2));
})),this.incrementIterations();
}dispose(){
this.accBeta1.dispose(),this.accBeta2.dispose(),null!=this.accumulatedFirstMoment&&yi(this.accumulatedFirstMoment.map((e=>e.variable))),null!=this.accumulatedSecondMoment&&yi(this.accumulatedSecondMoment.map((e=>e.variable)));
}async getWeights(){
const e=[...this.accumulatedFirstMoment,...this.accumulatedSecondMoment];return[await this.saveIterations()].concat(e.map((e=>({name:e.originalName,tensor:e.variable}))));
}async setWeights(e){
e=await this.extractIterations(e),xi((()=>{
this.accBeta1.assign(Bi(this.beta1,this.iterations_+1)),this.accBeta2.assign(Bi(this.beta2,this.iterations_+1));
}));const t=e.length/2;this.accumulatedFirstMoment=e.slice(0,t).map((e=>({originalName:e.name,variable:e.tensor.variable(!1)}))),this.accumulatedSecondMoment=e.slice(t,2*t).map((e=>({originalName:e.name,variable:e.tensor.variable(!1)})));
}getConfig(){
return{learningRate:this.learningRate,beta1:this.beta1,beta2:this.beta2,epsilon:this.epsilon};
}static fromConfig(e,t){
return new e(t.learningRate,t.beta1,t.beta2,t.epsilon);
}
}const Vi=As({abs_:function(e){
const t=Es(e,"x","abs");if("complex64"===t.dtype){
const e={x:t};return vs.runKernel(Se,e);
}{const e={x:t};return vs.runKernel(Z,e);}
}});function Gi(e,t){
const n=e.length,r=[];for(let s=0;s<n;s++){
const i=n-1-s,a=e[i]||1;(t[t.length-1-s]||1)>1&&1===a&&r.unshift(i);
}return r;
}function ji(e,t){
const n=[];for(let r=0;r<t.length;r++){
const s=e[e.length-r-1],i=t.length-r-1,a=t[i];(null==s||1===s&&a>1)&&n.unshift(i);
}return n;
}function Hi(e,t){
const n=Math.max(e.length,t.length),r=new Array(n);for(let s=0;s<n;s++){
let i=e[e.length-s-1];null==i&&(i=1);let a=t[t.length-s-1];if(null==a&&(a=1),1===i){
r[n-s-1]=a;
}else if(1===a){
r[n-s-1]=i;
}else{
if(i!==a){
throw Error(`Operands could not be broadcast together with shapes ${e} and ${t}.`);
}r[n-s-1]=i;
}
}return r;
}const qi=As({maximum_:function(e,t){
let n=Es(e,"a","maximum"),r=Es(t,"b","maximum");[n,r]=ps(n,r),"bool"===n.dtype&&(n=fi(n,"int32"),r=fi(r,"int32")),Hi(n.shape,r.shape);const s={a:n,b:r};return vs.runKernel(Et,s);
}});class Ki extends Mi{
static get className(){
return"Adamax";
}constructor(e,t,n,r=null,s=0){
super(),this.learningRate=e,this.beta1=t,this.beta2=n,this.epsilon=r,this.decay=s,this.accumulatedFirstMoment=[],this.accumulatedWeightedInfNorm=[],xi((()=>{
this.iteration=Ri(0).variable(),this.accBeta1=Ri(t).variable();
})),null==r&&(this.epsilon=vs.backend.epsilon());
}applyGradients(e){
const t=Array.isArray(e)?e.map((e=>e.name)):Object.keys(e);xi((()=>{
const n=Ui(1,this.accBeta1),r=Si(-this.learningRate,ki(Ci(this.iteration,this.decay),1));t.forEach(((t,s)=>{
const i=vs.registeredVariables[t];null==this.accumulatedFirstMoment[s]&&(this.accumulatedFirstMoment[s]={originalName:`${t}/m`,variable:Ti(i).variable(!1)}),null==this.accumulatedWeightedInfNorm[s]&&(this.accumulatedWeightedInfNorm[s]={originalName:`${t}/v`,variable:Ti(i).variable(!1)});const a=Array.isArray(e)?e[s].tensor:e[t];if(null==a){
return;
}const o=this.accumulatedFirstMoment[s].variable,u=this.accumulatedWeightedInfNorm[s].variable,l=ki(Ci(o,this.beta1),Ci(a,1-this.beta1)),c=Ci(u,this.beta2),h=Vi(a),d=qi(c,h);o.assign(l),u.assign(d);const p=ki(Ci(Si(r,n),Si(l,ki(d,this.epsilon))),i);i.assign(p);
})),this.iteration.assign(ki(this.iteration,1)),this.accBeta1.assign(Ci(this.accBeta1,this.beta1));
})),this.incrementIterations();
}dispose(){
this.accBeta1.dispose(),this.iteration.dispose(),null!=this.accumulatedFirstMoment&&yi(this.accumulatedFirstMoment.map((e=>e.variable))),null!=this.accumulatedWeightedInfNorm&&yi(this.accumulatedWeightedInfNorm.map((e=>e.variable)));
}async getWeights(){
throw new Error("getWeights() is not implemented for Adamax yet.");
}async setWeights(e){
throw new Error("setWeights() is not implemented for Adamax yet.");
}getConfig(){
return{learningRate:this.learningRate,beta1:this.beta1,beta2:this.beta2,epsilon:this.epsilon,decay:this.decay};
}static fromConfig(e,t){
return new e(t.learningRate,t.beta1,t.beta2,t.epsilon,t.decay);
}
}class Xi extends Mi{
static get className(){
return"SGD";
}constructor(e){
super(),this.learningRate=e,this.setLearningRate(e);
}applyGradients(e){
(Array.isArray(e)?e.map((e=>e.name)):Object.keys(e)).forEach(((t,n)=>{
const r=Array.isArray(e)?e[n].tensor:e[t];if(null==r){
return;
}const s=vs.registeredVariables[t];xi((()=>{
const e=ki(Ci(this.c,r),s);s.assign(e);
}));
})),this.incrementIterations();
}setLearningRate(e){
this.learningRate=e,null!=this.c&&this.c.dispose(),this.c=wi(Ri(-e));
}dispose(){
this.c.dispose();
}async getWeights(){
return[await this.saveIterations()];
}async setWeights(e){
if(0!==(e=await this.extractIterations(e)).length){
throw new Error("SGD optimizer does not have settable weights.");
}
}getConfig(){
return{learningRate:this.learningRate};
}static fromConfig(e,t){
return new e(t.learningRate);
}
}class Yi extends Xi{
static get className(){
return"Momentum";
}constructor(e,t,n=!1){
super(e),this.learningRate=e,this.momentum=t,this.useNesterov=n,this.accumulations=[],this.m=Ri(this.momentum);
}applyGradients(e){
(Array.isArray(e)?e.map((e=>e.name)):Object.keys(e)).forEach(((t,n)=>{
const r=vs.registeredVariables[t];if(null==this.accumulations[n]){
const e=!1;this.accumulations[n]={originalName:`${t}/momentum`,variable:xi((()=>Ti(r).variable(e)))};
}const s=this.accumulations[n].variable,i=Array.isArray(e)?e[n].tensor:e[t];null!=i&&xi((()=>{
let e;const t=ki(Ci(this.m,s),i);e=this.useNesterov?ki(Ci(this.c,ki(i,Ci(t,this.m))),r):ki(Ci(this.c,t),r),s.assign(t),r.assign(e);
}));
})),this.incrementIterations();
}dispose(){
this.m.dispose(),null!=this.accumulations&&yi(this.accumulations.map((e=>e.variable)));
}setMomentum(e){
this.momentum=e;
}async getWeights(){
return[await this.saveIterations()].concat(this.accumulations.map((e=>({name:e.originalName,tensor:e.variable}))));
}async setWeights(e){
e=await this.extractIterations(e),this.accumulations=e.map((e=>({originalName:e.name,variable:e.tensor.variable(!1)})));
}getConfig(){
return{learningRate:this.learningRate,momentum:this.momentum,useNesterov:this.useNesterov};
}static fromConfig(e,t){
return new e(t.learningRate,t.momentum,t.useNesterov);
}
}class Zi extends Mi{
static get className(){
return"RMSProp";
}constructor(e,t=.9,n=0,r=null,s=!1){
if(super(),this.learningRate=e,this.decay=t,this.momentum=n,this.epsilon=r,this.accumulatedMeanSquares=[],this.accumulatedMoments=[],this.accumulatedMeanGrads=[],this.centered=s,null==r&&(this.epsilon=vs.backend.epsilon()),null==e){
throw new Error("learningRate for RMSPropOptimizer must be defined.");
}
}applyGradients(e){
(Array.isArray(e)?e.map((e=>e.name)):Object.keys(e)).forEach(((t,n)=>{
const r=vs.registeredVariables[t],s=!1;null==this.accumulatedMeanSquares[n]&&(this.accumulatedMeanSquares[n]={originalName:`${t}/rms`,variable:xi((()=>Ti(r).variable(s)))}),null==this.accumulatedMoments[n]&&(this.accumulatedMoments[n]={originalName:`${t}/momentum`,variable:xi((()=>Ti(r).variable(s)))}),null==this.accumulatedMeanGrads[n]&&this.centered&&(this.accumulatedMeanGrads[n]={originalName:`${t}/mg`,variable:xi((()=>Ti(r).variable(s)))});const i=Array.isArray(e)?e[n].tensor:e[t];if(null==i){
return;
}const a=this.accumulatedMeanSquares[n].variable,o=this.accumulatedMoments[n].variable;xi((()=>{
const e=ki(Ci(a,this.decay),Ci($i(i),1-this.decay));if(this.centered){
const t=this.accumulatedMeanGrads[n].variable,s=ki(Ci(t,this.decay),Ci(i,1-this.decay)),u=Si(Ci(i,this.learningRate),Ni(Ui(e,ki($i(s),this.epsilon)))),l=ki(Ci(o,this.momentum),u);a.assign(e),t.assign(s),o.assign(l);const c=Ui(r,l);r.assign(c);
}else{
const e=ki(Ci(a,this.decay),Ci($i(i),1-this.decay)),t=ki(Ci(o,this.momentum),Si(Ci(i,this.learningRate),Ni(ki(e,this.epsilon))));a.assign(e),o.assign(t);const n=Ui(r,t);r.assign(n);
}
}));
})),this.incrementIterations();
}dispose(){
null!=this.accumulatedMeanSquares&&yi(this.accumulatedMeanSquares.map((e=>e.variable))),null!=this.accumulatedMeanGrads&&this.centered&&yi(this.accumulatedMeanGrads.map((e=>e.variable))),null!=this.accumulatedMoments&&yi(this.accumulatedMoments.map((e=>e.variable)));
}async getWeights(){
const e=[...this.accumulatedMeanSquares,...this.accumulatedMoments];return this.centered&&e.push(...this.accumulatedMeanGrads),[await this.saveIterations()].concat(e.map((e=>({name:e.originalName,tensor:e.variable}))));
}async setWeights(e){
e=await this.extractIterations(e);const t=this.centered?e.length/3:e.length/2,n=!1;this.accumulatedMeanSquares=e.slice(0,t).map((e=>({originalName:e.name,variable:e.tensor.variable(n)}))),this.accumulatedMoments=e.slice(t,2*t).map((e=>({originalName:e.name,variable:e.tensor.variable(n)}))),this.centered&&(this.accumulatedMeanGrads=e.slice(2*t,3*t).map((e=>({originalName:e.name,variable:e.tensor.variable(n)}))));
}getConfig(){
return{learningRate:this.learningRate,decay:this.decay,momentum:this.momentum,epsilon:this.epsilon,centered:this.centered};
}static fromConfig(e,t){
return new e(t.learningRate,t.decay,t.momentum,t.epsilon,t.centered);
}
}const Ji=[Li,Pi,Wi,Ki,Yi,Zi,Xi];function Qi(e){
return new Promise((e=>setTimeout(e))).then(e);
}class ea{
constructor(e){
if(!H().getBool("IS_BROWSER")){
throw new Error("browserDownloads() cannot proceed because the current environment is not a browser.");
}e.startsWith(ea.URL_SCHEME)&&(e=e.slice(ea.URL_SCHEME.length)),null!=e&&0!==e.length||(e="model"),this.modelJsonFileName=e+".json",this.weightDataFileName=e+".weights.bin";
}async save(e){
if("undefined"==typeof document){
throw new Error("Browser downloads are not supported in this environment since `document` is not present");
}const t=Os.join(e.weightData),n=window.URL.createObjectURL(new Blob([t],{type:"application/octet-stream"}));if(e.modelTopology instanceof ArrayBuffer){
throw new Error("BrowserDownloads.save() does not support saving model topology in binary formats yet.");
}{const t=Bs(e,[{paths:["./"+this.weightDataFileName],weights:e.weightSpecs}]),r=window.URL.createObjectURL(new Blob([JSON.stringify(t)],{type:"application/json"})),s=null==this.modelJsonAnchor?document.createElement("a"):this.modelJsonAnchor;if(s.download=this.modelJsonFileName,s.href=r,await Qi((()=>s.dispatchEvent(new MouseEvent("click")))),null!=e.weightData){
const e=null==this.weightDataAnchor?document.createElement("a"):this.weightDataAnchor;e.download=this.weightDataFileName,e.href=n,await Qi((()=>e.dispatchEvent(new MouseEvent("click"))));
}return{modelArtifactsInfo:Us(e)};}
}
}function ta(e,t,n,r){
!function(e){
d(null!=e&&Array.isArray(e)&&e.length>0,(()=>"promises must be a none empty array"));
}(e),function(e,t){
d(e>=0&&e<=1,(()=>`Progress fraction must be in range [0, 1], but got startFraction ${e}`)),d(t>=0&&t<=1,(()=>`Progress fraction must be in range [0, 1], but got endFraction ${t}`)),d(t>=e,(()=>`startFraction must be no more than endFraction, but got startFraction ${e} and endFraction ${t}`));
}(n=null==n?0:n,r=null==r?1:r);let s=0;return Promise.all(e.map((i=>(i.then((i=>{
const a=n+ ++s/e.length*(r-n);return t(a),i;
})),i))));
}async function na(e,t){
null==t&&(t={});const n=null==t.fetchFunc?H().platform.fetch:t.fetchFunc,r=e.map((e=>n(e,t.requestInit,{isBinary:!0}))),s=(null==t.onProgress?await Promise.all(r):await ta(r,t.onProgress,0,.5)).map((e=>e.arrayBuffer()));return null==t.onProgress?await Promise.all(s):await ta(s,t.onProgress,.5,1);
}ea.URL_SCHEME="downloads://",Ws.registerSaveRouter((e=>H().getBool("IS_BROWSER")&&!Array.isArray(e)&&e.startsWith(ea.URL_SCHEME)?function(e="model"){
return new ea(e);
}(e.slice(ea.URL_SCHEME.length)):null));class ra{
constructor(e,t){
if(this.DEFAULT_METHOD="POST",null==t&&(t={}),this.weightPathPrefix=t.weightPathPrefix,this.onProgress=t.onProgress,this.weightUrlConverter=t.weightUrlConverter,null!=t.fetchFunc?(d("function"==typeof t.fetchFunc,(()=>"Must pass a function that matches the signature of `fetch` (see https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API)")),this.fetch=t.fetchFunc):this.fetch=H().platform.fetch,d(null!=e&&e.length>0,(()=>"URL path for http must not be null, undefined or empty.")),Array.isArray(e)&&d(2===e.length,(()=>`URL paths for http must have a length of 2, (actual length is ${e.length}).`)),this.path=e,null!=t.requestInit&&null!=t.requestInit.body){
throw new Error("requestInit is expected to have no pre-existing body, but has one.");
}this.requestInit=t.requestInit||{};
}async save(e){
if(e.modelTopology instanceof ArrayBuffer){
throw new Error("BrowserHTTPRequest.save() does not support saving model topology in binary formats yet.");
}const t=Object.assign({method:this.DEFAULT_METHOD},this.requestInit);t.body=new FormData;const n=Bs(e,[{paths:["./model.weights.bin"],weights:e.weightSpecs}]);if(t.body.append("model.json",new Blob([JSON.stringify(n)],{type:"application/json"}),"model.json"),null!=e.weightData){
const n=Os.join(e.weightData);t.body.append("model.weights.bin",new Blob([n],{type:"application/octet-stream"}),"model.weights.bin");
}const r=await this.fetch(this.path,t);if(r.ok){
return{modelArtifactsInfo:Us(e),responses:[r]};
}throw new Error(`BrowserHTTPRequest.save() failed due to HTTP response status ${r.status}.`);
}async load(){
const e=await this.fetch(this.path,this.requestInit);if(!e.ok){
throw new Error(`Request to ${this.path} failed with status code ${e.status}. Please verify this URL points to the model JSON of the model to load.`);
}let t;try{
t=await e.json();
}catch(e){
let t=`Failed to parse model JSON of response from ${this.path}.`;throw this.path.endsWith(".pb")?t+=" Your path contains a .pb file extension. Support for .pb models have been removed in TensorFlow.js 1.0 in favor of .json models. You can re-convert your Python TensorFlow model using the TensorFlow.js 1.0 conversion scripts or you can convert your.pb models with the 'pb2json'NPM script in the tensorflow/tfjs-converter repository.":t+=" Please make sure the server is serving valid JSON for this request.",new Error(t);
}const n=t.modelTopology,r=t.weightsManifest;if(null==n&&null==r){
throw new Error(`The JSON from HTTP path ${this.path} contains neither model topology or manifest for weights.`);
}return async function(e,t){
let n,r;return null!=e.weightsManifest&&([n,r]=await t(e.weightsManifest)),function(e,t,n){
const r={modelTopology:e.modelTopology,format:e.format,generatedBy:e.generatedBy,convertedBy:e.convertedBy};if(null!=e.trainingConfig&&(r.trainingConfig=e.trainingConfig),null!=e.weightsManifest){
if(!t){
throw new Error("modelJSON has weightsManifest but weightSpecs is null");
}if(!n){
throw new Error("modelJSON has weightsManifest but weightData is null");
}r.weightSpecs=t,r.weightData=n;
}return null!=e.signature&&(r.signature=e.signature),null!=e.userDefinedMetadata&&(r.userDefinedMetadata=e.userDefinedMetadata),null!=e.modelInitializer&&(r.modelInitializer=e.modelInitializer),null!=e.initializerSignature&&(r.initializerSignature=e.initializerSignature),r;
}(e,n,r);
}(t,(e=>this.loadWeights(e)));
}async loadWeights(e){
const t=Array.isArray(this.path)?this.path[1]:this.path,[n,r]=function(e){
const t=e.lastIndexOf("/"),n=e.lastIndexOf("?");return[e.substring(0,t)+"/",n>t?e.substring(n):""];
}(t),s=this.weightPathPrefix||n,i=function(e){
const t=[];for(const n of e){
t.push(...n.weights);
}return t;
}(e),a=[],o=[];for(const t of e){
for(const e of t.paths){
null!=this.weightUrlConverter?o.push(this.weightUrlConverter(e)):a.push(s+e+r);
}
}return this.weightUrlConverter&&a.push(...await Promise.all(o)),[i,await na(a,{requestInit:this.requestInit,fetchFunc:this.fetch,onProgress:this.onProgress})];
}
}function sa(e){
return null!=e.match(ra.URL_SCHEME_REGEX);
}ra.URL_SCHEME_REGEX=/^https?:\/\//;const ia=(e,t)=>{
if("undefined"==typeof fetch&&(null==t||null==t.fetchFunc)){
return null;
}{let n=!0;if(n=Array.isArray(e)?e.every((e=>sa(e))):sa(e),n){
return function(e,t){
return new ra(e,t);
}(e,t);
}}return null;
};Ws.registerSaveRouter(ia),Ws.registerLoadRouter(ia);const aa=-2,oa=-1;function ua(e,t,n){
const r=e.shape.length;d(r===t.length,(()=>`Error in slice${r}D: Length of begin ${t} must match the rank of the array (${r}).`)),d(r===n.length,(()=>`Error in slice${r}D: Length of size ${n} must match the rank of the array (${r}).`));for(let s=0;s<r;++s){
d(t[s]+n[s]<=e.shape[s],(()=>`Error in slice${r}D: begin[${s}] + size[${s}] (${t[s]+n[s]}) would overflow input.shape[${s}] (${e.shape[s]})`));
}
}function la(e){
const t=[];let n=0;for(;e>0;){
1&e&&t.push(n),e/=2,n++;
}return t;
}function ca(e,t,n){
const r=[];for(let s=0;s<e.length;s++){
r[s]=Math.ceil((t[s]-e[s])/n[s]);
}return r;
}function ha(e,t,n,r){
const s=[...e];for(let e=s.length;e<r.length;e++){
s.push(1);
}for(let e=0;e<n;e++){
0===e?s[t]=1:(s.splice(t,0,1),s.pop());
}return s;
}function da(e,t,n){
return n<=e?n:n-(t-1);
}function pa(e,t){
const n=[];for(let r=0;r<e;r++){
n.push(t+r);
}return n;
}function fa(e,t,n,r,s,i,a,o,u){
const l=e.length;let c=new Array(l),h=new Array(l),d=new Array(l);if(t.length&&n>0){
const u=t[0],l=n+1;c=ma(a,u,l,r,e),h=ga(o,u,l,s,e),d=ha(i,u,l,e);
}else {
for(let t=0;t<l;t++){
c[t]=xa(a,r,i,e,t,u),h[t]=ya(o,s,i,e,t,u),d[t]=ba(i,t,u);
}
}return{begin:c,end:h,strides:d};
}function ma(e,t,n,r,s){
const i=[...s],a=pa(n,t);for(let s=0;s<i.length;s++){
if(a.indexOf(s)>-1){
i[s]=0;
}else{
const a=da(t,n,s);let o=r[a];e&1<<a&&(o=0),i[s]=o;
}
}return i;
}function ga(e,t,n,r,s){
const i=[...s],a=pa(n,t);for(let s=0;s<i.length;s++){
if(a.indexOf(s)>-1){
i[s]=Number.MAX_SAFE_INTEGER;
}else{
const a=da(t,n,s);let o=r[a];e&1<<a&&(o=Number.MAX_SAFE_INTEGER),i[s]=o;
}
}for(let e=0;e<i.length;e++){
const t=s[e];i[e]<0&&(i[e]+=t),i[e]=l(0,i[e],s[e]);
}return i;
}function ba(e,t,n){
let r=e[t];return(n&1<<t||null==r)&&(r=1),r;
}function xa(e,t,n,r,s,i){
let a=t[s];const o=n[s]||1;(e&1<<s||i&1<<s||null==a)&&(a=o>0?Number.MIN_SAFE_INTEGER:Number.MAX_SAFE_INTEGER);const u=r[s];return a<0&&(a+=u),a=l(0,a,u-1),a;
}function ya(e,t,n,r,s,i){
let a=t[s];const o=n[s]||1;(e&1<<s||i&1<<s||null==a)&&(a=o>0?Number.MAX_SAFE_INTEGER:Number.MIN_SAFE_INTEGER);const u=r[s];return a<0&&(a+=u),a=o>0?l(0,a,u):l(-1,a,u-1),a;
}function wa(e,t,n){
let r=n.length;for(let e=0;e<n.length;e++){
if(n[e]>1){
r=e;break;
}
}for(let s=r+1;s<n.length;s++){
if(t[s]>0||n[s]!==e[s]){
return!1;
}
}return!0;
}function va(e,t){
let n=e.length>0?e[e.length-1]:1;for(let r=0;r<e.length-1;r++){
n+=e[r]*t[r];
}return n;
}function ka(e,t,n){
let r;const s=e.shape.length;let i;return r="number"==typeof t?[t,...new Array(s-1).fill(0)]:t.length<s?t.concat(new Array(s-t.length).fill(0)):t.slice(),r.forEach((e=>{
d(-1!==e,(()=>"slice() does not support negative begin indexing."));
})),i=null==n?new Array(s).fill(-1):"number"==typeof n?[n,...new Array(s-1).fill(-1)]:n.length<s?n.concat(new Array(s-n.length).fill(-1)):n,i=i.map(((t,n)=>t>=0?t:(d(-1===t,(()=>`Negative size values should be exactly -1 but got ${t} for the slice() size at index ${n}.`)),e.shape[n]-r[n]))),[r,i];
}function Ia(e,t,n,r,s,i,a,o,u){
let l;if(null==r?(l=new Array(t.length),l.fill(1)):l=r,null!=a&&0!=(a&a-1)){
throw new Error("Multiple ellipses in slice is not allowed.");
}let c=!1;const h={dims:l.length,numAddAxisAfterEllipsis:0,begin:t.slice(),end:n.slice(),strides:l.slice(),beginMask:s,endMask:i,ellipsisMask:a,newAxisMask:o,shrinkAxisMask:u};for(let e=0;e<h.dims;e++){
c&&0!=(1<<e&o)&&h.numAddAxisAfterEllipsis++,1<<e&a&&(c=!0);
}c||(h.ellipsisMask|=1<<h.dims,h.dims++);const d={dims:e.length,beginMask:0,endMask:0,beginValid:!1,endValid:!1};!function(e,t){
t.beginMask=0,t.endMask=0,t.shrinkAxisMask=0;let n=0;t.beginValid=null!=e.begin,t.endValid=null!=e.end,t.begin=new Array(t.dims),t.end=new Array(t.dims),t.strides=new Array(t.dims),t.finalShapeGatherIndices=[],t.finalShapeGatherIndicesSparse=[],t.inputShapeGatherIndicesSparse=new Array(t.dims);for(let r=0;r<e.dims;r++){
if(1<<r&e.ellipsisMask){
const s=Math.min(t.dims-(e.dims-r)+1+e.numAddAxisAfterEllipsis,t.dims);for(;n<s;n++){
t.begin[n]=0,t.end[n]=0,t.strides[n]=1,t.beginMask|=1<<n,t.endMask|=1<<n,t.finalShapeGatherIndices.push(n),t.finalShapeGatherIndicesSparse.push(-1),t.inputShapeGatherIndicesSparse[n]=r;
}
}else if(1<<r&e.newAxisMask){
t.finalShapeGatherIndices.push(aa),t.finalShapeGatherIndicesSparse.push(-1);
}else{
if(n===t.begin.length){
throw Error(`Index out of range using input dim ${n}; input has only ${t.dims} dims, ${t.begin.length}.`);
}null!=e.begin&&(t.begin[n]=e.begin[r]),null!=e.end&&(t.end[n]=e.end[r]),t.strides[n]=e.strides[r],e.beginMask&1<<r&&(t.beginMask|=1<<n),e.endMask&1<<r&&(t.endMask|=1<<n),e.shrinkAxisMask&1<<r?(t.finalShapeGatherIndices.push(oa),t.finalShapeGatherIndicesSparse.push(-1),t.shrinkAxisMask|=1<<n):(t.finalShapeGatherIndices.push(n),t.finalShapeGatherIndicesSparse.push(r)),t.inputShapeGatherIndicesSparse[n]=r,n++;
}
}
}(h,d);let p=!0,f=!0,m=!0;const g=[],b=[];for(let t=0;t<e.length;++t){
if(0===d.strides[t]){
throw Error(`strides[${t}] must be non-zero`);
}const n=!!(d.shrinkAxisMask&1<<t),r=e[t];if(-1===r){
g.push(n?1:-1);continue;
}const s=[d.beginMask&1<<t,d.endMask&1<<t],i=[d.strides[t]>0?0:-1,d.strides[t]>0?r:r-1];if(n&&d.strides[t]<=0){
throw Error("only stride 1 allowed on non-range indexing.");
}m=m&&1===d.strides[t];const a=!!(d.beginMask&1<<t&&d.endMask&1<<t);if(d.beginValid&&d.endValid){
if(n){
const e=d.begin[t]<0?r+d.begin[t]:d.begin[t];if(d.begin[t]=e,d.end[t]=d.begin[t]+1,e<0||e>=r){
throw Error(`slice index ${d.begin[t]} of dimension ${t} out of bounds.`);
}
}else {
d.begin[t]=Sa(d.begin[t],0,d.strides[t],r,s,i),d.end[t]=Sa(d.end[t],1,d.strides[t],r,s,i);
}const e=1===d.strides[t]&&0===d.begin[t]&&d.end[t]===r;p=p&&e,f=f&&(0===t&&1===d.strides[t]||e);
}else {
p=p&&1===d.strides[t]&&a,f=f&&(0===t&&1===d.strides[t]||a);
}let o,u=!1;if(d.beginValid&&d.endValid?(o=d.end[t]-d.begin[t],u=!0):n?(o=1,u=!0):a&&r>=0&&(o=d.strides[t]<0?-r:r,u=!0),u){
let e;e=0===o||o<0!=d.strides[t]<0?0:Math.trunc(o/d.strides[t])+(o%d.strides[t]!=0?1:0),g.push(e);
}else {
g.push(-1);
}
}for(let e=0;e<d.finalShapeGatherIndices.length;++e){
const t=d.finalShapeGatherIndices[e];t>=0?b.push(g[t]):t===aa&&b.push(1);
}return{finalShapeSparse:b.filter(((e,t)=>d.finalShapeGatherIndices[t]!==aa)),finalShape:b,isIdentity:p,sliceDim0:f,isSimpleSlice:m,begin:d.begin,end:d.end,strides:d.strides};
}function Sa(e,t,n,r,s,i){
if(s[t]){
return n>0?i[t]:i[t+1&1];
}{const t=e<0?r+e:e;return t<i[0]?i[0]:t>i[1]?i[1]:t;}
}const Ca=As({all_:function(e,t=null,n=!1){
const r={x:Es(e,"x","all","bool")},s={axis:t,keepDims:n};return vs.runKernel(ne,r,s);
}}),Na=As({any_:function(e,t=null,n=!1){
const r={x:Es(e,"x","any","bool")},s={axis:t,keepDims:n};return vs.runKernel(re,r,s);
}}),$a=As({argMax_:function(e,t=0){
const n={x:Es(e,"x","argMax")},r={axis:t};return vs.runKernel(se,n,r);
}});function Ta(e,t,n,r,s="NHWC",i){
return Aa(e,[...t,e[3]],n,i,r,null,null,Ua(s));
}function Ea(e,t,n,r,s,i,a="channelsLast"){
const[o,u]=Da(t);let l;if("channelsLast"===a){
l=[o,u,e[3],e[3]];
}else{
if("channelsFirst"!==a){
throw new Error(`Unknown dataFormat ${a}`);
}l=[o,u,e[1],e[1]];
}return Aa(e,l,n,r,s,i,!1,a);
}function Ra(e,t,n,r,s,i,a="NDHWC"){
const[o,u,l]=Oa(t);let c,h;if("NDHWC"===a){
h="channelsLast",c=[o,u,l,e[4],e[4]];
}else{
if("NCDHW"!==a){
throw new Error(`Unknown dataFormat ${a}`);
}h="channelsFirst",c=[o,u,l,e[1],e[1]];
}return Fa(e,c,n,r,s,!1,h,i);
}function Aa(e,t,n,r,s,i,a=!1,o="channelsLast"){
let[u,l,c,h]=[-1,-1,-1,-1];if("channelsLast"===o){
[u,l,c,h]=e;
}else{
if("channelsFirst"!==o){
throw new Error(`Unknown dataFormat ${o}`);
}[u,h,l,c]=e;
}const[d,p,,f]=t,[m,g]=Da(n),[b,x]=Da(r),y=Ma(d,b),w=Ma(p,x),{padInfo:v,outHeight:k,outWidth:I}=function(e,t,n,r,s,i,a,o,u){
let l,c,h;if("number"==typeof e){
l={top:e,bottom:e,left:e,right:e,type:0===e?"VALID":"NUMBER"};const s=function(e,t,n,r,s){
null==r&&(r=_a(e,t,n));const i=e[1];return[La((e[0]-t+2*r)/n+1,s),La((i-t+2*r)/n+1,s)];
}([t,n],i,r,e,o);c=s[0],h=s[1];
}else if("same"===e){
c=Math.ceil(t/r),h=Math.ceil(n/s);const e=Math.max(0,(c-1)*r+i-t),o=Math.max(0,(h-1)*s+a-n),u=Math.floor(e/2),d=e-u,p=Math.floor(o/2);l={top:u,bottom:d,left:p,right:o-p,type:"SAME"};
}else if("valid"===e){
l={top:0,bottom:0,left:0,right:0,type:"VALID"},c=Math.ceil((t-i+1)/r),h=Math.ceil((n-a+1)/s);
}else{
if("object"!=typeof e){
throw Error(`Unknown padding parameter: ${e}`);
}{const d="channelsLast"===u?e[1][0]:e[2][0],p="channelsLast"===u?e[1][1]:e[2][1],f="channelsLast"===u?e[2][0]:e[3][0],m="channelsLast"===u?e[2][1]:e[3][1];l={top:d,bottom:p,left:f,right:m,type:0===d&&0===p&&0===f&&0===m?"VALID":"EXPLICIT"},c=La((t-i+d+p)/r+1,o),h=La((n-a+f+m)/s+1,o);}
}return{padInfo:l,outHeight:c,outWidth:h};
}(s,l,c,m,g,y,w,i,o),S=a?f*h:f;let C;return"channelsFirst"===o?C=[u,S,k,I]:"channelsLast"===o&&(C=[u,k,I,S]),{batchSize:u,dataFormat:o,inHeight:l,inWidth:c,inChannels:h,outHeight:k,outWidth:I,outChannels:S,padInfo:v,strideHeight:m,strideWidth:g,filterHeight:d,filterWidth:p,effectiveFilterHeight:y,effectiveFilterWidth:w,dilationHeight:b,dilationWidth:x,inShape:e,outShape:C,filterShape:t};
}function Fa(e,t,n,r,s,i=!1,a="channelsLast",o){
let[u,l,c,h,d]=[-1,-1,-1,-1,-1];if("channelsLast"===a){
[u,l,c,h,d]=e;
}else{
if("channelsFirst"!==a){
throw new Error(`Unknown dataFormat ${a}`);
}[u,d,l,c,h]=e;
}const[p,f,m,,g]=t,[b,x,y]=Oa(n),[w,v,k]=Oa(r),I=Ma(p,w),S=Ma(f,v),C=Ma(m,k),{padInfo:N,outDepth:$,outHeight:T,outWidth:E}=function(e,t,n,r,s,i,a,o,u,l,c){
let h,d,p,f;if("valid"===e&&(e=0),"number"==typeof e){
h={top:e,bottom:e,left:e,right:e,front:e,back:e,type:0===e?"VALID":"NUMBER"};const m=function(e,t,n,r,s,i){
null==s&&(s=_a(e,t[0],r[0]));const a=[0,0,0,1];for(let n=0;n<3;n++){
e[n]+2*s>=t[n]&&(a[n]=La((e[n]-t[n]+2*s)/r[n]+1,i));
}return a;
}([t,n,r,1],[o,u,l],0,[s,i,a],e,c);d=m[0],p=m[1],f=m[2];
}else{
if("same"!==e){
throw Error(`Unknown padding parameter: ${e}`);
}{d=Math.ceil(t/s),p=Math.ceil(n/i),f=Math.ceil(r/a);const e=(d-1)*s+o-t,c=(p-1)*i+u-n,m=(f-1)*a+l-r,g=Math.floor(e/2),b=e-g,x=Math.floor(c/2),y=c-x,w=Math.floor(m/2);h={top:x,bottom:y,left:w,right:m-w,front:g,back:b,type:"SAME"};}
}return{padInfo:h,outDepth:d,outHeight:p,outWidth:f};
}(s,l,c,h,b,x,y,I,S,C,o),R=i?g*d:g;let A;return"channelsFirst"===a?A=[u,R,$,T,E]:"channelsLast"===a&&(A=[u,$,T,E,R]),{batchSize:u,dataFormat:a,inDepth:l,inHeight:c,inWidth:h,inChannels:d,outDepth:$,outHeight:T,outWidth:E,outChannels:R,padInfo:N,strideDepth:b,strideHeight:x,strideWidth:y,filterDepth:p,filterHeight:f,filterWidth:m,effectiveFilterDepth:I,effectiveFilterHeight:S,effectiveFilterWidth:C,dilationDepth:w,dilationHeight:v,dilationWidth:k,inShape:e,outShape:A,filterShape:t};
}function _a(e,t,n,r=1){
const s=Ma(t,r);return Math.floor((e[0]*(n-1)-n+s)/2);
}function Da(e){
return"number"==typeof e?[e,e,e]:2===e.length?[e[0],e[1],1]:e;
}function Oa(e){
return"number"==typeof e?[e,e,e]:e;
}function Ma(e,t){
return t<=1?e:e+(e-1)*(t-1);
}function La(e,t){
if(!t){
return Math.trunc(e);
}switch(t){
case"round":return Math.round(e);case"ceil":return Math.ceil(e);case"floor":return Math.floor(e);default:throw new Error(`Unknown roundingMode ${t}`);
}
}function za(e){
const[t,n,r]=Da(e);return 1===t&&1===n&&1===r;
}function Pa(e,t){
return za(e)||za(t);
}function Ba(e){
return Da(e).every((e=>e>0));
}function Ua(e){
if("NHWC"===e){
return"channelsLast";
}if("NCHW"===e){
return"channelsFirst";
}throw new Error(`Unknown dataFormat ${e}`);
}function Wa(e,t,n){
if(null!=n){
if("string"==typeof t){
throw Error(`Error in ${e}: pad must be an integer when using dimRoundingMode ${n} but got pad ${t}.`);
}if("number"==typeof t){
d(b(t),(()=>`Error in ${e}: pad must be an integer when using dimRoundingMode ${n} but got pad ${t}.`));
}else{
if("object"!=typeof t){
throw Error(`Error in ${e}: Unknown padding parameter: ${t}`);
}t.forEach((t=>{
t.forEach((t=>{
d(b(t),(()=>`Error in ${e}: pad must be an integer when using dimRoundingMode ${n} but got pad ${t}.`));
}));
}));
}
}
}const Va=As({reshape_:function(e,t){
const n={x:Es(e,"x","reshape","string_or_numeric")},r={shape:t};return vs.runKernel(un,n,r);
}}),Ga=As({avgPool_:function(e,t,n,r,s){
const i=Es(e,"x","avgPool","float32");d(Pa(n,1),(()=>`Error in avgPool: Either strides or dilations must be 1. Got strides ${n} and dilations '1'`));let a=i,o=!1;3===i.rank&&(o=!0,a=Va(i,[1,i.shape[0],i.shape[1],i.shape[2]])),d(4===a.rank,(()=>`Error in avgPool: x must be rank 4 but got rank ${a.rank}.`)),Wa("avgPool",r,s);const u={x:a},l={filterSize:t,strides:n,pad:r,dimRoundingMode:s};let c=vs.runKernel(he,u,l);return c=fi(c,i.dtype),o?Va(c,[c.shape[1],c.shape[2],c.shape[3]]):c;
}}),ja=As({avgPool3d_:function(e,t,n,r,s,i="NDHWC"){
const a=Es(e,"x","avgPool3d","float32");let o=a,u=!1;4===a.rank&&(u=!0,o=Va(a,[1,a.shape[0],a.shape[1],a.shape[2],a.shape[3]])),d(5===o.rank,(()=>`Error in avgPool3d: x must be rank 5 but got rank ${o.rank}.`)),d("NDHWC"===i,(()=>`Error in avgPool3d: Only NDHWC is currently supported, but got dataFormat of ${i}`)),d("number"==typeof n&&n>0||Array.isArray(n)&&n[0]>0&&n[1]>0&&n[2]>0,(()=>`Error in avgPool3d: Stride must be > 0, but got '${n}'`)),Wa("avgPool3d",r,s);const l={x:o},c={filterSize:t,strides:n,pad:r,dimRoundingMode:s,dataFormat:i};let h=vs.runKernel(pe,l,c);return h=fi(h,o.dtype),u?Va(h,[h.shape[1],h.shape[2],h.shape[3],h.shape[4]]):h;
}}),Ha=As({batchNorm_:function(e,t,n,r,s,i){
null==i&&(i=.001);const a=Es(e,"x","batchNorm"),o=Es(t,"mean","batchNorm"),u=Es(n,"variance","batchNorm");let l,c;null!=s&&(l=Es(s,"scale","batchNorm")),null!=r&&(c=Es(r,"offset","batchNorm")),d(o.rank===u.rank,(()=>"Batch normalization gradient requires mean and variance to have equal ranks.")),d(null==c||o.rank===c.rank,(()=>"Batch normalization gradient requires mean and offset to have equal ranks.")),d(null==l||o.rank===l.rank,(()=>"Batch normalization gradient requires mean and scale to have equal ranks."));const h={x:function(e){
let t;return t=0===e.rank||1===e.rank?Va(e,[1,1,1,e.size]):2===e.rank?Va(e,[1,1,e.shape[0],e.shape[1]]):3===e.rank?Va(e,[1,e.shape[0],e.shape[1],e.shape[2]]):e,t;
}(a),scale:l,offset:c,mean:o,variance:u},p={varianceEpsilon:i},f=vs.runKernel(at,h,p);return Va(f,a.shape);
}}),qa=As({batchNorm2d_:function(e,t,n,r,s,i){
const a=Es(e,"x","batchNorm"),o=Es(t,"mean","batchNorm"),u=Es(n,"variance","batchNorm");let l,c;return null!=s&&(l=Es(s,"scale","batchNorm")),null!=r&&(c=Es(r,"offset","batchNorm")),d(2===a.rank,(()=>`Error in batchNorm2D: x must be rank 2 but got rank ${a.rank}.`)),d(2===o.rank||1===o.rank,(()=>`Error in batchNorm2D: mean must be rank 2 or rank 1 but got rank ${o.rank}.`)),d(2===u.rank||1===u.rank,(()=>`Error in batchNorm2D: variance must be rank 2 or rank 1 but got rank ${u.rank}.`)),null!=l&&d(2===l.rank||1===l.rank,(()=>`Error in batchNorm2D: scale must be rank 2 or rank 1 but got rank ${l.rank}.`)),null!=c&&d(2===c.rank||1===c.rank,(()=>`Error in batchNorm2D: offset must be rank 2 or rank 1 but got rank ${c.rank}.`)),Ha(a,o,u,c,l,i);
}}),Ka=As({batchNorm3d_:function(e,t,n,r,s,i){
const a=Es(e,"x","batchNorm"),o=Es(t,"mean","batchNorm"),u=Es(n,"variance","batchNorm");let l,c;return null!=s&&(l=Es(s,"scale","batchNorm")),null!=r&&(c=Es(r,"offset","batchNorm")),d(3===a.rank,(()=>`Error in batchNorm3D: x must be rank 3 but got rank ${a.rank}.`)),d(3===o.rank||1===o.rank,(()=>`Error in batchNorm3D: mean must be rank 3 or rank 1 but got rank ${o.rank}.`)),d(3===u.rank||1===u.rank,(()=>`Error in batchNorm3D: variance must be rank 3 or rank 1 but got rank ${u.rank}.`)),null!=l&&d(3===l.rank||1===l.rank,(()=>`Error in batchNorm3D: scale must be rank 3 or rank 1 but got rank ${l.rank}.`)),null!=c&&d(3===c.rank||1===c.rank,(()=>`Error in batchNorm3D: offset must be rank 3 or rank 1 but got rank ${c.rank}.`)),Ha(a,o,u,c,l,i);
}}),Xa=As({batchNorm4d_:function(e,t,n,r,s,i){
const a=Es(e,"x","batchNorm"),o=Es(t,"mean","batchNorm"),u=Es(n,"variance","batchNorm");let l,c;return null!=s&&(l=Es(s,"scale","batchNorm")),null!=r&&(c=Es(r,"offset","batchNorm")),d(4===a.rank,(()=>`Error in batchNorm4D: x must be rank 4 but got rank ${a.rank}.`)),d(4===o.rank||1===o.rank,(()=>`Error in batchNorm4D: mean must be rank 4 or rank 1 but got rank ${o.rank}.`)),d(4===u.rank||1===u.rank,(()=>`Error in batchNorm4D: variance must be rank 4 or rank 1 but got rank ${u.rank}.`)),null!=l&&d(4===l.rank||1===l.rank,(()=>`Error in batchNorm4D: scale must be rank 4 or rank 1 but got rank ${l.rank}.`)),null!=c&&d(4===c.rank||1===c.rank,(()=>`Error in batchNorm4D: offset must be rank 4 or rank 1 but got rank ${c.rank}.`)),Ha(a,o,u,c,l,i);
}}),Ya=As({broadcastTo_:function(e,t){
let n=Es(e,"broadcastTo","x");const r=n.shape;if(P(t),t.length<n.rank){
throw new Error(`broadcastTo(): shape.length=${t.length} < input.rank=${n.rank}.`);
}if(t.length>n.rank){
const e=n.shape.slice();for(;e.length<t.length;){
e.unshift(1);
}n=Va(n,e);
}const s=n.shape,i=Array.from(t);for(let e=t.length-1;e>=0;e--){
if(s[e]===t[e]){
i[e]=1;
}else if(1!==n.shape[e]){
throw new Error(`broadcastTo(): [${r}] cannot be broadcast to [${t}].`);
}
}if(0===i.map(((e,t)=>e>1?t:-1)).filter((e=>e>=0)).length){
return mi(n);
}const a={x:n},o={reps:i};return vs.runKernel(Kn,a,o);
}}),Za=As({clipByValue_:function(e,t,n){
const r=Es(e,"x","clipByValue");if(d(t<=n,(()=>`Error in clip: min (${t}) must be less than or equal to max (${n}).`)),t===n){
return zi(r.shape,t,r.dtype);
}const s={x:r},i={clipValueMin:t,clipValueMax:n};return vs.runKernel(ke,s,i);
}}),Ja=As({concat_:function(e,t=0){
d(e.length>=1,(()=>"Pass at least one tensor to concat"));const n=Rs(e,"tensors","concat","string_or_numeric");if("complex64"===n[0].dtype&&n.forEach((e=>{
if("complex64"!==e.dtype){
throw new Error(`Cannot concatenate complex64 tensors with a tensor\n          with dtype ${e.dtype}. `);
}
})),1===n.length){
return mi(n[0]);
}const r=n,s={axis:t};return vs.runKernel(Ce,r,s);
}}),Qa=As({concat1d_:function(e){
return Ja(e,0);
}}),eo=As({concat2d_:function(e,t){
return Ja(e,t);
}}),to=As({concat3d_:function(e,t){
return Ja(e,t);
}}),no=As({concat4d_:function(e,t){
return Ja(e,t);
}}),ro=As({conv2d_:function(e,t,n,r,s="NHWC",i=[1,1],a){
const o=Es(e,"x","conv2d","float32"),u=Es(t,"filter","conv2d","float32");let l=o,c=!1;3===o.rank&&(c=!0,l=Va(o,[1,o.shape[0],o.shape[1],o.shape[2]])),d(4===l.rank,(()=>`Error in conv2d: input must be rank 4, but got rank ${l.rank}.`)),d(4===u.rank,(()=>`Error in conv2d: filter must be rank 4, but got rank ${u.rank}.`)),Wa("conv2d",r,a);const h="NHWC"===s?l.shape[3]:l.shape[1];d(h===u.shape[2],(()=>`Error in conv2d: depth of input (${h}) must match input depth for filter ${u.shape[2]}.`)),d(Pa(n,i),(()=>`Error in conv2D: Either strides or dilations must be 1. Got strides ${n} and dilations '${i}'`)),d(Ba(i),(()=>"Error in conv2D: Dilated rates should be larger than 0.")),d(Ba(n),(()=>"Error in conv2D: Strides should be larger than 0."));const p={x:l,filter:u},f={strides:n,pad:r,dataFormat:s,dilations:i,dimRoundingMode:a},m=vs.runKernel(Ne,p,f);return c?Va(m,[m.shape[1],m.shape[2],m.shape[3]]):m;
}}),so=As({conv1d_:function(e,t,n,r,s="NWC",i=1,a){
const o=Es(e,"x","conv1d"),u=Es(t,"filter","conv1d");let l=o,c=!1;2===o.rank&&(c=!0,l=Va(o,[1,o.shape[0],o.shape[1]])),d(3===l.rank,(()=>`Error in conv1d: input must be rank 3, but got rank ${l.rank}.`)),d(3===u.rank,(()=>`Error in conv1d: filter must be rank 3, but got rank ${u.rank}.`)),Wa("conv1d",r,a),d(l.shape[2]===u.shape[1],(()=>`Error in conv1d: depth of input (${l.shape[2]}) must match input depth for filter ${u.shape[1]}.`)),d(Pa(n,i),(()=>`Error in conv1D: Either stride or dilation must be 1. Got stride ${n} and dilation '${i}'`)),d(Ba(i),(()=>"Error in conv1D: Dilated rates should be larger than 0.")),d(Ba(n),(()=>"Error in conv1D: Stride should be larger than 0.")),d("NWC"===s,(()=>`Error in conv1d: got dataFormat of ${s} but only NWC is currently supported.`));const h=Va(u,[1,u.shape[0],u.shape[1],u.shape[2]]),p=Va(l,[l.shape[0],1,l.shape[1],l.shape[2]]),f=ro(p,h,[1,n],r,"NHWC",[1,i],a);return Va(f,c?[f.shape[2],f.shape[3]]:[f.shape[0],f.shape[2],f.shape[3]]);
}}),io=As({conv2DBackpropInput_:function(e,t,n,r,s,i="NHWC",a){
d(e.length===t.rank,(()=>`Length of inShape (${e.length}) and rank of dy (${t.rank}) must match`));let o=e,u=t,l=!1;3===t.rank&&(l=!0,u=Va(t,[1,t.shape[0],t.shape[1],t.shape[2]]),o=[1,e[0],e[1],e[2]]),d(4===o.length,(()=>`Error in conv2dDerInput: inShape must be length 4, but got length ${o.length}.`)),d(4===u.rank,(()=>`Error in conv2dDerInput: dy must be rank 4, but got rank ${u.rank}`)),d(4===n.rank,(()=>`Error in conv2dDerInput: filter must be rank 4, but got rank ${n.rank}`));const c="NHWC"===i?o[3]:o[1],h="NHWC"===i?u.shape[3]:u.shape[1];d(c===n.shape[2],(()=>`Error in conv2dDerInput: depth of input (${c}) must match input depth for filter ${n.shape[2]}.`)),d(h===n.shape[3],(()=>`Error in conv2dDerInput: depth of output (${h}) must match output depth for filter ${n.shape[3]}.`)),Wa("conv2dDerInput",s,a);const p={dy:u,filter:n},f={strides:r,pad:s,dataFormat:i,dimRoundingMode:a,inputShape:o},m=vs.runKernel(Te,p,f);return l?Va(m,[m.shape[1],m.shape[2],m.shape[3]]):m;
}}),ao=As({conv2dTranspose_:function(e,t,n,r,s,i){
const a=Es(e,"x","conv2dTranspose"),o=Es(t,"filter","conv2dTranspose");return io(n,a,o,r,s,"NHWC",i);
}}),oo=As({conv3d_:function(e,t,n,r,s="NDHWC",i=[1,1,1]){
const a=Es(e,"x","conv3d"),o=Es(t,"filter","conv3d");let u=a,l=!1;4===a.rank&&(l=!0,u=Va(a,[1,a.shape[0],a.shape[1],a.shape[2],a.shape[3]])),d(5===u.rank,(()=>`Error in conv3d: input must be rank 5, but got rank ${u.rank}.`)),d(5===o.rank,(()=>`Error in conv3d: filter must be rank 5, but got rank ${o.rank}.`)),d(u.shape[4]===o.shape[3],(()=>`Error in conv3d: depth of input (${u.shape[4]}) must match input depth for filter ${o.shape[3]}.`)),d(Pa(n,i),(()=>`Error in conv3D: Either strides or dilations must be 1. Got strides ${n} and dilations '${i}'`)),d("NDHWC"===s,(()=>`Error in conv3d: got dataFormat of ${s} but only NDHWC is currently supported.`)),d(Ba(i),(()=>"Error in conv3D: Dilated rates should be larger than 0.")),d(Ba(n),(()=>"Error in conv3D: Strides should be larger than 0."));const c={x:u,filter:o},h={strides:n,pad:r,dataFormat:s,dilations:i},p=vs.runKernel(Ee,c,h);return l?Va(p,[p.shape[1],p.shape[2],p.shape[3],p.shape[4]]):p;
}}),uo=As({conv3DBackpropInput_:function(e,t,n,r,s){
d(e.length===t.rank,(()=>`Length of inShape (${e.length}) and rank of dy (${t.rank}) must match`));let i=e,a=t,o=!1;4===t.rank&&(o=!0,a=Va(t,[1,t.shape[0],t.shape[1],t.shape[2],t.shape[3]]),i=[1,e[0],e[1],e[2],e[3]]);const u=i[4],l=a.shape[4];d(5===i.length,(()=>`Error in conv3dDerInput: inShape must be length 5, but got length ${i.length}.`)),d(5===a.rank,(()=>`Error in conv3dDerInput: dy must be rank 5, but got rank ${a.rank}`)),d(5===n.rank,(()=>`Error in conv3dDerInput: filter must be rank 5, but got rank ${n.rank}`)),d(u===n.shape[3],(()=>`Error in conv3dDerInput: depth of input (${u}) must match input depth for filter ${n.shape[3]}.`)),d(l===n.shape[4],(()=>`Error in conv3dDerInput: depth of output (${l}) must match output depth for filter ${n.shape[4]}.`));const c={dy:a,filter:n},h={pad:s,strides:r,inputShape:i},p=vs.runKernel(Ae,c,h);return o?Va(p,[p.shape[1],p.shape[2],p.shape[3],p.shape[4]]):p;
}}),lo=As({conv3dTranspose_:function(e,t,n,r,s){
const i=Es(e,"x","conv3dTranspose"),a=Es(t,"filter","conv3dTranspose");return uo(n,i,a,r,s);
}}),co=As({denseBincount_:function(e,t,n,r=!1){
const s=Es(e,"x","denseBincount"),i=Es(t,"weights","denseBincount");d("int32"===s.dtype,(()=>`Error in denseBincount: input dtype must be int32, but got ${s.dtype}`)),d(s.rank<=2,(()=>`Error in denseBincount: input must be at most rank 2, but got rank ${s.rank}.`)),d(n>=0,(()=>`size must be non-negative, but got ${n}.`)),d(i.size===s.size||0===i.size,(()=>`Error in denseBincount: weights must have the same shape as x or 0-length, but got x shape: ${s.shape}, weights shape: ${i.shape}.`));const a={x:s,weights:i},o={size:n,binaryOutput:r};return vs.runKernel(Le,a,o);
}}),ho=As({depthwiseConv2d_:function(e,t,n,r,s="NHWC",i=[1,1],a){
const o=Es(e,"x","depthwiseConv2d","float32"),u=Es(t,"filter","depthwiseConv2d","float32");let l=o,c=!1;3===o.rank&&(c=!0,l=Va(o,[1,o.shape[0],o.shape[1],o.shape[2]])),d(4===l.rank,(()=>`Error in depthwiseConv2d: input must be rank 4, but got rank ${l.rank}.`)),d(4===u.rank,(()=>`Error in depthwiseConv2d: filter must be rank 4, but got rank ${u.rank}.`));const h="NHWC"===s?l.shape[3]:l.shape[1];d(h===u.shape[2],(()=>`Error in depthwiseConv2d: number of input channels (${h}) must match the inChannels dimension in filter ${u.shape[2]}.`)),Wa("depthwiseConv2d",r,a);const p={x:l,filter:u},f={strides:n,pad:r,dataFormat:s,dilations:i,dimRoundingMode:a},m=vs.runKernel(Pe,p,f);return c?Va(m,[m.shape[1],m.shape[2],m.shape[3]]):m;
}}),po=As({elu_:function(e){
const t={x:Es(e,"x","elu","float32")};return vs.runKernel(Ke,t);
}}),fo=As({equal_:function(e,t){
let n=Es(e,"a","equal","string_or_numeric"),r=Es(t,"b","equal","string_or_numeric");[n,r]=ps(n,r),Hi(n.shape,r.shape);const s={a:n,b:r};return vs.runKernel(Ze,s);
}}),mo=As({exp_:function(e){
const t={x:Es(e,"x","exp")};return vs.runKernel(Je,t);
}}),go=As({expandDims_:function(e,t=0){
const n=Es(e,"x","expandDims","string_or_numeric");d(t<=n.rank,(()=>"Axis must be <= rank of the tensor"));const r={input:n},s={dim:t};return vs.runKernel(Qe,r,s);
}}),bo=As({tile_:function(e,t){
const n=Es(e,"x","tile","string_or_numeric");d(n.rank===t.length,(()=>`Error in transpose: rank of input ${n.rank} must match length of reps ${t}.`));const r={x:n},s={reps:t};return vs.runKernel(Kn,r,s);
}}),xo=As({eye_:function(e,t,n,r="float32"){
null==t&&(t=e);const s=pi([e,t],r),i=e<=t?e:t;for(let e=0;e<i;++e){
s.set(1,e,e);
}const a=Va(s.toTensor(),[e,t]);if(null==n){
return a;
}if(1===n.length){
return bo(go(a,0),[n[0],1,1]);
}if(2===n.length){
return bo(go(go(a,0),0),[n[0],n[1],1,1]);
}if(3===n.length){
return bo(go(go(go(a,0),0),0),[n[0],n[1],n[2],1,1]);
}throw new Error(`eye() currently supports only 1D and 2D batchShapes, but received ${n.length}D.`);
}}),yo=As({floor_:function(e){
const t={x:Es(e,"x","floor","float32")};return vs.runKernel(st,t);
}}),wo=As({gather_:function(e,t,n=0,r=0){
const s={x:Es(e,"x","gather"),indices:Es(t,"indices","gather","int32")},i={axis:n,batchDims:r};return vs.runKernel(ot,s,i);
}}),vo=As({greater_:function(e,t){
let n=Es(e,"a","greater","string_or_numeric"),r=Es(t,"b","greater","string_or_numeric");[n,r]=ps(n,r),Hi(n.shape,r.shape);const s={a:n,b:r};return vs.runKernel(lt,s);
}}),ko=As({greaterEqual_:function(e,t){
let n=Es(e,"a","greaterEqual","string_or_numeric"),r=Es(t,"b","greaterEqual","string_or_numeric");[n,r]=ps(n,r),Hi(n.shape,r.shape);const s={a:n,b:r};return vs.runKernel(ct,s);
}}),Io=As({leakyRelu_:function(e,t=.2){
const n={x:Es(e,"x","leakyRelu")},r={alpha:t};return vs.runKernel(bt,n,r);
}}),So=As({log_:function(e){
const t={x:Es(e,"x","log","float32")};return vs.runKernel(vt,t);
}}),Co=As({log1p_:function(e){
const t={x:Es(e,"x","log1p")};return vs.runKernel(kt,t);
}}),No=As({max_:function(e,t=null,n=!1){
const r={x:Es(e,"x","max")},s={reductionIndices:t,keepDims:n};return vs.runKernel(Tt,r,s);
}}),$o=As({sum_:function(e,t=null,n=!1){
let r=Es(e,"x","sum");"bool"===r.dtype&&(r=fi(r,"int32"));const s={x:r},i={axis:t,keepDims:n};return vs.runKernel(En,s,i);
}}),To=As({logSoftmax_:function(e,t=-1){
const n=Es(e,"logits","logSoftmax");if(-1===t&&(t=n.rank-1),t!==n.rank-1){
throw Error(`Log Softmax along a non-last dimension is not yet supported. Logits was rank ${n.rank} and axis was ${t}`);
}const r=Ei(((e,n)=>{
const r=No(e,t,!0),s=Ui(e,r),i=Ui(fi(s,"float32"),So($o(mo(s),t,!0)));return n([i]),{value:i,gradFunc:(e,n)=>{
const[r]=n,s=mo(r);return Ui(e,Ci($o(e,t,!0),s));
}};
}));return r(n);
}}),Eo=As({logicalAnd_:function(e,t){
const n=Es(e,"a","logicalAnd","bool"),r=Es(t,"b","logicalAnd","bool");Hi(n.shape,r.shape);const s={a:n,b:r};return vs.runKernel(It,s);
}}),Ro=As({matMul_:function(e,t,n=!1,r=!1){
let s=Es(e,"a","matMul"),i=Es(t,"b","matMul");[s,i]=ps(s,i);const a={a:s,b:i},o={transposeA:n,transposeB:r};return vs.runKernel(me,a,o);
}}),Ao=As({maxPool_:function(e,t,n,r,s){
const i=Es(e,"x","maxPool");let a=i,o=!1;3===i.rank&&(o=!0,a=Va(i,[1,i.shape[0],i.shape[1],i.shape[2]])),d(4===a.rank,(()=>`Error in maxPool: input must be rank 4 but got rank ${a.rank}.`)),d(Pa(n,1),(()=>`Error in maxPool: Either strides or dilations must be 1. Got strides ${n} and dilations '1'`)),Wa("maxPool",r,s);const u={x:a},l={filterSize:t,strides:n,pad:r,dimRoundingMode:s},c=vs.runKernel(Rt,u,l);return o?Va(c,[c.shape[1],c.shape[2],c.shape[3]]):c;
}}),Fo=As({maxPool3d_:function(e,t=[1,1,1],n,r,s,i="NDHWC"){
const a=Es(e,"x","maxPool3d");let o=a,u=!1;4===a.rank&&(u=!0,o=Va(a,[1,a.shape[0],a.shape[1],a.shape[2],a.shape[3]])),d(5===o.rank,(()=>`Error in maxPool3d: x must be rank 5 but got rank ${o.rank}.`)),d("NDHWC"===i,(()=>`Error in maxPool3d: Only NDHWC is currently supported, but got dataFormat of ${i}`)),Wa("maxPool3d",r,s);const l={x:o},c={filterSize:t,strides:n,pad:r,dimRoundingMode:s,dataFormat:i},h=vs.runKernel(Ft,l,c);return u?Va(h,[h.shape[1],h.shape[2],h.shape[3],h.shape[4]]):h;
}}),_o=As({mean_:function(e,t=null,n=!1){
const r={x:Es(e,"x","mean")},s={axis:t,keepDims:n};return vs.runKernel(Ot,r,s);
}}),Do=As({min_:function(e,t=null,n=!1){
const r={x:Es(e,"x","min")},s={axis:t,keepDims:n};return vs.runKernel(Mt,r,s);
}}),Oo=As({minimum_:function(e,t){
let n=Es(e,"a","minimum"),r=Es(t,"b","minimum");[n,r]=ps(n,r),"bool"===n.dtype&&(n=fi(n,"int32"),r=fi(r,"int32")),Hi(n.shape,r.shape);const s={a:n,b:r};return vs.runKernel(Lt,s);
}});function Mo(e,t){
for(let n=0;n<e.length;++n){
if(e[e.length-n-1]!==t-1-n){
return!1;
}
}return!0;
}function Lo(e,t,n){
const r=e.length+t.length,s=[];let i=0,a=0;for(let o=0;o<r;o++){
-1===n.indexOf(o)?s.push(e[i++]):s.push(t[a++]);
}return s;
}function zo(e,t){
const n=[],r=e.length;for(let s=0;s<r;s++){
-1===t.indexOf(s)&&n.push(e[s]);
}return[n,t.map((t=>e[t]))];
}function Po(e,t){
return Lo(e,t.map((e=>1)),t);
}function Bo(e,t,n){
d(Mo(t,n),(()=>`${e} supports only inner-most axes for now. Got axes ${t} and rank-${n} input.`));
}function Uo(e,t){
if(Mo(e,t)){
return null;
}const n=[];for(let r=0;r<t;++r){
-1===e.indexOf(r)&&n.push(r);
}return e.forEach((e=>n.push(e))),n;
}function Wo(e){
return e.map(((e,t)=>[t,e])).sort(((e,t)=>e[1]-t[1])).map((e=>e[0]));
}function Vo(e,t){
const n=[];for(let r=t-e;r<t;++r){
n.push(r);
}return n;
}const Go=As({moments_:function(e,t=null,n=!1){
const r=k(t,(e=Es(e,"x","moments")).shape),s=_o(e,r,n);let i=s.shape;n||(i=Po(s.shape,r));const a=$i(Ui(fi(e,"float32"),Va(s,i)));return{mean:s,variance:_o(a,r,n)};
}}),jo=As({neg_:function(e){
const t={x:Es(e,"x","neg")};return vs.runKernel(Wt,t);
}}),Ho=As({notEqual_:function(e,t){
let n=Es(e,"a","notEqual","string_or_numeric"),r=Es(t,"b","notEqual","string_or_numeric");[n,r]=ps(n,r),Hi(n.shape,r.shape);const s={a:n,b:r};return vs.runKernel(Vt,s);
}}),qo=As({oneHot_:function(e,t,n=1,r=0,s="int32"){
if(t<2){
throw new Error(`Error in oneHot: depth must be >=2, but it is ${t}`);
}const i={indices:Es(e,"indices","oneHot","int32")},a={dtype:s,depth:t,onValue:n,offValue:r};return vs.runKernel(Kt,i,a);
}});function Ko(e,t="float32"){
if(P(e),"complex64"===t){
const t=Ko(e,"float32"),n=Ko(e,"float32");return Fs(t,n);
}const n=L(m(e),t);return vs.makeTensor(n,e,t);
}function Xo(e,t="float32"){
if(P(e),"complex64"===t){
const t=Xo(e,"float32"),n=Ko(e,"float32");return Fs(t,n);
}const n=M(m(e),t);return vs.makeTensor(n,e,t);
}const Yo=As({onesLike_:function(e){
const t={x:Es(e,"x","onesLike")};return vs.runKernel(qt,t);
}}),Zo=As({pad_:function(e,t,n=0){
const r=Es(e,"x","pad");if(0===r.rank){
throw new Error("pad(scalar) is not defined. Pass non-scalar to pad");
}const s={paddings:t,constantValue:n},i={x:r};return vs.runKernel(Yt,i,s);
}}),Jo=As({prelu_:function(e,t){
const n={x:Es(e,"x","prelu"),alpha:Es(t,"alpha","prelu")};return vs.runKernel(Jt,n);
}});var Qo=__webpack_require__(313);class eu{
constructor(e,t,n,r,s){
this.mean=e,this.stdDev=t,this.dtype=n,this.nextVal=NaN,this.truncated=r,this.truncated&&(this.upper=this.mean+2*this.stdDev,this.lower=this.mean-2*this.stdDev);const i=s||Math.random();this.random=Qo.alea(i.toString());
}nextValue(){
if(!isNaN(this.nextVal)){
const e=this.nextVal;return this.nextVal=NaN,e;
}let e,t,n=!1;for(;!n;){
let r,s,i;do{
r=2*this.random()-1,s=2*this.random()-1,i=r*r+s*s;
}while(i>=1||0===i);const a=Math.sqrt(-2*Math.log(i)/i);e=this.mean+this.stdDev*r*a,t=this.mean+this.stdDev*s*a,this.truncated&&!this.isValidTruncated(e)||(n=!0);
}return this.truncated&&!this.isValidTruncated(t)||(this.nextVal=this.convertValue(t)),this.convertValue(e);
}convertValue(e){
return null==this.dtype||"float32"===this.dtype?e:Math.round(e);
}isValidTruncated(e){
return e<=this.upper&&e>=this.lower;
}
}class tu{
constructor(e=0,t=1,n,r){
if(this.canReturnFloat=()=>null==this.dtype||"float32"===this.dtype,this.min=e,this.range=t-e,this.dtype=n,null==r&&(r=Math.random()),"number"==typeof r&&(r=r.toString()),!this.canReturnFloat()&&this.range<=1){
throw new Error(`The difference between ${e} - ${t} <= 1 and dtype is not float`);
}this.random=Qo.alea(r);
}convertValue(e){
return this.canReturnFloat()?e:Math.round(e);
}nextValue(){
return this.convertValue(this.min+this.range*this.random());
}
}const nu=As({randomNormal_:function(e,t=0,n=1,r,s){
if(P(e),null!=r&&"bool"===r){
throw new Error(`Unsupported data type ${r}`);
}const i=new eu(t,n,r,!1,s),a=pi(e,r);for(let e=0;e<a.values.length;e++){
a.values[e]=i.nextValue();
}return a.toTensor();
}}),ru=As({randomUniform_:function(e,t=0,n=1,r="float32",s){
P(e);const i=pi(e,r),a=new tu(t,n,null,s);for(let e=0;e<i.values.length;e++){
i.values[e]=a.nextValue();
}return i.toTensor();
}});function su(e,t,n=1,r="float32"){
if(0===n){
throw new Error("Cannot have a step of zero");
}const s={start:e,stop:t,step:n,dtype:r};return vs.runKernel(rn,{},s);
}const iu=As({relu_:function(e){
const t={x:Es(e,"x","relu")};return vs.runKernel(on,t);
}}),au=As({reverse_:function(e,t){
const n={x:Es(e,"x","reverse")},r={dims:t};return vs.runKernel(fn,n,r);
}}),ou=As({selu_:function(e){
const t={x:Es(e,"x","selu")};return vs.runKernel(vn,t);
}}),uu=As({separableConv2d_:function(e,t,n,r,s,i=[1,1],a="NHWC"){
const o=Es(e,"x","separableConv2d"),u=Es(t,"depthwiseFilter","separableConv2d"),l=Es(n,"pointwiseFilter","separableConv2d");let c=o,h=!1;if(3===o.rank&&(h=!0,c=Va(o,[1,o.shape[0],o.shape[1],o.shape[2]])),"NCHW"===a){
throw new Error("separableConv2d currently does not support dataFormat NCHW; only NHWC is supported");
}d(4===c.rank,(()=>`Error in separableConv2d: input must be rank 4, but got rank ${c.rank}.`)),d(4===u.rank,(()=>`Error in separableConv2d: depthwise filter must be rank 4, but got rank ${u.rank}.`)),d(4===l.rank,(()=>`Error in separableConv2d: pointwise filter must be rank 4, but got rank ${u.rank}.`)),d(1===l.shape[0],(()=>`Error in separableConv2d: the first dimension of pointwise filter  must be 1, but got ${l.shape[0]}.`)),d(1===l.shape[1],(()=>`Error in separableConv2d: the second dimension of pointwise filter must be 1, but got ${l.shape[1]}.`));const p=u.shape[2],f=u.shape[3];d(l.shape[2]===p*f,(()=>`Error in separableConv2d: the third dimension of pointwise filter must be ${p*f}, but got ${l.shape[2]}.`));const m=ho(c,u,r,s,a,i),g=ro(m,l,1,"valid",a);return h?Va(g,[g.shape[1],g.shape[2],g.shape[3]]):g;
}}),lu=As({sigmoid_:function(e){
const t={x:Es(e,"x","sigmoid","float32")};return vs.runKernel(Nn,t);
}}),cu=As({slice_:function(e,t,n){
const r=Es(e,"x","slice","string_or_numeric");if(0===r.rank){
throw new Error("Slicing scalar is not possible");
}const s={x:r},i={begin:t,size:n};return vs.runKernel(kn,s,i);
}}),hu=As({slice1d_:function(e,t,n){
const r=Es(e,"x","slice1d");return d(1===r.rank,(()=>`slice1d expects a rank-1 tensor, but got a rank-${r.rank} tensor`)),cu(r,[t],[n]);
}}),du=As({slice2d_:function(e,t,n){
const r=Es(e,"x","slice2d");return d(2===r.rank,(()=>`slice2d expects a rank-2 tensor, but got a rank-${r.rank} tensor`)),cu(r,t,n);
}}),pu=As({slice3d_:function(e,t,n){
const r=Es(e,"x","slice3d");return d(3===r.rank,(()=>`slice3d expects a rank-3 tensor, but got a rank-${r.rank} tensor`)),cu(r,t,n);
}}),fu=As({slice4d_:function(e,t,n){
const r=Es(e,"x","slice4d");return d(4===r.rank,(()=>`slice4d expects a rank-4 tensor, but got a rank-${r.rank} tensor`)),cu(r,t,n);
}}),mu=As({softmax_:function(e,t=-1){
const n=Es(e,"logits","softmax","float32");if(-1===t&&(t=n.rank-1),t!==n.rank-1){
throw Error(`Softmax along a non-last dimension is not yet supported. Logits was rank ${n.rank} and dim was ${t}`);
}const r={logits:n},s={dim:t};return vs.runKernel(Fn,r,s);
}}),gu=As({softplus_:function(e){
const t={x:Es(e,"x","softplus")};return vs.runKernel($n,t);
}}),bu=As({split_:function(e,t,n=0){
const r={x:Es(e,"x","split")},s={numOrSizeSplits:t,axis:n};return vs.runKernel(An,r,s);
}}),xu=As({squeeze_:function(e,t){
const n=Es(e,"x","squeeze","string_or_numeric");return Va(n,I(n.shape,t).newShape);
}}),yu=As({stack_:function(e,t=0){
const n=Rs(e,"tensors","stack","string_or_numeric");d(n.length>=1,(()=>"Pass at least one tensor to tf.stack")),n.length>0&&d(t<=n[0].rank,(()=>"Axis must be <= rank of the tensor"));const r=n,s={axis:t};return vs.runKernel(Xt,r,s);
}}),wu=As({tanh_:function(e){
const t={x:Es(e,"x","tanh","float32")};return vs.runKernel(qn,t);
}});function vu(e,t){
f(e);const n=Ns(e,t);if(1!==n.length){
throw new Error("tensor1d() requires values to be a flat/TypedArray");
}return _s(e,null,n,t);
}const ku=As({truncatedNormal_:function(e,t=0,n=1,r,s){
if(P(e),null!=r&&"bool"===r){
throw new Error("Unsupported data type $ { dtype }");
}const i=new eu(t,n,r,!0,s),a=pi(e,r);for(let e=0;e<a.values.length;e++){
a.values[e]=i.nextValue();
}return a.toTensor();
}}),Iu=As({unstack_:function(e,t=0){
const n=Es(e,"x","unstack","string_or_numeric");d(t>=-n.shape.length&&t<n.shape.length,(()=>`Axis = ${t} is not in [-${n.shape.length}, ${n.shape.length})`));const r={value:n},s={axis:t};return vs.runKernel(Qn,r,s);
}}),Su=As({where_:function(e,t,n){
const r=Es(t,"a","where"),s=Es(n,"b","where"),i=Es(e,"condition","where","bool"),a=Hi(Hi(i.shape,r.shape),s.shape),o={condition:Ya(i,a),t:Ya(r,a),e:Ya(s,a)};return vs.runKernel(wn,o);
}}),Cu=As({imag_:function(e){
const t={input:Es(e,"input","imag")};return vs.runKernel(pt,t);
}}),Nu=As({real_:function(e){
const t={input:Es(e,"input","real")};return vs.runKernel(sn,t);
}}),$u=As({transpose_:function(e,t,n){
const r=Es(e,"x","transpose");if(null==t&&(t=r.shape.map(((e,t)=>t)).reverse()),d(r.rank===t.length,(()=>`Error in transpose: rank of input ${r.rank} must match length of perm ${t}.`)),t.forEach((e=>{
d(e>=0&&e<r.rank,(()=>"All entries in 'perm' must be between 0 and "+(r.rank-1)+` but got ${t}`));
})),r.rank<=1){
return r.clone();
}const s={x:r},i={perm:t};return"complex64"===r.dtype?xi((()=>{
let e=Nu(r),t=Cu(r);return e=vs.runKernel(Zn,{x:e},i),t=vs.runKernel(Zn,{x:t},i),n&&(t=jo(t)),Fs(e,t);
})):vs.runKernel(Zn,s,i);
}}),Tu=As({dropout_:function(e,t,n,r){
const s=Es(e,"x","dropout");if(d("float32"===s.dtype,(()=>`x has to be a floating point tensor since it's going to be scaled, but got a ${s.dtype} tensor instead.`)),d(t>=0&&t<1,(()=>`rate must be a float in the range [0, 1), but got ${t}.`)),0===t){
return e instanceof es?s.clone():s;
}const i=function(e,t){
if(null==t){
return e.shape.slice();
}if(g(e.shape,t)){
return t;
}if(e.shape.length===t.length){
const n=[];for(let r=0;r<e.shape.length;r++){
null==t[r]&&null!=e.shape[r]?n.push(e.shape[r]):n.push(t[r]);
}return n;
}return t;
}(s,n),a=1-t,o=Si(yo(ki(ru(i,0,1,"float32",r),a)),a);return Ci(s,o);
}}),Eu=As({fft_:function(e){
d("complex64"===e.dtype,(()=>`The dtype for tf.spectral.fft() must be complex64 but got ${e.dtype}.`));const t={input:e};return vs.runKernel(tt,t);
}}),Ru=As({rfft_:function(e,t){
d("float32"===e.dtype,(()=>`The dtype for rfft() must be real value but got ${e.dtype}`));let n=e.shape[e.shape.length-1];const r=e.size/n;let s;if(null!=t&&t<n){
const r=e.shape.map((e=>0)),i=e.shape.map((e=>e));i[e.shape.length-1]=t,s=cu(e,r,i),n=t;
}else if(null!=t&&t>n){
const r=e.shape.map((e=>e));r[e.shape.length-1]=t-n,s=Ja([e,Ko(r)],e.shape.length-1),n=t;
}else {
s=e;
}const i=Ti(s),a=Va(Fs(s,i),[r,n]),o=Eu(a),u=Math.floor(n/2)+1,l=Nu(o),c=Cu(o),h=bu(l,[u,n-u],l.shape.length-1),p=bu(c,[u,n-u],c.shape.length-1),f=s.shape.slice();return f[s.shape.length-1]=u,Va(Fs(h[0],p[0]),f);
}}),Au=As({ifft_:function(e){
d("complex64"===e.dtype,(()=>`The dtype for tf.spectral.ifft() must be complex64 but got ${e.dtype}.`));const t={input:e};return vs.runKernel(dt,t);
}}),Fu=As({irfft_:function(e){
const t=e.shape[e.shape.length-1],n=e.size/t;let r;if(t<=2){
const s=Va(e,[n,t]);r=Au(s);
}else{
const s=[n,2*(t-1)],i=Va(Nu(e),[n,t]),a=Va(Cu(e),[n,t]),o=au(cu(i,[0,1],[n,t-2]),1),u=Ci(au(cu(a,[0,1],[n,t-2]),1),Ri(-1)),l=Ja([i,o],1),c=Ja([a,u],1),h=Va(Fs(l,c),[s[0],s[1]]);r=Au(h);
}if(r=Nu(r),3===e.rank&&0!==e.shape[0]){
const t=r,n=e.shape[0];r=Va(r,[n,r.shape[0]/n,r.shape[1]]),t.dispose();
}return r;
}}),_u=As({conv2DBackpropFilter_:function(e,t,n,r,s,i="NHWC",a){
let o=e;3===e.rank&&(o=Va(e,[1,e.shape[0],e.shape[1],e.shape[2]]));let u=t;3===u.rank&&(u=Va(t,[1,t.shape[0],t.shape[1],t.shape[2]])),d(4===o.rank,(()=>`Error in conv2dDerFilter: input must be rank 4, but got shape ${o.shape}.`)),d(4===u.rank,(()=>`Error in conv2dDerFilter: dy must be rank 4, but got shape ${u.shape}.`)),d(4===n.length,(()=>`Error in conv2dDerFilter: filterShape must be length 4, but got ${n}.`));const l="NHWC"===i?o.shape[3]:o.shape[1],c="NHWC"===i?u.shape[3]:u.shape[1];d(l===n[2],(()=>`Error in conv2dDerFilter: depth of input ${l}) must match input depth in filter (${n[2]}.`)),d(c===n[3],(()=>`Error in conv2dDerFilter: depth of dy (${c}) must match output depth for filter (${n[3]}).`)),Wa("conv2dDerFilter",s,a);const h={x:o,dy:u},p={strides:r,pad:s,dataFormat:i,dimRoundingMode:a,filterShape:n};return vs.runKernel($e,h,p);
}}),Du=As({relu6_:function(e){
const t={x:Es(e,"x","relu6")};return vs.runKernel(pn,t);
}}),Ou=As({step_:function(e,t=0){
const n={x:Es(e,"x","step")},r={alpha:t};return vs.runKernel(nr,n,r);
}});function Mu(e,t,n){
if(null==n||"linear"===n){
return e;
}if("relu"===n){
return Ci(e,Ou(t));
}throw new Error(`Cannot compute gradient for fused activation ${n}.`);
}function Lu(e,t){
let n=t;const r=ji(e.shape,t.shape);return r.length>0&&(n=$o(n,r)),Va(n,e.shape);
}function zu(e,t,n,r){
if("linear"===t){
return e;
}if("relu"===t){
return iu(e);
}if("elu"===t){
return po(e);
}if("relu6"===t){
return Du(e);
}if("prelu"===t){
return Jo(e,n);
}if("leakyrelu"===t){
return Io(e,r);
}if("sigmoid"===t){
return lu(e);
}throw new Error(`Unknown fused activation ${t}.`);
}const Pu=(e,t)=>!(e>0)||"linear"===t,Bu=As({fusedConv2d_:function({x:e,filter:t,strides:n,pad:r,dataFormat:s="NHWC",dilations:i=[1,1],dimRoundingMode:a,bias:o,activation:u="linear",preluActivationWeights:l,leakyreluAlpha:c}){
if(u=u||"linear",!1===Pu(vs.state.gradientDepth,u)){
d("NHWC"===s,(()=>`Error in fused conv2d: got dataFormat of ${s} but only NHWC is currently supported for the case of gradient depth is 0 and the activation is not linear.`));let h=ro(e,t,n,r,s,i,a);return null!=o&&(h=ki(h,o)),zu(h,u,l,c);
}const h=Es(e,"x","conv2d","float32"),p=Es(t,"filter","conv2d","float32");let f=h,m=!1;3===h.rank&&(m=!0,f=Va(h,[1,h.shape[0],h.shape[1],h.shape[2]])),d(4===f.rank,(()=>`Error in fused conv2d: input must be rank 4, but got rank ${f.rank}.`)),d(4===p.rank,(()=>`Error in fused conv2d: filter must be rank 4, but got rank ${p.rank}.`)),Wa("fused conv2d",r,a);const g="NHWC"===s?f.shape[3]:f.shape[1];d(p.shape[2]===g,(()=>`Error in conv2d: depth of input (${g}) must match input depth for filter ${p.shape[2]}.`)),d(Pa(n,i),(()=>`Error in conv2D: Either strides or dilations must be 1. Got strides ${n} and dilations '${i}'`));const b=Aa(f.shape,p.shape,n,i,r,a);let x,y;if(null!=o&&(x=Es(o,"bias","fused conv2d"),[x]=ps(x,h),"NHWC"===s?Hi(b.outShape,x.shape):(d(x.shape.length<=1,(()=>`Error in fused conv2d: only supports scalar or 1-D Tensor bias for NCHW format but got the bias of rank-${x.shape.length}.`)),d(0===x.shape.length||x.shape[0]===b.outChannels||1===x.shape[0],(()=>`Error in fused conv2d: bias shape (${x.shape}) is not compatible with the number of output channels (${b.outChannels})`)))),null!=l){
const e=l.shape;if(d(e.length<=1||3===e.length,(()=>`Error in fused conv2d: only supports scalar, 1-D Tensor or 3-D Tensor PReLU activation weights but got a tensor of rank-${e.length}.`)),1===e.length){
d(1===e[0]||e[0]===b.outChannels,(()=>`Error in fused conv2d: PReLU activation weights (${e}) is not compatible with the number of output channels (${b.outChannels}).`));
}else if(3===e.length){
try{
Hi(e,b.outShape);
}catch(t){
const n=`Error in fused conv2d: PReLU activation weights (${e}) is not compatible with the output shape of the conv2d (${b.outShape}).`;throw Error(n);
}
}y=Es(l,"prelu weights","fused conv2d");
}const w=(e,t)=>{
d("NHWC"===s,(()=>`Error in gradient of fused conv2D: got dataFormat of ${s} but only NHWC is currently supported.`));const[a,o,l,c]=t,h=Mu(e,l,u);d(za(i),(()=>`Error in gradient of fused conv2D: dilation rates greater than 1 are not yet supported in gradients. Got dilations '${i}'`));const p=[io(o.shape,h,a,n,r),_u(o,h,a.shape,n,r)];if(null!=c){
const e=Lu(c,h);p.push(e);
}return p;
},v={x:f,filter:p,bias:x,preluActivationWeights:y},k={strides:n,pad:r,dataFormat:s,dilations:i,dimRoundingMode:a,activation:u,leakyreluAlpha:c};if(null==o){
const e=Ei(((e,t,n)=>{
let r=vs.runKernel(ir,v,k);return n([t,e,r]),m&&(r=Va(r,[r.shape[1],r.shape[2],r.shape[3]])),{value:r,gradFunc:w};
}));return e(f,p);
}{const e=Ei(((e,t,n,r)=>{
let s=vs.runKernel(ir,v,k);return r([t,e,s,n]),m&&(s=Va(s,[s.shape[1],s.shape[2],s.shape[3]])),{value:s,gradFunc:w};
}));return e(f,p,x);}
}}),Uu=As({depthwiseConv2dNativeBackpropFilter_:function(e,t,n,r,s,i=[1,1],a){
let o=e;3===e.rank&&(o=Va(e,[1,e.shape[0],e.shape[1],e.shape[2]]));let u=t;3===u.rank&&(u=Va(t,[1,t.shape[0],t.shape[1],t.shape[2]]));const l={x:o,dy:u},c={strides:r,pad:s,dimRoundingMode:a,dilations:i,filterShape:n};return vs.runKernel(Be,l,c);
}}),Wu=As({depthwiseConv2dNativeBackpropInput_:function(e,t,n,r,s,i=[1,1],a){
let o=t,u=!1;3===t.rank&&(u=!0,o=Va(t,[1,t.shape[0],t.shape[1],t.shape[2]]));const l={dy:o,filter:n},c={strides:r,pad:s,dimRoundingMode:a,dilations:i,inputShape:e},h=vs.runKernel(Ue,l,c);return u?Va(h,[h.shape[1],h.shape[2],h.shape[3]]):h;
}}),Vu=As({fusedMatMul_:function({a:e,b:t,transposeA:n=!1,transposeB:r=!1,bias:s,activation:i="linear",preluActivationWeights:a,leakyreluAlpha:o=.2}){
if(!1===Pu(vs.state.gradientDepth,i)){
let u=Ro(e,t,n,r);return null!=s&&(u=ki(u,s)),zu(u,i,a,o);
}let u=Es(e,"a","fused matMul"),l=Es(t,"b","fused matMul");[u,l]=ps(u,l);const c=n?u.shape[u.rank-2]:u.shape[u.rank-1],h=r?l.shape[l.rank-1]:l.shape[l.rank-2],p=n?u.shape[u.rank-1]:u.shape[u.rank-2],f=r?l.shape[l.rank-2]:l.shape[l.rank-1],g=u.shape.slice(0,-2),b=l.shape.slice(0,-2),x=m(g),y=m(b);d(c===h,(()=>`Error in fused matMul: inner shapes (${c}) and (${h}) of Tensors with shapes ${u.shape} and ${l.shape} and transposeA=${n} and transposeB=${r} must match.`));const w=Hi(u.shape.slice(0,-2),l.shape.slice(0,-2)).concat([p,f]),v=Va(u,n?[x,c,p]:[x,p,c]),k=Va(l,r?[y,f,h]:[y,h,f]);let I,S;null!=s&&(I=Es(s,"bias","fused matMul"),[I]=ps(I,u),Hi(w,I.shape)),null!=a&&(S=Es(a,"prelu weights","fused matMul"));const C=(e,t)=>{
const[a,o,u,l]=t,c=Mu(Va(e,u.shape),u,i);let h,d;return n||r?!n&&r?(h=Ro(c,o,!1,!1),d=Ro(c,a,!0,!1)):n&&!r?(h=Ro(o,c,!1,!0),d=Ro(a,c,!1,!1)):(h=Ro(o,c,!0,!0),d=Ro(c,a,!0,!0)):(h=Ro(c,o,!1,!0),d=Ro(a,c,!0,!1)),null!=s?[h,d,Lu(l,c)]:[h,d];
},N={a:v,b:k,bias:I,preluActivationWeights:S},$={transposeA:n,transposeB:r,activation:i,leakyreluAlpha:o};if(null==s){
const e=Ei(((e,t,n)=>{
const r=vs.runKernel(sr,N,$);return n([e,t,r]),{value:Va(r,w),gradFunc:C};
}));return e(v,k);
}{const e=Ei(((e,t,n,r)=>{
const s=vs.runKernel(sr,N,$);return r([e,t,s,n]),{value:Va(s,w),gradFunc:C};
}));return e(v,k,I);}
}});function Gu(e,t,n){
if(f(e),null!=t&&2!==t.length){
throw new Error("tensor2d() requires shape to have two numbers");
}const r=Ns(e,n);if(2!==r.length&&1!==r.length){
throw new Error("tensor2d() requires values to be number[][] or flat/TypedArray");
}if(1===r.length&&null==t){
throw new Error("tensor2d() requires shape to be provided when `values` are a flat/TypedArray");
}return _s(e,t,r,n);
}const ju=As({cropAndResize_:function(e,t,n,r,s="bilinear",i=0){
const a=Es(e,"image","cropAndResize"),o=Es(t,"boxes","cropAndResize","float32"),u=Es(n,"boxInd","cropAndResize","int32"),l=o.shape[0];d(4===a.rank,(()=>`Error in cropAndResize: image must be rank 4,but got rank ${a.rank}.`)),d(2===o.rank&&4===o.shape[1],(()=>`Error in cropAndResize: boxes must be have size [${l},4] but had shape ${o.shape}.`)),d(1===u.rank&&u.shape[0]===l,(()=>`Error in cropAndResize: boxInd must be have size [${l}] but had shape ${o.shape}.`)),d(2===r.length,(()=>`Error in cropAndResize: cropSize must be of length 2, but got length ${r.length}.`)),d(r[0]>=1&&r[1]>=1,(()=>`cropSize must be atleast [1,1], but was ${r}`)),d("bilinear"===s||"nearest"===s,(()=>`method must be bilinear or nearest, but was ${s}`));const c={image:a,boxes:o,boxInd:u},h={method:s,extrapolationValue:i,cropSize:r};return vs.runKernel(Me,c,h);
}}),Hu=As({flipLeftRight_:function(e){
const t=Es(e,"image","flipLeftRight","float32");d(4===t.rank,(()=>`Error in flipLeftRight: image must be rank 4,but got rank ${t.rank}.`));const n={image:t};return vs.runKernel(rt,n,{});
}}),qu=As({grayscaleToRGB_:function(e){
const t=Es(e,"image","grayscaleToRGB"),n=t.rank-1,r=t.shape[n];d(t.rank>=2,(()=>`Error in grayscaleToRGB: images must be at least rank 2, but got rank ${t.rank}.`)),d(1===r,(()=>`Error in grayscaleToRGB: last dimension of a grayscale image should be size 1, but got size ${r}.`));const s=new Array(t.rank);return s.fill(1,0,n),s[n]=3,bo(t,s);
}}),Ku=As({einsum_:function(e,...t){
const n=t.map(((e,t)=>Es(e,`tensors${t}`,"einsum"))),r={equation:e};return vs.runKernel(qe,n,r);
}}),Xu=As({rgbToGrayscale_:function(e){
const t=Es(e,"image","RGBToGrayscale"),n=t.rank-1,r=t.shape[n];d(t.rank>=2,(()=>`Error in RGBToGrayscale: images must be at least rank 2, but got rank ${t.rank}.`)),d(3===r,(()=>`Error in RGBToGrayscale: last dimension of an RGB image should be size 3, but got size ${r}.`));const s=t.dtype,i=fi(t,"float32"),a=vu([.2989,.587,.114]);let o;switch(t.rank){
case 2:o=Ku("ij,j->i",i,a);break;case 3:o=Ku("ijk,k->ij",i,a);break;case 4:o=Ku("ijkl,l->ijk",i,a);break;case 5:o=Ku("ijklm,m->ijkl",i,a);break;case 6:o=Ku("ijklmn,n->ijklm",i,a);break;default:throw new Error("Not a valid tensor rank.");
}return o=go(o,-1),fi(o,s);
}}),Yu=As({rotateWithOffset_:function(e,t,n=0,r=.5){
const s=Es(e,"image","rotateWithOffset","float32");d(4===s.rank,(()=>`Error in rotateWithOffset: image must be rank 4,but got rank ${s.rank}.`));const i={image:s},a={radians:t,fillValue:n,center:r};return vs.runKernel(rr,i,a);
}});function Zu(e,t,n,r,s,i){
null==r&&(r=.5),null==s&&(s=Number.NEGATIVE_INFINITY),null==i&&(i=0);const a=e.shape[0];return n=Math.min(n,a),d(0<=r&&r<=1,(()=>`iouThreshold must be in [0, 1], but was '${r}'`)),d(2===e.rank,(()=>`boxes must be a 2D tensor, but was of rank '${e.rank}'`)),d(4===e.shape[1],(()=>`boxes must have 4 columns, but 2nd dimension was ${e.shape[1]}`)),d(1===t.rank,(()=>"scores must be a 1D tensor")),d(t.shape[0]===a,(()=>`scores has incompatible shape with boxes. Expected ${a}, but was ${t.shape[0]}`)),d(0<=i&&i<=1,(()=>`softNmsSigma must be in [0, 1], but was '${i}'`)),{maxOutputSize:n,iouThreshold:r,scoreThreshold:s,softNmsSigma:i};
}const Ju=As({nonMaxSuppression_:function(e,t,n,r=.5,s=Number.NEGATIVE_INFINITY){
const i=Es(e,"boxes","nonMaxSuppression","float32"),a=Es(t,"scores","nonMaxSuppression","float32"),o=Zu(i,a,n,r,s),u={maxOutputSize:n=o.maxOutputSize,iouThreshold:r=o.iouThreshold,scoreThreshold:s=o.scoreThreshold};return vs.runKernel(Gt,{boxes:i,scores:a},u);
}});function Qu(e,t,n){
const r=function(e,t,n){
return function(e,t,n){
let r=0,s=e.length,i=0,a=!1;for(;r<s;){
i=r+(s-r>>>1);const o=n(t,e[i]);o>0?r=i+1:(s=i,a=!o);
}return a?r:-r-1;
}(e,t,n||el);
}(e,t,n),s=r<0?-(r+1):r;e.splice(s,0,t);
}function el(e,t){
return e>t?1:e<t?-1:0;
}function tl(e,t,n,r,s){
return sl(e,t,n,r,s,0);
}function nl(e,t,n,r,s,i){
return sl(e,t,n,r,s,0,!1,i,!0);
}function rl(e,t,n,r,s,i){
return sl(e,t,n,r,s,i,!0);
}function sl(e,t,n,r,s,i,a=!1,o=!1,u=!1){
const l=[];for(let e=0;e<t.length;e++){
t[e]>s&&l.push({score:t[e],boxIndex:e,suppressBeginIndex:0});
}l.sort(ol);const c=i>0?-.5/i:0,h=[],d=[];for(;h.length<n&&l.length>0;){
const t=l.pop(),{score:n,boxIndex:i,suppressBeginIndex:a}=t;if(n<s){
break;
}let o=!1;for(let n=h.length-1;n>=a;--n){
const a=il(e,i,h[n]);if(a>=r){
o=!0;break;
}if(t.score=t.score*al(r,c,a),t.score<=s){
break;
}
}t.suppressBeginIndex=h.length,o||(t.score===n?(h.push(i),d.push(t.score)):t.score>s&&Qu(l,t,ol));
}const p=h.length,f=n-p;o&&f>0&&(h.push(...new Array(f).fill(0)),d.push(...new Array(f).fill(0)));const m={selectedIndices:h};return a&&(m.selectedScores=d),u&&(m.validOutputs=p),m;
}function il(e,t,n){
const r=e.subarray(4*t,4*t+4),s=e.subarray(4*n,4*n+4),i=Math.min(r[0],r[2]),a=Math.min(r[1],r[3]),o=Math.max(r[0],r[2]),u=Math.max(r[1],r[3]),l=Math.min(s[0],s[2]),c=Math.min(s[1],s[3]),h=Math.max(s[0],s[2]),d=Math.max(s[1],s[3]),p=(o-i)*(u-a),f=(h-l)*(d-c);if(p<=0||f<=0){
return 0;
}const m=Math.max(i,l),g=Math.max(a,c),b=Math.min(o,h),x=Math.min(u,d),y=Math.max(b-m,0)*Math.max(x-g,0);return y/(p+f-y);
}function al(e,t,n){
const r=Math.exp(t*n*n);return n<=e?r:0;
}function ol(e,t){
return e.score-t.score||e.score===t.score&&t.boxIndex-e.boxIndex;
}const ul=As({nonMaxSuppressionWithScore_:function(e,t,n,r=.5,s=Number.NEGATIVE_INFINITY,i=0){
const a=Es(e,"boxes","nonMaxSuppression"),o=Es(t,"scores","nonMaxSuppression"),u=Zu(a,o,n,r,s,i),l={boxes:a,scores:o},c={maxOutputSize:n=u.maxOutputSize,iouThreshold:r=u.iouThreshold,scoreThreshold:s=u.scoreThreshold,softNmsSigma:i=u.softNmsSigma},h=vs.runKernel(Ht,l,c);return{selectedIndices:h[0],selectedScores:h[1]};
}}),ll=As({nonMaxSuppressionPadded_:function(e,t,n,r=.5,s=Number.NEGATIVE_INFINITY,i=!1){
const a=Es(e,"boxes","nonMaxSuppression"),o=Es(t,"scores","nonMaxSuppression"),u=Zu(a,o,n,r,s,null),l={boxes:a,scores:o},c={maxOutputSize:u.maxOutputSize,iouThreshold:u.iouThreshold,scoreThreshold:u.scoreThreshold,padToMaxOutputSize:i},h=vs.runKernel(jt,l,c);return{selectedIndices:h[0],validOutputs:h[1]};
}}),cl=As({resizeBilinear_:function(e,t,n=!1,r=!1){
const s=Es(e,"images","resizeBilinear");d(3===s.rank||4===s.rank,(()=>`Error in resizeBilinear: x must be rank 3 or 4, but got rank ${s.rank}.`)),d(2===t.length,(()=>`Error in resizeBilinear: new shape must 2D, but got shape ${t}.`)),d(!1===r||!1===n,(()=>"Error in resizeBilinear: If halfPixelCenters is true, alignCorners must be false."));let i=s,a=!1;3===s.rank&&(a=!0,i=Va(s,[1,s.shape[0],s.shape[1],s.shape[2]]));const[]=t,o={images:i},u={alignCorners:n,halfPixelCenters:r,size:t},l=vs.runKernel(hn,o,u);return a?Va(l,[l.shape[1],l.shape[2],l.shape[3]]):l;
}}),hl=As({resizeNearestNeighbor_:function(e,t,n=!1,r=!1){
const s=Es(e,"images","resizeNearestNeighbor");d(3===s.rank||4===s.rank,(()=>`Error in resizeNearestNeighbor: x must be rank 3 or 4, but got rank ${s.rank}.`)),d(2===t.length,(()=>`Error in resizeNearestNeighbor: new shape must 2D, but got shape ${t}.`)),d("float32"===s.dtype||"int32"===s.dtype,(()=>"`images` must have `int32` or `float32` as dtype")),d(!1===r||!1===n,(()=>"Error in resizeNearestNeighbor: If halfPixelCenters is true, alignCorners must be false."));let i=s,a=!1;3===s.rank&&(a=!0,i=Va(s,[1,s.shape[0],s.shape[1],s.shape[2]]));const[]=t,o={images:i},u={alignCorners:n,halfPixelCenters:r,size:t},l=vs.runKernel(ln,o,u);return a?Va(l,[l.shape[1],l.shape[2],l.shape[3]]):l;
}}),dl=As({bincount_:function(e,t,n){
const r=Es(e,"x","bincount"),s=Es(t,"weights","bincount");d("int32"===r.dtype,(()=>`Error in bincount: input dtype must be int32, but got ${r.dtype}`)),d(n>=0,(()=>`size must be non-negative, but got ${n}.`)),d(s.size===r.size||0===s.size,(()=>`Error in bincount: weights must have the same size as input or0-length, but got input shape: ${r.shape}, weights shape: ${s.shape}.`));const i={x:r,weights:s},a={size:n};return vs.runKernel(be,i,a);
}}),pl=As({lessEqual_:function(e,t){
let n=Es(e,"a","lessEqual","string_or_numeric"),r=Es(t,"b","lessEqual","string_or_numeric");[n,r]=ps(n,r),Hi(n.shape,r.shape);const s={a:n,b:r};return vs.runKernel(yt,s);
}}),fl=As({round_:function(e){
const t={x:Es(e,"x","round")};return vs.runKernel(mn,t);
}}),ml=As({threshold_:function(e,t="binary",n=!1,r=.5){
const s=Es(e,"image","threshold"),i=s.shape[0]*s.shape[1];let a,o,u,l,c=Ci(vu([r]),255);if(d(3===s.rank,(()=>`Error in threshold: image must be rank 3,but got rank ${s.rank}.`)),d(3===s.shape[2]||1===s.shape[2],(()=>`Error in threshold: image color channel must be equal to 3 or 1but got ${s.shape[2]}.`)),d("int32"===s.dtype||"float32"===s.dtype,(()=>`Error in dtype: image dtype must be int32 or float32,but got dtype ${s.dtype}.`)),d("otsu"===t||"binary"===t,(()=>`Method must be binary or otsu, but was ${t}`)),3===s.shape[2]){
[a,o,u]=bu(s,[1,1,1],-1);const e=Ci(a,.2989),t=Ci(o,.587),n=Ci(u,.114);l=ki(ki(e,t),n);
}else {
l=e;
}"otsu"===t&&(c=function(e,t){
let n,r,s,i,a,o,u=vu([-1]),l=vu([0]),c=vu([0]);for(let h=0;h<e.size-1;h++){
n=cu(e,0,h+1),r=cu(e,h+1),a=Si($o(n),t),o=Si($o(r),t);const d=$o(Ci(n,su(0,n.size)));s=Si(d,$o(n));const p=zi(r.shape,n.size),f=ki(su(0,r.size),p),m=Ci(r,f);i=Si($o(m),$o(r));const g=Ui(s,i),b=Ui(s,i),x=Ci(a,o);c=Ci(Ci(x,g),b);const y=vo(c,l);l=Su(y,c,l),u=Su(y,vu([h]),u);
}return u;
}(dl(fi(fl(l),"int32"),Ds([]),256),i));const h=n?pl(l,c):vo(l,c);return fi(Ci(h,255),"int32");
}}),gl=As({transform_:function(e,t,n="nearest",r="constant",s=0,i){
const a=Es(e,"image","transform","float32"),o=Es(t,"transforms","transform","float32");d(4===a.rank,(()=>`Error in transform: image must be rank 4,but got rank ${a.rank}.`)),d(2===o.rank&&(o.shape[0]===a.shape[0]||1===o.shape[0])&&8===o.shape[1],(()=>"Error in transform: Input transform should be batch x 8 or 1 x 8")),d(null==i||2===i.length,(()=>`Error in transform: outputShape must be [height, width] or null, but got ${i}.`));const u={image:a,transforms:o},l={interpolation:n,fillMode:r,fillValue:s,outputShape:i};return vs.runKernel(Yn,u,l);
}}),bl=As({less_:function(e,t){
let n=Es(e,"a","less","string_or_numeric"),r=Es(t,"b","less","string_or_numeric");[n,r]=ps(n,r),Hi(n.shape,r.shape);const s={a:n,b:r};return vs.runKernel(xt,s);
}}),xl=As({bandPart_:function(e,t,n){
const r=Es(e,"a","bandPart");d(r.rank>=2,(()=>`bandPart(): Rank must be at least 2, got ${r.rank}.`));const s=r.shape,[i,a]=r.shape.slice(-2);let o,u;"number"==typeof t?(d(t%1==0,(()=>`bandPart(): numLower must be an integer, got ${t}.`)),d(t<=i,(()=>`bandPart(): numLower (${t}) must not be greater than the number of rows (${i}).`)),o=Es(t<0?i:t,"numLower","bandPart")):(d("int32"===t.dtype,(()=>"bandPart(): numLower's dtype must be an int32.")),o=Su(bl(t,0),i,Oo(t,i))),"number"==typeof n?(d(n%1==0,(()=>`bandPart(): numUpper must be an integer, got ${n}.`)),d(n<=a,(()=>`bandPart(): numUpper (${n}) must not be greater than the number of columns (${a}).`)),u=Es(n<0?a:n,"numUpper","bandPart")):(d("int32"===n.dtype,(()=>"bandPart(): numUpper's dtype must be an int32.")),u=Su(bl(n,0),a,Oo(n,a)));const l=Va(su(0,i,1,"int32"),[-1,1]),c=su(0,a,1,"int32"),h=Ui(l,c),p=Eo(pl(h,o),ko(h,jo(u))),f=Ko([i,a],r.dtype);return Va(yu(Iu(Va(r,[-1,i,a])).map((e=>Su(p,e,f)))),s);
}});function yl(e,t,n=null){
if(0===e.rank){
return Vi(e);
}if(1!==e.rank&&null===n){
return yl(Va(e,[-1]),t,n);
}if(1===e.rank||"number"==typeof n||Array.isArray(n)&&1===n.length){
if(1===t){
return $o(Vi(e),n);
}if(t===1/0){
return No(Vi(e),n);
}if(t===-1/0){
return Do(Vi(e),n);
}if("euclidean"===t||2===t){
return Ni($o(Bi(Vi(e),Ri(2,"int32")),n));
}throw new Error(`Error in norm: invalid ord value: ${t}`);
}if(Array.isArray(n)&&2===n.length){
if(1===t){
return No($o(Vi(e),n[0]),n[1]-1);
}if(t===1/0){
return No($o(Vi(e),n[1]),n[0]);
}if(t===-1/0){
return Do($o(Vi(e),n[1]),n[0]);
}if("fro"===t||"euclidean"===t){
return Ni($o($i(e),n));
}throw new Error(`Error in norm: invalid ord value: ${t}`);
}throw new Error(`Error in norm: invalid axis: ${n}`);
}const wl=As({norm_:function(e,t="euclidean",n=null,r=!1){
const s=yl(e=Es(e,"x","norm"),t,n);let i=s.shape;if(r){
const t=k(n,e.shape);i=Po(s.shape,t);
}return Va(s,i);
}}),vl=As({gramSchmidt_:function(e){
let t;if(Array.isArray(e)){
t=!1,d(null!=e&&e.length>0,(()=>"Gram-Schmidt process: input must not be null, undefined, or empty"));const n=e[0].shape[0];for(let t=1;t<e.length;++t){
d(e[t].shape[0]===n,(()=>`Gram-Schmidt: Non-unique lengths found in the input vectors: (${e[t].shape[0]} vs. ${n})`));
}
}else {
t=!0,e=bu(e,e.shape[0],0).map((e=>xu(e,[0])));
}d(e.length<=e[0].shape[0],(()=>`Gram-Schmidt: Number of vectors (${e.length}) exceeds number of dimensions (${e[0].shape[0]}).`));const n=[],r=e;for(let t=0;t<e.length;++t){
n.push(vs.tidy((()=>{
let e=r[t];if(t>0){
for(let r=0;r<t;++r){
const t=Ci($o(Ci(n[r],e)),n[r]);e=Ui(e,t);
}
}return Si(e,wl(e,"euclidean"));
})));
}return t?yu(n,0):n;
}});function kl(e,t=!1){
return vs.tidy((()=>{
d(2===e.shape.length,(()=>`qr2d() requires a 2D Tensor, but got a ${e.shape.length}D Tensor.`));const n=e.shape[0],r=e.shape[1];let s=xo(n),i=mi(e);const a=Gu([[1]],[1,1]);let o=mi(a);const u=n>=r?r:n;for(let e=0;e<u;++e){
const t=i,u=o,l=s;[o,i,s]=vs.tidy((()=>{
const t=cu(i,[e,e],[n-e,1]),u=wl(t),l=cu(i,[e,e],[1,1]),c=Su(vo(l,0),Gu([[-1]]),Gu([[1]])),h=Ui(l,Ci(c,u)),d=Si(t,h);o=1===d.shape[0]?mi(a):Ja([a,cu(d,[1,0],[d.shape[0]-1,d.shape[1]])],0);const p=jo(Si(Ro(c,h),u)),f=cu(i,[e,0],[n-e,r]),m=Ci(p,o),g=$u(o);if(0===e){
i=Ui(f,Ro(m,Ro(g,f)));
}else{
const t=Ui(f,Ro(m,Ro(g,f)));i=Ja([cu(i,[0,0],[e,r]),t],0);
}const b=$u(m),x=cu(s,[0,e],[n,s.shape[1]-e]);if(0===e){
s=Ui(x,Ro(Ro(x,o),b));
}else{
const t=Ui(x,Ro(Ro(x,o),b));s=Ja([cu(s,[0,0],[n,e]),t],1);
}return[o,i,s];
})),yi([t,u,l]);
}return!t&&n>r&&(s=cu(s,[0,0],[n,r]),i=cu(i,[0,0],[r,r])),[s,i];
}));
}const Il=As({qr_:function(e,t=!1){
if(d(e.rank>=2,(()=>`qr() requires input tensor to have a rank >= 2, but got rank ${e.rank}`)),2===e.rank){
return kl(e,t);
}{const n=e.shape.slice(0,e.shape.length-2).reduce(((e,t)=>e*t)),r=Iu(Va(e,[n,e.shape[e.shape.length-2],e.shape[e.shape.length-1]]),0),s=[],i=[];return r.forEach((e=>{
const[n,r]=kl(e,t);s.push(n),i.push(r);
})),[Va(yu(s,0),e.shape),Va(yu(i,0),e.shape)];}
}});var Sl;!function(e){
e[e.NONE=0]="NONE",e[e.MEAN=1]="MEAN",e[e.SUM=2]="SUM",e[e.SUM_BY_NONZERO_WEIGHTS=3]="SUM_BY_NONZERO_WEIGHTS";
}(Sl||(Sl={}));const Cl=As({squaredDifference_:function(e,t){
let n=Es(e,"a","squaredDifference"),r=Es(t,"b","squaredDifference");[n,r]=ps(n,r),Hi(n.shape,r.shape);const s={a:n,b:r};return vs.runKernel(zn,s,{});
}}),Nl=As({logSumExp_:function(e,t=null,n=!1){
const r=Es(e,"x","logSumExp"),s=k(t,r.shape),i=No(r,s,!0),a=Ui(r,i),o=mo(a),u=$o(o,s),l=So(u),c=ki(Va(i,l.shape),l);if(n){
const e=Po(c.shape,s);return Va(c,e);
}return c;
}}),$l={flipLeftRight:Hu,grayscaleToRGB:qu,resizeNearestNeighbor:hl,resizeBilinear:cl,rgbToGrayscale:Xu,rotateWithOffset:Yu,cropAndResize:ju,nonMaxSuppression:Ju,nonMaxSuppressionAsync:async function(e,t,n,r=.5,s=Number.NEGATIVE_INFINITY){
const i=Es(e,"boxes","nonMaxSuppressionAsync"),a=Es(t,"scores","nonMaxSuppressionAsync"),o=Zu(i,a,n,r,s);n=o.maxOutputSize,r=o.iouThreshold,s=o.scoreThreshold;const u=await Promise.all([i.data(),a.data()]),l=u[0],c=u[1],{selectedIndices:h}=tl(l,c,n,r,s);return i!==e&&i.dispose(),a!==t&&a.dispose(),vu(h,"int32");
},nonMaxSuppressionWithScore:ul,nonMaxSuppressionWithScoreAsync:async function(e,t,n,r=.5,s=Number.NEGATIVE_INFINITY,i=0){
const a=Es(e,"boxes","nonMaxSuppressionAsync"),o=Es(t,"scores","nonMaxSuppressionAsync"),u=Zu(a,o,n,r,s,i);n=u.maxOutputSize,r=u.iouThreshold,s=u.scoreThreshold,i=u.softNmsSigma;const l=await Promise.all([a.data(),o.data()]),c=l[0],h=l[1],{selectedIndices:d,selectedScores:p}=rl(c,h,n,r,s,i);return a!==e&&a.dispose(),o!==t&&o.dispose(),{selectedIndices:vu(d,"int32"),selectedScores:vu(p)};
},nonMaxSuppressionPadded:ll,nonMaxSuppressionPaddedAsync:async function(e,t,n,r=.5,s=Number.NEGATIVE_INFINITY,i=!1){
const a=Es(e,"boxes","nonMaxSuppressionAsync"),o=Es(t,"scores","nonMaxSuppressionAsync"),u=Zu(a,o,n,r,s,null),l=u.maxOutputSize,c=u.iouThreshold,h=u.scoreThreshold,[d,p]=await Promise.all([a.data(),o.data()]),{selectedIndices:f,validOutputs:m}=nl(d,p,l,c,h,i);return a!==e&&a.dispose(),o!==t&&o.dispose(),{selectedIndices:vu(f,"int32"),validOutputs:Ri(m,"int32")};
},threshold:ml,transform:gl},Tl={bandPart:xl,gramSchmidt:vl,qr:Il},El=class{
static sgd(e){
return new Xi(e);
}static momentum(e,t,n=!1){
return new Yi(e,t,n);
}static rmsprop(e,t=.9,n=0,r=null,s=!1){
return new Zi(e,t,n,r,s);
}static adam(e=.001,t=.9,n=.999,r=null){
return new Wi(e,t,n,r);
}static adadelta(e=.001,t=.95,n=null){
return new Li(e,t,n);
}static adamax(e=.002,t=.9,n=.999,r=null,s=0){
return new Ki(e,t,n,r,s);
}static adagrad(e,t=.1){
return new Pi(e,t);
}
},Rl="undefined"!=typeof requestAnimationFrame?requestAnimationFrame:"undefined"!=typeof setImmediate?setImmediate:e=>e();function Al(){
return new Promise((e=>Rl((()=>e()))));
}function Fl(e,t){
const n=e[0].length;e.forEach(((e,t)=>{
d(e.length===n,(()=>`Error in concat${n}D: rank of tensors[${t}] must be the same as the rank of the rest (${n})`));
})),d(t>=0&&t<n,(()=>`Error in concat${n}D: axis must be between 0 and ${n-1}.`));const r=e[0];e.forEach(((e,s)=>{
for(let i=0;i<n;i++){
d(i===t||e[i]===r[i],(()=>`Error in concat${n}D: Shape of tensors[${s}] (${e}) does not match the shape of the rest (${r}) along the non-concatenated axis ${s}.`));
}
}));
}function _l(e,t){
const n=e[0].slice();for(let r=1;r<e.length;r++){
n[t]+=e[r][t];
}return n;
}var Dl;function Ol(e,t,n){
let r=[];if(null==n&&null==t){
return r;
}if(null==t){
for(;r.length<e+n.length;){
r.push(-1);
}
}else {
r=t.slice();
}if(null==n){
return r;
}if(e+n.length!==r.length){
throw new Error(`rt input.shape and shape=${t} are incompatible: rt input.rank = ${e+n.length}, but shape.rank = ${r.length}`);
}for(let s=1;s<n.length;++s){
const i=n[s],a=r[r.length-n.length+s],o=r[a];if(i>=0){
if(o>=0){
if(o!==i){
throw new Error(`rt input.shape and shape=${t} are incompatible: rt input.shape[${s+e}] = ${i} but shape[${s+e}] = ${o}`);
}
}else {
r[a]=i;
}
}
}return r;
}function Ml(e){
const t={FIRST_DIM_SIZE:Dl.FIRST_DIM_SIZE,VALUE_ROWIDS:Dl.VALUE_ROWIDS,ROW_LENGTHS:Dl.ROW_LENGTHS,ROW_SPLITS:Dl.ROW_SPLITS,ROW_LIMITS:Dl.ROW_LIMITS,ROW_STARTS:Dl.ROW_STARTS},n=[];for(const r of e){
if(!(r in t)){
break;
}n.push(t[r]);
}return n;
}function Ll(e){
return 0===e.length?0:e[0]===Dl.FIRST_DIM_SIZE?e.length-1:e.length;
}function zl(e,t){
if(null==e||null==t){
return;
}const n=e.length,r=t.length;if(n>=r){
throw new Error(`defaultValue.shape=${e} and ragged tensor flatValues.shape=${t}, are incompatible: defaultValue.rank = ${n} must be less than ragged tensor input flatValues.rank = ${r})`);
}for(let s=0;s<Math.min(n,r-1);++s){
const n=e[s],r=t[s+1];if(n>=0&&r>=0&&1!==n&&n!==r){
throw new Error(`defaultValue.shape=${e}, and ragged tensor input flatValues.shape=${t} are incompatible: defaultValue.shape[${s-e.length}] = ${n} but ragged tensor input.flatValues.shape[${s-e.length}] = ${r}`);
}
}
}!function(e){
e[e.FIRST_DIM_SIZE=0]="FIRST_DIM_SIZE",e[e.VALUE_ROWIDS=1]="VALUE_ROWIDS",e[e.ROW_LENGTHS=2]="ROW_LENGTHS",e[e.ROW_SPLITS=3]="ROW_SPLITS",e[e.ROW_LIMITS=4]="ROW_LIMITS",e[e.ROW_STARTS=5]="ROW_STARTS";
}(Dl||(Dl={}));const Pl=30;function Bl(e){
return e<=Pl?e:F(e,Math.floor(Math.sqrt(e)));
}function Ul(e,t,n){
return[n*("number"==typeof e?e:e[0]),t*("number"==typeof e?e:e[1])];
}function Wl(e,t,n,r=!0){
let s=[];if(r){
s=s.concat(t.slice(0)),s.push(e[0]/n),s=s.concat(e.slice(1));
}else{
s=s.concat(e[0]);const n=t.length;for(let r=0;r<n;++r){
s=s.concat([e[r+1]/t[r],t[r]]);
}s=s.concat(e.slice(n+1));
}return s;
}function Vl(e,t,n=!0){
const r=[];if(n){
r.push(t);for(let n=t+1;n<e;++n){
n<=2*t?(r.push(n),r.push(n-(t+1))):r.push(n);
}
}else{
const n=[],s=[];for(let r=1;r<e;++r){
r>=2*t+1||r%2==1?s.push(r):n.push(r);
}r.push(...n),r.push(0),r.push(...s);
}return r;
}function Gl(e,t,n,r=!0){
const s=[];r?s.push(e[0]/n):s.push(e[0]*n);for(let n=1;n<e.length;++n){
n<=t.length?r?s.push(t[n-1]*e[n]):s.push(e[n]/t[n-1]):s.push(e[n]);
}return s;
}function jl(e,t){
const n=[0];for(let r=0;r<t;++r){
n.push(e[r][0]);
}return n;
}function Hl(e,t,n){
const r=e.slice(0,1);for(let s=0;s<n;++s){
r.push(e[s+1]-t[s][0]-t[s][1]);
}return r;
}function ql(e,t){
const n=e.shape.length,r=t.shape.length;if(n<1){
throw new Error(`tf.gatherND() expects the input to be rank 1 or higher, but the rank was ${n}.`);
}if(r<1){
throw new Error(`tf.gatherND() expects the indices to be rank 1 or higher, but the rank was ${r}.`);
}if("int32"!==t.dtype){
throw new Error(`tf.gatherND() expects the indices to be int32 type, but the dtype was ${t.dtype}.`);
}if(t.shape[r-1]>n){
throw new Error(`index innermost dimension length must be <= tensor rank; saw: ${t.shape[r-1]} vs. ${n}`);
}if(0===m(e.shape)){
throw new Error(`Requested more than 0 entries, but input is empty. Input shape: ${e.shape}.`);
}const s=t.shape,i=s[s.length-1];let a=1;for(let e=0;e<s.length-1;++e){
a*=s[e];
}const o=e.shape,u=s.slice();u.pop();let l=1;for(let e=i;e<n;++e){
l*=o[e],u.push(o[e]);
}const c=[..._(e.shape).map((e=>e/l)),1].slice(0,i);return[u,a,l,c];
}function Kl(e,t,n){
const r=t.rank>1?t.shape[t.rank-1]:1,s=t.rank>1?t.rank-1:1,i=`Must have updates.shape = indices.shape[:batchDim] + shape[sliceDim:], got updates.shape: ${n.shape}, indices.shape: ${t.shape}, shape: ${e}, sliceDim: ${r}, and batchDim: ${s}.`;if(n.rank<s){
throw new Error(i+` update.rank < ${s}. `);
}if(e.length<r+(n.rank-s)){
throw new Error(i+` Output shape length < ${r+(n.rank-s)}`);
}if(n.rank!==s+e.length-r){
throw new Error(i+" update.rank != "+(s+e.length-r));
}for(let e=0;e<s;++e){
if(n.shape[e]!==t.shape[e]){
throw new Error(i+` updates.shape[${e}] (${n.shape[e]}) != indices.shape[${e}] (${t.shape[e]}).`);
}
}for(let t=0;t<n.rank-s;++t){
if(n.shape[t+s]!==e[t+r]){
throw new Error(i+` updates.shape[${t+s}] (${n.shape[t+s]}) != shape[${t+s}] (${e[t+s]})`);
}
}
}function Xl(e,t,n){
if(t.rank<1){
throw new Error(`tf.scatterND() expects the indices to be rank 1 or higher, but the rank was ${t.rank}.`);
}if(e.rank<1){
throw new Error(`tf.scatterND() expects the updates to be rank 1 or higher, but the rank was ${e.rank}.`);
}if("int32"!==t.dtype){
throw new Error(`The dtype of 'indices' should be int32, but got dtype: ${t.dtype}`);
}if(n.length<1){
throw new Error(`Output rank must be greater or equal to 1, but got shape: ${n}`);
}if(0===n.length){
if(0===t.size){
throw new Error(`Indices specified for empty output. indices shape: ${t.shape}`);
}if(0===e.size){
throw new Error(`Updates specified for empty output. updates shape: ${e.shape}`);
}
}Kl(n,t,e);
}function Yl(e,t,n){
const r=t.shape.length,s=r>1?t.shape[r-1]:1,i=n.length;let a=1;for(let e=s;e<i;++e){
a*=n[e];
}const o=s<1?1:s;return{sliceRank:s,numUpdates:m(t.shape)/o,sliceSize:a,strides:[..._(n.slice(0,s)),1],outputSize:m(n)};
}const Zl=1.7580993408473768,Jl=1.0507009873554805,Ql=.3275911,ec=.254829592,tc=-.284496736,nc=1.421413741,rc=-1.453152027,sc=1.061405429;function ic(e,t){
if(e.length!==t.length){
throw new Error(`Cannot merge real and imag arrays of different lengths. real:${e.length}, imag: ${t.length}.`);
}const n=new Float32Array(2*e.length);for(let r=0;r<n.length;r+=2){
n[r]=e[r/2],n[r+1]=t[r/2];
}return n;
}function ac(e){
const t=new Float32Array(e.length/2),n=new Float32Array(e.length/2);for(let r=0;r<e.length;r+=2){
t[r/2]=e[r],n[r/2]=e[r+1];
}return{real:t,imag:n};
}function oc(e){
const t=Math.ceil(e.length/4),n=new Float32Array(t),r=new Float32Array(t);for(let t=0;t<e.length;t+=4){
n[Math.floor(t/4)]=e[t],r[Math.floor(t/4)]=e[t+1];
}return{real:n,imag:r};
}function uc(e){
const t=Math.floor(e.length/4),n=new Float32Array(t),r=new Float32Array(t);for(let t=2;t<e.length;t+=4){
n[Math.floor(t/4)]=e[t],r[Math.floor(t/4)]=e[t+1];
}return{real:n,imag:r};
}function lc(e,t){
return{real:e[2*t],imag:e[2*t+1]};
}function cc(e,t,n,r){
e[2*r]=t,e[2*r+1]=n;
}function hc(e,t){
const n=new Float32Array(e/2),r=new Float32Array(e/2);for(let s=0;s<Math.ceil(e/2);s++){
const i=(t?2:-2)*Math.PI*(s/e);n[s]=Math.cos(i),r[s]=Math.sin(i);
}return{real:n,imag:r};
}function dc(e,t,n){
const r=(n?2:-2)*Math.PI*(e/t);return{real:Math.cos(r),imag:Math.sin(r)};
}const pc="->",fc=/->/g,mc=",",gc="...";function bc(e,t){
const n=((e=e.replace(/\s/g,"")).length-e.replace(fc,"").length)/pc.length;if(n<1){
throw new Error("Equations without an arrow are not supported.");
}if(n>1){
throw new Error(`Equation must contain exactly one arrow ("${pc}").`);
}const[r,s]=e.split(pc);d(-1===r.indexOf(gc),(()=>`The ellipsis notation ("${gc}") is not supported yet.`));const i=r.split(mc),a=i.length;if(t!==a){
throw new Error(`Expected ${a} input tensors, received ${t}`);
}if(a>2){
throw new Error("Support for more than 2 input tensors is not implemented yet.");
}const o=[];for(let e=0;e<s.length;++e){
const t=s[e];if(!i.some((e=>-1!==e.indexOf(t)))){
throw new Error(`Output subscripts contain the label ${t} not present in the input subscripts.`);
}-1===o.indexOf(t)&&o.push(t);
}for(let e=0;e<r.length;++e){
const t=r[e];-1===o.indexOf(t)&&t!==mc&&o.push(t);
}const u=new Array(i.length);for(let e=0;e<a;++e){
if(new Set(i[e].split("")).size!==i[e].length){
throw new Error(`Found duplicate axes in input component ${i[e]}. Support for duplicate axes in input is not implemented yet.`);
}u[e]=[];for(let t=0;t<i[e].length;++t){
u[e].push(o.indexOf(i[e][t]));
}
}const l=o.length,c=[];for(let e=s.length;e<l;++e){
c.push(e);
}return{allDims:o,summedDims:c,idDims:u};
}function xc(e,t){
let n=new Array(e);n.fill(-1);for(let e=0;e<t.length;++e){
n[t[e]]=e;
}const r=[];for(let t=0;t<e;++t){
-1===n[t]&&r.push(t);
}return n=n.filter((e=>-1!==e)),{permutationIndices:n,expandDims:r};
}function yc(e,t,n){
const r=new Array(e);for(let e=0;e<n.length;++e){
const s=n[e].shape;for(let n=0;n<t[e].length;++n){
void 0===r[t[e][n]]?r[t[e][n]]=s[n]:d(r[t[e][n]]===s[n],(()=>`Expected dimension ${r[t[e][n]]} at axis ${n} of input shaped ${JSON.stringify(s)}, but got dimension ${s[n]}`));
}
}
}function wc(e,t){
const n=e,r=[];let s=0;0===e.length&&n.push(-1),s=e.length+1;for(let e=0;e<s;++e){
r.push([]);
}const i=[];for(let e=0;e<n.length;++e){
const s=kc(t,n[e]);for(const t of s){
-1===i.indexOf(t)&&(r[e].push(t),i.push(t));
}
}return{path:n,steps:r};
}function vc(e){
return e.every(((e,t)=>e===t));
}function kc(e,t){
const n=[];for(let r=0;r<e.length;++r){
0!==e[r].length&&-1===e[r].indexOf(t)&&-1!==t||n.push(r);
}return n;
}function Ic(e,t,n=0){
let r=[];if("number"==typeof t){
d(e.shape[n]%t==0,(()=>"Number of splits must evenly divide the axis.")),r=new Array(t).fill(e.shape[n]/t);
}else{
const s=t.reduce(((e,t)=>(-1===t&&(e+=1),e)),0);d(s<=1,(()=>"There should be only one negative value in split array."));const i=t.indexOf(-1);if(-1!==i){
const r=t.reduce(((e,t)=>t>0?e+t:e));t[i]=e.shape[n]-r;
}d(e.shape[n]===t.reduce(((e,t)=>e+t)),(()=>"The sum of sizes must match the size of the axis dimension.")),r=t;
}return r;
}function Sc(e){
return`Received SparseTensor with denseShape[0] = 0 but\n  indices.shape[0] = ${e}`;
}function Cc(e,t){
return`indices(${e}, 0) is invalid: ${t} < 0`;
}function Nc(e,t,n){
return`indices(${e}, 0) is invalid: ${t} >= ${n}`;
}function $c(e,t){
return`only one output dimension may be -1, not both ${e} and ${t}`;
}function Tc(e,t){
return`size ${e} must be non-negative, not ${t}`;
}function Ec(){
return"reshape cannot infer the missing input size for an empty tensor unless all specified input sizes are non-zero";
}function Rc(e,t){
return`Input to reshape is a SparseTensor with ${m(e)}\n  dense values, but the requested shape requires a multiple of ${m(t)}. inputShape=${e} outputShape= ${t}`;
}function Ac(e,t){
return`Input to reshape is a tensor with ${m(e)} dense values, but the requested shape has ${m(t)}. inputShape=${e} outputShape=${t}`;
}function Fc(){
return"segment ids must be >= 0";
}function _c(){
return"segment ids are not increasing";
}function Dc(e,t){
return`Segment id ${e} out of range [0, ${t}), possibly because segmentIds input is not sorted.`;
}function Oc(e,t,n){
return`Bad: indices[${e}] == ${t} out of range [0, ${n})`;
}function Mc(e,t){
let n,r=!1;for(e<=Pl?(n=e,r=!0):n=F(e,Math.floor(Math.sqrt(e)));!r;){
n>t||n===e?r=!0:n=F(e,n+1);
}return n;
}function Lc(e,t,n){
const r=[],s=e.length;for(let i=0;i<s;i++){
i!==t?r.push(e[i]):r.push(n);
}return r;
}function zc(e,t,n,r){
const s=t.shape.length,i=e.shape.length;if(0!==r&&(r<-s||r>s)){
throw new Error(`Expect batchDims in the range of [-${s}, ${s}], but got ${r}`);
}if(r<0&&(r+=s),r>i){
throw new Error(`batchDims (${r}) must be less than rank(x) (\n    ${i}).`);
}if(n<r){
throw new Error(`batchDims (${r}) must be less than or equal to axis (${n}).`);
}for(let n=0;n<r;++n){
if(e.shape[n]!==t.shape[n]){
throw new Error(`x.shape[${n}]: ${e.shape[n]} should be equal to indices.shape[${n}]: ${t.shape[n]}.`);
}
}const a=e.shape[n],o=[];let u=1,l=1,c=1;for(let t=0;t<r;++t){
o.push(e.shape[t]),u*=e.shape[t];
}for(let t=r;t<n;t++){
o.push(e.shape[t]),l*=e.shape[t];
}for(let e=r;e<s;e++){
o.push(t.shape[e]);
}for(let t=n+1;t<i;t++){
o.push(e.shape[t]),c*=e.shape[t];
}return{batchSize:u,sliceSize:c,outerSize:l,dimSize:a,outputShape:o};
}function Pc(e){
try{
return e.map((e=>Mr(e)));
}catch(e){
throw new Error(`Failed to decode encoded string bytes into utf-8, error: ${e}`);
}
}function Bc(e){
return e.map((e=>Or(e)));
}function Uc(e,t){
const n=[];for(let e=0;e<t.length;e++){
t[e]&&n.push(e);
}const r=pi(e,"int32"),s=pi([n.length,e.length],"int32");for(let t=0;t<n.length;t++){
const i=r.indexToLoc(n[t]),a=t*e.length;s.values.set(i,a);
}return s.toTensor();
}!function(){
for(const e of Ji){
Oi(e);
}
}();const Wc={kernelName:Z,inputsToSave:["x"],gradFunc:(e,t)=>{
const[n]=t;return{x:()=>Ci(e,Ou(fi(n,"float32"),-1))};
}},Vc={kernelName:J,inputsToSave:["x"],gradFunc:(e,t)=>{
const[n]=t;return{x:()=>{
const t=$i(fi(n,"float32")),r=Ni(Ui(Ri(1),t));return jo(Si(e,r));
}};
}},Gc={kernelName:Q,inputsToSave:["x"],gradFunc:(e,t)=>{
const[n]=t;return{x:()=>{
const t=Ni(Ui($i(fi(n,"float32")),1));return Si(e,t);
}};
}},jc={kernelName:ee,inputsToSave:["a","b"],gradFunc:(e,t)=>{
const[n,r]=t,s=Hi(n.shape,r.shape);return{a:()=>{
let t=e;const r=ji(n.shape,s);return r.length>0&&(t=$o(t,r)),Va(t,n.shape);
},b:()=>{
let t=e;const n=ji(r.shape,s);return n.length>0&&(t=$o(t,n)),Va(t,r.shape);
}};
}},Hc={kernelName:te,saveAllInputs:!0,gradFunc:(e,t)=>{
const n={};return t.forEach(((t,r)=>{
n[r]=()=>e.clone();
})),n;
}},qc={kernelName:se,inputsToSave:["x"],gradFunc:(e,t)=>{
const[n]=t;return{x:()=>Ti(n)};
}},Kc={kernelName:ie,inputsToSave:["x"],gradFunc:(e,t)=>{
const[n]=t;return{x:()=>Ti(n)};
}},Xc={kernelName:ae,inputsToSave:["x"],gradFunc:(e,t)=>{
const[n]=t;return{x:()=>Si(e,Ni(Ui(Ri(1),$i(fi(n,"float32")))))};
}},Yc={kernelName:oe,inputsToSave:["x"],gradFunc:(e,t)=>{
const[n]=t;return{x:()=>{
const t=Ni(ki(Ri(1),$i(fi(n,"float32"))));return Si(e,t);
}};
}},Zc={kernelName:ce,inputsToSave:["a","b"],gradFunc:(e,t)=>{
const[n,r]=t,s=Hi(n.shape,r.shape);return{a:()=>{
const t=ki($i(n),$i(r));let i=Ci(e,Si(r,t));const a=ji(n.shape,s);return a.length>0&&(i=$o(i,a)),Va(i,n.shape);
},b:()=>{
const t=ki($i(n),$i(r));let i=jo(Ci(e,Si(n,t)));const a=ji(r.shape,s);return a.length>0&&(i=$o(i,a)),Va(i,r.shape);
}};
}},Jc={kernelName:ue,inputsToSave:["x"],gradFunc:(e,t)=>{
const[n]=t;return{x:()=>Si(e,ki($i(fi(n,"float32")),1))};
}},Qc={kernelName:le,inputsToSave:["x"],gradFunc:(e,t)=>{
const[n]=t;return{x:()=>Si(e,Ui(Ri(1),$i(fi(n,"float32"))))};
}},eh=As({avgPool3dGrad_:function(e,t,n,r,s,i){
const a=Es(e,"dy","avgPool3dGrad"),o=Es(t,"input","avgPool3dGrad");let u=a,l=o,c=!1;4===o.rank&&(c=!0,u=Va(a,[1,a.shape[0],a.shape[1],a.shape[2],a.shape[3]]),l=Va(o,[1,o.shape[0],o.shape[1],o.shape[2],o.shape[3]])),d(5===u.rank,(()=>`Error in avgPool3dGrad: dy must be rank 5 but got rank ${u.rank}.`)),d(5===l.rank,(()=>`Error in avgPool3dGrad: input must be rank 5 but got rank ${l.rank}.`)),Wa("avgPool3dGrad",s,i);const h={dy:u,input:l},p={filterSize:n,strides:r,pad:s,dimRoundingMode:i},f=vs.runKernel(fe,h,p);return c?Va(f,[f.shape[1],f.shape[2],f.shape[3],f.shape[4]]):f;
}}),th={kernelName:pe,inputsToSave:["x"],gradFunc:(e,t,n)=>{
const[r]=t,{filterSize:s,strides:i,pad:a,dimRoundingMode:o}=n;return{x:()=>eh(e,r,s,i,a,o)};
}},nh=As({avgPoolGrad_:function(e,t,n,r,s){
const i=Es(e,"dy","avgPoolGrad"),a=Es(t,"input","avgPoolGrad");d(a.rank===i.rank,(()=>`Rank of input (${a.rank}) does not match rank of dy (${i.rank})`));let o=a,u=i,l=!1;3===a.rank&&(l=!0,o=Va(a,[1,a.shape[0],a.shape[1],a.shape[2]]),u=Va(i,[1,i.shape[0],i.shape[1],i.shape[2]])),d(4===u.rank,(()=>`Error in avgPoolGrad: dy must be rank 4 but got rank ${u.rank}.`)),d(4===o.rank,(()=>`Error in avgPoolGrad: input must be rank 4 but got rank ${o.rank}.`));const c={dy:u,input:o},h={filterSize:n,strides:r,pad:s},p=vs.runKernel(de,c,h);return l?Va(p,[p.shape[1],p.shape[2],p.shape[3]]):p;
}}),rh={kernelName:he,inputsToSave:["x"],gradFunc:(e,t,n)=>{
const[r]=t,{filterSize:s,strides:i,pad:a}=n;return{x:()=>nh(e,r,s,i,a)};
}},sh={kernelName:me,inputsToSave:["a","b"],gradFunc:(e,t,n)=>{
const[r,s]=t,{transposeA:i,transposeB:a}=n;return i||a?!i&&a?{a:()=>Ro(e,s,!1,!1),b:()=>Ro(e,r,!0,!1)}:i&&!a?{a:()=>Ro(s,e,!1,!0),b:()=>Ro(r,e,!1,!1)}:{a:()=>Ro(s,e,!0,!0),b:()=>Ro(e,r,!0,!0)}:{a:()=>Ro(e,s,!1,!0),b:()=>Ro(r,e,!0,!1)};
}},ih=As({spaceToBatchND_:function(e,t,n){
const r=Es(e,"x","spaceToBatchND");d(r.rank>=1+t.length,(()=>`input rank ${r.rank} should be > than [blockShape] ${t.length}`)),d(n.length===t.length,(()=>`paddings.shape[0] ${n.length} must be equal to [blockShape] ${t.length}`)),d(r.shape.reduce(((e,r,s)=>s>0&&s<=t.length?e&&(r+n[s-1][0]+n[s-1][1])%t[s-1]==0:e),!0),(()=>`input spatial dimensions ${r.shape.slice(1)} with paddings ${n.toString()} must be divisible by blockShapes ${t.toString()}`));const s={x:r},i={blockShape:t,paddings:n};return vs.runKernel(Rn,s,i);
}}),ah={kernelName:ge,gradFunc:(e,t,n)=>{
const{blockShape:r,crops:s}=n;return{x:()=>ih(e,r,s)};
}},oh={kernelName:"BroadcastTo",gradFunc:(e,t,n)=>{
const r=n,s=r.inputShape,i=r.shape,a=Array.from(i);for(let e=s.length-1;e>=0;e--){
if(s[e]===i[e]){
a[e]=1;
}else if(1!==s[e]){
throw new Error(`broadcastTo(): [${s}] cannot be broadcast to [${i}].`);
}
}const o=[];for(let e=0;e<a.length;e++){
a[e]>1&&o.push(e);
}return{x:()=>$o(e,o,!0)};
}},uh={kernelName:we,gradFunc:e=>({x:()=>e.clone()})},lh={kernelName:ve,gradFunc:e=>({x:()=>Ti(e)})},ch={kernelName:ke,inputsToSave:["x"],gradFunc:(e,t,n)=>{
const[r]=t,{clipValueMin:s,clipValueMax:i}=n;return{x:()=>Su(Eo(ko(r,s),pl(r,i)),e,Ti(e))};
}},hh={kernelName:Se,inputsToSave:["x"],gradFunc:Wc.gradFunc},dh={kernelName:Ce,saveAllInputs:!0,gradFunc:(e,t,n)=>{
const r=t.map((e=>e.shape)),{axis:s}=n,i=k(s,t[0].shape)[0],a=r.map((e=>e[i]));return bu(e,a,i).map((e=>()=>e));
}},ph={kernelName:Ne,inputsToSave:["x","filter"],gradFunc:(e,t,n)=>{
const[r,s]=t,{dilations:i,strides:a,pad:o,dataFormat:u}=n;return d(za(i),(()=>`Error in gradient of conv2D: dilation rates greater than 1 are not yet supported in gradients. Got dilations '${i}'`)),{x:()=>io(r.shape,e,s,a,o,u),filter:()=>_u(r,e,s.shape,a,o,u)};
}},fh={kernelName:Te,inputsToSave:["dy","filter"],gradFunc:(e,t,n)=>{
const[r,s]=t,{strides:i,pad:a,dataFormat:o,dimRoundingMode:u}=n;return{dy:()=>ro(e,s,i,a,o,1,u),filter:()=>_u(e,r,s.shape,i,a,o,u)};
}},mh=As({conv3DBackpropFilter_:function(e,t,n,r,s){
let i=e;4===e.rank&&(i=Va(e,[1,e.shape[0],e.shape[1],e.shape[2],e.shape[3]]));let a=t;4===a.rank&&(a=Va(t,[1,t.shape[0],t.shape[1],t.shape[2],t.shape[3]])),d(5===i.rank,(()=>`Error in conv3dDerFilter: input must be rank 5, but got shape ${i.shape}.`)),d(5===a.rank,(()=>`Error in conv3dDerFilter: dy must be rank 5, but got shape ${a.shape}.`)),d(5===n.length,(()=>`Error in conv3dDerFilter: filterShape must be length 5, but got ${n}.`)),d(i.shape[4]===n[3],(()=>`Error in conv3dDerFilter: depth of input ${i.shape[4]}) must match input depth in filter (${n[3]}.`)),d(a.shape[4]===n[4],(()=>`Error in conv3dDerFilter: depth of dy (${a.shape[4]}) must match output depth for filter (${n[4]}).`));const o={x:i,dy:a},u={strides:r,pad:s,filterShape:n};return vs.runKernel(Re,o,u);
}}),gh={kernelName:Ee,inputsToSave:["x","filter"],gradFunc:(e,t,n)=>{
const{dilations:r,strides:s,pad:i}=n;d(za(r),(()=>`Error in gradient of conv3D: dilation rates greater than 1 are not yet supported in gradients. Got dilations '${r}'`));const[a,o]=t;return{x:()=>uo(a.shape,e,o,s,i),filter:()=>mh(a,e,o.shape,s,i)};
}},bh=As({sin_:function(e){
const t={x:Es(e,"x","sin","float32")};return vs.runKernel(In,t);
}}),xh={kernelName:Fe,inputsToSave:["x"],gradFunc:(e,t)=>{
const[n]=t;return{x:()=>Ci(jo(bh(fi(n,"float32"))),e)};
}},yh=As({sinh_:function(e){
const t={x:Es(e,"x","sinh")};return vs.runKernel(Sn,t);
}}),wh={kernelName:_e,inputsToSave:["x"],gradFunc:(e,t)=>{
const[n]=t;return{x:()=>Ci(yh(fi(n,"float32")),e)};
}},vh=As({cumsum_:function(e,t=0,n=!1,r=!1){
const s={x:Es(e,"x","cumsum")},i={axis:t,exclusive:n,reverse:r};return vs.runKernel(Oe,s,i);
}}),kh={kernelName:Oe,inputsToSave:["x"],gradFunc:(e,t,n)=>{
const[r]=t,{axis:s,exclusive:i,reverse:a}=n;return{x:()=>{
const t=Uo([s],r.rank);let n=vh(e,s,i,!a);return null!=t&&(n=$u(n,t)),n;
}};
}},Ih={kernelName:Pe,inputsToSave:["x","filter"],gradFunc:(e,t,n)=>{
const{dilations:r,strides:s,pad:i,dimRoundingMode:a}=n,o=null==r?[1,1]:r;d(za(o),(()=>`Error in gradient of depthwiseConv2dNative: dilation rates greater than 1 are not yet supported. Got dilations '${o}'`));const[u,l]=t;return d(4===u.rank,(()=>`Error in gradient of depthwiseConv2dNative: input must be rank 4, but got rank ${u.rank}.`)),d(4===l.rank,(()=>`Error in gradient of depthwiseConv2dNative: filter must be rank 4, but got rank ${l.rank}.`)),d(u.shape[3]===l.shape[2],(()=>`Error in gradient of depthwiseConv2d: number of input channels (${u.shape[3]}) must match the inChannels dimension in filter ${l.shape[2]}.`)),d(Pa(s,o),(()=>`Error in gradient of depthwiseConv2d: Either strides or dilations must be  1. Got strides ${s} and dilations '${o}'.`)),Wa("depthwiseConv2d",i,a),{x:()=>Wu(u.shape,e,l,s,i,o,a),filter:()=>Uu(u,e,l.shape,s,i,o,a)};
}},Sh={kernelName:Ve,inputsToSave:["x","filter"],gradFunc:(e,t,n)=>{
const[r,s]=t,i={x:r,filter:s,dy:e},a={x:r,filter:s,dy:e};return{x:()=>vs.runKernel(Ge,i,n),filter:()=>vs.runKernel(je,a,n)};
}},Ch={kernelName:Ke,outputsToSave:[!0],gradFunc:(e,t)=>{
const[n]=t,r={dy:e,y:n};return{x:()=>vs.runKernel(Xe,r)};
}},Nh={kernelName:Ye,inputsToSave:["x"],gradFunc:(e,t)=>{
const[n]=t,r=Ci(mo(jo($i(n))),2/Math.sqrt(Math.PI));return{x:()=>Ci(e,r)};
}},$h={kernelName:Je,outputsToSave:[!0],gradFunc:(e,t)=>{
const[n]=t;return{x:()=>Ci(e,n)};
}},Th={kernelName:Qe,inputsToSave:["input"],gradFunc:(e,t)=>{
const[n]=t;return{input:()=>Va(e,n.shape)};
}},Eh={kernelName:et,inputsToSave:["x"],gradFunc:(e,t)=>{
const[n]=t;return{x:()=>Ci(e,mo(n))};
}},Rh={kernelName:st,gradFunc:e=>({x:()=>Ti(e)})},Ah={kernelName:it,inputsToSave:["a","b"],gradFunc:(e,t)=>{
const[n,r]=t,s=Hi(n.shape,r.shape);return{a:()=>{
const t=Si(e,fi(r,"float32")),i=ji(n.shape,s);return i.length>0?Va($o(t,i),n.shape):t;
},b:()=>{
let t=Ci(e,fi(n,"float32"));const i=ji(r.shape,s);i.length>0&&(t=Va($o(t,i),r.shape));const a=$i(r);return jo(Si(t,fi(a,"float32")));
}};
}},Fh=As({rsqrt_:function(e){
const t={x:Es(e,"x","rsqrt","float32")};return vs.runKernel(gn,t);
}}),_h={kernelName:at,inputsToSave:["x","mean","variance","scale"],gradFunc:(e,t,n)=>{
const{varianceEpsilon:r}=n,[s,i,a,o]=t,u=null==o?Ri(1):o,l=ji(i.shape,s.shape),c=[];if(1===i.rank){
for(let e=0;e<s.shape.length-1;++e){
c.push(s.shape[e]);
}c.push(1);
}const h=Ui(s,i),d=Ci(e,u),p=Fh(ki(a,Ri(r))),f=Ci(Ci(Ci(p,p),p),Ri(-.5));return{x:()=>1===i.rank?Va(Ci(Ci(e,bo(Va(p,[1,1,1,i.shape[0]]),c)),u),s.shape):Va(Ci(Ci(e,p),u),s.shape),mean:()=>{
let e=Ci(Ci(p,Ri(-1)),d);return 1===i.rank&&(e=$o(e,l)),Va(e,i.shape);
},variance:()=>{
let e=Ci(Ci(f,h),d);return 1===i.rank&&(e=$o(e,l)),Va(e,i.shape);
},scale:()=>{
const t=Ci(h,p);let n=Ci(e,t);return 1===i.rank&&(n=$o(n,l)),Va(n,i.shape);
},offset:()=>{
let t=e;return 1===i.rank&&(t=$o(t,l)),Va(t,i.shape);
}};
}},Dh=As({unsortedSegmentSum_:function(e,t,n){
const r=Es(e,"x","unsortedSegmentSum"),s=Es(t,"segmentIds","unsortedSegmentSum","int32");d(b(n),(()=>"numSegments must be of dtype int"));const i={x:r,segmentIds:s},a={numSegments:n};return vs.runKernel(er,i,a);
}}),Oh={kernelName:ot,inputsToSave:["x","indices"],gradFunc:(e,t,n)=>{
const[r,s]=t,{axis:i}=n,a=k(i,r.shape)[0];return{x:()=>{
const t=r.shape,n=s.size,o=t.slice(0,a),u=o.length,l=t.slice(i,t.length).slice(1),c=l.length,h=Mh(0,u),d=Mh(u+1,u+1+c),p=Lh([o,[n],l]),f=Va(e,p),m=Va(s,[n]),g=Lh([[u],h,d]),b=$u(f,g);let x=Dh(b,m,r.shape[a]);const y=Wo(g);return x=$u(x,y),x;
},indices:()=>s};
}};function Mh(e,t){
const n=[];for(let r=e;r<t;++r){
n.push(r);
}return n;
}function Lh(e){
const t=[];for(let n=0;n<e.length;++n){
for(let r=0;r<e[n].length;++r){
t.push(e[n][r]);
}
}return t;
}const zh={kernelName:ct,inputsToSave:["a","b"],gradFunc:(e,t)=>{
const[n,r]=t;return{a:()=>Ti(n),b:()=>Ti(r)};
}},Ph={kernelName:ht,gradFunc:e=>({x:()=>fi(e,"float32")})},Bh={kernelName:ft,gradFunc:e=>({x:()=>Ti(e)})},Uh={kernelName:mt,gradFunc:e=>({x:()=>Ti(e)})},Wh={kernelName:gt,gradFunc:e=>({x:()=>Ti(e)})},Vh={kernelName:bt,inputsToSave:["x"],gradFunc:(e,t,n)=>{
const[r]=t,{alpha:s}=n,i=vo(r,0);return{x:()=>Su(i,e,Ci(e,s))};
}},Gh={kernelName:kt,inputsToSave:["x"],gradFunc:(e,t)=>{
const[n]=t;return{x:()=>Si(e,ki(n,1))};
}},jh={kernelName:vt,inputsToSave:["x"],gradFunc:(e,t)=>{
const[n]=t;return{x:()=>Si(e,fi(n,"float32"))};
}},Hh={kernelName:"LogSoftmax",inputsToSave:[],outputsToSave:[!0],gradFunc:(e,t,n)=>{
const[r]=t,{axis:s}=n;return{logits:()=>{
const t=mo(r);return Ui(e,Ci($o(e,s,!0),t));
}};
}},qh=As({localResponseNormalizationBackprop_:function(e,t,n,r=5,s=1,i=1,a=.5){
const o={x:e,y:t,dy:n},u={depthRadius:r,bias:s,alpha:i,beta:a};return vs.runKernel($t,o,u);
}}),Kh={kernelName:Nt,inputsToSave:["x"],outputsToSave:[!0],gradFunc:(e,t,n)=>{
const[r,s]=t,{depthRadius:i,bias:a,alpha:o,beta:u}=n;return{x:()=>qh(r,s,e,i,a,o,u)};
}};function Xh(e,t,n,r){
return t.rank<n.rank&&(t=Va(t,Po(t.shape,r))),e.rank<n.rank&&(e=Va(e,Po(e.shape,r))),{x:()=>Ci(e,fi(fo(n,t),e.dtype))};
}const Yh={kernelName:Tt,inputsToSave:["x"],outputsToSave:[!0],gradFunc:(e,t,n)=>{
const r=n,{reductionIndices:s}=r,i=t[0],a=Xh(e,t[1],i,k(s,i.shape));return{x:()=>a.x()};
}},Zh={kernelName:Et,inputsToSave:["a","b"],gradFunc:(e,t)=>{
const[n,r]=t;return{a:()=>Ci(e,fi(ko(n,r),"float32")),b:()=>Ci(e,fi(bl(n,r),"float32"))};
}},Jh=As({maxPool3dGrad_:function(e,t,n,r,s,i,a){
const o=Es(e,"dy","maxPool3dGrad"),u=Es(t,"input","maxPool3dGrad"),l=Es(n,"output","maxPool3dGrad");let c=o,h=u,p=l,f=!1;4===u.rank&&(f=!0,c=Va(o,[1,o.shape[0],o.shape[1],o.shape[2],o.shape[3]]),h=Va(u,[1,u.shape[0],u.shape[1],u.shape[2],u.shape[3]]),p=Va(l,[1,l.shape[0],l.shape[1],l.shape[2],l.shape[3]])),d(5===c.rank,(()=>`Error in maxPool3dGrad: dy must be rank 5 but got rank ${c.rank}.`)),d(5===h.rank,(()=>`Error in maxPool3dGrad: input must be rank 5 but got rank ${h.rank}.`)),d(5===p.rank,(()=>`Error in maxPool3dGrad: output must be rank 5 but got rank ${p.rank}.`)),Wa("maxPool3dGrad",i,a);const m={dy:c,input:h,output:p},g={filterSize:r,strides:s,pad:i,dimRoundingMode:a},b=vs.runKernel(_t,m,g);return f?Va(b,[b.shape[1],b.shape[2],b.shape[3],b.shape[4]]):b;
}}),Qh={kernelName:Ft,inputsToSave:["x"],outputsToSave:[!0],gradFunc:(e,t,n)=>{
const[r,s]=t,{filterSize:i,strides:a,pad:o,dimRoundingMode:u}=n;return{x:()=>Jh(e,r,s,i,a,o,u)};
}},ed=As({maxPoolGrad_:function(e,t,n,r,s,i,a){
const o=Es(e,"dy","maxPoolGrad"),u=Es(t,"input","maxPoolGrad"),l=Es(n,"output","maxPoolGrad");d(u.rank===o.rank,(()=>`Rank of input (${u.rank}) does not match rank of dy (${o.rank})`)),d(4===o.rank,(()=>`Error in maxPoolGrad: dy must be rank 4 but got rank ${o.rank}.`)),d(4===u.rank,(()=>`Error in maxPoolGrad: input must be rank 4 but got rank ${u.rank}.`)),Wa("maxPoolGrad",i,a);const c={dy:o,input:u,output:l},h={filterSize:r,strides:s,pad:i,dimRoundingMode:a};return vs.runKernel(At,c,h);
}}),td={kernelName:Rt,inputsToSave:["x"],outputsToSave:[!0],gradFunc:(e,t,n)=>{
const[r,s]=t,{filterSize:i,strides:a,pad:o}=n;return{x:()=>ed(e,r,s,i,a,o)};
}},nd={kernelName:Ot,inputsToSave:["x"],gradFunc:(e,t,n)=>{
const[r]=t,{axis:s}=n,i=k(s,r.shape),a=m(zo(r.shape,i)[1]);return{x:()=>{
const t=r.shape.slice();i.forEach((e=>{
t[e]=1;
}));const n=Va(e,t);return Si(Ci(n,Xo(r.shape,"float32")),a);
}};
}},rd={kernelName:Mt,inputsToSave:["x"],outputsToSave:[!0],gradFunc:(e,t,n)=>{
const r=n,{axis:s}=r,[i,a]=t,o=Xh(e,a,i,k(s,i.shape));return{x:()=>o.x()};
}},sd={kernelName:Lt,inputsToSave:["a","b"],gradFunc:(e,t)=>{
const[n,r]=t;return{a:()=>Ci(e,fi(pl(n,r),"float32")),b:()=>Ci(e,fi(vo(n,r),"float32"))};
}},id={kernelName:zt,inputsToSave:["x"],gradFunc:(e,t,n)=>{
const r=t[0],{paddings:s}=n,i=s.map((e=>e[0]));return{x:()=>cu(e,i,r.shape)};
}},ad={kernelName:Pt,inputsToSave:["a","b"],gradFunc:(e,t)=>{
const[n,r]=t,s=Hi(n.shape,r.shape);return{a:()=>{
const t=ji(n.shape,s);return t.length>0?Va($o(e,t),n.shape):e;
},b:()=>{
const t=Ci(e,jo(yo(Si(n,r)))),i=ji(r.shape,s);return i.length>0?Va($o(t,i),r.shape):t;
}};
}},od={kernelName:Ut,inputsToSave:["a","b"],gradFunc:(e,t)=>{
const[n,r]=t,s=Hi(n.shape,r.shape);return{a:()=>{
const t=Ci(e,fi(r,"float32")),i=ji(n.shape,s);return i.length>0?Va($o(t,i),n.shape):t;
},b:()=>{
const t=Ci(e,fi(n,"float32")),i=ji(r.shape,s);return i.length>0?Va($o(t,i),r.shape):t;
}};
}},ud={kernelName:Wt,gradFunc:e=>({x:()=>jo(e)})},ld={kernelName:Kt,inputsToSave:["indices"],gradFunc:(e,t)=>{
const n=t[0];return{indices:()=>Ko(n.shape,"float32")};
}},cd={kernelName:qt,gradFunc:e=>({x:()=>Ti(e)})},hd={kernelName:Xt,saveAllInputs:!0,gradFunc:(e,t,n)=>{
const{axis:r}=n;return Iu(e,r).map((e=>()=>e));
}},dd={kernelName:Yt,inputsToSave:["x"],gradFunc:(e,t,n)=>{
const r=t[0],{paddings:s}=n,i=s.map((e=>e[0]));return{x:()=>cu(e,i,r.shape)};
}},pd={kernelName:Zt,inputsToSave:["a","b"],outputsToSave:[!0],gradFunc:(e,t)=>{
const[n,r,s]=t,i=n,a=r,o=Hi(i.shape,a.shape);return{a:()=>{
const t=fi(a,"float32");let n=Ci(e,Ci(t,Bi(i,Ui(t,Ri(1)))));const r=ji(i.shape,o);return r.length>0&&(n=$o(n,r)),Va(n,i.shape);
},b:()=>{
const t=vo(i,0),n=Su(t,So(i),Ti(i));let r=Ci(e,Ci(s,n));const u=ji(a.shape,o);return u.length>0&&(r=$o(r,u)),Va(r,a.shape);
}};
}},fd={kernelName:Jt,inputsToSave:["x","alpha"],gradFunc:(e,t)=>{
const[n,r]=t,s=vo(n,0);return{x:()=>Su(s,e,Ci(e,r)),alpha:()=>{
let t=Su(s,Ti(e),Ci(e,n));const i=ji(r.shape,e.shape);return i.length>0&&(t=$o(t,i)),Va(t,r.shape);
}};
}},md=As({cumprod_:function(e,t=0,n=!1,r=!1){
const s={x:Es(e,"x","cumprod")},i={axis:t,exclusive:n,reverse:r};return vs.runKernel(De,s,i);
}});const gd={kernelName:Qt,inputsToSave:["x"],gradFunc:(e,t,n)=>{
const[r]=t,{axis:s}=n;let i=[];return i=null==s?r.shape.map(((e,t)=>t)):"number"==typeof s?[s]:s,{x:()=>function(e,t,n){
const r=e.shape.length,s=r-n.length,i=Uo(n,r);let a=e;null!=i&&(a=$u(e,i));const o=a.shape.slice(),u=o.splice(r-n.length,n.length).reduce(((e,t)=>e*t),1);o.push(u);let l=function(e,t,n){
const r=e.shape.slice();r[n]=1;const s=Va(t,r),i=md(e,n,!0,!1),a=md(e,n,!0,!0),o=Ci(i,a);return Ci(s,o);
}(a.reshape(o),t,s);if(l=l.reshape(a.shape),null!=i){
const e=Wo(i);l=$u(l,e);
}return l;
}(r,e,i)};
}},bd={kernelName:He,inputsToSave:["a","b"],gradFunc:(e,t)=>{
const[n,r]=t,s=Hi(n.shape,r.shape);return{a:()=>{
const t=Si(e,fi(r,"float32")),i=ji(n.shape,s);return i.length>0?Va($o(t,i),n.shape):t;
},b:()=>{
let t=Ci(e,fi(n,"float32"));const i=ji(r.shape,s);i.length>0&&(t=Va($o(t,i),r.shape));const a=$i(r);return jo(Si(t,fi(a,"float32")));
}};
}},xd={kernelName:an,inputsToSave:["x"],gradFunc:(e,t)=>{
const[n]=t;return{x:()=>Si(e,jo($i(n)))};
}},yd={kernelName:pn,inputsToSave:["x"],gradFunc:(e,t)=>{
const[n]=t,r=Ci(pl(n,6),Ou(n));return{x:()=>Ci(e,fi(r,"float32"))};
}},wd={kernelName:on,inputsToSave:["x"],gradFunc:(e,t)=>{
const[n]=t;return{x:()=>Ci(e,fi(Ou(n),"float32"))};
}},vd={kernelName:un,inputsToSave:["x"],gradFunc:(e,t)=>{
const[n]=t;return{x:()=>Va(e,n.shape)};
}},kd={kernelName:hn,inputsToSave:["images"],gradFunc:(e,t,n)=>{
const[r]=t,s={dy:e,images:r};return{images:()=>vs.runKernel(dn,s,n)};
}},Id={kernelName:ln,inputsToSave:["images"],gradFunc:(e,t,n)=>{
const[r]=t,s={dy:e,images:r};return{images:()=>vs.runKernel(cn,s,n)};
}},Sd={kernelName:fn,gradFunc:(e,t,n)=>{
const{dims:r}=n,s=k(r,e.shape);return{x:()=>au(e,s)};
}},Cd={kernelName:mn,gradFunc:e=>({x:()=>Ti(e)})},Nd={kernelName:gn,inputsToSave:["x"],gradFunc:(e,t)=>{
const[n]=t;return{x:()=>jo(Si(e,Ci(Bi(n,1.5),2)))};
}},$d=As({logicalNot_:function(e){
const t={x:Es(e,"x","logicalNot","bool")};return vs.runKernel(St,t);
}}),Td={kernelName:wn,inputsToSave:["condition"],gradFunc:(e,t)=>{
const[n]=t;return{condition:()=>fi(Ti(n),"float32"),t:()=>Ci(e,fi(n,e.dtype)),e:()=>Ci(e,fi($d(n),e.dtype))};
}},Ed={kernelName:vn,inputsToSave:["x"],gradFunc:(e,t)=>{
const[n]=t;return{x:()=>{
const t=vo(n,Ri(0)),r=Ri(Zl),s=Ri(Jl),i=Ci(e,s),a=Ci(Ci(e,r),mo(fi(n,"float32")));return Su(t,i,a);
}};
}},Rd={kernelName:Nn,outputsToSave:[!0],gradFunc:(e,t)=>{
const[n]=t;return{x:()=>Ci(e,Ci(n,Ui(Ri(1),n)))};
}},Ad={kernelName:Cn,gradFunc:e=>({x:()=>Ti(e)})},Fd=As({cos_:function(e){
const t={x:Es(e,"x","cos","float32")};return vs.runKernel(Fe,t);
}}),_d={kernelName:In,inputsToSave:["x"],gradFunc:(e,t)=>{
const[n]=t;return{x:()=>Ci(Fd(fi(n,"float32")),e)};
}},Dd=As({cosh_:function(e){
const t={x:Es(e,"x","cosh","float32")};return vs.runKernel(_e,t);
}}),Od={kernelName:Sn,inputsToSave:["x"],gradFunc:(e,t)=>{
const[n]=t;return{x:()=>Ci(Dd(fi(n,"float32")),e)};
}},Md={kernelName:kn,inputsToSave:["x"],gradFunc:(e,t,n)=>{
const[r]=t,{begin:s,size:i}=n,a=r.shape,[o,u]=ka(r,s,i),l=[];for(let t=0;t<e.rank;t++){
l.push([o[t],a[t]-o[t]-u[t]]);
}return{x:()=>Zo(e,l)};
}},Ld={kernelName:Fn,outputsToSave:[!0],gradFunc:(e,t,n)=>{
const[r]=t,{dim:s}=n,i=Ci(e,r);return{logits:()=>Ui(i,Ci($o(i,[s],!0),r))};
}},zd={kernelName:$n,inputsToSave:["x"],gradFunc:(e,t)=>{
const[n]=t;return{x:()=>Ci(e,lu(n))};
}},Pd=As({batchToSpaceND_:function(e,t,n){
const r=Es(e,"x","batchToSpaceND"),s=t.reduce(((e,t)=>e*t));d(r.rank>=1+t.length,(()=>`input rank is ${r.rank} but should be > than blockShape.length ${t.length}`)),d(n.length===t.length,(()=>`crops.length is ${n.length} but should be equal to blockShape.length  ${t.length}`)),d(r.shape[0]%s==0,(()=>`input tensor batch is ${r.shape[0]} but is not divisible by the product of the elements of blockShape ${t.join(" * ")} === ${s}`));const i={x:r},a={blockShape:t,crops:n};return vs.runKernel(ge,i,a);
}}),Bd={kernelName:Rn,gradFunc:(e,t,n)=>{
const{blockShape:r,paddings:s}=n;return{x:()=>Pd(e,r,s)};
}},Ud={kernelName:An,gradFunc:(e,t,n)=>{
const{axis:r}=n;return{x:()=>Ja(e,r)};
}},Wd=[Wc,Vc,Gc,jc,Hc,qc,Kc,Xc,Yc,Zc,Jc,Qc,th,rh,sh,ah,oh,uh,lh,ch,hh,dh,fh,ph,gh,xh,wh,kh,Ih,Sh,bd,Ch,Nh,$h,Th,Eh,Ah,Rh,_h,Oh,zh,Ph,Bh,Uh,Wh,Vh,Gh,jh,Hh,Kh,Yh,Yh,Zh,Qh,td,nd,rd,sd,id,ad,od,ud,ld,cd,hd,dd,dd,pd,fd,gd,xd,yd,wd,vd,kd,Id,Sd,Cd,Nd,Td,Ed,Rd,Ad,_d,Od,Md,Ld,zd,Bd,Bd,Ud,Ud,{kernelName:Tn,inputsToSave:["x"],gradFunc:(e,t)=>{
const[n]=t;return{x:()=>Si(e,Ci(Ni(fi(n,"float32")),2))};
}},{kernelName:zn,inputsToSave:["a","b"],gradFunc:(e,t)=>{
const[n,r]=t,s=Ri(2);return{a:()=>Ci(e,Ci(s,Ui(n,r))),b:()=>Ci(e,Ci(s,Ui(r,n)))};
}},{kernelName:Pn,inputsToSave:["x"],gradFunc:(e,t)=>{
const[n]=t;return{x:()=>Ci(e,Ci(fi(n,"float32"),2))};
}},{kernelName:nr,gradFunc:e=>({x:()=>Ti(e)})},{kernelName:jn,inputsToSave:["a","b"],gradFunc:(e,t)=>{
const[n,r]=t,s=Hi(n.shape,r.shape);return{a:()=>{
let t=e;const r=ji(n.shape,s);return r.length>0&&(t=$o(t,r)),Va(t,n.shape);
},b:()=>{
let t=e;const n=ji(r.shape,s);return n.length>0&&(t=$o(t,n)),Va(jo(t),r.shape);
}};
}},{kernelName:En,inputsToSave:["x"],gradFunc:(e,t,n)=>{
const[r]=t,s=r.shape.slice(),{axis:i}=n;k(i,r.shape).forEach((e=>{
s[e]=1;
}));const a=Va(e,s),o=Ci(a,Xo(r.shape,"float32"));return{x:()=>o};
}},{kernelName:Hn,inputsToSave:["x"],gradFunc:(e,t)=>{
const[n]=t;return{x:()=>Si(e,$i(Fd(n)))};
}},{kernelName:qn,outputsToSave:[!0],gradFunc:(e,t)=>{
const[n]=t;return{x:()=>Ci(Ui(Ri(1),$i(n)),e)};
}},{kernelName:Kn,inputsToSave:["x"],gradFunc:(e,t,n)=>{
const[r]=t,{reps:s}=n;return{x:()=>{
let t=Ti(r);if(1===r.rank){
for(let n=0;n<s[0];++n){
t=ki(t,cu(e,[n*r.shape[0]],[r.shape[0]]));
}
}else if(2===r.rank){
for(let n=0;n<s[0];++n){
for(let i=0;i<s[1];++i){
t=ki(t,cu(e,[n*r.shape[0],i*r.shape[1]],[r.shape[0],r.shape[1]]));
}
}
}else if(3===r.rank){
for(let n=0;n<s[0];++n){
for(let i=0;i<s[1];++i){
for(let a=0;a<s[2];++a){
t=ki(t,cu(e,[n*r.shape[0],i*r.shape[1],a*r.shape[2]],[r.shape[0],r.shape[1],r.shape[2]]));
}
}
}
}else{
if(4!==r.rank){
throw new Error(`Gradient for tile operation is not implemented for rank-${r.rank} tensors yet.`);
}for(let n=0;n<s[0];++n){
for(let i=0;i<s[1];++i){
for(let a=0;a<s[2];++a){
for(let o=0;o<s[3];++o){
t=ki(t,cu(e,[n*r.shape[0],i*r.shape[1],a*r.shape[2],o*r.shape[3]],[r.shape[0],r.shape[1],r.shape[2],r.shape[3]]));
}
}
}
}
}return t;
}};
}},{kernelName:Zn,gradFunc:(e,t,n)=>{
const r=n,{perm:s}=r,i=Wo(s);return{x:()=>$u(e,i)};
}},{kernelName:Qn,gradFunc:(e,t,n)=>{
const r=n,{axis:s}=r;return{value:()=>yu(e,s)};
}},{kernelName:er,inputsToSave:["segmentIds"],gradFunc:(e,t)=>{
const[n]=t;return{x:()=>function(e,t){
const n=qi(t,Ti(t)),r=wo(e,n);let s=ko(t,Ri(0,"int32"));const i=r.rank-s.rank;for(let e=0;e<i;++e){
s=go(s,e+1);
}s=Eo(s,Xo(r.shape,"bool"));const a=Ti(r);return Su(s,r,a);
}(e,n)};
}},{kernelName:tr,gradFunc:e=>({x:()=>Ti(e)})}];for(const e of Wd){
mr(e);
}ts().prototype.abs=function(){
return this.throwIfDisposed(),Vi(this);
};const Vd=As({acos_:function(e){
const t={x:Es(e,"x","acos")};return vs.runKernel(J,t);
}});ts().prototype.acos=function(){
return this.throwIfDisposed(),Vd(this);
};const Gd=As({acosh_:function(e){
const t={x:Es(e,"x","acosh")};return vs.runKernel(Q,t);
}});ts().prototype.acosh=function(){
return this.throwIfDisposed(),Gd(this);
},ts().prototype.add=function(e){
return this.throwIfDisposed(),ki(this,e);
},ts().prototype.all=function(e,t){
return this.throwIfDisposed(),Ca(this,e,t);
},ts().prototype.any=function(e,t){
return this.throwIfDisposed(),Na(this,e,t);
},ts().prototype.argMax=function(e){
return this.throwIfDisposed(),$a(this,e);
};const jd=As({argMin_:function(e,t=0){
const n={x:Es(e,"x","argMin")},r={axis:t};return vs.runKernel(ie,n,r);
}});ts().prototype.argMin=function(e){
return this.throwIfDisposed(),jd(this,e);
},ts().prototype.asScalar=function(){
return this.throwIfDisposed(),d(1===this.size,(()=>"The array must have only 1 element.")),Va(this,[]);
},ts().prototype.asType=function(e){
return this.throwIfDisposed(),fi(this,e);
},ts().prototype.as1D=function(){
return this.throwIfDisposed(),Va(this,[this.size]);
},ts().prototype.as2D=function(e,t){
return this.throwIfDisposed(),Va(this,[e,t]);
},ts().prototype.as3D=function(e,t,n){
return this.throwIfDisposed(),Va(this,[e,t,n]);
},ts().prototype.as4D=function(e,t,n,r){
return this.throwIfDisposed(),Va(this,[e,t,n,r]);
},ts().prototype.as5D=function(e,t,n,r,s){
return this.throwIfDisposed(),Va(this,[e,t,n,r,s]);
};const Hd=As({asin_:function(e){
const t={x:Es(e,"x","asin")};return vs.runKernel(ae,t);
}});ts().prototype.asin=function(){
return this.throwIfDisposed(),Hd(this);
};const qd=As({asinh_:function(e){
const t={x:Es(e,"x","asinh")};return vs.runKernel(oe,t);
}});ts().prototype.asinh=function(){
return this.throwIfDisposed(),qd(this);
};const Kd=As({atan_:function(e){
const t={x:Es(e,"x","atan")};return vs.runKernel(ue,t);
}});ts().prototype.atan=function(){
return this.throwIfDisposed(),Kd(this);
};const Xd=As({atan2_:function(e,t){
let n=Es(e,"a","atan2"),r=Es(t,"b","atan2");[n,r]=ps(n,r);const s={a:n,b:r};return vs.runKernel(ce,s);
}});ts().prototype.atan2=function(e){
return this.throwIfDisposed(),Xd(this,e);
};const Yd=As({atanh_:function(e){
const t={x:Es(e,"x","atanh")};return vs.runKernel(le,t);
}});ts().prototype.atanh=function(){
return this.throwIfDisposed(),Yd(this);
},ts().prototype.avgPool=function(e,t,n,r){
return this.throwIfDisposed(),Ga(this,e,t,n,r);
},ts().prototype.batchToSpaceND=function(e,t){
return this.throwIfDisposed(),Pd(this,e,t);
},ts().prototype.batchNorm=function(e,t,n,r,s){
return this.throwIfDisposed(),Ha(this,e,t,n,r,s);
},ts().prototype.broadcastTo=function(e){
return this.throwIfDisposed(),Ya(this,e);
},ts().prototype.cast=function(e){
return this.throwIfDisposed(),fi(this,e);
};const Zd=As({ceil_:function(e){
const t={x:Es(e,"x","ceil","float32")};return vs.runKernel(ve,t);
}});ts().prototype.ceil=function(){
return this.throwIfDisposed(),Zd(this);
},ts().prototype.clipByValue=function(e,t){
return this.throwIfDisposed(),Za(this,e,t);
},ts().prototype.concat=function(e,t){
return this.throwIfDisposed(),e instanceof es&&(e=[e]),Ja([this,...e],t);
},ts().prototype.conv1d=function(e,t,n,r,s,i){
return this.throwIfDisposed(),so(this,e,t,n,r,s,i);
},ts().prototype.conv2dTranspose=function(e,t,n,r,s){
return this.throwIfDisposed(),ao(this,e,t,n,r,s);
},ts().prototype.conv2d=function(e,t,n,r,s,i){
return this.throwIfDisposed(),ro(this,e,t,n,r,s,i);
},ts().prototype.cos=function(){
return this.throwIfDisposed(),Fd(this);
},ts().prototype.cosh=function(){
return this.throwIfDisposed(),Dd(this);
},ts().prototype.cumprod=function(e,t,n){
return this.throwIfDisposed(),md(this,e,t,n);
},ts().prototype.cumsum=function(e,t,n){
return this.throwIfDisposed(),vh(this,e,t,n);
};const Jd=As({depthToSpace_:function(e,t,n="NHWC"){
const r=Es(e,"x","depthToSpace","float32"),s="NHWC"===n?r.shape[1]:r.shape[2],i="NHWC"===n?r.shape[2]:r.shape[3],a="NHWC"===n?r.shape[3]:r.shape[1];d(t>1,(()=>`blockSize should be > 1 for depthToSpace, but was: ${t}`)),d(s*t>=0,(()=>`Negative dimension size caused by overflow when multiplying\n    ${s} and ${t}  for depthToSpace with input shape\n    ${r.shape}`)),d(i*t>=0,(()=>`Negative dimension size caused by overflow when multiplying\n    ${i} and ${t} for depthToSpace with input shape\n        ${r.shape}`)),d(a%(t*t)==0,(()=>`Dimension size must be evenly divisible by ${t*t} but is ${a} for depthToSpace with input shape ${r.shape}`));const o={x:r},u={blockSize:t,dataFormat:n};return vs.runKernel(ze,o,u);
}});ts().prototype.depthToSpace=function(e,t){
return this.throwIfDisposed(),Jd(this,e,t);
},ts().prototype.depthwiseConv2d=function(e,t,n,r,s,i){
return this.throwIfDisposed(),ho(this,e,t,n,r,s,i);
};const Qd=As({dilation2d_:function(e,t,n,r,s=[1,1],i="NHWC"){
const a=Es(e,"x","dilation2d"),o=Es(t,"filter","dilation2d");d(3===a.rank||4===a.rank,(()=>`Error in dilation2d: input must be rank 3 or 4, but got rank ${a.rank}.`)),d(3===o.rank,(()=>`Error in dilation2d: filter must be rank 3, but got rank ${o.rank}.`)),d("NHWC"===i,(()=>`Error in dilation2d: Only NHWC is currently supported, but got dataFormat of ${i}`));let u=a,l=!1;3===a.rank&&(u=Va(a,[1,a.shape[0],a.shape[1],a.shape[2]]),l=!0),d(u.shape[3]===o.shape[2],(()=>`Error in dilation2d:  input and filter must have the same depth: ${u.shape[3]} vs ${o.shape[2]}`));const c={x:u,filter:o},h={strides:n,pad:r,dilations:s},p=vs.runKernel(Ve,c,h);return l?Va(p,[p.shape[1],p.shape[2],p.shape[3]]):p;
}});ts().prototype.dilation2d=function(e,t,n,r,s){
return this.throwIfDisposed(),Qd(this,e,t,n,r,s);
};const ep=As({divNoNan_:function(e,t){
let n=Es(e,"a","div"),r=Es(t,"b","div");[n,r]=ps(n,r);const s=Si(n,r),i=Ti(s),a=fo(r,i);return Su(a,i,s);
}});ts().prototype.divNoNan=function(e){
return this.throwIfDisposed(),ep(this,e);
},ts().prototype.div=function(e){
return this.throwIfDisposed(),Si(this,e);
};const tp=As({dot_:function(e,t){
const n=Es(e,"t1","dot"),r=Es(t,"t2","dot");d(!(1!==n.rank&&2!==n.rank||1!==r.rank&&2!==r.rank),(()=>`Error in dot: inputs must all be rank 1 or 2, but got ranks ${n.rank} and ${r.rank}.`));const s=1===n.rank?n.size:n.shape[1],i=1===r.rank?r.size:r.shape[0];if(d(s===i,(()=>`Error in dot: inner dimensions of inputs must match, but got ${s} and ${i}.`)),1===n.rank&&1===r.rank){
const e=Va(n,[1,-1]),t=Va(r,[-1,1]),s=Ro(e,t);return Va(s,[]);
}if(1===n.rank&&2===r.rank){
const e=Va(n,[1,-1]),t=Va(r,[r.shape[0],r.shape[1]]),s=Ro(e,t);return Va(s,[s.size]);
}if(2===n.rank&&1===r.rank){
const e=Va(r,[-1,1]),t=Ro(n,e);return Va(t,[t.size]);
}{const e=Va(r,[r.shape[0],r.shape[1]]);return Ro(n,e);}
}});ts().prototype.dot=function(e){
return this.throwIfDisposed(),tp(this,e);
},ts().prototype.elu=function(){
return this.throwIfDisposed(),po(this);
},ts().prototype.equal=function(e){
return this.throwIfDisposed(),fo(this,e);
};const np=As({erf_:function(e){
let t=Es(e,"x","erf");d("int32"===t.dtype||"float32"===t.dtype,(()=>"Input dtype must be `int32` or `float32`.")),"int32"===t.dtype&&(t=fi(t,"float32"));const n={x:t};return vs.runKernel(Ye,n);
}});ts().prototype.erf=function(){
return this.throwIfDisposed(),np(this);
};const rp=As({euclideanNorm_:function(e,t=null,n=!1){
return wl(e,"euclidean",t,n);
}});ts().prototype.euclideanNorm=function(e,t){
return this.throwIfDisposed(),rp(this,e,t);
},ts().prototype.exp=function(){
return this.throwIfDisposed(),mo(this);
},ts().prototype.expandDims=function(e){
return this.throwIfDisposed(),go(this,e);
};const sp=As({expm1_:function(e){
const t={x:Es(e,"x","expm1")};return vs.runKernel(et,t);
}});ts().prototype.expm1=function(){
return this.throwIfDisposed(),sp(this);
},ts().prototype.fft=function(){
return this.throwIfDisposed(),Eu(this);
},ts().prototype.flatten=function(){
return this.throwIfDisposed(),Va(this,[this.size]);
},ts().prototype.floor=function(){
return this.throwIfDisposed(),yo(this);
},ts().prototype.floorDiv=function(e){
return this.throwIfDisposed(),Ii(this,e);
},ts().prototype.gather=function(e,t,n){
return this.throwIfDisposed(),wo(this,e,t,n);
},ts().prototype.greaterEqual=function(e){
return this.throwIfDisposed(),ko(this,e);
},ts().prototype.greater=function(e){
return this.throwIfDisposed(),vo(this,e);
},ts().prototype.ifft=function(){
return this.throwIfDisposed(),Au(this);
},ts().prototype.irfft=function(){
return this.throwIfDisposed(),Fu(this);
};const ip=As({isFinite_:function(e){
const t={x:Es(e,"x","isFinite")};return vs.runKernel(ft,t);
}});ts().prototype.isFinite=function(){
return this.throwIfDisposed(),ip(this);
};const ap=As({isInf_:function(e){
const t={x:Es(e,"x","isInf")};return vs.runKernel(mt,t);
}});ts().prototype.isInf=function(){
return this.throwIfDisposed(),ap(this);
};const op=As({isNaN_:function(e){
const t={x:Es(e,"x","isNaN")};return vs.runKernel(gt,t);
}});ts().prototype.isNaN=function(){
return this.throwIfDisposed(),op(this);
},ts().prototype.leakyRelu=function(e){
return this.throwIfDisposed(),Io(this,e);
},ts().prototype.lessEqual=function(e){
return this.throwIfDisposed(),pl(this,e);
},ts().prototype.less=function(e){
return this.throwIfDisposed(),bl(this,e);
};const up=As({localResponseNormalization_:function(e,t=5,n=1,r=1,s=.5){
const i=Es(e,"x","localResponseNormalization");d(4===i.rank||3===i.rank,(()=>`Error in localResponseNormalization: x must be rank 3 or 4 but got\n               rank ${i.rank}.`)),d(b(t),(()=>`Error in localResponseNormalization: depthRadius must be an integer but got depthRadius ${t}.`));let a=i,o=!1;3===i.rank&&(o=!0,a=Va(i,[1,i.shape[0],i.shape[1],i.shape[2]]));const u={x:a},l={depthRadius:t,bias:n,alpha:r,beta:s},c=vs.runKernel(Nt,u,l);return o?Va(c,[c.shape[1],c.shape[2],c.shape[3]]):c;
}});ts().prototype.localResponseNormalization=function(e,t,n,r){
return this.throwIfDisposed(),up(this,e,t,n,r);
};const lp=As({logSigmoid_:function(e){
const t=Es(e,"x","logSigmoid");return Ei((e=>({value:jo(gu(jo(e))),gradFunc:t=>Ci(t,lu(jo(e)))})))(t);
}});ts().prototype.logSigmoid=function(){
return this.throwIfDisposed(),lp(this);
},ts().prototype.logSoftmax=function(e){
return this.throwIfDisposed(),To(this,e);
},ts().prototype.logSumExp=function(e,t){
return this.throwIfDisposed(),Nl(this,e,t);
},ts().prototype.log=function(){
return this.throwIfDisposed(),So(this);
},ts().prototype.log1p=function(){
return this.throwIfDisposed(),Co(this);
},ts().prototype.logicalAnd=function(e){
return this.throwIfDisposed(),Eo(this,e);
},ts().prototype.logicalNot=function(){
return this.throwIfDisposed(),$d(this);
};const cp=As({logicalOr_:function(e,t){
const n=Es(e,"a","logicalOr","bool"),r=Es(t,"b","logicalOr","bool");Hi(n.shape,r.shape);const s={a:n,b:r};return vs.runKernel(Ct,s);
}});ts().prototype.logicalOr=function(e){
return this.throwIfDisposed(),cp(this,e);
};const hp=As({logicalXor_:function(e,t){
const n=Es(e,"a","logicalXor","bool"),r=Es(t,"b","logicalXor","bool");return Hi(n.shape,r.shape),Eo(cp(e,t),$d(Eo(e,t)));
}});ts().prototype.logicalXor=function(e){
return this.throwIfDisposed(),hp(this,e);
},ts().prototype.matMul=function(e,t,n){
return this.throwIfDisposed(),Ro(this,e,t,n);
},ts().prototype.maxPool=function(e,t,n,r){
return this.throwIfDisposed(),Ao(this,e,t,n,r);
},ts().prototype.max=function(e,t){
return this.throwIfDisposed(),No(this,e,t);
},ts().prototype.maximum=function(e){
return this.throwIfDisposed(),qi(this,e);
},ts().prototype.mean=function(e,t){
return this.throwIfDisposed(),_o(this,e,t);
},ts().prototype.min=function(e,t){
return this.throwIfDisposed(),Do(this,e,t);
},ts().prototype.minimum=function(e){
return this.throwIfDisposed(),Oo(this,e);
};const dp=As({mirrorPad_:function(e,t,n){
d("reflect"===n||"symmetric"===n,(()=>`Invalid mode. Mode must be either reflect or symmetric. Got ${n}.`));const r=Es(e,"x","mirrorPad");if(0===r.rank){
throw new Error("mirrorPad(scalar) is not defined. Pass non-scalar to mirrorPad");
}d(t.length===r.rank,(()=>`Padding doesn't match input. Must be ${r.rank}. Got ${t.length}.`));const s="reflect"===n?1:0;for(let e=0;e<r.rank;e++){
d(2===t[e].length,(()=>"Invalid number of paddings. Must be length of 2 each.")),d(t[e][0]>=0&&t[e][0]<=r.shape[e]-s&&t[e][1]>=0&&t[e][1]<=r.shape[e]-s,(()=>`Padding in dimension ${e} cannot be greater than or equal to ${r.shape[e]-s} or less than 0 for input of shape ${r.shape}`));
}const i={paddings:t,mode:n},a={x:r};return vs.runKernel(zt,a,i);
}});ts().prototype.mirrorPad=function(e,t){
return this.throwIfDisposed(),dp(this,e,t);
};const pp=As({mod_:function(e,t){
let n=Es(e,"a","mod"),r=Es(t,"b","mod");[n,r]=ps(n,r);const s={a:n,b:r};return vs.runKernel(Pt,s);
}});ts().prototype.mod=function(e){
return this.throwIfDisposed(),pp(this,e);
},ts().prototype.mul=function(e){
return this.throwIfDisposed(),Ci(this,e);
},ts().prototype.neg=function(){
return this.throwIfDisposed(),jo(this);
},ts().prototype.norm=function(e,t,n){
return this.throwIfDisposed(),wl(this,e,t,n);
},ts().prototype.notEqual=function(e){
return this.throwIfDisposed(),Ho(this,e);
},ts().prototype.oneHot=function(e,t=1,n=0){
return this.throwIfDisposed(),qo(this,e,t,n);
},ts().prototype.onesLike=function(){
return this.throwIfDisposed(),Yo(this);
},ts().prototype.pad=function(e,t){
return this.throwIfDisposed(),Zo(this,e,t);
};const fp=As({pool_:function(e,t,n,r,s,i,a){
null==s&&(s=[1,1]),null==i&&(i=1),0===r&&(r="valid");const o=Es(e,"x","maxPool");let u=o,l=!1;3===o.rank&&(l=!0,u=Va(o,[1,o.shape[0],o.shape[1],o.shape[2]])),d(Pa(i,s),(()=>`Error in pool: Either strides or dilations must be 1. Got strides ${i} and dilations '${s}'`));const c=Ea(u.shape,t,i,s,r),h=[c.dilationHeight,c.dilationWidth];let p;p="same"===r?function(e,t){
const n=e.map(((e,n)=>e+(e-1)*(t[n]-1))).map((e=>e-1)),r=n.map((e=>Math.floor(e/2))),s=n.map(((e,t)=>e-r[t]));return n.map(((e,t)=>[r[t],s[t]]));
}([c.filterHeight,c.filterWidth],h):[[0,0],[0,0]];const f=1===h[0]&&1===h[1],[m,g]=function(e,t,n){
const r=n.map((e=>e[0])),s=n.map((e=>e[1])),i=e.concat(r,s),a=t.map(((e,t)=>(e-i[t]%e)%e)),o=s.map(((e,t)=>e+a[t]));return[t.map(((e,t)=>[r[t],o[t]])),t.map(((e,t)=>[0,a[t]]))];
}([c.inHeight,c.inWidth],h,p),b=f?r:"valid",x=f?u:ih(u,h,m),y=("avg"===n?()=>Ga(x,t,i,b,a):()=>Ao(x,t,i,b,a))(),w=f?y:Pd(y,h,g);return l?Va(w,[w.shape[1],w.shape[2],w.shape[3]]):w;
}});ts().prototype.pool=function(e,t,n,r,s,i){
return this.throwIfDisposed(),fp(this,e,t,n,r,s,i);
},ts().prototype.pow=function(e){
return this.throwIfDisposed(),Bi(this,e);
},ts().prototype.prelu=function(e){
return this.throwIfDisposed(),Jo(this,e);
};const mp=As({prod_:function(e,t=null,n=!1){
let r=Es(e,"x","prod");"bool"===r.dtype&&(r=fi(r,"int32"));const s={x:r},i={axis:t,keepDims:n};return vs.runKernel(Qt,s,i);
}});ts().prototype.prod=function(e,t){
return this.throwIfDisposed(),mp(this,e,t);
};const gp=As({reciprocal_:function(e){
const t={x:Es(e,"x","reciprocal")};return vs.runKernel(an,t);
}});ts().prototype.reciprocal=function(){
return this.throwIfDisposed(),gp(this);
},ts().prototype.relu=function(){
return this.throwIfDisposed(),iu(this);
},ts().prototype.relu6=function(){
return this.throwIfDisposed(),Du(this);
},ts().prototype.reshapeAs=function(e){
return this.throwIfDisposed(),Va(this,e.shape);
},ts().prototype.reshape=function(e){
return this.throwIfDisposed(),Va(this,e);
},ts().prototype.resizeBilinear=function(e,t,n){
return this.throwIfDisposed(),cl(this,e,t,n);
},ts().prototype.resizeNearestNeighbor=function(e,t,n){
return this.throwIfDisposed(),hl(this,e,t,n);
},ts().prototype.reverse=function(e){
return this.throwIfDisposed(),au(this,e);
},ts().prototype.rfft=function(){
return this.throwIfDisposed(),Ru(this);
},ts().prototype.round=function(){
return this.throwIfDisposed(),fl(this);
},ts().prototype.rsqrt=function(){
return this.throwIfDisposed(),Fh(this);
},ts().prototype.selu=function(){
return this.throwIfDisposed(),ou(this);
},ts().prototype.separableConv2d=function(e,t,n,r,s,i){
return this.throwIfDisposed(),uu(this,e,t,n,r,s,i);
},ts().prototype.sigmoid=function(){
return this.throwIfDisposed(),lu(this);
};const bp=As({sign_:function(e){
const t={x:Es(e,"x","sign")};return vs.runKernel(Cn,t);
}});ts().prototype.sign=function(){
return this.throwIfDisposed(),bp(this);
},ts().prototype.sin=function(){
return this.throwIfDisposed(),bh(this);
},ts().prototype.sinh=function(){
return this.throwIfDisposed(),yh(this);
},ts().prototype.slice=function(e,t){
return this.throwIfDisposed(),cu(this,e,t);
},ts().prototype.softmax=function(e){
return this.throwIfDisposed(),mu(this,e);
},ts().prototype.softplus=function(){
return this.throwIfDisposed(),gu(this);
},ts().prototype.spaceToBatchND=function(e,t){
return this.throwIfDisposed(),ih(this,e,t);
},ts().prototype.split=function(e,t){
return this.throwIfDisposed(),bu(this,e,t);
},ts().prototype.sqrt=function(){
return this.throwIfDisposed(),Ni(this);
},ts().prototype.square=function(){
return this.throwIfDisposed(),$i(this);
},ts().prototype.squaredDifference=function(e){
return this.throwIfDisposed(),Cl(this,e);
},ts().prototype.squeeze=function(e){
return this.throwIfDisposed(),xu(this,e);
},ts().prototype.stack=function(e,t){
this.throwIfDisposed();const n=e instanceof es?[this,e]:[this,...e];return yu(n,t);
},ts().prototype.step=function(e){
return this.throwIfDisposed(),Ou(this,e);
};const xp=As({stridedSlice_:function(e,t,n,r,s=0,i=0,a=0,o=0,u=0){
const l={x:Es(e,"x","stridedSlice","string_or_numeric")},c={begin:t,end:n,strides:r,beginMask:s,endMask:i,ellipsisMask:a,newAxisMask:o,shrinkAxisMask:u};return vs.runKernel(Un,l,c);
}});ts().prototype.stridedSlice=function(e,t,n,r,s,i,a,o){
return this.throwIfDisposed(),xp(this,e,t,n,r,s,i,a,o);
},ts().prototype.sub=function(e){
return this.throwIfDisposed(),Ui(this,e);
},ts().prototype.sum=function(e,t){
return this.throwIfDisposed(),$o(this,e,t);
};const yp=As({tan_:function(e){
const t={x:Es(e,"x","tan","float32")};return vs.runKernel(Hn,t);
}});ts().prototype.tan=function(){
return this.throwIfDisposed(),yp(this);
},ts().prototype.tanh=function(){
return this.throwIfDisposed(),wu(this);
},ts().prototype.tile=function(e){
return this.throwIfDisposed(),bo(this,e);
},ts().prototype.toBool=function(){
return this.throwIfDisposed(),fi(this,"bool");
},ts().prototype.toFloat=function(){
return this.throwIfDisposed(),fi(this,"float32");
},ts().prototype.toInt=function(){
return this.throwIfDisposed(),fi(this,"int32");
};const wp=As({topk_:function(e,t=1,n=!0){
const r=Es(e,"x","topk");if(0===r.rank){
throw new Error("topk() expects the input to be of rank 1 or higher");
}const s=r.shape[r.shape.length-1];if(t<0){
throw new Error(`'k' passed to topk() must be >= 0 but got ${t}`);
}if(t>s){
throw new Error(`'k' passed to topk() must be <= the last dimension (${s}) but got ${t}`);
}const i={x:r},a={k:t,sorted:n},[o,u]=vs.runKernel(Xn,i,a);return{values:o,indices:u};
}});ts().prototype.topk=function(e,t){
return this.throwIfDisposed(),wp(this,e,t);
},ts().prototype.transpose=function(e){
return this.throwIfDisposed(),$u(this,e);
};const vp=As({unique_:function(e,t=0){
const n=Es(e,"x","unique","string_or_numeric");d(n.rank>0,(()=>"The input tensor must be at least 1D"));const r={x:n},s={axis:t},[i,a]=vs.runKernel(Jn,r,s);return{values:i,indices:a};
}});ts().prototype.unique=function(e){
return this.throwIfDisposed(),vp(this,e);
},ts().prototype.unsortedSegmentSum=function(e,t){
return this.throwIfDisposed(),Dh(this,e,t);
},ts().prototype.unstack=function(e){
return this.throwIfDisposed(),Iu(this,e);
},ts().prototype.where=function(e,t){
return this.throwIfDisposed(),Su(e,this,t);
},ts().prototype.zerosLike=function(){
return this.throwIfDisposed(),Ti(this);
};class kp extends Error{
constructor(e){
super(e),Object.setPrototypeOf(this,kp.prototype);
}
}class Ip extends Error{
constructor(e){
super(e),Object.setPrototypeOf(this,Ip.prototype);
}
}class Sp extends Error{
constructor(e){
super(e),Object.setPrototypeOf(this,Sp.prototype);
}
}class Cp extends Error{
constructor(e){
super(e),Object.setPrototypeOf(this,Cp.prototype);
}
}class Np extends Error{
constructor(e){
super(e),Object.setPrototypeOf(this,Np.prototype);
}
}class $p{
constructor(e){
this.maxEntries=e||100,this.cache=new Map;
}get(e){
let t;return this.cache.has(e)&&(t=this.cache.get(e),this.cache.delete(e),this.cache.set(e,t)),t;
}put(e,t){
if(this.cache.has(e)){
this.cache.delete(e);
}else if(this.cache.size>=this.maxEntries){
const e=this.cache.keys().next().value;this.cache.delete(e);
}this.cache.set(e,t);
}getMaxEntries(){
return this.maxEntries;
}setMaxEntries(e){
if(e<0){
throw new Error(`The maxEntries of LRU caches must be at least 0, but got ${e}.`);
}if(this.maxEntries>e){
for(let t=0;t<this.maxEntries-e;t++){
const e=this.cache.keys().next().value;this.cache.delete(e);
}
}this.maxEntries=e;
}
}function Tp(e,t){
if(Array.isArray(e)){
let n=[];for(let r=0;r<t;r++){
n=n.concat(e);
}return n;
}{const n=new Array(t);return n.fill(e),n;}
}function Ep(e,t){
if(!e){
throw new Np(t);
}
}function Rp(e,t){
let n=0;for(const r of e){
r===t&&n++;
}return n;
}function Ap(e){
return 1===e.length?e[0]:e;
}function Fp(e){
return Array.isArray(e)?e:[e];
}function _p(e){
const t=e.replace(/(.)([A-Z][a-z0-9]+)/g,"$1_$2").replace(/([a-z])([A-Z])/g,"$1_$2").toLowerCase();return"_"!==t[0]?t:"private"+t;
}function Dp(e){
return e.length<=1||-1===e.indexOf("_")?e:e.replace(/[_]+(\w|$)/g,((e,t)=>t.toUpperCase()));
}let Op={};function Mp(e){
if(null==e){
return null;
}const t={};return t.className=e.getClassName(),t.config=e.getConfig(),t;
}function Lp(e){
if(null!=e&&"object"==typeof e){
if(Array.isArray(e)){
e.forEach((e=>Lp(e)));
}else{
const t=Object.keys(e);for(const n of t){
const t=e[n];null!=t&&"object"==typeof t&&(Array.isArray(t)||"ndarray"!==t.type||"number"!=typeof t.value?Lp(t):e[n]=t.value);
}
}
}
}function zp(e,t={},n={},r="object",s=!1){
if("string"==typeof e){
const s=e;let i;if(s in n){
i=n[s];
}else if(s in Op){
i=Op[s];
}else if(i=t[s],null==i){
throw new Sp(`Unknown ${r}: ${e}. This may be due to one of the following reasons:\n1. The ${r} is defined in Python, in which case it needs to be ported to TensorFlow.js or your JavaScript code.\n2. The custom ${r} is defined in JavaScript, but is not registered properly with tf.serialization.registerClass().`);
}return i;
}{const i=e;if(null==i.className||null==i.config){
throw new Sp(`${r}: Improper config format: ${JSON.stringify(i)}.\n'className' and 'config' must set.`);
}const a=i.className;let o,u;if(a in n?[o,u]=n[a]:a in Op?[o,u]=Op.className:a in t&&([o,u]=t[a]),null==o){
throw new Sp(`Unknown ${r}: ${a}. This may be due to one of the following reasons:\n1. The ${r} is defined in Python, in which case it needs to be ported to TensorFlow.js or your JavaScript code.\n2. The custom ${r} is defined in JavaScript, but is not registered properly with tf.serialization.registerClass().`);
}if(null!=u){
const e={};for(const t of Object.keys(Op)){
e[t]=Op[t];
}for(const t of Object.keys(n)){
e[t]=n[t];
}i.config.customObjects=e;const t=Object.assign({},Op);for(const e of Object.keys(n)){
Op[e]=n[e];
}Lp(i.config);const r=u(o,i.config,n,s);return Op=Object.assign({},t),r;
}{const e=Object.assign({},Op);for(const e of Object.keys(n)){
Op[e]=n[e];
}const t=new o(i.config);return Op=Object.assign({},e),t;}}
}function Pp(e,t){
return-1*function(e,t){
return e<t?-1:e>t?1:0;
}(e,t);
}function Bp(e){
if(null==e){
return e;
}const t=[];for(const n of e){
-1===t.indexOf(n)&&t.push(n);
}return t;
}function Up(e){
if(null==e){
throw new Sp(`Invalid value in obj: ${JSON.stringify(e)}`);
}for(const t in e){
if(e.hasOwnProperty(t)){
return!1;
}
}return!0;
}function Wp(e,t,n){
if(null!=n&&e.indexOf(n)<0){
throw new Sp(`${n} is not a valid ${t}.  Valid values are ${e} or null/undefined.`);
}
}function Vp(e,t,n=0,r=1/0){
return Ep(n>=0),Ep(r>=n),Array.isArray(e)&&e.length>=n&&e.length<=r&&e.every((e=>typeof e===t));
}function Gp(e,t){
Array.isArray(e)?(d(e.length>0,(()=>`${t} is unexpectedly an empty array.`)),e.forEach(((e,n)=>Gp(e,`element ${n+1} of ${t}`)))):d(Number.isInteger(e)&&e>0,(()=>`Expected ${t} to be a positive integer, but got ${jp(e)}.`));
}function jp(e){
return null===e?"null":Array.isArray(e)?"["+e.map((e=>jp(e))).join(",")+"]":"string"==typeof e?`"${e}"`:`${e}`;
}function Hp(e){
return"relu"===e?"relu":"linear"===e?"linear":"elu"===e?"elu":null;
}let qp=0;function Kp(){
return qp++;
}const Xp={};function Yp(e=""){
return e in Xp||(Xp[e]=0),Xp[e]+=1,e+Xp[e].toString();
}const Zp=["channelsFirst","channelsLast"],Jp=["nearest","bilinear"],Qp=["valid","same","causal"],ef=["max","avg"],tf=["sum","mul","concat","ave"],nf=new Map;function rf(e){
Wp(Zp,"DataFormat",e);
}function sf(e){
Wp(Qp,"PaddingMode",e);
}function af(e){
Wp(ef,"PoolMode",e);
}const of=[];function uf(e,t){
of.push(e);try{
const e=t();return of.pop(),e;
}catch(e){
throw of.pop(),e;
}
}function lf(e){
if(!df(e)){
throw new Error("Not a valid tensor name: '"+e+"'");
}return(0===of.length?"":of.join("/")+"/")+e;
}function cf(e){
if(!df(e)){
throw new Error("Not a valid tensor name: '"+e+"'");
}nf.has(e)||nf.set(e,0);const t=nf.get(e);if(nf.set(e,nf.get(e)+1),t>0){
const n=`${e}_${t}`;return nf.set(n,1),n;
}return e;
}const hf=new RegExp(/^[A-Za-z0-9][-A-Za-z0-9\._\/]*$/);function df(e){
return!!e.match(hf);
}function pf(e,t,n){
null==t&&(t=0),null==n&&(n=e.length);let r=1;for(let s=t;s<n;++s){
r*=e[s];
}return r;
}function ff(e){
if(0===e.length){
return Number.NaN;
}let t=Number.POSITIVE_INFINITY;for(let n=0;n<e.length;n++){
const r=e[n];r<t&&(t=r);
}return t;
}function mf(e){
if(0===e.length){
return Number.NaN;
}let t=Number.NEGATIVE_INFINITY;for(let n=0;n<e.length;n++){
const r=e[n];r>t&&(t=r);
}return t;
}function gf(e,t){
if(t<e){
throw new Sp(`end (${t}) < begin (${e}) is forbidden.`);
}const n=[];for(let r=e;r<t;++r){
n.push(r);
}return n;
}let bf;function xf(){
return null==bf&&(bf=vs.backend.epsilon()),bf;
}function yf(e,t){
return fi(e,t);
}function wf(e,t=-1){
const n=e.shape.slice();return t<0&&(t=n.length+t+1),n.splice(t,0,1),Va(e,n);
}function vf(e,t,n){
return xi((()=>{
switch(e.rank){
case 1:return hu(e,t,n);case 2:return du(e,[t,0],[n,e.shape[1]]);case 3:return pu(e,[t,0,0],[n,e.shape[1],e.shape[2]]);case 4:return fu(e,[t,0,0,0],[n,e.shape[1],e.shape[2],e.shape[3]]);case 5:return cu(e,[t,0,0,0,0],[n,e.shape[1],e.shape[2],e.shape[3],e.shape[4]]);case 6:return cu(e,[t,0,0,0,0,0],[n,e.shape[1],e.shape[2],e.shape[3],e.shape[4],e.shape[5]]);default:throw new Sp(`sliceAlongFirstAxis() received an unsupported tensor rank: ${e.rank}`);
}
}));
}function kf(e,t,n){
return xi((()=>{
switch(e.rank){
case 1:return hu(e,t,n);case 2:return du(e,[0,t],[e.shape[0],n]);case 3:return pu(e,[0,0,t],[e.shape[0],e.shape[1],n]);case 4:return fu(e,[0,0,0,t],[e.shape[0],e.shape[1],e.shape[2],n]);default:throw new Sp(`sliceAlongLastAxis() received an unsupported tensor rank: ${e.rank}`);
}
}));
}function If(e,t,n,r){
return xi((()=>{
switch(e.rank){
case 1:return hu(e,t,n);case 2:switch(r){
case 1:return vf(e,t,n);case 2:return kf(e,t,n);default:throw new Sp(`The axis is not within the rank of the tensor ${r}`);
}case 3:switch(r){
case 1:return vf(e,t,n);case 2:return pu(e,[0,t,0],[e.shape[0],n,e.shape[2]]);case 3:return kf(e,t,n);default:throw new Sp(`The axis is not within the rank of the tensor ${r}`);
}case 4:switch(r){
case 1:return vf(e,t,n);case 2:return fu(e,[0,t,0,0],[e.shape[0],n,e.shape[2],e.shape[3]]);case 3:return fu(e,[0,0,t,0],[e.shape[0],e.shape[1],n,e.shape[3]]);case 4:return kf(e,t,n);default:throw new Sp(`The axis is not within the rank of the tensor ${r}`);
}default:throw new Sp(`sliceAlongLastAxis() received an unsupported tensor rank: ${e.rank}`);
}
}));
}function Sf(e,t=-1){
let n;return t<0&&(n=e[0].rank,t=0!==n?n:0),t===e[0].rank&&(t=-1),Ja(e,t);
}function Cf(e,t){
switch(e.rank){
case 1:return Qa([e,t]);case 2:return eo([e,t],0);case 3:return to([e,t],0);case 4:return no([e,t],0);default:throw new Sp(`concatAlongFirstAxis() received an unsupported tensor rank: ${e.rank}`);
}
}function Nf(e,t){
if(Array.isArray(t)||(t=[t]),e.rank!==t.length){
throw new Sp(`The length of input n (${t.length}) does not match the number of dimensions in input x (${e.rank})`);
}return bo(e,t);
}function $f(e,t=0,n=1,r,s){
return nu(e,t,n,r,s);
}function Tf(e,t,n,r){
if(e.rank<2||t.rank<2){
throw new Cp(`dot requires both inputs to be rank >= 2 but got x shape = ${e.shape} and y shape = ${t.shape}`);
}if(t.rank>=3&&e.shape.slice(-1)[0]!==t.shape.slice(-2)[0]){
throw new Cp(`If rank y >= 3, then the second last dim of y must equal the last dim of x but got x shape = ${e.shape} and  y shape = ${t.shape}`);
}if(2===e.rank&&2===t.rank){
return Vu({a:e,b:t,transposeA:!1,transposeB:!1,bias:r?Af(e.rank,r,"channelsLast"):null,activation:n});
}{const s=e.shape.slice(),i=s.pop();e=Va(e,[-1,i]);const a=t.shape.slice(),o=a.pop(),u=a.pop(),l=[...a,o],c=Array.from({length:t.rank},((e,n)=>0===n?t.rank-2:n<=t.rank-2?n-1:n));t=Va($u(t,c),[u,-1]);const h=[...s,...l];return Va(Vu({a:e,b:t,transposeA:!1,transposeB:!1,bias:r?Af(e.rank,r,"channelsLast"):null,activation:n}),h);}
}function Ef(e,t,n){
return xi((()=>(t=Array.isArray(t)?vu(t,"int32"):fi(t,"int32"),wo(e,t,n))));
}function Rf(e){
return Ci(e,e);
}function Af(e,t,n){
const r=t.shape;if(1!==t.rank&&t.rank!==e){
throw new Sp(`Unexpected bias dimensions: ${t.rank}; expected it to be 1 or ${e}`);
}if(5===e){
if("channelsFirst"===n){
return 1===r.length?Va(t,[1,r[0],1,1,1]):Va(t,[1,r[3],r[0],r[1],r[2]]);
}if("channelsLast"===n){
return 1===r.length?Va(t,[1,1,1,1,r[0]]):Va(t,[1].concat(r));
}
}else if(4===e){
if("channelsFirst"===n){
return 1===r.length?Va(t,[1,r[0],1,1]):Va(t,[1,r[2],r[0],r[1]]);
}if("channelsLast"===n){
return 1===r.length?Va(t,[1,1,1,r[0]]):Va(t,[1].concat(r));
}
}else if(3===e){
if("channelsFirst"===n){
return 1===r.length?Va(t,[1,r[0],1]):Va(t,[1,r[1],r[0]]);
}if("channelsLast"===n){
return 1===r.length?Va(t,[1,1,r[0]]):Va(t,[1].concat(r));
}
}else if(e<3){
return t;
}throw new Sp(`Unsupported input rank by biasAdd: ${t.rank}`);
}function Ff(e,t,n){
return xi((()=>(null==n&&(n="channelsLast"),rf(n),ki(e,Af(e.rank,t,n)))));
}function _f(e,t,n,r){
return xi((()=>Tu(e,t,n,r)));
}function Df(e,t,n=!1){
return n?e():t();
}const Of=["fanIn","fanOut","fanAvg"],Mf=["normal","uniform","truncatedNormal"];class Lf extends _i{
fromConfigUsesCustomObjects(){
return!1;
}getConfig(){
return{};
}
}class zf extends Lf{
apply(e,t){
return Ko(e,t);
}
}zf.className="Zeros",Oi(zf);class Pf extends Lf{
apply(e,t){
return Xo(e,t);
}
}Pf.className="Ones",Oi(Pf);class Bf extends Lf{
constructor(e){
if(super(),"object"!=typeof e){
throw new Sp(`Expected argument of type ConstantConfig but got ${e}`);
}if(void 0===e.value){
throw new Sp(`config must have value set but got ${e}`);
}this.value=e.value;
}apply(e,t){
return xi((()=>Ci(Ri(this.value),Xo(e,t))));
}getConfig(){
return{value:this.value};
}
}Bf.className="Constant",Oi(Bf);class Uf extends Lf{
constructor(e){
super(),this.DEFAULT_MINVAL=-.05,this.DEFAULT_MAXVAL=.05,this.minval=e.minval||this.DEFAULT_MINVAL,this.maxval=e.maxval||this.DEFAULT_MAXVAL,this.seed=e.seed;
}apply(e,t){
return ru(e,this.minval,this.maxval,t,this.seed);
}getConfig(){
return{minval:this.minval,maxval:this.maxval,seed:this.seed};
}
}Uf.className="RandomUniform",Oi(Uf);class Wf extends Lf{
constructor(e){
super(),this.DEFAULT_MEAN=0,this.DEFAULT_STDDEV=.05,this.mean=e.mean||this.DEFAULT_MEAN,this.stddev=e.stddev||this.DEFAULT_STDDEV,this.seed=e.seed;
}apply(e,t){
if("float32"!==(t=t||"float32")&&"int32"!==t){
throw new Cp(`randomNormal does not support dType ${t}.`);
}return $f(e,this.mean,this.stddev,t,this.seed);
}getConfig(){
return{mean:this.mean,stddev:this.stddev,seed:this.seed};
}
}Wf.className="RandomNormal",Oi(Wf);class Vf extends Lf{
constructor(e){
super(),this.DEFAULT_MEAN=0,this.DEFAULT_STDDEV=.05,this.mean=e.mean||this.DEFAULT_MEAN,this.stddev=e.stddev||this.DEFAULT_STDDEV,this.seed=e.seed;
}apply(e,t){
if("float32"!==(t=t||"float32")&&"int32"!==t){
throw new Cp(`truncatedNormal does not support dType ${t}.`);
}return ku(e,this.mean,this.stddev,t,this.seed);
}getConfig(){
return{mean:this.mean,stddev:this.stddev,seed:this.seed};
}
}Vf.className="TruncatedNormal",Oi(Vf);class Gf extends Lf{
constructor(e){
super(),this.gain=null!=e.gain?e.gain:1;
}apply(e,t){
return xi((()=>{
if(2!==e.length||e[0]!==e[1]){
throw new Sp("Identity matrix initializer can only be used for 2D square matrices.");
}return Ci(this.gain,xo(e[0]));
}));
}getConfig(){
return{gain:this.gain};
}
}Gf.className="Identity",Oi(Gf);class jf extends Lf{
constructor(e){
if(super(),e.scale<0){
throw new Sp(`scale must be a positive float. Got: ${e.scale}`);
}var t;this.scale=null==e.scale?1:e.scale,this.mode=null==e.mode?"fanIn":e.mode,t=this.mode,Wp(Of,"FanMode",t),this.distribution=null==e.distribution?"normal":e.distribution,function(e){
Wp(Mf,"Distribution",e);
}(this.distribution),this.seed=e.seed;
}apply(e,t){
const n=function(e,t="channelsLast"){
let n,r;if(rf(t),2===e.length){
n=e[0],r=e[1];
}else if(-1!==[3,4,5].indexOf(e.length)){
if("channelsFirst"===t){
const t=pf(e,2);n=e[1]*t,r=e[0]*t;
}else if("channelsLast"===t){
const t=pf(e,0,e.length-2);n=e[e.length-2]*t,r=e[e.length-1]*t;
}
}else{
const t=pf(e);n=Math.sqrt(t),r=Math.sqrt(t);
}return[n,r];
}(e),r=n[0],s=n[1];let i=this.scale;if("fanIn"===this.mode?i/=Math.max(1,r):"fanOut"===this.mode?i/=Math.max(1,s):i/=Math.max(1,(r+s)/2),"normal"===this.distribution){
const n=Math.sqrt(i);if("float32"!==(t=t||"float32")&&"int32"!==t){
throw new Cp(`${this.getClassName()} does not support dType ${t}.`);
}return ku(e,0,n,t,this.seed);
}{const n=Math.sqrt(3*i);return ru(e,-n,n,t,this.seed);}
}getConfig(){
return{scale:this.scale,mode:this.mode,distribution:this.distribution,seed:this.seed};
}
}jf.className="VarianceScaling",Oi(jf);class Hf extends jf{
constructor(e){
super({scale:1,mode:"fanAvg",distribution:"uniform",seed:null==e?null:e.seed});
}getClassName(){
return jf.className;
}
}Hf.className="GlorotUniform",Oi(Hf);class qf extends jf{
constructor(e){
super({scale:1,mode:"fanAvg",distribution:"normal",seed:null==e?null:e.seed});
}getClassName(){
return jf.className;
}
}qf.className="GlorotNormal",Oi(qf);class Kf extends jf{
constructor(e){
super({scale:2,mode:"fanIn",distribution:"normal",seed:null==e?null:e.seed});
}getClassName(){
return jf.className;
}
}Kf.className="HeNormal",Oi(Kf);class Xf extends jf{
constructor(e){
super({scale:2,mode:"fanIn",distribution:"uniform",seed:null==e?null:e.seed});
}getClassName(){
return jf.className;
}
}Xf.className="HeUniform",Oi(Xf);class Yf extends jf{
constructor(e){
super({scale:1,mode:"fanIn",distribution:"normal",seed:null==e?null:e.seed});
}getClassName(){
return jf.className;
}
}Yf.className="LeCunNormal",Oi(Yf);class Zf extends jf{
constructor(e){
super({scale:1,mode:"fanIn",distribution:"uniform",seed:null==e?null:e.seed});
}getClassName(){
return jf.className;
}
}Zf.className="LeCunUniform",Oi(Zf);class Jf extends Lf{
constructor(e){
super(),this.DEFAULT_GAIN=1,this.ELEMENTS_WARN_SLOW=2e3,this.gain=null==e.gain?this.DEFAULT_GAIN:e.gain,this.seed=e.seed;
}apply(e,t){
return xi((()=>{
if(e.length<2){
throw new Cp("Shape must be at least 2D.");
}if("int32"!==t&&"float32"!==t&&void 0!==t){
throw new TypeError(`Unsupported data type ${t}.`);
}const n=m(e.slice(0,-1)),r=e[e.length-1],s=n*r;s>this.ELEMENTS_WARN_SLOW&&console.warn(`Orthogonal initializer is being called on a matrix with more than ${this.ELEMENTS_WARN_SLOW} (${s}) elements: Slowness may result.`);const i=$f([Math.max(r,n),Math.min(r,n)],0,1,t,this.seed),a=Tl.qr(i,!1);let o=a[0];const u=a[1].flatten().stridedSlice([0],[Math.min(r,n)*Math.min(r,n)],[Math.min(r,n)+1]);return o=Ci(o,u.sign()),n<r&&(o=o.transpose()),Ci(Ri(this.gain),o.reshape(e));
}));
}getConfig(){
return{gain:this.gain,seed:this.seed};
}
}Jf.className="Orthogonal",Oi(Jf);const Qf={constant:"Constant",glorotNormal:"GlorotNormal",glorotUniform:"GlorotUniform",heNormal:"HeNormal",heUniform:"HeUniform",identity:"Identity",leCunNormal:"LeCunNormal",leCunUniform:"LeCunUniform",ones:"Ones",orthogonal:"Orthogonal",randomNormal:"RandomNormal",randomUniform:"RandomUniform",truncatedNormal:"TruncatedNormal",varianceScaling:"VarianceScaling",zeros:"Zeros"};function em(e,t={}){
return zp(e,Di.getMap().classNameMap,t,"initializer");
}function tm(e){
return Mp(e);
}function nm(e){
if("string"==typeof e){
const t=e in Qf?Qf[e]:e;if("GlorotNormal"===t){
return new qf;
}if("GlorotUniform"===t){
return new Hf;
}if("HeNormal"===t){
return new Kf;
}if("HeUniform"===t){
return new Xf;
}if("LeCunNormal"===t){
return new Yf;
}if("LeCunUniform"===t){
return new Zf;
}{const e={};return e.className=t,e.config={},em(e);}
}return e instanceof Lf?e:em(e);
}function rm(e){
return Array.isArray(e)&&Array.isArray(e[0]);
}function sm(e){
return 0===e.length?[]:Array.isArray(e[0])?e:[e];
}function im(e){
let t;if(Array.isArray(e)){
if(1!==e.length){
throw new Sp(`Expected Tensor length to be 1; got ${e.length}`);
}t=e[0];
}else {
t=e;
}return t;
}function am(e){
if(Array.isArray(e)&&Array.isArray(e[0])){
if(1===e.length){
return e[0];
}throw new Sp(`Expected exactly 1 Shape; got ${e.length}`);
}return e;
}function om(e){
let t=0;for(const n of e){
0===n.shape.length?t+=1:t+=n.shape.reduce(((e,t)=>e*t));
}return t;
}const um="Variable";class lm{
constructor(e,t="float32",n=um,r=!0,s=null){
this.dtype=null==t?"float32":t,this.shape=e.shape,this.id=Kp(),n=null==n?um:n,this.originalName=lf(n),this.name=cf(this.originalName),this.trainable_=r,this.constraint=s,this.val=function(e,t=!0,n,r){
return vs.makeVariable(e,t,n,r);
}(e,this.trainable_,this.name,this.dtype);
}read(){
return this.assertNotDisposed(),this.val;
}write(e){
return this.assertNotDisposed(),function(e,t){
if(e.shape.toString()!==t.shape.toString()){
throw new Error("Shape mismatch: "+JSON.stringify(e.shape)+" vs. "+JSON.stringify(t.shape));
}
}(this.val,e),this.val.id!==e.id&&(this.val.assign(e),null!=this.constraint&&this.val.assign(this.constraint.apply(this.val))),this;
}dispose(){
this.assertNotDisposed(),this.val.dispose();
}assertNotDisposed(){
if(this.val.isDisposed){
throw new Error(`LayersVariable ${this.name} is already disposed.`);
}
}get trainable(){
return this.trainable_;
}set trainable(e){
this.trainable_=e,this.val.trainable=e;
}
}function cm(e){
return e.map((e=>e.read()));
}function hm(e){
e.forEach((e=>{
e[0].write(e[1]);
}));
}class dm{
constructor(e){
this.dtype=e.dtype,this.shape=e.shape,null!=e.shape?this.ndim=e.shape.length:this.ndim=e.ndim,this.maxNDim=e.maxNDim,this.minNDim=e.minNDim,this.axes=e.axes||{};
}
}class pm{
constructor(e,t,n,r,s,i,a){
this.dtype=e,this.shape=t,this.sourceLayer=n,this.inputs=r,this.callArgs=s,this.outputTensorIndex=a,this.id=Kp(),null!=i&&(this.originalName=lf(i),this.name=cf(this.originalName)),this.rank=t.length;
}
}let fm=0;class mm{
constructor(e,t){
this.callArgs=t,this.id=fm++,this.outboundLayer=e.outboundLayer,this.inboundLayers=e.inboundLayers,this.nodeIndices=e.nodeIndices,this.tensorIndices=e.tensorIndices,this.inputTensors=e.inputTensors,this.outputTensors=e.outputTensors,this.inputMasks=e.inputMasks,this.outputMasks=e.outputMasks,this.inputShapes=e.inputShapes,this.outputShapes=e.outputShapes;for(const t of e.inboundLayers){
null!=t&&t.outboundNodes.push(this);
}e.outboundLayer.inboundNodes.push(this);
}getConfig(){
const e=[];for(const t of this.inboundLayers){
null!=t?e.push(t.name):e.push(null);
}return{outboundLayer:this.outboundLayer?this.outboundLayer.name:null,inboundLayers:e,nodeIndices:this.nodeIndices,tensorIndices:this.tensorIndices};
}
}let gm=0;class bm extends _i{
constructor(e={}){
super(),this._callHook=null,this._addedWeightNames=[],this._stateful=!1,this.id=gm++,this.activityRegularizer=null,this.inputSpec=null,this.supportsMasking=!1,this._trainableWeights=[],this._nonTrainableWeights=[],this._losses=[],this._updates=[],this._built=!1,this.inboundNodes=[],this.outboundNodes=[];let t=e.name;if(!t){
const e=this.getClassName();t=_p(e)+"_"+Yp(e);
}if(this.name=t,this.trainable_=null==e.trainable||e.trainable,null!=e.inputShape||null!=e.batchInputShape){
let t;if(null!=e.batchInputShape){
t=e.batchInputShape;
}else if(null!=e.inputShape){
let n=null;null!=e.batchSize&&(n=e.batchSize),t=[n].concat(e.inputShape);
}this.batchInputShape=t;let n=e.dtype;null==n&&(n=e.inputDType),null==n&&(n="float32"),this.dtype=n;
}null!=e.weights?this.initialWeights=e.weights:this.initialWeights=null,this._refCount=null,this.fastWeightInitDuringBuild=!1;
}static nodeKey(e,t){
return e.name+"_ib-"+t.toString();
}getNodeAtIndex(e,t){
if(0===this.inboundNodes.length){
throw new Ip(`The layer has never been called and thus has no defined ${t}.`);
}if(this.inboundNodes.length<=e){
throw new Sp(`Asked to get ${t} at node ${e}, but the layer has only ${this.inboundNodes.length} inbound nodes.`);
}return this.inboundNodes[e];
}getInputAt(e){
return Ap(this.getNodeAtIndex(e,"input").inputTensors);
}getOutputAt(e){
return Ap(this.getNodeAtIndex(e,"output").outputTensors);
}get input(){
if(this.inboundNodes.length>1){
throw new kp(`Layer ${this.name} has multiple inbound nodes, hence the notion of "layer input" is ill-defined. Use \`getInputAt(nodeIndex)\` instead.`);
}if(0===this.inboundNodes.length){
throw new kp(`Layer ${this.name} is not connected, no input to return.`);
}return Ap(this.getNodeAtIndex(0,"input").inputTensors);
}get output(){
if(0===this.inboundNodes.length){
throw new kp(`Layer ${this.name} has no inbound nodes.`);
}if(this.inboundNodes.length>1){
throw new kp(`Layer ${this.name} has multiple inbound nodes, hence the notion of "layer output" is ill-defined. Use \`getOutputAt(nodeIndex)\` instead.`);
}return Ap(this.getNodeAtIndex(0,"output").outputTensors);
}get losses(){
return this._losses;
}calculateLosses(){
return this.losses.map((e=>e()));
}get updates(){
return this._updates;
}get built(){
return this._built;
}set built(e){
this._built=e;
}get trainable(){
return this.trainable_;
}set trainable(e){
this._trainableWeights.forEach((t=>t.trainable=e)),this.trainable_=e;
}get trainableWeights(){
return this.trainable_?this._trainableWeights.filter((e=>e.trainable)):[];
}set trainableWeights(e){
this._trainableWeights=e;
}get nonTrainableWeights(){
return this.trainable?this._trainableWeights.filter((e=>!e.trainable)).concat(this._nonTrainableWeights):this._trainableWeights.concat(this._nonTrainableWeights);
}set nonTrainableWeights(e){
this._nonTrainableWeights=e;
}get weights(){
return this.trainableWeights.concat(this.nonTrainableWeights);
}get stateful(){
return this._stateful;
}resetStates(){
if(!this.stateful){
throw new Error("Cannot call the resetStates() method of a non-stateful Layer object.");
}
}assertInputCompatibility(e){
if(e=Fp(e),null==this.inputSpec||0===this.inputSpec.length){
return;
}const t=Fp(this.inputSpec);if(e.length!==t.length){
throw new Sp(`Layer ${this.name} expects ${t.length} inputs, but it received ${e.length} input tensors. Input received: ${e}`);
}for(let n=0;n<e.length;n++){
const r=e[n],s=t[n];if(null==s){
continue;
}const i=r.rank;if(null!=s.ndim&&i!==s.ndim){
throw new Sp(`Input ${n} is incompatible with layer ${this.name}: expected ndim=${s.ndim}, found ndim=${i}`);
}if(null!=s.maxNDim&&i>s.maxNDim){
throw new Sp(`Input ${n} is incompatible with layer ${this.name}: expected max_ndim=${s.maxNDim}, found ndim=${i}`);
}if(null!=s.minNDim&&i<s.minNDim){
throw new Sp(`Input ${n} is incompatible with layer ${this.name}: expected min_ndim=${s.minNDim}, found ndim=${i}.`);
}if(null!=s.dtype&&r.dtype!==s.dtype){
throw new Sp(`Input ${n} is incompatible with layer ${this.name} : expected dtype=${s.dtype}, found dtype=${r.dtype}.`);
}if(s.axes){
const e=r.shape;for(const t in s.axes){
const r=Number(t),i=s.axes[t],a=r>=0?e[r]:e[e.length+r];if(null!=i&&-1===[i,null].indexOf(a)){
throw new Sp(`Input ${n} is incompatible with layer ${this.name}: expected axis ${r} of input shape to have value ${i} but got shape ${e}.`);
}
}
}if(null!=s.shape){
for(let e=0;e<s.shape.length;++e){
const t=s.shape[e],i=r.shape[e];if(null!=t&&null!=i&&t!==i){
throw new Sp(`Input ${n} is incompatible with layer ${this.name}: expected shape=${s.shape}, found shape=${r.shape}.`);
}
}
}
}
}call(e,t){
return e;
}invokeCallHook(e,t){
null!=this._callHook&&this._callHook(e,t);
}setCallHook(e){
this._callHook=e;
}clearCallHook(){
this._callHook=null;
}apply(e,t){
t=t||{},this.assertNotDisposed();const n=Fp(e);let r=!0;for(const e of n){
if(!(e instanceof pm)){
r=!1;break;
}
}let s=!0;for(const e of n){
if(e instanceof pm){
s=!1;break;
}
}if(r===s){
throw new Sp("Arguments to apply() must be all SymbolicTensors or all Tensors");
}return uf(this.name,(()=>{
if(!this.built){
this.assertInputCompatibility(e);const t=[];for(const n of Fp(e)){
t.push(n.shape);
}this.build(Ap(t)),this.built=!0,this.initialWeights&&this.setWeights(this.initialWeights),null===this._refCount&&s&&(this._refCount=1);
}if(this.assertInputCompatibility(e),s){
let r=this.call(e,t);const s=Fp(r),i=[];for(let e of s){
-1!==n.indexOf(e)&&(e=e.clone()),i.push(e);
}if(r=Ap(i),null!=this.activityRegularizer){
throw new Cp("Layer invocation in the presence of activity regularizer(s) is not supported yet.");
}return r;
}{const n=function(e){
e=Fp(e);const t=[];for(const n of e){
t.push(n.shape);
}return Ap(t);
}(e),r=this.computeOutputShape(n);let s;const i="float32";if(this.warnOnIncompatibleInputShape(Array.isArray(e)?n[0]:n),s=null!=r&&r.length>0&&Array.isArray(r[0])?r.map(((n,r)=>new pm(i,n,this,Fp(e),t,this.name,r))):new pm(i,r,this,Fp(e),t,this.name),this.addInboundNode(e,s,null,null,n,r,t),this._refCount++,null!=this.activityRegularizer){
throw new Cp("Layer invocation in the presence of activity regularizer(s) is not supported yet.");
}return s;}
}));
}warnOnIncompatibleInputShape(e){
if(null!=this.batchInputShape){
if(e.length!==this.batchInputShape.length){
console.warn(`The rank of the input tensor provided (shape: ${JSON.stringify(e)}) does not match that of the batchInputShape (${JSON.stringify(this.batchInputShape)}) of the layer ${this.name}`);
}else{
let t=!1;this.batchInputShape.forEach(((n,r)=>{
null!=n&&null!=e[r]&&e[r]!==n&&(t=!0);
})),t&&console.warn(`The shape of the input tensor (${JSON.stringify(e)}) does not match the expectation of layer ${this.name}: ${JSON.stringify(this.batchInputShape)}`);
}
}
}get outputShape(){
if(null==this.inboundNodes||0===this.inboundNodes.length){
throw new kp(`The layer ${this.name} has never been called and thus has no defined output shape.`);
}const e=[];for(const t of this.inboundNodes){
const n=JSON.stringify(t.outputShapes);-1===e.indexOf(n)&&e.push(n);
}if(1===e.length){
const e=this.inboundNodes[0].outputShapes;return Array.isArray(e)&&Array.isArray(e[0])&&1===e.length?e[0]:e;
}throw new kp(`The layer ${this.name} has multiple inbound nodes with different output shapes. Hence the notion of "output shape" is ill-defined for the layer.`);
}countParams(){
if(!this.built){
throw new Ip(`You tried to call countParams() on ${this.name}, but the layer is not built yet. Build it first by calling build(batchInputShape).`);
}return om(this.weights);
}build(e){
this.built=!0;
}getWeights(e=!1){
return cm(e?this.trainableWeights:this.weights);
}setWeights(e){
xi((()=>{
const t=this.weights;if(t.length!==e.length){
throw new Sp(`You called setWeights(weights) on layer "${this.name}" with a weight list of length ${e.length}, but the layer was expecting ${t.length} weights. Provided weights: ${e}...`);
}if(0===t.length){
return;
}const n=[],r=cm(t);for(let s=0;s<r.length;++s){
const i=r[s],a=t[s],o=e[s];if(!g(i.shape,o.shape)){
throw new Sp(`Layer weight shape ${i.shape} not compatible with provided weight shape ${o.shape}`);
}n.push([a,o]);
}hm(n);
}));
}addWeight(e,t,n,r,s,i,a,o){
if(-1!==this._addedWeightNames.indexOf(e)){
throw new Sp(`Duplicate weight name ${e} for layer ${this.name}`);
}this._addedWeightNames.push(e),null==n&&(n="float32"),this.fastWeightInitDuringBuild&&(r=null!=o?o():nm("zeros"));const u=r.apply(t,n),l=new lm(u,n,e,i,a);return u.dispose(),null!=s&&this.addLoss((()=>s.apply(l.read()))),null==i&&(i=!0),i?this._trainableWeights.push(l):this._nonTrainableWeights.push(l),l;
}setFastWeightInitDuringBuild(e){
this.fastWeightInitDuringBuild=e;
}addLoss(e){
null==e||Array.isArray(e)&&0===e.length||(e=Fp(e),void 0!==this._losses&&null!==this._losses&&this.losses.push(...e));
}computeOutputShape(e){
return e;
}computeMask(e,t){
if(!this.supportsMasking){
if(null!=t){
if(!Array.isArray(t)){
throw new TypeError(`Layer ${this.name} does not support masking, but was passed an inputMask.`);
}t.forEach((e=>{
if(null!=e){
throw new TypeError(`Layer ${this.name} does not support masking, but was passed an inputMask.`);
}
}));
}return null;
}return t;
}addInboundNode(e,t,n,r,s,i,a=null){
const o=Fp(e);t=Fp(t),n=Fp(n),r=Fp(r),s=sm(s),i=sm(i);const u=[],l=[],c=[];for(const e of o){
u.push(e.sourceLayer),l.push(e.nodeIndex),c.push(e.tensorIndex);
}new mm({outboundLayer:this,inboundLayers:u,nodeIndices:l,tensorIndices:c,inputTensors:o,outputTensors:t,inputMasks:n,outputMasks:r,inputShapes:s,outputShapes:i},a);for(let e=0;e<t.length;e++){
t[e].sourceLayer=this,t[e].nodeIndex=this.inboundNodes.length-1,t[e].tensorIndex=e;
}
}getConfig(){
const e={name:this.name,trainable:this.trainable};return null!=this.batchInputShape&&(e.batchInputShape=this.batchInputShape),null!=this.dtype&&(e.dtype=this.dtype),e;
}disposeWeights(){
return this.weights.forEach((e=>e.dispose())),this.weights.length;
}assertNotDisposed(){
if(0===this._refCount){
throw new Error(`Layer '${this.name}' is already disposed.`);
}
}dispose(){
if(!this.built){
throw new Error(`Cannot dispose Layer ${this.name} because it has not been built yet.`);
}if(null===this._refCount){
throw new Error(`Cannot dispose Layer ${this.name} because it has not been used yet.`);
}this.assertNotDisposed();let e=0;return 0==--this._refCount&&(e=this.disposeWeights()),{refCountAfterDispose:this._refCount,numDisposedVariables:e};
}
}function xm(e,t,n){
if((null==t||null!=n&&n>0)&&(t=e.sourceLayer,n=e.nodeIndex),0===t.inboundNodes.length){
return[e];
}{const e=t.inboundNodes[n];if(0===e.inboundLayers.length){
return e.inputTensors;
}{const t=[];for(let n=0;n<e.inboundLayers.length;n++){
const r=xm(e.inputTensors[n],e.inboundLayers[n],e.nodeIndices[n]);for(const e of r){
-1===t.indexOf(e)&&t.push(e);
}
}return t;}}
}class ym extends bm{
constructor(e){
if(super({dtype:e.dtype,name:null!=e.name?e.name:Yp("input").toString()}),null==e.batchSize&&(e.batchSize=null),null==e.sparse&&(e.sparse=!1),this.trainable=!1,this.built=!0,this.sparse=e.sparse,null!=e.inputShape&&null!=e.batchInputShape){
throw new Sp("Only provide the inputShape OR batchInputShape argument to inputLayer, not both at the same time.");
}let t=e.batchInputShape;if(null==t){
if(null==e.inputShape){
throw new Sp("An InputLayer should be passed either a `batchInputShape` or an `inputShape`.");
}t=[e.batchSize].concat(e.inputShape);
}else if(null!=e.batchSize){
throw new Sp("Cannot specify batchSize if batchInputShape is specified when creating an InputLayer.");
}const n=e.dtype||"float32";this.batchInputShape=t,this.dtype=n,this.inputSpec=[{shape:t}];const r=new pm(this.dtype,this.batchInputShape,this,[],{},this.name);r.nodeIndex=0,r.tensorIndex=0,new mm({outboundLayer:this,inboundLayers:[],nodeIndices:[],tensorIndices:[],inputTensors:[r],outputTensors:[r],inputMasks:[null],outputMasks:[null],inputShapes:[t],outputShapes:[t]});
}apply(e,t){
throw new Sp(`Cannot pass any input to an InputLayer's apply() method. InputLayer name: ${this.name}`);
}dispose(){
return{refCountAfterDispose:this._refCount,numDisposedVariables:0};
}getConfig(){
return{batchInputShape:this.batchInputShape,dtype:this.dtype,sparse:this.sparse,name:this.name};
}
}ym.className="InputLayer",Oi(ym);class wm{
constructor(e){
if(this.id2Value={},this.id2Mask={},this.name2Id={},e instanceof wm){
for(const t in e.id2Value){
this.id2Value[t]=e.id2Value[t],t in e.id2Mask&&(this.id2Mask[t]=e.id2Mask[t]);
}
}else{
if(null==e){
return;
}for(const t of e){
this.add(t.key,t.value);
}
}
}add(e,t,n){
if(null!=this.id2Value[e.id]){
throw new Sp(`Duplicate key: name=${e.name}, id=${e.id}`);
}return this.id2Value[e.id]=function(e,t){
if(null==e.dtype||e.dtype===t.dtype){
return t;
}try{
return fi(t,e.dtype);
}catch(n){
throw new Sp(`The dtype of the feed (${t.dtype}) can not be cast to the dtype of the key '${e.name}' (${e.dtype}).`);
}
}(e,t),this.name2Id[e.name]=e.id,null!=n&&(this.id2Mask[e.id]=n),this;
}addFeed(e){
this.add(e.key,e.value);
}hasKey(e){
return null!=this.id2Value[e.id];
}names(){
return Object.keys(this.name2Id);
}getValue(e){
if(e instanceof pm){
if(null==this.id2Value[e.id]){
throw new Sp(`Nonexistent key: ${e.name}`);
}return this.id2Value[e.id];
}{const t=this.name2Id[e];if(null==t){
throw new Sp(`Feed dict has no SymbolicTensor name: ${e}`);
}return this.id2Value[t];}
}getMask(e){
if(e instanceof pm){
if(null==this.id2Value[e.id]){
throw new Sp(`Nonexistent key: ${e.name}`);
}return this.id2Mask[e.id];
}{const t=this.name2Id[e];if(null==t){
throw new Sp(`Feed dict has no SymbolicTensor name: ${e}`);
}return this.id2Mask[t];}
}disposeMasks(){
null!=this.id2Mask&&yi(this.id2Mask);
}
}const vm=new $p,km=new $p;function Im(e,t,n,r){
const s=null!=n&&n.training,i=Array.isArray(e),a=i?e:[e],o=a.map((e=>e.name)),u=[],l=t.names();for(const e of o){
-1!==l.indexOf(e)?u.push(t.getValue(e)):u.push(null);
}null!=r&&(r.maxNumTensors=-1/0,r.minNumTensors=1/0);const c=o.join(",")+"|"+t.names().sort().join(",");let h,p=vm.get(c);if(null==p){
const e=function(e,t){
d(null!=e&&e.length>0,(()=>"Expected at least one fetch, got none"));let n=[],r={};if(1===e.length){
const s=Cm(e[0],t);n=s.sorted,r=s.recipientMap;
}else{
const s=new Set;for(const i of e){
const{sorted:e,recipientMap:a}=Cm(i,t);for(const t of e){
s.has(t.name)||(n.push(t),s.add(t.name));
}for(const e in a){
null==r[e]&&(r[e]=new Set),a[e].forEach((t=>r[e].add(t)));
}
}
}return{sorted:n,recipientCounts:Sm(r)};
}(a,t);p=e.sorted,h=e.recipientCounts,vm.put(c,p),km.put(c,h);
}h={},s||Object.assign(h,km.get(c));const f=new wm(t);for(let e=0;e<p.length;++e){
if(null!=r){
const e=bi().numTensors;e>r.maxNumTensors&&(r.maxNumTensors=e),e<r.minNumTensors&&(r.minNumTensors=e);
}const i=p[e],a=i.sourceLayer;if(a instanceof ym){
continue;
}const l=[],c=[],d=[];let m=!1;for(const e of i.inputs){
const n=f.getValue(e),r=f.getMask(e);l.push(n),c.push(r),null!=r&&(m=!0),s||(h[e.name]--,0!==h[e.name]||t.hasKey(e)||-1!==o.indexOf(e.name)||n.isDisposed||!0===e.sourceLayer.stateful||d.push(n));
}m&&((n=n||{}).mask=c[0]);const g=Fp(a.apply(l,n));let b=null;a.supportsMasking&&(b=a.computeMask(l,c));const x=Nm(i),y=Array.isArray(x)?x:[x];for(let e=0;e<y.length;++e){
f.hasKey(y[e])||f.add(y[e],g[e],Array.isArray(b)?b[0]:b);const t=o.indexOf(y[e].name);-1!==t&&(u[t]=g[e]);
}s||yi(d);
}return f.disposeMasks(),i?u:u[0];
}function Sm(e){
const t={};for(const n in e){
t[n]=e[n].size;
}return t;
}function Cm(e,t){
const n=new Set,r=[],s={};for(const e of t.names()){
n.add(e);
}const i=[],a=[];for(i.push(e);i.length>0;){
const e=i[i.length-1];if(n.has(e.name)){
i.pop();continue;
}const t=a[a.length-1]===i.length-1;if(0===e.inputs.length||t){
i.pop(),r.push(e),n.add(e.name),t&&a.pop();
}else{
a.push(i.length-1);for(const t of e.inputs){
null==s[t.name]&&(s[t.name]=new Set),s[t.name].add(e.name),n.has(t.name)||i.push(t);
}
}
}return{sorted:r,recipientMap:s};
}function Nm(e){
let t;if(1===e.sourceLayer.inboundNodes.length){
t=e.sourceLayer.output;
}else{
let n=null;for(let t=0;t<e.sourceLayer.inboundNodes.length;++t){
for(const r of e.sourceLayer.inboundNodes[t].outputTensors){
if(r.id===e.id){
n=t;break;
}
}
}t=e.sourceLayer.getOutputAt(n);
}return t;
}function $m(e,t){
return xi((()=>Ni($o(Ci(e,e),t,!0))));
}H().registerFlag("TOPOLOGICAL_SORT_CACHE_MAX_ENTRIES",(()=>100),(function(e){
null!=vm&&vm.setMaxEntries(e),null!=km&&km.setMaxEntries(e);
}));class Tm extends _i{
getConfig(){
return{};
}
}class Em extends Tm{
constructor(e){
super(),this.defaultMaxValue=2,this.defaultAxis=0,this.maxValue=null!=e.maxValue?e.maxValue:this.defaultMaxValue,this.axis=null!=e.axis?e.axis:this.defaultAxis;
}apply(e){
return xi((()=>{
const t=$m(e,this.axis),n=Za(t,0,this.maxValue);return Ci(e,Si(n,ki(xf(),t)));
}));
}getConfig(){
return{maxValue:this.maxValue,axis:this.axis};
}
}Em.className="MaxNorm",Oi(Em);class Rm extends Tm{
constructor(e){
super(),this.defaultAxis=0,this.axis=null!=e.axis?e.axis:this.defaultAxis;
}apply(e){
return xi((()=>Si(e,ki(xf(),$m(e,this.axis)))));
}getConfig(){
return{axis:this.axis};
}
}Rm.className="UnitNorm",Oi(Rm);class Am extends Tm{
apply(e){
return iu(e);
}
}Am.className="NonNeg",Oi(Am);class Fm extends Tm{
constructor(e){
super(),this.defaultMinValue=0,this.defaultMaxValue=1,this.defaultRate=1,this.defaultAxis=0,this.minValue=null!=e.minValue?e.minValue:this.defaultMinValue,this.maxValue=null!=e.maxValue?e.maxValue:this.defaultMaxValue,this.rate=null!=e.rate?e.rate:this.defaultRate,this.axis=null!=e.axis?e.axis:this.defaultAxis;
}apply(e){
return xi((()=>{
const t=$m(e,this.axis),n=ki(Ci(this.rate,Za(t,this.minValue,this.maxValue)),Ci(1-this.rate,t));return Ci(e,Si(n,ki(xf(),t)));
}));
}getConfig(){
return{minValue:this.minValue,maxValue:this.maxValue,rate:this.rate,axis:this.axis};
}
}Fm.className="MinMaxNorm",Oi(Fm);const _m={maxNorm:"MaxNorm",minMaxNorm:"MinMaxNorm",nonNeg:"NonNeg",unitNorm:"UnitNorm"};function Dm(e){
return Mp(e);
}function Om(e,t={}){
return zp(e,Di.getMap().classNameMap,t,"constraint");
}function Mm(e){
return null==e?null:"string"==typeof e?Om({className:e in _m?_m[e]:e,config:{}}):e instanceof Tm?e:Om(e);
}async function Lm(e){
if(null==e){
return;
}const t=[],n=[],r=[];for(const s in e){
const i=e[s];if("number"!=typeof i){
const e=i;t.push(e.data()),n.push(s),r.push(e);
}
}if(t.length>0){
const s=await Promise.all(t);for(let t=0;t<s.length;++t){
e[n[t]]=s[t][0];
}yi(r);
}
}function zm(e){
if(null!=e){
for(const t in e){
const n=e[t];"number"!=typeof n&&n.dispose();
}
}
}var Pm;!function(e){
e[e.SILENT=0]="SILENT",e[e.VERBOSE=1]="VERBOSE";
}(Pm||(Pm={}));class Bm{
constructor(){
this.validationData=null;
}setParams(e){
this.params=e;
}async onEpochBegin(e,t){}async onEpochEnd(e,t){}async onBatchBegin(e,t){}async onBatchEnd(e,t){}async onTrainBegin(e){}async onTrainEnd(e){}setModel(e){}
}class Um{
constructor(e,t=10){
null==e&&(e=[]),this.callbacks=e,this.queueLength=t;
}append(e){
this.callbacks.push(e);
}setParams(e){
for(const t of this.callbacks){
t.setParams(e);
}
}setModel(e){
for(const t of this.callbacks){
t.setModel(e);
}
}async onEpochBegin(e,t){
null==t&&(t={});for(const n of this.callbacks){
await n.onEpochBegin(e,t);
}
}async onEpochEnd(e,t){
null==t&&(t={});for(const n of this.callbacks){
await n.onEpochEnd(e,t);
}
}async onBatchBegin(e,t){
null==t&&(t={});for(const n of this.callbacks){
await n.onBatchBegin(e,t);
}
}async onBatchEnd(e,t){
null==t&&(t={});for(const n of this.callbacks){
await n.onBatchEnd(e,t);
}
}async onTrainBegin(e){
null==e&&(e={});for(const t of this.callbacks){
await t.onTrainBegin(e);
}
}async onTrainEnd(e){
null==e&&(e={});for(const t of this.callbacks){
await t.onTrainEnd(e);
}
}
}class Wm extends Bm{
constructor(){
super();
}async onEpochBegin(e){
this.seen=0,this.totals={};
}async onBatchEnd(e,t){
null==t&&(t={});const n=null==t.size?0:t.size;this.seen+=n;for(const e in t){
const r=t[e];if("number"==typeof r){
this.totals.hasOwnProperty(e)||(this.totals[e]=0),this.totals[e]=this.totals[e]+r*n;
}else{
let t;e in this.totals?t=this.totals[e]:this.totals[e]=0;const s=xi((()=>ki(this.totals[e],Ci(r,n))));this.totals[e]=s,null!=t&&t.dispose();
}
}
}async onEpochEnd(e,t){
if(null!=t){
for(const e of this.params.metrics){
null!=this.totals[e]&&("number"==typeof this.totals[e]?t[e]=this.totals[e]/this.seen:xi((()=>{
const n=Ci(Si(1,this.seen),this.totals[e]);t[e]=n,this.totals[e].dispose(),wi(t[e]);
})));
}
}
}
}class Vm extends Bm{
async onTrainBegin(e){
this.epoch=[],this.history={};
}async onEpochEnd(e,t){
null==t&&(t={}),this.epoch.push(e);for(const e in t){
null==this.history[e]&&(this.history[e]=[]),this.history[e].push(t[e]);
}
}async syncData(){
const e=[],t=[],n=[];for(const r in this.history){
const s=this.history[r];for(let i=0;i<s.length;++i){
if("number"!=typeof s[i]){
const a=s[i];e.push(a.data()),t.push(r),n.push(i);
}
}
}const r=await Promise.all(e);for(let e=0;e<r.length;++e){
this.history[t[e]][n[e]].dispose(),this.history[t[e]][n[e]]=r[e][0];
}
}
}class Gm extends Bm{
constructor(e,t){
if(super(),this.currentEpoch=0,this.nowFunc=e.nowFunc,this.nextFrameFunc=e.nextFrameFunc||Al,this.yieldEvery=t||"auto","auto"===this.yieldEvery&&(this.yieldEvery=125),"never"===this.yieldEvery&&null!=e.onYield){
throw new Error("yieldEvery is `never` but you provided an `onYield` callback. Either change `yieldEvery` or remove the callback");
}E(this.yieldEvery)&&(this.maybeWait=function(e,t,n){
let r,s=null!=n?n():Dr();return(...i)=>{
const a=null!=n?n():Dr();return a-s<t||(s=a,r=e(...i)),r;
};
}(this.maybeWait.bind(this),this.yieldEvery,this.nowFunc)),this.trainBegin=e.onTrainBegin,this.trainEnd=e.onTrainEnd,this.epochBegin=e.onEpochBegin,this.epochEnd=e.onEpochEnd,this.batchBegin=e.onBatchBegin,this.batchEnd=e.onBatchEnd,this.yield=e.onYield;
}async maybeWait(e,t,n){
const r=[];null!=this.yield&&(await Lm(n),r.push(this.yield(e,t,n))),r.push(this.nextFrameFunc()),await Promise.all(r);
}async onEpochBegin(e,t){
this.currentEpoch=e,null!=this.epochBegin&&(await Lm(t),await this.epochBegin(e,t));
}async onEpochEnd(e,t){
const n=[];null!=this.epochEnd&&(await Lm(t),n.push(this.epochEnd(e,t))),"epoch"===this.yieldEvery&&n.push(this.nextFrameFunc()),await Promise.all(n);
}async onBatchBegin(e,t){
null!=this.batchBegin&&(await Lm(t),await this.batchBegin(e,t));
}async onBatchEnd(e,t){
const n=[];null!=this.batchEnd&&(await Lm(t),n.push(this.batchEnd(e,t))),"batch"===this.yieldEvery?n.push(this.nextFrameFunc()):E(this.yieldEvery)&&n.push(this.maybeWait(this.currentEpoch,e,t)),await Promise.all(n);
}async onTrainBegin(e){
null!=this.trainBegin&&(await Lm(e),await this.trainBegin(e));
}async onTrainEnd(e){
null!=this.trainEnd&&(await Lm(e),await this.trainEnd(e));
}
}function jm(e,t){
return null==e&&(e={}),e instanceof Bm?[e]:Array.isArray(e)&&e[0]instanceof Bm?e:Fp(e).map((e=>new Gm(e,t)));
}class Hm{
constructor(){}static registerCallbackConstructor(e,t){
d(e>=0&&Number.isInteger(e),(()=>`Verbosity level is expected to be an integer >= 0, but got ${e}`)),Hm.checkForDuplicate(t),null==Hm.constructors[e]&&(Hm.constructors[e]=[]),Hm.constructors[e].push(t);
}static checkForDuplicate(e){
for(const t in Hm.constructors){
Hm.constructors[+t].forEach((t=>{
if(t===e){
throw new Sp("Duplicate callback constructor.");
}
}));
}
}static clear(){
Hm.constructors={};
}static createCallbacks(e){
const t=[];for(const n in Hm.constructors){
const r=+n;e>=r&&t.push(...Hm.constructors[r]);
}return t.map((e=>new e));
}
}function qm(e,t,n,r,s,i,a,o,u){
const l=new Vm,c=[new Wm,...Hm.createCallbacks(t)];null!=e&&c.push(...e),c.push(l);const h=new Um(c);return h.setParams({epochs:n,initialEpoch:r,samples:s,steps:i,batchSize:a,verbose:t,doValidation:o,metrics:u}),{callbackList:h,history:l};
}function Km(e,t={},n=!1){
return zp(e,Di.getMap().classNameMap,t,"layer",n);
}function Xm(e,t){
return xi((()=>{
"float32"!==e.dtype&&(e=fi(e,"float32"));const n=$o(Rf(e),t,!0),r=zi(n.shape,xf()),s=Ni(qi(n,r));return Si(e,s);
}));
}function Ym(e,t){
return xi((()=>_o(Rf(Ui(t,e)),-1)));
}function Zm(e,t){
return xi((()=>_o(Vi(Ui(t,e)),-1)));
}function Jm(e,t){
return xi((()=>{
const n=Ui(e,t),r=Za(Vi(e),xf(),Number.MAX_VALUE),s=Vi(Si(n,r));return Ci(100,_o(s,-1));
}));
}function Qm(e,t,n=!1){
return xi((()=>{
if(n){
t=mu(t);
}else{
const e=$o(t,t.shape.length-1,!0);t=Si(t,e);
}return t=Za(t,xf(),1-xf()),jo($o(Ci(fi(e,"float32"),So(t)),t.shape.length-1));
}));
}function eg(e,t,n=!1){
return xi((()=>{
const r=fi(yo(function(e){
const t=[pf(e.shape)];return Va(e,t);
}(e)),"int32"),s=(t=Za(t,xf(),1-xf())).shape;return Qm(Va(qo(r,s[s.length-1]),s),t,n);
}));
}function tg(e,t){
return xi((()=>{
let n;return n=Za(t,xf(),1-xf()),n=So(Si(n,Ui(1,n))),_o(function(e,t){
if(!g(e.shape,t.shape)){
throw new Sp(`logits and labels must have the same shape, but got shapes ${JSON.stringify(e.shape)} and ${JSON.stringify(t.shape)}`);
}return xi((()=>{
const n=iu(t),r=jo(Vi(t));return ki(Ui(n,Ci(t,e)),Co(mo(r)));
}));
}(e,n),-1);
}));
}function ng(e,t){
return xi((()=>{
const n=Xm(e,-1),r=Xm(t,-1),s=Ci(n,r);return jo($o(s,-1));
}));
}Hm.constructors={};const rg={meanSquaredError:Ym,meanAbsoluteError:Zm,meanAbsolutePercentageError:Jm,meanSquaredLogarithmicError:function(e,t){
return xi((()=>{
const n=Za(t,xf(),Number.MAX_VALUE),r=So(ki(1,n)),s=Za(e,xf(),Number.MAX_VALUE),i=So(ki(1,s));return _o(Rf(Ui(r,i)),-1);
}));
},squaredHinge:function(e,t){
return xi((()=>{
const n=qi(0,Ui(1,Ci(e,t)));return _o(Rf(n),-1);
}));
},hinge:function(e,t){
return xi((()=>{
const n=qi(0,Ui(1,Ci(e,t)));return _o(n,-1);
}));
},categoricalHinge:function(e,t){
return xi((()=>{
const n=$o(Ci(e,t),-1),r=No(Ci(Ui(1,e),t),-1);return qi(0,ki(1,Ui(r,n)));
}));
},logcosh:function(e,t){
return xi((()=>{
const n=Math.log(2),r=Ui(t,e),s=Ui(ki(r,gu(Ci(-2,r))),n);return _o(s,-1);
}));
},categoricalCrossentropy:Qm,sparseCategoricalCrossentropy:eg,binaryCrossentropy:tg,kullbackLeiblerDivergence:function(e,t){
return xi((()=>{
const n=Za(e,xf(),1),r=Za(t,xf(),1);return $o(Ci(e,So(Si(n,r))),-1);
}));
},poisson:function(e,t){
return xi((()=>{
const n=So(ki(xf(),t));return _o(Ui(t,Ci(e,n)),-1);
}));
},cosineProximity:ng};function sg(e){
if("string"==typeof e){
if(e in rg){
return rg[e];
}let t=`Unknown loss ${e}`;throw e.toLowerCase().includes("softmaxcrossentropy")&&(t=`Unknown loss ${e}. Use "categoricalCrossentropy" as the string name for tf.losses.softmaxCrossEntropy`),new Sp(t);
}return e;
}function ig(e,t){
return xi((()=>{
const n=Ci(.5,Yo(t)),r=yf(vo(t,n),e.dtype);return _o(fo(e,r),-1);
}));
}function ag(e,t){
return xi((()=>yf(fo($a(e,-1),$a(t,-1)),"float32")));
}function og(e,t){
return tg(e,t);
}function ug(e,t){
return e.rank===t.rank&&(e=xu(e,[e.rank-1])),(t=$a(t,-1)).dtype!==e.dtype&&(t=fi(t,e.dtype)),fi(fo(e,t),"float32");
}const lg=Qm,cg=eg,hg={binaryAccuracy:ig,categoricalAccuracy:ag,precision:function(e,t){
return xi((()=>{
const n=function(e,t){
return xi((()=>fi($o(Eo(fo(e,1),fo(t,1))),"float32")));
}(e,t),r=function(e,t){
return xi((()=>fi($o(Eo(fo(e,0),fo(t,1))),"float32")));
}(e,t),s=ki(n,r);return fi(Su(vo(s,0),Si(n,s),0),"float32");
}));
},categoricalCrossentropy:lg,sparseCategoricalCrossentropy:cg,mse:Ym,MSE:Ym,mae:Zm,MAE:Zm,mape:Jm,MAPE:Jm,cosine:ng};function dg(e){
if("string"==typeof e&&e in hg){
return hg[e];
}if("string"!=typeof e&&null!=e){
return e;
}throw new Sp(`Unknown metric ${e}`);
}function pg(e){
if(Ep(null!==e,`Unknown LossOrMetricFn ${e}`),"string"==typeof e){
return e;
}{let t;for(const n of Object.keys(rg)){
if(rg[n]===e){
t=n;break;
}
}if(void 0!==t){
return t;
}for(const n of Object.keys(hg)){
if(hg[n]===e){
t=n;break;
}
}return void 0!==t?t:e.name;}
}function fg(e,t,n=!1){
if(null==e||"object"!=typeof e||Object.getPrototypeOf(e)!==Object.prototype||!mg(e)){
throw new Error("User-defined metadata is expected to be a JSON object, but is not.");
}if(n){
const n=JSON.stringify(e);n.length>1048576&&console.warn(`User-defined metadata of model "${t}" is too large in size (length=${n.length} when serialized). It is not recommended to store such large objects in user-defined metadata. Please make sure its serialized length is <= 1048576.`);
}
}function mg(e){
if(null===e){
return!0;
}if("object"==typeof e){
if(Object.getPrototypeOf(e)===Object.prototype){
const t=Object.keys(e);for(const n of t){
if("string"!=typeof n){
return!1;
}if(!mg(e[n])){
return!1;
}
}return!0;
}if(Array.isArray(e)){
for(const t of e){
if(!mg(t)){
return!1;
}
}return!0;
}return!1;
}{const t=typeof e;return"string"===t||"number"===t||"boolean"===t;}
}function gg(e,t,n=console.log){
let r="";for(let n=0;n<e.length;++n){
n>0&&(r=r.slice(0,r.length-1)+" "),r+=e[n],r=r.slice(0,t[n]),r+=" ".repeat(t[n]-r.length);
}n(r);
}function bg(e,t,n){
let r,s;try{
s=e.inboundNodes.map((e=>JSON.stringify(e.inputShapes))).join(",");
}catch(e){
s="multiple";
}try{
r=JSON.stringify(e.outputShape);
}catch(e){
r="multiple";
}gg([`${e.name} (${e.getClassName()})`,s,r,e.countParams().toString()],t,n);
}function xg(e,t,n,r){
let s,i;try{
i=e.inboundNodes.map((e=>JSON.stringify(e.inputShapes))).join(",");
}catch(e){
i="multiple";
}try{
s=JSON.stringify(e.outputShape);
}catch(e){
s="multiple";
}const a=[];for(const t of e.inboundNodes){
if(!(null!=n&&n.length>0&&-1===n.indexOf(t))){
for(let e=0;e<t.inboundLayers.length;++e){
const n=t.inboundLayers[e].name,r=t.nodeIndices[e],s=t.tensorIndices[e];a.push(`${n}[${r}][${s}]`);
}
}
}const o=e.name,u=e.getClassName(),l=0===a.length?"":a[0];gg([`${o} (${u})`,i,s,e.countParams().toString(),l],t,r);for(let e=1;e<a.length;++e){
gg(["","","","",a[e]],t,r);
}
}function yg(e,t,n){
return("inboundNodes"===e||"outputLayers"===e||"inputLayers"===e)&&0===t&&"string"==typeof n;
}function wg(e,t){
if(null===e){
return null;
}if("string"==typeof e){
return Dp(e);
}if("number"==typeof e||"boolean"==typeof e){
return e;
}if(e instanceof Array){
const n=[],r=e.length;for(let s=0;s<r;++s){
const r=e[s];yg(t,s,r)?n.push(r):n.push(wg(r,t));
}return n;
}{const t={};for(const n of Object.keys(e)){
const r=e[n];if("name"===n&&"string"==typeof r){
t[n]=r;
}else{
const e=Dp(n);t[e]=wg(r,e);
}
}return t;}
}function vg(e,t){
if(null==e){
return null;
}if("string"==typeof e){
return _p(e);
}if("number"==typeof e||"boolean"==typeof e){
return e;
}if(e instanceof Array){
const n=[],r=e.length;for(let s=0;s<r;++s){
const r=e[s];yg(t,s,r)?n.push(r):n.push(vg(r,t));
}return n;
}{const t={};for(const n of Object.keys(e)){
const r=e[n];t[_p(n)]="name"!==n&&"className"!==n||"string"!=typeof r?vg(r,n):r;
}return t;}
}const kg="4.10.0";class Ig extends bm{
constructor(e){
if(super({}),this.containerNodes=new Set,this.name=e.name,null==this.name){
const e=this.getClassName().toLowerCase();this.name=Yp(e);
}if(this.supportsMasking=!1,this.trainable_=!0,Array.isArray(e.inputs)?this.inputs=e.inputs.slice():this.inputs=[e.inputs],Array.isArray(e.outputs)?this.outputs=e.outputs.slice():this.outputs=[e.outputs],Bp(this.inputs).length!==this.inputs.length){
throw new Sp(`The list of inputs passed to the model is redundant. All inputs should only appear once. Found: ${this.inputs.map((e=>e.name))}`);
}Bp(this.outputs).length!==this.outputs.length&&console.warn(`The list of outputs passed to the model is redundant. All outputs should only appear once. Found: ${this.outputs.map((e=>e.name))}`),this.inputLayers=[],this.inputLayersNodeIndices=[],this.inputLayersTensorIndices=[],this.outputLayers=[],this.outputLayersNodeIndices=[],this.outputLayersTensorIndices=[],this.layers=[],this.internalContainerRefs=[];for(const e of this.outputs){
const t=e.sourceLayer,n=e.nodeIndex,r=e.tensorIndex;this.outputLayers.push(t),this.outputLayersNodeIndices.push(n),this.outputLayersTensorIndices.push(r);
}for(const e of this.inputs){
const t=e.sourceLayer,n=e.nodeIndex,r=e.tensorIndex;Ep(0===n,"input layer has >1 nodes"),Ep(0===r,"input layer has >1 tensors"),this.inputLayers.push(t),this.inputLayersNodeIndices.push(n),this.inputLayersTensorIndices.push(r);
}this.inputNames=[],this.outputNames=[],this.feedInputShapes=[],this.feedInputNames=[],this.feedOutputNames=[];for(let t=0;t<this.inputLayers.length;t++){
const n=this.inputLayers[t];if(!(n instanceof ym)){
throw new TypeError(`Input layers to a LayersModel must be InputLayer objects. Received inputs: ${e.inputs}. Input ${t} (0-based) originates from layer type ${n.getClassName()}.`);
}this.inputNames.push(n.name),this.feedInputShapes.push(n.batchInputShape),this.feedInputNames.push(n.name);
}for(const e of this.outputLayers){
this.outputNames.push(e.name);
}this.internalInputShapes=this.inputs.map((e=>e.shape)),this.internalOutputShapes=this.outputs.map((e=>e.shape));const t={},n={},r={},s={},i={},a=[],o=(e,t,n,r,s,u)=>{
null!=r&&null!=s&&null!=u||(r=e.sourceLayer,s=e.nodeIndex,u=e.tensorIndex);const l=r.inboundNodes[s];if(-1!==n.indexOf(l)){
throw new Ip(`The tensor ${e.name} at layer "${r.name}" is part of a cycle.`);
}if(-1!==t.indexOf(l)){
return;
}this.containerNodes.add(Ig.nodeKey(r,s)),r.id in i||(i[r.id]=Object.keys(i).length),-1===n.indexOf(l)&&n.push(l);const c=l.inboundLayers.length;for(let e=0;e<c;e++){
const r=l.inputTensors[e],s=l.inboundLayers[e],i=l.nodeIndices[e],a=l.tensorIndices[e];o(r,t,n,s,i,a);
}for(t.push(l);n.indexOf(l)>=0;){
n.splice(n.indexOf(l),1);
}a.push(l);
},u=[],l=[];for(const e of this.outputs){
o(e,u,l);
}const c=a.slice().reverse();for(const e of c){
n[e.id]=e,e.id in t||(t[e.id]=0);let i=t[e.id];const a=null==r[e.outboundLayer.id]?0:r[e.outboundLayer.id];i=Math.max(i,a),r[e.outboundLayer.id]=i,s[e.outboundLayer.id]=e.outboundLayer,t[e.id]=i;for(let r=0;r<e.inboundLayers.length;r++){
const s=e.inboundLayers[r],a=e.nodeIndices[r],o=s.inboundNodes[a],u=null==t[o.id]?0:t[o.id];t[o.id]=Math.max(i+1,u),n[o.id]=o;
}
}const h={};for(const e in t){
const r=t[e];r in h||(h[r]=[]),h[r].push(n[e]);
}const d={};for(const e in r){
const t=r[e];t in d||(d[t]=[]),d[t].push(s[e]);
}let p=Object.keys(d).map((e=>parseInt(e,10))).sort(Pp);this.layers=[];for(const e of p){
const t=d[e];t.sort(((e,t)=>{
const n=i[e.id],r=i[t.id];return n<r?-1:n>r?1:0;
}));for(const e of t){
e instanceof Ig&&this.internalContainerRefs.push(e),this.layers.push(e);
}
}this.layersByDepth=d,p=Object.keys(h).map((e=>parseInt(e,10))).sort(Pp);const f=this.inputs.slice(),m=[];for(const e of p){
for(const t of h[e]){
const e=t.outboundLayer;if(null!=e){
for(const n of t.inputTensors){
if(-1===f.indexOf(n)){
throw new Ip(`Graph disconnected: cannot obtain value for tensor ${n} at layer "${e.name}". The following previous layers were accessed without issue: ${m}`);
}
}for(const e of t.outputTensors){
f.push(e);
}m.push(e.name);
}
}
}this.nodesByDepth=h;const g=this.layers.map((e=>e.name));for(const e of g){
const t=g.filter((t=>t===e)).length;if(1!==t){
throw new Ip(`The name "${e}" is used ${t} times in the model. All layer names should be unique. Layer names: `+JSON.stringify(g));
}
}this.outboundNodes=[],this.inboundNodes=[],new mm({outboundLayer:this,inboundLayers:[],nodeIndices:[],tensorIndices:[],inputTensors:this.inputs,outputTensors:this.outputs,inputMasks:this.inputs.map((e=>null)),outputMasks:this.outputs.map((e=>null)),inputShapes:this.inputs.map((e=>e.shape)),outputShapes:this.outputs.map((e=>e.shape))}),this.built=!0,this._refCount=1;
}assertNotDisposed(){
if(0===this._refCount){
throw new Error(`Container '${this.name}' is already disposed.`);
}
}dispose(){
this.assertNotDisposed();const e={refCountAfterDispose:null,numDisposedVariables:0};if(0==--this._refCount){
for(const t of this.layers){
e.numDisposedVariables+=t.dispose().numDisposedVariables;
}for(const t of this.internalContainerRefs){
e.numDisposedVariables+=t.dispose().numDisposedVariables;
}
}return e.refCountAfterDispose=this._refCount,e;
}get trainable(){
return this.trainable_;
}set trainable(e){
this.layers.forEach((t=>{
t._trainableWeights.forEach((t=>t.trainable=e));
})),this.trainable_=e;
}get trainableWeights(){
if(this._trainableWeights.length>0){
throw new Sp("Container instance unexpectedly contains _trainableWeights.The trainable weights of a Container are a union of the trainable weights of its consituent Layers. Its own _trainableWeights must remain an empty Array.");
}if(!this.trainable){
return[];
}let e=[];for(const t of this.layers){
e=e.concat(t.trainableWeights);
}return e;
}get nonTrainableWeights(){
const e=[];for(const t of this.layers){
e.push(...t.nonTrainableWeights);
}if(!this.trainable){
const t=[];for(const e of this.layers){
t.push(...e.trainableWeights);
}return t.concat(e);
}return e;
}get weights(){
return this.trainableWeights.concat(this.nonTrainableWeights);
}loadWeights(e,t=!0){
const n={};let r=0;const s=Object.keys(e)[0].split("/"),i=!isNaN(parseInt(s[s.length-1],10));for(const e of this.layers){
for(const[t,s]of e.weights.entries()){
const e=i?`${s.name.split("/").slice(0,-1).join("/")+"/"}${t}`:s.originalName;if(null!=n[e]){
throw new Sp(`Duplicate weight name: ${e}`);
}n[e]=s,r++;
}
}const a=[];for(const r in e){
let s=r;if(null==n[r]){
const e=r.split("/");s=e.slice(0,-2).concat([e[e.length-1]]).join("/");
}if(null!=n[s]){
a.push([n[s],e[r]]);
}else if(t){
throw new Sp(`Provided weight data has no target variable: ${r}`);
}delete n[s];
}if(t){
const e=[];for(const t in n){
e.push(t);
}if(e.length>0){
throw new Sp(`${e.length} of ${r} weights are not set: ${e}`);
}
}hm(a);
}updatedConfig(){
const e=this.getConfig(),t={};return t.className=this.getClassName(),t.config=e,t.kerasVersion=`tfjs-layers ${kg}`,t.backend="TensorFlow.js",t;
}toJSON(e,t=!0){
const n=vg(this.updatedConfig());return t?JSON.stringify(n):n;
}call(e,t){
return xi((()=>{
e=Fp(e);const n=new wm;for(let t=0;t<this.inputs.length;++t){
n.add(this.inputs[t],e[t]);
}return Im(this.outputs,n,t);
}));
}computeMask(e,t){
return xi((()=>{
let n;return e=Fp(e),n=null==t?Tp(null,e.length):Fp(t),this.runInternalGraph(e,n)[1];
}));
}computeOutputShape(e){
const t=sm(e);if(t.length!==this.inputLayers.length){
throw new Sp(`Invalid inputShape argument ${e}: model has ${this.inputLayers.length} tensor inputs.`);
}const n={};for(let e=0;e<t.length;e++){
const r=this.inputLayers[e],s=t[e];n[r.name+"_0_0"]=s;
}const r=Object.keys(this.nodesByDepth).map((e=>parseInt(e,10))).sort(Pp);if(r.length>1){
for(const e of r){
const t=this.nodesByDepth[e];for(const e of t){
const t=e.outboundLayer;if(-1!==this.inputLayers.map((e=>e.id)).indexOf(t.id)){
continue;
}const r=[];for(let t=0;t<e.inboundLayers.length;t++){
const s=e.inboundLayers[t],i=e.nodeIndices[t],a=e.tensorIndices[t],o=n[`${s.name}_${i}_${a}`];r.push(o);
}const s=sm(t.computeOutputShape(Ap(r))),i=t.inboundNodes.indexOf(e);for(let e=0;e<s.length;e++){
n[`${t.name}_${i}_${e}`]=s[e];
}
}
}
}const s=[],i=[];for(let e=0;e<this.outputLayers.length;e++){
const t=this.outputLayers[e],n=this.outputLayersNodeIndices[e],r=this.outputLayersTensorIndices[e],s=`${t.name}_${n}_${r}`;i.push(s);
}for(let e=0;e<i.length;e++){
const t=i[e];Ep(t in n),s.push(n[t]);
}return Ap(s);
}runInternalGraph(e,t){
null==t&&(t=Tp(null,e.length));const n={};for(let r=0;r<this.inputs.length;++r){
const s=this.inputs[r],i=e[r],a=t[r];n[s.id]=[i,a];
}const r=Object.keys(this.nodesByDepth).map((e=>parseInt(e,10))).sort(Pp);for(const e of r){
const t=this.nodesByDepth[e];for(const e of t){
const t=e.outboundLayer,r=e.inputTensors,s=e.outputTensors,i=[];for(const e of r){
e.id in n&&i.push(n[e.id]);
}if(i.length===r.length){
let r,a,o,u,l={};if(null!=e.callArgs&&(l=e.callArgs),1===i.length){
const[e,n]=i[0];null==l.mask&&(l.mask=n),o=Fp(t.call(e,l)),u=Fp(t.computeMask(e,n)),r=[e],a=[n];
}else {
r=i.map((e=>e[0])),a=i.map((e=>e[1])),null==l.mask&&(l.mask=a),o=Fp(t.call(r,l)),u=Fp(t.computeMask(r,a));
}if(t.activityRegularizer){
throw new Cp("LayersModel invocation with concrete Tensor value(s) in the presence of activity regularizer(s) is not supported yet.");
}for(let e=0;e<s.length;++e){
const t=s[e],r=o[e],i=u[e];n[t.id]=[r,i];
}
}
}
}const s=[],i=[],a=[];for(const e of this.outputs){
Ep(e.id in n,`Could not compute output ${e.name} : ${e.id}`);const[t,r]=n[e.id];a.push(t.shape),s.push(t),i.push(r);
}return[s,i,a];
}buildNodeConversionMap(e){
const t={};let n;for(const e of this.layers){
n=e instanceof Ig?1:0;for(let r=0;r<e.inboundNodes.length;r++){
const s=Ig.nodeKey(e,r);this.containerNodes.has(s)&&(t[s]=n,n+=1);
}
}return t;
}getLayer(e,t){
if(null!=t){
return this.findLayer(t);
}if(null==e){
throw new Sp("Provide either a layer name or layer index");
}if("number"==typeof e){
return this.findLayer(e);
}for(const t of this.layers){
if(t.name===e){
return t;
}
}throw new Sp(`No such layer: ${e}`);
}findLayer(e){
if(this.layers.length<=e){
throw new Sp(`Was asked to retrieve layer at index ${e}, but model only has ${this.layers.length} layer(s).`);
}return this.layers[e];
}calculateLosses(){
return xi((()=>{
const e=[];for(const t of this.layers){
for(let n=0;n<t.inboundNodes.length;++n){
const r=Ig.nodeKey(t,n);this.containerNodes.has(r)&&e.push(...t.calculateLosses());
}
}return e;
}));
}getConfig(){
const e={name:this.name},t=this.buildNodeConversionMap(this.layers),n=[];for(const e of this.layers){
const r=e.getClassName(),s=e.getConfig(),i=[];for(let n=0;n<e.inboundNodes.length;n++){
const r=e.inboundNodes[n],s=Ig.nodeKey(e,n);let a={};if(this.containerNodes.has(s)){
if(r.callArgs){
try{
JSON.stringify(r.callArgs),a=r.callArgs;
}catch(t){
console.warn(`Layer ${e.name} was passed non-serializable keyword arguments: ${r.callArgs}. They will not be included in the serialized model (and thus will be missing at deserialization time).`),a={};
}
}if(r.inboundLayers.length>0){
const e=[];for(let n=0;n<r.inboundLayers.length;n++){
const s=r.inboundLayers[n],i=r.nodeIndices[n],o=r.tensorIndices[n];let u=t[Ig.nodeKey(s,i)];null==u&&(u=0),e.push([s.name,u,o,a]);
}i.push(e);
}
}
}const a={};a.name=e.name,a.className=r,a.config=s,a.inboundNodes=i,n.push(a);
}e.layers=n;const r=[];for(let e=0;e<this.inputLayers.length;e++){
const n=this.inputLayers[e],s=this.inputLayersNodeIndices[e],i=Ig.nodeKey(n,s);if(!this.containerNodes.has(i)){
continue;
}let a=t[i];null==a&&(a=0);const o=this.inputLayersTensorIndices[e];r.push([n.name,a,o]);
}e.inputLayers=r;const s=[];for(let e=0;e<this.outputLayers.length;e++){
const n=this.outputLayers[e],r=this.outputLayersNodeIndices[e],i=Ig.nodeKey(n,r);if(!this.containerNodes.has(i)){
continue;
}let a=t[i];null==a&&(a=0);const o=this.outputLayersTensorIndices[e];s.push([n.name,a,o]);
}return e.outputLayers=s,e;
}static fromConfig(e,t,n={},r=!1){
const s={},i={};function a(e,t){
e.name in i?i[e.name].push(t):i[e.name]=[t];
}function o(e,t){
const n=[];let r;for(const i of t){
const o=i[0],u=i[1],l=i[2];if(r=null==i[3]?{}:i[3],!(o in s)){
return void a(e,t);
}const c=s[o];if(c.inboundNodes.length<=u){
return void a(e,t);
}const h=c.inboundNodes[u];n.push(h.outputTensors[l]);
}n.length>0&&e.apply(Ap(n),r);
}function u(e){
const n=e.name,i=Km(e,null!=t.customObjects?t.customObjects:{});i.setFastWeightInitDuringBuild(r),s[n]=i,e.inboundNodes.forEach((e=>{
if(!(e instanceof Array)){
throw new Sp(`Corrupted configuration, expected array for nodeData: ${e}`);
}a(i,e);
}));
}const l=t.name,c=t.layers;for(const e of c){
u(e);
}for(;!Up(i);){
for(const e of c){
const t=s[e.name];if(t.name in i){
const e=i[t.name];delete i[t.name];for(const n of e){
o(t,n);
}
}
}
}const h=[],d=[],p=t.inputLayers;for(const e of p){
const t=e[0],n=e[1],r=e[2];Ep(t in s);const i=s[t].inboundNodes[n].outputTensors;h.push(i[r]);
}const f=t.outputLayers;for(const e of f){
const t=e[0],n=e[1],r=e[2];Ep(t in s);const i=s[t].inboundNodes[n].outputTensors;d.push(i[r]);
}return new e({inputs:h,outputs:d,name:l});
}get stateful(){
if(this._stateful){
throw new Sp("Container instance unexpectedly has _stateful = true. The statefulness of a Container is determined by the Layers it contains. Its _stateful property must remain the default false.");
}for(const e of this.layers){
if(e.stateful){
return!0;
}
}return!1;
}resetStates(){
xi((()=>{
this.layers.forEach((e=>{
e.stateful&&e.resetStates();
}));
}));
}
}function Sg(e,t){
return function(e,t,n){
const r=t.length;if(null==e||Array.isArray(e)&&0===e.length){
return t.map((e=>null));
}if(1===r){
return Array.isArray(e)&&1===e.length?e:"object"==typeof e&&t[0]in e?[e[t[0]]]:[e];
}if(Array.isArray(e)){
if(e.length!==r){
throw new Error(`Provided ${n} is an array of ${e.length} element(s), but the model has ${r} outputs. Make sure a set of weights is provided for each model output.`);
}return e;
}if("object"==typeof e&&Object.keys(e).length>0&&"object"==typeof e[Object.keys(e)[0]]){
const n=[];return t.forEach((t=>{
t in e?n.push(e[t]):n.push(null);
})),n;
}throw new Error(`The model has multiple (${r}) outputs, so ${n} must be either an array with ${r} elements or an object with ${t} keys. Provided ${n} not understood: ${JSON.stringify(e)}`);
}(e,t,"classWeight");
}async function Cg(e,t,n,r){
if(null!=t||null!=r){
throw new Error("Support sampleWeight is not implemented yet");
}if(null!=n){
const t=xi((()=>{
if(1===e.shape.length){
return mi(e);
}if(2===e.shape.length){
if(e.shape[1]>1){
return $a(e,1);
}if(1===e.shape[1]){
return Va(e,[e.shape[0]]);
}throw new Error(`Encountered unexpected last-dimension size (${e.shape[1]}) during handling of class weights. The size is expected to be >= 1.`);
}throw new Error(`Unexpected rank of target (y) tensor (${e.rank}) during handling of class weights. The rank is expected to be 1 or 2.`);
})),r=Array.from(await t.data());yi(t);const s=[];return r.forEach((e=>{
if(null==n[e]){
throw new Error(`classWeight must contain all classes in the training data. The class ${e} exists in the data but not in classWeight`);
}s.push(n[e]);
})),vu(s,"float32");
}return null;
}function Ng(e,t){
return Ci(e,t);
}function $g(e,t){
let n,r;const s=t;n=s.xs,r=s.ys,d(null!=n&&null!=r,(()=>`A Dataset iterator for fitDataset() is expected to generate objects of the form \`{xs: xVal, ys: yVal}\`, where the two values may be \`tf.Tensor\`, an array of Tensors, or a map of string to Tensor.  The provided Dataset instead generates ${t}`));const i=Tg("input",e.inputNames,n),a=Tg("output",e.outputNames,r),o=i[0].shape[0];d(i.length===e.inputs.length,(()=>`LayersModel has ${e.inputs.length} inputs, but the dataset provides ${i.length} inputs.  (Expected input keys: ${JSON.stringify(e.inputNames)})`)),d(a.length===e.outputs.length,(()=>`LayersModel has ${e.outputs.length} outputs, but the dataset provides ${a.length} outputs.  (Expected output keys: ${JSON.stringify(e.outputNames)})`));for(let t=0;t<i.length;t++){
d(i[t].shape[0]===o,(()=>`Batch size mismatch: input ${e.inputNames[t]} has ${i[t].shape[0]}; expected  ${o} based on input ${e.inputNames[0]}.`));
}for(let t=0;t<a.length;t++){
d(a[t].shape[0]===o,(()=>`Batch size mismatch: output ${e.outputNames[t]} has ${a[t].shape[0]}; expected  ${o} based on input ${e.inputNames[0]}.`));
}return{xs:i,ys:a};
}function Tg(e,t,n){
if(n instanceof es){
return[n];
}if(Array.isArray(n)){
return d(n.length===t.length,(()=>`Received an array of ${n.length} Tensors, but expected ${t.length} to match the ${e} keys ${t}.`)),n;
}{const r=[];for(const s of t){
if(null==n[s]){
throw new Sp(`The feature data generated by the dataset lacks the required ${e} key '${s}'.`);
}r.push(n[s]);
}return r;}
}function Eg(e){
return"function"==typeof e.iterator;
}function Rg(e){
d(e>0&&Number.isInteger(e),(()=>`batchSize is required to be a positive integer, but got ${e}`));
}function Ag(e,t,n){
return null==e?[null]:Array.isArray(e)?e.map((e=>vf(e,t,n-t))):vf(e,t,n-t);
}function Fg(e,t){
return xi((()=>null==e?null:Array.isArray(e)?e.map((e=>Fg(e,t))):Ef(e,"int32"===t.dtype?t:fi(t,"int32"))));
}function _g(e,t){
const n=[];let r=0,s=null;for(;r<e;){
s=r+t,s>=e&&(s=e),n.push([r,s]),r=s;
}return n;
}function Dg(e){
const t=[];e instanceof es&&(e=[e]);for(let n=0;n<e.length;++n){
const r=e[n];if(1===r.rank){
t.push(wf(r,1));
}else{
if(0===r.rank){
throw new Error("Expected tensor to be at least 1D, but received a 0D tensor (scalar).");
}t.push(r);
}
}return t;
}function Og(e,t){
if(null==e){
return;
}const n=[];if(t instanceof es){
n.push(t.id);
}else if(Array.isArray(t)){
t.forEach((e=>n.push(e.id)));
}else if(null!=t){
for(const e in t){
const r=t[e];n.push(r.id);
}
}const r=[];if(e instanceof es){
-1===n.indexOf(e.id)&&r.push(e);
}else if(Array.isArray(e)){
e.forEach((e=>{
-1===n.indexOf(e.id)&&r.push(e);
}));
}else if(null!=e){
for(const t in e){
const s=e[t];-1===n.indexOf(s.id)&&r.push(s);
}
}r.forEach((e=>{
e.isDisposed||e.dispose();
}));
}function Mg(e){
return Array.isArray(e);
}function Lg(e){
return!function(e){
return e instanceof es;
}(e)&&!Mg(e);
}function zg(e,t,n,r=!0,s=""){
if(null==t||0===t.length){
if(null!=e){
let t=!1;if(Mg(e)&&e.length>0){
t=!0;
}else if(Lg(e)){
for(const n in e){
if(e.hasOwnProperty(n)){
t=!0;break;
}
}
}else {
t=!0;
}if(t){
throw new Sp(`Error when checking model ${s} expected no data, but got ${e}`);
}
}return[];
}if(null==e){
return t.map((e=>null));
}let i;if(Lg(e)){
i=[];for(const n of t){
if(null==e[n]){
throw new Sp(`No data provided for "${n}". Need data for each key in: ${t}`);
}i.push(e[n]);
}
}else if(Mg(e)){
if(e.length!==t.length){
throw new Sp(`Error when checking model ${s}: the Array of Tensors that you are passing to your model is not the size the model expected. Expected to see ${t.length} Tensor(s), but instead got the following list of Tensor(s): ${e}`);
}i=e;
}else{
if(t.length>1){
throw new Sp(`The model ${s} expects ${t.length} Tensor(s), but only received one Tensor. Found: Tensor with shape ${e.shape}`);
}i=[e];
}if(i=Dg(i),null!=n){
for(let e=0;e<t.length;++e){
if(null==n[e]){
continue;
}const a=i[e];if(a.shape.length!==n[e].length){
throw new Sp(`Error when checking ${s}: expected ${t[e]} to have ${n[e].length} dimension(s). but got array with shape ${a.shape}`);
}for(let t=0;t<n[e].length;++t){
if(0===t&&!r){
continue;
}const i=a.shape[t],o=n[e][t];if(null!=o&&o>=0&&i!==o){
throw new Sp(`${s} expected a batch of elements where each example has shape [${n[e].slice(1,n[e].length)}] (i.e.,tensor shape [*,${n[e].slice(1,n[e].length)}]) but the ${s} received an input with ${a.shape[0]} examples, each with shape [${a.shape.slice(1,a.shape.length)}] (tensor shape [${a.shape}])`);
}
}
}
}return i;
}function Pg(e,t,n,r=!0,s=""){
let i;if(Array.isArray(e)){
if(e.length!==t.length){
throw new Sp(`Error when checking model ${s}: the Array of Tensors that you are passing to your model is not the size the the model expected. Expected to see ${t.length} Tensor(s), but instead got ${e.length} Tensors(s).`);
}i=e;
}else{
if(t.length>1){
throw new Sp(`The model expects ${t.length} ${s} Tensors, but only received one Tensor. Found: array with shape ${JSON.stringify(e.shape)}.`);
}i=[e];
}if(null!=n){
for(let e=0;e<t.length;++e){
if(null==n[e]){
continue;
}const a=i[e];if(a.shape.length!==n[e].length){
throw new Sp(`Error when checking ${s}: expected ${t[e]} to have ${n[e].length} dimension(s), but got array with shape ${JSON.stringify(a.shape)}`);
}for(let i=0;i<n[e].length;++i){
if(0===i&&!r){
continue;
}const o=a.shape[i],u=n[e][i];if(null!=u&&u!==o){
throw new Sp(`Error when checking ${s}: expected ${t[e]} to have shape ${JSON.stringify(n[e])} but got array with shape ${JSON.stringify(a.shape)}.`);
}
}
}
}
}class Bg extends Ig{
constructor(e){
super(e),this.isTraining=!1;
}summary(e,t,n=console.log){
if(!this.built){
throw new Sp("This model has never been called, thus its weights have not been created yet. So no summary can be displayed. Build the model first (e.g., by calling it on some test data).");
}!function(e,t,n,r=console.log){
const s=function(e){
let t=!0;const n=[],r=[];for(const t in e.nodesByDepth){
n.push(e.nodesByDepth[t]);
}for(const e of n){
if(e.length>1||1===e.length&&e[0].inboundLayers.length>1){
t=!1;break;
}r.push(...e);
}if(t){
for(const n of e.layers){
let e=!1;for(const s of n.inboundNodes){
if(-1!==r.indexOf(s)){
if(e){
t=!1;break;
}e=!0;
}
}if(!t){
break;
}
}
}return t;
}(e),i=["Layer (type)","Input Shape","Output shape","Param #"];let a;if(s?(t=t||90,n=n||[.32,.61,.89,1]):(t=t||115,n=n||[.24,.48,.7,.8,1]),n[n.length-1]<=1&&(n=n.map((e=>Math.floor(t*e)))),!s){
i.push("Receives inputs"),a=[];for(const t in e.nodesByDepth){
a.push(...e.nodesByDepth[t]);
}
}r("_".repeat(t)),gg(i,n,r),r("=".repeat(t));const o=e.layers;for(let e=0;e<o.length;++e){
s?bg(o[e],n,r):xg(o[e],n,a,r),r((e===o.length-1?"=":"_").repeat(t));
}e.checkTrainableWeightsConsistency();const u=function(e){
let t;return t=null!=e.collectedTrainableWeights?om(e.collectedTrainableWeights):om(e.trainableWeights),t;
}(e),l=om(e.nonTrainableWeights);r(`Total params: ${u+l}`),r(`Trainable params: ${u}`),r(`Non-trainable params: ${l}`),r("_".repeat(t));
}(this,e,t,n);
}compile(e){
if(null==e.loss&&(e.loss=[]),this.loss=e.loss,"string"==typeof e.optimizer){
this.optimizer_=function(e){
const t={Adagrad:()=>El.adagrad(.01),Adadelta:()=>El.adadelta(1,.95,xf()),Adam:()=>El.adam(.001,.9,.999,xf()),Adamax:()=>El.adamax(.002,.9,.999,xf(),0),RMSProp:()=>El.rmsprop(.001,.9,0,xf()),SGD:()=>El.sgd(.01)};if(t.adagrad=t.Adagrad,t.adadelta=t.Adadelta,t.adam=t.Adam,t.adamax=t.Adamax,t.rmsprop=t.RMSProp,t.sgd=t.SGD,e in t){
return t[e]();
}throw new Sp(`Unknown Optimizer ${e}`);
}(e.optimizer),this.isOptimizerOwned=!0;
}else{
if(!(e.optimizer instanceof Mi)){
throw new Sp("User-defined optimizer must be an instance of tf.Optimizer.");
}this.optimizer_=e.optimizer,this.isOptimizerOwned=!1;
}let t=[];if(Array.isArray(e.loss)||"string"==typeof e.loss||"function"==typeof e.loss){
if(Array.isArray(e.loss)){
if(e.loss.length!==this.outputs.length){
throw new Sp(`When passing an Array as loss, it should have one entry per model output. The model has ${this.outputs.length} output(s), but you passed loss=${e.loss}.`);
}const n=e.loss;t=n.map((e=>sg(e)));
}else{
const n=sg(e.loss);this.outputs.forEach((e=>{
t.push(n);
}));
}
}else{
e.loss=e.loss;for(const t in e.loss){
if(-1===this.outputNames.indexOf(t)){
throw new Sp(`Unknown entry in loss dictionary: "${t}". Only expected the following keys: ${this.outputNames}`);
}
}for(const n of this.outputNames){
null==e.loss[n]&&console.warn(`Output "${n}" is missing from loss dictionary. We assume this was done on purpose, and we will not be expecting data to be passed to ${n} during training`),t.push(sg(e.loss[n]));
}
}this.lossFunctions=t,this.feedOutputNames=[],this.feedOutputShapes=[],this.feedLossFns=[];for(let e=0;e<this.outputs.length;++e){
const t=this.internalOutputShapes[e],n=this.outputNames[e];this.feedOutputNames.push(n),this.feedOutputShapes.push(t),this.feedLossFns.push(this.lossFunctions[e]);
}const n=[];this.metrics=e.metrics,this.metricsNames=["loss"],this.metricsTensors=[],uf("loss",(()=>{
for(let e=0;e<this.outputs.length;++e){
if(-1!==n.indexOf(e)){
continue;
}const t=this.lossFunctions[e];this.outputs.length>1&&(this.metricsTensors.push([t,e]),this.metricsNames.push(this.outputNames[e]+"_loss"));
}
}));const r=function(e,t){
if(null==e||Array.isArray(e)&&0===e.length){
return t.map((e=>[]));
}let n;if("string"==typeof e||"function"==typeof e){
n=[e];
}else{
if(!Array.isArray(e)&&"object"!=typeof e){
throw new TypeError(`Type of metrics argument not understood. Expected an string,function, Array, or Object, found: ${e}`);
}n=e;
}if(Array.isArray(n)){
return t.map((e=>n));
}{const e=[];for(const r of t){
let t=n.hasOwnProperty(r)?n[r]:[];Array.isArray(t)||(t=[t]),e.push(t);
}return e;}
}(e.metrics,this.outputNames),s=(e,t,n)=>{
this.outputNames.length>1&&(t=this.outputNames[e]+"_"+t),this.metricsNames.push(t),this.metricsTensors.push([n,e]);
};uf("metric",(()=>{
for(let e=0;e<this.outputs.length;++e){
-1===n.indexOf(e)&&(t=>{
let n,r,i;for(const a of t){
if("string"==typeof a&&-1!==["accuracy","acc","crossentropy","ce"].indexOf(a)){
const t=this.internalOutputShapes[e];let s;1===t[t.length-1]||this.lossFunctions[e]===tg?-1!==["accuracy","acc"].indexOf(a)?r=ig:-1!==["crossentropy","ce"].indexOf(a)&&(r=og):this.lossFunctions[e]===eg?-1!==["accuracy","acc"].indexOf(a)?r=ug:-1!==["crossentropy","ce"].indexOf(a)&&(r=cg):-1!==["accuracy","acc"].indexOf(a)?r=ag:-1!==["crossentropy","ce"].indexOf(a)&&(r=lg),-1!==["accuracy","acc"].indexOf(a)?s="acc":-1!==["crossentropy","ce"].indexOf(a)&&(s="ce"),i=r,n=""+s;
}else{
const e=dg(a);i=e,n=""+pg(a);
}let t;uf(n,(()=>{
t=i;
})),s(e,n,t);
}
})(r[e]);
}
})),this.collectedTrainableWeights=this.trainableWeights;
}checkTrainableWeightsConsistency(){
null!=this.collectedTrainableWeights&&this.trainableWeights.length!==this.collectedTrainableWeights.length&&console.warn("Discrepancy between trainableweights and collected trainable weights. Did you set `model.trainable` without calling `model.compile()` afterwards?");
}evaluate(e,t,n={}){
const r=null==n.batchSize?32:n.batchSize;Rg(r);const s=this.standardizeUserDataXY(e,t,!0,r);try{
const e=s[0].concat(s[1]);this.makeTestFunction();const t=this.testFunction;return Ap(this.testLoop(t,e,r,n.verbose,n.steps));
}finally{
Og(s[0],e),Og(s[1],t);
}
}async evaluateDataset(e,t){
return this.makeTestFunction(),async function(e,t,n){
const r=null!=(n=n||{}).batches,s=e.testFunction;let i=[];if(n.verbose>0){
throw new Cp("Verbose mode is not implemented yet.");
}d(!r||n.batches>0&&Number.isInteger(n.batches),(()=>`Test loop expects \`batches\` to be a positive integer, but received ${JSON.stringify(n.batches)}`));const a="function"==typeof t.next?t:await t.iterator();let o=0,u=0;for(;!r||u<n.batches;){
const t=await a.next();if(i=xi((()=>{
if(t.value){
const{xs:n,ys:r}=$g(e,t.value),a=n.concat(r),l=xi((()=>s(a)));if(yi(a),0===u){
for(let e=0;e<l.length;++e){
i.push(Ri(0));
}
}const c=a[0].shape[0];for(let e=0;e<l.length;++e){
const t=l[e],n=i[e];i[e]=xi((()=>ki(i[e],Ci(c,t)))),u>0&&yi(n);
}yi(l),o+=c,++u;
}return i;
})),t.done){
r&&console.warn(`Your dataset iterator ran out of data during evaluateDataset(). Interrupting evalution. Make sure that your dataset can generate at least \`batches\` batches (in this case, ${n.batches} batches). You may need to use the repeat() function when building your dataset.`);break;
}
}for(let e=0;e<i.length;++e){
const t=i[e];i[e]=Si(i[e],o),yi(t);
}return Ap(i);
}(this,e,t);
}checkNumSamples(e,t,n,r="steps"){
let s;if(null!=n){
if(s=null,null!=t){
throw new Sp(`If ${r} is set, batchSize must be null or undefined.Got batchSize = ${t}`);
}
}else{
if(null==e){
throw new Sp(`Either the input data should have a defined shape, or ${r} shoud be specified.`);
}s=Array.isArray(e)?e[0].shape[0]:e.shape[0];
}return s;
}execute(e,t){
if(Array.isArray(t)&&0===t.length){
throw new Sp("`outputs` is an empty Array, which is not allowed.");
}const n=Array.isArray(t),r=n?t:[t],s=this.retrieveSymbolicTensors(r),i=new wm;if(e instanceof es&&(e=[e]),Array.isArray(e)){
if(e.length!==this.inputs.length){
throw new Sp(`The number of inputs provided (${e.length}) does not match the number of inputs of this model (${this.inputs.length}).`);
}for(let t=0;t<this.inputs.length;++t){
i.add(this.inputs[t],e[t]);
}
}else {
for(const t of this.inputs){
const n=e[t.name];if(null==n){
throw new Sp(`No value is provided for the model's input ${t.name}`);
}i.add(t,n);
}
}const a=Im(s,i);return n?a:a[0];
}retrieveSymbolicTensors(e){
const t=Tp(null,e.length);let n=e.length;for(const r of this.layers){
const s=Array.isArray(r.output)?r.output:[r.output],i=s.map((e=>e.name));for(let r=0;r<e.length;++r){
const a=i.indexOf(e[r]);if(-1!==a&&(t[r]=s[a],n--),0===n){
break;
}
}if(0===n){
break;
}
}if(n>0){
const n=[];throw t.forEach(((t,r)=>{
null==t&&n.push(e[r]);
})),new Sp(`Cannot find SymbolicTensors for output name(s): ${JSON.stringify(n)}`);
}return t;
}predictLoop(e,t=32,n=!1){
return xi((()=>{
const r=this.checkNumSamples(e);if(n){
throw new Cp("Verbose predictLoop() is not implemented yet.");
}const s=_g(r,t),i=this.outputs.map((e=>[]));for(let t=0;t<s.length;++t){
xi((()=>{
const n=s[t][0],r=s[t][1],i=Ag(e,n,r),a=[];if(Array.isArray(i)){
for(let e=0;e<i.length;++e){
a.push({key:this.inputs[e],value:i[e]});
}
}else {
a.push({key:this.inputs[0],value:i});
}const o=new wm(a);return Im(this.outputs,o);
})).forEach(((e,t)=>i[t].push(e)));
}return Ap(i.map((e=>Ja(e,0))));
}));
}predict(e,t={}){
const n=Dg(e);Pg(n,this.inputNames,this.feedInputShapes,!1);try{
const e=null==t.batchSize?32:t.batchSize;return Rg(e),this.predictLoop(n,e);
}finally{
Og(n,e);
}
}predictOnBatch(e){
Pg(e,this.inputNames,this.feedInputShapes,!0);const t=(Array.isArray(e)?e[0]:e).shape[0];return this.predictLoop(e,t);
}standardizeUserDataXY(e,t,n=!0,r){
if(null==this.optimizer_){
throw new Ip("You must compile a model before training/testing. Use LayersModel.compile(modelCompileArgs).");
}const s=[];for(let e=0;e<this.feedOutputShapes.length;++e){
const t=this.feedOutputShapes[e];this.feedLossFns[e]===eg?s.push(t.slice(0,t.length-1).concat([1])):s.push(t);
}if(function(e,t,n){
const r=Bp(e.map((e=>e.shape[0])));r.sort();const s=Bp(t.map((e=>e.shape[0])));if(s.sort(),r.length>1){
throw new Sp(`All input Tensors (x) should have the same number of samples. Got array shapes: ${JSON.stringify(e.map((e=>e.shape)))}`);
}if(s.length>1){
throw new Sp(`All target Tensors (y) should have the same number of samples. Got array shapes: ${JSON.stringify(t.map((e=>e.shape)))}`);
}if(r.length>0&&s.length>0&&!g(r,s)){
throw new Sp(`Input Tensors should have the same number of samples as target Tensors. Found ${r[0]} input sample(s) and ${s[0]} target sample(s).`);
}
}(e=zg(e,this.feedInputNames,this.feedInputShapes,!1,"input"),t=zg(t,this.feedOutputNames,s,!1,"target")),function(e,t,n){
const r=[Ym,tg,Qm];for(let s=0;s<e.length;++s){
const i=e[s],a=t[s],o=n[s];if(null!=a){
if(a===Qm&&1===i.shape[i.shape.length-1]){
throw new Sp(`You are passing a target array of shape ${i.shape} while using a loss 'categorical_crossentropy'. 'categorical_crossentropy'expects targets to be binary matrices (1s and 0s) of shape [samples, classes].`);
}if(-1!==r.indexOf(a)){
const e=i.shape.slice(1),t=o.slice(1);for(let n=0;n<e.length;++n){
const r=e[n],s=t[n];if(null!=s&&r!==s){
throw new Sp(`A target Tensor with shape ${i.shape} was passed for an output of shape ${o}, while using a loss function that expects targets to have the same shape as the output.`);
}
}
}
}
}
}(t,this.feedLossFns,this.feedOutputShapes),this.stateful&&null!=r&&r>0&&e[0].shape[0]%r!=0){
throw new Sp(`In a stateful network, you should only pass inputs with a number of samples that is divisible by the batch size ${r}. Found: ${e[0].shape[0]} sample(s).`);
}return[e,t];
}async standardizeUserData(e,t,n,r,s=!0,i){
const[a,o]=this.standardizeUserDataXY(e,t,s,i);if(null!=n){
throw new Error("sample weight is not supported yet.");
}let u=null;if(null!=r){
const e=Sg(r,this.outputNames);u=[];for(let t=0;t<e.length;++t){
u.push(await Cg(o[t],null,e[t]));
}
}return[a,o,u];
}testLoop(e,t,n,r=0,s){
return xi((()=>{
const i=this.checkNumSamples(t,n,s,"steps"),a=[];if(r>0){
throw new Cp("Verbose mode is not implemented yet.");
}if(null!=s){
throw new Cp("steps mode in testLoop() is not implemented yet");
}{const r=_g(i,n),s=vu(gf(0,i));for(let n=0;n<r.length;++n){
const i=r[n][0],o=r[n][1],u=vf(s,i,o-i),l=Fg(t,u),c=e(l);if(0===n){
for(let e=0;e<c.length;++e){
a.push(Ri(0));
}
}for(let e=0;e<c.length;++e){
const t=c[e];a[e]=ki(a[e],Ci(o-i,t));
}
}for(let e=0;e<a.length;++e){
a[e]=Si(a[e],i);
}}return a;
}));
}getDedupedMetricsNames(){
const e=this.metricsNames,t=[];for(let n=0;n<e.length;++n){
const r=e[n];let s=r;Rp(e,r)>1&&(s+=`_${Rp(e.slice(0,n),r)}`),t.push(s);
}return t;
}makeTrainFunction(){
return e=>{
const t=[],n=e.slice(0,this.inputs.length),r=e.slice(this.inputs.length,this.inputs.length+this.outputs.length),s=e.slice(this.inputs.length+this.outputs.length,this.inputs.length+2*this.outputs.length),i=[],a=this.collectedTrainableWeights.map((e=>e.read()));return[this.optimizer_.minimize((()=>{
const e=[];for(let t=0;t<this.inputs.length;++t){
e.push({key:this.inputs[t],value:n[t]});
}const a=new wm(e),o=Im(this.outputs,a,{training:!0});let u;for(let e=0;e<this.lossFunctions.length;++e){
let n=(0,this.lossFunctions[e])(r[e],o[e]);null!=s[e]&&(n=Ng(n,s[e]));const i=_o(n);t.push(i),u=0===e?n:ki(u,n);
}for(let e=0;e<this.metricsTensors.length;++e){
let n;if(this.outputs.length>1&&e<this.outputs.length){
n=t[e];
}else{
const t=this.metricsTensors[e][0],s=this.metricsTensors[e][1];n=_o(t(r[s],o[s]));
}wi(n),i.push(n);
}return u=_o(u),this.calculateLosses().forEach((e=>{
u=ki(u,e);
})),u;
}),!0,a)].concat(i);
};
}makeTestFunction(){
this.testFunction=e=>xi((()=>{
const t=[];let n;const r=e.slice(0,this.inputs.length),s=e.slice(this.inputs.length,this.inputs.length+this.outputs.length),i=[];for(let e=0;e<this.inputs.length;++e){
i.push({key:this.inputs[e],value:r[e]});
}const a=new wm(i),o=Im(this.outputs,a);for(let e=0;e<this.lossFunctions.length;++e){
const r=this.lossFunctions[e],i=_o(r(s[e],o[e]));n=0===e?i:ki(n,i),t.push(n);
}for(let e=0;e<this.metricsTensors.length;++e){
const n=this.metricsTensors[e][0],r=this.metricsTensors[e][1],i=_o(n(s[r],o[r]));t.push(i);
}return t;
}));
}async fit(e,t,n={}){
if(this.isTraining){
throw new Error("Cannot start training because another fit() call is ongoing.");
}let r,s,i,a,o,u,l,c,h;this.isTraining=!0;try{
const d=null==n.batchSize?32:n.batchSize;Rg(d);const p=!1,f=await this.standardizeUserData(e,t,n.sampleWeight,n.classWeight,p,d);r=f[0],s=f[1],h=f[2];let m,g=!1;if(null!=n.validationData&&n.validationData.length>0){
if(g=!0,2!==n.validationData.length){
throw 3===n.validationData.length?new Cp("validationData including sample weights is not supported yet."):new Sp(`When passing validation data, it must contain 2 (valX, valY) or 3 (valX, valY, valSampleWeight) items; ${n.validationData} is invalid.`);
}o=n.validationData[0],u=n.validationData[1];const e=!0,t=await this.standardizeUserData(o,u,null,null,e,d);l=t[0],c=t[1],m=l.concat(c);
}else if(null!=n.validationSplit&&n.validationSplit>0&&n.validationSplit<1){
g=!0;const e=Math.floor(r[0].shape[0]*(1-n.validationSplit)),t=r[0].shape[0];l=Ag(r,e,t),i=r,r=Ag(r,0,e),c=Ag(s,e,t),a=s,s=Ag(s,0,e),m=l.concat(c);
}else {
null!=n.validationSteps&&(g=!0);
}const b=r.concat(s).concat(h);this.checkTrainableWeightsConsistency();const x=this.makeTrainFunction(),y=this.getDedupedMetricsNames();let w,v;g?(this.makeTestFunction(),w=this.testFunction,v=y.slice().concat(y.map((e=>"val_"+e)))):(w=null,m=[],v=y.slice());const k=jm(n.callbacks,n.yieldEvery);return await this.fitLoop(x,b,y,d,n.epochs,n.verbose,k,w,m,n.shuffle,v,n.initialEpoch,null,null);
}finally{
this.isTraining=!1,Og(r,e),Og(s,t),Og(i,e),Og(a,t),Og(l,o),Og(c,u),null!=h&&yi(h);
}
}async fitLoop(e,t,n,r,s,i,a,o,l,c,h,d,p,f){
null==r&&(r=32),null==s&&(s=1),null==c&&(c=!0),null==d&&(d=0);let m=!1;if(null!=o&&null!=l&&(m=!0),null!=f&&(m=!0,null==p)){
throw new Sp("Can only use `validationSteps` when doing step-wise training, i.e., `stepsPerEpoch` must be set.");
}const g=this.checkNumSamples(t,r,p,"steps_per_epoch");let b;null!=g&&(b=gf(0,g)),null==i&&(i=1);const{callbackList:x,history:y}=qm(a,i,s,d,g,p,r,m,h);x.setModel(this),this.history=y,await x.onTrainBegin(),this.stopTraining_=!1;for(let i=d;i<s;++i){
await x.onEpochBegin(i);const s={};if(null!=p){
throw new Cp("stepsPerEpoch mode is not implemented yet.");
}{if("batch"===c){
throw new Cp("batch shuffling is not implemneted yet");
}c&&u(b);const i=vu(b),a=_g(g,r);for(let u=0;u<a.length;++u){
const c={};if(await x.onBatchBegin(u,c),xi((()=>{
const h=a[u][0],d=a[u][1],p=vf(i,h,d-h);c.batch=u,c.size=d-h;const f=Fg(t,p),g=e(f);for(let e=0;e<n.length;++e){
const t=n[e],r=g[e];c[t]=r,wi(r);
}if(u===a.length-1&&m){
const e=this.testLoop(o,l,r);for(let t=0;t<n.length;++t){
const r=n[t],i=e[t];wi(i),s["val_"+r]=i;
}
}
})),await x.onBatchEnd(u,c),zm(c),this.stopTraining_){
break;
}
}i.dispose();}if(await x.onEpochEnd(i,s),this.stopTraining_){
break;
}
}return await x.onTrainEnd(),await this.history.syncData(),this.history;
}async fitDataset(e,t){
return async function(e,t,n){
const r=null!=n.batchesPerEpoch;if(d(null!=e.optimizer,(()=>"You must compile a model before training/testing. Use LayersModel.compile(modelCompileConfig).")),d(null!=n,(()=>"For fitDataset(), the 2nd argument (config) is required, but it is not provided in this call.")),d(null!=n.epochs&&n.epochs>0&&Number.isInteger(n.epochs),(()=>`For fitDataset(), config.epochs is expected to be a positive integer, but got ${n.epochs}`)),d(!r||n.batchesPerEpoch>0&&Number.isInteger(n.batchesPerEpoch),(()=>`For fitDataset(), config.batchesPerEpoch is expected to be a positive integer if specified, but got ${n.batchesPerEpoch}`)),d(null==n.validationSplit,(()=>"`validationSplit` is not supported by `fitDataset()`. Use validationData instead.")),e.isTraining){
throw new Error("Cannot start training because another fit() call is ongoing.");
}e.isTraining=!0;try{
const s=null!=n.validationData;let i,a;if(s){
if(Eg(n.validationData)){
d(null==n.validationBatches||n.validationBatches>0&&Number.isInteger(n.validationBatches),(()=>`For fitDataset() with dataset-based validation, config.validationBatches is expected not to be provided, or to be a positive integer, but got ${n.validationBatches}`));
}else{
const e=function(e){
if(3===e.length){
throw new Cp("Validation with sample weights is not implemented yet.");
}return{xs:e[0],ys:e[1]};
}(n.validationData);i=e.xs,a=e.ys;
}
}const o=e.makeTrainFunction(),u=e.getDedupedMetricsNames();let l;l=s?u.slice().concat(u.map((e=>"val_"+e))):u.slice();const c=jm(n.callbacks,n.yieldEvery),h=null==n.verbose?1:n.verbose,{callbackList:p,history:f}=qm(c,h,n.epochs,null,null,function(e,t){
let n=null;return null!=t.batchesPerEpoch?n=t.batchesPerEpoch:Number.isFinite(e.size)&&(n=e.size),n;
}(t,n),null,s,l);p.setModel(e),e.history=f,await p.onTrainBegin(),e.stopTraining_=!1;let m=null==n.initialEpoch?0:n.initialEpoch,g=await t.iterator();for(;m<n.epochs;){
const l={};await p.onEpochBegin(m);let c=0,h=0;for(r||(g=await t.iterator());!r||c<n.batchesPerEpoch;){
const t=await g.next();if(r&&t.done){
console.warn(`You provided \`batchesPerEpoch\` as ${n.batchesPerEpoch}, but your dataset iterator ran out of data after ${c} batches; interrupting training. Make sure that your dataset can generate at least \`batchesPerEpoch * epochs\` batches (in this case, `+n.batchesPerEpoch*n.epochs+" batches). You may need to use the repeat() function when building your dataset.");break;
}if(null!=t.value){
const{xs:r,ys:s}=$g(e,t.value),i={};i.batch=h,i.size=r[0].shape[0],await p.onBatchBegin(h,i);const a=[];if(null!=n.classWeight){
const t=Sg(n.classWeight,e.outputNames);for(let e=0;e<t.length;++e){
a.push(await Cg(s[e],null,t[e]));
}
}const l=r.concat(s).concat(a),d=o(l);yi(l);for(let e=0;e<u.length;++e){
const t=u[e],n=d[e];i[t]=n,wi(n);
}await p.onBatchEnd(h,i),zm(i),h++,c++;
}if(r?c>=n.batchesPerEpoch:t.done){
if(s){
let t;t=Eg(n.validationData)?Fp(await e.evaluateDataset(n.validationData,{batches:n.validationBatches})):Fp(e.evaluate(i,a,{batchSize:null==n.validationBatchSize?32:n.validationBatchSize,verbose:0}));for(let n=0;n<e.metricsNames.length;++n){
l[`val_${e.metricsNames[n]}`]=t[n];
}
}break;
}if(e.stopTraining_){
break;
}
}if(await p.onEpochEnd(m,l),m++,e.stopTraining_){
break;
}
}return await p.onTrainEnd(),await e.history.syncData(),e.history;
}finally{
e.isTraining=!1;
}
}(this,e,t);
}async trainOnBatch(e,t){
const n=await this.standardizeUserData(e,t),r=n[0],s=n[1],i=this.makeTrainFunction()(r.concat(s)),a=[];for(const e of i){
const t=await e.data();a.push(t[0]);
}return yi(i),Og(n[0],e),Og(n[1],t),Ap(a);
}getNamedWeights(e){
const t=[],n=null!=e&&e.trainableOnly,r=n?this.trainableWeights:this.weights,s=this.getWeights(n);for(let e=0;e<r.length;++e){
n&&!r[e].trainable||t.push({name:r[e].originalName,tensor:s[e]});
}return t;
}set stopTraining(e){
this.stopTraining_=e;
}get stopTraining(){
return this.stopTraining_;
}get optimizer(){
return this.optimizer_;
}set optimizer(e){
this.optimizer_!==e&&(this.optimizer_=e,this.isOptimizerOwned=!1);
}dispose(){
const e=super.dispose();if(0===e.refCountAfterDispose&&null!=this.optimizer&&this.isOptimizerOwned){
const t=bi().numTensors;this.optimizer_.dispose(),e.numDisposedVariables+=t-bi().numTensors;
}return e;
}getLossIdentifiers(){
let e;if("string"==typeof this.loss){
e=_p(this.loss);
}else if(Array.isArray(this.loss)){
for(const e of this.loss){
if("string"!=typeof e){
throw new Error("Serialization of non-string loss is not supported.");
}
}e=this.loss.map((e=>_p(e)));
}else{
const t=Object.keys(this.loss);e={};const n=this.loss;for(const r of t){
if("string"!=typeof n[r]){
throw new Error("Serialization of non-string loss is not supported.");
}e[r]=_p(n[r]);
}
}return e;
}getMetricIdentifiers(){
if("string"==typeof this.metrics||"function"==typeof this.metrics){
return[_p(pg(this.metrics))];
}if(Array.isArray(this.metrics)){
return this.metrics.map((e=>_p(pg(e))));
}{const e={};for(const t in this.metrics){
e[t]=_p(pg(this.metrics[t]));
}return e;}
}getTrainingConfig(){
return{loss:this.getLossIdentifiers(),metrics:this.getMetricIdentifiers(),optimizer_config:{class_name:this.optimizer.getClassName(),config:this.optimizer.getConfig()}};
}loadTrainingConfig(e){
if(null!=e.weighted_metrics){
throw new Error("Loading weight_metrics is not supported yet.");
}if(null!=e.loss_weights){
throw new Error("Loading loss_weights is not supported yet.");
}if(null!=e.sample_weight_mode){
throw new Error("Loading sample_weight_mode is not supported yet.");
}const t=Km(wg(e.optimizer_config));let n,r;if("string"==typeof e.loss){
n=Dp(e.loss);
}else if(Array.isArray(e.loss)){
n=e.loss.map((e=>Dp(e)));
}else if(null!=e.loss){
n={};for(const t in e.loss){
n[t]=Dp(e.loss[t]);
}
}if(Array.isArray(e.metrics)){
r=e.metrics.map((e=>Dp(e)));
}else if(null!=e.metrics){
r={};for(const t in e.metrics){
r[t]=Dp(e.metrics[t]);
}
}this.compile({loss:n,metrics:r,optimizer:t});
}async save(e,t){
if("string"==typeof e){
const t=(e=>Ws.getSaveHandlers(e))(e);if(0===t.length){
throw new Sp(`Cannot find any save handlers for URL '${e}'`);
}if(t.length>1){
throw new Sp(`Found more than one (${t.length}) save handlers for URL '${e}'`);
}e=t[0];
}if(null==e.save){
throw new Sp("LayersModel.save() cannot proceed because the IOHandler provided does not have the `save` attribute defined.");
}const n=await Ms(this.getNamedWeights(t)),r={modelTopology:this.toJSON(null,!1),format:"layers-model",generatedBy:`TensorFlow.js tfjs-layers v${kg}`,convertedBy:null};if(null!=t&&t.includeOptimizer&&null!=this.optimizer){
r.trainingConfig=this.getTrainingConfig();const e="optimizer",{data:t,specs:i}=await Ms(await this.optimizer.getWeights(),e);n.specs.push(...i),n.data=(s=[n.data,t],Os.join(s));
}var s;if(null!=this.userDefinedMetadata){
const e=!0;fg(this.userDefinedMetadata,this.name,e),r.userDefinedMetadata=this.userDefinedMetadata;
}return r.weightData=n.data,r.weightSpecs=n.specs,e.save(r);
}setUserDefinedMetadata(e){
fg(e,this.name),this.userDefinedMetadata=e;
}getUserDefinedMetadata(){
return this.userDefinedMetadata;
}
}Bg.className="Model",Oi(Bg);class Ug extends Bg{}Ug.className="Functional",Oi(Ug);class Wg extends Bg{
constructor(e){
if(super({inputs:[],outputs:[]}),e=e||{},this.trainable=!0,this.built=!1,this.name=null!=e.name?e.name:Yp("sequential_"),null!=e.layers){
for(const t of e.layers){
this.add(t);
}
}
}checkShape(e){
if(e.inboundNodes[0].outputTensors[0].shape.some((e=>e<0))){
throw new Sp(`Negative dimension size caused by adding layer ${e.name} with input shape [${e.inboundNodes[0].inputTensors[0].shape}]`);
}
}add(e){
const t=e instanceof Wg||e instanceof Bg;let n;if(t){
if(n=e,1!==n.outputs.length){
throw new Sp("All layers in a Sequential model should have a single output tensor. For multi-output layers, use the functional API.");
}if(1!==n.inputs.length){
throw new Sp("All layers in a Sequential model should have a single input tensor. For multi-input layers, use the functional API.");
}
}if(0===this.outputs.length){
if(0===e.inboundNodes.length){
if(null==e.batchInputShape){
throw new Sp("The first layer in a Sequential model must get an `inputShape` or `batchInputShape` argument.");
}const t=function(e){
if(null==e.batchShape&&null==e.shape){
throw new Error("Please provide to Input either a `shape` or a `batchShape` argument. Note that `shape` does not include the batch dimension.");
}if(null!=e.batchShape&&null!=e.shape){
throw new Sp("Please provide either a `shape` or `batchShape` argument to Input, but not both.");
}let t=e.batchShape;null!=e.shape&&null==t&&(t=[null].concat(e.shape));let n=e.dtype;return null==n&&(n="float32"),new ym({batchInputShape:t,name:e.name,dtype:n,sparse:e.sparse}).inboundNodes[0].outputTensors[0];
}({batchShape:e.batchInputShape,dtype:e.dtype,name:e.name+"_input"});e.apply(t);
}if(t){
this.outputs=n.outputs,this.inputs=n.inputs;
}else{
if(1!==e.inboundNodes.length){
throw new Sp(`A layer added to a Sequential model must not already be connected somewhere else. LayersModel received layer ${e.name} which has ${e.inboundNodes.length} pre-existing inbound connections.`);
}if(1!==e.inboundNodes[0].outputTensors.length){
throw new Sp("All layers in a Sequential model should have a single output tensor. For multi-output layers, use the functional API.");
}this.checkShape(e),this.outputs=[e.inboundNodes[0].outputTensors[0]],this.inputs=xm(this.outputs[0]);
}this.inboundNodes=[],new mm({outboundLayer:this,inboundLayers:[],nodeIndices:[],tensorIndices:[],inputTensors:this.inputs,outputTensors:this.outputs,inputMasks:Tp(null,this.inputs.length),outputMasks:[null],inputShapes:this.inputs.map((e=>e.shape)),outputShapes:this.outputs[0].shape});
}else{
const t=e.apply(this.outputs[0]);if(Array.isArray(t)){
throw new TypeError("All layers in a Sequential model should have a single output tensor. For multi-output layers, use the functional API.");
}this.checkShape(e),this.outputs=[t],this.inboundNodes[0].outputTensors=this.outputs,this.inboundNodes[0].outputShapes=[this.outputs[0].shape];
}this.layers.push(e),this.built=!1;
}pop(){
if(0===this.layers.length){
throw new TypeError("There are no layers in the model.");
}if(this.layers.pop(),0===this.layers.length){
this.outputs=[],this.inboundNodes=[],this.outboundNodes=[];
}else{
const e=this.layers.length-1;this.layers[e].outboundNodes=[],this.outputs=[this.layers[e].output],this.inboundNodes[0].outputTensors=this.outputs,this.inboundNodes[0].outputShapes=[this.outputs[0].shape];
}
}call(e,t){
return null==this.model&&this.build(),this.model.call(e,t);
}build(e){
if(am(e),0===this.inputs.length||0===this.outputs.length){
throw new TypeError("Sequential model cannot be built: model is empty. Add some layers first.");
}this.model=new Bg({inputs:this.inputs,outputs:this.outputs[0],name:this.name+"_model"}),this.model.trainable=this.trainable,this.supportsMasking=this.model.supportsMasking,this.inputLayers=this.model.inputLayers,this.inputLayersNodeIndices=this.model.inputLayersNodeIndices,this.inputLayersTensorIndices=this.model.inputLayersTensorIndices,this.outputLayers=this.model.outputLayers,this.outputLayersNodeIndices=this.model.outputLayersNodeIndices,this.outputLayersTensorIndices=this.model.outputLayersTensorIndices,this.nodesByDepth=this.model.nodesByDepth,this.containerNodes=this.model.containerNodes,this.outputNames=this.model.outputNames,this.inputNames=this.model.inputNames,this.built=!0;
}countParams(){
return this.built||this.build(),super.countParams();
}summary(e,t,n=console.log){
this.built||this.build(),super.summary(e,t,n);
}setWeights(e){
null==this.model&&this.build(),this.model.setWeights(e);
}evaluate(e,t,n={}){
if(!this.built){
throw new Ip("The model needs to be compiled before being used.");
}return this.model.evaluate(e,t,n);
}async evaluateDataset(e,t){
if(!this.built){
throw new Ip("The model needs to be compiled before being used.");
}return this.model.evaluateDataset(e,t);
}predict(e,t={}){
return null==this.model&&this.build(),this.model.predict(e,t);
}predictOnBatch(e){
return null==this.model&&this.build(),this.model.predictOnBatch(e);
}compile(e){
this.build(),this.model.compile(e),this.optimizer_=this.model.optimizer,this.isOptimizerOwned=this.model.isOptimizerOwned,this.loss=this.model.loss,this.metrics=this.model.metrics,this.metricsTensors=this.model.metricsTensors,this.metricsNames=this.model.metricsNames;
}get optimizer(){
return null==this.model?void 0:this.model.optimizer;
}set optimizer(e){
this.model.optimizer=e;
}async fit(e,t,n={}){
if(!this.built){
throw new Ip("The model needs to be compiled before being used.");
}return this.model.fit(e,t,n);
}async fitDataset(e,t){
if(!this.built){
throw new Ip("The model needs to be compiled before being used.");
}return this.model.fitDataset(e,t);
}async trainOnBatch(e,t){
return this.model.trainOnBatch(e,t);
}static fromConfig(e,t,n={},r=!1){
let s,i={};if(t instanceof Array){
if(null==t[0].className||"Merge"===t[0].className){
throw new Sp("Legacy serialization format not supported yet.");
}s=t;
}else {
d(null!=t.layers,(()=>"When the config data for a Sequential model is not an Array, it must be an Object that contains the 'layers' field.")),s=t.layers,delete t.layers,i=t;
}const a=new e(i);if(!(a instanceof Wg)){
throw new Cp(`Sequential.fromConfig called on non-Sequential input: ${a}`);
}for(const e of s){
const t=Km(e,void 0,r);r&&t.setFastWeightInitDuringBuild(!0),a.add(t);
}return a;
}set stopTraining(e){
if(null==this.model){
throw new Sp("Cannot set the stopTraining property of a sequential model before it is compiled.");
}this.model.stopTraining=e;
}get stopTraining(){
if(null==this.model){
throw new Sp("Cannot get the stopTraining property of a sequential model before it is compiled.");
}return this.model.stopTraining;
}getConfig(){
const e=[];for(const t of this.layers){
const n={};n.className=t.getClassName(),n.config=t.getConfig(),e.push(n);
}return{name:this.name,layers:e};
}
}Wg.className="Sequential",Oi(Wg);class Vg extends _i{
getConfig(){
return{};
}
}class Gg extends Vg{
apply(e,t=1){
return function(e,t=1){
if(1!==t){
throw new Cp(`Support for alpha values other than 1 (${t}) is not implemented yet.`);
}return po(e);
}(e,t);
}
}Gg.className="elu",Oi(Gg);class jg extends Vg{
apply(e){
return ou(e);
}
}jg.className="selu",Oi(jg);class Hg extends Vg{
apply(e){
return iu(e);
}
}Hg.className="relu",Oi(Hg);class qg extends Vg{
apply(e){
return xi((()=>Oo(6,iu(e))));
}
}qg.className="relu6",Oi(qg);class Kg extends Vg{
apply(e){
return e;
}
}Kg.className="linear",Oi(Kg);class Xg extends Vg{
apply(e){
return lu(e);
}
}Xg.className="sigmoid",Oi(Xg);class Yg extends Vg{
apply(e){
return function(e){
return xi((()=>{
const t=ki(.5,Ci(.2,e));return Za(t,0,1);
}));
}(e);
}
}Yg.className="hardSigmoid",Oi(Yg);class Zg extends Vg{
apply(e){
return gu(e);
}
}Zg.className="softplus",Oi(Zg);class Jg extends Vg{
apply(e){
return function(e){
return xi((()=>Si(e,ki(Vi(e),1))));
}(e);
}
}Jg.className="softsign",Oi(Jg);class Qg extends Vg{
apply(e){
return wu(e);
}
}Qg.className="tanh",Oi(Qg);class eb extends Vg{
apply(e,t=-1){
return mu(e,t);
}
}eb.className="softmax",Oi(eb);class tb extends Vg{
apply(e,t=-1){
return To(e,t);
}
}tb.className="logSoftmax",Oi(tb);class nb extends Vg{
apply(e,t=1){
return xi((()=>Ci(lu(Ci(e,t)),e)));
}
}nb.className="swish",Oi(nb);class rb extends Vg{
apply(e){
return xi((()=>Ci(e,wu(gu(e)))));
}
}function sb(e){
return e.getClassName();
}function ib(e,t={}){
return zp(e,Di.getMap().classNameMap,t,"activation");
}function ab(e){
if(null==e){
return ib({className:"linear",config:{}});
}if("string"==typeof e){
const t={};return t.className=e,t.config={},ib(t);
}return e instanceof Vg?e:ib(e);
}rb.className="mish",Oi(rb);class ob extends _i{}class ub extends ob{
constructor(e){
super(),function(e){
if(null!=e&&"object"!=typeof e){
throw new Error(`Argument to L1L2 regularizer's constructor is expected to be an object, but received: ${e}`);
}
}(e),this.l1=null==e||null==e.l1?.01:e.l1,this.l2=null==e||null==e.l2?.01:e.l2,this.hasL1=0!==this.l1,this.hasL2=0!==this.l2;
}apply(e){
return xi((()=>{
let t=Ko([1]);return this.hasL1&&(t=ki(t,$o(Ci(this.l1,Vi(e))))),this.hasL2&&(t=ki(t,$o(Ci(this.l2,Rf(e))))),Va(t,[]);
}));
}getConfig(){
return{l1:this.l1,l2:this.l2};
}static fromConfig(e,t){
return new e({l1:t.l1,l2:t.l2});
}
}ub.className="L1L2",Oi(ub);const lb={l1l2:"L1L2"};function cb(e){
return Mp(e);
}function hb(e,t={}){
return zp(e,Di.getMap().classNameMap,t,"regularizer");
}function db(e){
return null==e?null:"string"==typeof e?hb({className:e in lb?lb[e]:e,config:{}}):e instanceof ob?e:hb(e);
}class pb extends bm{
constructor(e){
super(null==e?{}:e),this.supportsMasking=!0,null!=e&&(this.maxValue=e.maxValue);
}call(e,t){
e=im(e);let n=iu(e);return null!=this.maxValue&&(n=Za(n,0,this.maxValue)),n;
}computeOutputShape(e){
return e;
}getConfig(){
const e={maxValue:this.maxValue},t=super.getConfig();return Object.assign(e,t),e;
}
}pb.className="ReLU",Oi(pb);class fb extends bm{
constructor(e){
super(null==e?{}:e),this.DEFAULT_ALPHA=.3,null==e&&(e={}),this.alpha=null==e.alpha?this.DEFAULT_ALPHA:e.alpha;
}call(e,t){
const n=im(e);return Io(n,this.alpha);
}computeOutputShape(e){
return e;
}getConfig(){
const e={alpha:this.alpha},t=super.getConfig();return Object.assign(e,t),e;
}
}fb.className="LeakyReLU",Oi(fb);class mb extends bm{
constructor(e){
if(super(null==e?{}:e),this.DEFAULT_ALPHA_INITIALIZER="zeros",null==e&&(e={}),this.supportsMasking=!0,this.alphaInitializer=nm(e.alphaInitializer||this.DEFAULT_ALPHA_INITIALIZER),this.alphaRegularizer=db(e.alphaRegularizer),this.alphaConstraint=Mm(e.alphaConstraint),null==e.sharedAxes){
this.sharedAxes=null;
}else if(Array.isArray(e.sharedAxes)){
this.sharedAxes=e.sharedAxes;
}else{
if("number"!=typeof e.sharedAxes){
throw new Sp(`Expected sharedAxes to be a number or an array of numbers, but got ${e.sharedAxes}`);
}this.sharedAxes=[e.sharedAxes];
}
}build(e){
const t=(e=am(e)).slice(1);if(null!=this.sharedAxes){
for(const e of this.sharedAxes){
t[e-1]=1;
}
}this.alpha=this.addWeight("alpha",t,"float32",this.alphaInitializer,this.alphaRegularizer,!0,this.alphaConstraint);const n={};if(null!=this.sharedAxes){
for(let t=1;t<e.length;++t){
n[t]=e[t];
}
}this.inputSpec=[new dm({ndim:e.length,axes:n})],this.built=!0;
}call(e,t){
return e=im(e),Jo(e,this.alpha.read());
}getConfig(){
const e={alphaInitializer:tm(this.alphaInitializer),alphaRegularizer:cb(this.alphaRegularizer),alphaConstraint:Dm(this.alphaConstraint),sharedAxes:this.sharedAxes},t=super.getConfig();return Object.assign(e,t),e;
}
}mb.className="PReLU",Oi(mb);class gb extends bm{
constructor(e){
if(super(null==e?{}:e),this.DEFAULT_ALPHA=1,null==e&&(e={}),null!=e.alpha&&e.alpha!==this.DEFAULT_ALPHA){
throw new Cp(`Non-default alpha value (${e.alpha}) is not supported by the ELU layer yet.`);
}this.alpha=null==e.alpha?this.DEFAULT_ALPHA:e.alpha;
}call(e,t){
const n=im(e);return po(n);
}computeOutputShape(e){
return e;
}getConfig(){
const e={alpha:this.alpha},t=super.getConfig();return Object.assign(e,t),e;
}
}gb.className="ELU",Oi(gb);class bb extends bm{
constructor(e){
super(null==e?{}:e),this.DEFAULT_THETA=1,null==e&&(e={}),this.theta=null==e.theta?this.DEFAULT_THETA:e.theta;
}call(e,t){
const n=im(e);return Ci(n,fi(vo(n,this.theta),"float32"));
}computeOutputShape(e){
return e;
}getConfig(){
const e={theta:this.theta},t=super.getConfig();return Object.assign(e,t),e;
}
}bb.className="ThresholdedReLU",Oi(bb);class xb extends bm{
constructor(e){
super(null==e?{}:e),this.DEFAULT_AXIS=1,null==e&&(e={}),this.softmax=(new eb).apply,this.axis=null==e.axis?this.DEFAULT_AXIS:e.axis;
}call(e,t){
const n=im(e);return this.softmax(n,this.axis);
}computeOutputShape(e){
return e;
}getConfig(){
const e={axis:this.axis},t=super.getConfig();return Object.assign(e,t),e;
}
}function yb(e,t,n){
if("number"==typeof e){
return Tp(e,t);
}if(e.length!==t){
throw new Sp(`The ${n} argument must be an integer or tuple of ${t} integers. Received: ${e.length} elements.`);
}for(let s=0;s<t;++s){
const i=e[s];if((r=i)!==parseInt(r.toString(),10)){
throw new Sp(`The ${n} argument must be an integer or tuple of ${t} integers. Received: ${JSON.stringify(e)} including a non-integer number ${i}`);
}
}return e;var r;
}function wb(e,t,n,r,s=1){
if(null==e){
return e;
}let i;return i="same"===n?e:e-(t+(t-1)*(s-1))+1,Math.floor((i+r-1)/r);
}function vb(e,t,n,r){
if(null==e){
return null;
}if("valid"===r){
e=e*t+mf([n-t,0]);
}else{
if("same"!==r){
throw new Sp(`Unsupport padding mode: ${r}.`);
}e*=t;
}return e;
}function kb(e,t){
return xi((()=>(rf(t),"channelsFirst"===t?$u(e,[0,2,3,1]):e)));
}function Ib(e,t){
return xi((()=>(rf(t),"channelsFirst"===t?$u(e,[0,2,3,4,1]):e)));
}function Sb(e,t,n,r=[1,1],s="valid",i,a,o=null){
return xi((()=>{
if(null==i&&(i="channelsLast"),rf(i),3!==e.rank&&4!==e.rank){
throw new Sp(`conv2dWithBiasActivation expects input to be of rank 3 or 4, but received ${e.rank}.`);
}if(3!==t.rank&&4!==t.rank){
throw new Sp(`conv2dWithBiasActivation expects kernel to be of rank 3 or 4, but received ${e.rank}.`);
}let u=kb(e,i);if("causal"===s){
throw new Cp("The support for CAUSAL padding mode in conv1dWithBias is not implemented yet.");
}return u=Bu({x:u,filter:t,strides:r,pad:"same"===s?"same":"valid",dilations:a,dataFormat:"NHWC",bias:n,activation:o}),"channelsFirst"===i&&(u=$u(u,[0,3,1,2])),u;
}));
}xb.className="Softmax",Oi(xb);class Cb extends bm{
constructor(e,t){
if(super(t),this.bias=null,this.DEFAULT_KERNEL_INITIALIZER="glorotNormal",this.DEFAULT_BIAS_INITIALIZER="zeros",Cb.verifyArgs(t),this.rank=e,Gp(this.rank,"rank"),1!==this.rank&&2!==this.rank&&3!==this.rank){
throw new Cp(`Convolution layer for rank other than 1, 2, or 3 (${this.rank}) is not implemented yet.`);
}if(this.kernelSize=yb(t.kernelSize,e,"kernelSize"),this.strides=yb(null==t.strides?1:t.strides,e,"strides"),this.padding=null==t.padding?"valid":t.padding,sf(this.padding),this.dataFormat=null==t.dataFormat?"channelsLast":t.dataFormat,rf(this.dataFormat),this.activation=ab(t.activation),this.useBias=null==t.useBias||t.useBias,this.biasInitializer=nm(t.biasInitializer||this.DEFAULT_BIAS_INITIALIZER),this.biasConstraint=Mm(t.biasConstraint),this.biasRegularizer=db(t.biasRegularizer),this.activityRegularizer=db(t.activityRegularizer),this.dilationRate=yb(null==t.dilationRate?1:t.dilationRate,e,"dilationRate"),1===this.rank&&Array.isArray(this.dilationRate)&&1!==this.dilationRate.length){
throw new Sp(`dilationRate must be a number or an array of a single number for 1D convolution, but received ${JSON.stringify(this.dilationRate)}`);
}if(2===this.rank){
if("number"==typeof this.dilationRate){
this.dilationRate=[this.dilationRate,this.dilationRate];
}else if(2!==this.dilationRate.length){
throw new Sp(`dilationRate must be a number or array of two numbers for 2D convolution, but received ${JSON.stringify(this.dilationRate)}`);
}
}else if(3===this.rank){
if("number"==typeof this.dilationRate){
this.dilationRate=[this.dilationRate,this.dilationRate,this.dilationRate];
}else if(3!==this.dilationRate.length){
throw new Sp(`dilationRate must be a number or array of three numbers for 3D convolution, but received ${JSON.stringify(this.dilationRate)}`);
}
}
}static verifyArgs(e){
if(Ep("kernelSize"in e,"required key 'kernelSize' not in config"),"number"!=typeof e.kernelSize&&!Vp(e.kernelSize,"number",1,3)){
throw new Sp(`BaseConv expects config.kernelSize to be number or number[] with length 1, 2, or 3, but received ${JSON.stringify(e.kernelSize)}.`);
}
}getConfig(){
const e={kernelSize:this.kernelSize,strides:this.strides,padding:this.padding,dataFormat:this.dataFormat,dilationRate:this.dilationRate,activation:sb(this.activation),useBias:this.useBias,biasInitializer:tm(this.biasInitializer),biasRegularizer:cb(this.biasRegularizer),activityRegularizer:cb(this.activityRegularizer),biasConstraint:Dm(this.biasConstraint)},t=super.getConfig();return Object.assign(e,t),e;
}
}class Nb extends Cb{
constructor(e,t){
super(e,t),this.kernel=null,Nb.verifyArgs(t),this.filters=t.filters,Gp(this.filters,"filters"),this.kernelInitializer=nm(t.kernelInitializer||this.DEFAULT_KERNEL_INITIALIZER),this.kernelConstraint=Mm(t.kernelConstraint),this.kernelRegularizer=db(t.kernelRegularizer);
}build(e){
e=am(e);const t="channelsFirst"===this.dataFormat?1:e.length-1;if(null==e[t]){
throw new Sp(`The channel dimension of the input should be defined. Found ${e[t]}`);
}const n=e[t],r=this.kernelSize.concat([n,this.filters]);this.kernel=this.addWeight("kernel",r,null,this.kernelInitializer,this.kernelRegularizer,!0,this.kernelConstraint),this.useBias&&(this.bias=this.addWeight("bias",[this.filters],null,this.biasInitializer,this.biasRegularizer,!0,this.biasConstraint)),this.inputSpec=[{ndim:this.rank+2,axes:{[t]:n}}],this.built=!0;
}call(e,t){
return xi((()=>{
let t;e=im(e);const n=null==this.bias?null:this.bias.read(),r=Hp(this.activation.getClassName());if(null!=r&&2===this.rank){
t=Sb(e,this.kernel.read(),n,this.strides,this.padding,this.dataFormat,this.dilationRate,r);
}else{
if(1===this.rank){
t=function(e,t,n,r=1,s="valid",i,a=1){
return xi((()=>{
if(null==i&&(i="channelsLast"),rf(i),3!==e.shape.length){
throw new Sp(`The input of a conv1dWithBias operation should be 3, but is ${e.shape.length} instead.`);
}if(3!==t.shape.length){
throw new Sp(`The kernel for a conv1dWithBias operation should be 3, but is ${t.shape.length} instead`);
}if(null!=n&&1!==n.shape.length){
throw new Sp(`The bias for a conv1dWithBias operation should be 1, but is ${t.shape.length} instead`);
}if("channelsFirst"===i&&(e=$u(e,[0,2,1])),"causal"===s){
throw new Cp("The support for CAUSAL padding mode in conv1dWithBias is not implemented yet.");
}let o=so(e,t,r,"same"===s?"same":"valid","NWC",a);return null!=n&&(o=Ff(o,n)),o;
}));
}(e,this.kernel.read(),n,this.strides[0],this.padding,this.dataFormat,this.dilationRate[0]);
}else if(2===this.rank){
t=Sb(e,this.kernel.read(),n,this.strides,this.padding,this.dataFormat,this.dilationRate);
}else{
if(3!==this.rank){
throw new Cp("convolutions greater than 3D are not implemented yet.");
}t=function(e,t,n,r=[1,1,1],s="valid",i,a){
return xi((()=>{
if(null==i&&(i="channelsLast"),rf(i),4!==e.rank&&5!==e.rank){
throw new Sp(`conv3dWithBias expects input to be of rank 4 or 5, but received ${e.rank}.`);
}if(4!==t.rank&&5!==t.rank){
throw new Sp(`conv3dWithBias expects kernel to be of rank 4 or 5, but received ${e.rank}.`);
}let o=Ib(e,i);if("causal"===s){
throw new Cp("The support for CAUSAL padding mode in conv3dWithBias is not implemented yet.");
}return o=oo(o,t,r,"same"===s?"same":"valid","NDHWC",a),null!=n&&(o=Ff(o,n)),"channelsFirst"===i&&(o=$u(o,[0,4,1,2,3])),o;
}));
}(e,this.kernel.read(),n,this.strides,this.padding,this.dataFormat,this.dilationRate);
}null!=this.activation&&(t=this.activation.apply(t));
}return t;
}));
}computeOutputShape(e){
e=am(e);const t=[],n="channelsLast"===this.dataFormat?e.slice(1,e.length-1):e.slice(2);for(let e=0;e<n.length;++e){
const r=wb(n[e],this.kernelSize[e],this.padding,this.strides[e],"number"==typeof this.dilationRate?this.dilationRate:this.dilationRate[e]);t.push(r);
}let r=[e[0]];return"channelsLast"===this.dataFormat?(r=r.concat(t),r.push(this.filters)):(r.push(this.filters),r=r.concat(t)),r;
}getConfig(){
const e={filters:this.filters,kernelInitializer:tm(this.kernelInitializer),kernelRegularizer:cb(this.kernelRegularizer),kernelConstraint:Dm(this.kernelConstraint)},t=super.getConfig();return Object.assign(e,t),e;
}static verifyArgs(e){
if(!("filters"in e)||"number"!=typeof e.filters||e.filters<1){
throw new Sp(`Convolution layer expected config.filters to be a 'number' > 0 but got ${JSON.stringify(e.filters)}`);
}
}
}class $b extends Nb{
constructor(e){
super(2,e),$b.verifyArgs(e);
}getConfig(){
const e=super.getConfig();return delete e.rank,e;
}static verifyArgs(e){
if("number"!=typeof e.kernelSize&&!Vp(e.kernelSize,"number",1,2)){
throw new Sp(`Conv2D expects config.kernelSize to be number or number[] with length 1 or 2, but received ${JSON.stringify(e.kernelSize)}.`);
}
}
}$b.className="Conv2D",Oi($b);class Tb extends Nb{
constructor(e){
super(3,e),Tb.verifyArgs(e);
}getConfig(){
const e=super.getConfig();return delete e.rank,e;
}static verifyArgs(e){
if("number"!=typeof e.kernelSize&&(!Array.isArray(e.kernelSize)||1!==e.kernelSize.length&&3!==e.kernelSize.length)){
throw new Sp(`Conv3D expects config.kernelSize to be number or [number, number, number], but received ${JSON.stringify(e.kernelSize)}.`);
}
}
}Tb.className="Conv3D",Oi(Tb);class Eb extends $b{
constructor(e){
if(super(e),this.inputSpec=[new dm({ndim:4})],"same"!==this.padding&&"valid"!==this.padding){
throw new Sp(`Conv2DTranspose currently supports only padding modes 'same' and 'valid', but received padding mode ${this.padding}`);
}
}build(e){
if(4!==(e=am(e)).length){
throw new Sp("Input should have rank 4; Received input shape: "+JSON.stringify(e));
}const t="channelsFirst"===this.dataFormat?1:e.length-1;if(null==e[t]){
throw new Sp("The channel dimension of the inputs should be defined. Found `None`.");
}const n=e[t],r=this.kernelSize.concat([this.filters,n]);this.kernel=this.addWeight("kernel",r,"float32",this.kernelInitializer,this.kernelRegularizer,!0,this.kernelConstraint),this.useBias&&(this.bias=this.addWeight("bias",[this.filters],"float32",this.biasInitializer,this.biasRegularizer,!0,this.biasConstraint)),this.inputSpec=[new dm({ndim:4,axes:{[t]:n}})],this.built=!0;
}call(e,t){
return xi((()=>{
let t=im(e);if(4!==t.shape.length){
throw new Sp(`Conv2DTranspose.call() expects input tensor to be rank-4, but received a tensor of rank-${t.shape.length}`);
}const n=t.shape,r=n[0];let s,i;"channelsFirst"===this.dataFormat?(s=2,i=3):(s=1,i=2);const a=n[s],o=n[i],u=this.kernelSize[0],l=this.kernelSize[1],c=this.strides[0],h=this.strides[1],d=[r,vb(a,c,u,this.padding),vb(o,h,l,this.padding),this.filters];"channelsLast"!==this.dataFormat&&(t=$u(t,[0,2,3,1]));let p=ao(t,this.kernel.read(),d,this.strides,this.padding);return"channelsLast"!==this.dataFormat&&(p=$u(p,[0,3,1,2])),null!=this.bias&&(p=Ff(p,this.bias.read(),this.dataFormat)),null!=this.activation&&(p=this.activation.apply(p)),p;
}));
}computeOutputShape(e){
const t=(e=am(e)).slice();let n,r,s;"channelsFirst"===this.dataFormat?(n=1,r=2,s=3):(n=3,r=1,s=2);const i=this.kernelSize[0],a=this.kernelSize[1],o=this.strides[0],u=this.strides[1];return t[n]=this.filters,t[r]=vb(t[r],o,i,this.padding),t[s]=vb(t[s],u,a,this.padding),t;
}getConfig(){
const e=super.getConfig();return delete e.dilationRate,e;
}
}Eb.className="Conv2DTranspose",Oi(Eb);class Rb extends Tb{
constructor(e){
if(super(e),this.inputSpec=[new dm({ndim:5})],"same"!==this.padding&&"valid"!==this.padding){
throw new Sp(`Conv3DTranspose currently supports only padding modes 'same' and 'valid', but received padding mode ${this.padding}`);
}
}build(e){
if(5!==(e=am(e)).length){
throw new Sp("Input should have rank 5; Received input shape: "+JSON.stringify(e));
}const t="channelsFirst"===this.dataFormat?1:e.length-1;if(null==e[t]){
throw new Sp("The channel dimension of the inputs should be defined. Found `None`.");
}const n=e[t],r=this.kernelSize.concat([this.filters,n]);this.kernel=this.addWeight("kernel",r,"float32",this.kernelInitializer,this.kernelRegularizer,!0,this.kernelConstraint),this.useBias&&(this.bias=this.addWeight("bias",[this.filters],"float32",this.biasInitializer,this.biasRegularizer,!0,this.biasConstraint)),this.inputSpec=[new dm({ndim:5,axes:{[t]:n}})],this.built=!0;
}call(e,t){
return xi((()=>{
let t=im(e);if(5!==t.shape.length){
throw new Sp(`Conv3DTranspose.call() expects input tensor to be rank-4, but received a tensor of rank-${t.shape.length}`);
}const n=t.shape,r=n[0];let s,i,a;"channelsFirst"===this.dataFormat?(a=2,s=3,i=4):(a=1,s=2,i=3);const o=n[a],u=n[s],l=n[i],c=this.kernelSize[0],h=this.kernelSize[1],d=this.kernelSize[2],p=this.strides[0],f=this.strides[1],m=this.strides[2],g=[r,vb(o,p,c,this.padding),vb(u,f,h,this.padding),vb(l,m,d,this.padding),this.filters];"channelsLast"!==this.dataFormat&&(t=$u(t,[0,2,3,4,1]));let b=lo(t,this.kernel.read(),g,this.strides,this.padding);return"channelsLast"!==this.dataFormat&&(b=$u(b,[0,4,1,2,3])),null!==this.bias&&(b=Ff(b,this.bias.read(),this.dataFormat)),null!==this.activation&&(b=this.activation.apply(b)),b;
}));
}computeOutputShape(e){
const t=(e=am(e)).slice();let n,r,s,i;"channelsFirst"===this.dataFormat?(n=1,r=2,s=3,i=4):(n=4,r=1,s=2,i=3);const a=this.kernelSize[0],o=this.kernelSize[1],u=this.kernelSize[2],l=this.strides[0],c=this.strides[1],h=this.strides[2];return t[n]=this.filters,t[r]=vb(t[r],l,a,this.padding),t[s]=vb(t[s],c,o,this.padding),t[i]=vb(t[i],h,u,this.padding),t;
}getConfig(){
const e=super.getConfig();return delete e.dilationRate,e;
}
}Rb.className="Conv3DTranspose",Oi(Rb);class Ab extends Nb{
constructor(e,t){
if(super(e,t),this.DEFAULT_DEPTHWISE_INITIALIZER="glorotUniform",this.DEFAULT_POINTWISE_INITIALIZER="glorotUniform",this.depthwiseKernel=null,this.pointwiseKernel=null,null==t.filters){
throw new Sp("The `filters` configuration field is required by SeparableConv, but is unspecified.");
}if(null!=t.kernelInitializer||null!=t.kernelRegularizer||null!=t.kernelConstraint){
throw new Sp("Fields kernelInitializer, kernelRegularizer and kernelConstraint are invalid for SeparableConv2D. Use depthwiseInitializer, depthwiseRegularizer, depthwiseConstraint, pointwiseInitializer, pointwiseRegularizer and pointwiseConstraint instead.");
}if(null!=t.padding&&"same"!==t.padding&&"valid"!==t.padding){
throw new Sp(`SeparableConv${this.rank}D supports only padding modes: 'same' and 'valid', but received ${JSON.stringify(t.padding)}`);
}this.depthMultiplier=null==t.depthMultiplier?1:t.depthMultiplier,this.depthwiseInitializer=nm(t.depthwiseInitializer||this.DEFAULT_DEPTHWISE_INITIALIZER),this.depthwiseRegularizer=db(t.depthwiseRegularizer),this.depthwiseConstraint=Mm(t.depthwiseConstraint),this.pointwiseInitializer=nm(t.depthwiseInitializer||this.DEFAULT_POINTWISE_INITIALIZER),this.pointwiseRegularizer=db(t.pointwiseRegularizer),this.pointwiseConstraint=Mm(t.pointwiseConstraint);
}build(e){
if((e=am(e)).length<this.rank+2){
throw new Sp(`Inputs to SeparableConv${this.rank}D should have rank ${this.rank+2}, but received input shape: ${JSON.stringify(e)}`);
}const t="channelsFirst"===this.dataFormat?1:e.length-1;if(null==e[t]||e[t]<0){
throw new Sp(`The channel dimension of the inputs should be defined, but found ${JSON.stringify(e[t])}`);
}const n=e[t],r=this.kernelSize.concat([n,this.depthMultiplier]),s=[];for(let e=0;e<this.rank;++e){
s.push(1);
}s.push(n*this.depthMultiplier,this.filters);const i=!0;this.depthwiseKernel=this.addWeight("depthwise_kernel",r,"float32",this.depthwiseInitializer,this.depthwiseRegularizer,i,this.depthwiseConstraint),this.pointwiseKernel=this.addWeight("pointwise_kernel",s,"float32",this.pointwiseInitializer,this.pointwiseRegularizer,i,this.pointwiseConstraint),this.useBias?this.bias=this.addWeight("bias",[this.filters],"float32",this.biasInitializer,this.biasRegularizer,i,this.biasConstraint):this.bias=null,this.inputSpec=[new dm({ndim:this.rank+2,axes:{[t]:n}})],this.built=!0;
}call(e,t){
return xi((()=>{
let t;if(e=im(e),1===this.rank){
throw new Cp("1D separable convolution is not implemented yet.");
}return 2===this.rank&&("channelsFirst"===this.dataFormat&&(e=$u(e,[0,2,3,1])),t=uu(e,this.depthwiseKernel.read(),this.pointwiseKernel.read(),this.strides,this.padding,this.dilationRate,"NHWC")),this.useBias&&(t=Ff(t,this.bias.read(),this.dataFormat)),null!=this.activation&&(t=this.activation.apply(t)),"channelsFirst"===this.dataFormat&&(t=$u(t,[0,3,1,2])),t;
}));
}getConfig(){
const e=super.getConfig();return delete e.rank,delete e.kernelInitializer,delete e.kernelRegularizer,delete e.kernelConstraint,e.depthwiseInitializer=tm(this.depthwiseInitializer),e.pointwiseInitializer=tm(this.pointwiseInitializer),e.depthwiseRegularizer=cb(this.depthwiseRegularizer),e.pointwiseRegularizer=cb(this.pointwiseRegularizer),e.depthwiseConstraint=Dm(this.depthwiseConstraint),e.pointwiseConstraint=Dm(this.pointwiseConstraint),e;
}
}Ab.className="SeparableConv";class Fb extends Ab{
constructor(e){
super(2,e);
}
}Fb.className="SeparableConv2D",Oi(Fb);class _b extends Nb{
constructor(e){
super(1,e),_b.verifyArgs(e),this.inputSpec=[{ndim:3}];
}getConfig(){
const e=super.getConfig();return delete e.rank,delete e.dataFormat,e;
}static verifyArgs(e){
if("number"!=typeof e.kernelSize&&!Vp(e.kernelSize,"number",1,1)){
throw new Sp(`Conv1D expects config.kernelSize to be number or number[] with length 1, but received ${JSON.stringify(e.kernelSize)}.`);
}
}
}_b.className="Conv1D",Oi(_b);class Db extends bm{
constructor(e){
super(e),"number"==typeof e.cropping?this.cropping=[[e.cropping,e.cropping],[e.cropping,e.cropping]]:"number"==typeof e.cropping[0]?this.cropping=[[e.cropping[0],e.cropping[0]],[e.cropping[1],e.cropping[1]]]:this.cropping=e.cropping,this.dataFormat=void 0===e.dataFormat?"channelsLast":e.dataFormat,this.inputSpec=[{ndim:4}];
}computeOutputShape(e){
return"channelsFirst"===this.dataFormat?[e[0],e[1],e[2]-this.cropping[0][0]-this.cropping[0][1],e[3]-this.cropping[1][0]-this.cropping[1][1]]:[e[0],e[1]-this.cropping[0][0]-this.cropping[0][1],e[2]-this.cropping[1][0]-this.cropping[1][1],e[3]];
}call(e,t){
return xi((()=>{
if(e=im(e),"channelsLast"===this.dataFormat){
const t=If(e,this.cropping[0][0],e.shape[1]-this.cropping[0][0]-this.cropping[0][1],2);return If(t,this.cropping[1][0],e.shape[2]-this.cropping[1][1]-this.cropping[1][0],3);
}{const t=If(e,this.cropping[0][0],e.shape[2]-this.cropping[0][0]-this.cropping[0][1],3);return If(t,this.cropping[1][0],e.shape[3]-this.cropping[1][1]-this.cropping[1][0],4);}
}));
}getConfig(){
const e={cropping:this.cropping,dataFormat:this.dataFormat},t=super.getConfig();return Object.assign(e,t),e;
}
}Db.className="Cropping2D",Oi(Db);class Ob extends bm{
constructor(e){
var t;super(e),this.DEFAULT_SIZE=[2,2],this.inputSpec=[{ndim:4}],this.size=null==e.size?this.DEFAULT_SIZE:e.size,this.dataFormat=null==e.dataFormat?"channelsLast":e.dataFormat,rf(this.dataFormat),this.interpolation=null==e.interpolation?"nearest":e.interpolation,t=this.interpolation,Wp(Jp,"InterpolationFormat",t);
}computeOutputShape(e){
if("channelsFirst"===this.dataFormat){
const t=null==e[2]?null:this.size[0]*e[2],n=null==e[3]?null:this.size[1]*e[3];return[e[0],e[1],t,n];
}{const t=null==e[1]?null:this.size[0]*e[1],n=null==e[2]?null:this.size[1]*e[2];return[e[0],t,n,e[3]];}
}call(e,t){
return xi((()=>{
let t=im(e);const n=t.shape;if("channelsFirst"===this.dataFormat){
t=$u(t,[0,2,3,1]);const e=this.size[0]*n[2],r=this.size[1]*n[3],s="nearest"===this.interpolation?$l.resizeNearestNeighbor(t,[e,r]):$l.resizeBilinear(t,[e,r]);return $u(s,[0,3,1,2]);
}{const e=this.size[0]*n[1],r=this.size[1]*n[2];return"nearest"===this.interpolation?$l.resizeNearestNeighbor(t,[e,r]):$l.resizeBilinear(t,[e,r]);}
}));
}getConfig(){
const e={size:this.size,dataFormat:this.dataFormat,interpolation:this.interpolation},t=super.getConfig();return Object.assign(e,t),e;
}
}Ob.className="UpSampling2D",Oi(Ob);class Mb extends Cb{
constructor(e){
super(2,e),this.depthwiseKernel=null,this.depthMultiplier=null==e.depthMultiplier?1:e.depthMultiplier,this.depthwiseInitializer=nm(e.depthwiseInitializer||this.DEFAULT_KERNEL_INITIALIZER),this.depthwiseConstraint=Mm(e.depthwiseConstraint),this.depthwiseRegularizer=db(e.depthwiseRegularizer);
}build(e){
if((e=am(e)).length<4){
throw new Sp(`Inputs to DepthwiseConv2D should have rank 4. Received input shape: ${JSON.stringify(e)}.`);
}const t="channelsFirst"===this.dataFormat?1:3;if(null==e[t]||e[t]<0){
throw new Sp(`The channel dimension of the inputs to DepthwiseConv2D should be defined, but is not (${e[t]}).`);
}const n=e[t],r=[this.kernelSize[0],this.kernelSize[1],n,this.depthMultiplier];this.depthwiseKernel=this.addWeight("depthwise_kernel",r,null,this.depthwiseInitializer,this.depthwiseRegularizer,!0,this.depthwiseConstraint),this.useBias?this.bias=this.addWeight("bias",[n*this.depthMultiplier],null,this.biasInitializer,this.biasRegularizer,!0,this.biasConstraint):this.bias=null,this.built=!0;
}call(e,t){
return xi((()=>{
let t=function(e,t,n=[1,1],r="valid",s,i){
return xi((()=>{
null==s&&(s="channelsLast"),rf(s);let a=kb(e,s);if(4!==e.rank){
throw new Sp(`Input for depthwiseConv2d is required to be 4-D, but is instead ${e.rank}-D`);
}if(4!==t.rank){
throw new Sp(`depthwiseKernel is required to be 4-D, but is instead ${t.rank}-D`);
}return a=ho(a,t,n,"same"===r?"same":"valid","NHWC",i),"channelsFirst"===s&&(a=$u(a,[0,3,1,2])),a;
}));
}(e=im(e),this.depthwiseKernel.read(),this.strides,this.padding,this.dataFormat,null);return this.useBias&&(t=Ff(t,this.bias.read(),this.dataFormat)),null!=this.activation&&(t=this.activation.apply(t)),t;
}));
}computeOutputShape(e){
e=am(e);const t="channelsFirst"===this.dataFormat?e[2]:e[1],n="channelsFirst"===this.dataFormat?e[3]:e[2],r="channelsFirst"===this.dataFormat?e[1]*this.depthMultiplier:e[3]*this.depthMultiplier,s=wb(t,this.kernelSize[0],this.padding,this.strides[0]),i=wb(n,this.kernelSize[1],this.padding,this.strides[1]);return"channelsFirst"===this.dataFormat?[e[0],r,s,i]:[e[0],s,i,r];
}getConfig(){
const e=super.getConfig();return e.depthMultiplier=this.depthMultiplier,e.depthwiseInitializer=tm(this.depthwiseInitializer),e.depthwiseRegularizer=cb(this.depthwiseRegularizer),e.depthwiseConstraint=Dm(this.depthwiseRegularizer),e;
}
}function Lb(e,t,n,r){
if(Array.isArray(e)){
if(null!=t||null!=n){
throw new Sp("When inputs is an array, neither initialState or constants should be provided");
}null!=r&&(n=e.slice(e.length-r,e.length),e=e.slice(0,e.length-r)),e.length>1&&(t=e.slice(1,e.length)),e=e[0];
}function s(e){
return null==e||Array.isArray(e)?e:[e];
}return{inputs:e,initialState:t=s(t),constants:n=s(n)};
}function zb(e,t,n,r=!1,s,i,a=!1,o=!1){
return xi((()=>{
const u=t.shape.length;if(u<3){
throw new Sp(`Input should be at least 3D, but is ${u}D.`);
}const l=[1,0].concat(gf(2,u));if(t=$u(t,l),null!=i){
throw new Cp("The rnn() functoin of the deeplearn.js backend does not support constants yet.");
}a&&console.warn("Backend rnn(): the unroll = true option is not applicable to the imperative deeplearn.js backend."),null!=s&&((s=fi(fi(s,"bool"),"float32")).rank===u-1&&(s=go(s,-1)),s=$u(s,l)),r&&(t=au(t,0),null!=s&&(s=au(s,0)));const c=[];let h,d=n;const p=t.shape[0],f=Iu(t);let m,g;null!=s&&(m=Iu(s));for(let t=0;t<p;++t){
const n=f[t],r=xi((()=>e(n,d)));if(null==s){
h=r[0],d=r[1];
}else{
const e=xi((()=>{
const e=m[t],n=Ui(Yo(e),e);return{output:ki(Ci(r[0],e),Ci(d[0],n)),newStates:d.map(((t,s)=>ki(Ci(r[1][s],e),Ci(t,n))))};
}));h=e.output,d=e.newStates;
}o&&c.push(h);
}return o&&(g=yu(c,1)),[h,g,d];
}));
}Mb.className="DepthwiseConv2D",Oi(Mb);class Pb extends bm{
constructor(e){
let t;if(super(e),null==e.cell){
throw new Sp("cell property is missing for the constructor of RNN.");
}if(t=Array.isArray(e.cell)?new qb({cells:e.cell}):e.cell,null==t.stateSize){
throw new Sp("The RNN cell should have an attribute `stateSize` (tuple of integers, one integer per RNN state).");
}this.cell=t,this.returnSequences=null!=e.returnSequences&&e.returnSequences,this.returnState=null!=e.returnState&&e.returnState,this.goBackwards=null!=e.goBackwards&&e.goBackwards,this._stateful=null!=e.stateful&&e.stateful,this.unroll=null!=e.unroll&&e.unroll,this.supportsMasking=!0,this.inputSpec=[new dm({ndim:3})],this.stateSpec=null,this.states_=null,this.numConstants=null,this.keptStates=[];
}getStates(){
return null==this.states_?gf(0,Array.isArray(this.cell.stateSize)?this.cell.stateSize.length:1).map((e=>null)):this.states_;
}setStates(e){
this.states_=e;
}computeOutputShape(e){
rm(e)&&(e=e[0]);let t=this.cell.stateSize;Array.isArray(t)||(t=[t]);const n=t[0];let r;if(r=this.returnSequences?[e[0],e[1],n]:[e[0],n],this.returnState){
const n=[];for(const r of t){
n.push([e[0],r]);
}return[r].concat(n);
}return r;
}computeMask(e,t){
return xi((()=>{
Array.isArray(t)&&(t=t[0]);const e=this.returnSequences?t:null;if(this.returnState){
const t=this.states.map((e=>null));return[e].concat(t);
}return e;
}));
}get states(){
if(null==this.states_){
const e=Array.isArray(this.cell.stateSize)?this.cell.stateSize.length:1,t=[];for(let n=0;n<e;++n){
t.push(null);
}return t;
}return this.states_;
}set states(e){
this.states_=e;
}build(e){
if(null!=this.numConstants){
throw new Cp("Constants support is not implemented in RNN yet.");
}rm(e)&&(e=e[0]);const t=this.stateful?e[0]:null,n=e.slice(2);this.inputSpec[0]=new dm({shape:[t,null,...n]});const r=[e[0]].concat(e.slice(2));let s;if(this.cell.build(r),s=Array.isArray(this.cell.stateSize)?this.cell.stateSize:[this.cell.stateSize],null!=this.stateSpec){
if(!g(this.stateSpec.map((e=>e.shape[e.shape.length-1])),s)){
throw new Sp(`An initialState was passed that is not compatible with cell.stateSize. Received stateSpec=${this.stateSpec}; However cell.stateSize is ${this.cell.stateSize}`);
}
}else {
this.stateSpec=s.map((e=>new dm({shape:[null,e]})));
}this.stateful&&this.resetStates();
}resetStates(e,t=!1){
xi((()=>{
if(!this.stateful){
throw new kp("Cannot call resetStates() on an RNN Layer that is not stateful.");
}const n=this.inputSpec[0].shape[0];if(null==n){
throw new Sp("If an RNN is stateful, it needs to know its batch size. Specify the batch size of your input tensors: \n- If using a Sequential model, specify the batch size by passing a `batchInputShape` option to your first layer.\n- If using the functional API, specify the batch size by passing a `batchShape` option to your Input layer.");
}if(null==this.states_){
Array.isArray(this.cell.stateSize)?this.states_=this.cell.stateSize.map((e=>Ko([n,e]))):this.states_=[Ko([n,this.cell.stateSize])];
}else if(null==e){
yi(this.states_),null!=this.keptStates&&(yi(this.keptStates),this.keptStates=[]),Array.isArray(this.cell.stateSize)?this.states_=this.cell.stateSize.map((e=>Ko([n,e]))):this.states_[0]=Ko([n,this.cell.stateSize]);
}else{
if(Array.isArray(e)||(e=[e]),e.length!==this.states_.length){
throw new Sp(`Layer ${this.name} expects ${this.states_.length} state(s), but it received ${e.length} state value(s). Input received: ${e}`);
}!0===t?this.keptStates.push(this.states_.slice()):yi(this.states_);for(let t=0;t<this.states_.length;++t){
const r=e[t],s=Array.isArray(this.cell.stateSize)?this.cell.stateSize[t]:this.cell.stateSize,i=[n,s];if(!g(r.shape,i)){
throw new Sp(`State ${t} is incompatible with layer ${this.name}: expected shape=${i}, received shape=${r.shape}`);
}this.states_[t]=r;
}
}this.states_=this.states_.map((e=>wi(e.clone())));
}));
}apply(e,t){
let n=null==t?null:t.initialState,r=null==t?null:t.constants;null==t&&(t={});const s=Lb(e,n,r,this.numConstants);e=s.inputs,n=s.initialState,r=s.constants;let i=[],a=[];if(null!=n){
t.initialState=n,i=i.concat(n),this.stateSpec=[];for(const e of n){
this.stateSpec.push(new dm({shape:e.shape}));
}a=a.concat(this.stateSpec);
}if(null!=r&&(t.constants=r,i=i.concat(r),this.numConstants=r.length),i[0]instanceof pm){
const n=[e].concat(i),r=this.inputSpec.concat(a),s=this.inputSpec;this.inputSpec=r;const o=super.apply(n,t);return this.inputSpec=s,o;
}return super.apply(e,t);
}call(e,t){
return xi((()=>{
const n=null==t?null:t.mask,r=null==t?null:t.training;let s=null==t?null:t.initialState;e=im(e),null==s&&(s=this.stateful?this.states_:this.getInitialState(e));const i=Array.isArray(this.cell.stateSize)?this.cell.stateSize.length:1;if(s.length!==i){
throw new Sp(`RNN Layer has ${i} state(s) but was passed ${s.length} initial state(s).`);
}this.unroll&&console.warn("Ignoring unroll = true for RNN layer, due to imperative backend.");const a={training:r},o=zb(((e,t)=>{
const n=this.cell.call([e].concat(t),a);return[n[0],n.slice(1)];
}),e,s,this.goBackwards,n,null,this.unroll,this.returnSequences),u=o[0],l=o[1],c=o[2];this.stateful&&this.resetStates(c,r);const h=this.returnSequences?l:u;return this.returnState?[h].concat(c):h;
}));
}getInitialState(e){
return xi((()=>{
let t=Ko(e.shape);return t=$o(t,[1,2]),t=wf(t),Array.isArray(this.cell.stateSize)?this.cell.stateSize.map((e=>e>1?Nf(t,[1,e]):t)):this.cell.stateSize>1?[Nf(t,[1,this.cell.stateSize])]:[t];
}));
}get trainableWeights(){
return this.trainable?this.cell.trainableWeights:[];
}get nonTrainableWeights(){
return this.trainable?this.cell.nonTrainableWeights:this.cell.weights;
}setFastWeightInitDuringBuild(e){
super.setFastWeightInitDuringBuild(e),null!=this.cell&&this.cell.setFastWeightInitDuringBuild(e);
}getConfig(){
const e=super.getConfig(),t={returnSequences:this.returnSequences,returnState:this.returnState,goBackwards:this.goBackwards,stateful:this.stateful,unroll:this.unroll};null!=this.numConstants&&(t.numConstants=this.numConstants);const n=this.cell.getConfig();return this.getClassName()===Pb.className&&(t.cell={className:this.cell.getClassName(),config:n}),Object.assign(Object.assign(Object.assign({},n),e),t);
}static fromConfig(e,t,n={}){
const r=Km(t.cell,n);return new e(Object.assign(t,{cell:r}));
}
}Pb.className="RNN",Oi(Pb);class Bb extends bm{}class Ub extends Bb{
constructor(e){
super(e),this.DEFAULT_ACTIVATION="tanh",this.DEFAULT_KERNEL_INITIALIZER="glorotNormal",this.DEFAULT_RECURRENT_INITIALIZER="orthogonal",this.DEFAULT_BIAS_INITIALIZER="zeros",this.units=e.units,Gp(this.units,"units"),this.activation=ab(null==e.activation?this.DEFAULT_ACTIVATION:e.activation),this.useBias=null==e.useBias||e.useBias,this.kernelInitializer=nm(e.kernelInitializer||this.DEFAULT_KERNEL_INITIALIZER),this.recurrentInitializer=nm(e.recurrentInitializer||this.DEFAULT_RECURRENT_INITIALIZER),this.biasInitializer=nm(e.biasInitializer||this.DEFAULT_BIAS_INITIALIZER),this.kernelRegularizer=db(e.kernelRegularizer),this.recurrentRegularizer=db(e.recurrentRegularizer),this.biasRegularizer=db(e.biasRegularizer),this.kernelConstraint=Mm(e.kernelConstraint),this.recurrentConstraint=Mm(e.recurrentConstraint),this.biasConstraint=Mm(e.biasConstraint),this.dropout=ff([1,mf([0,null==e.dropout?0:e.dropout])]),this.recurrentDropout=ff([1,mf([0,null==e.recurrentDropout?0:e.recurrentDropout])]),this.dropoutFunc=e.dropoutFunc,this.stateSize=this.units,this.dropoutMask=null,this.recurrentDropoutMask=null;
}build(e){
e=am(e),this.kernel=this.addWeight("kernel",[e[e.length-1],this.units],null,this.kernelInitializer,this.kernelRegularizer,!0,this.kernelConstraint),this.recurrentKernel=this.addWeight("recurrent_kernel",[this.units,this.units],null,this.recurrentInitializer,this.recurrentRegularizer,!0,this.recurrentConstraint),this.useBias?this.bias=this.addWeight("bias",[this.units],null,this.biasInitializer,this.biasRegularizer,!0,this.biasConstraint):this.bias=null,this.built=!0;
}call(e,t){
return xi((()=>{
if(2!==e.length){
throw new Sp(`SimpleRNNCell expects 2 input Tensors, got ${e.length}.`);
}let n=e[1];e=e[0];const r=null!=t.training&&t.training;let s;0<this.dropout&&this.dropout<1&&null==this.dropoutMask&&(this.dropoutMask=Kb({ones:()=>Yo(e),rate:this.dropout,training:r,dropoutFunc:this.dropoutFunc})),0<this.recurrentDropout&&this.recurrentDropout<1&&null==this.recurrentDropoutMask&&(this.recurrentDropoutMask=Kb({ones:()=>Yo(n),rate:this.recurrentDropout,training:r,dropoutFunc:this.dropoutFunc}));const i=this.dropoutMask,a=this.recurrentDropoutMask;s=Tf(null!=i?Ci(e,i):e,this.kernel.read()),null!=this.bias&&(s=Ff(s,this.bias.read())),null!=a&&(n=Ci(n,a));let o=ki(s,Tf(n,this.recurrentKernel.read()));return null!=this.activation&&(o=this.activation.apply(o)),[o,o];
}));
}getConfig(){
const e=super.getConfig(),t={units:this.units,activation:sb(this.activation),useBias:this.useBias,kernelInitializer:tm(this.kernelInitializer),recurrentInitializer:tm(this.recurrentInitializer),biasInitializer:tm(this.biasInitializer),kernelRegularizer:cb(this.kernelRegularizer),recurrentRegularizer:cb(this.recurrentRegularizer),biasRegularizer:cb(this.biasRegularizer),activityRegularizer:cb(this.activityRegularizer),kernelConstraint:Dm(this.kernelConstraint),recurrentConstraint:Dm(this.recurrentConstraint),biasConstraint:Dm(this.biasConstraint),dropout:this.dropout,recurrentDropout:this.recurrentDropout};return Object.assign(Object.assign({},e),t);
}
}Ub.className="SimpleRNNCell",Oi(Ub);class Wb extends Pb{
constructor(e){
e.cell=new Ub(e),super(e);
}call(e,t){
return xi((()=>{
null!=this.cell.dropoutMask&&(yi(this.cell.dropoutMask),this.cell.dropoutMask=null),null!=this.cell.recurrentDropoutMask&&(yi(this.cell.recurrentDropoutMask),this.cell.recurrentDropoutMask=null);const n=null==t?null:t.mask,r=null==t?null:t.training,s=null==t?null:t.initialState;return super.call(e,{mask:n,training:r,initialState:s});
}));
}static fromConfig(e,t){
return new e(t);
}
}Wb.className="SimpleRNN",Oi(Wb);class Vb extends Bb{
constructor(e){
if(super(e),this.DEFAULT_ACTIVATION="tanh",this.DEFAULT_RECURRENT_ACTIVATION="hardSigmoid",this.DEFAULT_KERNEL_INITIALIZER="glorotNormal",this.DEFAULT_RECURRENT_INITIALIZER="orthogonal",this.DEFAULT_BIAS_INITIALIZER="zeros",e.resetAfter){
throw new Sp("GRUCell does not support reset_after parameter set to true.");
}this.units=e.units,Gp(this.units,"units"),this.activation=ab(void 0===e.activation?this.DEFAULT_ACTIVATION:e.activation),this.recurrentActivation=ab(void 0===e.recurrentActivation?this.DEFAULT_RECURRENT_ACTIVATION:e.recurrentActivation),this.useBias=null==e.useBias||e.useBias,this.kernelInitializer=nm(e.kernelInitializer||this.DEFAULT_KERNEL_INITIALIZER),this.recurrentInitializer=nm(e.recurrentInitializer||this.DEFAULT_RECURRENT_INITIALIZER),this.biasInitializer=nm(e.biasInitializer||this.DEFAULT_BIAS_INITIALIZER),this.kernelRegularizer=db(e.kernelRegularizer),this.recurrentRegularizer=db(e.recurrentRegularizer),this.biasRegularizer=db(e.biasRegularizer),this.kernelConstraint=Mm(e.kernelConstraint),this.recurrentConstraint=Mm(e.recurrentConstraint),this.biasConstraint=Mm(e.biasConstraint),this.dropout=ff([1,mf([0,null==e.dropout?0:e.dropout])]),this.recurrentDropout=ff([1,mf([0,null==e.recurrentDropout?0:e.recurrentDropout])]),this.dropoutFunc=e.dropoutFunc,this.implementation=e.implementation,this.stateSize=this.units,this.dropoutMask=null,this.recurrentDropoutMask=null;
}build(e){
const t=(e=am(e))[e.length-1];this.kernel=this.addWeight("kernel",[t,3*this.units],null,this.kernelInitializer,this.kernelRegularizer,!0,this.kernelConstraint),this.recurrentKernel=this.addWeight("recurrent_kernel",[this.units,3*this.units],null,this.recurrentInitializer,this.recurrentRegularizer,!0,this.recurrentConstraint),this.useBias?this.bias=this.addWeight("bias",[3*this.units],null,this.biasInitializer,this.biasRegularizer,!0,this.biasConstraint):this.bias=null,this.built=!0;
}call(e,t){
return xi((()=>{
if(2!==e.length){
throw new Sp(`GRUCell expects 2 input Tensors (inputs, h, c), got ${e.length}.`);
}const n=null!=t.training&&t.training;let r=e[1];e=e[0],0<this.dropout&&this.dropout<1&&null==this.dropoutMask&&(this.dropoutMask=Kb({ones:()=>Yo(e),rate:this.dropout,training:n,count:3,dropoutFunc:this.dropoutFunc})),0<this.recurrentDropout&&this.recurrentDropout<1&&null==this.recurrentDropoutMask&&(this.recurrentDropoutMask=Kb({ones:()=>Yo(r),rate:this.recurrentDropout,training:n,count:3,dropoutFunc:this.dropoutFunc}));const s=this.dropoutMask,i=this.recurrentDropoutMask;let a,o,u;0<this.dropout&&this.dropout<1&&(e=Ci(e,s[0]));let l=Tf(e,this.kernel.read());this.useBias&&(l=Ff(l,this.bias.read())),0<this.recurrentDropout&&this.recurrentDropout<1&&(r=Ci(r,i[0]));const c=this.recurrentKernel.read(),[h,d]=bu(c,[2*this.units,this.units],c.rank-1),p=Tf(r,h),[f,m,g]=bu(l,3,l.rank-1),[b,x]=bu(p,2,p.rank-1);a=this.recurrentActivation.apply(ki(f,b)),o=this.recurrentActivation.apply(ki(m,x));const y=Tf(Ci(o,r),d);u=this.activation.apply(ki(g,y));const w=ki(Ci(a,r),Ci(ki(1,jo(a)),u));return[w,w];
}));
}getConfig(){
const e=super.getConfig(),t={units:this.units,activation:sb(this.activation),recurrentActivation:sb(this.recurrentActivation),useBias:this.useBias,kernelInitializer:tm(this.kernelInitializer),recurrentInitializer:tm(this.recurrentInitializer),biasInitializer:tm(this.biasInitializer),kernelRegularizer:cb(this.kernelRegularizer),recurrentRegularizer:cb(this.recurrentRegularizer),biasRegularizer:cb(this.biasRegularizer),activityRegularizer:cb(this.activityRegularizer),kernelConstraint:Dm(this.kernelConstraint),recurrentConstraint:Dm(this.recurrentConstraint),biasConstraint:Dm(this.biasConstraint),dropout:this.dropout,recurrentDropout:this.recurrentDropout,implementation:this.implementation,resetAfter:!1};return Object.assign(Object.assign({},e),t);
}
}Vb.className="GRUCell",Oi(Vb);class Gb extends Pb{
constructor(e){
0===e.implementation&&console.warn("`implementation=0` has been deprecated, and now defaults to `implementation=1`. Please update your layer call."),e.cell=new Vb(e),super(e);
}call(e,t){
return xi((()=>{
null!=this.cell.dropoutMask&&(yi(this.cell.dropoutMask),this.cell.dropoutMask=null),null!=this.cell.recurrentDropoutMask&&(yi(this.cell.recurrentDropoutMask),this.cell.recurrentDropoutMask=null);const n=null==t?null:t.mask,r=null==t?null:t.training,s=null==t?null:t.initialState;return super.call(e,{mask:n,training:r,initialState:s});
}));
}static fromConfig(e,t){
return 0===t.implmentation&&(t.implementation=1),new e(t);
}
}Gb.className="GRU",Oi(Gb);class jb extends Bb{
constructor(e){
super(e),this.DEFAULT_ACTIVATION="tanh",this.DEFAULT_RECURRENT_ACTIVATION="hardSigmoid",this.DEFAULT_KERNEL_INITIALIZER="glorotNormal",this.DEFAULT_RECURRENT_INITIALIZER="orthogonal",this.DEFAULT_BIAS_INITIALIZER="zeros",this.units=e.units,Gp(this.units,"units"),this.activation=ab(void 0===e.activation?this.DEFAULT_ACTIVATION:e.activation),this.recurrentActivation=ab(void 0===e.recurrentActivation?this.DEFAULT_RECURRENT_ACTIVATION:e.recurrentActivation),this.useBias=null==e.useBias||e.useBias,this.kernelInitializer=nm(e.kernelInitializer||this.DEFAULT_KERNEL_INITIALIZER),this.recurrentInitializer=nm(e.recurrentInitializer||this.DEFAULT_RECURRENT_INITIALIZER),this.biasInitializer=nm(e.biasInitializer||this.DEFAULT_BIAS_INITIALIZER),this.unitForgetBias=e.unitForgetBias,this.kernelRegularizer=db(e.kernelRegularizer),this.recurrentRegularizer=db(e.recurrentRegularizer),this.biasRegularizer=db(e.biasRegularizer),this.kernelConstraint=Mm(e.kernelConstraint),this.recurrentConstraint=Mm(e.recurrentConstraint),this.biasConstraint=Mm(e.biasConstraint),this.dropout=ff([1,mf([0,null==e.dropout?0:e.dropout])]),this.recurrentDropout=ff([1,mf([0,null==e.recurrentDropout?0:e.recurrentDropout])]),this.dropoutFunc=e.dropoutFunc,this.implementation=e.implementation,this.stateSize=[this.units,this.units],this.dropoutMask=null,this.recurrentDropoutMask=null;
}build(e){
var t;const n=(e=am(e))[e.length-1];let r;if(this.kernel=this.addWeight("kernel",[n,4*this.units],null,this.kernelInitializer,this.kernelRegularizer,!0,this.kernelConstraint),this.recurrentKernel=this.addWeight("recurrent_kernel",[this.units,4*this.units],null,this.recurrentInitializer,this.recurrentRegularizer,!0,this.recurrentConstraint),this.useBias){
if(this.unitForgetBias){
const e=this.biasInitializer,n=this.units;r=new((t=class extends Lf{
apply(t,r){
const s=e.apply([n]),i=(new Pf).apply([n]),a=e.apply([2*n]);return Cf(Cf(s,i),a);
}
}).className="CustomInit",t);
}else {
r=this.biasInitializer;
}this.bias=this.addWeight("bias",[4*this.units],null,r,this.biasRegularizer,!0,this.biasConstraint);
}else {
this.bias=null;
}this.built=!0;
}call(e,t){
return xi((()=>{
const n=null!=t.training&&t.training;if(3!==e.length){
throw new Sp(`LSTMCell expects 3 input Tensors (inputs, h, c), got ${e.length}.`);
}let r=e[1];const s=e[2];e=e[0],0<this.dropout&&this.dropout<1&&null==this.dropoutMask&&(this.dropoutMask=Kb({ones:()=>Yo(e),rate:this.dropout,training:n,count:4,dropoutFunc:this.dropoutFunc})),0<this.recurrentDropout&&this.recurrentDropout<1&&null==this.recurrentDropoutMask&&(this.recurrentDropoutMask=Kb({ones:()=>Yo(r),rate:this.recurrentDropout,training:n,count:4,dropoutFunc:this.dropoutFunc}));const i=this.dropoutMask,a=this.recurrentDropoutMask;let o,u,l,c;0<this.dropout&&this.dropout<1&&(e=Ci(e,i[0]));let h=Tf(e,this.kernel.read());0<this.recurrentDropout&&this.recurrentDropout<1&&(r=Ci(r,a[0])),h=ki(h,Tf(r,this.recurrentKernel.read())),this.useBias&&(h=Ff(h,this.bias.read()));const[d,p,f,m]=bu(h,4,h.rank-1);o=this.recurrentActivation.apply(d),u=this.recurrentActivation.apply(p),l=ki(Ci(u,s),Ci(o,this.activation.apply(f))),c=this.recurrentActivation.apply(m);const g=Ci(c,this.activation.apply(l));return[g,g,l];
}));
}getConfig(){
const e=super.getConfig(),t={units:this.units,activation:sb(this.activation),recurrentActivation:sb(this.recurrentActivation),useBias:this.useBias,kernelInitializer:tm(this.kernelInitializer),recurrentInitializer:tm(this.recurrentInitializer),biasInitializer:tm(this.biasInitializer),unitForgetBias:this.unitForgetBias,kernelRegularizer:cb(this.kernelRegularizer),recurrentRegularizer:cb(this.recurrentRegularizer),biasRegularizer:cb(this.biasRegularizer),activityRegularizer:cb(this.activityRegularizer),kernelConstraint:Dm(this.kernelConstraint),recurrentConstraint:Dm(this.recurrentConstraint),biasConstraint:Dm(this.biasConstraint),dropout:this.dropout,recurrentDropout:this.recurrentDropout,implementation:this.implementation};return Object.assign(Object.assign({},e),t);
}
}jb.className="LSTMCell",Oi(jb);class Hb extends Pb{
constructor(e){
0===e.implementation&&console.warn("`implementation=0` has been deprecated, and now defaults to `implementation=1`. Please update your layer call."),e.cell=new jb(e),super(e);
}call(e,t){
return xi((()=>{
null!=this.cell.dropoutMask&&(yi(this.cell.dropoutMask),this.cell.dropoutMask=null),null!=this.cell.recurrentDropoutMask&&(yi(this.cell.recurrentDropoutMask),this.cell.recurrentDropoutMask=null);const n=null==t?null:t.mask,r=null==t?null:t.training,s=null==t?null:t.initialState;return super.call(e,{mask:n,training:r,initialState:s});
}));
}static fromConfig(e,t){
return 0===t.implmentation&&(t.implementation=1),new e(t);
}
}Hb.className="LSTM",Oi(Hb);class qb extends Bb{
constructor(e){
super(e),this.cells=e.cells;
}get stateSize(){
const e=[];for(const t of this.cells.slice().reverse()){
Array.isArray(t.stateSize)?e.push(...t.stateSize):e.push(t.stateSize);
}return e;
}call(e,t){
return xi((()=>{
let n=e.slice(1);const r=[];for(const e of this.cells.slice().reverse()){
Array.isArray(e.stateSize)?r.push(n.splice(0,e.stateSize.length)):r.push(n.splice(0,1));
}r.reverse();const s=[];let i;for(let a=0;a<this.cells.length;++a){
const o=this.cells[a];n=r[a],i=0===a?[e[0]].concat(n):[i[0]].concat(n),i=o.call(i,t),s.push(i.slice(1));
}n=[];for(const e of s.slice().reverse()){
n.push(...e);
}return[i[0]].concat(n);
}));
}build(e){
let t;rm(e)&&(e=e[0]),this.cells.forEach(((n,r)=>{
uf(`RNNCell_${r}`,(()=>{
n.build(e),t=Array.isArray(n.stateSize)?n.stateSize[0]:n.stateSize,e=[e[0],t];
}));
})),this.built=!0;
}getConfig(){
const e=super.getConfig(),t={cells:this.cells.map((e=>({className:e.getClassName(),config:e.getConfig()})))};return Object.assign(Object.assign({},e),t);
}static fromConfig(e,t,n={}){
const r=[];for(const e of t.cells){
r.push(Km(e,n));
}return new e({cells:r});
}get trainableWeights(){
if(!this.trainable){
return[];
}const e=[];for(const t of this.cells){
e.push(...t.trainableWeights);
}return e;
}get nonTrainableWeights(){
const e=[];for(const t of this.cells){
e.push(...t.nonTrainableWeights);
}if(!this.trainable){
const t=[];for(const e of this.cells){
t.push(...e.trainableWeights);
}return t.concat(e);
}return e;
}getWeights(){
const e=[];for(const t of this.cells){
e.push(...t.weights);
}return cm(e);
}setWeights(e){
const t=[];for(const n of this.cells){
const r=n.weights.length,s=e.splice(r);for(let e=0;e<n.weights.length;++e){
t.push([n.weights[e],s[e]]);
}
}hm(t);
}
}function Kb(e){
const{ones:t,rate:n,training:r=!1,count:s=1,dropoutFunc:i}=e,a=()=>null!=i?i(t(),n):_f(t(),n),o=()=>Df(a,t,r);return!s||s<=1?wi(o().clone()):Array(s).fill(void 0).map(o).map((e=>wi(e.clone())));
}qb.className="StackedRNNCells",Oi(qb);class Xb extends Pb{
constructor(e){
if(e.unroll){
throw new Cp("Unrolling is not possible with convolutional RNNs.");
}if(Array.isArray(e.cell)){
throw new Cp("It is not possible at the moment to stack convolutional cells.");
}super(e),this.inputSpec=[new dm({ndim:5})];
}call(e,t){
return xi((()=>{
if(null!=this.cell.dropoutMask&&(yi(this.cell.dropoutMask),this.cell.dropoutMask=null),null!=this.cell.recurrentDropoutMask&&(yi(this.cell.recurrentDropoutMask),this.cell.recurrentDropoutMask=null),t&&t.constants){
throw new Sp("ConvRNN2D cell does not support constants");
}const n=null==t?null:t.mask,r=null==t?null:t.training,s=null==t?null:t.initialState;return super.call(e,{mask:n,training:r,initialState:s});
}));
}computeOutputShape(e){
let t=this.computeSingleOutputShape(e);return this.returnSequences||(t=[t[0],...t.slice(2)]),this.returnState&&(t=[t,...Array(2).fill([e[0],...t.slice(-3)])]),t;
}getInitialState(e){
return xi((()=>{
const{stateSize:t}=this.cell,n=e.shape,r=this.computeSingleOutputShape(n),s=Ko([r[0],...r.slice(2)]);return Array.isArray(t)?Array(t.length).fill(s):[s];
}));
}resetStates(e,t=!1){
xi((()=>{
if(!this.stateful){
throw new kp("Cannot call resetStates() on an RNN Layer that is not stateful.");
}const n=this.inputSpec[0].shape,r=this.computeSingleOutputShape(n),s=[r[0],...r.slice(2)];if(null==n[0]){
throw new Sp("If an RNN is stateful, it needs to know its batch size. Specify the batch size of your input tensors: \n- If using a Sequential model, specify the batch size by passing a `batchInputShape` option to your first layer.\n- If using the functional API, specify the batch size by passing a `batchShape` option to your Input layer.");
}if(null==this.getStates()){
Array.isArray(this.cell.stateSize)?this.states_=this.cell.stateSize.map((()=>Ko(s))):this.states_=[Ko(s)];
}else if(null==e){
yi(this.states_),null!=this.keptStates&&(yi(this.keptStates),this.keptStates=[]),Array.isArray(this.cell.stateSize)?this.states_=this.cell.stateSize.map((()=>Ko(s))):this.states_[0]=Ko(s);
}else{
if(Array.isArray(e)||(e=[e]),e.length!==this.states_.length){
throw new Sp(`Layer ${this.name} expects ${this.states_.length} state(s), but it received ${e.length} state value(s). Input received: ${e}`);
}t?this.keptStates.push(this.states_.slice()):yi(this.states_);for(let t=0;t<this.states_.length;++t){
const n=e[t],r=s;if(!g(n.shape,r)){
throw new Sp(`State ${t} is incompatible with layer ${this.name}: expected shape=${r}, received shape=${n.shape}`);
}this.states_[t]=n;
}
}this.states_=this.states_.map((e=>wi(e.clone())));
}));
}computeSingleOutputShape(e){
const{dataFormat:t,filters:n,kernelSize:r,padding:s,strides:i,dilationRate:a}=this.cell,o="channelsFirst"===t,u=e[o?3:2],l=e[o?4:3],c=wb(u,r[0],s,i[0],a[0]),h=wb(l,r[1],s,i[1],a[1]);return[...e.slice(0,2),...o?[n,c,h]:[c,h,n]];
}
}Xb.className="ConvRNN2D";class Yb extends jb{
constructor(e){
const{filters:t,kernelSize:n,strides:r,padding:s,dataFormat:i,dilationRate:a}=e;super(Object.assign(Object.assign({},e),{units:t})),this.filters=t,Gp(this.filters,"filters"),this.kernelSize=yb(n,2,"kernelSize"),this.kernelSize.forEach((e=>Gp(e,"kernelSize"))),this.strides=yb(r||1,2,"strides"),this.strides.forEach((e=>Gp(e,"strides"))),this.padding=s||"valid",sf(this.padding),this.dataFormat=i||"channelsLast",rf(this.dataFormat),this.dilationRate=yb(a||1,2,"dilationRate"),this.dilationRate.forEach((e=>Gp(e,"dilationRate")));
}build(e){
var t;e=am(e);const n="channelsFirst"===this.dataFormat?1:e.length-1;if(null==e[n]){
throw new Sp(`The channel dimension of the input should be defined. Found ${e[n]}`);
}const r=e[n],s=this.kernelSize.concat([r,4*this.filters]);this.kernel=this.addWeight("kernel",s,null,this.kernelInitializer,this.kernelRegularizer,!0,this.kernelConstraint);const i=this.kernelSize.concat([this.filters,4*this.filters]);if(this.recurrentKernel=this.addWeight("recurrent_kernel",i,null,this.recurrentInitializer,this.recurrentRegularizer,!0,this.recurrentConstraint),this.useBias){
let e;if(this.unitForgetBias){
const n=this.biasInitializer,r=this.filters;e=new((t=class extends Lf{
apply(e,t){
return Sf([n.apply([r]),Xo([r]),n.apply([2*r])]);
}
}).className="CustomInit",t);
}else {
e=this.biasInitializer;
}this.bias=this.addWeight("bias",[4*this.filters],null,e,this.biasRegularizer,!0,this.biasConstraint);
}this.built=!0;
}call(e,t){
return xi((()=>{
if(3!==e.length){
throw new Sp(`ConvLSTM2DCell expects 3 input Tensors (inputs, h, c), got ${e.length}.`);
}const n=t.training||!1,r=e[0],s=e[1],i=e[2];0<this.dropout&&this.dropout<1&&null==this.dropoutMask&&(this.dropoutMask=Kb({ones:()=>Yo(r),rate:this.dropout,training:n,count:4,dropoutFunc:this.dropoutFunc}));const a=this.dropoutMask,o=(e,t,n)=>t&&t[n]?Ci(t[n],e):e;let u=o(r,a,0),l=o(r,a,1),c=o(r,a,2),h=o(r,a,3);0<this.recurrentDropout&&this.recurrentDropout<1&&null==this.recurrentDropoutMask&&(this.recurrentDropoutMask=Kb({ones:()=>Yo(s),rate:this.recurrentDropout,training:n,count:4,dropoutFunc:this.dropoutFunc}));const d=this.recurrentDropoutMask;let p=o(s,d,0),f=o(s,d,1),m=o(s,d,2),g=o(s,d,3);const[b,x,y,w]=bu(this.kernel.read(),4,3),[v,k,I,S]=this.useBias?bu(this.bias.read(),4):[null,null,null,null];u=this.inputConv(u,b,v,this.padding),l=this.inputConv(l,x,k,this.padding),c=this.inputConv(c,y,I,this.padding),h=this.inputConv(h,w,S,this.padding);const[C,N,$,T]=bu(this.recurrentKernel.read(),4,3);p=this.recurrentConv(p,C),f=this.recurrentConv(f,N),m=this.recurrentConv(m,$),g=this.recurrentConv(g,T);const E=this.recurrentActivation.apply(ki(u,p)),R=this.recurrentActivation.apply(ki(l,f)),A=ki(Ci(R,i),Ci(E,this.activation.apply(ki(c,m)))),F=Ci(this.recurrentActivation.apply(ki(h,g)),this.activation.apply(A));return[F,F,A];
}));
}getConfig(){
const e=super.getConfig(),{units:t}=e,n=function(e,t){
var n={};for(var r in e){
Object.prototype.hasOwnProperty.call(e,r)&&t.indexOf(r)<0&&(n[r]=e[r]);
}if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){
var s=0;for(r=Object.getOwnPropertySymbols(e);s<r.length;s++){
t.indexOf(r[s])<0&&Object.prototype.propertyIsEnumerable.call(e,r[s])&&(n[r[s]]=e[r[s]]);
}
}return n;
}(e,["units"]),r={filters:this.filters,kernelSize:this.kernelSize,padding:this.padding,dataFormat:this.dataFormat,dilationRate:this.dilationRate,strides:this.strides};return Object.assign(Object.assign({},n),r);
}inputConv(e,t,n,r){
const s=ro(e,t,this.strides,r||"valid","channelsFirst"===this.dataFormat?"NCHW":"NHWC",this.dilationRate);return n?Ff(s,n,this.dataFormat):s;
}recurrentConv(e,t){
return ro(e,t,1,"same","channelsFirst"===this.dataFormat?"NCHW":"NHWC");
}
}Yb.className="ConvLSTM2DCell",Oi(Yb);class Zb extends Xb{
constructor(e){
const t=new Yb(e);super(Object.assign(Object.assign({},e),{cell:t}));
}static fromConfig(e,t){
return new e(t);
}
}Zb.className="ConvLSTM2D",Oi(Zb);class Jb extends bm{
constructor(e){
super(e),this.rate=Math.max(Math.min(e.rate,1),0),this.noiseShape=e.noiseShape,this.seed=e.seed,this.supportsMasking=!0;
}getNoiseShape(e){
if(null==this.noiseShape){
return this.noiseShape;
}const t=e.shape,n=[];for(let e=0;e<this.noiseShape.length;++e){
n.push(null==this.noiseShape[e]?t[e]:this.noiseShape[e]);
}return n;
}call(e,t){
return xi((()=>{
this.invokeCallHook(e,t);const n=im(e);if(0<this.rate&&this.rate<1){
const e=null!=t.training&&t.training,r=this.getNoiseShape(n);return Df((()=>_f(n,this.rate,r,this.seed)),(()=>n),e);
}return e;
}));
}getConfig(){
const e={rate:this.rate,noiseShape:this.noiseShape,seed:this.seed},t=super.getConfig();return Object.assign(e,t),e;
}dispose(){
return super.dispose();
}
}Jb.className="Dropout",Oi(Jb);class Qb extends Jb{
constructor(e){
super(e),this.inputSpec=[{ndim:3}];
}getNoiseShape(e){
const t=e.shape;return[t[0],1,t[2]];
}
}Qb.className="SpatialDropout1D",Oi(Qb);class ex extends bm{
constructor(e){
if(super(e),this.activation=null,this.useBias=!0,this.kernel=null,this.bias=null,this.DEFAULT_KERNEL_INITIALIZER="glorotNormal",this.DEFAULT_BIAS_INITIALIZER="zeros",null==e.batchInputShape&&null==e.inputShape&&null!=e.inputDim){
let t=null;null!=e.batchSize&&(t=e.batchSize),this.batchInputShape=[t,e.inputDim];
}this.units=e.units,Gp(this.units,"units"),this.activation=ab(e.activation),null!=e.useBias&&(this.useBias=e.useBias),this.kernelInitializer=nm(e.kernelInitializer||this.DEFAULT_KERNEL_INITIALIZER),this.biasInitializer=nm(e.biasInitializer||this.DEFAULT_BIAS_INITIALIZER),this.kernelConstraint=Mm(e.kernelConstraint),this.biasConstraint=Mm(e.biasConstraint),this.kernelRegularizer=db(e.kernelRegularizer),this.biasRegularizer=db(e.biasRegularizer),this.activityRegularizer=db(e.activityRegularizer),this.supportsMasking=!0,this.inputSpec=[{minNDim:2}];
}build(e){
const t=(e=am(e))[e.length-1];null==this.kernel&&(this.kernel=this.addWeight("kernel",[t,this.units],null,this.kernelInitializer,this.kernelRegularizer,!0,this.kernelConstraint),this.useBias&&(this.bias=this.addWeight("bias",[this.units],null,this.biasInitializer,this.biasRegularizer,!0,this.biasConstraint))),this.inputSpec=[{minNDim:2,axes:{[-1]:t}}],this.built=!0;
}computeOutputShape(e){
const t=(e=am(e)).slice();return t[t.length-1]=this.units,t;
}call(e,t){
return xi((()=>{
this.invokeCallHook(e,t);const n=im(e),r=Hp(this.activation.getClassName());let s;return null!=r?s=Tf(n,this.kernel.read(),r,this.bias?this.bias.read():null):(s=Tf(n,this.kernel.read()),null!=this.bias&&(s=Ff(s,this.bias.read())),null!=this.activation&&(s=this.activation.apply(s))),s;
}));
}getConfig(){
const e={units:this.units,activation:sb(this.activation),useBias:this.useBias,kernelInitializer:tm(this.kernelInitializer),biasInitializer:tm(this.biasInitializer),kernelRegularizer:cb(this.kernelRegularizer),biasRegularizer:cb(this.biasRegularizer),activityRegularizer:cb(this.activityRegularizer),kernelConstraint:Dm(this.kernelConstraint),biasConstraint:Dm(this.biasConstraint)},t=super.getConfig();return Object.assign(e,t),e;
}
}ex.className="Dense",Oi(ex);class tx extends bm{
constructor(e){
super(e=e||{}),this.inputSpec=[{minNDim:3}],this.dataFormat=e.dataFormat;
}computeOutputShape(e){
e=am(e);for(const t of e.slice(1)){
if(null==t){
throw new Sp(`The shape of the input to "Flatten" is not fully defined (got ${e.slice(1)}). Make sure to pass a complete "input_shape" or "batch_input_shape" argument to the first layer in your model.`);
}
}return[e[0],pf(e,1)];
}call(e,t){
return xi((()=>{
this.invokeCallHook(e,t);let n=im(e);if("channelsFirst"===this.dataFormat&&n.rank>1){
const e=[0];for(let t=2;t<n.rank;++t){
e.push(t);
}e.push(1),n=$u(n,e);
}return function(e){
if(e.rank<=1){
throw new Sp(`batchFlatten requires a minimum rank of 2. Got rank: ${e.rank}.`);
}const t=[e.shape[0],pf(e.shape,1)];return Va(e,t);
}(n);
}));
}getConfig(){
const e={};null!=this.dataFormat&&(e.dataFormat=this.dataFormat);const t=super.getConfig();return Object.assign(e,t),e;
}
}tx.className="Flatten",Oi(tx);class nx extends bm{
constructor(e){
super(e),this.supportsMasking=!0,this.activation=ab(e.activation);
}call(e,t){
return xi((()=>{
this.invokeCallHook(e,t);const n=im(e);return this.activation.apply(n);
}));
}getConfig(){
const e={activation:sb(this.activation)},t=super.getConfig();return Object.assign(e,t),e;
}
}nx.className="Activation",Oi(nx);class rx extends bm{
constructor(e){
super(e),this.n=e.n,this.inputSpec=[{ndim:2}];
}computeOutputShape(e){
return[e[0],this.n,e[1]];
}call(e,t){
return xi((()=>{
return e=im(e),t=e,n=this.n,xi((()=>{
if(2!==t.shape.length){
throw new Sp(`repeat() expects a rank-2 tensor, but received a rank-${t.shape.length} tensor.`);
}return Nf(wf(t,1),[1,n,1]);
}));var t,n;
}));
}getConfig(){
const e={n:this.n},t=super.getConfig();return Object.assign(e,t),e;
}
}rx.className="RepeatVector",Oi(rx);class sx extends bm{
constructor(e){
super(e),this.targetShape=e.targetShape;for(let e=0;e<this.targetShape.length;++e){
this.isUnknown(this.targetShape[e])&&(this.targetShape[e]=null);
}
}isUnknown(e){
return e<0||null==e;
}fixUnknownDimension(e,t){
const n="Total size of new array must be unchanged.",r=t.slice();let s=1,i=null;for(let e=0;e<r.length;++e){
const t=r[e];if(this.isUnknown(t)){
if(null!==i){
throw new Sp("Can only specifiy one unknown dimension.");
}i=e;
}else {
s*=t;
}
}const a=pf(e);if(null!==i){
if(0===s||a%s!=0){
throw new Sp(n);
}r[i]=a/s;
}else if(a!==s){
throw new Sp(n);
}return r;
}computeOutputShape(e){
let t=!1;for(let n=0;n<e.length;++n){
if(this.isUnknown(e[n])){
t=!0;break;
}
}return t?e.slice(0,1).concat(this.targetShape):e.slice(0,1).concat(this.fixUnknownDimension(e.slice(1),this.targetShape));
}call(e,t){
return xi((()=>{
this.invokeCallHook(e,t);const n=im(e),r=n.shape,s=r.slice(0,1).concat(this.fixUnknownDimension(r.slice(1),this.targetShape));return Va(n,s);
}));
}getConfig(){
const e={targetShape:this.targetShape},t=super.getConfig();return Object.assign(e,t),e;
}
}sx.className="Reshape",Oi(sx);class ix extends bm{
constructor(e){
if(super(e),null==e.dims){
throw new Error("Required configuration field `dims` is missing during Permute constructor call.");
}if(!Array.isArray(e.dims)){
throw new Error(`Permute constructor requires \`dims\` to be an Array, but received ${e.dims} instead.`);
}const t=gf(1,e.dims.length+1);if(!g(e.dims.slice().sort(),t)){
throw new Error("Invalid permutation `dims`: "+JSON.stringify(e.dims)+" `dims` must contain consecutive integers starting from 1.");
}this.dims=e.dims,this.dimsIncludingBatch=[0].concat(this.dims),this.inputSpec=[new dm({ndim:this.dims.length+1})];
}computeOutputShape(e){
const t=(e=am(e)).slice();return this.dims.forEach(((n,r)=>{
t[r+1]=e[n];
})),t;
}call(e,t){
return $u(im(e),this.dimsIncludingBatch);
}getConfig(){
const e={dims:this.dims},t=super.getConfig();return Object.assign(e,t),e;
}
}ix.className="Permute",Oi(ix);class ax extends bm{
constructor(e){
super(null==e?{}:e),this.supportsMasking=!0,this.maskValue=null!=e?null==e.maskValue?0:e.maskValue:0;
}computeOutputShape(e){
return e;
}getConfig(){
const e=super.getConfig(),t={maskValue:this.maskValue};return Object.assign(t,e),t;
}computeMask(e,t){
const n=im(e);return Na(Ho(n,this.maskValue),-1);
}call(e,t){
return xi((()=>{
this.invokeCallHook(e,t);const n=im(e),r=Na(Ho(n,this.maskValue),-1,!0);return Ci(n,fi(r,n.dtype));
}));
}
}ax.className="Masking",Oi(ax);class ox extends bm{
constructor(e){
if(super(e),this.embeddings=null,this.DEFAULT_EMBEDDINGS_INITIALIZER="randomUniform",null==e.batchInputShape&&null==e.inputShape){
let t=null;null!=e.batchSize&&(t=e.batchSize),null==e.inputLength?this.batchInputShape=[t,null]:this.batchInputShape=[t].concat(Fp(e.inputLength));
}this.inputDim=e.inputDim,Gp(this.inputDim,"inputDim"),this.outputDim=e.outputDim,Gp(this.outputDim,"outputDim"),this.embeddingsInitializer=nm(e.embeddingsInitializer||this.DEFAULT_EMBEDDINGS_INITIALIZER),this.embeddingsRegularizer=db(e.embeddingsRegularizer),this.activityRegularizer=db(e.activityRegularizer),this.embeddingsConstraint=Mm(e.embeddingsConstraint),this.maskZero=e.maskZero,this.supportsMasking=e.maskZero,this.inputLength=e.inputLength;
}build(e){
this.embeddings=this.addWeight("embeddings",[this.inputDim,this.outputDim],this.dtype,this.embeddingsInitializer,this.embeddingsRegularizer,!0,this.embeddingsConstraint),this.built=!0;
}warnOnIncompatibleInputShape(e){}computeMask(e,t){
return xi((()=>this.maskZero?(e=im(e),Ho(e,Ti(e))):null));
}computeOutputShape(e){
if(e=am(e),null==this.inputLength){
return[...e,this.outputDim];
}const t=Fp(this.inputLength);if(t.length!==e.length-1){
throw new Sp(`"inputLength" is ${this.inputLength}, but received input shape has shape ${e}`);
}{let n=0;for(let r=0;r<t.length;++r){
const s=t[r],i=e[r+1];if(null!=s&&null!=i&&s!==i){
throw new Sp(`"inputLength" is ${this.inputLength}, but received input shape has shape ${e}`);
}null==s&&(t[n]=i),n++;
}}return[e[0],...t,this.outputDim];
}call(e,t){
return xi((()=>{
this.invokeCallHook(e,t);let n=im(e);"int32"!==n.dtype&&(n=yf(n,"int32"));const r=Ef(this.embeddings.read(),Va(n,[n.size]));return Va(r,am(this.computeOutputShape(n.shape)));
}));
}getConfig(){
const e={inputDim:this.inputDim,outputDim:this.outputDim,embeddingsInitializer:tm(this.embeddingsInitializer),embeddingsRegularizer:cb(this.embeddingsRegularizer),activityRegularizer:cb(this.activityRegularizer),embeddingsConstraint:Dm(this.embeddingsConstraint),maskZero:this.maskZero,inputLength:this.inputLength},t=super.getConfig();return Object.assign(e,t),e;
}
}ox.className="Embedding",Oi(ox);class ux extends bm{
constructor(e){
super(e||{}),this.supportsMasking=!0;
}mergeFunction(e){
throw new Cp;
}computeElementwiseOpOutputShape(e,t){
if(null==e||null==t){
return null;
}if(e.length<t.length){
return this.computeElementwiseOpOutputShape(t,e);
}if(0===t.length){
return e;
}const n=e.slice(0,e.length-t.length);for(let r=0;r<t.length;++r){
const s=e[e.length-t.length+r],i=t[r];if(null==s||null==i||s<0||i<0){
n.push(null);
}else if(1===s){
n.push(i);
}else if(1===i){
n.push(s);
}else{
if(s!==i){
throw new Sp("Operands could not be broadcast together with shapes "+JSON.stringify(e)+" "+JSON.stringify(t));
}n.push(s);
}
}return n;
}build(e){
if(Array.isArray(e)&&!Array.isArray(e[0])&&(e=[am(e)]),e.length<2){
throw new Sp(`A merge layer should be called on an Array of at least 2 inputs. Got ${e.length} input(s).`);
}let t=[];for(const n of e){
null!=n&&null!==n[0]&&t.push(n[0]);
}if(t=Bp(t),t.length>1){
throw new Sp(`Can not merge tensors with different batch sizes. Got tensors with shapes: ${JSON.stringify(e)}.`);
}let n=null==e[0]?null:e[0].slice(1);for(let t=1;t<e.length;++t){
const r=null==e[t]?null:e[t].slice(1);n=this.computeElementwiseOpOutputShape(n,r);
}const r=e.map((e=>e.length));-1===e.indexOf(null)&&1===Bp(r).length?this.reshapeRequired=!1:this.reshapeRequired=!0;
}call(e,t){
return xi((()=>{
if(this.reshapeRequired){
const t=[],n=e.map((e=>e.rank));if(-1===n.indexOf(null)){
const r=mf(n);for(let n of e){
const e=n.rank;for(let t=0;t<r-e;++t){
n=wf(n,1);
}t.push(n);
}return this.mergeFunction(t);
}{let n=!1;for(const r of e){
const e=r.rank;if(null==e){
const e=r.shape,s=e[0],i=e.slice(1).concat([s]);let a=Va(r,[s].concat(pf(e.slice(1))));a=$u(a,[1,0]),a=Va(a,i),t.push(a),n=!0;
}else if(e>1){
const s=gf(1,e).concat([0]);t.push($u(r,s)),n=!0;
}else {
t.push(r);
}
}let r=this.mergeFunction(t);const s=r.rank;if(n){
if(null==s){
const e=r.shape,t=e[e.length-1],n=[t].concat(e.slice(0,e.length-1));r=Va($u(Va(r,[-1,t]),[1,0]),n);
}else if(s>1){
const e=[s-1].concat(gf(0,s-1));r=$u(r,e);
}
}return r;}
}return this.mergeFunction(e);
}));
}computeOutputShape(e){
let t;t=null==e[0]?null:e[0].slice(1);for(let n=1;n<e.length;++n){
const r=null==e[n]?null:e[n].slice(1);t=this.computeElementwiseOpOutputShape(t,r);
}let n=[];for(const t of e){
null!=t&&null!==t[0]&&n.push(t[0]);
}return n=Bp(n),t=1===n.length?n.concat(t):[null].concat(t),t;
}computeMask(e,t){
return xi((()=>{
if(null==t){
return null;
}if(!Array.isArray(t)){
throw new Sp("`mask` should be an Array");
}if(!Array.isArray(e)){
throw new Sp("`inputs` should be an Array");
}if(t.length!==e.length){
throw new Sp(`The Array 'inputs' and 'mask' are expected to have the same length, but have different lengths (${e.length} vs ${t.length})`);
}if(t.every((e=>null==e))){
return null;
}let n=(t=t.map((e=>null==e?e:go(e,0))))[0];for(let e=1;e<t.length-1;++e){
n=Eo(n,t[e]);
}return n;
}));
}
}class lx extends ux{
constructor(e){
super(e);
}mergeFunction(e){
return xi((()=>{
let t=e[0].clone();for(let n=1;n<e.length;++n){
t=ki(t,e[n]);
}return t;
}));
}
}lx.className="Add",Oi(lx);class cx extends ux{
constructor(e){
super(e);
}mergeFunction(e){
return xi((()=>{
let t=e[0].clone();for(let n=1;n<e.length;++n){
t=Ci(t,e[n]);
}return t;
}));
}
}cx.className="Multiply",Oi(cx);class hx extends ux{
constructor(e){
super(e);
}mergeFunction(e){
return xi((()=>{
let t=e[0].clone();for(let n=1;n<e.length;++n){
t=ki(t,e[n]);
}return Ci(1/e.length,t);
}));
}
}hx.className="Average",Oi(hx);class dx extends ux{
constructor(e){
super(e);
}mergeFunction(e){
return xi((()=>{
let t=e[0];for(let n=1;n<e.length;++n){
t=qi(t,e[n]);
}return t;
}));
}
}dx.className="Maximum",Oi(dx);class px extends ux{
constructor(e){
super(e);
}mergeFunction(e){
return xi((()=>{
let t=e[0];for(let n=1;n<e.length;++n){
t=Oo(t,e[n]);
}return t;
}));
}
}px.className="Minimum",Oi(px);class fx extends ux{
constructor(e){
super(e),this.DEFAULT_AXIS=-1,null==e&&(e={}),this.axis=null==e.axis?this.DEFAULT_AXIS:e.axis,this.supportsMasking=!0,this.reshapeRequired=!1;
}build(e){
if(!Array.isArray(e)||!Array.isArray(e[0])||1===e.length){
throw new Sp("A `Concatenate` layer should be called on a list of at least 2 inputs");
}let t=!0;for(const n of e){
if(null!=n){
t=!1;break;
}
}if(t){
return;
}const n=[];for(let t=0;t<e.length;++t){
const r=e[t].slice();r.splice(this.axis,1);let s=!1;for(const e of n){
if(g(e,r)){
s=!0;break;
}
}s||n.push(r);
}if(n.length>1){
throw new Sp("A `Concatenate` layer requires inputs with matching shapes except for the concat axis. Got input shapes: "+JSON.stringify(e));
}
}mergeFunction(e){
return xi((()=>Sf(e,this.axis)));
}computeOutputShape(e){
if(!Array.isArray(e)||!Array.isArray(e[0])){
throw new Sp("A `Concatenate` layer should be called on a list of inputs.");
}const t=e,n=t[0].slice(),r=this.axis<0?n.length+this.axis:this.axis;for(const e of t.slice(1)){
if(null==n[r]||null==e[r]){
n[r]=null;break;
}n[r]+=e[r];
}return n;
}computeMask(e,t){
if(null==t){
return null;
}if(!Array.isArray(t)){
throw new Sp("`mask` should be an array for Concatenate");
}if(!Array.isArray(e)){
throw new Sp("`inputs` should be an array for Concatenate");
}if(t.length!==e.length){
throw new Sp(`Mismatch in the length of mask (${t.length}) and the legnth of inputs (${e.length})`);
}return xi((()=>{
let n=!0;if(t.forEach((e=>{
null==e||(n=!1);
})),n){
return null;
}const r=[];for(let n=0;n<e.length;++n){
null==t[n]?r.push(fi(Yo(e[n]),"bool")):t[n].rank<e[n].rank?r.push(go(t[n],-1)):r.push(t[n]);
}const s=Ja(r,this.axis);return Ca(s,-1,!1);
}));
}getConfig(){
const e={axis:this.axis},t=super.getConfig();return Object.assign(e,t),e;
}
}function mx(e,t){
for(;e<0;){
e+=t;
}return e;
}fx.className="Concatenate",Oi(fx);class gx extends ux{
constructor(e){
super(e),this.axes=e.axes,this.normalize=null!=e.normalize&&e.normalize,this.supportsMasking=!0,this.reshapeRequired=!1;
}build(e){
d(Array.isArray(e)&&2===e.length&&Array.isArray(e[0])&&Array.isArray(e[1]),(()=>"A `Dot` layer should be called on a list of exactly 2 inputs."));const t=e[0],n=e[1];if(t.length>3||n.length>3){
throw new Cp("Dot layer does not support tensors of 4D or higher rank yet.");
}const r=this.interpretAxes(t,n);if(t[r[0]]!==n[r[1]]){
throw new Sp(`Dimension incompatibility: ${t[r[0]]} !== ${n[r[1]]}`);
}
}mergeFunction(e){
if(2!==e.length){
throw new Sp(`A \`Dot\` layer must be called on exactly 2 inputs, but received ${e.length} input(s).`);
}let t,n=e[0],r=e[1];return t=Array.isArray(this.axes)?this.axes.map(((t,n)=>mx(t,e[n].shape.length))):[mx(this.axes,n.shape.length),mx(this.axes,r.shape.length)],this.normalize&&(n=Xm(n,t[0]),r=Xm(r,t[1])),function(e,t,n){
if(e.shape.length>3||t.shape.length>3){
throw new Cp("batchDot is not implemented for tensors of 4D or higher rank yet");
}if(d(e.shape.length>=2,(()=>`batchDot requires the rank of x to be >= 2, but got ${e.shape.length}`)),d(e.shape.length>=2,(()=>`batchDot requires the rank of y to be >= 2, but got ${t.shape.length}`)),"number"==typeof n&&(n=[n,n]),"complex64"===e.dtype||"complex64"===t.dtype){
throw new Cp("batchDot is not implemented for complex64-type Tensors yet.");
}const r=e.shape.length,s=t.shape.length;null==n&&(n=[r-1,s-2]);const i=n;return xi((()=>{
let n,a;if(r>s){
n=r-s;const e=[];for(let t=0;t<n;++t){
e.push(1);
}t=Va(t,t.shape.concat(e));
}else if(s>r){
n=s-r;const t=[];for(let e=0;e<n;++e){
t.push(1);
}e=Va(e,e.shape.concat(t));
}else {
n=0;
}if(2===e.shape.length&&2===t.shape.length){
a=i[0]===i[1]?$o(Ci(e,t),i[0]):$o(Ci($u(e,[1,0]),t),i[1]);
}else{
const n=i[0]!==e.shape.length-1,r=i[1]===t.shape.length-1;a=Ro(e,t,n,r);
}if(n>0){
let e;e=r>s?r+s-3:r-1;const t=[];for(let r=e;r<e+n;++r){
t.push(r);
}a=xu(a,t);
}return 1===a.shape.length&&(a=go(a,1)),a;
}));
}(n,r,t);
}interpretAxes(e,t){
let n;return n=Array.isArray(this.axes)?this.axes:[mx(this.axes,e.length),mx(this.axes,t.length)],n;
}computeOutputShape(e){
d(Array.isArray(e)&&2===e.length&&Array.isArray(e[0])&&Array.isArray(e[1]),(()=>"A `Dot` layer should be called on a list of exactly 2 inputs."));const t=e[0].slice(),n=e[1].slice();if(t.length>3||n.length>3){
throw new Cp("Dot layer does not support tensors of 4D or higher rank yet.");
}const r=this.interpretAxes(t,n);t.splice(r[0],1),n.splice(r[1],1),n.splice(0,1);const s=t.concat(n);return 1===s.length&&s.push(1),s;
}computeMask(e,t){
return null;
}getConfig(){
const e={axes:this.axes,normalize:this.normalize},t=super.getConfig();return Object.assign(e,t),e;
}
}gx.className="Dot",Oi(gx);class bx extends bm{
constructor(e){
super(e),this.supportsMasking=!0,this.stddev=e.stddev;
}computeOutputShape(e){
return e;
}getConfig(){
const e=super.getConfig(),t={stddev:this.stddev};return Object.assign(t,e),t;
}call(e,t){
return xi((()=>{
this.invokeCallHook(e,t);const n=im(e);return Df((()=>ki($f(n.shape,0,this.stddev),n)),(()=>n),t.training||!1);
}));
}
}bx.className="GaussianNoise",Oi(bx);class xx extends bm{
constructor(e){
super(e),this.supportsMasking=!0,this.rate=e.rate;
}computeOutputShape(e){
return e;
}getConfig(){
const e=super.getConfig(),t={rate:this.rate};return Object.assign(t,e),t;
}call(e,t){
return xi((()=>{
this.invokeCallHook(e,t);const n=im(e);return this.rate>0&&this.rate<1?Df((()=>{
const e=Math.sqrt(this.rate/(1-this.rate));return Ci(n,$f(n.shape,1,e));
}),(()=>n),t.training||!1):n;
}));
}
}xx.className="GaussianDropout",Oi(xx);class yx extends bm{
constructor(e){
super(e),this.supportsMasking=!0,this.rate=e.rate,this.noiseShape=e.noiseShape;
}_getNoiseShape(e){
return this.noiseShape||im(e).shape;
}computeOutputShape(e){
return e;
}getConfig(){
const e=super.getConfig(),t={rate:this.rate};return Object.assign(t,e),t;
}call(e,t){
return xi((()=>{
if(this.rate<1&&this.rate>0){
const n=this._getNoiseShape(e);return Df((()=>{
const t=im(e),r=-1.7580993408473766;let s=ko(ru(n),this.rate);s=yf(s,"float32");const i=((1-this.rate)*(1+this.rate*r**2))**-.5,a=-i*r*this.rate,o=ki(Ci(t,s),Ci(ki(s,-1),r));return ki(Ci(o,i),a);
}),(()=>im(e)),t.training||!1);
}return e;
}));
}
}function wx(e,t,n,r,s,i=.001){
let a;if(2===e.rank){
a=qa(e,t,n,r,s,i);
}else if(3===e.rank){
a=Ka(e,t,n,r,s,i);
}else{
if(4!==e.rank){
throw new Cp(`batchNormalization is not implemented for array of rank ${e.rank} yet`);
}a=Xa(e,t,n,r,s,i);
}return a;
}yx.className="AlphaDropout",Oi(yx);class vx extends bm{
constructor(e){
null==e&&(e={}),super(e),this.supportsMasking=!0,this.axis=null==e.axis?-1:e.axis,this.momentum=null==e.momentum?.99:e.momentum,this.epsilon=null==e.epsilon?.001:e.epsilon,this.center=null==e.center||e.center,this.scale=null==e.scale||e.scale,this.betaInitializer=nm(e.betaInitializer||"zeros"),this.gammaInitializer=nm(e.gammaInitializer||"ones"),this.movingMeanInitializer=nm(e.movingMeanInitializer||"zeros"),this.movingVarianceInitializer=nm(e.movingVarianceInitializer||"ones"),this.betaConstraint=Mm(e.betaConstraint),this.gammaConstraint=Mm(e.gammaConstraint),this.betaRegularizer=db(e.betaRegularizer),this.gammaRegularizer=db(e.gammaRegularizer);
}build(e){
e=am(e);const t=this.axis>=0?this.axis:this.axis+e.length,n=e[t];if(null==n){
throw new Sp(`Axis ${t} of input tensor should have a defined dimension but the layer received an input with shape ${JSON.stringify(e)}.`);
}this.inputSpec=[new dm({ndim:e.length,axes:{[t]:n}})];const r=[n];this.scale&&(this.gamma=this.addWeight("gamma",r,null,this.gammaInitializer,this.gammaRegularizer,!0,this.gammaConstraint)),this.center&&(this.beta=this.addWeight("beta",r,null,this.betaInitializer,this.betaRegularizer,!0,this.betaConstraint)),this.movingMean=this.addWeight("moving_mean",r,null,this.movingMeanInitializer,null,!1),this.movingVariance=this.addWeight("moving_variance",r,null,this.movingVarianceInitializer,null,!1),this.built=!0;
}call(e,t){
return xi((()=>{
const n=null!=t.training&&t.training,r=im(e),s=r.shape,i=s.length,a=gf(0,i),o=this.axis>=0?this.axis:this.axis+i;a.splice(o,1);const u=Tp(1,i);u[o]=s[o];const l=a.slice();l.sort();const c=!g(l,gf(0,i).slice(0,i-1));if(!n){
return(()=>{
if(c){
const e=Va(this.movingMean.read(),u),t=Va(this.movingVariance.read(),u),n=this.center?Va(this.beta.read(),u):null,s=this.scale?Va(this.gamma.read(),u):null;return wx(r,e,t,n,s,this.epsilon);
}return wx(r,this.movingMean.read(),this.movingVariance.read(),null==this.beta?null:this.beta.read(),null==this.gamma?null:this.gamma.read(),this.epsilon);
})();
}const[h,d,p]=function(e,t,n,r,s=.001){
return g(r.slice().sort(),gf(0,e.rank-1))?function(e,t,n,r,s=.001){
return xi((()=>{
const i=Go(e,r),a=i.mean,o=i.variance;return[wx(e,a,o,n,t,s),a,o];
}));
}(e,t,n,r,s):function(e,t,n,r,s=.001){
return xi((()=>{
const i=Go(e,r),a=i.mean,o=i.variance,u=[];for(const t of gf(0,e.rank)){
-1!==r.indexOf(t)?u.push(1):u.push(e.shape[t]);
}const l=Va(a,u),c=Va(o,u),h=null==t?null:Va(t,u),d=null==n?null:Va(n,u);return[wx(e,l,c,d,h,s),a,o];
}));
}(e,t,n,r,s);
}(r,this.gamma.read(),this.beta.read(),a,this.epsilon),f=(e,t,n)=>{
xi((()=>{
const r=1-n,s=e.read(),i=Ci(Ui(s,t),r);e.write(Ui(s,i));
}));
};return(()=>{
f(this.movingMean,d,this.momentum),f(this.movingVariance,p,this.momentum);
})(),h;
}));
}getConfig(){
const e={axis:this.axis,momentum:this.momentum,epsilon:this.epsilon,center:this.center,scale:this.scale,betaInitializer:tm(this.betaInitializer),gammaInitializer:tm(this.gammaInitializer),movingMeanInitializer:tm(this.movingMeanInitializer),movingVarianceInitializer:tm(this.movingVarianceInitializer),betaRegularizer:cb(this.betaRegularizer),gammaRegularizer:cb(this.gammaRegularizer),betaConstraint:Dm(this.betaConstraint),gammaConstraint:Dm(this.gammaConstraint)},t=super.getConfig();return Object.assign(e,t),e;
}
}vx.className="BatchNormalization",Oi(vx);class kx extends bm{
constructor(e){
if(null==e&&(e={}),super(e),this.axis=null==e.axis?-1:e.axis,"number"==typeof this.axis){
if(!Number.isInteger(this.axis)){
throw new Error(`Expected axis to be an integer, but received ${this.axis}`);
}
}else{
if(!Array.isArray(this.axis)){
throw new Error(`Expected axis to be an integer or an array of integers, but received ${JSON.stringify(this.axis)}`);
}for(const e of this.axis){
if(!Number.isInteger(e)){
throw new Error(`Expected axis to be an array of integers, but received ${JSON.stringify(this.axis)}`);
}
}
}this.epsilon=null==e.epsilon?.001:e.epsilon,this.center=null==e.center||e.center,this.scale=null==e.scale||e.scale,this.betaInitializer=nm(e.betaInitializer||"zeros"),this.gammaInitializer=nm(e.gammaInitializer||"ones"),this.betaRegularizer=db(e.betaRegularizer),this.gammaRegularizer=db(e.gammaRegularizer),this.supportsMasking=!0;
}build(e){
const t=(e=am(e)).length;"number"==typeof this.axis&&(this.axis=[this.axis]);for(let e=0;e<this.axis.length;++e){
this.axis[e]<0&&(this.axis[e]+=t);
}for(const e of this.axis){
if(e<0||e>=t){
throw new Error(`Invalid axis: ${e}`);
}
}if(this.axis.length!==Bp(this.axis).length){
throw new Error(`Found duplicate axes in: ${this.axis}`);
}const n=this.axis.map((t=>e[t]));this.scale?this.gamma=this.addWeight("gamma",n,"float32",this.gammaInitializer,this.gammaRegularizer,!0):this.gamma=null,this.center?this.beta=this.addWeight("beta",n,"float32",this.betaInitializer,this.betaRegularizer,!0):this.beta=null,this.built=!0;
}call(e,t){
const n=im(e),r=n.shape,s=r.length;return xi((()=>{
let{mean:e,variance:t}=Go(n,this.axis,!0);const i=Tp(1,s);for(const e of this.axis){
i[e]=r[e];
}const a=e=>null!=e&&e.shape.length!==s?Va(e,i):e;let o=this.scale?a(this.gamma.read()):null,u=this.center?a(this.beta.read()):null;const l=[],c=[];for(let e=0;e<s;++e){
-1!==this.axis.indexOf(e)?(l.push(r[e]),c.push(1)):(l.push(1),c.push(r[e]));
}return e=bo(e,l),t=bo(t,l),null!=o&&(o=bo(o,c)),null!=u&&(u=bo(u,c)),wx(n,e,t,u,o,this.epsilon);
}));
}getConfig(){
const e={axis:this.axis,epsilon:this.epsilon,center:this.center,scale:this.scale,betaInitializer:tm(this.betaInitializer),gammaInitializer:tm(this.gammaInitializer),betaRegularizer:cb(this.betaRegularizer),gammaRegularizer:cb(this.gammaRegularizer)},t=super.getConfig();return Object.assign(e,t),e;
}
}kx.className="LayerNormalization",Oi(kx);class Ix extends bm{
constructor(e){
if(null==e&&(e={}),super(e),this.dataFormat=null==e.dataFormat?"channelsLast":e.dataFormat,null==e.padding){
this.padding=[[1,1],[1,1]];
}else if("number"==typeof e.padding){
this.padding=[[e.padding,e.padding],[e.padding,e.padding]];
}else{
if(e.padding=e.padding,2!==e.padding.length){
throw new Sp(`ZeroPadding2D expects padding to be a length-2 array, but received a length-${e.padding.length} array.`);
}let t,n;if("number"==typeof e.padding[0]){
t=[e.padding[0],e.padding[0]],n=[e.padding[1],e.padding[1]];
}else{
if(e.padding=e.padding,2!==e.padding[0].length){
throw new Sp(`ZeroPadding2D expects height padding to be a length-2 array, but received a length-${e.padding[0].length} array.`);
}if(t=e.padding[0],2!==e.padding[1].length){
throw new Sp(`ZeroPadding2D expects width padding to be a length-2 array, but received a length-${e.padding[1].length} array.`);
}n=e.padding[1];
}this.padding=[t,n];
}this.inputSpec=[new dm({ndim:4})];
}computeOutputShape(e){
let t,n;return e=am(e),"channelsFirst"===this.dataFormat?(t=null!=e[2]&&e[2]>=0?e[2]+this.padding[0][0]+this.padding[0][1]:null,n=null!=e[3]&&e[3]>=0?e[3]+this.padding[1][0]+this.padding[1][1]:null,[e[0],e[1],t,n]):(t=null!=e[1]&&e[1]>=0?e[1]+this.padding[0][0]+this.padding[0][1]:null,n=null!=e[2]&&e[2]>=0?e[2]+this.padding[1][0]+this.padding[1][1]:null,[e[0],t,n,e[3]]);
}call(e,t){
return xi((()=>{
return t=im(e),n=this.padding,r=this.dataFormat,xi((()=>{
if(4!==t.rank){
throw new Sp(`temporalPadding expects input tensor to be 4-D, but received a ${t.rank}-D tensor.`);
}if(null==n&&(n=[[1,1],[1,1]]),2!==n.length||2!==n[0].length||2!==n[1].length){
throw new Sp("spatial2dPadding expects `padding` to be an Array of two Arrays, each of which is an Array of two integers.");
}if(null==r&&(r="channelsLast"),"channelsLast"!==r&&"channelsFirst"!==r){
throw new Sp(`Unknown data format: ${r}. Supported data formats are 'channelsLast' and 'channelsFirst.`);
}let e;return e="channelsFirst"===r?[[0,0],[0,0],n[0],n[1]]:[[0,0],n[0],n[1],[0,0]],Zo(t,e);
}));var t,n,r;
}));
}getConfig(){
const e={padding:this.padding,dataFormat:this.dataFormat},t=super.getConfig();return Object.assign(e,t),e;
}
}function Sx(e,t,n,r,s,i){
return xi((()=>{
let a;rf(s),af(i),sf(r),null==n&&(n=[1,1]),null==r&&(r="valid"),null==s&&(s="channelsLast"),null==i&&(i="max"),e=kb(e,s);const o="same"===r?"same":"valid";return a="max"===i?Ao(e,t,n,o):Ga(e,t,n,o),"channelsFirst"===s&&(a=$u(a,[0,3,1,2])),a;
}));
}function Cx(e,t,n,r,s,i){
return xi((()=>{
let a;rf(s),af(i),sf(r),null==n&&(n=[1,1,1]),null==r&&(r="valid"),null==s&&(s="channelsLast"),null==i&&(i="max"),e=Ib(e,s);const o="same"===r?"same":"valid";return a="max"===i?Fo(e,t,n,o):ja(e,t,n,o),"channelsFirst"===s&&(a=$u(a,[0,4,1,2,3])),a;
}));
}Ix.className="ZeroPadding2D",Oi(Ix);class Nx extends bm{
constructor(e){
if(null==e.poolSize&&(e.poolSize=2),super(e),"number"==typeof e.poolSize){
this.poolSize=[e.poolSize];
}else{
if(!Array.isArray(e.poolSize)||1!==e.poolSize.length||"number"!=typeof e.poolSize[0]){
throw new Sp(`poolSize for 1D convolutional layer must be a number or an Array of a single number, but received ${JSON.stringify(e.poolSize)}`);
}this.poolSize=e.poolSize;
}if(Gp(this.poolSize,"poolSize"),null==e.strides){
this.strides=this.poolSize;
}else if("number"==typeof e.strides){
this.strides=[e.strides];
}else{
if(!Array.isArray(e.strides)||1!==e.strides.length||"number"!=typeof e.strides[0]){
throw new Sp(`strides for 1D convolutional layer must be a number or an Array of a single number, but received ${JSON.stringify(e.strides)}`);
}this.strides=e.strides;
}Gp(this.strides,"strides"),this.padding=null==e.padding?"valid":e.padding,sf(this.padding),this.inputSpec=[new dm({ndim:3})];
}computeOutputShape(e){
const t=wb((e=am(e))[1],this.poolSize[0],this.padding,this.strides[0]);return[e[0],t,e[2]];
}call(e,t){
return xi((()=>{
this.invokeCallHook(e,t),e=wf(im(e),2);const n=this.poolingFunction(im(e),[this.poolSize[0],1],[this.strides[0],1],this.padding,"channelsLast");return xu(n,[2]);
}));
}getConfig(){
const e={poolSize:this.poolSize,padding:this.padding,strides:this.strides},t=super.getConfig();return Object.assign(e,t),e;
}
}class $x extends Nx{
constructor(e){
super(e);
}poolingFunction(e,t,n,r,s){
return rf(s),sf(r),Sx(e,t,n,r,s,"max");
}
}$x.className="MaxPooling1D",Oi($x);class Tx extends Nx{
constructor(e){
super(e);
}poolingFunction(e,t,n,r,s){
return rf(s),sf(r),Sx(e,t,n,r,s,"avg");
}
}Tx.className="AveragePooling1D",Oi(Tx);class Ex extends bm{
constructor(e){
if(null==e.poolSize&&(e.poolSize=[2,2]),super(e),this.poolSize=Array.isArray(e.poolSize)?e.poolSize:[e.poolSize,e.poolSize],null==e.strides){
this.strides=this.poolSize;
}else if(Array.isArray(e.strides)){
if(2!==e.strides.length){
throw new Sp(`If the strides property of a 2D pooling layer is an Array, it is expected to have a length of 2, but received length ${e.strides.length}.`);
}this.strides=e.strides;
}else {
this.strides=[e.strides,e.strides];
}Gp(this.poolSize,"poolSize"),Gp(this.strides,"strides"),this.padding=null==e.padding?"valid":e.padding,this.dataFormat=null==e.dataFormat?"channelsLast":e.dataFormat,rf(this.dataFormat),sf(this.padding),this.inputSpec=[new dm({ndim:4})];
}computeOutputShape(e){
e=am(e);let t="channelsFirst"===this.dataFormat?e[2]:e[1],n="channelsFirst"===this.dataFormat?e[3]:e[2];return t=wb(t,this.poolSize[0],this.padding,this.strides[0]),n=wb(n,this.poolSize[1],this.padding,this.strides[1]),"channelsFirst"===this.dataFormat?[e[0],e[1],t,n]:[e[0],t,n,e[3]];
}call(e,t){
return xi((()=>(this.invokeCallHook(e,t),this.poolingFunction(im(e),this.poolSize,this.strides,this.padding,this.dataFormat))));
}getConfig(){
const e={poolSize:this.poolSize,padding:this.padding,strides:this.strides,dataFormat:this.dataFormat},t=super.getConfig();return Object.assign(e,t),e;
}
}class Rx extends Ex{
constructor(e){
super(e);
}poolingFunction(e,t,n,r,s){
return rf(s),sf(r),Sx(e,t,n,r,s,"max");
}
}Rx.className="MaxPooling2D",Oi(Rx);class Ax extends Ex{
constructor(e){
super(e);
}poolingFunction(e,t,n,r,s){
return rf(s),sf(r),Sx(e,t,n,r,s,"avg");
}
}Ax.className="AveragePooling2D",Oi(Ax);class Fx extends bm{
constructor(e){
if(null==e.poolSize&&(e.poolSize=[2,2,2]),super(e),this.poolSize=Array.isArray(e.poolSize)?e.poolSize:[e.poolSize,e.poolSize,e.poolSize],null==e.strides){
this.strides=this.poolSize;
}else if(Array.isArray(e.strides)){
if(3!==e.strides.length){
throw new Sp(`If the strides property of a 3D pooling layer is an Array, it is expected to have a length of 3, but received length ${e.strides.length}.`);
}this.strides=e.strides;
}else {
this.strides=[e.strides,e.strides,e.strides];
}Gp(this.poolSize,"poolSize"),Gp(this.strides,"strides"),this.padding=null==e.padding?"valid":e.padding,this.dataFormat=null==e.dataFormat?"channelsLast":e.dataFormat,rf(this.dataFormat),sf(this.padding),this.inputSpec=[new dm({ndim:5})];
}computeOutputShape(e){
e=am(e);let t="channelsFirst"===this.dataFormat?e[2]:e[1],n="channelsFirst"===this.dataFormat?e[3]:e[2],r="channelsFirst"===this.dataFormat?e[4]:e[3];return t=wb(t,this.poolSize[0],this.padding,this.strides[0]),n=wb(n,this.poolSize[1],this.padding,this.strides[1]),r=wb(r,this.poolSize[2],this.padding,this.strides[2]),"channelsFirst"===this.dataFormat?[e[0],e[1],t,n,r]:[e[0],t,n,r,e[4]];
}call(e,t){
return xi((()=>(this.invokeCallHook(e,t),this.poolingFunction(im(e),this.poolSize,this.strides,this.padding,this.dataFormat))));
}getConfig(){
const e={poolSize:this.poolSize,padding:this.padding,strides:this.strides,dataFormat:this.dataFormat},t=super.getConfig();return Object.assign(e,t),e;
}
}class _x extends Fx{
constructor(e){
super(e);
}poolingFunction(e,t,n,r,s){
return rf(s),sf(r),Cx(e,t,n,r,s,"max");
}
}_x.className="MaxPooling3D",Oi(_x);class Dx extends Fx{
constructor(e){
super(e);
}poolingFunction(e,t,n,r,s){
return rf(s),sf(r),Cx(e,t,n,r,s,"avg");
}
}Dx.className="AveragePooling3D",Oi(Dx);class Ox extends bm{
constructor(e){
super(e),this.inputSpec=[new dm({ndim:3})];
}computeOutputShape(e){
return[e[0],e[2]];
}call(e,t){
throw new Cp;
}
}class Mx extends Ox{
constructor(e){
super(e||{});
}call(e,t){
return xi((()=>{
const t=im(e);return _o(t,1);
}));
}
}Mx.className="GlobalAveragePooling1D",Oi(Mx);class Lx extends Ox{
constructor(e){
super(e||{});
}call(e,t){
return xi((()=>{
const t=im(e);return No(t,1);
}));
}
}Lx.className="GlobalMaxPooling1D",Oi(Lx);class zx extends bm{
constructor(e){
super(e),this.dataFormat=null==e.dataFormat?"channelsLast":e.dataFormat,rf(this.dataFormat),this.inputSpec=[new dm({ndim:4})];
}computeOutputShape(e){
return"channelsLast"===this.dataFormat?[e[0],e[3]]:[e[0],e[1]];
}call(e,t){
throw new Cp;
}getConfig(){
const e={dataFormat:this.dataFormat},t=super.getConfig();return Object.assign(e,t),e;
}
}class Px extends zx{
call(e,t){
return xi((()=>{
const t=im(e);return"channelsLast"===this.dataFormat?_o(t,[1,2]):_o(t,[2,3]);
}));
}
}Px.className="GlobalAveragePooling2D",Oi(Px);class Bx extends zx{
call(e,t){
return xi((()=>{
const t=im(e);return"channelsLast"===this.dataFormat?No(t,[1,2]):No(t,[2,3]);
}));
}
}Bx.className="GlobalMaxPooling2D",Oi(Bx);class Ux extends bm{
constructor(e){
super(e),this.layer=e.layer;
}build(e){
this.built=!0;
}get trainable(){
return null!=this.layer&&this.layer.trainable;
}set trainable(e){
null!=this.layer&&(this.layer.trainable=e);
}get trainableWeights(){
return this.layer.trainableWeights;
}get nonTrainableWeights(){
return this.layer.nonTrainableWeights;
}get updates(){
return this.layer._updates;
}get losses(){
return this.layer.losses;
}getWeights(){
return this.layer.getWeights();
}setWeights(e){
this.layer.setWeights(e);
}getConfig(){
const e={layer:{className:this.layer.getClassName(),config:this.layer.getConfig()}},t=super.getConfig();return Object.assign(e,t),e;
}setFastWeightInitDuringBuild(e){
super.setFastWeightInitDuringBuild(e),null!=this.layer&&this.layer.setFastWeightInitDuringBuild(e);
}static fromConfig(e,t,n={}){
const r=Km(t.layer,n);delete t.layer;const s={layer:r};return Object.assign(s,t),new e(s);
}
}class Wx extends Ux{
constructor(e){
super(e),this.supportsMasking=!0;
}build(e){
if((e=am(e)).length<3){
throw new Sp(`TimeDistributed layer expects an input shape >= 3D, but received input shape ${JSON.stringify(e)}`);
}this.inputSpec=[{shape:e}];const t=[e[0]].concat(e.slice(2));this.layer.built||(this.layer.build(t),this.layer.built=!0),super.build(e);
}computeOutputShape(e){
const t=[(e=am(e))[0]].concat(e.slice(2)),n=this.layer.computeOutputShape(t),r=e[1];return[n[0],r].concat(n.slice(1));
}call(e,t){
return xi((()=>zb(((e,n)=>[im(this.layer.call(e,t)),[]]),e=im(e),[],!1,null,null,!1,!0)[1]));
}
}Wx.className="TimeDistributed",Oi(Wx);class Vx extends Ux{
constructor(e){
super(e);const t=e.layer.getConfig(),n={};n.className=e.layer.getClassName(),n.config=t,this.forwardLayer=Km(n),t.goBackwards=!0!==t.goBackwards;const r={};var s;if(r.className=e.layer.getClassName(),r.config=t,this.backwardLayer=Km(r),this.forwardLayer.name="forward_"+this.forwardLayer.name,this.backwardLayer.name="backward_"+this.backwardLayer.name,this.mergeMode=void 0===e.mergeMode?"concat":e.mergeMode,s=this.mergeMode,Wp(tf,"BidirectionalMergeMode",s),e.weights){
throw new Cp("weights support is not implemented for Bidirectional layer yet.");
}this._stateful=e.layer.stateful,this.returnSequences=e.layer.returnSequences,this.returnState=e.layer.returnState,this.supportsMasking=!0,this._trainable=!0,this.inputSpec=e.layer.inputSpec,this.numConstants=null;
}get trainable(){
return this._trainable;
}set trainable(e){
this._trainable=e,null!=this.forwardLayer&&(this.forwardLayer.trainable=e),null!=this.backwardLayer&&(this.backwardLayer.trainable=e);
}getWeights(){
return this.forwardLayer.getWeights().concat(this.backwardLayer.getWeights());
}setWeights(e){
const t=e.length,n=Math.floor(t/2);this.forwardLayer.setWeights(e.slice(0,n)),this.backwardLayer.setWeights(e.slice(n));
}computeOutputShape(e){
let t,n,r,s=this.forwardLayer.computeOutputShape(e);return Array.isArray(s)&&Array.isArray(s[0])||(s=[s]),this.returnState?(r=s.slice(1),t=s[0]):t=s[0],"concat"===this.mergeMode?(t[t.length-1]*=2,n=[t]):n=null==this.mergeMode?[t,t.slice()]:[t],this.returnState?null==this.mergeMode?n.concat(r).concat(r.slice()):[t].concat(r).concat(r.slice()):Ap(n);
}apply(e,t){
let n=null==t?null:t.initialState,r=null==t?null:t.constants;null==t&&(t={});const s=Lb(e,n,r,this.numConstants);if(e=s.inputs,n=s.initialState,r=s.constants,Array.isArray(e)&&(n=e.slice(1),e=e[0]),(null==n||0===n.length)&&null==r){
return super.apply(e,t);
}const i=[],a=[];if(null!=n){
const e=n.length;if(e%2>0){
throw new Sp("When passing `initialState` to a Bidrectional RNN, the state should be an Array containing the states of the underlying RNNs.");
}t.initialState=n,i.push(...n);const r=n.map((e=>new dm({shape:e.shape})));this.forwardLayer.stateSpec=r.slice(0,e/2),this.backwardLayer.stateSpec=r.slice(e/2),a.push(...r);
}if(null!=r){
throw new Cp("Support for constants in Bidirectional layers is not implemented yet.");
}const o=i[0]instanceof pm;for(const e of i){
if(e instanceof pm!==o){
throw new Sp("The initial state of a Bidirectional layer cannot be specified as a mix of symbolic and non-symbolic tensors");
}
}if(o){
const n=[e].concat(i),r=this.inputSpec.concat(a),s=this.inputSpec;this.inputSpec=r;const o=super.apply(n,t);return this.inputSpec=s,o;
}return super.apply(e,t);
}call(e,t){
return xi((()=>{
const n=t.initialState;let r,s,i,a;if(null==n){
r=this.forwardLayer.call(e,t),s=this.backwardLayer.call(e,t);
}else{
const i=n.slice(0,n.length/2),a=n.slice(n.length/2);r=this.forwardLayer.call(e,Object.assign(t,{initialState:i})),s=this.backwardLayer.call(e,Object.assign(t,{initialState:a}));
}return this.returnState&&(Array.isArray(r)&&(i=r.slice(1).concat(s.slice(1))),r=r[0],s=s[0]),this.returnSequences&&(s=au(s,1)),"concat"===this.mergeMode?a=Sf([r,s]):"sum"===this.mergeMode?a=ki(r,s):"ave"===this.mergeMode?a=Ci(.5,ki(r,s)):"mul"===this.mergeMode?a=Ci(r,s):null==this.mergeMode&&(a=[r,s]),this.returnState?null==this.mergeMode?a.concat(i):[a].concat(i):a;
}));
}resetStates(e){
this.forwardLayer.resetStates(),this.backwardLayer.resetStates();
}build(e){
uf(this.forwardLayer.name,(()=>{
this.forwardLayer.build(e);
})),uf(this.backwardLayer.name,(()=>{
this.backwardLayer.build(e);
})),this.built=!0;
}computeMask(e,t){
let n;if(Array.isArray(t)&&(t=t[0]),n=this.returnSequences?null==this.mergeMode?[t,t]:t:null==this.mergeMode?[null,null]:null,this.returnState){
const e=this.forwardLayer.states.map((e=>null));return Array.isArray(n)?n.concat(e).concat(e):[n].concat(e).concat(e);
}return n;
}get trainableWeights(){
return this.forwardLayer.trainableWeights.concat(this.backwardLayer.trainableWeights);
}get nonTrainableWeights(){
return this.forwardLayer.nonTrainableWeights.concat(this.backwardLayer.nonTrainableWeights);
}setFastWeightInitDuringBuild(e){
super.setFastWeightInitDuringBuild(e),null!=this.forwardLayer&&this.forwardLayer.setFastWeightInitDuringBuild(e),null!=this.backwardLayer&&this.backwardLayer.setFastWeightInitDuringBuild(e);
}getConfig(){
const e={mergeMode:this.mergeMode},t=super.getConfig();return Object.assign(e,t),e;
}static fromConfig(e,t){
const n=Km(t.layer);if(delete t.layer,null!=t.numConstants){
throw new Cp("Deserialization of a Bidirectional layer with numConstants present is not supported yet.");
}const r=t;return r.layer=n,new e(r);
}
}Vx.className="Bidirectional",Oi(Vx);class Gx extends bm{
constructor(e){
super(e),this.scale=e.scale,e.offset?this.offset=e.offset:this.offset=0;
}getConfig(){
const e={scale:this.scale,offset:this.offset},t=super.getConfig();return Object.assign(e,t),e;
}call(e,t){
return xi((()=>("float32"!==(e=im(e)).dtype&&(e=yf(e,"float32")),ki(Ci(e,this.scale),this.offset))));
}
}Gx.className="Rescaling",Oi(Gx);const{resizeBilinear:jx,cropAndResize:Hx}=$l;class qx extends bm{
constructor(e){
super(e),this.height=e.height,this.width=e.width;
}centerCrop(e,t,n,r,s,i,a,o){
return xi((()=>{
let u,l=!1;const c=[t/i,n/a,(r+t)/i,(s+n)/a],h=[];3===e.rank?(l=!0,u=yu([e])):u=e;for(let e=0;e<u.shape[0];e++){
h.push(c);
}const d=Ds(h,[h.length,4]),p=su(0,h.length,1,"int32"),f=Hx(u,d,p,[r,s],"nearest");return yf(l?im(Iu(f)):f,o);
}));
}upsize(e,t,n,r){
return xi((()=>yf(jx(e,[t,n]),r)));
}call(e,t){
return xi((()=>{
const t=im(e),n=t.dtype,r=t.shape,s=r[r.length-3],i=r[r.length-2];let a=0;s!==this.height&&(a=Math.floor((s-this.height)/2));let o=0;return i!==this.width&&(o=Math.floor((i-this.width)/2),0===o&&(o=1)),a>=0&&o>=0?this.centerCrop(t,a,o,this.height,this.width,s,i,n):this.upsize(e,this.height,this.width,n);
}));
}getConfig(){
const e={height:this.height,width:this.width},t=super.getConfig();return Object.assign(e,t),e;
}computeOutputShape(e){
const t=(e=am(e)).length-3,n=e.length-2;return e[t]=this.height,e[n]=this.width,e;
}
}qx.className="CenterCrop",Oi(qx);class Kx extends bm{
constructor(e){
super(e),this.numTokens=e.numTokens,e.outputMode?this.outputMode=e.outputMode:this.outputMode="multiHot";
}getConfig(){
const e={numTokens:this.numTokens,outputMode:this.outputMode},t=super.getConfig();return Object.assign(e,t),e;
}computeOutputShape(e){
return null==(e=am(e))?[this.numTokens]:"oneHot"===this.outputMode&&1!==e[e.length-1]?(e.push(this.numTokens),e):(e[e.length-1]=this.numTokens,e);
}call(e,t){
return xi((()=>{
let n;if("int32"!==(e=im(e)).dtype&&(e=yf(e,"int32")),void 0!==t.countWeights){
if("count"!==this.outputMode){
throw new Sp(`countWeights is not used when outputMode !== count.\n              Received countWeights=${t.countWeights}`);
}n=im(t.countWeights);
}const r=No(e),s=Do(e),i=vo(this.numTokens,r).bufferSync().get(0),a=ko(s,0).bufferSync().get(0);if(!i||!a){
throw new Sp(`Input values must be between 0 < values <= numTokens with numTokens=${this.numTokens}`);
}return function(e,t,n,r){
let s=im(e);if("int32"!==s.dtype&&(s=yf(s,"int32")),"int"===t){
return s;
}const i=s.shape;if(0===s.rank&&(s=go(s,-1)),"oneHot"===t&&1!==s.shape[s.shape.length-1]&&(s=go(s,-1)),s.rank>2){
throw new Sp(`When outputMode is not int, maximum output rank is 2 Received outputMode ${t} and input shape ${i} which would result in output rank ${s.rank}.`);
}const a=["multiHot","oneHot"].includes(t);let o;if(o=co(s,void 0!==r&&"count"===t?r:[],n,a),"tfIdf"!==t){
return o;
}if(r){
return Ci(o,r);
}throw new Sp("When outputMode is 'tfIdf', weights must be provided.");
}(e,this.outputMode,this.numTokens,n);
}));
}
}Kx.className="CategoryEncoding",Oi(Kx);const Xx=new Set(["bilinear","nearest"]);class Yx extends bm{
constructor(e){
if(super(e),this.height=e.height,this.width=e.width,e.interpolation){
if(!Xx.has(e.interpolation)){
throw new Sp(`Invalid interpolation parameter: ${e.interpolation} is not implemented`);
}this.interpolation=e.interpolation;
}else {
this.interpolation="bilinear";
}this.cropToAspectRatio=Boolean(e.cropToAspectRatio);
}computeOutputShape(e){
const t=(e=am(e))[2];return[this.height,this.width,t];
}getConfig(){
const e={height:this.height,width:this.width,interpolation:this.interpolation,cropToAspectRatio:this.cropToAspectRatio},t=super.getConfig();return Object.assign(e,t),e;
}call(e,t){
return xi((()=>{
const t=[this.height,this.width];if("bilinear"===this.interpolation){
return $l.resizeBilinear(e,t,!this.cropToAspectRatio);
}if("nearest"===this.interpolation){
return $l.resizeNearestNeighbor(e,t,!this.cropToAspectRatio);
}throw new Error(`Interpolation is ${this.interpolation} but only ${[...Xx]} are supported`);
}));
}
}Yx.className="Resizing",Oi(Yx);class Zx{
constructor(e){
this.seed=e;
}next(){
if(void 0!==this.seed){
return this.seed++;
}
}
}Zx.className="RandomSeed";class Jx extends bm{
constructor(e){
super(e),this.randomGenerator=new Zx(e.seed);
}getConfig(){
const e={seed:this.randomGenerator.seed},t=super.getConfig();return Object.assign(e,t),e;
}
}Jx.className="BaseRandomLayer";const Qx=new Set(["bilinear","nearest"]);class ey extends Jx{
constructor(e){
super(e);const{factor:t,interpolation:n="bilinear"}=e;if(this.factor=t,Array.isArray(this.factor)&&2===this.factor.length){
this.widthLower=this.factor[0],this.widthUpper=this.factor[1];
}else{
if(Array.isArray(this.factor)||!(this.factor>0)){
throw new Sp(`Invalid factor: ${this.factor}. Must be positive number or tuple of 2 numbers`);
}this.widthLower=-this.factor,this.widthUpper=this.factor;
}if(this.widthLower<-1||this.widthUpper<-1){
throw new Sp(`factor must have values larger than -1. Got: ${this.factor}`);
}if(this.widthUpper<this.widthLower){
throw new Sp(`factor cannot have upper bound less than lower bound.\n        Got upper bound: ${this.widthUpper}.\n        Got lower bound: ${this.widthLower}\n      `);
}if(n){
if(!Qx.has(n)){
throw new Sp(`Invalid interpolation parameter: ${n} is not implemented`);
}this.interpolation=n;
}
}getConfig(){
const e={factor:this.factor,interpolation:this.interpolation},t=super.getConfig();return Object.assign(e,t),e;
}computeOutputShape(e){
const t=(e=am(e))[2];return[this.imgHeight,-1,t];
}call(e,t){
return xi((()=>{
const t=im(e);this.imgHeight=t.shape[t.shape.length-3];const n=t.shape[t.shape.length-2];this.widthFactor=ru([1],1+this.widthLower,1+this.widthUpper,"float32",this.randomGenerator.next());let r=this.widthFactor.dataSync()[0]*n;r=Math.round(r);const s=[this.imgHeight,r];switch(this.interpolation){
case"bilinear":return $l.resizeBilinear(e,s);case"nearest":return $l.resizeNearestNeighbor(e,s);default:throw new Error(`Interpolation is ${this.interpolation}\n          but only ${[...Qx]} are supported`);
}
}));
}
}var ty,ny,ry,sy;function iy(e,t,n=new Map,r=new Set){
if(null==e){
return null;
}if("function"==typeof Blob&&e instanceof Blob){
return e.slice();
}if(r.has(e)){
throw new Error("Circular references are not supported.");
}if(n.has(e)){
return n.get(e);
}const s=t(e);if(s.recurse&&null!==s.value){
throw new Error("A deep map function may not return both a value and recurse=true.");
}if(s.recurse){
if(ly(e)){
const s=Array.isArray(e)?[]:{};r.add(e);for(const i in e){
const a=iy(e[i],t,n,r);s[i]=a;
}return r.delete(e),e.__proto__&&(s.__proto__=e.__proto__),s;
}throw new Error(`Can't recurse into non-iterable type: ${e}`);
}return n.set(e,s.value),s.value;
}function ay(e,t=uy){
return oy(e,t);
}function oy(e,t,n=new Set){
const r=e[0];if(n.has(r)){
throw new Error("Circular references are not supported.");
}const s=t(e);if(s.recurse&&null!==s.value){
throw new Error("A deep zip function may not return both a value and recurse=true.");
}if(s.recurse){
if(ly(r)){
const s=Array.isArray(r)?[]:{};n.add(r);for(const i in r){
const r=oy(e.map((e=>e[i])),t,n);s[i]=r;
}return n.delete(r),s;
}throw new Error(`Can't recurse into non-iterable type: ${r}`);
}return s.value;
}function uy(e){
return null===e?null:ly(e[0])?{value:null,recurse:!0}:{value:e,recurse:!1};
}function ly(e){
let t=!1;if(H().get("IS_BROWSER")){
t=e instanceof TextDecoder;
}else{
const{StringDecoder:n}=__webpack_require__(182);t=e instanceof n;
}return null!=e&&!ArrayBuffer.isView(e)&&(Array.isArray(e)||"object"==typeof e&&!(e instanceof es)&&!(e instanceof Promise)&&!t);
}function cy(e){
return iy(e,hy);
}function hy(e){
return e instanceof es?{value:e.clone(),recurse:!1}:ly(e)?{value:null,recurse:!0}:{value:e,recurse:!1};
}ey.className="RandomWidth",Oi(ey),H().registerFlag("KEEP_INTERMEDIATE_TENSORS",(()=>!1),(e=>{
e&&console.warn("Keep intermediate tensors is ON. This will print the values of all intermediate tensors during model inference. Not all models support this mode. For details, check e2e/benchmarks/ model_config.js. This significantly impacts performance.");
})),function(e){
e[e.DT_INVALID=0]="DT_INVALID",e[e.DT_FLOAT=1]="DT_FLOAT",e[e.DT_DOUBLE=2]="DT_DOUBLE",e[e.DT_INT32=3]="DT_INT32",e[e.DT_UINT8=4]="DT_UINT8",e[e.DT_INT16=5]="DT_INT16",e[e.DT_INT8=6]="DT_INT8",e[e.DT_STRING=7]="DT_STRING",e[e.DT_COMPLEX64=8]="DT_COMPLEX64",e[e.DT_INT64=9]="DT_INT64",e[e.DT_BOOL=10]="DT_BOOL",e[e.DT_QINT8=11]="DT_QINT8",e[e.DT_QUINT8=12]="DT_QUINT8",e[e.DT_QINT32=13]="DT_QINT32",e[e.DT_BFLOAT16=14]="DT_BFLOAT16",e[e.DT_QINT16=15]="DT_QINT16",e[e.DT_QUINT16=16]="DT_QUINT16",e[e.DT_UINT16=17]="DT_UINT16",e[e.DT_COMPLEX128=18]="DT_COMPLEX128",e[e.DT_HALF=19]="DT_HALF",e[e.DT_RESOURCE=20]="DT_RESOURCE",e[e.DT_VARIANT=21]="DT_VARIANT",e[e.DT_UINT32=22]="DT_UINT32",e[e.DT_UINT64=23]="DT_UINT64",e[e.DT_FLOAT_REF=101]="DT_FLOAT_REF",e[e.DT_DOUBLE_REF=102]="DT_DOUBLE_REF",e[e.DT_INT32_REF=103]="DT_INT32_REF",e[e.DT_UINT8_REF=104]="DT_UINT8_REF",e[e.DT_INT16_REF=105]="DT_INT16_REF",e[e.DT_INT8_REF=106]="DT_INT8_REF",e[e.DT_STRING_REF=107]="DT_STRING_REF",e[e.DT_COMPLEX64_REF=108]="DT_COMPLEX64_REF",e[e.DT_INT64_REF=109]="DT_INT64_REF",e[e.DT_BOOL_REF=110]="DT_BOOL_REF",e[e.DT_QINT8_REF=111]="DT_QINT8_REF",e[e.DT_QUINT8_REF=112]="DT_QUINT8_REF",e[e.DT_QINT32_REF=113]="DT_QINT32_REF",e[e.DT_BFLOAT16_REF=114]="DT_BFLOAT16_REF",e[e.DT_QINT16_REF=115]="DT_QINT16_REF",e[e.DT_QUINT16_REF=116]="DT_QUINT16_REF",e[e.DT_UINT16_REF=117]="DT_UINT16_REF",e[e.DT_COMPLEX128_REF=118]="DT_COMPLEX128_REF",e[e.DT_HALF_REF=119]="DT_HALF_REF",e[e.DT_RESOURCE_REF=120]="DT_RESOURCE_REF",e[e.DT_VARIANT_REF=121]="DT_VARIANT_REF",e[e.DT_UINT32_REF=122]="DT_UINT32_REF",e[e.DT_UINT64_REF=123]="DT_UINT64_REF";
}(ty||(ty={})),function(e){
let t;!function(e){
e[e.LEGACY=0]="LEGACY",e[e.V1=1]="V1",e[e.V2=2]="V2";
}(t=e.CheckpointFormatVersion||(e.CheckpointFormatVersion={}));
}(ny||(ny={})),new Set(["Switch","Merge","Enter","Exit","NextIteration","StatelessIf","StatelessWhile","if","While"]),new Set(["NonMaxSuppressionV2","NonMaxSuppressionV3","NonMaxSuppressionV5","Where"]),new Set(["HashTable","HashTableV2","LookupTableImport","LookupTableImportV2","LookupTableFind","LookupTableFindV2","LookupTableSize","LookupTableSizeV2"]);class dy{
constructor(e){
if(this.capacity=e,this.begin=0,this.end=0,null==e){
throw new RangeError("Can't create a ring buffer of unknown capacity.");
}if(e<1){
throw new RangeError("Can't create ring buffer of capacity < 1.");
}this.data=new Array(e),this.doubledCapacity=2*e;
}wrap(e){
for(;e<0;){
e+=this.doubledCapacity;
}return e%this.doubledCapacity;
}get(e){
if(e<0){
throw new RangeError("Can't get item at a negative index.");
}return this.data[e%this.capacity];
}set(e,t){
if(e<0){
throw new RangeError("Can't set item at a negative index.");
}this.data[e%this.capacity]=t;
}length(){
let e=this.end-this.begin;return e<0&&(e=this.doubledCapacity+e),e;
}isFull(){
return this.length()===this.capacity;
}isEmpty(){
return 0===this.length();
}push(e){
if(this.isFull()){
throw new RangeError("Ring buffer is full.");
}this.set(this.end,e),this.end=this.wrap(this.end+1);
}pushAll(e){
for(const t of e){
this.push(t);
}
}pop(){
if(this.isEmpty()){
throw new RangeError("Ring buffer is empty.");
}this.end=this.wrap(this.end-1);const e=this.get(this.end);return this.set(this.end,void 0),e;
}unshift(e){
if(this.isFull()){
throw new RangeError("Ring buffer is full.");
}this.begin=this.wrap(this.begin-1),this.set(this.begin,e);
}shift(){
if(this.isEmpty()){
throw new RangeError("Ring buffer is empty.");
}const e=this.get(this.begin);return this.set(this.begin,void 0),this.begin=this.wrap(this.begin+1),e;
}shuffleExcise(e){
if(this.isEmpty()){
throw new RangeError("Ring buffer is empty.");
}const t=this.wrap(this.begin+e),n=this.get(t);return this.set(t,this.pop()),n;
}
}class py extends dy{
constructor(){
super(py.INITIAL_CAPACITY);
}isFull(){
return!1;
}push(e){
super.isFull()&&this.expand(),super.push(e);
}unshift(e){
super.isFull()&&this.expand(),super.unshift(e);
}expand(){
const e=2*this.capacity,t=new Array(e),n=this.length();for(let e=0;e<n;e++){
t[e]=this.get(this.wrap(this.begin+e));
}this.data=t,this.capacity=e,this.doubledCapacity=2*this.capacity,this.begin=0,this.end=n;
}
}py.INITIAL_CAPACITY=32;class fy{
async toArray(){
const e=[];let t=await this.next();for(;!t.done;){
e.push(t.value),t=await this.next();
}return e;
}async toArrayForTest(){
const e=this.prefetch(100),t=[];let n=await e.next();for(;!n.done;){
t.push(n.value),n=await e.next();
}return t;
}async resolveFully(){
let e=await this.next();for(;!e.done;){
e=await this.next();
}
}async resolveWhile(e){
let t=await this.next(),n=e(t.value);for(;!t.done&&n;){
t=await this.next(),n=e(t.value);
}
}handleErrors(e){
return new Iy(this,e);
}filter(e){
return new vy(this,e);
}map(e){
return new ky(this,e);
}mapAsync(e){
return new Sy(this,e);
}serialMapAsync(e){
return new Sy(this,e).serial();
}flatmap(e){
return new Ny(this,e);
}async forEachAsync(e){
return this.map(e).resolveFully();
}async serialForEach(e){
return this.serialMapAsync(e).resolveWhile((e=>!0===e));
}rowMajorBatch(e,t=!0){
return new wy(this,e,t);
}columnMajorBatch(e,t=!0,n=uy){
return this.rowMajorBatch(e,t).map((e=>ay(e,n)));
}concatenate(e,t){
return new $y(new my([this,e]),t);
}take(e){
return e<0||null==e?this:new yy(this,e);
}skip(e){
return e<0||null==e?this:new xy(this,e);
}prefetch(e){
return new Ty(this,e);
}shuffle(e,t){
return new Ey(this,e,t);
}serial(){
return new by(this);
}
}class my extends fy{
constructor(e){
super(),this.items=e,this.trav=0;
}summary(){
return`Array of ${this.items.length} items`;
}async next(){
if(this.trav>=this.items.length){
return{value:null,done:!0};
}const e=this.items[this.trav];return this.trav++,{value:cy(e),done:!1};
}
}class gy extends fy{
constructor(e){
super(),this.nextFn=e;
}summary(){
return"Function call";
}async next(){
try{
return this.nextFn();
}catch(e){
throw e.message=`Error thrown while iterating through a dataset: ${e.message}`,e;
}
}
}class by extends fy{
constructor(e){
super(),this.upstream=e,this.lastRead=Promise.resolve({value:null,done:!1});
}summary(){
return`${this.upstream.summary()} -> Serial`;
}async next(){
return this.lastRead=this.lastRead.then((()=>this.serialNext())),this.lastRead;
}async serialNext(){
return this.upstream.next();
}
}class xy extends fy{
constructor(e,t){
super(),this.upstream=e,this.maxCount=t,this.count=0,this.lastRead=Promise.resolve({value:null,done:!1});
}summary(){
return`${this.upstream.summary()} -> Skip`;
}async next(){
return this.lastRead=this.lastRead.then((()=>this.serialNext())),this.lastRead;
}async serialNext(){
for(;this.count++<this.maxCount;){
const e=await this.upstream.next();if(e.done){
return e;
}yi(e.value);
}return this.upstream.next();
}
}class yy extends fy{
constructor(e,t){
super(),this.upstream=e,this.maxCount=t,this.count=0;
}summary(){
return`${this.upstream.summary()} -> Take`;
}async next(){
return this.count++>=this.maxCount?{value:null,done:!0}:this.upstream.next();
}
}class wy extends fy{
constructor(e,t,n=!0){
super(),this.upstream=e,this.batchSize=t,this.enableSmallLastBatch=n,this.lastRead=Promise.resolve({value:null,done:!1});
}summary(){
return`${this.upstream.summary()} -> RowMajorBatch`;
}async next(){
return this.lastRead=this.lastRead.then((()=>this.serialNext())),this.lastRead;
}async serialNext(){
const e=[];for(;e.length<this.batchSize;){
const t=await this.upstream.next();if(t.done){
return this.enableSmallLastBatch&&e.length>0?{value:e,done:!1}:{value:null,done:!0};
}e.push(t.value);
}return{value:e,done:!1};
}
}class vy extends fy{
constructor(e,t){
super(),this.upstream=e,this.predicate=t,this.lastRead=Promise.resolve({value:null,done:!1});
}summary(){
return`${this.upstream.summary()} -> Filter`;
}async next(){
return this.lastRead=this.lastRead.then((()=>this.serialNext())),this.lastRead;
}async serialNext(){
for(;;){
const e=await this.upstream.next();if(e.done||this.predicate(e.value)){
return e;
}yi(e.value);
}
}
}class ky extends fy{
constructor(e,t){
super(),this.upstream=e,this.transform=t;
}summary(){
return`${this.upstream.summary()} -> Map`;
}async next(){
const e=await this.upstream.next();if(e.done){
return{value:null,done:!0};
}const t=ms(e.value),n=this.transform(e.value),r=ms(n);for(const e of t){
fs(e,r)||e.dispose();
}return{value:n,done:!1};
}
}class Iy extends fy{
constructor(e,t){
super(),this.upstream=e,this.handler=t,this.count=0,this.lastRead=Promise.resolve({value:null,done:!1});
}summary(){
return`${this.upstream.summary()} -> handleErrors`;
}async next(){
return this.lastRead=this.lastRead.then((()=>this.serialNext())),this.lastRead;
}async serialNext(){
for(;;){
try{
return await this.upstream.next();
}catch(e){
if(!this.handler(e)){
return{value:null,done:!0};
}
}
}
}
}class Sy extends fy{
constructor(e,t){
super(),this.upstream=e,this.transform=t;
}summary(){
return`${this.upstream.summary()} -> AsyncMap`;
}async next(){
const e=await this.upstream.next();if(e.done){
return{value:null,done:!0};
}const t=ms(e.value),n=await this.transform(e.value),r=ms(n);for(const e of t){
fs(e,r)||e.dispose();
}return{value:n,done:!1};
}
}class Cy extends fy{
constructor(){
super(),this.outputQueue=new py,this.lastRead=Promise.resolve({value:null,done:!1});
}async next(){
return this.lastRead=this.lastRead.then((()=>this.serialNext())),this.lastRead;
}async serialNext(){
for(;0===this.outputQueue.length();){
if(!await this.pump()){
return{value:null,done:!0};
}
}return{value:this.outputQueue.shift(),done:!1};
}
}class Ny extends Cy{
constructor(e,t){
super(),this.upstream=e,this.transform=t;
}summary(){
return`${this.upstream.summary()} -> Flatmap`;
}async pump(){
const e=await this.upstream.next();if(e.done){
return!1;
}const t=ms(e.value),n=this.transform(e.value),r=ms(n);this.outputQueue.pushAll(n);for(const e of t){
fs(e,r)||e.dispose();
}return!0;
}
}class $y extends fy{
constructor(e,t){
super(),this.baseErrorHandler=t,this.lastRead=null,this.iterator=null,this.moreIterators=e;
}summary(){
return"TODO: fill in upstream of chained summaries -> Chained";
}async next(){
return this.lastRead=this.readFromChain(this.lastRead),this.lastRead;
}async readFromChain(e){
if(await e,null==this.iterator){
const e=await this.moreIterators.next();if(e.done){
return{value:null,done:!0};
}this.iterator=e.value,null!=this.baseErrorHandler&&(this.iterator=this.iterator.handleErrors(this.baseErrorHandler));
}const t=await this.iterator.next();return t.done?(this.iterator=null,this.readFromChain(e)):t;
}
}(sy=ry||(ry={}))[sy.FAIL=0]="FAIL",sy[sy.SHORTEST=1]="SHORTEST",sy[sy.LONGEST=2]="LONGEST";class Ty extends fy{
constructor(e,t){
super(),this.upstream=e,this.bufferSize=t,this.buffer=new dy(t);
}summary(){
return`${this.upstream.summary()} -> Prefetch`;
}refill(){
for(;!this.buffer.isFull();){
const e=this.upstream.next();this.buffer.push(e);
}
}next(){
return this.refill(),this.buffer.shift();
}
}class Ey extends Ty{
constructor(e,t,n){
super(e,t),this.upstream=e,this.windowSize=t,this.upstreamExhausted=!1,this.random=Qo.alea(n||Dr().toString()),this.lastRead=Promise.resolve({value:null,done:!1});
}async next(){
return this.lastRead=this.lastRead.then((()=>this.serialNext())),this.lastRead;
}randomInt(e){
return Math.floor(this.random()*e);
}chooseIndex(){
return this.randomInt(this.buffer.length());
}async serialNext(){
for(this.upstreamExhausted||this.refill();!this.buffer.isEmpty();){
const e=this.chooseIndex(),t=await this.buffer.shuffleExcise(e);if(!t.done){
return this.refill(),t;
}this.upstreamExhausted=!0;
}return{value:null,done:!0};
}
}class Ry{
constructor(){
this.size=null;
}batch(e,t=!0){
const n=this;let r;return d(e>0,(()=>`batchSize needs to be positive, but it is\n      ${e}`)),r=this.size===1/0||null==this.size?this.size:t?Math.ceil(this.size/e):Math.floor(this.size/e),Ay((async()=>(await n.iterator()).columnMajorBatch(e,t,Fy)),r);
}concatenate(e){
const t=this;let n;return n=this.size===1/0||e.size===1/0?1/0:null!=this.size&&null!=e.size?this.size+e.size:null,Ay((async()=>(await t.iterator()).concatenate(await e.iterator())),n);
}filter(e){
const t=this;let n;return n=this.size===1/0?1/0:null,Ay((async()=>(await t.iterator()).filter((t=>xi((()=>e(t)))))),n);
}async forEachAsync(e){
return(await this.iterator()).forEachAsync(e);
}map(e){
const t=this;return Ay((async()=>(await t.iterator()).map((t=>xi((()=>e(t)))))),this.size);
}mapAsync(e){
const t=this;return Ay((async()=>(await t.iterator()).mapAsync(e)),this.size);
}prefetch(e){
if(null==e){
throw new RangeError("`Dataset.prefetch()` requires bufferSize to be specified.");
}const t=this;return Ay((async()=>(await t.iterator()).prefetch(e)),this.size);
}repeat(e){
const t=this;let n;return n=null!=this.size&&e>0?this.size*e:0===e?0:null!=this.size&&(void 0===e||e<0)?1/0:null,Ay((async()=>{
return n=(s=async()=>({value:await t.iterator(),done:!1}),new gy(s)).take(e),new $y(n,r);var n,r,s;
}),n);
}skip(e){
const t=this;let n;return n=null!=this.size&&e>=0&&this.size>=e?this.size-e:null!=this.size&&(this.size<e||void 0===e||e<0)?0:null,Ay((async()=>(await t.iterator()).skip(e)),n);
}shuffle(e,t,n=!0){
if(null==e||e<0){
throw null==this.size?new RangeError("`Dataset.shuffle()` requires bufferSize to be specified."):new RangeError(`\`Dataset.shuffle()\` requires bufferSize to be specified.  If your data fits in main memory (for regular JS objects), and/or GPU memory (for \`tf.Tensor\`s), consider setting bufferSize to the dataset size (${this.size} elements)`);
}const r=this,s=Qo.alea(t||Dr().toString());return Ay((async()=>{
let t=s.int32();return n&&(t+=s.int32()),(await r.iterator()).shuffle(e,t.toString());
}),this.size);
}take(e){
const t=this;let n;return n=null!=this.size&&this.size>e?e:null!=this.size&&this.size<=e?this.size:null,Ay((async()=>(await t.iterator()).take(e)),n);
}async toArray(){
if(this.size===1/0){
throw new Error("Can not convert infinite data stream to array.");
}return(await this.iterator()).toArray();
}async toArrayForTest(){
if(this.size===1/0){
throw new Error("Can not convert infinite data stream to array.");
}return(await this.iterator()).toArrayForTest();
}
}function Ay(e,t=null){
return new class extends Ry{
constructor(){
super(...arguments),this.size=t;
}async iterator(){
return e();
}
};
}function Fy(e){
if(null===e){
return null;
}return null==(t=e[0])||null===(n=t)||"object"!=typeof n&&"function"!=typeof n||Array.isArray(t)||"object"==typeof t&&t instanceof es||Lr(t)?{value:function(e){
if(0===e.length){
throw new Error("Can't make a batch of zero elements.");
}return e[0]instanceof es?yu(e):Ds(e);
}(e),recurse:!1}:{value:null,recurse:!0};var t,n;
}function _y(e,t){
Array.isArray(e)||(e=[e]),e.forEach((e=>{
null!=e&&d("complex64"!==e.dtype,(()=>`${t} does not support complex64 tensors in the CPU backend.`));
}));
}Ry.MAX_BUFFER_SIZE=1e4,Symbol("out"),Symbol("field"),Symbol("quote"),Symbol("quoteafterquote"),Symbol("quoteinquote");const Dy=Uc;class Oy extends a{
nextDataId(){
return Oy.nextDataId++;
}constructor(){
super(),this.blockSize=48,this.firstUse=!0,this.data=new i(this,gi());
}write(e,t,n){
this.firstUse&&(this.firstUse=!1,H().get("IS_NODE")&&or("\n============================\nHi, looks like you are running TensorFlow.js in Node.js. To speed things up dramatically, install our node backend, visit https://github.com/tensorflow/tfjs-node for more details. \n============================"));const r={id:this.nextDataId()};return this.data.set(r,{values:e,dtype:n,refCount:1}),r;
}makeTensorInfo(e,t,n){
let r;if("string"===t&&null!=n&&n.length>0&&T(n[0])){
const s=n.map((e=>Or(e)));r=this.write(s,e,t);
}else {
r=this.write(n,e,t);
}return{dataId:r,shape:e,dtype:t};
}refCount(e){
return this.data.has(e)?this.data.get(e).refCount:0;
}incRef(e){
this.data.get(e).refCount++;
}decRef(e){
this.data.has(e)&&this.data.get(e).refCount--;
}move(e,t,n,r,s){
this.data.set(e,{values:t,dtype:r,refCount:s});
}numDataIds(){
return this.data.numDataIds();
}async read(e){
return this.readSync(e);
}readSync(e){
const{dtype:t,complexTensorInfos:n}=this.data.get(e);return"complex64"===t?ic(this.readSync(n.real.dataId),this.readSync(n.imag.dataId)):function(e,t){
if(Array.isArray(e)){
return e;
}if("float32"===t){
return e instanceof Float32Array?e:new Float32Array(e);
}if("int32"===t){
return e instanceof Int32Array?e:new Int32Array(e);
}if("bool"===t||"string"===t){
return Uint8Array.from(new Int32Array(e));
}throw new Error(`Unknown dtype ${t}`);
}(this.data.get(e).values,t);
}bufferSync(e){
const t=this.readSync(e.dataId);if("string"===e.dtype){
try{
const n=t.map((e=>Mr(e)));return pi(e.shape,e.dtype,n);
}catch(e){
throw new Error("Failed to decode encoded string bytes into utf-8");
}
}return pi(e.shape,e.dtype,t);
}makeOutput(e,t,n){
return gi().makeTensorFromTensorInfo(this.makeTensorInfo(t,n,e),this);
}disposeData(e,t=!1){
if(this.data.has(e)){
if(this.data.get(e).refCount--,!t&&this.data.get(e).refCount>0){
return!1;
}const{complexTensorInfos:n}=this.data.get(e);null!=n&&(this.disposeData(n.real.dataId,!0),this.disposeData(n.imag.dataId,!0)),this.data.delete(e);
}return!0;
}disposeIntermediateTensorInfo(e){
this.disposeData(e.dataId);
}async time(e){
const t=Dr();return e(),{kernelMs:Dr()-t};
}memory(){
return{unreliable:!0,reasons:["The reported memory is an upper bound. Due to automatic garbage collection, the true allocated memory may be less."]};
}where(e){
_y([e],"where");const t=this.readSync(e.dataId);return Dy(e.shape,t);
}dispose(){}floatPrecision(){
return 32;
}epsilon(){
return super.epsilon();
}
}function My(e){
return(t,n,r)=>{
const s=C(n,t.length);for(let n=0;n<t.length;++n){
s[n]=e(t[n],r);
}return s;
};
}function Ly(e,t,n){
return zy(e,My(t),n);
}function zy(e,t,n){
return({inputs:r,attrs:s,backend:i})=>{
const{x:a}=r;_y(a,e);const o=i,u=o.data.get(a.dataId).values;let l;if("string"===a.dtype){
if(!Array.isArray(u)){
throw new Error("String tensor's value was not an instance of Array");
}l=Pc(u);
}else {
l=u;
}const c=n||a.dtype,h=t(l,c,s);return o.makeTensorInfo(a.shape,c,h);
};
}Oy.nextDataId=0,vi("cpu",(()=>new Oy),1);const Py=Ly(Ke,(e=>e>=0?e:Math.exp(e)-1)),By={kernelName:Ke,backendName:"cpu",kernelFunc:Py};function Uy(e){
const{inputs:t,backend:n}=e,{x:r}=t;return n.incRef(r.dataId),{dataId:r.dataId,shape:r.shape,dtype:r.dtype};
}const Wy={kernelName:ht,backendName:"cpu",kernelFunc:Uy};function Vy(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{alpha:i}=r;_y([s],"leakyRelu");const a=m(s.shape),o=n.data.get(s.dataId).values,u=S("float32",a);for(let e=0;e<o.length;e++){
u[e]=o[e]<0?i*o[e]:o[e];
}return n.makeTensorInfo(s.shape,"float32",u);
}const Gy={kernelName:bt,backendName:"cpu",kernelFunc:Vy};function jy(e){
return(t,n,r,s,i)=>{
const a=Hi(t,n),o=a.length,u=_(a),l=S(i,m(a)),c=t.length,h=n.length,d=_(t),p=_(n),f=Gi(t,a),g=Gi(n,a);if(f.length+g.length===0){
for(let t=0;t<l.length;++t){
l[t]=e(r[t%r.length],s[t%s.length]);
}
}else {
for(let t=0;t<l.length;++t){
const n=U(t,o,u),i=n.slice(-c);f.forEach((e=>i[e]=0));const a=B(i,c,d),m=n.slice(-h);g.forEach((e=>m[e]=0));const b=B(m,h,p);l[t]=e(r[a],s[b]);
}
}return[l,a];
};
}const Hy=jy(((e,t)=>e<0?t*e:e));function qy(e){
const{inputs:t,backend:n}=e,{x:r,alpha:s}=t;_y([r,s],"prelu");const i=n.data.get(r.dataId).values,a=n.data.get(s.dataId).values,[o,u]=Hy(r.shape,s.shape,i,a,"float32");return n.makeTensorInfo(u,"float32",o);
}const Ky={kernelName:Jt,backendName:"cpu",kernelFunc:qy},Xy=Ly(on,(e=>Math.max(0,e))),Yy={kernelName:on,backendName:"cpu",kernelFunc:Xy},Zy=Ly(pn,(e=>Math.min(Math.max(0,e),6))),Jy={kernelName:pn,backendName:"cpu",kernelFunc:Zy},Qy=My((e=>1/(1+Math.exp(-e)))),ew=Ly(Nn,(e=>1/(1+Math.exp(-e)))),tw={kernelName:Nn,backendName:"cpu",kernelFunc:ew};function nw(e,t,n,r,s){
if("linear"===n){
return Uy({inputs:{x:t},backend:e});
}if("relu"===n){
return Xy({inputs:{x:t},backend:e});
}if("elu"===n){
return Py({inputs:{x:t},backend:e});
}if("relu6"===n){
return Zy({inputs:{x:t},backend:e});
}if("prelu"===n){
return qy({inputs:{x:t,alpha:r},backend:e});
}if("leakyrelu"===n){
return Vy({inputs:{x:t},backend:e,attrs:{alpha:s}});
}if("sigmoid"===n){
return ew({inputs:{x:t},backend:e});
}throw new Error(`Activation ${n} has not been implemented for the CPU backend.`);
}function rw(e){
const{inputs:t,backend:n}=e,{real:r,imag:s}=t,i=n.data.get(r.dataId).values,a=n.data.get(s.dataId).values,o=n.makeTensorInfo(r.shape,"complex64");return n.data.get(o.dataId).complexTensorInfos={real:n.makeTensorInfo(r.shape,"float32",i),imag:n.makeTensorInfo(s.shape,"float32",a)},o;
}const sw={kernelName:Ie,backendName:"cpu",kernelFunc:rw};function iw(e,t,n="float32"){
if("complex64"===n){
return rw({inputs:{real:iw(e,t,"float32"),imag:iw(e,t,"float32")},backend:e});
}const r=L(m(t),n);return e.makeTensorInfo(t,n,r);
}function aw(e){
const{inputs:t,backend:n}=e,{input:r}=t,s=n.data.get(r.dataId).complexTensorInfos.real,i=n.data.get(s.dataId).values;return n.makeTensorInfo(s.shape,s.dtype,i);
}const ow={kernelName:sn,backendName:"cpu",kernelFunc:aw};function uw(e,t,n,r){
if("int32"===r){
return[t,"int32",Int32Array.from(e)];
}if("bool"===r){
const r=_r([0],n),[s,i]=jy(((e,t)=>e!==t?1:0))(t,[],e,r,"bool");return[i,"bool",s];
}throw new Error(`Error in Cast: failed to cast ${n} to ${r}`);
}function lw(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{dtype:i}=r;if("complex64"===i){
if("complex64"===s.dtype){
return Uy({inputs:{x:s},backend:n});
}const e=iw(n,s.shape,s.dtype),t=lw({inputs:{x:s},backend:n,attrs:{dtype:"float32"}}),r=rw({inputs:{real:t,imag:e},backend:n});return n.disposeIntermediateTensorInfo(e),n.disposeIntermediateTensorInfo(t),r;
}if("complex64"===s.dtype){
const e=aw({inputs:{input:s},backend:n}),t=lw({inputs:{x:e},backend:n,attrs:{dtype:i}});return n.disposeIntermediateTensorInfo(e),t;
}if(!N(s.dtype,i)){
const e=Uy({inputs:{x:s},backend:n});return{dataId:e.dataId,shape:e.shape,dtype:i};
}const a=n.data.get(s.dataId).values,[o,u,l]=uw(a,s.shape,s.dtype,i);return n.makeTensorInfo(o,u,l);
}const cw={kernelName:we,backendName:"cpu",kernelFunc:lw};function hw(e,t,n,r){
return null==n?({inputs:n,backend:s})=>{
const{a:i,b:a}=n,o=s;_y([i,a],e);const u=o.data.get(i.dataId).values,l=o.data.get(a.dataId).values,c="string"===i.dtype?Pc(u):u,h="string"===i.dtype?Pc(l):l,d=r||i.dtype,[p,f]=t(i.shape,a.shape,c,h,d);return o.makeTensorInfo(f,d,p);
}:({inputs:e,backend:s})=>{
const{a:i,b:a}=e,o=s;if("complex64"===i.dtype||"complex64"===a.dtype){
const e=lw({inputs:{x:i},backend:o,attrs:{dtype:"complex64"}}),t=o.data.get(e.dataId),r=t.complexTensorInfos.real,s=t.complexTensorInfos.imag,u=o.data.get(r.dataId).values,l=o.data.get(s.dataId).values,c=lw({inputs:{x:a},backend:o,attrs:{dtype:"complex64"}}),h=o.data.get(c.dataId),d=h.complexTensorInfos.real,p=h.complexTensorInfos.imag,f=o.data.get(d.dataId).values,m=o.data.get(p.dataId).values,[g,b,x]=n(i.shape,a.shape,u,l,f,m),y=o.makeTensorInfo(x,"float32",g),w=o.makeTensorInfo(x,"float32",b),v=rw({inputs:{real:y,imag:w},backend:o});return o.disposeIntermediateTensorInfo(e),o.disposeIntermediateTensorInfo(c),o.disposeIntermediateTensorInfo(y),o.disposeIntermediateTensorInfo(w),v;
}{const e=o.data.get(i.dataId).values,n=o.data.get(a.dataId).values,s=r||i.dtype,[u,l]=t(i.shape,a.shape,e,n,s);return o.makeTensorInfo(l,s,u);}
};
}function dw(e){
return(t,n,r,s,i,a)=>{
const o=Hi(t,n),u=m(o),l=o.length,c=_(o),h=S("float32",u),d=S("float32",u),p=Gi(t,o),f=Gi(n,o),g=ic(r,s),b=ic(i,a),x=t.length,y=_(t),w=n.length,v=_(n);if(p.length+f.length===0){
for(let t=0;t<h.length;t++){
const n=t%g.length,r=t%b.length,s=e(g[2*n],g[2*n+1],b[2*r],b[2*r+1]);h[t]=s.real,d[t]=s.imag;
}
}else {
for(let t=0;t<h.length;t++){
const n=U(t,l,c),r=n.slice(-x);p.forEach((e=>r[e]=0));const s=B(r,x,y),i=n.slice(-w);f.forEach((e=>i[e]=0));const a=B(i,w,v),o=e(g[2*s],g[2*s+1],b[2*a],b[2*a+1]);h[t]=o.real,d[t]=o.imag;
}
}return[h,d,o];
};
}const pw=jy(((e,t)=>e+t)),fw=dw(((e,t,n,r)=>({real:e+n,imag:t+r}))),mw=hw(ee,pw,fw),gw={kernelName:ee,backendName:"cpu",kernelFunc:mw};function bw(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{shape:i}=r,a=m(s.shape),o=v(i,a),u=m(o);d(a===u,(()=>`The new shape (${o}) has ${u} elements and the old shape (${s.shape}) has ${a} elements. The new shape and old shape must have the same number of elements.`)),n.incRef(s.dataId);const l=n.data.get(s.dataId);if(null!=l.complexTensorInfos){
const e=l.complexTensorInfos.real,t=l.complexTensorInfos.imag;e.shape=o,t.shape=o;
}return{dataId:s.dataId,shape:o,dtype:s.dtype};
}const xw={kernelName:un,backendName:"cpu",kernelFunc:bw};function yw(e){
const{inputs:t,backend:n,attrs:r}=e,{a:s,b:i}=t,{transposeA:a,transposeB:o}=r;_y([s,i],"matMul");const u=s.shape.length,l=i.shape.length,c=a?s.shape[u-2]:s.shape[u-1],h=o?i.shape[l-1]:i.shape[l-2],p=a?s.shape[u-1]:s.shape[u-2],f=o?i.shape[l-2]:i.shape[l-1],g=s.shape.slice(0,-2),b=i.shape.slice(0,-2),x=m(g),y=m(b),w=Hi(s.shape.slice(0,-2),i.shape.slice(0,-2)).concat([p,f]);d(c===h,(()=>`Error in matMul: inner shapes (${c}) and (${h}) of Tensors with shapes ${s.shape} and ${i.shape} and transposeA=${a} and transposeB=${o} must match.`));const v=o?[y,f,h]:[y,h,f],k=bw({inputs:{x:s},backend:n,attrs:{shape:a?[x,c,p]:[x,p,c]}}),I=bw({inputs:{x:i},backend:n,attrs:{shape:v}}),S=a?k.shape[1]:k.shape[2],C=a?k.shape[2]:k.shape[1],N=o?I.shape[1]:I.shape[2],$=Math.max(x,y),T=n.data.get(k.dataId).values,E=n.data.get(I.dataId).values,R=_(k.shape),A=_(I.shape),[F,D,O]=a?[R[0],1,R[1]]:[R[0],R[1],1],[M,L,z]=o?[1,A[1],A[0]]:[A[1],1,A[0]],P=C*N,B=pi([$,C,N],k.dtype),U=B.values,W=n.blockSize;for(let e=0;e<$;e++){
const t=e%x,n=e%y;for(let r=0;r<C;r+=W){
const s=Math.min(r+W,C);for(let i=0;i<N;i+=W){
const a=Math.min(i+W,N);for(let o=0;o<S;o+=W){
const u=Math.min(o+W,S);for(let l=r;l<s;l++){
for(let r=i;r<a;r++){
let s=0;for(let e=o;e<u;e++){
s+=T[t*F+l*D+e*O]*E[e*M+r*L+n*z];
}U[e*P+(l*N+r)]+=s;
}
}
}
}
}
}return n.disposeIntermediateTensorInfo(k),n.disposeIntermediateTensorInfo(I),n.makeTensorInfo(w,B.dtype,B.values);
}const ww={kernelName:me,backendName:"cpu",kernelFunc:yw},vw={kernelName:sr,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{a:s,b:i,bias:a,preluActivationWeights:o}=t,{transposeA:u,transposeB:l,activation:c,leakyreluAlpha:h}=r;let d,p,f;const m=[];d=yw({inputs:{a:s,b:i},attrs:{transposeA:u,transposeB:l},backend:n}),a&&(p=mw({inputs:{a:d,b:a},backend:n}),m.push(d),d=p),c&&(f=nw(n,d,c,o,h),m.push(d),d=f);for(const e of m){
n.disposeIntermediateTensorInfo(e);
}return d;
}};function kw(e){
const t=new Float32Array(e.length);for(let n=0;n<e.length;++n){
t[n]=Math.abs(e[n]);
}return t;
}const Iw={kernelName:Z,backendName:"cpu",kernelFunc:e=>{
const{x:t}=e.inputs,n=e.backend;_y(t,"abs");let r=new Float32Array(m(t.shape));return r=kw(n.data.get(t.dataId).values),n.makeOutput(r,t.shape,t.dtype);
}},Sw=Ly(J,(e=>Math.acos(e))),Cw={kernelName:J,backendName:"cpu",kernelFunc:Sw},Nw=Ly(Q,(e=>Math.acosh(e))),$w={kernelName:Q,backendName:"cpu",kernelFunc:Nw},Tw={kernelName:te,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n}=e,r=t;_y(t,"addN");const s=r.map((e=>n.data.get(e.dataId).values)),i=pi(r[0].shape,r[0].dtype),a=i.values;for(let e=0;e<r.length;e++){
const t=s[e];for(let e=0;e<a.length;e++){
a[e]+=t[e];
}
}return n.makeTensorInfo(i.shape,i.dtype,i.values);
}};function Ew(e,t,n,r,s){
const i=t.length,a=m(t),o=_(t),u=_(s),l=S(n,m(s));for(let t=0;t<a;++t){
const n=U(t,i,o),s=new Array(n.length);for(let e=0;e<s.length;e++){
s[e]=n[r[e]];
}l[B(s,i,u)]=e[t];
}return l;
}function Rw(e){
const{inputs:t,attrs:n,backend:r}=e,{x:s}=t,{perm:i}=n;_y(s,"transpose");const a=s.shape.length,o=new Array(a);for(let e=0;e<o.length;e++){
o[e]=s.shape[i[e]];
}const u=Ew(r.data.get(s.dataId).values,s.shape,s.dtype,i,o);return{dataId:r.write(u,o,s.dtype),shape:o,dtype:s.dtype};
}const Aw={kernelName:Zn,backendName:"cpu",kernelFunc:Rw},Fw={kernelName:ne,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{axis:i,keepDims:a}=r;_y(s,"all");const o=k(i,s.shape);let u=o;const l=Uo(u,s.shape.length);let c=s;null!=l&&(c=Rw({inputs:{x:s},backend:n,attrs:{perm:l}}),u=Vo(u.length,s.shape.length)),Bo("all",u,c.shape.length);const[h,d]=zo(c.shape,u),p=m(d),f=L(m(h),c.dtype),g=n.data.get(c.dataId).values;for(let e=0;e<f.length;++e){
const t=e*p;let n=g[t];for(let e=0;e<p;++e){
const r=g[t+e];n=n&&r;
}f[e]=n;
}null!=l&&n.disposeIntermediateTensorInfo(c);const b=n.makeTensorInfo(h,c.dtype,f);if(a){
const e=bw({inputs:{x:b},backend:n,attrs:{shape:Po(h,o)}});return n.disposeIntermediateTensorInfo(b),e;
}return b;
}},_w={kernelName:re,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{axis:i,keepDims:a}=r;_y(s,"any");const o=k(i,s.shape);let u=o;const l=Uo(u,s.shape.length);let c=s;null!=l&&(c=Rw({inputs:{x:s},backend:n,attrs:{perm:l}}),u=Vo(u.length,s.shape.length)),Bo("any",u,c.shape.length);const[h,d]=zo(c.shape,u),p=m(d),f=L(m(h),c.dtype),g=n.data.get(c.dataId).values;for(let e=0;e<f.length;++e){
const t=e*p;let n=g[t];for(let e=0;e<p;++e){
const r=g[t+e];n=n||r;
}f[e]=n;
}null!=l&&n.disposeIntermediateTensorInfo(c);const b=n.makeTensorInfo(h,c.dtype,f);if(a){
const e=bw({inputs:{x:b},backend:n,attrs:{shape:Po(h,o)}});return n.disposeIntermediateTensorInfo(b),e;
}return b;
}},Dw={kernelName:se,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{axis:i}=r;_y(s,"argMax");let a=k(i,s.shape);const o=Uo(a,s.shape.length);let u=s;const l=[];null!=o&&(u=Rw({inputs:{x:s},backend:n,attrs:{perm:o}}),l.push(u),a=Vo(a.length,u.shape.length)),a=[a[0]],Bo("argMax",a,u.shape.length);const[c,h]=zo(u.shape,a),d=L(m(c),"int32"),p=m(h),f=n.data.get(u.dataId).values;for(let e=0;e<d.length;++e){
const t=e*p;let n=f[t],r=0;for(let e=0;e<p;++e){
const s=f[t+e];s>n&&(n=s,r=e);
}d[e]=r;
}return l.forEach((e=>n.disposeIntermediateTensorInfo(e))),n.makeTensorInfo(c,"int32",d);
}},Ow={kernelName:ie,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{axis:i}=r;_y(s,"argMin");let a=k(i,s.shape);const o=Uo(a,s.shape.length);let u=s;const l=[];null!=o&&(u=Rw({inputs:{x:s},backend:n,attrs:{perm:o}}),l.push(u),a=Vo(a.length,u.shape.length)),a=[a[0]],Bo("argMin",a,u.shape.length);const[c,h]=zo(u.shape,a),d=L(m(c),"int32"),p=m(h),f=n.data.get(u.dataId).values;for(let e=0;e<d.length;++e){
const t=e*p;let n=f[t],r=0;for(let e=0;e<p;++e){
const s=f[t+e];s<n&&(n=s,r=e);
}d[e]=r;
}return l.forEach((e=>n.disposeIntermediateTensorInfo(e))),n.makeTensorInfo(c,"int32",d);
}},Mw=Ly(ae,(e=>Math.asin(e))),Lw={kernelName:ae,backendName:"cpu",kernelFunc:Mw},zw=Ly(oe,(e=>Math.asinh(e))),Pw={kernelName:oe,backendName:"cpu",kernelFunc:zw},Bw=Ly(ue,(e=>Math.atan(e))),Uw={kernelName:ue,backendName:"cpu",kernelFunc:Bw},Ww=jy(((e,t)=>Math.atan2(e,t))),Vw=hw(ce,Ww),Gw={kernelName:ce,backendName:"cpu",kernelFunc:Vw},jw=Ly(le,(e=>Math.atanh(e))),Hw={kernelName:le,backendName:"cpu",kernelFunc:jw};function qw(e,t,n,r,s,i){
const a=s.strideHeight,o=s.strideWidth,u=s.dilationHeight,l=s.dilationWidth,c=s.effectiveFilterHeight,h=s.effectiveFilterWidth,d=s.padInfo.top,p=s.padInfo.left,f="max"===i?Number.NEGATIVE_INFINITY:Number.POSITIVE_INFINITY,m=pi(s.outShape,n),g=m.values,b=s.outShape[1]*s.outShape[2]*s.outShape[3],x=s.outShape[2]*s.outShape[3],y=s.outShape[3];for(let t=0;t<s.batchSize;++t){
const n=t*b,m=t*r[0];for(let t=0;t<s.inChannels;++t){
for(let b=0;b<s.outHeight;++b){
const w=b*a-d,v=Math.max(0,w),k=Math.min(s.inHeight,c+w),I=n+b*x;for(let n=0;n<s.outWidth;++n){
const a=n*o-p,c=Math.max(0,a),d=Math.min(s.inWidth,h+a);let b=f,x=0,w=0;for(let n=v;n<k;n+=u){
const s=m+n*r[1];for(let n=c;n<d;n+=l){
const a=e[s+n*r[2]+t];"max"===i&&a>b?b=a:"avg"===i&&(x+=a,w++);
}if(isNaN(b)){
break;
}
}g[I+n*y+t]="avg"===i?x/w:b;
}
}
}
}return m;
}function Kw(e,t,n,r,s=!1,i=!1){
const a=pi(r.outShape,"int32"),o=r.strideHeight,u=r.strideWidth,l=r.dilationHeight,c=r.dilationWidth,h=r.effectiveFilterHeight,d=r.effectiveFilterWidth,p=r.padInfo.top,f=r.padInfo.left,m=pi(t,n,e);for(let e=0;e<r.batchSize;++e){
for(let t=0;t<r.inChannels;++t){
for(let n=0;n<r.outHeight;++n){
const g=n*o-p;let b=g;for(;b<0;){
b+=l;
}const x=Math.min(r.inHeight,h+g);for(let o=0;o<r.outWidth;++o){
const h=o*u-f;let p=h;for(;p<0;){
p+=c;
}const y=Math.min(r.inWidth,d+h);let w=Number.NEGATIVE_INFINITY,v=-1;for(let n=b;n<x;n+=l){
const a=n-g;for(let o=p;o<y;o+=c){
const u=o-h,l=m.get(e,n,o,t);l>w&&(w=l,v=s?i?((e*r.inHeight+n)*r.inWidth+o)*r.inChannels+t:(n*r.inWidth+o)*r.inChannels+t:a*d+u);
}
}a.set(v,e,n,o,t);
}
}
}
}return a;
}function Xw(e,t,n,r,s,i){
const a=s.strideDepth,o=s.strideHeight,u=s.strideWidth,l=s.dilationDepth,c=s.dilationHeight,h=s.dilationWidth,d=s.effectiveFilterDepth,p=s.effectiveFilterHeight,f=s.effectiveFilterWidth,m=s.padInfo.front,g=s.padInfo.top,b=s.padInfo.left,x="max"===i?Number.NEGATIVE_INFINITY:Number.POSITIVE_INFINITY,y=pi(s.outShape,n),w=y.values,v=s.outShape[1]*s.outShape[2]*s.outShape[3]*s.outShape[4],k=s.outShape[2]*s.outShape[3]*s.outShape[4],I=s.outShape[3]*s.outShape[4],S=s.outShape[4];for(let t=0;t<s.batchSize;++t){
const n=t*v,y=t*r[0];for(let t=0;t<s.inChannels;++t){
for(let v=0;v<s.outDepth;++v){
const C=v*a-m;let N=C;for(;N<0;){
N+=l;
}const $=Math.min(s.inDepth,d+C),T=n+v*k;for(let n=0;n<s.outHeight;++n){
const a=n*o-g;let d=a;for(;d<0;){
d+=c;
}const m=Math.min(s.inHeight,p+a),v=T+n*I;for(let n=0;n<s.outWidth;++n){
const a=n*u-b;let o=a;for(;o<0;){
o+=h;
}const p=Math.min(s.inWidth,f+a),g=v+n*S;let k=x,I=0,C=0;for(let n=N;n<$;n+=l){
const s=y+n*r[1];for(let n=d;n<m;n+=c){
const a=s+n*r[2];for(let n=o;n<p;n+=h){
const s=e[a+n*r[3]+t];if("max"===i&&s>k?k=s:"avg"===i&&(I+=s,C++),isNaN(k)){
break;
}
}if(isNaN(k)){
break;
}
}if(isNaN(k)){
break;
}
}w[g+t]="avg"===i?I/Math.max(C,1):k;
}
}
}
}
}return y;
}const Yw={kernelName:he,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t;_y(s,"avgPool");const{filterSize:i,strides:a,pad:o,dimRoundingMode:u}=r;d(Pa(a,1),(()=>`Error in avgPool: Either strides or dilations must be 1. Got strides ${a} and dilations '1'`));const l=Ea(s.shape,i,a,1,o,u);let c;if(1===l.filterWidth&&1===l.filterHeight&&g(l.inShape,l.outShape)){
c=Uy({inputs:{x:s},backend:n});
}else{
const e=n.data.get(s.dataId).values,t=_(s.shape),r=qw(e,s.shape,s.dtype,t,l,"avg");c=n.makeTensorInfo(l.outShape,s.dtype,r.values);
}return c;
}},Zw={kernelName:pe,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{filterSize:i,strides:a,pad:o,dimRoundingMode:u,dataFormat:l}=r;_y(s,"avgPool3d");const c=Ra(s.shape,i,a,1,o,u,l),h=Xw(n.data.get(s.dataId).values,s.shape,s.dtype,_(s.shape),c,"avg");return n.makeTensorInfo(h.shape,"float32",h.values);
}},Jw={kernelName:fe,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{dy:s,input:i}=t,{filterSize:a,strides:o,pad:u,dimRoundingMode:l}=r;_y([s,i],"avgPool3DGrad");const c=Ra(i.shape,a,o,1,u,l),h=c.strideDepth,d=c.strideHeight,p=c.strideWidth,f=c.filterDepth,m=c.filterHeight,g=c.filterWidth,b=c.dilationDepth,x=c.dilationHeight,y=c.dilationWidth,w=c.effectiveFilterDepth,v=c.effectiveFilterHeight,k=c.effectiveFilterWidth,I=w-1-c.padInfo.front,S=k-1-c.padInfo.left,C=v-1-c.padInfo.top,N=pi(i.shape,"float32"),$=1/(f*m*g),T=n.bufferSync(s);for(let e=0;e<c.batchSize;++e){
for(let t=0;t<c.inChannels;++t){
for(let n=0;n<c.inDepth;++n){
for(let r=0;r<c.inHeight;++r){
for(let s=0;s<c.inWidth;++s){
const i=n-I,a=r-C,o=s-S;let u=0;for(let n=0;n<w;n+=b){
const r=(i+n)/h;if(!(r<0||r>=c.outDepth||Math.floor(r)!==r)){
for(let n=0;n<v;n+=x){
const s=(a+n)/d;if(!(s<0||s>=c.outHeight||Math.floor(s)!==s)){
for(let n=0;n<k;n+=y){
const i=(o+n)/p;i<0||i>=c.outWidth||Math.floor(i)!==i||(u+=T.get(e,r,s,i,t));
}
}
}
}
}N.set(u*$,e,n,r,s,t);
}
}
}
}
}return n.makeTensorInfo(N.shape,N.dtype,N.values);
}},Qw={kernelName:de,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{dy:s,input:i}=t,a=i;_y([s,i],"avgPoolGrad");const{filterSize:o,strides:u,pad:l}=r,c=Ea(a.shape,o,u,1,l),h=c.strideHeight,d=c.strideWidth,p=c.filterHeight,f=c.filterWidth,m=c.dilationHeight,g=c.dilationWidth,b=c.effectiveFilterHeight,x=c.effectiveFilterWidth,y=x-1-c.padInfo.left,w=b-1-c.padInfo.top,v=pi(a.shape,"float32"),k=1/(p*f),I=n.data.get(s.dataId).values,S=pi(s.shape,"float32",I);for(let e=0;e<c.batchSize;++e){
for(let t=0;t<c.inChannels;++t){
for(let n=0;n<c.inHeight;++n){
for(let r=0;r<c.inWidth;++r){
const s=n-w,i=r-y;let a=0;for(let n=0;n<b;n+=m){
const r=(s+n)/h;if(!(r<0||r>=c.outHeight||Math.floor(r)!==r)){
for(let n=0;n<x;n+=g){
const s=(i+n)/d;s<0||s>=c.outWidth||Math.floor(s)!==s||(a+=S.get(e,r,s,t));
}
}
}v.set(a*k,e,n,r,t);
}
}
}
}return n.makeTensorInfo(v.shape,v.dtype,v.values);
}},ev={kernelName:at,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s,scale:i,offset:a,mean:o,variance:u}=t;d(o.shape.length===u.shape.length,(()=>"Batch normalization gradient requires mean and variance to have equal ranks.")),d(null==a||o.shape.length===a.shape.length,(()=>"Batch normalization gradient requires mean and offset to have equal ranks.")),d(null==i||o.shape.length===i.shape.length,(()=>"Batch normalization gradient requires mean and scale to have equal ranks.")),_y([s,o,u,i,a],"batchNorm");let{varianceEpsilon:l}=r;null==l&&(l=.001);const c=n.data.get(s.dataId).values,h=n.data.get(o.dataId).values,p=n.data.get(u.dataId).values,f=i?n.data.get(i.dataId).values:new Float32Array([1]),m=a?n.data.get(a.dataId).values:new Float32Array([0]),g=new Float32Array(c.length),b=m.length,x=f.length,y=p.length,w=h.length;let v=0,k=0,I=0,S=0;for(let e=0;e<c.length;++e){
g[e]=m[v++]+(c[e]-h[k++])*f[I++]/Math.sqrt(p[S++]+l),v>=b&&(v=0),k>=w&&(k=0),I>=x&&(I=0),S>=y&&(S=0);
}return n.makeTensorInfo(s.shape,s.dtype,g);
}};function tv(e,t,n,r,s){
const i=wa(r,t,n),a=m(n),o=_(r);if(i){
const n=va(t,o);return"string"===s?e.slice(n,n+a):e.subarray(n,n+a);
}const u=pi(r,s,"string"===s?Pc(e):e),l=pi(n,s);for(let e=0;e<l.size;++e){
const n=l.indexToLoc(e),r=n.map(((e,n)=>e+t[n]));l.set(u.get(...r),...n);
}return"string"===s?Bc(l.values):l.values;
}function nv(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{begin:i,size:a}=r;_y(s,"slice");const[o,u]=ka(s,i,a);ua(s,o,u);const l=tv(n.data.get(s.dataId).values,o,u,s.shape,s.dtype);return n.makeTensorInfo(u,s.dtype,l);
}const rv={kernelName:kn,backendName:"cpu",kernelFunc:nv},sv={kernelName:ge,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{blockShape:i,crops:a}=r;_y([s],"batchToSpaceND");const o=i.reduce(((e,t)=>e*t)),u=Wl(s.shape,i,o),l=Vl(u.length,i.length),c=Gl(s.shape,i,o),h=jl(a,i.length),d=Hl(c,a,i.length),p=bw({inputs:{x:s},backend:n,attrs:{shape:u}}),f=Rw({inputs:{x:p},backend:n,attrs:{perm:l}}),m=bw({inputs:{x:f},backend:n,attrs:{shape:c}}),g=nv({inputs:{x:m},backend:n,attrs:{begin:h,size:d}});return n.disposeIntermediateTensorInfo(p),n.disposeIntermediateTensorInfo(f),n.disposeIntermediateTensorInfo(m),g;
}};function iv(e,t,n,r,s){
const i=m(r),a=L(s,n);for(let n=0;n<e.length;n++){
const r=e[n];if(r<0){
throw new Error("Input x must be non-negative!");
}r>=s||(a[r]+=i>0?t[n]:1);
}return a;
}function av(e,t,n,r=!1){
const s=e.shape[0],i=e.shape[1],a=pi([s,n],t.dtype);for(let o=0;o<s;o++){
for(let s=0;s<i;s++){
const i=e.get(o,s);if(i<0){
throw new Error("Input x must be non-negative!");
}i>=n||(r?a.set(1,o,i):t.size>0?a.set(a.get(o,i)+t.get(o,s),o,i):a.set(a.get(o,i)+1,o,i));
}
}return a;
}const ov={kernelName:be,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s,weights:i}=t,{size:a}=r,o=iv(n.data.get(s.dataId).values,n.data.get(i.dataId).values,i.dtype,i.shape,a);return n.makeTensorInfo([a],i.dtype,o);
}},uv=jy(((e,t)=>e&t)),lv={kernelName:xe,backendName:"cpu",kernelFunc:hw(xe,uv)},cv={kernelName:ye,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n}=e,{s0:r,s1:s}=t,i=n.data.get(r.dataId).values,a=n.data.get(s.dataId).values,o=Hi(Array.from(i),Array.from(a));return n.makeTensorInfo([o.length],"int32",Int32Array.from(o));
}},hv=My((e=>Math.ceil(e))),dv=zy(ve,hv),pv={kernelName:ve,backendName:"cpu",kernelFunc:dv},fv=Ly(ke,((e,t)=>{
const n=t;return e>n.clipValueMax?n.clipValueMax:e<n.clipValueMin?n.clipValueMin:e;
})),mv={kernelName:ke,backendName:"cpu",kernelFunc:fv},gv={kernelName:Se,backendName:"cpu",kernelFunc:e=>{
const{x:t}=e.inputs,n=e.backend,r=new Float32Array(m(t.shape)),s=n.data.get(t.dataId),i=s.complexTensorInfos.real,a=s.complexTensorInfos.imag,o=n.data.get(i.dataId).values,u=n.data.get(a.dataId).values;for(let e=0;e<o.length;e++){
const t=o[e],n=u[e];r[e]=Math.hypot(t,n);
}return n.makeOutput(r,t.shape,"float32");
}};function bv(e,t,n,r){
const s=C(n,m(t));if(r&&"string"!==n){
let t=0;e.forEach((e=>{
const n=m(e.shape);s.set(e.vals,t),t+=n;
}));
}else{
let r=0;e.forEach((e=>{
const i="string"===n?Pc(e.vals):e.vals;let a=0;for(let n=0;n<e.shape[0];++n){
const o=n*t[1]+r;for(let t=0;t<e.shape[1];++t){
s[o+t]=i[a++];
}
}r+=e.shape[1];
}));
}return s;
}function xv(e){
const{inputs:t,backend:n}=e,{input:r}=t,s=n.data.get(r.dataId).complexTensorInfos.imag,i=n.data.get(s.dataId).values;return n.makeTensorInfo(s.shape,s.dtype,i);
}const yv={kernelName:pt,backendName:"cpu",kernelFunc:xv};function wv(e){
const{inputs:t,backend:n,attrs:r}=e,{axis:s}=r,i=k(s,t[0].shape)[0];Fl(t.map((e=>e.shape)),i);let a=_l(t.map((e=>e.shape)),i);if(0===m(a)){
return n.makeTensorInfo(a,t[0].dtype,[]);
}const o=t.filter((e=>m(e.shape)>0));if(1===o.length){
return Uy({inputs:{x:o[0]},backend:n});
}if("complex64"===o[0].dtype){
const e=o.map((e=>aw({inputs:{input:e},backend:n}))),t=o.map((e=>xv({inputs:{input:e},backend:n}))),r=wv({inputs:e,backend:n,attrs:{axis:i}}),s=wv({inputs:t,backend:n,attrs:{axis:i}}),a=rw({inputs:{real:r,imag:s},backend:n});return e.forEach((e=>n.disposeIntermediateTensorInfo(e))),t.forEach((e=>n.disposeIntermediateTensorInfo(e))),n.disposeIntermediateTensorInfo(r),n.disposeIntermediateTensorInfo(s),a;
}const u=o.map((e=>{
const t=m(e.shape.slice(i));return bw({inputs:{x:e},backend:n,attrs:{shape:[-1,t]}});
})),l=u.map((e=>({vals:n.data.get(e.dataId).values,shape:e.shape})));a=_l(u.map((e=>e.shape)),1);const c=1===u[0].shape[0],h=bv(l,a,t[0].dtype,c),d=_l(o.map((e=>e.shape)),i),p=n.makeTensorInfo(d,t[0].dtype,h);return u.forEach((e=>n.disposeIntermediateTensorInfo(e))),p;
}const vv={kernelName:Ce,backendName:"cpu",kernelFunc:wv};function kv(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s,filter:i}=t,{strides:a,pad:o,dataFormat:u,dilations:l,dimRoundingMode:c}=r;_y([s,i],"conv2d");const h=Ua(u),d=Aa(s.shape,i.shape,a,l,o,c,!1,h),p=d.filterHeight,f=d.filterWidth,m=d.dilationHeight,g=d.dilationWidth,b=d.padInfo.left,x=d.padInfo.top,y="channelsLast"===d.dataFormat,w=new Yr(d.outShape,s.dtype),v=_(s.shape),k=_(i.shape),I=v[0],S=y?v[1]:v[2],C=y?v[2]:1,N=y?1:v[1],$=w.strides[0],T=y?w.strides[1]:w.strides[2],E=y?w.strides[2]:1,R=y?1:w.strides[1],A=n.data.get(s.dataId).values,F=n.data.get(i.dataId).values,D=w.values;for(let e=0;e<d.batchSize;++e){
const t=e*I,n=e*$;for(let e=0;e<d.outHeight;++e){
const r=n+e*T,s=e*d.strideHeight-x;for(let e=0;e<p;++e){
const n=s+e*m;if(n<0||n>=d.inHeight){
continue;
}const i=e*k[0],a=t+n*S;for(let e=0;e<d.outWidth;++e){
const t=r+e*E,n=e*d.strideWidth-b;for(let e=0;e<f;++e){
const r=n+e*g;if(r<0||r>=d.inWidth){
continue;
}const s=a+r*C;let o=i+e*k[1];for(let e=0;e<d.inChannels;++e){
const n=A[s+e*N];for(let e=0;e<d.outChannels;++e){
D[t+e*R]+=n*F[o+e];
}o+=d.outChannels;
}
}
}
}
}
}return n.makeTensorInfo(w.shape,w.dtype,D);
}const Iv={kernelName:Ne,backendName:"cpu",kernelFunc:kv},Sv={kernelName:$e,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s,dy:i}=t,{strides:a,pad:o,dataFormat:u,dimRoundingMode:l,filterShape:c}=r;_y([s,i],"conv2dBackpropFilter");const h=Ua(u),d=Aa(s.shape,c,a,1,o,l,!1,h),{strideHeight:p,strideWidth:f,filterHeight:m,filterWidth:g}=d,b="channelsLast"===d.dataFormat,x=new Yr(d.filterShape,"float32"),y=d.padInfo.left,w=d.padInfo.top,v=n.data.get(s.dataId).values,k=n.data.get(i.dataId).values,I=new Yr(s.shape,s.dtype,v),S=new Yr(i.shape,i.dtype,k);for(let e=0;e<m;++e){
const t=Math.max(0,Math.ceil((w-e)/p)),n=Math.min(d.outHeight,(d.inHeight+w-e)/p);for(let r=0;r<g;++r){
const s=Math.max(0,Math.ceil((y-r)/f)),i=Math.min(d.outWidth,(d.inWidth+y-r)/f);for(let a=0;a<d.inChannels;++a){
for(let o=0;o<d.outChannels;++o){
let u=0;for(let l=0;l<d.batchSize;++l){
for(let c=t;c<n;++c){
const t=e+c*p-w;for(let e=s;e<i;++e){
const n=r+e*f-y;u+=b?I.get(l,t,n,a)*S.get(l,c,e,o):I.get(l,a,t,n)*S.get(l,o,c,e);
}
}
}x.set(u,e,r,a,o);
}
}
}
}return n.makeTensorInfo(x.shape,x.dtype,x.values);
}},Cv={kernelName:Te,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{dy:s,filter:i}=t,{inputShape:a,strides:o,pad:u,dataFormat:l,dimRoundingMode:c}=r;_y([s,i],"conv2dBackpropInput");const h=_(i.shape),d=_(s.shape);let p=Ua(l);const f=Aa(a,i.shape,o,1,u,c,!1,p),m=new Yr(f.inShape,"float32"),g=m.values,b=n.data.get(s.dataId).values,x=n.data.get(i.dataId).values,[y,w,v]=h,{batchSize:k,filterHeight:I,filterWidth:S,inChannels:C,inHeight:N,inWidth:$,outChannels:T,outHeight:E,outWidth:R,strideHeight:A,strideWidth:F}=f;p=f.dataFormat;const D=I-1-f.padInfo.top,O=S-1-f.padInfo.left,M="channelsLast"===p,L=m.strides[0],z=M?m.strides[1]:m.strides[2],P=M?m.strides[2]:1,B=M?1:m.strides[1],U=d[0],W=M?d[1]:d[2],V=M?d[2]:1,G=M?1:d[1];for(let e=0;e<k;++e){
for(let t=0;t<C;++t){
for(let n=0;n<N;++n){
const r=n-D,s=Math.max(0,Math.ceil(r/A)),i=Math.min(E,(I+r)/A);for(let a=0;a<$;++a){
const o=a-O,u=Math.max(0,Math.ceil(o/F)),l=Math.min(R,(S+o)/F);let c=0;for(let n=s;n<i;++n){
const s=n*A-r;for(let r=u;r<l;++r){
const i=U*e+W*n+V*r,a=y*(I-1-s)+w*(S-1-(r*F-o))+v*t;for(let e=0;e<T;++e){
c+=b[i+G*e]*x[a+e];
}
}
}g[L*e+z*n+P*a+B*t]=c;
}
}
}
}return n.makeTensorInfo(m.shape,m.dtype,m.values);
}},Nv={kernelName:Ee,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s,filter:i}=t,{strides:a,pad:o,dilations:u}=r;_y([s,i],"conv3d");const l=Fa(s.shape,i.shape,a,u,o),{filterDepth:c,filterHeight:h,filterWidth:d,dilationDepth:p,dilationHeight:f,dilationWidth:m,padInfo:g}=l,b=g.front,x=g.left,y=g.top,w=new Yr(l.outShape,s.dtype),v=n.data.get(s.dataId).values,k=n.data.get(i.dataId).values,I=w.values,S=_(s.shape),C=_(i.shape);for(let e=0;e<l.batchSize;++e){
const t=e*S[0],n=e*w.strides[0];for(let e=0;e<l.outDepth;++e){
const r=n+e*w.strides[1],s=e*l.strideDepth-b;for(let e=0;e<c;++e){
const n=s+e*p;if(n<0||n>=l.inDepth){
continue;
}const i=e*C[0],a=t+n*S[1];for(let e=0;e<l.outHeight;++e){
const t=r+e*w.strides[2],n=e*l.strideHeight-y;for(let e=0;e<h;++e){
const r=n+e*f;if(r<0||r>=l.inHeight){
continue;
}const s=i+e*C[1],o=a+r*S[2];for(let e=0;e<l.outWidth;++e){
const n=t+e*l.outChannels,r=e*l.strideWidth-x;for(let e=0;e<d;++e){
const t=r+e*m;if(t<0||t>=l.inWidth){
continue;
}const i=s+e*C[2],a=o+t*l.inChannels;let u=i;for(let e=0;e<l.inChannels;++e){
const t=v[a+e];for(let e=0;e<l.outChannels;++e){
I[n+e]+=t*k[u+e];
}u+=l.outChannels;
}
}
}
}
}
}
}
}return n.makeTensorInfo(w.shape,w.dtype,w.values);
}},$v={kernelName:Re,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s,dy:i}=t,{strides:a,pad:o,filterShape:u}=r;_y([s,i],"conv3dBackpropFilterV2");const l=_(s.shape),c=_(i.shape),h=Fa(s.shape,u,a,1,o),d=h.strideDepth,p=h.strideHeight,f=h.strideWidth,m=h.filterDepth,g=h.filterHeight,b=h.filterWidth,x=new Yr(h.filterShape,"float32"),y=x.values,[w,v,k,I]=x.strides,S=n.data.get(i.dataId).values,[C,N,$,T]=c,E=n.data.get(s.dataId).values,[R,A,F,D]=l,O=h.padInfo.front,M=h.padInfo.left,L=h.padInfo.top;for(let e=0;e<m;++e){
const t=Math.max(0,Math.ceil((O-e)/d)),n=Math.min(h.outDepth,(h.inDepth+O-e)/d),r=e*w;for(let s=0;s<g;++s){
const i=Math.max(0,Math.ceil((L-s)/p)),a=Math.min(h.outHeight,(h.inHeight+L-s)/p),o=s*v+r;for(let r=0;r<b;++r){
const u=Math.max(0,Math.ceil((M-r)/f)),l=Math.min(h.outWidth,(h.inWidth+M-r)/f),c=r*k+o;for(let o=0;o<h.inChannels;++o){
const m=o*I+c;for(let c=0;c<h.outChannels;++c){
let g=0;for(let m=0;m<h.batchSize;++m){
const h=m*R,b=m*C;for(let m=t;m<n;++m){
const t=(e+m*d-O)*A+h,n=m*N+b;for(let e=i;e<a;++e){
const i=(s+e*p-L)*F+t,a=e*$+n;for(let e=u;e<l;++e){
const t=e*T+a;g+=E[(r+e*f-M)*D+i+o]*S[t+c];
}
}
}
}y[m+c]=g;
}
}
}
}
}return n.makeTensorInfo(x.shape,x.dtype,x.values);
}},Tv={kernelName:Ae,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{dy:s,filter:i}=t,{pad:a,strides:o,inputShape:u}=r;_y([s],"conv3dBackpropInputV2");const l=_(s.shape),c=_(i.shape),h=Fa(u,i.shape,o,1,a),d=new Yr(h.inShape,"float32"),p=d.values,[f,m,g,b]=d.strides,x=n.data.get(s.dataId).values,[y,w,v,k]=l,I=n.data.get(i.dataId).values,[S,C,N,$]=c,{batchSize:T,filterDepth:E,filterHeight:R,filterWidth:A,inChannels:F,inDepth:D,inHeight:O,inWidth:M,outChannels:L,outDepth:z,outHeight:P,outWidth:B,strideDepth:U,strideHeight:W,strideWidth:V}=h,G=E-1-h.padInfo.front,j=R-1-h.padInfo.top,H=A-1-h.padInfo.left;for(let e=0;e<T;++e){
for(let t=0;t<F;++t){
for(let n=0;n<D;++n){
const r=n-G,s=Math.max(0,Math.ceil(r/U)),i=Math.min(z,(E+r)/U);for(let a=0;a<O;++a){
const o=a-j,u=Math.max(0,Math.ceil(o/W)),l=Math.min(P,(R+o)/W);for(let c=0;c<M;++c){
const h=c-H,d=Math.max(0,Math.ceil(h/V)),T=Math.min(B,(A+h)/V);let F=0;for(let n=s;n<i;++n){
const s=n*U-r;for(let r=u;r<l;++r){
const i=r*W-o;for(let a=d;a<T;++a){
const o=y*e+w*n+v*r+k*a,u=S*(E-1-s)+C*(R-1-i)+N*(A-1-(a*V-h))+$*t;for(let e=0;e<L;++e){
F+=x[o+e]*I[u+e];
}
}
}
}p[f*e+m*n+g*a+b*c+t]=F;
}
}
}
}
}return n.makeTensorInfo(d.shape,d.dtype,d.values);
}},Ev=Ly(Fe,(e=>Math.cos(e))),Rv={kernelName:Fe,backendName:"cpu",kernelFunc:Ev},Av=Ly(_e,(e=>Math.cosh(e))),Fv={kernelName:_e,backendName:"cpu",kernelFunc:Av},_v={kernelName:Me,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{image:s,boxes:i,boxInd:a}=t,{cropSize:o,method:u,extrapolationValue:l}=r,[c,h,d,p]=s.shape,f=i.shape[0],[m,g]=o,b=pi([f,m,g,p],"float32"),x=n.data.get(i.dataId).values,y=n.data.get(a.dataId).values,w=n.data.get(s.dataId).values,v=_(s.shape),k=_(b.shape);for(let e=0;e<f;e++){
const t=4*e,n=x[t],r=x[t+1],s=x[t+2],i=x[t+3],a=y[e];if(a>=c){
continue;
}const o=m>1?(s-n)*(h-1)/(m-1):0,f=g>1?(i-r)*(d-1)/(g-1):0;for(let t=0;t<m;t++){
const c=m>1?n*(h-1)+t*o:.5*(n+s)*(h-1);if(c<0||c>h-1){
for(let n=0;n<g;n++){
for(let r=0;r<p;r++){
const s=r+n*k[2]+t*k[1]+e*k[0];b.values[s]=l;
}
}
}else if("bilinear"===u){
const n=Math.floor(c),s=Math.ceil(c),o=c-n;for(let u=0;u<g;u++){
const c=g>1?r*(d-1)+u*f:.5*(r+i)*(d-1);if(c<0||c>d-1){
for(let n=0;n<p;n++){
const r=n+u*k[2]+t*k[1]+e*k[0];b.values[r]=l;
}continue;
}const h=Math.floor(c),m=Math.ceil(c),x=c-h;for(let r=0;r<p;r++){
let i=r+h*v[2]+n*v[1]+a*v[0];const l=w[i];i=r+m*v[2]+n*v[1]+a*v[0];const c=w[i];i=r+h*v[2]+s*v[1]+a*v[0];const d=w[i];i=r+m*v[2]+s*v[1]+a*v[0];const p=l+(c-l)*x,f=d+(w[i]-d)*x;i=r+u*k[2]+t*k[1]+e*k[0],b.values[i]=p+(f-p)*o;
}
}
}else {
for(let n=0;n<g;++n){
const s=g>1?r*(d-1)+n*f:.5*(r+i)*(d-1);if(s<0||s>d-1){
for(let r=0;r<p;r++){
const s=r+n*k[2]+t*k[1]+e*k[0];b.values[s]=l;
}continue;
}const o=Math.round(s),u=Math.round(c);for(let r=0;r<p;r++){
const s=r+o*v[2]+u*v[1]+a*v[0],i=r+n*k[2]+t*k[1]+e*k[0];b.values[i]=w[s];
}
}
}
}
}return n.makeTensorInfo(b.shape,b.dtype,b.values);
}},Dv={kernelName:De,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{axis:i,exclusive:a,reverse:o}=r;_y(s,"cumprod");const u=Uo([i],s.shape.length);let l=s;null!=u&&(l=Rw({inputs:{x:s},backend:n,attrs:{perm:u}}));const c=Vo(1,s.shape.length)[0];if(c!==l.shape.length-1){
throw new Error(`backend.cumprod in CPU expects an inner-most axis=${l.shape.length-1} but got axis=${c}`);
}const h=ls(l.dtype,"int32"),d=M(m(l.shape),h),p=n.data.get(l.dataId).values,f=l.shape[l.shape.length-1],g=o?(e,t)=>e+f-t-1:(e,t)=>e+t;for(let e=0;e<p.length;e+=f){
for(let t=0;t<f;t++){
const n=g(e,t);if(0===t){
d[n]=a?1:p[n];
}else{
const r=g(e,t-1);d[n]=a?p[r]*d[r]:p[n]*d[r];
}
}
}const b=n.makeTensorInfo(l.shape,h,d);if(null!=u){
const e=Rw({inputs:{x:b},backend:n,attrs:{perm:Wo(u)}});return n.disposeIntermediateTensorInfo(b),n.disposeIntermediateTensorInfo(l),e;
}return b;
}},Ov={kernelName:Oe,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{axis:i,exclusive:a,reverse:o}=r;_y(s,"cumsum");const u=Uo([i],s.shape.length);let l=s;null!=u&&(l=Rw({inputs:{x:s},backend:n,attrs:{perm:u}}));const c=Vo(1,s.shape.length)[0];if(c!==l.shape.length-1){
throw new Error(`backend.cumsum in CPU expects an inner-most axis=${l.shape.length-1} but got axis=${c}`);
}const h=ls(l.dtype,"int32"),d=L(m(l.shape),h),p=n.data.get(l.dataId).values,f=l.shape[l.shape.length-1],g=o?(e,t)=>e+f-t-1:(e,t)=>e+t;for(let e=0;e<p.length;e+=f){
for(let t=0;t<f;t++){
const n=g(e,t);if(0===t){
d[n]=a?0:p[n];
}else{
const r=g(e,t-1);d[n]=a?p[r]+d[r]:p[n]+d[r];
}
}
}const b=n.makeTensorInfo(l.shape,h,d);if(null!=u){
const e=Rw({inputs:{x:b},backend:n,attrs:{perm:Wo(u)}});return n.disposeIntermediateTensorInfo(b),n.disposeIntermediateTensorInfo(l),e;
}return b;
}},Mv={kernelName:Le,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s,weights:i}=t,{size:a,binaryOutput:o}=r;if(1===s.shape.length){
const e=iv(n.data.get(s.dataId).values,n.data.get(i.dataId).values,i.dtype,i.shape,a);return n.makeTensorInfo([a],i.dtype,e);
}if(2===s.shape.length){
const e=av(n.bufferSync(s),n.bufferSync(i),a,o);return n.makeTensorInfo(e.shape,i.dtype,e.values);
}throw new Error(`Error in denseBincount: input must be at most rank 2, but got rank${s.shape.length}.`);
}},Lv={kernelName:ze,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{blockSize:i,dataFormat:a}=r;d("NHWC"===a,(()=>`Only NHWC dataFormat supported on CPU for depthToSpace. Got ${a}`));const o=s.shape[0],u=s.shape[1],l=s.shape[2],c=s.shape[3],h=u*i,p=l*i,f=c/(i*i),m=n.data.get(s.dataId).values,g=new Float32Array(o*h*p*f);let b=0;for(let e=0;e<o;++e){
for(let t=0;t<h;++t){
const n=Math.floor(t/i),r=t%i;for(let t=0;t<p;++t){
const s=Math.floor(t/i),a=(r*i+t%i)*f;for(let t=0;t<f;++t){
const r=t+a+c*(s+l*(n+u*e));g[b++]=m[r];
}
}
}
}return n.makeTensorInfo([o,h,p,f],s.dtype,g);
}};function zv(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s,filter:i}=t,{strides:a,pad:o,dilations:u,dimRoundingMode:l}=r;_y([s,i],"depthwiseConv2DNative");const c=_(s.shape),h=_(i.shape);let p=u;null==p&&(p=[1,1]),d(Pa(a,p),(()=>`Error in depthwiseConv2d: Either strides or dilations must be 1. Got strides ${a} and dilations '${p}'`));const f=Aa(s.shape,i.shape,a,p,o,l,!0),{filterHeight:m,filterWidth:g,dilationHeight:b,dilationWidth:x,padInfo:y}=f,w=y.left,v=y.top,k=f.outChannels/f.inChannels,I=new Yr(f.outShape,s.dtype),S=n.data.get(s.dataId).values,C=n.data.get(i.dataId).values,N=I.values;for(let e=0;e<f.batchSize;++e){
const t=e*c[0],n=e*I.strides[0];for(let e=0;e<f.outHeight;++e){
const r=n+e*I.strides[1],s=e*f.strideHeight-v;for(let e=0;e<m;++e){
const n=s+e*b;if(n<0||n>=f.inHeight){
continue;
}const i=e*h[0],a=t+n*c[1];for(let e=0;e<f.outWidth;++e){
const t=r+e*I.strides[2],n=e*f.strideWidth-w;for(let e=0;e<g;++e){
const r=n+e*x;if(r<0||r>=f.inWidth){
continue;
}const s=i+e*h[1],o=a+r*f.inChannels;let u=t,l=s;for(let e=0;e<f.inChannels;++e){
const t=S[o+e];for(let e=0;e<k;++e){
N[u+e]+=t*C[l+e];
}u+=k,l+=k;
}
}
}
}
}
}return n.makeTensorInfo(I.shape,I.dtype,I.values);
}const Pv={kernelName:Pe,backendName:"cpu",kernelFunc:zv},Bv={kernelName:Be,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s,dy:i}=t,{strides:a,dilations:o,pad:u,dimRoundingMode:l,filterShape:c}=r;_y([s,i],"depthwiseConv2dNativeBackpropFilter");const h=Aa(s.shape,c,a,o,u,l,!0),{strideHeight:d,strideWidth:p,filterHeight:f,filterWidth:m}=h,g=new Yr(h.filterShape,"float32"),b=h.padInfo.left,x=h.padInfo.top,y=h.outChannels/h.inChannels,w=n.data.get(s.dataId).values,v=new Yr(s.shape,s.dtype,w),k=n.data.get(i.dataId).values,I=new Yr(i.shape,i.dtype,k);for(let e=0;e<f;++e){
const t=Math.max(0,Math.ceil((x-e)/d)),n=Math.min(h.outHeight,(h.inHeight+x-e)/d);for(let r=0;r<m;++r){
const s=Math.max(0,Math.ceil((b-r)/p)),i=Math.min(h.outWidth,(h.inWidth+b-r)/p);for(let a=0;a<h.outChannels;++a){
const o=Math.trunc(a/y),u=a%y;let l=0;for(let u=0;u<h.batchSize;++u){
for(let c=t;c<n;++c){
const t=e+c*d-x;for(let e=s;e<i;++e){
const n=r+e*p-b;l+=v.get(u,t,n,o)*I.get(u,c,e,a);
}
}
}g.set(l,e,r,o,u);
}
}
}return n.makeTensorInfo(g.shape,g.dtype,g.values);
}},Uv={kernelName:Ue,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{dy:s,filter:i}=t,{strides:a,dilations:o,pad:u,dimRoundingMode:l,inputShape:c}=r;_y([s,i],"depthwiseConv2DNativeBackpropInput");const h=_(s.shape),d=_(i.shape),p=Aa(c,i.shape,a,o,u,l,!0),f=new Yr(p.inShape,"float32"),m=f.values,[g,b,x]=f.strides,y=n.data.get(s.dataId).values,[w,v,k]=h,I=n.data.get(i.dataId).values,[S,C,N]=d,{batchSize:$,filterHeight:T,filterWidth:E,inChannels:R,inHeight:A,inWidth:F,outChannels:D,outHeight:O,outWidth:M,strideHeight:L,strideWidth:z}=p,P=T-1-p.padInfo.top,B=E-1-p.padInfo.left,U=D/R;for(let e=0;e<$;++e){
for(let t=0;t<R;++t){
for(let n=0;n<A;++n){
const r=n-P,s=Math.max(0,Math.ceil(r/L)),i=Math.min(O,(T+r)/L);for(let a=0;a<F;++a){
const o=a-B,u=Math.max(0,Math.ceil(o/z)),l=Math.min(M,(E+o)/z);let c=0;for(let n=s;n<i;++n){
const s=n*L-r;for(let r=u;r<l;++r){
const i=w*e+v*n+k*r,a=S*(T-1-s)+C*(E-1-(r*z-o))+N*t;for(let e=0;e<U;++e){
c+=y[i+(t*U+e)]*I[a+e];
}
}
}m[g*e+b*n+x*a+t]=c;
}
}
}
}return n.makeTensorInfo(f.shape,f.dtype,f.values);
}},Wv={kernelName:We,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n}=e,{x:r}=t,s=m(r.shape),i=n.data.get(r.dataId).values,a=pi([s,s],r.dtype),o=a.values;for(let e=0;e<i.length;e++){
o[e*s+e]=i[e];
}const u=[...r.shape,...r.shape];return n.makeTensorInfo(u,a.dtype,a.values);
}},Vv={kernelName:Ve,backendName:"cpu",kernelFunc:({inputs:e,backend:t,attrs:n})=>{
const{x:r,filter:s}=e,{strides:i,pad:a,dilations:o}=n,u=t,l=u.data.get(r.dataId).values,c=r.shape.length,h=u.data.get(s.dataId).values,d=s.shape.length,{batchSize:p,inHeight:f,inWidth:g,inChannels:b,outHeight:x,outWidth:y,padInfo:w,strideHeight:v,strideWidth:k,filterHeight:I,filterWidth:S,dilationHeight:N,dilationWidth:$,outShape:T}=Ta(r.shape,s.shape,i,a,"NHWC",o),E=m(T),R=T.length,A=C(r.dtype,E);for(let e=0;e<p;++e){
for(let t=0;t<x;++t){
const n=t*v-w.top;for(let i=0;i<y;++i){
const a=i*k-w.left;for(let o=0;o<b;++o){
let u=Number.MIN_SAFE_INTEGER;for(let t=0;t<I;++t){
const i=n+t*N;if(i>=0&&i<f){
for(let n=0;n<S;++n){
const p=a+n*$;if(p>=0&&p<g){
const a=B([e,i,p,o],c,_(r.shape)),f=B([t,n,o],d,_(s.shape)),m=l[a]+h[f];m>u&&(u=m);
}
}
}
}A[B([e,t,i,o],R,_(T))]=u;
}
}
}
}return{dataId:u.write(_r(A,r.dtype),T,r.dtype),shape:T,dtype:r.dtype};
}},Gv={kernelName:je,backendName:"cpu",kernelFunc:({inputs:e,backend:t,attrs:n})=>{
const{x:r,filter:s,dy:i}=e,{strides:a,pad:o,dilations:u}=n,l=t,c=O(r.shape,l.data.get(r.dataId).values),h=O(s.shape,l.data.get(s.dataId).values),{batchSize:p,inHeight:f,inWidth:m,inChannels:g,outHeight:b,outWidth:x,padInfo:y,strideHeight:w,strideWidth:v,filterHeight:k,filterWidth:I,dilationHeight:S,dilationWidth:C,outShape:N}=Ta(r.shape,s.shape,a,o,"NHWC",u);d(i.rank===N.length,(()=>`Error in ${je}, dy must have the same rank as output ${N.length}, but got ${i.rank}`));const $=O(N,l.data.get(i.dataId).values),T=z(s.shape,s.dtype);for(let e=0;e<p;++e){
for(let t=0;t<b;++t){
const n=t*w-y.top;for(let r=0;r<x;++r){
const s=r*v-y.left;for(let i=0;i<g;++i){
let a=Number.MIN_SAFE_INTEGER,o=0,u=0;for(let t=0;t<k;++t){
const r=n+t*S;if(r>=0&&r<f){
for(let n=0;n<I;++n){
const l=s+n*C;if(l>=0&&l<m){
const s=c[e][r][l][i]+h[t][n][i];s>a&&(a=s,o=t,u=n);
}
}
}
}T[o][u][i]+=$[e][t][r][i];
}
}
}
}return{dataId:l.write(_r(T,r.dtype),s.shape,s.dtype),shape:s.shape,dtype:s.dtype};
}},jv={kernelName:Ge,backendName:"cpu",kernelFunc:({inputs:e,backend:t,attrs:n})=>{
const{x:r,filter:s,dy:i}=e,{strides:a,pad:o,dilations:u}=n,l=t,c=O(r.shape,l.data.get(r.dataId).values),h=O(s.shape,l.data.get(s.dataId).values),{batchSize:p,inHeight:f,inWidth:m,inChannels:g,outHeight:b,outWidth:x,padInfo:y,strideHeight:w,strideWidth:v,filterHeight:k,filterWidth:I,dilationHeight:S,dilationWidth:C,outShape:N}=Ta(r.shape,s.shape,a,o,"NHWC",u);d(i.rank===N.length,(()=>`Error in ${Ge}, dy must have the same rank as output ${N.length}, but got ${i.rank}`));const $=O(N,l.data.get(i.dataId).values),T=z(r.shape,r.dtype);for(let e=0;e<p;++e){
for(let t=0;t<b;++t){
const n=t*w-y.top;for(let r=0;r<x;++r){
const s=r*v-y.left;for(let i=0;i<g;++i){
let a=Number.MIN_SAFE_INTEGER,o=n<0?0:n,u=s<0?0:s;for(let t=0;t<k;++t){
const r=n+t*S;if(r>=0&&r<f){
for(let n=0;n<I;++n){
const l=s+n*C;if(l>=0&&l<m){
const s=c[e][r][l][i]+h[t][n][i];s>a&&(a=s,o=r,u=l);
}
}
}
}T[e][o][u][i]+=$[e][t][r][i];
}
}
}
}return{dataId:l.write(_r(T,r.dtype),r.shape,r.dtype),shape:r.shape,dtype:r.dtype};
}},Hv={kernelName:"Draw",backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{image:s}=t,{canvas:i,options:a}=r,{contextOptions:o,imageOptions:u}=a||{},l=(null==u?void 0:u.alpha)||1,c=(null==o?void 0:o.contextType)||"2d";if("2d"!==c){
throw new Error(`Context type ${o.contextType} is not supported by the CPU backend.`);
}const h=i.getContext(c,(null==o?void 0:o.contextAttributes)||{});if(null==h){
throw new Error(`Could not get the context with ${c} type.`);
}const[d,p]=s.shape.slice(0,2),f=2===s.shape.length?1:s.shape[2],m=n.data.get(s.dataId).values,g="float32"===s.dtype?255:1,b=new Uint8ClampedArray(p*d*4);for(let e=0;e<d*p;++e){
const t=[0,0,0,255*l];for(let n=0;n<f;n++){
const r=m[e*f+n];if("float32"===s.dtype){
if(r<0||r>1){
throw new Error(`Tensor values for a float32 Tensor must be in the range [0 - 1] but encountered ${r}.`);
}
}else if("int32"===s.dtype&&(r<0||r>255)){
throw new Error(`Tensor values for a int32 Tensor must be in the range [0 - 255] but encountered ${r}.`);
}1===f?(t[0]=r*g,t[1]=r*g,t[2]=r*g):t[n]=r*g;
}const n=4*e;b[n+0]=Math.round(t[0]),b[n+1]=Math.round(t[1]),b[n+2]=Math.round(t[2]),b[n+3]=Math.round(t[3]);
}i.width=p,i.height=d;const x=new ImageData(b,p,d);return h.putImageData(x,0,0),s;
}},qv=jy(((e,t)=>e*t)),Kv=dw(((e,t,n,r)=>({real:e*n-t*r,imag:e*r+t*n}))),Xv=hw(Ut,qv,Kv),Yv={kernelName:Ut,backendName:"cpu",kernelFunc:Xv};function Zv(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{axis:i,keepDims:a}=r;let o;_y(s,"sum"),o="bool"===s.dtype?lw({inputs:{x:s},backend:n,attrs:{dtype:"int32"}}):Uy({inputs:{x:s},backend:n});const u=o.shape.length,l=k(i,o.shape),c=Uo(l,u);let h=l,d=o;null!=c&&(d=Rw({inputs:{x:o},backend:n,attrs:{perm:c}}),h=Vo(h.length,u)),Bo("sum",h,d.shape.length);const[p,f]=zo(d.shape,h);let g=iw(n,p,ls(d.dtype,"int32"));const b=m(f),x=n.data.get(g.dataId).values,y=n.data.get(d.dataId).values;for(let e=0;e<x.length;++e){
const t=e*b;let n=0;for(let e=0;e<b;++e){
n+=y[t+e];
}x[e]=n;
}if(a){
const e=g;g=bw({inputs:{x:g},backend:n,attrs:{shape:Po(g.shape,l)}}),n.disposeIntermediateTensorInfo(e);
}return n.disposeIntermediateTensorInfo(o),null!=c&&n.disposeIntermediateTensorInfo(d),g;
}const Jv={kernelName:En,backendName:"cpu",kernelFunc:Zv},Qv={kernelName:qe,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{equation:s}=r,i=t,{allDims:a,summedDims:o,idDims:u}=bc(s,i.length);yc(a.length,u,i);const{path:l,steps:c}=wc(o,u),h=c.length;let d=null,p=a.length;const f=[];for(let e=0;e<h;++e){
for(const t of c[e]){
const{permutationIndices:e,expandDims:r}=xc(p,u[t]);let s;vc(e)?s=i[t]:(s=Rw({inputs:{x:i[t]},backend:n,attrs:{perm:e}}),f.push(s));const a=s.shape.slice();for(let e=0;e<r.length;++e){
a.splice(r[e],0,1);
}g(s.shape,a)||(s=bw({inputs:{x:s},backend:n,attrs:{shape:a}}),f.push(s)),null===d?d=s:(d=Xv({inputs:{a:s,b:d},backend:n}),f.push(d));
}e<h-1&&(l[e]>=0&&(d=Zv({inputs:{x:d},backend:n,attrs:{axis:l[e]-(a.length-p),keepDims:!1}}),f.push(d)),p--);
}for(const e of f){
e!==d&&n.disposeIntermediateTensorInfo(e);
}return d;
}},ek={kernelName:Xe,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n}=e,{dy:r,y:s}=t;_y([r,s],"eluGrad");const i=new Float32Array(m(s.shape)),a=n.data.get(s.dataId).values,o=n.data.get(r.dataId).values;for(let e=0;e<a.length;++e){
const t=a[e];i[e]=t>=0?o[e]:o[e]*(t+1);
}return n.makeTensorInfo(s.shape,"float32",i);
}},tk=jy(((e,t)=>e===t?1:0)),nk=hw(Ze,tk,null,"bool"),rk={kernelName:Ze,backendName:"cpu",kernelFunc:nk},sk=Ql,ik=ec,ak=tc,ok=nc,uk=rc,lk=sc,ck=Ly(Ye,(e=>{
const t=Math.sign(e),n=Math.abs(e),r=1/(1+sk*n);return t*(1-((((lk*r+uk)*r+ok)*r+ak)*r+ik)*r*Math.exp(-n*n));
})),hk={kernelName:Ye,backendName:"cpu",kernelFunc:ck},dk=My((e=>Math.exp(e))),pk=zy(Je,dk,"float32"),fk={kernelName:Je,backendName:"cpu",kernelFunc:pk};function mk(e){
const{inputs:t,backend:n,attrs:r}=e,{input:s}=t,{dim:i}=r,a=s.shape.length,o=s.shape.slice();let u=i;return i<0&&(d(-(a+1)<=i,(()=>`Axis must be in the interval [${-(a+1)}, ${a}]`)),u=a+i+1),o.splice(u,0,1),bw({inputs:{x:s},backend:n,attrs:{shape:o}});
}const gk={kernelName:Qe,backendName:"cpu",kernelFunc:mk},bk=My((e=>Math.expm1(e))),xk=zy(et,bk),yk={kernelName:et,backendName:"cpu",kernelFunc:xk},wk=jy(((e,t)=>e/t)),vk=hw(He,wk),kk={kernelName:He,backendName:"cpu",kernelFunc:vk},Ik=jy(((e,t)=>e-t)),Sk=dw(((e,t,n,r)=>({real:e-n,imag:t-r}))),Ck=hw(jn,Ik,Sk),Nk={kernelName:jn,backendName:"cpu",kernelFunc:Ck};function $k(e,t,n){
const r=e.shape,s=r[0],i=r[1],a=n.data.get(e.dataId),o=a.complexTensorInfos.real,u=a.complexTensorInfos.imag,l=[s,i],c=m(l),h=S("float32",c),d=S("float32",c);for(let e=0;e<s;e++){
const r=nv({inputs:{x:o},backend:n,attrs:{begin:[e,0],size:[1,i]}}),s=nv({inputs:{x:u},backend:n,attrs:{begin:[e,0],size:[1,i]}}),a=rw({inputs:{real:r,imag:s},backend:n}),{real:l,imag:c}=Tk(a,t,n),p=ic(l,c);for(let t=0;t<i;t++){
const n=lc(p,t);h[e*i+t]=n.real,d[e*i+t]=n.imag;
}n.disposeIntermediateTensorInfo(r),n.disposeIntermediateTensorInfo(s),n.disposeIntermediateTensorInfo(a);
}const p=n.makeTensorInfo(l,"float32",h),f=n.makeTensorInfo(l,"float32",d),g=rw({inputs:{real:p,imag:f},backend:n});return n.disposeIntermediateTensorInfo(p),n.disposeIntermediateTensorInfo(f),g;
}function Tk(e,t,n){
const r=m(e.shape),s=n.data.get(e.dataId),i=n.data.get(s.complexTensorInfos.real.dataId).values,a=n.data.get(s.complexTensorInfos.imag.dataId).values;if(0==((o=r)&o-1)){
const s=Ek(i,a,r,t,n),o=[e.shape[0],e.shape[1]];if(t){
const e=n.makeTensorInfo(o,"float32",s.real),t=n.makeTensorInfo(o,"float32",s.imag),i=n.makeTensorInfo([],"float32",Fr(r,"float32")),a=Uy({inputs:{x:i},backend:n}),u=kk.kernelFunc({inputs:{a:e,b:i},backend:n}),l=kk.kernelFunc({inputs:{a:t,b:a},backend:n}),c=n.data.get(u.dataId).values,h=n.data.get(l.dataId).values;return n.disposeIntermediateTensorInfo(e),n.disposeIntermediateTensorInfo(t),n.disposeIntermediateTensorInfo(i),n.disposeIntermediateTensorInfo(a),n.disposeIntermediateTensorInfo(u),n.disposeIntermediateTensorInfo(l),{real:c,imag:h};
}return s;
}{const e=function(e,t,n){
const r=new Float32Array(2*t);for(let s=0;s<t;s++){
let i=0,a=0;for(let r=0;r<t;r++){
const o=dc(s*r,t,n),u=lc(e,r);i+=u.real*o.real-u.imag*o.imag,a+=u.real*o.imag+u.imag*o.real;
}n&&(i/=t,a/=t),cc(r,i,a,s);
}return r;
}(ic(i,a),r,t);return ac(e);}var o;
}function Ek(e,t,n,r,s){
if(1===n){
return{real:e,imag:t};
}const i=ic(e,t),a=n/2,o=oc(i),u=o.real,l=o.imag,c=[u.length],h=s.makeTensorInfo(c,"float32",u),d=s.makeTensorInfo(c,"float32",l),p=rw({inputs:{real:h,imag:d},backend:s}),f=uc(i),m=f.real,g=f.imag,b=[m.length],x=s.makeTensorInfo(b,"float32",m),y=s.makeTensorInfo(b,"float32",g),w=rw({inputs:{real:x,imag:y},backend:s}),v=Ek(u,l,a,r,s),k=v.real,I=v.imag,S=[k.length],C=s.makeTensorInfo(S,"float32",k),N=s.makeTensorInfo(S,"float32",I),$=rw({inputs:{real:C,imag:N},backend:s}),T=Ek(m,g,a,r,s),E=T.real,R=T.imag,A=[E.length],F=s.makeTensorInfo(A,"float32",E),_=s.makeTensorInfo(A,"float32",R),D=rw({inputs:{real:F,imag:_},backend:s}),O=hc(n,r),M=[O.real.length],L=s.makeTensorInfo(M,"float32",O.real),z=s.makeTensorInfo(M,"float32",O.imag),P=rw({inputs:{real:L,imag:z},backend:s}),B=Xv({inputs:{a:P,b:D},backend:s}),U=mw({inputs:{a:$,b:B},backend:s}),W=Ck({inputs:{a:$,b:B},backend:s}),V=aw({inputs:{input:U},backend:s}),G=aw({inputs:{input:W},backend:s}),j=xv({inputs:{input:U},backend:s}),H=xv({inputs:{input:W},backend:s}),q=wv({inputs:[V,G],backend:s,attrs:{axis:0}}),K=wv({inputs:[j,H],backend:s,attrs:{axis:0}}),X=s.data.get(q.dataId).values,Y=s.data.get(K.dataId).values;return s.disposeIntermediateTensorInfo(h),s.disposeIntermediateTensorInfo(d),s.disposeIntermediateTensorInfo(p),s.disposeIntermediateTensorInfo(x),s.disposeIntermediateTensorInfo(y),s.disposeIntermediateTensorInfo(w),s.disposeIntermediateTensorInfo(C),s.disposeIntermediateTensorInfo(N),s.disposeIntermediateTensorInfo($),s.disposeIntermediateTensorInfo(F),s.disposeIntermediateTensorInfo(_),s.disposeIntermediateTensorInfo(D),s.disposeIntermediateTensorInfo(L),s.disposeIntermediateTensorInfo(z),s.disposeIntermediateTensorInfo(P),s.disposeIntermediateTensorInfo(B),s.disposeIntermediateTensorInfo(U),s.disposeIntermediateTensorInfo(W),s.disposeIntermediateTensorInfo(V),s.disposeIntermediateTensorInfo(j),s.disposeIntermediateTensorInfo(G),s.disposeIntermediateTensorInfo(H),s.disposeIntermediateTensorInfo(q),s.disposeIntermediateTensorInfo(K),{real:X,imag:Y};
}const Rk={kernelName:tt,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n}=e,{input:r}=t,s=m(r.shape),i=r.shape[r.shape.length-1],a=bw({inputs:{x:r},backend:n,attrs:{shape:[s/i,i]}}),o=$k(a,!1,n),u=bw({inputs:{x:o},backend:n,attrs:{shape:r.shape}});return n.disposeIntermediateTensorInfo(a),n.disposeIntermediateTensorInfo(o),u;
}};function Ak(e){
const{backend:t,attrs:n}=e,{shape:r,value:s,dtype:i}=n,a=i||R(s),o=C(a,m(r));return function(e,t,n){
e.fill(t);
}(o,s),t.makeTensorInfo(r,a,o);
}const Fk={kernelName:nt,backendName:"cpu",kernelFunc:Ak},_k={kernelName:rt,backendName:"cpu",kernelFunc:({inputs:e,attrs:t,backend:n})=>{
const{image:r}=e,s=n,i=S(r.dtype,m(r.shape)),[a,o,u,l]=r.shape,c=s.data.get(r.dataId).values;for(let e=0;e<a;e++){
const t=e*u*o*l;for(let e=0;e<o;e++){
const n=e*(u*l);for(let e=0;e<u;e++){
const r=e*l;for(let s=0;s<l;s++){
const a=Math.round(u-e-1),o=t+n+r+s;let h=c[o];a>=0&&a<u&&(h=c[t+n+a*l+s]),i[o]=h;
}
}
}
}return{dataId:s.write(i,r.shape,r.dtype),shape:r.shape,dtype:r.dtype};
}},Dk=My((e=>Math.floor(e))),Ok=zy(st,Dk),Mk={kernelName:st,backendName:"cpu",kernelFunc:Ok},Lk=jy(((e,t)=>Math.floor(e/t))),zk=hw(it,Lk,null,"int32"),Pk={kernelName:it,backendName:"cpu",kernelFunc:zk},Bk={kernelName:ir,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s,filter:i,bias:a,preluActivationWeights:o}=t,{strides:u,pad:l,dataFormat:c,dilations:h,dimRoundingMode:d,activation:p,leakyreluAlpha:f}=r;let m=kv({inputs:{x:s,filter:i},backend:n,attrs:{strides:u,pad:l,dataFormat:c,dilations:h,dimRoundingMode:d}});if(a){
const e=m;if("NCHW"===c&&1===a.shape.length&&1!==a.shape[0]){
const e=bw({inputs:{x:a},backend:n,attrs:{shape:[a.shape[0],1,1]}});m=mw({inputs:{a:m,b:e},backend:n}),n.disposeIntermediateTensorInfo(e);
}else {
m=mw({inputs:{a:m,b:a},backend:n});
}n.disposeIntermediateTensorInfo(e);
}if(p){
const e=m;if("NCHW"===c&&"prelu"===p&&1===o.shape.length&&1!==o.shape[0]){
const e=bw({inputs:{x:o},backend:n,attrs:{shape:[o.shape[0],1,1]}});m=nw(n,m,p,e,f),n.disposeIntermediateTensorInfo(e);
}else {
m=nw(n,m,p,o,f);
}n.disposeIntermediateTensorInfo(e);
}return m;
}},Uk={kernelName:ar,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s,filter:i,bias:a,preluActivationWeights:o}=t,{strides:u,pad:l,dataFormat:c,dilations:h,dimRoundingMode:d,activation:p,leakyreluAlpha:f}=r;let m=zv({inputs:{x:s,filter:i},backend:n,attrs:{strides:u,pad:l,dataFormat:c,dilations:h,dimRoundingMode:d}});if(a){
const e=m;m=mw({inputs:{a:m,b:a},backend:n}),n.disposeIntermediateTensorInfo(e);
}if(p){
const e=m;m=nw(n,m,p,o,f),n.disposeIntermediateTensorInfo(e);
}return m;
}};function Wk(e,t,n,r,s,i,a,o,u){
const l=pi([r,i],n);for(let n=0;n<r;n++){
const r=[];let c=0;for(let t=0;t<s;t++){
const i=e[n*s+t];c+=i*a[t],r.push(i);
}if(c<0||c>=u/i){
throw new Error(`Invalid indices: ${r} does not index into ${o}`);
}for(let e=0;e<i;e++){
l.values[n*i+e]=t.get(...t.indexToLoc(c*i+e));
}
}return l;
}const Vk={kernelName:ut,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n}=e,{params:r,indices:s}=t,i=m(r.shape),a=s.shape,o=a[a.length-1],[u,l,c,h]=ql(r,s);if(0===l){
return n.makeTensorInfo(u,r.dtype,[]);
}const d=Wk(n.data.get(s.dataId).values,n.bufferSync(r),r.dtype,l,o,c,h,r.shape,i);return n.makeTensorInfo(u,r.dtype,d.values);
}};function Gk(e,t,n){
const r=pi(n,e.dtype);for(let n=0;n<r.size;++n){
const s=r.indexToLoc(n).slice(),i=s[0],a=s[2],o=t.locToIndex([i,a]);s[2]=t.values[o];const u=e.locToIndex(s);0<=u&&u<e.values.length&&(r.values[n]=e.values[u]);
}return r;
}const jk={kernelName:ot,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s,indices:i}=t,{axis:a,batchDims:o}=r;_y([s,i],"gatherV2");const u=k(a,s.shape)[0],l=n.data.get(i.dataId).values,c=s.shape[u];for(let e=0;e<l.length;++e){
const t=l[e];d(t<=c-1&&t>=0,(()=>`GatherV2: the index value ${t} is not in [0, ${c-1}]`));
}let h=o;null==o&&(h=0);const p=m(i.shape),f=zc(s,i,u,h),g=bw({inputs:{x:s},backend:n,attrs:{shape:[f.batchSize,f.outerSize,f.dimSize,f.sliceSize]}}),b=bw({inputs:{x:i},backend:n,attrs:{shape:[f.batchSize,p/f.batchSize]}}),x=[f.batchSize,f.outerSize,p/f.batchSize,f.sliceSize],y=n.bufferSync(b),w=Gk(n.bufferSync(g),y,x);return n.disposeIntermediateTensorInfo(g),n.disposeIntermediateTensorInfo(b),n.makeTensorInfo(f.outputShape,w.dtype,w.values);
}},Hk=jy(((e,t)=>e>t?1:0)),qk=hw(lt,Hk,null,"bool"),Kk={kernelName:lt,backendName:"cpu",kernelFunc:qk},Xk=jy(((e,t)=>e>=t?1:0)),Yk=hw(ct,Xk,null,"bool"),Zk={kernelName:ct,backendName:"cpu",kernelFunc:Yk},Jk={kernelName:dt,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n}=e,{input:r}=t,s=m(r.shape),i=r.shape[r.shape.length-1],a=bw({inputs:{x:r},backend:n,attrs:{shape:[s/i,i]}}),o=$k(a,!0,n),u=bw({inputs:{x:o},backend:n,attrs:{shape:r.shape}});return n.disposeIntermediateTensorInfo(a),n.disposeIntermediateTensorInfo(o),u;
}},Qk=Ly(ft,(e=>Number.isFinite(e)?1:0),"bool"),eI={kernelName:ft,backendName:"cpu",kernelFunc:Qk},tI=Ly(mt,(e=>Math.abs(e)===1/0?1:0),"bool"),nI={kernelName:mt,backendName:"cpu",kernelFunc:tI},rI=Ly(gt,(e=>Number.isNaN(e)?1:0),"bool"),sI={kernelName:gt,backendName:"cpu",kernelFunc:rI},iI=jy(((e,t)=>e<t?1:0)),aI=hw(xt,iI,null,"bool"),oI={kernelName:xt,backendName:"cpu",kernelFunc:aI},uI=jy(((e,t)=>e<=t?1:0)),lI=hw(yt,uI,null,"bool"),cI={kernelName:yt,backendName:"cpu",kernelFunc:lI};function hI(e,t,n){
const r=(t-e)/(n-1),s=L(n,"float32");s[0]=e;for(let e=1;e<s.length;e++){
s[e]=s[e-1]+r;
}return s;
}const dI={kernelName:wt,backendName:"cpu",kernelFunc:function(e){
const{backend:t,attrs:n}=e,{start:r,stop:s,num:i}=n,a=hI(r,s,i);return t.makeTensorInfo([a.length],"float32",a);
}},pI=My((e=>Math.log(e))),fI=zy(vt,pI),mI={kernelName:vt,backendName:"cpu",kernelFunc:fI},gI=Ly(kt,(e=>Math.log1p(e))),bI={kernelName:kt,backendName:"cpu",kernelFunc:gI},xI=jy(((e,t)=>e&&t)),yI=hw(It,xI,null,"bool"),wI={kernelName:It,backendName:"cpu",kernelFunc:yI},vI=Ly(St,(e=>e?0:1),"bool"),kI={kernelName:St,backendName:"cpu",kernelFunc:vI},II=jy(((e,t)=>e||t)),SI=hw(Ct,II,null,"bool"),CI={kernelName:Ct,backendName:"cpu",kernelFunc:SI},NI={kernelName:Nt,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{depthRadius:i,bias:a,alpha:o,beta:u}=r;_y(s,"LRN");const l=s.shape[3],c=l-1,h=n.data.get(s.dataId).values,d=m(s.shape),p=new Float32Array(d);function f(e){
const t=e%l;let n=e-t+Math.max(0,t-i);const r=e-t+Math.min(t+i,c);let s=0;for(;n<=r;n++){
const e=h[n];s+=e*e;
}return s;
}for(let e=0;e<d;e++){
const t=f(e),n=h[e]*Math.pow(a+o*t,-u);p[e]=n;
}return n.makeTensorInfo(s.shape,s.dtype,p);
}},$I={kernelName:$t,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s,y:i,dy:a}=t,{depthRadius:o,bias:u,alpha:l,beta:c}=r;_y(a,"LRNGrad");const h=m(a.shape),d=a.shape[3],p=n.data.get(a.dataId).values,f=n.data.get(s.dataId).values,g=n.data.get(i.dataId).values,b=new Float32Array(h),x=h;for(let e=0;e<x;e++){
const t=e%d,n=e-t+Math.max(0,t-o),r=e-t+Math.min(d,t+o+1);let s=0;for(let e=n;e<r;e++){
s+=Math.pow(f[e],2);
}s=l*s+u;for(let t=n;t<r;t++){
let n=-2*l*c*f[t]*g[e]/s;e===t&&(n+=Math.pow(s,-c)),n*=p[e],b[t]+=n;
}
}return n.makeTensorInfo(a.shape,s.dtype,b);
}};function TI(e,t,n,r){
const s=S(r,m(n));for(let n=0;n<s.length;++n){
const r=n*t;let i=e[r];for(let n=0;n<t;++n){
const t=e[r+n];(Number.isNaN(t)||t>i)&&(i=t);
}s[n]=i;
}return s;
}function EI(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{reductionIndices:i,keepDims:a}=r,o=n;let u=s.shape;const l=u.length,c=k(i,u);let h=c;const d=Uo(h,l);let p=o.data.get(s.dataId).values;if(null!=d){
const e=new Array(l);for(let t=0;t<e.length;t++){
e[t]=u[d[t]];
}p=Ew(p,u,s.dtype,d,e),h=Vo(h.length,l),u=e;
}_y(s,"max"),Bo("max",h,l);const[f,g]=zo(u,h),b=TI(p,m(g),f,s.dtype),x=o.write(b,f,s.dtype);let y=f;return a&&(y=Po(f,c)),{dataId:x,shape:y,dtype:s.dtype};
}const RI={kernelName:Tt,backendName:"cpu",kernelFunc:EI},AI=jy(((e,t)=>Math.max(e,t))),FI=hw(Et,AI),_I={kernelName:Et,backendName:"cpu",kernelFunc:FI},DI={kernelName:Rt,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t;_y(s,"maxPool");const{filterSize:i,strides:a,pad:o,dimRoundingMode:u}=r;d(Pa(a,1),(()=>`Error in maxPool: Either strides or dilations must be 1. Got strides ${a} and dilations '1'`));const l=Ea(s.shape,i,a,1,o,u);let c;if(1===l.filterWidth&&1===l.filterHeight&&g(l.inShape,l.outShape)){
c=Uy({inputs:{x:s},backend:n});
}else{
const e=n.data.get(s.dataId).values,t=_(s.shape),r=qw(e,s.shape,s.dtype,t,l,"max");c=n.makeTensorInfo(l.outShape,s.dtype,r.values);
}return c;
}},OI={kernelName:Ft,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{filterSize:i,strides:a,pad:o,dimRoundingMode:u,dataFormat:l}=r;_y(s,"maxPool3d");const c=Ra(s.shape,i,a,1,o,u,l),h=Xw(n.data.get(s.dataId).values,s.shape,s.dtype,_(s.shape),c,"max");return n.makeTensorInfo(h.shape,"float32",h.values);
}},MI={kernelName:_t,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{dy:s,input:i}=t,{filterSize:a,strides:o,pad:u,dimRoundingMode:l}=r;_y([s,i],"maxPool3DGrad");const c=Ra(i.shape,a,o,1,u,l),h=function(e,t){
const n=pi(t.outShape,"int32"),r=t.strideDepth,s=t.strideHeight,i=t.strideWidth,a=t.dilationDepth,o=t.dilationHeight,u=t.dilationWidth,l=t.effectiveFilterDepth,c=t.effectiveFilterHeight,h=t.effectiveFilterWidth,d=t.padInfo.front,p=t.padInfo.top,f=t.padInfo.left;for(let m=0;m<t.batchSize;++m){
for(let g=0;g<t.inChannels;++g){
for(let b=0;b<t.outDepth;++b){
const x=b*r-d;let y=x;for(;y<0;){
y+=a;
}const w=Math.min(t.inDepth,l+x);for(let r=0;r<t.outHeight;++r){
const l=r*s-p;let d=l;for(;d<0;){
d+=o;
}const v=Math.min(t.inHeight,c+l);for(let s=0;s<t.outWidth;++s){
const p=s*i-f;let k=p;for(;k<0;){
k+=u;
}const I=Math.min(t.inWidth,h+p);let S=Number.NEGATIVE_INFINITY,C=-1;for(let t=y;t<w;t+=a){
const n=t-x;for(let r=d;r<v;r+=o){
const s=r-l;for(let i=k;i<I;i+=u){
const a=i-p,o=e.get(m,t,r,i,g);o>=S&&(S=o,C=n*c*h+s*c+a);
}
}
}n.set(C,m,b,r,s,g);
}
}
}
}
}return n;
}(n.bufferSync(i),c),d=c.strideDepth,p=c.strideHeight,f=c.strideWidth,m=c.dilationDepth,g=c.dilationHeight,b=c.dilationWidth,x=c.effectiveFilterDepth,y=c.effectiveFilterHeight,w=c.effectiveFilterWidth,v=x-1-c.padInfo.front,k=w-1-c.padInfo.left,I=y-1-c.padInfo.top,S=pi(i.shape,"float32"),C=n.bufferSync(s);for(let e=0;e<c.batchSize;++e){
for(let t=0;t<c.inChannels;++t){
for(let n=0;n<c.inDepth;++n){
for(let r=0;r<c.inHeight;++r){
for(let s=0;s<c.inWidth;++s){
const i=n-v,a=r-I,o=s-k;let u=0;for(let n=0;n<x;n+=m){
const r=(i+n)/d;if(!(r<0||r>=c.outDepth||Math.floor(r)!==r)){
for(let s=0;s<y;s+=g){
const i=(a+s)/p;if(!(i<0||i>=c.outHeight||Math.floor(i)!==i)){
for(let a=0;a<w;a+=b){
const l=(o+a)/f;if(l<0||l>=c.outWidth||Math.floor(l)!==l){
continue;
}const d=x*y*w-1-h.get(e,r,i,l,t)===n*y*w+s*w+a?1:0;0!==d&&(u+=C.get(e,r,i,l,t)*d);
}
}
}
}
}S.set(u,e,n,r,s,t);
}
}
}
}
}return n.makeTensorInfo(S.shape,S.dtype,S.values);
}},LI={kernelName:At,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{dy:s,input:i,output:a}=t,o=i;_y([i,a],"maxPoolGrad");const{filterSize:u,strides:l,pad:c,dimRoundingMode:h}=r,d=Ea(o.shape,u,l,1,c,h),p=n.data.get(o.dataId).values,f=pi(d.outShape,o.dtype,Kw(p,o.shape,o.dtype,d).values),m=d.strideHeight,g=d.strideWidth,b=d.dilationHeight,x=d.dilationWidth,y=d.effectiveFilterHeight,w=d.effectiveFilterWidth,v=w-1-d.padInfo.left,k=y-1-d.padInfo.top,I=pi(o.shape,"float32"),S=n.data.get(s.dataId).values,C=pi(s.shape,"float32",S);for(let e=0;e<d.batchSize;++e){
for(let t=0;t<d.inChannels;++t){
for(let n=0;n<d.inHeight;++n){
for(let r=0;r<d.inWidth;++r){
const s=n-k,i=r-v;let a=0;for(let n=0;n<y;n+=b){
const r=(s+n)/m;if(!(r<0||r>=d.outHeight||Math.floor(r)!==r)){
for(let s=0;s<w;s+=x){
const o=(i+s)/g;if(o<0||o>=d.outWidth||Math.floor(o)!==o){
continue;
}const u=y*w-1-f.get(e,r,o,t)===n*w+s?1:0;0!==u&&(a+=C.get(e,r,o,t)*u);
}
}
}I.set(a,e,n,r,t);
}
}
}
}return n.makeTensorInfo(I.shape,I.dtype,I.values);
}},zI={kernelName:Dt,backendName:"cpu",kernelFunc:({inputs:e,attrs:t,backend:n})=>{
const{x:r}=e,{filterSize:s,strides:i,pad:a,includeBatchInIndex:o}=t,u=n;_y(r,"MaxPoolWithArgmax");const l=u.data.get(r.dataId).values,c=Ea(r.shape,s,i,[1,1],a),[h,d]=function(e,t,n,r,s){
const i=qw(e,0,n,_(t),s,"max"),a=Kw(e,t,n,s,!0,r);return[i.values,a.values];
}(l,r.shape,r.dtype,o,c),p=u.write(h,c.outShape,r.dtype),f=u.write(d,c.outShape,r.dtype);return[{dataId:p,shape:c.outShape,dtype:r.dtype},{dataId:f,shape:c.outShape,dtype:"int32"}];
}},PI={kernelName:Ot,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{axis:i,keepDims:a}=r,o=k(i,s.shape),u=m(zo(s.shape,o)[1]),l=[],c=n.makeTensorInfo([],"float32",new Float32Array([u]));l.push(c);const h=lw({inputs:{x:s},backend:n,attrs:{dtype:"float32"}});l.push(h);const d=vk({inputs:{a:h,b:c},backend:n});l.push(d);const p=Zv({inputs:{x:d},backend:n,attrs:{axis:i,keepDims:a}});return l.forEach((e=>n.disposeIntermediateTensorInfo(e))),p;
}},BI={kernelName:Mt,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{axis:i,keepDims:a}=r;_y(s,"min");const o=k(i,s.shape);let u=o;const l=Uo(u,s.shape.length);let c=s;null!=l&&(c=Rw({inputs:{x:s},backend:n,attrs:{perm:l}}),u=Vo(u.length,s.shape.length)),Bo("min",u,c.shape.length);const[h,d]=zo(c.shape,u),p=m(d),f=L(m(h),c.dtype),g=n.data.get(c.dataId).values;for(let e=0;e<f.length;++e){
const t=e*p;let n=g[t];for(let e=0;e<p;++e){
const r=g[t+e];(Number.isNaN(r)||r<n)&&(n=r);
}f[e]=n;
}null!=l&&n.disposeIntermediateTensorInfo(c);const b=n.makeTensorInfo(h,c.dtype,f);if(a){
const e=bw({inputs:{x:b},backend:n,attrs:{shape:Po(h,o)}});return n.disposeIntermediateTensorInfo(b),e;
}return b;
}},UI=jy(((e,t)=>Math.min(e,t))),WI=hw(Lt,UI),VI={kernelName:Lt,backendName:"cpu",kernelFunc:WI},GI={kernelName:zt,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{paddings:i,mode:a}=r;_y(s,"mirrorPad");const o=i.map(((e,t)=>e[0]+s.shape[t]+e[1])),u=i.map((e=>e[0])),l=i.map(((e,t)=>e[0]+s.shape[t])),c="reflect"===a?0:1,h=n.data.get(s.dataId).values,d=s.shape.length,p=_(s.shape),f=m(o),g=o.length,b=_(o),x=S(s.dtype,f);for(let e=0;e<f;e++){
let t=U(e,g,b);for(let e=0;e<g;e++){
t[e]<u[e]?t[e]=2*u[e]-t[e]-c:t[e]>=l[e]&&(t[e]=2*(l[e]-1)-t[e]+c);
}t=t.map(((e,t)=>e-u[t]));const n=B(t,d,p);x[e]=h[n];
}return{dataId:n.write(x,o,s.dtype),shape:o,dtype:s.dtype};
}},jI=jy(((e,t)=>{
const n=e%t;return e<0&&t<0||e>=0&&t>=0?n:(n+t)%t;
})),HI=hw(Pt,jI),qI={kernelName:Pt,backendName:"cpu",kernelFunc:HI};function KI(e){
const{inputs:t,backend:n,attrs:r}=e,{logits:s}=t,{dim:i}=r,a=s.shape.length;let o=i;if(-1===o&&(o=a-1),o!==a-1){
throw Error(`Softmax along a non-last dimension is not yet supported. Logits was rank ${a} and dim was ${o}`);
}const u=k([o],s.shape),l=EI({inputs:{x:s},backend:n,attrs:{reductionIndices:u,keepDims:!1}}),c=Po(l.shape,u),h=bw({inputs:{x:l},backend:n,attrs:{shape:c}}),d=Ck({inputs:{a:s,b:h},backend:n}),p=pk({inputs:{x:d},backend:n}),f=Zv({inputs:{x:p},backend:n,attrs:{axis:u,keepDims:!1}}),m=bw({inputs:{x:f},backend:n,attrs:{shape:c}}),g=vk({inputs:{a:p,b:m},backend:n});return n.disposeIntermediateTensorInfo(l),n.disposeIntermediateTensorInfo(h),n.disposeIntermediateTensorInfo(d),n.disposeIntermediateTensorInfo(p),n.disposeIntermediateTensorInfo(f),n.disposeIntermediateTensorInfo(m),g;
}const XI={kernelName:Fn,backendName:"cpu",kernelFunc:KI},YI={kernelName:Bt,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{logits:s}=t,{numSamples:i,seed:a,normalized:o}=r;_y(s,"multinomial");const u=o?s:KI({inputs:{logits:s},backend:n,attrs:{dim:-1}}),l=u.shape[0],c=u.shape[1],h=n.data.get(u.dataId).values,d=[l,i],p=L(m(d),"int32");for(let e=0;e<l;++e){
const t=e*c,n=new Float32Array(c-1);n[0]=h[t];for(let e=1;e<n.length;++e){
n[e]=n[e-1]+h[t+e];
}const r=Qo.alea(a.toString()),s=e*i;for(let e=0;e<i;++e){
const t=r();p[s+e]=n.length;for(let r=0;r<n.length;r++){
if(t<n[r]){
p[s+e]=r;break;
}
}
}
}return o||n.disposeIntermediateTensorInfo(u),n.makeTensorInfo(d,"int32",p);
}};function ZI(e,t,n){
const r=Fr(-1,n);return qv([],t,r,e,n);
}const JI={kernelName:Wt,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n}=e,{x:r}=t;_y(r,"neg");const s=n.data.get(r.dataId).values,[i,a]=ZI(s,r.shape,r.dtype);return n.makeTensorInfo(a,r.dtype,i);
}},QI=tl,eS={kernelName:Gt,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{boxes:s,scores:i}=t,{maxOutputSize:a,iouThreshold:o,scoreThreshold:u}=r;_y(s,"NonMaxSuppression");const l=n.data.get(s.dataId).values,c=n.data.get(i.dataId).values,{selectedIndices:h}=QI(l,c,a,o,u);return n.makeTensorInfo([h.length],"int32",new Int32Array(h));
}},tS=nl,nS={kernelName:jt,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{boxes:s,scores:i}=t,{maxOutputSize:a,iouThreshold:o,scoreThreshold:u,padToMaxOutputSize:l}=r;_y(s,"NonMaxSuppressionPadded");const c=n.data.get(s.dataId).values,h=n.data.get(i.dataId).values,{selectedIndices:d,validOutputs:p}=tS(c,h,a,o,u,l);return[n.makeTensorInfo([d.length],"int32",new Int32Array(d)),n.makeTensorInfo([],"int32",new Int32Array([p]))];
}},rS=rl,sS={kernelName:Ht,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{boxes:s,scores:i}=t,{maxOutputSize:a,iouThreshold:o,scoreThreshold:u,softNmsSigma:l}=r;_y(s,"NonMaxSuppressionWithScore");const c=n.data.get(s.dataId).values,h=n.data.get(i.dataId).values,d=a,p=o,f=u,m=l,{selectedIndices:g,selectedScores:b}=rS(c,h,d,p,f,m);return[n.makeTensorInfo([g.length],"int32",new Int32Array(g)),n.makeTensorInfo([b.length],"float32",new Float32Array(b))];
}},iS=jy(((e,t)=>e!==t?1:0)),aS=hw(Vt,iS,null,"bool"),oS={kernelName:Vt,backendName:"cpu",kernelFunc:aS},uS={kernelName:Kt,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{indices:s}=t,{dtype:i,depth:a,onValue:o,offValue:u}=r;_y(s,"oneHot");const l=m(s.shape),c=new Float32Array(l*a);c.fill(u);const h=n.data.get(s.dataId).values;for(let e=0;e<l;++e){
h[e]>=0&&h[e]<a&&(c[e*a+h[e]]=o);
}return n.makeTensorInfo([...s.shape,a],i,c);
}};function lS(e){
const{inputs:t,backend:n}=e,{x:r}=t;if("string"===r.dtype){
throw new Error("zerosLike is not supported for string tensors");
}if("complex64"===r.dtype){
const e=aw({inputs:{input:r},backend:n}),t=lS({inputs:{x:e},backend:n}),s=xv({inputs:{input:r},backend:n}),i=lS({inputs:{x:s},backend:n}),a=rw({inputs:{real:t,imag:i},backend:n});return n.disposeIntermediateTensorInfo(e),n.disposeIntermediateTensorInfo(t),n.disposeIntermediateTensorInfo(s),n.disposeIntermediateTensorInfo(i),a;
}return Ak({backend:n,attrs:{shape:r.shape,value:0,dtype:r.dtype}});
}const cS={kernelName:tr,backendName:"cpu",kernelFunc:lS},hS={kernelName:qt,backendName:"cpu",kernelFunc:function e(t){
const{inputs:n,backend:r}=t,{x:s}=n;if("string"===s.dtype){
throw new Error("onesLike is not supported for string tensors");
}if("complex64"===s.dtype){
const t=aw({inputs:{input:s},backend:r}),n=e({inputs:{x:t},backend:r}),i=xv({inputs:{input:s},backend:r}),a=lS({inputs:{x:i},backend:r}),o=rw({inputs:{real:n,imag:a},backend:r});return r.disposeIntermediateTensorInfo(t),r.disposeIntermediateTensorInfo(n),r.disposeIntermediateTensorInfo(i),r.disposeIntermediateTensorInfo(a),o;
}return Ak({backend:r,attrs:{shape:s.shape,value:1,dtype:s.dtype}});
}};function dS(e){
const{inputs:t,backend:n,attrs:r}=e,{axis:s}=r;if(1===t.length){
return mk({inputs:{input:t[0]},backend:n,attrs:{dim:s}});
}const i=t[0].shape,a=t[0].dtype;t.forEach((e=>{
p(i,e.shape,"All tensors passed to stack must have matching shapes"),d(a===e.dtype,(()=>"All tensors passed to stack must have matching dtypes"));
}));const o=[],u=wv({inputs:t.map((e=>{
const t=mk({inputs:{input:e},backend:n,attrs:{dim:s}});return o.push(t),t;
})),backend:n,attrs:{axis:s}});return o.forEach((e=>n.disposeIntermediateTensorInfo(e))),u;
}const pS={kernelName:Xt,backendName:"cpu",kernelFunc:dS},fS={kernelName:Yt,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{paddings:i,constantValue:a}=r;_y(s,"pad");const o=i.map(((e,t)=>e[0]+s.shape[t]+e[1])),u=i.map((e=>e[0])),l=n.data.get(s.dataId).values,c=m(s.shape),h=s.shape.length,d=_(s.shape),p=m(o),f=o.length,g=_(o),b=S(s.dtype,p);0!==a&&b.fill(a);for(let e=0;e<c;e++){
b[B(U(e,h,d).map(((e,t)=>e+u[t])),f,g)]=l[e];
}return{dataId:n.write(b,o,s.dtype),shape:o,dtype:s.dtype};
}},mS=jy(((e,t)=>Math.pow(e,t))),gS=hw(Zt,mS),bS={kernelName:Zt,backendName:"cpu",kernelFunc:gS};function xS(e,t,n,r){
const[s,i]=zo(e,r),a=ls(t,"int32"),o=L(m(s),a),u=m(i);for(let e=0;e<o.length;++e){
const t=e*u;let r=1;for(let e=0;e<u;++e){
r*=n[t+e];
}o[e]=r;
}return{outVals:o,outShape:s,outDtype:a};
}const yS={kernelName:Qt,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{axis:i,keepDims:a}=r;_y(s,"prod");const o=s.shape.length,u=k(i,s.shape),l=Uo(u,o);let c=u,h=s;const d=[];null!=l&&(h=Rw({inputs:{x:s},backend:n,attrs:{perm:l}}),d.push(h),c=Vo(c.length,o));const p=n.data.get(h.dataId).values,{outVals:f,outShape:m,outDtype:g}=xS(h.shape,h.dtype,p,c);let b=m;return a&&(b=Po(m,u)),d.forEach((e=>n.disposeIntermediateTensorInfo(e))),n.makeTensorInfo(b,g,f);
}};function wS(e,t){
const n=e.slice(0,t);for(;n.length<t;){
n.push(1);
}for(let r=t;r<e.length;r++){
n[t-1]*=e[r];
}return n;
}function vS(e,t,n,r,s,i,a,o){
if(0===e.length){
throw new Error("paramsNestedSplits must be non empty");
}if(0===t[0].length){
throw new Error("Split tensors must not be scalars");
}if(function(e,t,n){
e.forEach(((e,r)=>{
if(e<0||e>=n){
const s=U(r,t.length,_(t)).join(",");throw new Error(`indices[${s}] = ${e} is not in [0, ${n})`);
}
}));
}(i,a,t[0][0]-1),0===r.length){
throw new Error("params.rank must be nonzero");
}const u=r[0],{outSplits:l,valueSlices:c,numValues:h}=function(e,t,n,r){
const s=[];let i=0;const a=t.length-1+n.length,o=new Array(a).fill(null).map((()=>[0]));!function(e,t){
for(let n=0;n<e.length;++n){
const r=e[n],s=n===e.length-1?t:e[n+1].length;if(0===r.length){
throw new Error("Ragged splits may not be empty");
}if(r[0]<0){
throw new Error("Ragged splits must be non-negative");
}if(r[r.length-1]>s){
throw new Error("Ragged splits must not point past values");
}for(let e=1;e<r.length;++e){
if(r[e-1]>r[e]){
throw new Error("Ragged splits must be sorted in ascending order");
}
}
}
}(n,r);let u=1;for(let e=0;e<t.length-1;++e){
u*=t[e];const n=t[e+1];for(let t=1;t<u+1;++t){
o[e].push(t*n);
}
}for(let r=0;r<e.length;++r){
let a=e[r],u=e[r]+1;for(let e=0;e<n.length;++e){
const r=n[e],s=e+t.length-1;if(s>=0){
const e=o[s],t=e[e.length-1]-r[a];for(let e=a;e<u;++e){
o[s].push(r[e+1]+t);
}
}a=r[a],u=r[u];
}u!==a&&(s.push([a,u]),i+=u-a);
}return{outSplits:o,valueSlices:s,numValues:i};
}(i,a,e,u),d=function(e){
const t=[];for(let n=0;n<e.length;++n){
const r=C("int32",e[n].length);t.push(r),e[n].forEach(((e,t)=>r[t]=e));
}return t;
}(l),p=function(e,t,n,r,s){
const i=t.slice();i[0]=s;const a=C(n,m(i)),o=e.length;return function(e,t,n,r,s,i){
const a=wS(t,2)[1],o=wS(i,2)[1];let u=0;for(const t of n){
for(let n=t[0];n<t[1];++n){
for(let t=0;t<r;++t){
s[u*o+t]=e[n*a+t];
}++u;
}
}
}(e,t,r,0===o?0:o/t[0],a,i),[a,i];
}(n,r,s,c,h);return[d,p[0],p[1]];
}const kS={kernelName:en,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{paramsNestedSplits:s,paramsDenseValues:i,indices:a}=t,{outputRaggedRank:o}=r,u=s.map((e=>n.data.get(e.dataId).values)),l=s.map((e=>e.shape)),c=n.data.get(i.dataId).values,h=n.data.get(a.dataId).values,[d,p,f]=vS(u,l,c,i.shape,i.dtype,h,a.shape),m=d.map((e=>n.makeTensorInfo([e.length],"int32",e))),g=n.makeTensorInfo(f,i.dtype,p);return m.concat([g]);
}},IS=2147483647;function SS(e,t,n,r,s,i,a){
if(t.length>1){
throw new Error("starts must be a scalar or vector");
}if(s.length>1){
throw new Error("limits must be a scalar or vector");
}if(a.length>1){
throw new Error("deltas must be a scalar or vector");
}const o=0===t.length,u=0===s.length,l=0===a.length,c=[];o||c.push(t[0]),u||c.push(s[0]),l||c.push(a[0]);for(let e=1;e<c.length;++e){
if(c[e]!==c[e-1]){
throw new Error("starts, limits, and deltas must have the same shape");
}
}const h=0===c.length?1:c[0],d=C("int32",h+1);d[0]=0;for(let t=0;t<h;++t){
const n=o?e[0]:e[t],s=u?r[0]:r[t],a=l?i[0]:i[t];if(0===a){
throw new Error("Requires delta != 0");
}let c;if(a>0&&s<n||a<0&&s>n){
c=0;
}else if(c=Math.ceil(Math.abs((s-n)/a)),c>IS){
throw new Error(`Requires ((limit - start) / delta) <= ${IS}`);
}d[t+1]=d[t]+c;
}const p=C(n,d[h]);let f=0;for(let t=0;t<h;++t){
const n=d[t+1]-d[t];let r=o?e[0]:e[t];const s=l?i[0]:i[t];for(let e=0;e<n;++e){
p[f++]=r,r+=s;
}
}return[d,p];
}const CS={kernelName:tn,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n}=e,{starts:r,limits:s,deltas:i}=t,a=n.data.get(r.dataId).values,o=n.data.get(s.dataId).values,u=n.data.get(i.dataId).values,[l,c]=SS(a,r.shape,r.dtype,o,s.shape,u,i.shape);return[n.makeTensorInfo([l.length],"int32",l),n.makeTensorInfo([c.length],r.dtype,c)];
}};var NS=Dl;class $S{
constructor(e,t,n,r,s,i,a,o,u,l){
this.shape=e,this.shapeShape=t,this.values=n,this.valuesShape=r,this.valuesDType=s,this.defaultValue=i,this.defaultValueShape=a,this.rowPartitionValues=o,this.rowPartitionValuesShapes=u,this.rowPartitionTypes=Ml(l),this.raggedRank=Ll(this.rowPartitionTypes);
}getRowPartitionTypeByDimension(e){
return this.rowPartitionTypes[0]===NS.FIRST_DIM_SIZE?this.rowPartitionTypes[e+1]:this.rowPartitionTypes[e];
}getRowPartitionTensor(e){
return this.rowPartitionTypes[0]===NS.FIRST_DIM_SIZE?this.rowPartitionValues[e+1]:this.rowPartitionValues[e];
}getMaxWidth(e){
const t=this.getRowPartitionTensor(e-1);switch(this.getRowPartitionTypeByDimension(e-1)){
case NS.VALUE_ROWIDS:return $S.getMaxWidthValueRowID(t);case NS.ROW_SPLITS:return $S.getMaxWidthRowSplit(t);default:throw new Error(`Cannot handle partition type ${NS[this.getRowPartitionTypeByDimension(e-1)]}`);
}
}static getMaxWidthRowSplit(e){
const t=e.length;if(0===t||1===t){
return 0;
}let n=0;for(let r=0;r<t-1;++r){
const t=e[r+1]-e[r];t>n&&(n=t);
}return n;
}static getMaxWidthValueRowID(e){
const t=e.length;if(0===t){
return 0;
}let n=0,r=e[0],s=0;for(let i=1;i<t;++i){
const t=e[i];t!==r&&(r=t,s=Math.max(i-n,s),n=i);
}return Math.max(t-n,s);
}tensorShapeFromTensor(e,t,n=!0){
if(0===t.length){
if(-1===e[0]){
return[];
}throw new Error("The only valid scalar shape tensor is the fully unknown shape specified as -1.");
}return ES(e,n);
}calculateOutputSize(e){
const t=this.valuesShape;zl(this.defaultValueShape,t);const n=this.tensorShapeFromTensor(this.shape,this.shapeShape),r=Ol(this.raggedRank,n,t);r[0]<0&&(r[0]=e);for(let e=1;e<=this.raggedRank;++e){
r[e]<0&&(r[e]=this.getMaxWidth(e));
}return r;
}calculateFirstParentOutputIndex(e,t,n){
const r=Math.min(e,n),s=[];let i=0;for(let e=0;e<r;++e,i+=t){
s.push(i);
}for(let t=r;t<e;++t){
s.push(-1);
}return d(s.length===e,(()=>"Final length of result must be equal to firstDimension.")),s;
}calculateOutputIndexRowSplit(e,t,n,r){
const s=e.length,i=[];for(let a=0;a<s-1;++a){
const s=e[a+1]-e[a];let o=Math.min(r,s),u=t[a];-1===u&&(o=0);for(let e=0;e<o;++e){
i.push(u),u+=n;
}for(let e=0;e<s-o;++e){
i.push(-1);
}
}if(s>0&&i.length!==e[s-1]){
throw new Error("Invalid row split size.");
}return i;
}calculateOutputIndexValueRowID(e,t,n,r){
const s=e.length,i=[];if(0===s){
return[];
}let a=0,o=e[0];if(o>=t.length){
throw new Error(`Got currentValueRowId=${o}, which is not less than ${t.length}`);
}let u=t[o];i.push(u);for(let l=1;l<s;++l){
const s=e[l];if(s===o){
u>=0&&(++a,a<r?u+=n:u=-1);
}else{
if(a=0,o=s,s>=t.length){
throw new Error(`Got nextValueRowId=${s} which is not less than ${t.length}`);
}u=t[s];
}i.push(u);
}if(i.length!==e.length){
throw new Error("Invalid row ids.");
}return i;
}calculateOutputIndex(e,t,n,r){
const s=this.getRowPartitionTensor(e),i=this.getRowPartitionTypeByDimension(e);switch(i){
case NS.VALUE_ROWIDS:return this.calculateOutputIndexValueRowID(s,t,n,r);case NS.ROW_SPLITS:if(s.length-1>t.length){
throw new Error(`Row partition size is greater than output size: ${s.length-1} > ${t.length}`);
}return this.calculateOutputIndexRowSplit(s,t,n,r);default:throw new Error(`Unsupported partition type: ${NS[i]}`);
}
}getFirstDimensionSize(){
const e=this.rowPartitionValues[0];if(0===this.rowPartitionTypes.length){
throw new Error("No row_partition_types given.");
}const t=this.rowPartitionTypes[0];switch(t){
case NS.FIRST_DIM_SIZE:return e[0];case NS.VALUE_ROWIDS:throw new Error("Cannot handle VALUE_ROWIDS in first dimension.");case NS.ROW_SPLITS:return this.rowPartitionValuesShapes[0][0]-1;default:throw new Error(`Cannot handle type ${NS[t]}`);
}
}compute(){
if(this.rowPartitionValues[0].length<=0){
throw new Error("Invalid first partition input. Tensor requires at least one element.");
}const e=this.getFirstDimensionSize(),t=this.calculateOutputSize(e),n=new Array(this.raggedRank+1);n[n.length-1]=1;for(let e=n.length-2;e>=0;--e){
n[e]=n[e+1]*t[e+1];
}const r=ES(t,!1),s=C(this.valuesDType,m(r));if(n[0]*t[0]>0){
let i=this.calculateFirstParentOutputIndex(e,n[0],t[0]);for(let e=1;e<=this.raggedRank;++e){
i=this.calculateOutputIndex(e-1,i,n[e],t[e]);
}this.setOutput(this.raggedRank,i,s,r);
}return[r,s];
}setOutput(e,t,n,r){
if(0===n.length){
return;
}const s=this.values,i=n;let a=r.slice();a=a.slice(e+1);const o=m(a),u=t.length;let l=this.defaultValue;if(l.length!==o&&1!==l.length){
const e=this.defaultValueShape;xi((()=>{
const t=Va(l,e),n=Ya(t,a);l=n.dataSync();
}));
}let c=0,h=0,d=0;for(let e=0;e<=u;++e){
let r=e<u?t[e]:-1;if(r!==d){
if(h<d){
const e=s.subarray(c*o);TS(i.subarray(h*o),e,(d-h)*o);
}if(e>=u){
const e=n.length;r=Math.floor(e/o);
}if(r>d){
if(1===this.defaultValue.length){
i.subarray(d*o,r*o).fill(this.defaultValue[0]),d=r;
}else {
for(;r>d;){
TS(i.slice(d*o),l,o),++d;
}
}
}r<0?(c=e+1,h=d):(c=e,h=d,d=h+1);
}else{
++d;
}
}
}
}function TS(e,t,n){
for(let r=0;r<n;r++){
e[r]=t[r];
}
}function ES(e,t){
const n=[];for(let r of e){
if(r<0){
if(!t){
throw new Error(`Dimension ${r} must be >= 0`);
}if(r<-1){
throw new Error(`Dimension ${r} must be >= -1`);
}r=-1;
}n.push(r);
}return n;
}function RS(e,t,n,r,s,i,a,o,u,l){
return new $S(e,t,n,r,s,i,a,o,u,l).compute();
}const AS={kernelName:nn,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{shape:s,values:i,defaultValue:a,rowPartitionTensors:o}=t,{rowPartitionTypes:u}=r,l=n.data.get(s.dataId).values,c=n.data.get(i.dataId).values,h=n.data.get(a.dataId).values,d=o.map((e=>n.data.get(e.dataId).values)),p=o.map((e=>e.shape)),[f,m]=RS(l,s.shape,c,i.shape,i.dtype,h,a.shape,d,p,u);return n.makeTensorInfo(f,i.dtype,m);
}};function FS(e,t,n,r){
if(e===t||e<t&&n<0||t<e&&n>1){
return L(0,r);
}const s=L(Math.abs(Math.ceil((t-e)/n)),r);t<e&&1===n&&(n=-1),s[0]=e;for(let e=1;e<s.length;e++){
s[e]=s[e-1]+n;
}return s;
}const _S={kernelName:rn,backendName:"cpu",kernelFunc:function(e){
const{backend:t,attrs:n}=e,{start:r,stop:s,dtype:i,step:a}=n,o=FS(r,s,a,i);return t.makeTensorInfo([o.length],i,o);
}},DS=Ly(an,(e=>1/e)),OS={kernelName:an,backendName:"cpu",kernelFunc:DS},MS={kernelName:hn,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{images:s}=t,{alignCorners:i,halfPixelCenters:a,size:o}=r;_y(s,"resizeBilinear");const u=_(s.shape),[l,c]=o,[h,d,p,f]=s.shape,g=n.data.get(s.dataId).values,b=new Float32Array(m([h,l,c,f])),x=[i&&l>1?d-1:d,i&&c>1?p-1:p],y=[i&&l>1?l-1:l,i&&c>1?c-1:c];let w=0;const v=x[0]/y[0],k=x[1]/y[1];for(let e=0;e<h;e++){
for(let t=0;t<l;t++){
let n;n=a?v*(t+.5)-.5:v*t;const r=Math.max(0,Math.floor(n)),s=n-r,i=Math.min(d-1,Math.ceil(n)),o=e*u[0]+r*u[1],l=e*u[0]+i*u[1];for(let e=0;e<c;e++){
let t;t=a?k*(e+.5)-.5:k*e;const n=Math.max(0,Math.floor(t)),r=t-n,i=Math.min(p-1,Math.ceil(t)),c=o+n*u[2],h=l+n*u[2],d=o+i*u[2],m=l+i*u[2];for(let e=0;e<f;e++){
const t=g[c+e],n=g[h+e],i=t+(g[d+e]-t)*r,a=i+(n+(g[m+e]-n)*r-i)*s;b[w++]=a;
}
}
}
}return n.makeTensorInfo([h,l,c,f],"float32",b);
}},LS={kernelName:dn,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{images:s,dy:i}=t,{alignCorners:a}=r;_y([i,s],"resizeBilinearGrad");const o=_(s.shape),[u,l,c,h]=s.shape,[,d,p]=i.shape,f=new Float32Array(u*l*c*h),m=[a&&d>1?l-1:l,a&&p>1?c-1:c],g=[a&&d>1?d-1:d,a&&p>1?p-1:p],b=m[0]/g[0],x=m[1]/g[1],y=n.data.get(i.dataId).values;let w=0;for(let e=0;e<u;e++){
const t=e*o[0];for(let e=0;e<d;e++){
const n=e*b,r=Math.floor(n),s=Math.min(Math.ceil(n),l-1),i=t+r*o[1],a=t+s*o[1],u=n-r,d=1-u;for(let e=0;e<p;e++){
const t=e*x,n=Math.floor(t),r=Math.min(Math.ceil(t),c-1),s=t-n,l=1-s,p=i+n*o[2],m=i+r*o[2],g=a+n*o[2],b=a+r*o[2],v=d*l,k=d*s,I=u*l,S=u*s;for(let e=0;e<h;e++){
const t=y[w++];f[p+e]+=t*v,f[m+e]+=t*k,f[g+e]+=t*I,f[b+e]+=t*S;
}
}
}
}return n.makeTensorInfo([u,c,l,h],"float32",f);
}},zS={kernelName:ln,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{images:s}=t,{alignCorners:i,halfPixelCenters:a,size:o}=r;_y(s,"resizeNearestNeighbor");const u=_(s.shape),[l,c]=o,[h,d,p,f]=s.shape,m=n.data.get(s.dataId).values,g=new Float32Array(h*l*c*f),b=[i&&l>1?d-1:d,i&&c>1?p-1:p],x=[i&&l>1?l-1:l,i&&c>1?c-1:c],y=b[0]/x[0],w=b[1]/x[1];let v=0;for(let e=0;e<h;e++){
const t=e*u[0];for(let e=0;e<l;e++){
const n=a?y*(e+.5):y*e;let r=Math.min(d-1,i?Math.round(n):Math.floor(n));a&&(r=Math.max(0,r));const s=t+r*u[1];for(let e=0;e<c;e++){
const t=a?w*(e+.5):w*e;let n=Math.min(p-1,i?Math.round(t):Math.floor(t));a&&(n=Math.max(0,n));const r=s+n*u[2];for(let e=0;e<f;e++){
const t=m[r+e];g[v++]=t;
}
}
}
}return n.makeTensorInfo([h,l,c,f],s.dtype,g);
}},PS={kernelName:cn,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{images:s,dy:i}=t,{alignCorners:a}=r;_y([i,s],"resizeNearestNeighborGrad");const o=_(s.shape),u=_(i.shape),[l,c,h,d]=s.shape,[,p,f]=i.shape,m=new Float32Array(l*c*h*d),g=n.data.get(i.dataId).values,b=[a&&p>1?c-1:c,a&&f>1?h-1:h],x=[a&&p>1?p-1:p,a&&f>1?f-1:f],y=b[0]/x[0],w=b[1]/x[1],v=1/y,k=1/w,I=2*Math.ceil(v)+2,S=2*Math.ceil(k)+2;for(let e=0;e<l;e++){
const t=e*o[0];for(let e=0;e<c;e++){
const n=t+e*o[1],r=Math.floor(e*v),s=Math.floor(r-I/2);for(let r=0;r<h;r++){
const i=n+r*o[2],l=Math.floor(r*k),b=Math.floor(l-S/2);for(let n=0;n<d;n++){
let o=0;for(let i=0;i<I;i++){
const l=i+s;if(l<0||l>=p){
continue;
}const d=t+l*u[1],m=l*y;if(e===Math.min(c-1,a?Math.round(m):Math.floor(m))){
for(let e=0;e<S;e++){
const t=e+b;if(t<0||t>=f){
continue;
}const s=d+t*u[2],i=t*w;r===Math.min(h-1,a?Math.round(i):Math.floor(i))&&(o+=g[s+n]);
}
}
}m[i+n]=o;
}
}
}
}return n.makeTensorInfo(s.shape,s.dtype,m);
}},BS={kernelName:fn,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{dims:i}=r;_y(s,"reverse");const a=s.shape.length,o=k(i,s.shape);if(0===a){
return Uy({inputs:{x:s},backend:n});
}const u=new Yr(s.shape,s.dtype),l=n.bufferSync(s);for(let e=0;e<u.size;e++){
const t=u.indexToLoc(e),n=t.slice();o.forEach((e=>n[e]=s.shape[e]-1-n[e])),u.set(l.get(...n),...t);
}return n.makeTensorInfo(u.shape,u.dtype,u.values);
}},US={kernelName:rr,backendName:"cpu",kernelFunc:({inputs:e,attrs:t,backend:n})=>{
const{image:r}=e,{radians:s,fillValue:i,center:a}=t,o=n,u=S(r.dtype,m(r.shape)),[l,c,h,d]=r.shape,[p,f]=Ul(a,c,h),g=Math.sin(s),b=Math.cos(s),x=o.data.get(r.dataId).values;for(let e=0;e<l;e++){
const t=e*h*c*d;for(let e=0;e<c;e++){
const n=e*(h*d);for(let r=0;r<h;r++){
const s=r*d;for(let a=0;a<d;a++){
const o=[l,e,r,a],m=o[2],y=o[1];let w=(m-p)*b-(y-f)*g,v=(m-p)*g+(y-f)*b;w=Math.round(w+p),v=Math.round(v+f);let k=i;"number"!=typeof i&&(k=3===a?255:i[a]),w>=0&&w<h&&v>=0&&v<c&&(k=x[t+v*(h*d)+w*d+a]),u[t+n+s+a]=k;
}
}
}
}return{dataId:o.write(u,r.shape,r.dtype),shape:r.shape,dtype:r.dtype};
}},WS=Ly(mn,(e=>{
const t=Math.floor(e);return e-t<.5?Math.floor(e):e-t>.5?Math.ceil(e):t%2==0?t:t+1;
})),VS={kernelName:mn,backendName:"cpu",kernelFunc:WS},GS=My((e=>1/Math.sqrt(e))),jS=zy(gn,GS),HS={kernelName:gn,backendName:"cpu",kernelFunc:jS};function qS(e,t,n,r,s,i,a,o,u,l){
const c=[r/s,s],h=e.values,d=t.values;if(0===r){
return pi(n,t.dtype);
}const p=u instanceof Yr?u:pi(c,t.dtype);"string"==typeof u||"number"==typeof u?p.values.fill(u):"boolean"==typeof u&&p.values.fill(+u);for(let e=0;e<i;e++){
const i=[];let u=0;for(let t=0;t<a;t++){
const n=h[e*a+t];i.push(n),u+=n*o[t];
}if(u<0||u>=r/s){
throw new Error(`Invalid indices: ${i} does not index into ${n}`);
}for(let n=0;n<s;n++){
l?p.values[u*s+n]+=d[e*s+n]:p.values[u*s+n]=0===t.rank?d[0]:d[e*s+n];
}
}return p;
}const KS={kernelName:bn,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{indices:s,updates:i}=t,{shape:a}=r,{sliceRank:o,numUpdates:u,sliceSize:l,strides:c,outputSize:h}=Yl(0,s,a),d=qS(n.bufferSync(s),n.bufferSync(i),a,h,l,u,o,c,0,!0);return n.makeTensorInfo(a,d.dtype,d.values);
}};function XS(e,t){
let n=0,r=e.length,s=0;for(;n<r;){
s=Math.floor((n+r)/2),e[s]<t?n=s+1:r=s;
}return r;
}function YS(e,t){
let n=0,r=e.length,s=0;for(;n<r;){
s=Math.floor((n+r)/2),e[s]<=t?n=s+1:r=s;
}return r;
}const ZS={kernelName:yn,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{sortedSequence:s,values:i}=t,{side:a}=r,o=function(e,t,n,r,s,i){
const a=C("int32",n*s);for(let o=0;o<n;++o){
const n=e.slice(o*r,(o+1)*r),u=o*s;for(let e=0;e<s;++e){
a[u+e]="left"===i?XS(n,t[e+u]):YS(n,t[e+u]);
}
}return a;
}(n.data.get(s.dataId).values,n.data.get(i.dataId).values,s.shape[0],s.shape[1],i.shape[1],a);return n.makeTensorInfo(i.shape,"int32",o);
}},JS={kernelName:wn,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n}=e,{condition:r,t:s,e:i}=t;_y([r,s,i],"select");const a=r.shape.length,o=n.data.get(r.dataId).values,u=n.data.get(s.dataId).values,l=n.data.get(i.dataId).values,c=ls(s.dtype,i.dtype),h=L(m(s.shape),c);let d=0;const p=0===a||a>1||1===s.shape.length?1:m(s.shape.slice(1));for(let e=0;e<o.length;e++){
for(let t=0;t<p;t++){
1===o[e]?h[d++]=u[e]:h[d++]=l[e];
}
}return n.makeTensorInfo(s.shape,c,h);
}},QS=Zl,eC=Jl,tC=Ly(vn,(e=>e>=0?eC*e:QS*(Math.exp(e)-1))),nC={kernelName:vn,backendName:"cpu",kernelFunc:tC},rC=Ly(Cn,(e=>e<0?-1:e>0?1:0)),sC={kernelName:Cn,backendName:"cpu",kernelFunc:rC},iC=Ly(In,(e=>Math.sin(e))),aC={kernelName:In,backendName:"cpu",kernelFunc:iC},oC=Ly(Sn,(e=>Math.sinh(e))),uC={kernelName:Sn,backendName:"cpu",kernelFunc:oC},lC=Math.log(1.1920928955078125e-7)+2,cC=Ly($n,(e=>{
const t=e>-lC,n=e<lC,r=Math.exp(e);let s;return s=n?r:t?e:Math.log(1+r),s;
})),hC={kernelName:$n,backendName:"cpu",kernelFunc:cC},dC={kernelName:Rn,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{blockShape:i,paddings:a}=r;_y([s],"spaceToBatchND");const o=m(i),u=[[0,0]];u.push(...a);for(let e=1+i.length;e<s.shape.length;++e){
u.push([0,0]);
}const l=fS.kernelFunc({inputs:{x:s},backend:n,attrs:{paddings:u,constantValue:0}}),c=Wl(l.shape,i,o,!1),h=Vl(c.length,i.length,!1),d=Gl(l.shape,i,o,!1),p=bw({inputs:{x:l},backend:n,attrs:{shape:c}}),f=Rw({inputs:{x:p},backend:n,attrs:{perm:h}}),g=bw({inputs:{x:f},backend:n,attrs:{shape:d}});return n.disposeIntermediateTensorInfo(l),n.disposeIntermediateTensorInfo(p),n.disposeIntermediateTensorInfo(f),g;
}};function pC(e,t,n,r,s,i,a){
const o=t[0],u=i[0],l=new Array(u),c=new Array(o),h=t[1];if(0===u){
if(0!==o){
throw new Error(Sc(o));
}return[C(n,0),[0,h],C(s,0),l,c];
}let d=!0,p=0;const f=new Array(u).fill(0);for(let t=0;t<o;++t){
const n=e[t*h];if(n<0){
throw new Error(Cc(t,n));
}if(n>=u){
throw new Error(Nc(t,n,u));
}++f[n],d=d&&n>=p,p=n;
}let m=!0;for(let e=0;e<u;++e){
const t=0===f[e];l[e]=t,m=m&&!t,f[e]=Math.max(f[e],1),e>0&&(f[e]+=f[e-1]);
}if(m&&d){
const t=e,n=r;for(let e=0;e<o;++e){
c[e]=e;
}return[t,[o,h],n,l,c];
}{const t=f[u-1],i=C(n,t*h),d=C(s,t),p=new Array(u).fill(0);for(let t=0;t<o;++t){
const n=e[t*h],s=p[n],a=(0===n?0:f[n-1])+s;p[n]++;for(let n=0;n<h;++n){
i[a*h+n]=e[t*h+n];
}d[a]=r[t],c[t]=a;
}for(let e=0;e<u;++e){
if(0===p[e]){
const t=0===e?0:f[e-1];i[t*h+0]=e;for(let e=1;e<h;++e){
i[t*h+e]=0;
}d[t]=a;
}
}return[i,[t,h],d,l,c];}
}const fC={kernelName:_n,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n}=e,{indices:r,values:s,denseShape:i,defaultValue:a}=t;if(1!==i.shape.length){
throw new Error(`Dense shape must be a vector, saw:\n        ${i.shape}`);
}if(2!==r.shape.length){
throw new Error(`Indices must be a matrix, saw:\n        ${r.shape}`);
}if(1!==s.shape.length){
throw new Error(`Values must be a vector, saw:\n        ${s.shape}`);
}if(0!==a.shape.length){
throw new Error(`Default value must be a scalar, saw:\n        ${a.shape}`);
}const o=n.data.get(r.dataId).values,u=n.data.get(s.dataId).values,l=n.data.get(i.dataId).values,c=n.data.get(a.dataId).values[0],[h,d,p,f,m]=pC(o,r.shape,r.dtype,u,s.dtype,l,c);return[n.makeTensorInfo(d,r.dtype,h),n.makeTensorInfo([d[0]],s.dtype,p),n.makeTensorInfo([f.length],"bool",new Uint8Array(f.map((e=>Number(e))))),n.makeTensorInfo([m.length],r.dtype,new Int32Array(m))];
}};function mC(e,t,n,r,s){
const i=m(r),a=t[0],o=s.length,u=[];let l=1,c=-1;for(let e=0;e<o;++e){
const t=s[e];if(-1===t){
if(-1!==c){
throw new Error($c(c,e));
}c=e,u.push(1);
}else{
if(t<0){
throw new Error(Tc(e,t));
}l*=t,u.push(t);
}
}if(-1!==c){
if(l<=0){
throw new Error("reshape cannot infer the missing input size for an empty tensor unless all specified input sizes are non-zero");
}const e=Math.trunc(i/l);if(l*e!==i){
throw new Error(Rc(r,u));
}u[c]=e;
}if(m(u)!==i){
throw new Error(Ac(r,u));
}const h=r.length,d=[];if(h>0){
d[h-1]=1;for(let e=h-2;e>=0;--e){
d[e]=d[e+1]*r[e+1];
}
}const p=[];if(o>0){
p[o-1]=1;for(let e=o-2;e>=0;--e){
p[e]=p[e+1]*u[e+1];
}
}const f=C(n,a*o);for(let t=0;t<a;++t){
let n=0;for(let r=0;r<h;++r){
n+=e[t*h+r]*d[r];
}for(let e=0;e<o;++e){
f[t*o+e]=Math.trunc(n/p[e]),n%=p[e];
}
}return[f,[a,o],u];
}const gC={kernelName:Dn,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n}=e,{inputIndices:r,inputShape:s,newShape:i}=t;if(2!==r.shape.length){
throw new Error(`Input indices should be a matrix but received shape\n        ${r.shape}`);
}if(1!==s.shape.length){
throw new Error(`Input shape should be a vector but received shape\n        ${s.shape}`);
}if(1!==i.shape.length){
throw new Error(`Target shape should be a vector but received shape ${i.shape}`);
}const a=Array.from(n.data.get(s.dataId).values),o=n.data.get(r.dataId).values,u=Array.from(n.data.get(i.dataId).values),[l,c,h]=mC(o,r.shape,r.dtype,a,u);return[n.makeTensorInfo(c,r.dtype,l),n.makeTensorInfo([h.length],i.dtype,new Int32Array(h))];
}};function bC(e,t,n,r,s,i=!1,a=0){
const o=r.length,u=[t[0],e.length/t[0]],l=u[1],c=o>0?s[o-1]+1:0;if(c<0){
throw new Error("segment ids must be >= 0");
}const h=t.slice();h[0]=c;const d=C(n,h.reduce(((e,t)=>e*t),1));if(0===o){
return c>0&&d.fill(a),[d,h];
}if(c<=0){
throw new Error("segment ids must be >= 0");
}let p=0,f=1,m=0,g=s[p];for(;;){
let t=0;if(f<o){
if(t=s[f],g===t){
++f;continue;
}if(g>=t){
throw new Error("segment ids are not increasing");
}
}if(g<0||g>=c){
throw new Error(Dc(g,c));
}g>m&&d.fill(a,m*l,g*l);for(let t=p;t<f;++t){
const n=r[t];if(n<0||n>=u[0]){
throw new Error(Oc(t,r[t],u[0]));
}for(let t=0;t<l;t++){
d[g*l+t]+=e[n*l+t];
}
}if(i){
for(let e=0;e<l;e++){
d[g*l+e]/=f-p;
}
}if(p=f,++f,m=g+1,g=t,f>o){
break;
}
}return m<c&&d.fill(a,m*l,c*l),[d,h];
}const xC={kernelName:On,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n}=e,{data:r,indices:s,segmentIds:i}=t;if(r.shape.length<1){
throw new Error("Data should be at least 1 dimensional but received scalar");
}if(1!==s.shape.length){
throw new Error(`Indices should be a vector but received shape\n          ${s.shape}`);
}if(1!==i.shape.length){
throw new Error(`Segment ids should be a vector but received shape\n          ${i.shape}`);
}if(s.shape[0]!==i.shape[0]){
throw new Error("segmentIds and indices should have same size.");
}const a=n.data.get(r.dataId).values,o=n.data.get(s.dataId).values,u=n.data.get(i.dataId).values,[l,c]=bC(a,r.shape,r.dtype,o,u,!0);return n.makeTensorInfo(c,r.dtype,l);
}},yC={kernelName:Mn,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n}=e,{data:r,indices:s,segmentIds:i}=t;if(r.shape.length<1){
throw new Error("Data should be at least 1 dimensional but received scalar");
}if(1!==s.shape.length){
throw new Error(`Indices should be a vector but received shape\n         ${s.shape}`);
}if(1!==i.shape.length){
throw new Error(`Segment ids should be a vector but received shape\n         ${i.shape}`);
}if(s.shape[0]!==i.shape[0]){
throw new Error("segmentIds and indices should have same size.");
}const a=n.data.get(r.dataId).values,o=n.data.get(s.dataId).values,u=n.data.get(i.dataId).values,[l,c]=bC(a,r.shape,r.dtype,o,u);return n.makeTensorInfo(c,r.dtype,l);
}},wC={kernelName:Ln,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{sparseIndices:s,sparseValues:i,defaultValue:a}=t,{outputShape:o}=r,{sliceRank:u,numUpdates:l,sliceSize:c,strides:h,outputSize:d}=Yl(0,s,o),p=!1,f=n.bufferSync(s);let m;switch(i.dtype){
case"bool":m=qS(f,n.bufferSync(i),o,d,c,l,u,h,Boolean(n.data.get(a.dataId).values[0]),p);break;case"float32":case"int32":m=qS(f,n.bufferSync(i),o,d,c,l,u,h,n.data.get(a.dataId).values[0],p);break;case"string":m=qS(f,n.bufferSync(i),o,d,c,l,u,h,Mr(n.data.get(a.dataId).values[0]),p);break;default:throw new Error(`Unsupported type ${i.dtype}`);
}return n.makeTensorInfo(o,m.dtype,m.values);
}},vC={kernelName:An,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{numOrSizeSplits:i,axis:a}=r,o=k(a,s.shape)[0],u=Ic(s,i,o),l=new Array(s.shape.length).fill(0),c=s.shape.slice();return u.map((e=>{
const t=[...c];t[o]=e;const r=nv({inputs:{x:s},backend:n,attrs:{begin:l,size:t}});return l[o]+=e,r;
}));
}},kC=My((e=>Math.sqrt(e))),IC=Ly(Tn,(e=>Math.sqrt(e))),SC={kernelName:Tn,backendName:"cpu",kernelFunc:IC},CC={kernelName:Pn,backendName:"cpu",kernelFunc:({inputs:e,backend:t})=>{
const{x:n}=e,r=t;_y(n,"square");const s=r.data.get(n.dataId).values,i=new Float32Array(s.length);for(let e=0;e<s.length;++e){
const t=s[e];i[e]=t*t;
}return{dataId:r.write(i,n.shape,n.dtype),shape:n.shape,dtype:n.dtype};
}},NC=jy(((e,t)=>{
const n=e-t;return n*n;
})),$C=hw(zn,NC),TC={kernelName:zn,backendName:"cpu",kernelFunc:$C},EC=My(((e,t)=>{
const{pattern:n,replaceGlobal:r,rewrite:s}=t;return e.replace(new RegExp(n,r?"g":""),s);
})),RC={kernelName:Bn,backendName:"cpu",kernelFunc:zy(Bn,EC)},AC=Ly(nr,((e,t)=>{
const n=t;return isNaN(e)?NaN:e>0?1:n.alpha;
})),FC={kernelName:nr,backendName:"cpu",kernelFunc:AC};function _C(e,t,n,r){
const s=pi(e,t.dtype);for(let e=0;e<s.size;e++){
const i=s.indexToLoc(e),a=new Array(i.length);for(let e=0;e<a.length;e++){
a[e]=i[e]*n[e]+r[e];
}s.set(t.get(...a),...i);
}return s;
}const DC={kernelName:Un,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{begin:i,end:a,strides:o,beginMask:u,endMask:l,ellipsisMask:c,newAxisMask:h,shrinkAxisMask:p}=r;_y(s,"stridedSlice");const{finalShapeSparse:f,finalShape:m,isIdentity:g,sliceDim0:b,isSimpleSlice:x,begin:y,end:w,strides:v}=Ia(s.shape,i,a,o,u,l,c,h,p);let k;if(g){
k=bw({inputs:{x:s},backend:n,attrs:{shape:m}});
}else if(b||x){
d(s.shape.length>=1,(()=>`Input must have rank at least 1, got: ${s.shape.length}`));const e=ca(y,w,v),t=nv({inputs:{x:s},backend:n,attrs:{begin:y,size:e}});k=bw({inputs:{x:t},backend:n,attrs:{shape:m}}),n.disposeIntermediateTensorInfo(t);
}else{
const e=_C(f,n.bufferSync(s),v,y);k=n.makeTensorInfo(m,e.dtype,e.values);
}return k;
}};class OC{
constructor(e,t,n,r,s,i){
this.separator=Or(e),this.nGramWidths=t,this.leftPad=Or(n),this.rightPad=Or(r),this.padWidth=s,this.preserveShort=i;
}getPadWidth(e){
return Math.min(this.padWidth<0?e-1:this.padWidth,e-1);
}getNumNGrams(e,t){
const n=this.getPadWidth(t);return Math.max(0,e+2*n-t+1);
}createNGrams(e,t,n,r,s,i){
for(let a=0;a<s;++a){
const o=this.getPadWidth(i),u=Math.max(0,o-a),l=Math.max(0,o-(s-(a+1))),c=i-(u+l),h=t+(u>0?0:a-o);let d=0;d+=u*this.leftPad.length;for(let t=0;t<c;++t){
d+=e[h+t].length;
}d+=l*this.rightPad.length,d+=(u+l+c-1)*this.separator.length,n[r+a]=new Uint8Array(d);const p=n[r+a];let f=0;const m=e=>e.forEach((e=>p[f++]=e));for(let e=0;e<u;++e){
m(this.leftPad),m(this.separator);
}for(let t=0;t<c-1;++t){
m(e[h+t]),m(this.separator);
}if(c>0){
m(e[h+c-1]);for(let e=0;e<l;++e){
m(this.separator),m(this.rightPad);
}
}else{
for(let e=0;e<l-1;++e){
m(this.rightPad),m(this.separator);
}m(this.rightPad);
}
}
}compute(e,t){
const n=e.length,r=t.length;if(r>0){
let e=t[0];if(0!==e){
throw new Error(`First split value must be 0, got ${e}`);
}for(let s=1;s<r;++s){
let r=t[s]>=e;if(r=r&&t[s]<=n,!r){
throw new Error(`Invalid split value ${t[s]}, must be in [${e}, ${n}]`);
}e=t[s];
}if(e!==n){
throw new Error(`Last split value must be data size. Expected ${n}, got ${e}`);
}
}const s=r-1,i=C("int32",r);if(0===n||0===r){
const e=new Array(n);for(let e=0;e<=s;++e){
i[e]=0;
}return[e,i];
}i[0]=0;for(let e=1;e<=s;++e){
const n=t[e]-t[e-1];let r=0;this.nGramWidths.forEach((e=>{
r+=this.getNumNGrams(n,e);
})),this.preserveShort&&n>0&&0===r&&(r=1),i[e]=i[e-1]+r;
}const a=new Array(i[s]);for(let n=0;n<s;++n){
const r=t[n];let s=i[n];if(this.nGramWidths.forEach((i=>{
const o=t[n+1]-t[n],u=this.getNumNGrams(o,i);this.createNGrams(e,r,a,s,u,i),s+=u;
})),this.preserveShort&&s===i[n]){
const i=t[n+1]-t[n];if(0===i){
continue;
}const o=i+2*this.padWidth,u=1;this.createNGrams(e,r,a,s,u,o);
}
}return[a,i];
}
}function MC(e,t,n,r,s,i,a,o){
return new OC(n,r,s,i,a,o).compute(e,t);
}const LC={kernelName:Wn,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{separator:s,nGramWidths:i,leftPad:a,rightPad:o,padWidth:u,preserveShortSequences:l}=r,{data:c,dataSplits:h}=t,d=n.data.get(c.dataId).values,p=n.data.get(h.dataId).values,[f,m]=MC(d,p,s,i,a,o,u,l);return[n.makeTensorInfo([f.length],"string",f),n.makeTensorInfo(h.shape,"int32",m)];
}};function zC(e,t,n,r){
if(!e.length){
return;
}if(0===t.length){
for(let t=0;t<e.length;++t){
r.push(e.subarray(t,t+1));
}return;
}if(1===t.length){
const s=t[0];let i=e.indexOf(s);for(;-1!==i;){
const t=e.subarray(0,i);n&&0===t.length||r.push(t),i=(e=e.subarray(i+1)).indexOf(s);
}return void(n&&0===e.length||r.push(e));
}let s=0;for(let i=0;i<e.length+1;i++){
if(i===e.length||-1!==t.indexOf(e[i])){
const t=e.subarray(s,i);n&&0===t.length||r.push(t),s=i+1;
}
}
}function PC(e,t,n){
const r=e.length,s=[];let i=0,a=0;const o=new Array(r);for(let u=0;u<r;++u){
const r=s.length;zC(e[u],t,n,s);const l=s.length-r;o[u]=l,i+=l,a=Math.max(a,l);
}const u=C("int32",2*i),l=new Array(i),c=[r,a];let h=0;for(let e=0;e<r;++e){
for(let t=0;t<o[e];++t){
u[2*h]=e,u[2*h+1]=t,l[h]=s[h],++h;
}
}return[u,l,c];
}const BC={kernelName:Vn,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{skipEmpty:s}=r,{input:i,delimiter:a}=t;if("string"!==i.dtype){
throw new Error("Input must be of datatype string");
}if(1!==i.shape.length){
throw new Error(`Input must be a vector, got shape: ${i.shape}`);
}if(0!==a.shape.length){
throw new Error(`Delimiter must be a scalar, got shape: ${a.shape}`);
}const o=n.data.get(i.dataId).values,u=n.data.get(a.dataId).values[0],[l,c,h]=PC(o,u,s),d=c.length;return[n.makeTensorInfo([d,2],"int32",l),n.makeTensorInfo([d],"string",c),n.makeTensorInfo([2],"int32",new Int32Array(h))];
}};function UC(e,t){
const n=C("int32",e.length);for(let r=0;r<e.length;++r){
n[r]=Ar(e[r]).modulo(t).getLowBitsUnsigned();
}return n;
}const WC={kernelName:Gn,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{numBuckets:s}=r,{input:i}=t;if("string"!==i.dtype){
throw new Error("Input must be of datatype string");
}if(s<=0){
throw new Error("Number of buckets must be at least 1");
}const a=UC(n.data.get(i.dataId).values,s);return n.makeTensorInfo(i.shape,"int32",a);
}},VC=Ly(Hn,(e=>Math.tan(e))),GC={kernelName:Hn,backendName:"cpu",kernelFunc:VC},jC=Ly(qn,(e=>Math.tanh(e)));function HC(e,t){
const n=new Array(e.rank);for(let r=0;r<n.length;r++){
n[r]=e.shape[r]*t[r];
}const r=pi(n,e.dtype);for(let t=0;t<r.values.length;++t){
const n=r.indexToLoc(t),s=new Array(e.rank);for(let t=0;t<s.length;t++){
s[t]=n[t]%e.shape[t];
}const i=e.locToIndex(s);r.values[t]=e.values[i];
}return r;
}const qC=(e,t)=>{
const n=t.value-e.value;return 0===n?e.index-t.index:n;
};function KC(e,t,n=0,r=e.length-1){
for(;r>n;){
if(r-n>600){
const s=r-n+1,i=t-n+1,a=Math.log(s),o=.5*Math.exp(2*a/3),u=.5*Math.sqrt(a*o*(s-o)/s)*Math.sign(i-s/2);KC(e,t,Math.max(n,Math.floor(t-i*o/s+u)),Math.min(r,Math.floor(t+(s-i)*o/s+u)));
}const s=e[t];let i=n,a=r;for(h(e,n,t),qC(e[r],s)>0&&h(e,n,r);i<a;){
for(h(e,i,a),i++,a--;qC(e[i],s)<0;){
i+=1;
}for(;qC(e[a],s)>0;){
a-=1;
}
}0===qC(e[n],s)?h(e,n,a):(a+=1,h(e,a,r)),a<=t&&(n=a+1),t<=a&&(r=a-1);
}
}function XC(e,t,n,r,s){
const i=t[t.length-1],[a,o]=[e.length/i,i],u=S(n,a*r),l=S("int32",a*r);for(let t=0;t<a;t++){
const n=t*o,i=e.subarray(n,n+o);let a=new Array(i.length);i.forEach(((e,t)=>a[t]={value:e,index:t})),r<a.length&&(KC(a,r),a=a.slice(0,r)),s&&a.sort(qC);const c=t*r,h=u.subarray(c,c+r),d=l.subarray(c,c+r);for(let e=0;e<r;e++){
h[e]=a[e].value,d[e]=a[e].index;
}
}const c=t.slice();return c[c.length-1]=r,[pi(c,n,u),pi(c,"int32",l)];
}const YC={kernelName:Yn,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,attrs:n,backend:r}=e,{image:s,transforms:i}=t,{interpolation:a,fillMode:o,fillValue:u,outputShape:l}=n,[c,h,d,p]=s.shape,[f,g]=null!=l?l:[h,d],b=[c,f,g,p],x=_(s.shape),y=x[0],w=x[1],v=x[2],k=_(b),I=k[0],C=k[1],N=k[2],$=S(s.dtype,m(b));$.fill(u);const T=r.data.get(s.dataId).values,E=r.data.get(i.dataId).values;for(let e=0;e<c;++e){
const t=1===i.shape[0]?E:E.subarray(8*e,8*e+8);for(let n=0;n<f;++n){
for(let r=0;r<g;++r){
for(let s=0;s<p;++s){
let i;const l=t[6]*r+t[7]*n+1;if(0===l){
continue;
}const c=(t[0]*r+t[1]*n+t[2])/l,p=(t[3]*r+t[4]*n+t[5])/l,f=ZC(c,d,o),m=ZC(p,h,o);switch(a){
case"nearest":i=QC(T,h,d,y,w,v,e,m,f,s,u);break;case"bilinear":i=eN(T,h,d,y,w,v,e,m,f,s,u);break;default:throw new Error(`Error in Transform: Expect 'nearest' or 'bilinear', but got ${a}`);
}$[e*I+n*C+r*N+s]=i;
}
}
}return r.makeTensorInfo(b,s.dtype,$);
}return{dataId:r.write($,b,s.dtype),shape:s.shape,dtype:s.dtype};
}};function ZC(e,t,n){
switch(n){
case"reflect":return function(e,t){
let n=e;if(n<0){
if(t<=1){
n=0;
}else{
const e=2*t;n<e&&(n=e*Math.trunc(-n/e)+n),n=n<-t?n+e:-n-1;
}
}else if(n>t-1){
if(t<=1){
n=0;
}else{
const e=2*t;n-=e*Math.trunc(n/e),n>=t&&(n=e-n-1);
}
}return l(0,n,t-1);
}(e,t);case"wrap":return function(e,t){
let n=e;if(n<0){
if(t<=1){
n=0;
}else{
const e=t-1;n+=t*(Math.trunc(-n/e)+1);
}
}else if(n>t-1){
if(t<=1){
n=0;
}else{
const e=t-1;n-=t*Math.trunc(n/e);
}
}return l(0,n,t-1);
}(e,t);case"nearest":return function(e,t){
return l(0,e,t-1);
}(e,t);default:return function(e,t){
return e;
}(e);
}
}function JC(e,t,n,r,s,i,a,o,u,l,c){
return 0<=o&&o<t&&0<=u&&u<n?e[a*r+o*s+u*i+l]:c;
}function QC(e,t,n,r,s,i,a,o,u,l,c){
return JC(e,t,n,r,s,i,a,Math.round(o),Math.round(u),l,c);
}function eN(e,t,n,r,s,i,a,o,u,l,c){
const h=Math.floor(o),d=Math.floor(u),p=h+1,f=d+1;return(p-o)*((f-u)*JC(e,t,n,r,s,i,a,h,d,l,c)+(u-d)*JC(e,t,n,r,s,i,a,h,f,l,c))+(o-h)*((f-u)*JC(e,t,n,r,s,i,a,p,d,l,c)+(u-d)*JC(e,t,n,r,s,i,a,p,f,l,c));
}function tN(e,t,n,r){
const s=k(t,n)[0],i=[1,n[0],1];for(let e=0;e<s;e++){
i[0]*=n[e];
}i[1]=n[s];for(let e=s+1;e<n.length;e++){
i[2]*=n[e];
}const a=new Map,o=new Int32Array(n[s]),u=new Yr(i,r,e),l=[],c=1===i[0]&&1===i[2];for(let t=0;t<n[s];t++){
let n;if(c){
n=e[t].toString();
}else{
const e=[];for(let n=0;n<i[0];n++){
for(let r=0;r<i[2];r++){
e.push(u.get(n,t,r));
}
}n=e.join(",");
}const r=a.get(n);if(null!=r){
o[t]=r;
}else{
const e=a.size;a.set(n,e),o[t]=e,l.push(t);
}
}const h=i.slice();h[1]=a.size;const d=new Yr(h,r);l.forEach(((e,t)=>{
for(let n=0;n<i[0];n++){
for(let r=0;r<i[2];r++){
d.set(u.get(n,e,r),n,t,r);
}
}
}));const p=n.slice();return p[s]=h[1],{outputValues:d.values,outputShape:p,indices:o};
}const nN={kernelName:er,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s,segmentIds:i}=t,{numSegments:a}=r;_y(s,"unsortedSegmentSum");const o=[],u=[],l=s.shape.length-i.shape.length;let c=i;for(let e=0;e<l;++e){
const t=mk({inputs:{input:c},backend:n,attrs:{dim:e+1}});c=t,u.push(t);
}for(let e=0;e<a;++e){
const t=Fr(e,"int32"),r=n.makeTensorInfo([],"int32",t),i=nk({inputs:{a:r,b:c},backend:n}),a=lw({inputs:{x:i},backend:n,attrs:{dtype:"float32"}}),l=Xv({inputs:{a,b:s},backend:n}),h=Zv({inputs:{x:l},backend:n,attrs:{axis:0,keepDims:!1}});o.push(h),u.push(r),u.push(i),u.push(a),u.push(l),u.push(h);
}const h=dS({inputs:o,backend:n,attrs:{axis:0}});return u.forEach((e=>n.disposeIntermediateTensorInfo(e))),h;
}},rN=[vw,Iw,Cw,$w,gw,Tw,Fw,_w,Dw,Ow,Lw,Pw,Uw,Gw,Hw,Yw,Zw,Jw,Qw,ww,ev,sv,ov,lv,cv,cw,pv,mv,sw,gv,vv,Iv,Sv,Cv,Nv,$v,Tv,Rv,Fv,_v,Dv,Ov,Mv,Lv,Pv,Bv,Uv,Wv,Vv,Gv,jv,Hv,Qv,By,ek,rk,hk,fk,gk,yk,Rk,Fk,_k,Mk,Pk,Bk,Uk,Vk,jk,Kk,Zk,Wy,Jk,yv,eI,nI,sI,Gy,oI,cI,dI,mI,bI,wI,kI,CI,NI,$I,RI,_I,DI,OI,MI,LI,zI,PI,BI,VI,GI,qI,YI,Yv,JI,eS,nS,sS,oS,uS,hS,pS,fS,bS,Ky,yS,kS,CS,AS,_S,ow,kk,OS,Yy,Jy,xw,MS,LS,zS,PS,BS,US,VS,HS,KS,ZS,JS,nC,tw,sC,aC,uC,rv,XI,hC,dC,fC,gC,xC,yC,wC,vC,SC,CC,TC,RC,FC,DC,LC,BC,WC,Nk,Jv,GC,{kernelName:qn,backendName:"cpu",kernelFunc:jC},{kernelName:xn,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n}=e,{tensor:r,indices:s,updates:i}=t,{sliceRank:a,numUpdates:o,sliceSize:u,strides:l,outputSize:c}=Yl(0,s,r.shape),h=n.bufferSync(s),d=n.bufferSync(i),p=n.bufferSync(r),f=qS(h,d,r.shape,c,u,o,a,l,p,!1);return n.makeTensorInfo(r.shape,f.dtype,f.values);
}},{kernelName:Kn,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{reps:i}=r;_y(s,"tile");const a=HC(n.bufferSync(s),i);return n.makeTensorInfo(a.shape,a.dtype,a.values);
}},{kernelName:Xn,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{k:i,sorted:a}=r;_y(s,"topk");const o=n.data.get(s.dataId).values,[u,l]=XC(o,s.shape,s.dtype,i,a);return[n.makeTensorInfo(u.shape,u.dtype,u.values),n.makeTensorInfo(l.shape,l.dtype,l.values)];
}},YC,Aw,{kernelName:Jn,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,attrs:n,backend:r}=e,{axis:s}=n,{x:i}=t;_y(i,"unique");const a=r.data.get(i.dataId).values,{outputValues:o,outputShape:u,indices:l}=tN(a,s,i.shape,i.dtype);return[r.makeTensorInfo(u,i.dtype,o),r.makeTensorInfo([l.length],"int32",l)];
}},{kernelName:Qn,backendName:"cpu",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{value:s}=t;let{axis:i}=r;i<0&&(i+=s.shape.length);const a=s.shape.length,o=s.shape[i],u=new Array(a-1);let l=0;for(let e=0;e<a;e++){
e!==i&&(u[l++]=s.shape[e]);
}const c=new Array(a).fill(0),h=s.shape.slice();h[i]=1;const d=new Array(o);for(let e=0;e<d.length;e++){
c[i]=e;const t=nv({inputs:{x:s},backend:n,attrs:{begin:c,size:h}});d[e]=bw({inputs:{x:t},backend:n,attrs:{shape:u}}),n.disposeIntermediateTensorInfo(t);
}return d;
}},nN,cS];for(const e of rN){
fr(e);
}const sN={},iN={alpha:!1,antialias:!1,premultipliedAlpha:!1,preserveDrawingBuffer:!1,depth:!1,stencil:!1,failIfMajorPerformanceCaveat:!0};function aN(e,t){
if(!(e in sN)||null!=t){
const n=function(e,t){
if(1!==e&&2!==e){
throw new Error("Cannot get WebGL rendering context, WebGL is disabled.");
}const n=null==t?function(e){
if(H().getBool("IS_SAFARI")||"undefined"==typeof OffscreenCanvas||2!==e){
if("undefined"!=typeof document){
return document.createElement("canvas");
}throw new Error("Cannot create a canvas in this context");
}return new OffscreenCanvas(300,150);
}(e):t;return n.addEventListener("webglcontextlost",(t=>{
t.preventDefault(),delete sN[e];
}),!1),H().getBool("SOFTWARE_WEBGL_ENABLED")&&(iN.failIfMajorPerformanceCaveat=!1),1===e?n.getContext("webgl",iN)||n.getContext("experimental-webgl",iN):n.getContext("webgl2",iN);
}(e,t);if(null===n){
return console.log("Could not get context for WebGL version",e),null;
}sN[e]=n;
}const n=sN[e];return null==n||n.isContextLost()?(delete sN[e],aN(e)):(n.disable(n.DEPTH_TEST),n.disable(n.STENCIL_TEST),n.disable(n.BLEND),n.disable(n.DITHER),n.disable(n.POLYGON_OFFSET_FILL),n.disable(n.SAMPLE_COVERAGE),n.enable(n.SCISSOR_TEST),n.enable(n.CULL_FACE),n.cullFace(n.BACK),sN[e]);
}var oN,uN,lN;function cN(e,t){
return[t,e];
}function hN(e){
const t=m(e);return x(Math.ceil(t/4));
}function dN(e,t){
return[Math.max(1,Math.ceil(t/2)),Math.max(1,Math.ceil(e/2))];
}function pN(e,t){
const n=e;let r,s,i,a,o,u,l,c,h,d;return 2===H().getNumber("WEBGL_VERSION")?(r=n.R32F,s=n.R16F,i=n.RGBA16F,a=n.RGBA32F,o=n.RED,l=4,c=1,h=n.HALF_FLOAT,d=n.FLOAT,u=n.RGBA8):(r=e.RGBA,s=e.RGBA,i=e.RGBA,a=n.RGBA,o=e.RGBA,l=4,c=4,h=null!=t?t.HALF_FLOAT_OES:null,d=e.FLOAT,u=e.RGBA),{internalFormatFloat:r,internalFormatHalfFloat:s,internalFormatPackedHalfFloat:i,internalFormatPackedFloat:a,textureFormatFloat:o,downloadTextureFormat:u,downloadUnpackNumChannels:l,defaultNumChannels:c,textureTypeHalfFloat:h,textureTypeFloat:d};
}function fN(e,t){
const n=t();return H().getBool("DEBUG")&&function(e){
const t=e.getError();if(t!==e.NO_ERROR){
throw new Error("WebGL Error: "+function(e,t){
switch(t){
case e.NO_ERROR:return"NO_ERROR";case e.INVALID_ENUM:return"INVALID_ENUM";case e.INVALID_VALUE:return"INVALID_VALUE";case e.INVALID_OPERATION:return"INVALID_OPERATION";case e.INVALID_FRAMEBUFFER_OPERATION:return"INVALID_FRAMEBUFFER_OPERATION";case e.OUT_OF_MEMORY:return"OUT_OF_MEMORY";case e.CONTEXT_LOST_WEBGL:return"CONTEXT_LOST_WEBGL";default:return`Unknown error code ${t}`;
}
}(e,t));
}
}(e),n;
}function mN(e){
return!!(H().getBool("WEBGL_RENDER_FLOAT32_ENABLED")||0===e||5.96e-8<Math.abs(e)&&Math.abs(e)<65504);
}function gN(e,t){
return CN(e,(()=>e.getExtension(t)),'Extension "'+t+'" not supported on this browser.');
}!function(e){
e[e.DENSE=0]="DENSE",e[e.SHARED_BATCH=1]="SHARED_BATCH";
}(oN||(oN={})),function(e){
e[e.RENDER=0]="RENDER",e[e.UPLOAD=1]="UPLOAD",e[e.PIXELS=2]="PIXELS",e[e.DOWNLOAD=3]="DOWNLOAD";
}(uN||(uN={})),function(e){
e[e.UNPACKED_FLOAT16=0]="UNPACKED_FLOAT16",e[e.UNPACKED_FLOAT32=1]="UNPACKED_FLOAT32",e[e.PACKED_4X1_UNSIGNED_BYTE=2]="PACKED_4X1_UNSIGNED_BYTE",e[e.PACKED_2X2_FLOAT32=3]="PACKED_2X2_FLOAT32",e[e.PACKED_2X2_FLOAT16=4]="PACKED_2X2_FLOAT16";
}(lN||(lN={}));const bN=/ERROR: [0-9]+:([0-9]+):/g;function xN(e,t){
const n=bN.exec(t);if(null==n){
return console.log(`Couldn't parse line number in error: ${t}`),void console.log(e);
}const r=+n[1],s=e.split("\n"),i=s.length.toString().length+2,a=s.map(((e,t)=>y((t+1).toString(),i)+e));let o=0;for(let e=0;e<a.length;e++){
o=Math.max(a[e].length,o);
}const u=a.slice(0,r-1),l=a.slice(r-1,r),c=a.slice(r);console.log(u.join("\n")),console.log(t.split("\n")[0]),console.log(`%c ${y(l[0],o)}`,"border:1px solid red; background-color:#e3d2d2; color:#a61717"),console.log(c.join("\n"));
}function yN(e,t){
if(fN(e,(()=>e.validateProgram(t))),!1===e.getProgramParameter(t,e.VALIDATE_STATUS)){
throw console.log(e.getProgramInfoLog(t)),new Error("Shader program validation failed.");
}
}function wN(e,t,n,r,s,i,a){
const o=e.getAttribLocation(t,n);return-1!==o&&(fN(e,(()=>e.bindBuffer(e.ARRAY_BUFFER,r))),fN(e,(()=>e.vertexAttribPointer(o,s,e.FLOAT,!1,i,a))),fN(e,(()=>e.enableVertexAttribArray(o))),!0);
}function vN(e,t,n,r){
fN(e,(()=>function(e,t,n){
(function(e,t){
const n=e.MAX_COMBINED_TEXTURE_IMAGE_UNITS-1,r=t+e.TEXTURE0;if(r<e.TEXTURE0||r>n){
throw new Error(`textureUnit must be in [gl.TEXTURE0, gl.TEXTURE${n}].`);
}
})(e,n),fN(e,(()=>e.activeTexture(e.TEXTURE0+n))),fN(e,(()=>e.bindTexture(e.TEXTURE_2D,t)));
}(e,t,r))),fN(e,(()=>e.uniform1i(n,r)));
}function kN(e,t,n){
fN(e,(()=>e.bindFramebuffer(e.FRAMEBUFFER,n))),fN(e,(()=>e.framebufferTexture2D(e.FRAMEBUFFER,e.COLOR_ATTACHMENT0,e.TEXTURE_2D,t,0)));
}function IN(e,t){
fN(e,(()=>e.bindFramebuffer(e.FRAMEBUFFER,t))),fN(e,(()=>e.framebufferTexture2D(e.FRAMEBUFFER,e.COLOR_ATTACHMENT0,e.TEXTURE_2D,null,0)));
}function SN(e){
const t=e.checkFramebufferStatus(e.FRAMEBUFFER);if(t!==e.FRAMEBUFFER_COMPLETE){
throw new Error("Error binding framebuffer: "+function(e,t){
switch(t){
case e.FRAMEBUFFER_INCOMPLETE_ATTACHMENT:return"FRAMEBUFFER_INCOMPLETE_ATTACHMENT";case e.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT:return"FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT";case e.FRAMEBUFFER_INCOMPLETE_DIMENSIONS:return"FRAMEBUFFER_INCOMPLETE_DIMENSIONS";case e.FRAMEBUFFER_UNSUPPORTED:return"FRAMEBUFFER_UNSUPPORTED";default:return`unknown error ${t}`;
}
}(e,t));
}
}function CN(e,t,n){
const r=fN(e,(()=>t()));if(null==r){
throw new Error(n);
}return r;
}function NN(e,t=2){
return m(e.slice(0,e.length-t));
}function $N(e){
if(0===e.length){
throw Error("Cannot get rows and columns of an empty shape array.");
}return[e.length>1?e[e.length-2]:1,e[e.length-1]];
}function TN(e){
let t=[1,1,1];return 0===e.length||1===e.length&&1===e[0]||(t=[NN(e),...$N(e)]),t;
}function EN(e){
return e%2==0;
}function RN(e,t){
if(g(e=e.slice(-2),t=t.slice(-2))){
return!0;
}if(!e.length||!t.length){
return!0;
}if(0===e[0]||0===e[1]||0===t[0]||0===t[1]){
return!0;
}if(e.length!==t.length){
const n=e[e.length-1],r=t[t.length-1];if(n===r){
return!0;
}if(EN(n)&&EN(r)&&(1===e[0]||1===t[0])){
return!0;
}
}return e[1]===t[1]&&EN(e[0])&&EN(t[0]);
}let AN,FN;function _N(e,t){
return null!=e.getExtension(t);
}function DN(e){
try{
if(null!=aN(e)){
return!0;
}
}catch(e){
return console.log("Error when getting WebGL context: ",e),!1;
}return!1;
}function ON(e){
const t=pN(e),n=e.createTexture();e.bindTexture(e.TEXTURE_2D,n),e.texImage2D(e.TEXTURE_2D,0,t.internalFormatFloat,1,1,0,t.textureFormatFloat,t.textureTypeFloat,null);const r=e.createFramebuffer();e.bindFramebuffer(e.FRAMEBUFFER,r),e.framebufferTexture2D(e.FRAMEBUFFER,e.COLOR_ATTACHMENT0,e.TEXTURE_2D,n,0);const s=e.checkFramebufferStatus(e.FRAMEBUFFER)===e.FRAMEBUFFER_COMPLETE;return e.bindTexture(e.TEXTURE_2D,null),e.bindFramebuffer(e.FRAMEBUFFER,null),e.deleteTexture(n),e.deleteFramebuffer(r),s;
}function MN(e,t){
Array.isArray(e)||(e=[e]),e.forEach((e=>{
null!=e&&d("complex64"!==e.dtype,(()=>`${t} does not support complex64 tensors in the WebGL backend.`));
}));
}const LN=H();function zN(){
let e,t,n,r,s,i,a,o,u,l;return 2===H().getNumber("WEBGL_VERSION")?(e="#version 300 es",t="in",n="out",r="in",s="texture",i="outputColor",a="out vec4 outputColor;",o=H().getBool("WEBGL2_ISNAN_CUSTOM")?"\n      bool isnan_custom(float val) {\n        uint floatToUint = floatBitsToUint(val);\n        return (floatToUint & 0x7fffffffu) > 0x7f800000u;\n      }\n\n      bvec4 isnan_custom(vec4 val) {\n        return bvec4(isnan_custom(val.x),\n          isnan_custom(val.y), isnan_custom(val.z), isnan_custom(val.w));\n      }\n\n      #define isnan(value) isnan_custom(value)\n    ":"",u="",l="\n      #define round(value) newRound(value)\n      int newRound(float value) {\n        return int(floor(value + 0.5));\n      }\n\n      ivec4 newRound(vec4 value) {\n        return ivec4(floor(value + vec4(0.5)));\n      }\n    "):(e="",t="attribute",n="varying",r="varying",s="texture2D",i="gl_FragColor",a="",o="\n      #define isnan(value) isnan_custom(value)\n      bool isnan_custom(float val) {\n        return (val > 0. || val < 1. || val == 0.) ? false : true;\n      }\n      bvec4 isnan_custom(vec4 val) {\n        return bvec4(isnan(val.x), isnan(val.y), isnan(val.z), isnan(val.w));\n      }\n    ",u="\n      uniform float INFINITY;\n\n      bool isinf(float val) {\n        return abs(val) == INFINITY;\n      }\n      bvec4 isinf(vec4 val) {\n        return equal(abs(val), vec4(INFINITY));\n      }\n    ",l="\n      int round(float value) {\n        return int(floor(value + 0.5));\n      }\n\n      ivec4 round(vec4 value) {\n        return ivec4(floor(value + vec4(0.5)));\n      }\n    "),{version:e,attribute:t,varyingVs:n,varyingFs:r,texture2D:s,output:i,defineOutput:a,defineSpecialNaN:o,defineSpecialInf:u,defineRound:l};
}function PN(e,t,n="index"){
const r=_(t);return r.map(((t,s)=>`int ${e[s]} = ${n} / ${t}; ${s===r.length-1?`int ${e[s+1]} = ${n} - ${e[s]} * ${t}`:`index -= ${e[s]} * ${t}`};`)).join("");
}function BN(e,t,n="index"){
const r=_(t);return r.map(((t,s)=>`int ${e[s]} = ${n} / outShapeStrides[${s}]; ${s===r.length-1?`int ${e[s+1]} = ${n} - ${e[s]} * outShapeStrides[${s}]`:`index -= ${e[s]} * outShapeStrides[${s}]`};`)).join("");
}function UN(e){
const t=_(e).map((e=>e.toString()));return`\n  int getFlatIndex(ivec3 coords) {\n    return coords.x * ${t[0]} + coords.y * ${t[1]} + coords.z;\n  }\n`;
}LN.registerFlag("HAS_WEBGL",(()=>LN.getNumber("WEBGL_VERSION")>0)),LN.registerFlag("WEBGL_VERSION",(()=>DN(2)?2:DN(1)?1:0)),LN.registerFlag("WEBGL_CHECK_NUMERICAL_PROBLEMS",(()=>!1)),LN.registerFlag("WEBGL_BUFFER_SUPPORTED",(()=>2===LN.get("WEBGL_VERSION"))),LN.registerFlag("WEBGL_CPU_FORWARD",(()=>!0)),LN.registerFlag("WEBGL_FORCE_F16_TEXTURES",(()=>!1)),LN.registerFlag("WEBGL_PACK",(()=>LN.getBool("HAS_WEBGL"))),LN.registerFlag("WEBGL_PACK_NORMALIZATION",(()=>LN.getBool("WEBGL_PACK"))),LN.registerFlag("WEBGL_PACK_CLIP",(()=>LN.getBool("WEBGL_PACK"))),LN.registerFlag("WEBGL_PACK_DEPTHWISECONV",(()=>LN.getBool("WEBGL_PACK"))),LN.registerFlag("WEBGL_PACK_BINARY_OPERATIONS",(()=>LN.getBool("WEBGL_PACK"))),LN.registerFlag("WEBGL_PACK_UNARY_OPERATIONS",(()=>LN.getBool("WEBGL_PACK"))),LN.registerFlag("WEBGL_PACK_ARRAY_OPERATIONS",(()=>LN.getBool("WEBGL_PACK"))),LN.registerFlag("WEBGL_PACK_IMAGE_OPERATIONS",(()=>LN.getBool("WEBGL_PACK"))),LN.registerFlag("WEBGL_PACK_REDUCE",(()=>LN.getBool("WEBGL_PACK"))),LN.registerFlag("WEBGL_LAZILY_UNPACK",(()=>LN.getBool("WEBGL_PACK"))),LN.registerFlag("WEBGL_CONV_IM2COL",(()=>LN.getBool("WEBGL_PACK"))),LN.registerFlag("WEBGL_MAX_TEXTURE_SIZE",(()=>function(e){
if(null==AN){
const t=aN(e);AN=t.getParameter(t.MAX_TEXTURE_SIZE);
}return AN;
}(LN.getNumber("WEBGL_VERSION")))),LN.registerFlag("WEBGL_MAX_TEXTURES_IN_SHADER",(()=>function(e){
if(null==FN){
const t=aN(e);FN=t.getParameter(t.MAX_TEXTURE_IMAGE_UNITS);
}return Math.min(16,FN);
}(LN.getNumber("WEBGL_VERSION")))),LN.registerFlag("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION",(()=>{
const e=LN.getNumber("WEBGL_VERSION");return 0===e?0:function(e){
if(0===e){
return 0;
}let t;const n=aN(e);return t=_N(n,"EXT_disjoint_timer_query_webgl2")&&2===e?2:_N(n,"EXT_disjoint_timer_query")?1:0,t;
}(e);
})),LN.registerFlag("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE",(()=>LN.getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION")>0&&!Is())),LN.registerFlag("WEBGL_RENDER_FLOAT32_CAPABLE",(()=>function(e){
if(0===e){
return!1;
}const t=aN(e);if(1===e){
if(!_N(t,"OES_texture_float")){
return!1;
}
}else if(!_N(t,"EXT_color_buffer_float")){
return!1;
}return ON(t);
}(LN.getNumber("WEBGL_VERSION")))),LN.registerFlag("WEBGL_RENDER_FLOAT32_ENABLED",(()=>!LN.getBool("WEBGL_FORCE_F16_TEXTURES")&&LN.getBool("WEBGL_RENDER_FLOAT32_CAPABLE"))),LN.registerFlag("WEBGL_DOWNLOAD_FLOAT_ENABLED",(()=>function(e){
if(0===e){
return!1;
}const t=aN(e);if(1!==e){
if(_N(t,"EXT_color_buffer_float")){
return ON(t);
}const e="EXT_color_buffer_half_float";if(_N(t,e)){
const n=t.getExtension(e);return function(e,t){
const n=pN(e,t),r=e.createTexture();e.bindTexture(e.TEXTURE_2D,r),e.texImage2D(e.TEXTURE_2D,0,n.internalFormatHalfFloat,1,1,0,n.textureFormatFloat,n.textureTypeHalfFloat,null);const s=e.createFramebuffer();e.bindFramebuffer(e.FRAMEBUFFER,s),e.framebufferTexture2D(e.FRAMEBUFFER,e.COLOR_ATTACHMENT0,e.TEXTURE_2D,r,0);const i=e.checkFramebufferStatus(e.FRAMEBUFFER)===e.FRAMEBUFFER_COMPLETE;return e.bindTexture(e.TEXTURE_2D,null),e.bindFramebuffer(e.FRAMEBUFFER,null),e.deleteTexture(r),e.deleteFramebuffer(s),i;
}(t,n);
}return!1;
}return!!_N(t,"OES_texture_float")&&!!_N(t,"WEBGL_color_buffer_float")&&ON(t);
}(LN.getNumber("WEBGL_VERSION")))),LN.registerFlag("WEBGL_FENCE_API_ENABLED",(()=>{
return 2===(e=LN.getNumber("WEBGL_VERSION"))&&null!=aN(e).fenceSync;var e;
})),LN.registerFlag("WEBGL_SIZE_UPLOAD_UNIFORM",(()=>LN.getBool("WEBGL_RENDER_FLOAT32_ENABLED")?4:0)),LN.registerFlag("WEBGL_DELETE_TEXTURE_THRESHOLD",(()=>-1),(e=>{
if("number"!=typeof e){
throw new Error(`WEBGL_DELETE_TEXTURE_THRESHOLD must be a number but got ${e}.`);
}if(e<0&&-1!==e){
throw new Error(`WEBGL_DELETE_TEXTURE_THRESHOLD must be -1 (indicating never delete) or at least 0, but got ${e}.`);
}
})),LN.registerFlag("WEBGL_FLUSH_THRESHOLD",(()=>Is()?1:-1),(e=>{
if("number"!=typeof e){
throw new Error(`WEBGL_FLUSH_THRESHOLD must be a number but got ${e}.`);
}if(e<0&&-1!==e){
throw new Error(`WEBGL_FLUSH_THRESHOLD must be -1 (indicating never manual flush) or at least 0, but got ${e}.`);
}
})),LN.registerFlag("CPU_HANDOFF_SIZE_THRESHOLD",(()=>128)),LN.registerFlag("WEBGL_USE_SHAPES_UNIFORMS",(()=>!1)),LN.registerFlag("TOPK_LAST_DIM_CPU_HANDOFF_SIZE_THRESHOLD",(()=>1e5)),LN.registerFlag("TOPK_K_CPU_HANDOFF_THRESHOLD",(()=>128)),LN.registerFlag("WEBGL_EXP_CONV",(()=>!1)),LN.registerFlag("SOFTWARE_WEBGL_ENABLED",(()=>LN.getBool("IS_TEST"))),LN.registerFlag("WEBGL_MAX_SIZE_FOR_NARROW_TEXTURE",(()=>1/0)),LN.registerFlag("WEBGL_AUTO_SQUARIFY_NARROW_TEXTURE_SHAPE",(()=>!1)),LN.registerFlag("WEBGL2_ISNAN_CUSTOM",(()=>!1)),LN.registerFlag("ENGINE_COMPILE_ONLY",(()=>!1));const WN="\n  const float FLOAT_MAX = 1.70141184e38;\n  const float FLOAT_MIN = 1.17549435e-38;\n\n  lowp vec4 encode_float(highp float v) {\n    if (isnan(v)) {\n      return vec4(255, 255, 255, 255);\n    }\n\n    highp float av = abs(v);\n\n    if(av < FLOAT_MIN) {\n      return vec4(0.0, 0.0, 0.0, 0.0);\n    } else if(v > FLOAT_MAX) {\n      return vec4(0.0, 0.0, 128.0, 127.0) / 255.0;\n    } else if(v < -FLOAT_MAX) {\n      return vec4(0.0, 0.0,  128.0, 255.0) / 255.0;\n    }\n\n    highp vec4 c = vec4(0,0,0,0);\n\n    highp float e = floor(log2(av));\n    highp float m = exp2(fract(log2(av))) - 1.0;\n\n    c[2] = floor(128.0 * m);\n    m -= c[2] / 128.0;\n    c[1] = floor(32768.0 * m);\n    m -= c[1] / 32768.0;\n    c[0] = floor(8388608.0 * m);\n\n    highp float ebias = e + 127.0;\n    c[3] = floor(ebias / 2.0);\n    ebias -= c[3] * 2.0;\n    c[2] += floor(ebias) * 128.0;\n\n    c[3] += 128.0 * step(0.0, -v);\n\n    return c / 255.0;\n  }\n",{getBroadcastDims:VN}=n;function GN(e,t,n){
const r=[];if(e.forEach((e=>{
const t=m(e.shapeInfo.logicalShape);if(e.shapeInfo.isUniform?r.push(`uniform float ${e.name}${t>1?`[${t}]`:""};`):(r.push(`uniform sampler2D ${e.name};`),r.push(`uniform int offset${e.name};`)),n.enableShapeUniforms){
const{uniformShape:t}=e$(n.packedInputs,e.shapeInfo.logicalShape,e.shapeInfo.texShape);switch(t.length){
case 1:r.push(`uniform int ${e.name}Shape;`);break;case 2:r.push(`uniform ivec2 ${e.name}Shape;`);break;case 3:r.push(`uniform ivec3 ${e.name}Shape;`);break;case 4:r.push(`uniform ivec4 ${e.name}Shape;`);
}r.push(`uniform ivec2 ${e.name}TexShape;`);
}
})),n.enableShapeUniforms){
switch(t.logicalShape.length){
case 1:r.push("uniform int outShape;");break;case 2:r.push("uniform ivec2 outShape;"),r.push("uniform int outShapeStrides;");break;case 3:r.push("uniform ivec3 outShape;"),r.push("uniform ivec2 outShapeStrides;");break;case 4:r.push("uniform ivec4 outShape;"),r.push("uniform ivec3 outShapeStrides;");
}r.push("uniform ivec2 outTexShape;");
}n.customUniforms&&n.customUniforms.forEach((e=>{
r.push(`uniform ${e.type} ${e.name}${e.arrayIndex?`[${e.arrayIndex}]`:""};`);
}));const s=r.join("\n"),i=e.map((e=>function(e,t,n=!1,r){
let s="";s+=n?HN(e,r):jN(e,r);const i=e.shapeInfo.logicalShape,a=t.logicalShape;return i.length<=a.length&&(s+=n?function(e,t){
const n=e.name,r=n.charAt(0).toUpperCase()+n.slice(1),s="get"+r+"AtOutCoords",i=e.shapeInfo.logicalShape.length,a=t.logicalShape.length,o=VN(e.shapeInfo.logicalShape,t.logicalShape),u=QN(a),l=a-i;let c;const h=["x","y","z","w","u","v"];c=0===i?"":a<2&&o.length>=1?"coords = 0;":o.map((e=>`coords.${h[e+l]} = 0;`)).join("\n");let d="";d=a<2&&i>0?"coords":e.shapeInfo.logicalShape.map(((e,t)=>`coords.${h[t+l]}`)).join(", ");let p="return outputValue;";const f=1===m(e.shapeInfo.logicalShape),g=1===m(t.logicalShape);if(1!==i||f||g){
if(f&&!g){
p=1===a?"\n        return vec4(outputValue.x, outputValue.x, 0., 0.);\n      ":"\n        return vec4(outputValue.x);\n      ";
}else if(o.length){
const e=i-2,t=i-1;o.indexOf(e)>-1&&o.indexOf(t)>-1?p="return vec4(outputValue.x);":o.indexOf(e)>-1?p="return vec4(outputValue.x, outputValue.y, outputValue.x, outputValue.y);":o.indexOf(t)>-1&&(p="return vec4(outputValue.xx, outputValue.zz);");
}
}else {
p="\n      return vec4(outputValue.xy, outputValue.xy);\n    ";
}return`\n    vec4 ${s}() {\n      ${u} coords = getOutputCoords();\n      ${c}\n      vec4 outputValue = get${r}(${d});\n      ${p}\n    }\n  `;
}(e,t):function(e,t){
const n=e.name,r=n.charAt(0).toUpperCase()+n.slice(1),s="get"+r+"AtOutCoords",i=t.texShape,a=e.shapeInfo.texShape,o=e.shapeInfo.logicalShape.length,u=t.logicalShape.length;if(!e.shapeInfo.isUniform&&o===u&&null==e.shapeInfo.flatOffset&&g(a,i)){
return`\n      float ${s}() {\n        return sampleTexture(${n}, resultUV);\n      }\n    `;
}const l=QN(u),c=VN(e.shapeInfo.logicalShape,t.logicalShape),h=u-o;let d;const p=["x","y","z","w","u","v"];d=0===o?"":u<2&&c.length>=1?"coords = 0;":c.map((e=>`coords.${p[e+h]} = 0;`)).join("\n");let f="";return f=u<2&&o>0?"coords":e.shapeInfo.logicalShape.map(((e,t)=>`coords.${p[t+h]}`)).join(", "),`\n    float ${s}() {\n      ${l} coords = getOutputCoords();\n      ${d}\n      return get${r}(${f});\n    }\n  `;
}(e,t)),s;
}(e,t,n.packedInputs,n.enableShapeUniforms))).join("\n"),a=t.texShape,o=zN(),u=function(e){
return`\n    float sampleTexture(sampler2D textureSampler, vec2 uv) {\n      return ${e.texture2D}(textureSampler, uv).r;\n    }\n  `;
}(o);let l,c,h=function(e){
return`${e.version}\n    precision highp float;\n    precision highp int;\n    precision highp sampler2D;\n    ${e.varyingFs} vec2 resultUV;\n    ${e.defineOutput}\n    const vec2 halfCR = vec2(0.5, 0.5);\n\n    struct ivec5\n    {\n      int x;\n      int y;\n      int z;\n      int w;\n      int u;\n    };\n\n    struct ivec6\n    {\n      int x;\n      int y;\n      int z;\n      int w;\n      int u;\n      int v;\n    };\n\n    uniform float NAN;\n    ${e.defineSpecialNaN}\n    ${e.defineSpecialInf}\n    ${e.defineRound}\n\n    int imod(int x, int y) {\n      return x - y * (x / y);\n    }\n\n    int idiv(int a, int b, float sign) {\n      int res = a / b;\n      int mod = imod(a, b);\n      if (sign < 0. && mod != 0) {\n        res -= 1;\n      }\n      return res;\n    }\n\n    //Based on the work of Dave Hoskins\n    //https://www.shadertoy.com/view/4djSRW\n    #define HASHSCALE1 443.8975\n    float random(float seed){\n      vec2 p = resultUV * seed;\n      vec3 p3  = fract(vec3(p.xyx) * HASHSCALE1);\n      p3 += dot(p3, p3.yzx + 19.19);\n      return fract((p3.x + p3.y) * p3.z);\n    }\n\n    ${qN}\n    ${KN}\n    ${XN}\n  `;
}(o);return t.isPacked?(l=function(e,t,n){
switch(e.length){
case 0:return"\n    int getOutputCoords() {\n      return 0;\n    }\n  ";case 1:return function(e,t,n){
const r=[Math.ceil(t[0]/2),Math.ceil(t[1]/2)];return 1===r[0]?n?"\n      int getOutputCoords() {\n        return 2 * int(resultUV.x * ceil(float(outTexShape[1]) / 2.0));\n      }\n    ":`\n      int getOutputCoords() {\n        return 2 * int(resultUV.x * ${r[1]}.0);\n      }\n    `:1===r[1]?n?"\n      int getOutputCoords() {\n        return 2 * int(resultUV.y * ceil(float(outTexShape[0]) / 2.0));\n      }\n    ":`\n      int getOutputCoords() {\n        return 2 * int(resultUV.y * ${r[0]}.0);\n      }\n    `:n?"\n    int getOutputCoords() {\n      ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(packedTexShape[0], packedTexShape[1]));\n      return 2 * (resTexRC.x * packedTexShape[1] + resTexRC.y);\n    }\n  ":`\n    int getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(${r[0]}, ${r[1]}));\n      return 2 * (resTexRC.x * ${r[1]} + resTexRC.y);\n    }\n  `;
}(0,t,n);case 2:return function(e,t,n){
const r=[Math.ceil(t[0]/2),Math.ceil(t[1]/2)];if(g(e,t)){
return n?"\n      ivec2 getOutputCoords() {\n        ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));\n        return 2 * ivec2(resultUV.yx * vec2(packedTexShape[0], packedTexShape[1]));\n      }\n    ":`\n      ivec2 getOutputCoords() {\n        return 2 * ivec2(resultUV.yx * vec2(${r[0]}, ${r[1]}));\n      }\n    `;
}const s=Math.ceil(e[1]/2);return n?"\n    ivec2 getOutputCoords() {\n      ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));\n      int texelsInLogicalRow = int(ceil(float(outShape[1]) / 2.0));\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(packedTexShape[0], packedTexShape[1]));\n\n      int index = resTexRC.x * packedTexShape[1] + resTexRC.y;\n      int r = 2 * (index / texelsInLogicalRow);\n      int c = imod(index, texelsInLogicalRow) * 2;\n\n      return ivec2(r, c);\n    }\n  ":`\n    ivec2 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(${r[0]}, ${r[1]}));\n\n      int index = resTexRC.x * ${r[1]} + resTexRC.y;\n      int r = 2 * (index / ${s});\n      int c = imod(index, ${s}) * 2;\n\n      return ivec2(r, c);\n    }\n  `;
}(e,t,n);case 3:return function(e,t,n){
if(n){
return"\n    ivec3 getOutputCoords() {\n      ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));\n      int texelsInLogicalRow = int(ceil(float(outShape[2]) / 2.0));\n      int texelsInBatch = texelsInLogicalRow * int(ceil(float(outShape[1]) / 2.0));\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(packedTexShape[0], packedTexShape[1]));\n      int index = resTexRC.x * packedTexShape[1] + resTexRC.y;\n\n      int b = index / texelsInBatch;\n      index -= b * texelsInBatch;\n\n      int r = 2 * (index / texelsInLogicalRow);\n      int c = imod(index, texelsInLogicalRow) * 2;\n\n      return ivec3(b, r, c);\n    }\n  ";
}const r=[Math.ceil(t[0]/2),Math.ceil(t[1]/2)],s=Math.ceil(e[2]/2),i=s*Math.ceil(e[1]/2);return`\n    ivec3 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(${r[0]}, ${r[1]}));\n      int index = resTexRC.x * ${r[1]} + resTexRC.y;\n\n      int b = index / ${i};\n      index -= b * ${i};\n\n      int r = 2 * (index / ${s});\n      int c = imod(index, ${s}) * 2;\n\n      return ivec3(b, r, c);\n    }\n  `;
}(e,t,n);default:return function(e,t,n){
if(n){
return"\n    ivec4 getOutputCoords() {\n      ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(packedTexShape[0], packedTexShape[1]));\n      int index = resTexRC.x * packedTexShape[1] + resTexRC.y;\n\n      int texelsInLogicalRow = int(ceil(float(outShape[3]) / 2.0));\n      int texelsInBatch = texelsInLogicalRow * int(ceil(float(outShape[2]) / 2.0));\n      int texelsInBatchN = texelsInBatch * outShape[1];\n\n      int b2 = index / texelsInBatchN;\n      index -= b2 * texelsInBatchN;\n\n      int b = index / texelsInBatch;\n      index -= b * texelsInBatch;\n\n      int r = 2 * (index / texelsInLogicalRow);\n      int c = imod(index, texelsInLogicalRow) * 2;\n\n      return ivec4(b2, b, r, c);\n    }\n  ";
}const r=[Math.ceil(t[0]/2),Math.ceil(t[1]/2)],s=Math.ceil(e[e.length-1]/2),i=s*Math.ceil(e[e.length-2]/2);let a=i,o="",u="b, r, c";for(let t=2;t<e.length-1;t++){
a*=e[e.length-t-1],o=`\n      int b${t} = index / ${a};\n      index -= b${t} * ${a};\n    `+o,u=`b${t}, `+u;
}return`\n    ivec${e.length} getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(${r[0]}, ${r[1]}));\n      int index = resTexRC.x * ${r[1]} + resTexRC.y;\n\n      ${o}\n\n      int b = index / ${i};\n      index -= b * ${i};\n\n      int r = 2 * (index / ${s});\n      int c = imod(index, ${s}) * 2;\n\n      return ivec${e.length}(${u});\n    }\n  `;
}(e,t,n);
}
}(t.logicalShape,a,n.enableShapeUniforms),c=function(e){
return`\n    void setOutput(vec4 val) {\n      ${e.output} = val;\n    }\n  `;
}(o)):(l=function(e,t,n){
switch(e.length){
case 0:return"\n    int getOutputCoords() {\n      return 0;\n    }\n  ";case 1:return function(e,t,n){
return 1===t[0]?n?"\n      int getOutputCoords() {\n        return int(resultUV.x * float(outTexShape[1]));\n      }\n    ":`\n      int getOutputCoords() {\n        return int(resultUV.x * ${t[1]}.0);\n      }\n    `:1===t[1]?n?"\n      int getOutputCoords() {\n        return int(resultUV.y * float(outTexShape[0]));\n      }\n    ":`\n      int getOutputCoords() {\n        return int(resultUV.y * ${t[0]}.0);\n      }\n    `:n?"\n    int getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(outTexShape[0], outTexShape[1]));\n      return resTexRC.x * outTexShape[1] + resTexRC.y;\n    }\n  ":`\n    int getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(${t[0]}, ${t[1]}));\n      return resTexRC.x * ${t[1]} + resTexRC.y;\n    }\n  `;
}(0,t,n);case 2:return function(e,t,n){
return g(e,t)?n?"\n      ivec2 getOutputCoords() {\n        return ivec2(resultUV.yx * vec2(outTexShape[0], outTexShape[1]));\n      }\n    ":`\n      ivec2 getOutputCoords() {\n        return ivec2(resultUV.yx * vec2(${t[0]}, ${t[1]}));\n      }\n    `:1===e[1]?n?"\n      ivec2 getOutputCoords() {\n        ivec2 resTexRC = ivec2(resultUV.yx *\n                               vec2(outTexShape[0], outTexShape[1]));\n        int index = resTexRC.x * outTexShape[1] + resTexRC.y;\n        return ivec2(index, 0);\n      }\n    ":`\n      ivec2 getOutputCoords() {\n        ivec2 resTexRC = ivec2(resultUV.yx *\n                               vec2(${t[0]}, ${t[1]}));\n        int index = resTexRC.x * ${t[1]} + resTexRC.y;\n        return ivec2(index, 0);\n      }\n    `:1===e[0]?n?"\n      ivec2 getOutputCoords() {\n        ivec2 resTexRC = ivec2(resultUV.yx *\n                               vec2(outTexShape[0], outTexShape[1]));\n        int index = resTexRC.x * outTexShape[1] + resTexRC.y;\n        return ivec2(0, index);\n      }\n    ":`\n      ivec2 getOutputCoords() {\n        ivec2 resTexRC = ivec2(resultUV.yx *\n                               vec2(${t[0]}, ${t[1]}));\n        int index = resTexRC.x * ${t[1]} + resTexRC.y;\n        return ivec2(0, index);\n      }\n    `:n?"\n    ivec2 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(outTexShape[0], outTexShape[1]));\n      int index = resTexRC.x * outTexShape[1] + resTexRC.y;\n      int r = index / outShape[1];\n      int c = index - r * outShape[1];\n      return ivec2(r, c);\n    }\n  ":`\n    ivec2 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(${t[0]}, ${t[1]}));\n      int index = resTexRC.x * ${t[1]} + resTexRC.y;\n      int r = index / ${e[1]};\n      int c = index - r * ${e[1]};\n      return ivec2(r, c);\n    }\n  `;
}(e,t,n);case 3:return function(e,t,n){
if(n){
return`\n  ivec3 getOutputCoords() {\n    ivec2 resTexRC = ivec2(resultUV.yx *\n                           vec2(outTexShape[0], outTexShape[1]));\n    int index = resTexRC.x * outTexShape[1] + resTexRC.y;\n    ${BN(["r","c","d"],e)}\n    return ivec3(r, c, d);\n  }\n`;
}const r=PN(["r","c","d"],e);return`\n    ivec3 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(${t[0]}, ${t[1]}));\n      int index = resTexRC.x * ${t[1]} + resTexRC.y;\n      ${r}\n      return ivec3(r, c, d);\n    }\n  `;
}(e,t,n);case 4:return function(e,t,n){
if(n){
return`\n    ivec4 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n        vec2(outTexShape[0], outTexShape[1]));\n      int index = resTexRC.x * outTexShape[1] + resTexRC.y;\n      ${BN(["r","c","d","d2"],e)}\n      return ivec4(r, c, d, d2);\n    }\n  `;
}const r=PN(["r","c","d","d2"],e);return`\n    ivec4 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n        vec2(${t[0]}, ${t[1]}));\n      int index = resTexRC.x * ${t[1]} + resTexRC.y;\n      ${r}\n      return ivec4(r, c, d, d2);\n    }\n  `;
}(e,t,n);case 5:return function(e,t){
const n=PN(["r","c","d","d2","d3"],e);return`\n    ivec5 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx * vec2(${t[0]},\n                             ${t[1]}));\n\n      int index = resTexRC.x * ${t[1]} + resTexRC.y;\n\n      ${n}\n\n      ivec5 outShape = ivec5(r, c, d, d2, d3);\n      return outShape;\n    }\n  `;
}(e,t);case 6:return function(e,t){
const n=PN(["r","c","d","d2","d3","d4"],e);return`\n    ivec6 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n        vec2(${t[0]}, ${t[1]}));\n      int index = resTexRC.x * ${t[1]} + resTexRC.y;\n\n      ${n}\n\n      ivec6 result = ivec6(r, c, d, d2, d3, d4);\n      return result;\n    }\n  `;
}(e,t);default:throw new Error(`${e.length}-D output sampling is not yet supported`);
}
}(t.logicalShape,a,n.enableShapeUniforms),c=function(e){
return`\n    void setOutput(float val) {\n      ${e.output} = vec4(val, 0, 0, 0);\n    }\n  `;
}(o)),n.packedInputs&&(h+=YN),[h,u,c,s,l,i,n.userCode].join("\n");
}function jN(e,t=!1){
const n=e.shapeInfo.logicalShape;switch(n.length){
case 0:return function(e,t){
const n=e.name,r="get"+n.charAt(0).toUpperCase()+n.slice(1);if(e.shapeInfo.isUniform){
return`float ${r}() {return ${n};}`;
}const[s,i]=e.shapeInfo.texShape;if(1===s&&1===i){
return`\n      float ${r}() {\n        return sampleTexture(${n}, halfCR);\n      }\n    `;
}const a=ZN(n);if(t){
return`\n    float ${r}() {\n      vec2 uv = uvFromFlat(${n}TexShape[0], ${n}TexShape[1], ${a});\n      return sampleTexture(${n}, uv);\n    }\n  `;
}const[o,u]=e.shapeInfo.texShape;return`\n    float ${r}() {\n      vec2 uv = uvFromFlat(${o}, ${u}, ${a});\n      return sampleTexture(${n}, uv);\n    }\n  `;
}(e,t);case 1:return function(e,t){
const n=e.name,r="get"+n.charAt(0).toUpperCase()+n.slice(1);if(e.shapeInfo.isUniform){
return`\n      float ${r}(int index) {\n        ${JN(e)}\n      }\n    `;
}const s=e.shapeInfo.texShape,i=s[0],a=s[1];if(1===a&&1===i){
return`\n      float ${r}(int index) {\n        return sampleTexture(${n}, halfCR);\n      }\n    `;
}const o=ZN(n);return 1===a?t?`\n      float ${r}(int index) {\n        vec2 uv = vec2(0.5, (float(index + ${o}) + 0.5) / float(${n}TexShape[0]));\n        return sampleTexture(${n}, uv);\n      }\n    `:`\n      float ${r}(int index) {\n        vec2 uv = vec2(0.5, (float(index + ${o}) + 0.5) / ${i}.0);\n        return sampleTexture(${n}, uv);\n      }\n    `:1===i?t?`\n      float ${r}(int index) {\n        vec2 uv = vec2((float(index + ${o}) + 0.5) / float(${n}TexShape[1]), 0.5);\n        return sampleTexture(${n}, uv);\n      }\n    `:`\n      float ${r}(int index) {\n        vec2 uv = vec2((float(index + ${o}) + 0.5) / ${a}.0, 0.5);\n        return sampleTexture(${n}, uv);\n      }\n    `:t?`\n    float ${r}(int index) {\n      vec2 uv = uvFromFlat(${n}TexShape[0], ${n}TexShape[1], index + ${o});\n      return sampleTexture(${n}, uv);\n    }\n  `:`\n    float ${r}(int index) {\n      vec2 uv = uvFromFlat(${i}, ${a}, index + ${o});\n      return sampleTexture(${n}, uv);\n    }\n  `;
}(e,t);case 2:return function(e,t){
const n=e.shapeInfo.logicalShape,r=e.name,s="get"+r.charAt(0).toUpperCase()+r.slice(1),i=e.shapeInfo.texShape;if(null!=i&&g(n,i)){
if(t){
return`\n      float ${s}(int row, int col) {\n        vec2 uv = (vec2(col, row) + halfCR) / vec2(${r}TexShape[1], ${r}TexShape[0]);\n        return sampleTexture(${r}, uv);\n      }\n    `;
}const e=i[0];return`\n    float ${s}(int row, int col) {\n      vec2 uv = (vec2(col, row) + halfCR) / vec2(${i[1]}.0, ${e}.0);\n      return sampleTexture(${r}, uv);\n    }\n  `;
}const{newShape:a,keptDims:o}=I(n),u=a;if(u.length<n.length){
const n=["row","col"];return`\n      ${jN(t$(e,u),t)}\n      float ${s}(int row, int col) {\n        return ${s}(${n$(n,o)});\n      }\n    `;
}if(e.shapeInfo.isUniform){
return`\n      float ${s}(int row, int col) {\n        int index = round(dot(vec2(row, col), vec2(${n[1]}, 1)));\n        ${JN(e)}\n      }\n    `;
}const l=i[0],c=i[1],h=ZN(r);return 1===c?t?`\n      float ${s}(int row, int col) {\n        float index = dot(vec3(row, col, ${h}), vec3(${r}Shape[1], 1, 1));\n        vec2 uv = vec2(0.5, (index + 0.5) / float(${r}TexShape[0]));\n        return sampleTexture(${r}, uv);\n      }\n    `:`\n    float ${s}(int row, int col) {\n      float index = dot(vec3(row, col, ${h}), vec3(${n[1]}, 1, 1));\n      vec2 uv = vec2(0.5, (index + 0.5) / ${l}.0);\n      return sampleTexture(${r}, uv);\n    }\n  `:1===l?t?`\n      float ${s}(int row, int col) {\n        float index = dot(vec3(row, col, ${h}), vec3(${r}Shape[1], 1, 1));\n        vec2 uv = vec2((index + 0.5) / float(${r}TexShape[1]), 0.5);\n        return sampleTexture(${r}, uv);\n      }\n    `:`\n    float ${s}(int row, int col) {\n      float index = dot(vec3(row, col, ${h}), vec3(${n[1]}, 1, 1));\n      vec2 uv = vec2((index + 0.5) / ${c}.0, 0.5);\n      return sampleTexture(${r}, uv);\n    }\n  `:t?`\n      float ${s}(int row, int col) {\n        // Explicitly use integer operations as dot() only works on floats.\n        int index = row * ${r}Shape[1] + col + ${h};\n        vec2 uv = uvFromFlat(${r}TexShape[0], ${r}TexShape[1], index);\n        return sampleTexture(${r}, uv);\n      }\n    `:`\n  float ${s}(int row, int col) {\n    // Explicitly use integer operations as dot() only works on floats.\n    int index = row * ${n[1]} + col + ${h};\n    vec2 uv = uvFromFlat(${l}, ${c}, index);\n    return sampleTexture(${r}, uv);\n  }\n`;
}(e,t);case 3:return function(e,t){
const n=e.shapeInfo.logicalShape,r=e.name,s="get"+r.charAt(0).toUpperCase()+r.slice(1),i=n[1]*n[2],a=n[2],{newShape:o,keptDims:u}=I(n),l=o;if(l.length<n.length){
const n=["row","col","depth"];return`\n        ${jN(t$(e,l),t)}\n        float ${s}(int row, int col, int depth) {\n          return ${s}(${n$(n,u)});\n        }\n      `;
}if(e.shapeInfo.isUniform){
return`\n      float ${s}(int row, int col, int depth) {\n        int index = round(dot(vec3(row, col, depth),\n                          vec3(${i}, ${a}, 1)));\n        ${JN(e)}\n      }\n    `;
}const c=e.shapeInfo.texShape,h=c[0],d=c[1],p=e.shapeInfo.flatOffset;if(d===i&&null==p){
return t?`\n      float ${s}(int row, int col, int depth) {\n        int stride1 = ${r}Shape[2];\n        float texR = float(row);\n        float texC = dot(vec2(col, depth), vec2(stride1, 1));\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                   vec2(${r}TexShape[1], ${r}TexShape[0]);\n        return sampleTexture(${r}, uv);\n      }\n    `:`\n        float ${s}(int row, int col, int depth) {\n          float texR = float(row);\n          float texC = dot(vec2(col, depth), vec2(${a}, 1));\n          vec2 uv = (vec2(texC, texR) + halfCR) /\n                     vec2(${d}.0, ${h}.0);\n          return sampleTexture(${r}, uv);\n        }\n      `;
}if(d===a&&null==p){
return t?`\n      float ${s}(int row, int col, int depth) {\n        float texR = dot(vec2(row, col), vec2(${r}Shape[1], 1));\n        float texC = float(depth);\n        vec2 uv = (vec2(texC, texR) + halfCR) / vec2(${r}TexShape[1], ${r}TexShape[0]);\n        return sampleTexture(${r}, uv);\n      }\n    `:`\n    float ${s}(int row, int col, int depth) {\n      float texR = dot(vec2(row, col), vec2(${n[1]}, 1));\n      float texC = float(depth);\n      vec2 uv = (vec2(texC, texR) + halfCR) / vec2(${d}.0, ${h}.0);\n      return sampleTexture(${r}, uv);\n    }\n  `;
}const f=ZN(r);return t?`\n    float ${s}(int row, int col, int depth) {\n      // Explicitly use integer operations as dot() only works on floats.\n      int stride0 = ${r}Shape[1] * ${r}Shape[2];\n      int stride1 = ${r}Shape[2];\n      int index = row * stride0 + col * stride1 + depth + ${f};\n      vec2 uv = uvFromFlat(${r}TexShape[0], ${r}TexShape[1], index);\n      return sampleTexture(${r}, uv);\n    }\n    `:`\n      float ${s}(int row, int col, int depth) {\n        // Explicitly use integer operations as dot() only works on floats.\n        int index = row * ${i} + col * ${a} + depth + ${f};\n        vec2 uv = uvFromFlat(${h}, ${d}, index);\n        return sampleTexture(${r}, uv);\n      }\n  `;
}(e,t);case 4:return function(e,t){
const n=e.shapeInfo.logicalShape,r=e.name,s="get"+r.charAt(0).toUpperCase()+r.slice(1),i=n[3],a=n[2]*i,o=n[1]*a,{newShape:u,keptDims:l}=I(n);if(u.length<n.length){
const n=["row","col","depth","depth2"];return`\n      ${jN(t$(e,u),t)}\n      float ${s}(int row, int col, int depth, int depth2) {\n        return ${s}(${n$(n,l)});\n      }\n    `;
}if(e.shapeInfo.isUniform){
return`\n      float ${s}(int row, int col, int depth, int depth2) {\n        int index = round(dot(vec4(row, col, depth, depth2),\n                          vec4(${o}, ${a}, ${i}, 1)));\n        ${JN(e)}\n      }\n    `;
}const c=e.shapeInfo.flatOffset,h=e.shapeInfo.texShape,d=h[0],p=h[1],f=`int stride2 = ${r}Shape[3];`,m=`int stride1 = ${r}Shape[2] * stride2;`,g=`int stride0 = ${r}Shape[1] * stride1;`;if(p===o&&null==c){
return t?`\n      float ${s}(int row, int col, int depth, int depth2) {\n        ${f}\n        ${m}\n        float texR = float(row);\n        float texC =\n            dot(vec3(col, depth, depth2),\n                vec3(stride1, stride2, 1));\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                   vec2(${r}TexShape[1], ${r}TexShape[0]);\n        return sampleTexture(${r}, uv);\n      }\n    `:`\n      float ${s}(int row, int col, int depth, int depth2) {\n        float texR = float(row);\n        float texC =\n            dot(vec3(col, depth, depth2),\n                vec3(${a}, ${i}, 1));\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                   vec2(${p}.0, ${d}.0);\n        return sampleTexture(${r}, uv);\n      }\n    `;
}if(p===i&&null==c){
return t?`\n      float ${s}(int row, int col, int depth, int depth2) {\n        float texR = dot(vec3(row, col, depth),\n                         vec3(${r}Shape[1] * ${r}Shape[2], ${r}Shape[2], 1));\n        float texC = float(depth2);\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                  vec2(${r}TexShape[1], ${r}TexShape[0]);\n        return sampleTexture(${r}, uv);\n      }\n    `:`\n      float ${s}(int row, int col, int depth, int depth2) {\n        float texR = dot(vec3(row, col, depth),\n                         vec3(${n[1]*n[2]}, ${n[2]}, 1));\n        float texC = float(depth2);\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                  vec2(${p}.0, ${d}.0);\n        return sampleTexture(${r}, uv);\n      }\n    `;
}const b=ZN(r);return t?`\n    float ${s}(int row, int col, int depth, int depth2) {\n      // Explicitly use integer operations as dot() only works on floats.\n      ${f}\n      ${m}\n      ${g}\n      int index = row * stride0 + col * stride1 +\n          depth * stride2 + depth2;\n      vec2 uv = uvFromFlat(${r}TexShape[0], ${r}TexShape[1], index + ${b});\n      return sampleTexture(${r}, uv);\n    }\n  `:`\n    float ${s}(int row, int col, int depth, int depth2) {\n      // Explicitly use integer operations as dot() only works on floats.\n      int index = row * ${o} + col * ${a} +\n          depth * ${i} + depth2;\n      vec2 uv = uvFromFlat(${d}, ${p}, index + ${b});\n      return sampleTexture(${r}, uv);\n    }\n  `;
}(e,t);case 5:return function(e){
const t=e.shapeInfo.logicalShape,n=e.name,r="get"+n.charAt(0).toUpperCase()+n.slice(1),s=t[4],i=t[3]*s,a=t[2]*i,o=t[1]*a,{newShape:u,keptDims:l}=I(t);if(u.length<t.length){
const t=["row","col","depth","depth2","depth3"];return`\n      ${jN(t$(e,u))}\n      float ${r}(int row, int col, int depth, int depth2, int depth3) {\n        return ${r}(${n$(t,l)});\n      }\n    `;
}if(e.shapeInfo.isUniform){
return`\n      float ${r}(int row, int col, int depth, int depth2, int depth3) {\n        float index = dot(\n          vec4(row, col, depth, depth2),\n          vec4(${o}, ${a}, ${i}, ${s})) +\n          depth3;\n        ${JN(e)}\n      }\n    `;
}const c=e.shapeInfo.flatOffset,h=e.shapeInfo.texShape,d=h[0],p=h[1];if(p===o&&null==c){
return`\n      float ${r}(int row, int col, int depth, int depth2, int depth3) {\n        int texR = row;\n        float texC = dot(vec4(col, depth, depth2, depth3),\n                         vec4(${a}, ${i}, ${s}, 1));\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                   vec2(${p}.0, ${d}.0);\n        return sampleTexture(${n}, uv);\n      }\n    `;
}if(p===s&&null==c){
return`\n      float ${r}(int row, int col, int depth, int depth2, int depth3) {\n        float texR = dot(\n          vec4(row, col, depth, depth2),\n          vec4(${t[1]*t[2]*t[3]},\n               ${t[2]*t[3]}, ${t[3]}, 1));\n        int texC = depth3;\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                  vec2(${p}.0, ${d}.0);\n        return sampleTexture(${n}, uv);\n      }\n    `;
}return`\n    float ${r}(int row, int col, int depth, int depth2, int depth3) {\n      // Explicitly use integer operations as dot() only works on floats.\n      int index = row * ${o} + col * ${a} + depth * ${i} +\n          depth2 * ${s} + depth3 + ${ZN(n)};\n      vec2 uv = uvFromFlat(${d}, ${p}, index);\n      return sampleTexture(${n}, uv);\n    }\n  `;
}(e);case 6:return function(e){
const t=e.shapeInfo.logicalShape,n=e.name,r="get"+n.charAt(0).toUpperCase()+n.slice(1),{newShape:s,keptDims:i}=I(t);if(s.length<t.length){
const t=["row","col","depth","depth2","depth3","depth4"];return`\n      ${jN(t$(e,s))}\n      float ${r}(int row, int col, int depth,\n                    int depth2, int depth3, int depth4) {\n        return ${r}(${n$(t,i)});\n      }\n    `;
}const a=t[5],o=t[4]*a,u=t[3]*o,l=t[2]*u,c=t[1]*l;if(e.shapeInfo.isUniform){
return`\n      float ${r}(int row, int col, int depth,\n                  int depth2, int depth3, int depth4) {\n        int index = round(dot(\n          vec4(row, col, depth, depth2),\n          vec4(${c}, ${l}, ${u}, ${o})) +\n          dot(\n            vec2(depth3, depth4),\n            vec2(${a}, 1)));\n        ${JN(e)}\n      }\n    `;
}const h=e.shapeInfo.flatOffset,d=e.shapeInfo.texShape,p=d[0],f=d[1];if(f===c&&null==h){
return`\n      float ${r}(int row, int col, int depth,\n                    int depth2, int depth3, int depth4) {\n        int texR = row;\n        float texC = dot(vec4(col, depth, depth2, depth3),\n          vec4(${l}, ${u}, ${o}, ${a})) +\n               float(depth4);\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                   vec2(${f}.0, ${p}.0);\n        return sampleTexture(${n}, uv);\n      }\n    `;
}if(f===a&&null==h){
return`\n      float ${r}(int row, int col, int depth,\n                    int depth2, int depth3, int depth4) {\n        float texR = dot(vec4(row, col, depth, depth2),\n          vec4(${t[1]*t[2]*t[3]*t[4]},\n               ${t[2]*t[3]*t[4]},\n               ${t[3]*t[4]},\n               ${t[4]})) + float(depth3);\n        int texC = depth4;\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                  vec2(${f}.0, ${p}.0);\n        return sampleTexture(${n}, uv);\n      }\n    `;
}return`\n    float ${r}(int row, int col, int depth,\n                  int depth2, int depth3, int depth4) {\n      // Explicitly use integer operations as dot() only works on floats.\n      int index = row * ${c} + col * ${l} + depth * ${u} +\n          depth2 * ${o} + depth3 * ${a} + depth4 + ${ZN(n)};\n      vec2 uv = uvFromFlat(${p}, ${f}, index);\n      return sampleTexture(${n}, uv);\n    }\n  `;
}(e);default:throw new Error(`${n.length}-D input sampling is not yet supported`);
}
}function HN(e,t){
switch(e.shapeInfo.logicalShape.length){
case 0:return function(e){
const t=e.name;return`\n    vec4 ${"get"+t.charAt(0).toUpperCase()+t.slice(1)}() {\n      return ${zN().texture2D}(${t}, halfCR);\n    }\n  `;
}(e);case 1:return function(e,t){
const n=e.name,r="get"+n.charAt(0).toUpperCase()+n.slice(1),s=e.shapeInfo.texShape,i=zN();if(t){
return`\n    vec4 ${r}(int index) {\n      ivec2 packedTexShape = ivec2(ceil(float(${n}TexShape[0]) / 2.0), ceil(float(${n}TexShape[1]) / 2.0));\n      vec2 uv = packedUVfrom1D(\n        packedTexShape[0], packedTexShape[1], index);\n      return ${i.texture2D}(${n}, uv);\n    }\n  `;
}const a=[Math.ceil(s[0]/2),Math.ceil(s[1]/2)];return`\n    vec4 ${r}(int index) {\n      vec2 uv = packedUVfrom1D(\n        ${a[0]}, ${a[1]}, index);\n      return ${i.texture2D}(${n}, uv);\n    }\n  `;
}(e,t);case 2:return function(e,t){
const n=e.shapeInfo.logicalShape,r=e.name,s="get"+r.charAt(0).toUpperCase()+r.slice(1),i=e.shapeInfo.texShape,a=i[0],o=i[1],u=zN();if(null!=i&&g(n,i)){
return t?`\n      vec4 ${s}(int row, int col) {\n        vec2 uv = (vec2(col, row) + halfCR) / vec2(${r}TexShape[1], ${r}TexShape[0]);\n\n        return ${u.texture2D}(${r}, uv);\n      }\n    `:`\n      vec4 ${s}(int row, int col) {\n        vec2 uv = (vec2(col, row) + halfCR) / vec2(${o}.0, ${a}.0);\n\n        return ${u.texture2D}(${r}, uv);\n      }\n    `;
}if(t){
return`\n    vec4 ${s}(int row, int col) {\n      ivec2 packedTexShape = ivec2(ceil(float(${r}TexShape[0]) / 2.0), ceil(float(${r}TexShape[1]) / 2.0));\n      int valuesPerRow = int(ceil(float(${r}Shape[1]) / 2.0));\n      vec2 uv = packedUVfrom2D(valuesPerRow, packedTexShape[0], packedTexShape[1], row, col);\n      return ${u.texture2D}(${r}, uv);\n    }\n  `;
}const l=[Math.ceil(i[0]/2),Math.ceil(i[1]/2)];return`\n    vec4 ${s}(int row, int col) {\n      vec2 uv = packedUVfrom2D(${Math.ceil(n[1]/2)}, ${l[0]}, ${l[1]}, row, col);\n      return ${u.texture2D}(${r}, uv);\n    }\n  `;
}(e,t);case 3:return function(e,t){
const n=e.shapeInfo.logicalShape,r=e.name,s="get"+r.charAt(0).toUpperCase()+r.slice(1),i=e.shapeInfo.texShape,a=[Math.ceil(i[0]/2),Math.ceil(i[1]/2)];if(1===n[0]){
const r=[1,2],i=["b","row","col"];return`\n        ${HN(t$(e,n.slice(1)),t)}\n        vec4 ${s}(int b, int row, int col) {\n          return ${s}(${n$(i,r)});\n        }\n      `;
}const o=zN();if(t){
return`\n    vec4 ${s}(int b, int row, int col) {\n      ivec2 packedTexShape = ivec2(ceil(float(${r}TexShape[0]) / 2.0), ceil(float(${r}TexShape[1]) / 2.0));\n      int valuesPerRow = int(ceil(float(${r}Shape[2]) / 2.0));\n      int texelsInBatch = valuesPerRow * int(ceil(float(${r}Shape[1]) / 2.0));\n      vec2 uv = packedUVfrom3D(\n        packedTexShape[0], packedTexShape[1], texelsInBatch, valuesPerRow, b, row, col);\n      return ${o.texture2D}(${r}, uv);\n    }\n  `;
}const u=a[0],l=a[1],c=Math.ceil(n[2]/2);return`\n    vec4 ${s}(int b, int row, int col) {\n      vec2 uv = packedUVfrom3D(\n        ${u}, ${l}, ${c*Math.ceil(n[1]/2)}, ${c}, b, row, col);\n      return ${o.texture2D}(${r}, uv);\n    }\n  `;
}(e,t);default:return function(e,t){
const n=e.name,r="get"+n.charAt(0).toUpperCase()+n.slice(1),s=zN();if(t){
return`\n    vec4 ${r}(int b2, int b, int row, int col) {\n      int valuesPerRow = int(ceil(float(${n}Shape[3]) / 2.0));\n      int texelsInBatch = valuesPerRow * int(ceil(float(${n}Shape[2]) / 2.0));\n      int index = b * texelsInBatch + (row / 2) * valuesPerRow + (col / 2);\n      texelsInBatch *= ${n}Shape[1];\n      index = b2 * texelsInBatch + index;\n      ivec2 packedTexShape = ivec2(ceil(float(${n}TexShape[0]) / 2.0), ceil(float(${n}TexShape[1]) / 2.0));\n      int texR = index / packedTexShape[1];\n      int texC = index - texR * packedTexShape[1];\n      vec2 uv = (vec2(texC, texR) + halfCR) / vec2(packedTexShape[1], packedTexShape[0]); return ${s.texture2D}(${n}, uv);\n    }\n  `;
}const i=e.shapeInfo.logicalShape,a=i.length,o=e.shapeInfo.texShape,u=[Math.ceil(o[0]/2),Math.ceil(o[1]/2)],l=u[0],c=u[1],h=Math.ceil(i[a-1]/2);let d=h*Math.ceil(i[a-2]/2),p="int b, int row, int col",f=`b * ${d} + (row / 2) * ${h} + (col / 2)`;for(let e=2;e<a-1;e++){
p=`int b${e}, `+p,d*=i[a-e-1],f=`b${e} * ${d} + `+f;
}return`\n    vec4 ${r}(${p}) {\n      int index = ${f};\n      int texR = index / ${c};\n      int texC = index - texR * ${c};\n      vec2 uv = (vec2(texC, texR) + halfCR) / vec2(${c}, ${l});\n      return ${s.texture2D}(${n}, uv);\n    }\n  `;
}(e,t);
}
}const qN="\nvec2 uvFromFlat(int texNumR, int texNumC, int index) {\n  int texR = index / texNumC;\n  int texC = index - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\nvec2 packedUVfrom1D(int texNumR, int texNumC, int index) {\n  int texelIndex = index / 2;\n  int texR = texelIndex / texNumC;\n  int texC = texelIndex - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\n",KN="\nvec2 packedUVfrom2D(int texelsInLogicalRow, int texNumR,\n  int texNumC, int row, int col) {\n  int texelIndex = (row / 2) * texelsInLogicalRow + (col / 2);\n  int texR = texelIndex / texNumC;\n  int texC = texelIndex - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\n",XN="\nvec2 packedUVfrom3D(int texNumR, int texNumC,\n    int texelsInBatch, int texelsInLogicalRow, int b,\n    int row, int col) {\n  int index = b * texelsInBatch + (row / 2) * texelsInLogicalRow + (col / 2);\n  int texR = index / texNumC;\n  int texC = index - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\n",YN="\n  float getChannel(vec4 frag, vec2 innerDims) {\n    vec2 modCoord = mod(innerDims, 2.);\n    return modCoord.x == 0. ?\n      (modCoord.y == 0. ? frag.r : frag.g) :\n      (modCoord.y == 0. ? frag.b : frag.a);\n  }\n  float getChannel(vec4 frag, int dim) {\n    float modCoord = mod(float(dim), 2.);\n    return modCoord == 0. ? frag.r : frag.g;\n  }\n";function ZN(e){
return`offset${e}`;
}function JN(e){
const t=e.name,n=m(e.shapeInfo.logicalShape);return n<2?`return ${t};`:`\n    for (int i = 0; i < ${n}; i++) {\n      if (i == index) {\n        return ${t}[i];\n      }\n    }\n  `;
}function QN(e){
if(e<=1){
return"int";
}if(2===e){
return"ivec2";
}if(3===e){
return"ivec3";
}if(4===e){
return"ivec4";
}if(5===e){
return"ivec5";
}if(6===e){
return"ivec6";
}throw Error(`GPU for rank ${e} is not yet supported`);
}function e$(e,t,n){
const{newShape:r,keptDims:s}=I(t),i=t.length,a=e&&3===i&&1===t[0],o=a?t.slice(1):r,u=!e&&i>1&&!g(t,n)&&r.length<i||a;return{useSqueezeShape:u,uniformShape:u?o:t,keptDims:s};
}function t$(e,t){
const n=JSON.parse(JSON.stringify(e));return n.shapeInfo.logicalShape=t,n;
}function n$(e,t){
return t.map((t=>e[t])).join(", ");
}function r$(e,t,n){
const r=[],s=[];let i,a,o,u=null,l=null;l=e.getUniformLocation(n,"NAN",!1),1===H().getNumber("WEBGL_VERSION")&&(u=e.getUniformLocation(n,"INFINITY",!1));const c=!1;for(const s of t.variableNames){
const i={name:s,uniform:e.getUniformLocation(n,s,c),offset:e.getUniformLocation(n,`offset${s}`,c)};t.enableShapeUniforms&&(i.shape=e.getUniformLocation(n,`${s}Shape`,c),i.texShape=e.getUniformLocation(n,`${s}TexShape`,c)),r.push(i);
}if(t.enableShapeUniforms&&(i=e.getUniformLocation(n,"outShape",c),o=e.getUniformLocation(n,"outShapeStrides",c),a=e.getUniformLocation(n,"outTexShape",c)),t.customUniforms){
for(const r of t.customUniforms){
s.push(e.getUniformLocation(n,r.name,c));
}
}return{variablesLocations:r,customUniformLocations:s,infLoc:u,nanLoc:l,outShapeLocation:i,outShapeStridesLocation:o,outTexShapeLocation:a};
}function s$(e,t){
if(e.length!==t.length){
throw Error(`Binary was compiled with ${e.length} inputs, but was executed with ${t.length} inputs`);
}e.forEach(((e,n)=>{
const r=e.logicalShape,s=t[n],i=s.shape;if(!g(r,i)){
throw Error(`Binary was compiled with different shapes than the current args. Shapes ${r} and ${i} must match`);
}if(e.isUniform&&s.isUniform){
return;
}const a=e.texShape,o=s.isUniform?null:s.texData.texShape;if(!g(a,o)){
throw Error(`Binary was compiled with different texture shapes than the current args. Shape ${a} and ${o} must match`);
}
}));
}function i$(e){
return H().getBool("WEBGL_USE_SHAPES_UNIFORMS")&&e<=4;
}class a${
constructor(e){
this.variableNames=["A"],this.packedInputs=!1,this.packedOutput=!0,this.outPackingScheme=oN.DENSE,this.customUniforms=[{name:"texShape",type:"ivec2"}];const t=zN();this.outputShape=e,this.enableShapeUniforms=i$(this.outputShape.length),this.userCode=`\n      ivec3 outCoordsFromFlatIndex(int index) {\n        ${this.enableShapeUniforms?BN(["r","c","d"],e):PN(["r","c","d"],e)}\n        return ivec3(r, c, d);\n      }\n\n      void main() {\n        ivec2 resTexRC = ivec2(resultUV.yx * vec2(texShape[0], texShape[1]));\n        int index = 4 * (resTexRC.x * texShape[1] + resTexRC.y);\n\n        vec4 result = vec4(0.);\n\n        for (int i=0; i<4; i++) {\n          int flatIndex = index + i;\n          ivec3 rc = outCoordsFromFlatIndex(flatIndex);\n          result[i] = getA(rc.x, rc.y, rc.z);\n        }\n\n        ${t.output} = result;\n      }\n    `;
}
}class o${
constructor(e){
this.variableNames=["A"],this.packedInputs=!0,this.packedOutput=!0,this.outPackingScheme=oN.DENSE,this.customUniforms=[{name:"texShape",type:"ivec2"}];const t=zN();this.outputShape=e,this.enableShapeUniforms=i$(this.outputShape.length),this.userCode=`\n      ivec3 outCoordsFromFlatIndex(int index) {\n        ${this.enableShapeUniforms?BN(["r","c","d"],e):PN(["r","c","d"],e)}\n        return ivec3(r, c, d);\n      }\n\n      void main() {\n        ivec2 resTexRC = ivec2(resultUV.yx * vec2(texShape[0], texShape[1]));\n        int index = 4 * (resTexRC.x * texShape[1] + resTexRC.y);\n\n        vec4 result = vec4(0.);\n\n        for (int i=0; i<4; i++) {\n          int flatIndex = index + i;\n          ivec3 rc = outCoordsFromFlatIndex(flatIndex);\n          result[i] = getChannel(getA(rc.x, rc.y, rc.z), vec2(rc.y, rc.z));\n        }\n\n        ${t.output} = result;\n      }\n    `;
}
}class u${
constructor(e){
this.variableNames=["A"],this.outTexUsage=uN.DOWNLOAD;const t=zN();this.outputShape=e,this.userCode=`\n      ${WN}\n\n      void main() {\n        float x = getAAtOutCoords();\n        ${t.output} = encode_float(x);\n      }\n    `;
}
}class l${
constructor(e){
this.variableNames=["A"],this.packedInputs=!0,this.packedOutput=!1,this.outTexUsage=uN.DOWNLOAD;const t=zN();this.outputShape=e,this.userCode=`\n      ${WN}\n\n      void main() {\n        ivec3 coords = getOutputCoords();\n        float x = getChannel(getAAtOutCoords(), vec2(coords.y, coords.z));\n        ${t.output} = encode_float(x);\n      }\n    `;
}
}const c$={R:0,G:1,B:2,A:3};class h${
constructor(e,t=!1,n="RGBA"){
this.variableNames=["A"],this.customUniforms=[{name:"texShape",type:"ivec2"}];const r=zN();this.outputShape=e,this.enableShapeUniforms=i$(this.outputShape.length);let s="result";t&&(s="floor(result * 255. + 0.5)");let i="";for(let e=0;e<n.length;e++){
const t=n[e];i+=`\n          if(offset == ${e}) {\n            result = values[${c$[t]}];\n          }`;
}this.userCode=`\n      ${this.enableShapeUniforms?"\n  int getFlatIndex(ivec3 coords) {\n    return coords.x * outShapeStrides[0] + coords.y * outShapeStrides[1] + coords.z;\n  }\n":UN(e)}\n\n      void main() {\n        ivec3 coords = getOutputCoords();\n        int flatIndex = getFlatIndex(coords);\n        float result = 0.;\n        int offset = imod(flatIndex, ${n.length});\n\n        flatIndex = idiv(flatIndex, ${n.length}, 1.);\n\n        int r = flatIndex / texShape[1];\n        if (r < texShape[0]) {\n          int c = imod(flatIndex, texShape[1]);\n          vec2 uv = (vec2(c, r) + halfCR) / vec2(texShape[1], texShape[0]);\n          vec4 values = ${r.texture2D}(A, uv);\n          ${i}\n        }\n        ${r.output} = vec4(${s}, 0., 0., 0.);\n      }\n    `;
}
}class d${
constructor(e,t=!1){
this.variableNames=["A"],this.packedInputs=!1,this.packedOutput=!0,this.customUniforms=[{name:"texShape",type:"ivec2"}];const n=zN();this.outputShape=e,this.enableShapeUniforms=i$(this.outputShape.length);let r="",s="result";t&&(s="floor(result * 255. + 0.5)");for(let t=0;t<=1;t++){
for(let s=0;s<=1;s++){
const i=2*t+s;r+=`\n          localCoords = coords;\n          if(localCoords[2] + ${s} < ${this.enableShapeUniforms?"outShape[2]":`${e[2]}`}) {\n          localCoords[2] += ${s};\n          if (localCoords[1] + ${t} < ${this.enableShapeUniforms?"outShape[1]":`${e[1]}`}) {\n            localCoords[1] += ${t};\n\n            flatIndex = getFlatIndex(localCoords);\n            offset = imod(flatIndex, 4);\n\n            flatIndex = idiv(flatIndex, 4, 1.);\n\n            int r = flatIndex / texShape[1];\n            int c = imod(flatIndex, texShape[1]);\n            vec2 uv = (vec2(c, r) + halfCR) / vec2(texShape[1], texShape[0]);\n            values = ${n.texture2D}(A, uv);\n\n            if (offset == 0) {\n              result[${i}] = values[0];\n            } else if (offset == 1) {\n              result[${i}] = values[1];\n            } else if (offset == 2) {\n              result[${i}] = values[2];\n            } else {\n              result[${i}] = values[3];\n            }\n          }\n        }\n        `;
}
}this.userCode=`\n        ${this.enableShapeUniforms?"\n  int getFlatIndex(ivec3 coords) {\n    return coords.x * outShapeStrides[0] + coords.y * outShapeStrides[1] + coords.z;\n  }\n":UN(e)}\n\n        void main() {\n          ivec3 coords = getOutputCoords();\n\n          vec4 result = vec4(0.);\n          int flatIndex, r, c, offset;\n          ivec3 localCoords;\n          vec2 uv;\n          vec4 values;\n\n          ${r}\n\n          ${n.output} = ${s};\n        }\n    `;
}
}function p$(e,t,n,r,s,i){
!function(e,t){
const n=H().getNumber("WEBGL_MAX_TEXTURE_SIZE");if(e<=0||t<=0){
throw new Error(`Requested texture size [${e}x${t}] is invalid.`);
}if(e>n||t>n){
throw new Error(`Requested texture size [${e}x${t}] greater than WebGL maximum on this browser / GPU [${n}x${n}].`);
}
}(t,n);const a=function(e){
return CN(e,(()=>e.createTexture()),"Unable to create WebGLTexture.");
}(e),o=e.TEXTURE_2D;return fN(e,(()=>e.bindTexture(o,a))),fN(e,(()=>e.texParameteri(o,e.TEXTURE_WRAP_S,e.CLAMP_TO_EDGE))),fN(e,(()=>e.texParameteri(o,e.TEXTURE_WRAP_T,e.CLAMP_TO_EDGE))),fN(e,(()=>e.texParameteri(o,e.TEXTURE_MIN_FILTER,e.NEAREST))),fN(e,(()=>e.texParameteri(o,e.TEXTURE_MAG_FILTER,e.NEAREST))),1===H().getNumber("WEBGL_VERSION")?fN(e,(()=>e.texImage2D(o,0,r,t,n,0,s,i,null))):fN(e,(()=>e.texStorage2D(o,1,r,t,n))),fN(e,(()=>e.bindTexture(e.TEXTURE_2D,null))),{texture:a,texShape:[n,t]};
}function f$(e){
return e.internalFormatFloat;
}function m$(e){
return e.internalFormatHalfFloat;
}function g$(e){
return e.downloadTextureFormat;
}function b$(e){
return e.internalFormatPackedFloat;
}function x$(e){
return e.internalFormatPackedHalfFloat;
}class y${
constructor(e){
this.outputTexture=null,this.program=null,this.disposed=!1,this.itemsToPoll=[];const t=H().getNumber("WEBGL_VERSION");if(null!=e?(this.gl=e,function(e,t){
sN[e]=t;
}(t,e)):this.gl=aN(t),e=this.gl,2===H().getNumber("WEBGL_VERSION")){
const t=e;this.createVertexArray=()=>fN(t,(()=>t.createVertexArray())),this.bindVertexArray=e=>fN(t,(()=>t.bindVertexArray(e))),this.deleteVertexArray=e=>fN(t,(()=>t.deleteVertexArray(e))),this.getVertexArray=()=>fN(t,(()=>t.getParameter(t.VERTEX_ARRAY_BINDING)));
}else if(null!=e){
const t=e.getExtension("OES_vertex_array_object");if(null==t){
throw new Error("All WebGL1 implementations are expected to offer OES_vertex_array_object.");
}this.createVertexArray=()=>fN(e,(()=>t.createVertexArrayOES())),this.bindVertexArray=n=>fN(e,(()=>t.bindVertexArrayOES(n))),this.deleteVertexArray=n=>fN(e,(()=>t.deleteVertexArrayOES(n))),this.getVertexArray=()=>fN(e,(()=>e.getParameter(t.VERTEX_ARRAY_BINDING_OES)));
}let n="WEBGL_color_buffer_float";const r="EXT_color_buffer_half_float";if(this.parallelCompilationExtension=this.gl.getExtension("KHR_parallel_shader_compile"),1===H().getNumber("WEBGL_VERSION")){
const e="OES_texture_float",t="OES_texture_half_float";if(this.textureFloatExtension=gN(this.gl,e),_N(this.gl,t)){
this.textureHalfFloatExtension=gN(this.gl,t);
}else if(H().get("WEBGL_FORCE_F16_TEXTURES")){
throw new Error("GL context does not support half float textures, yet the environment flag WEBGL_FORCE_F16_TEXTURES is set to true.");
}if(this.colorBufferFloatExtension=this.gl.getExtension(n),_N(this.gl,r)){
this.colorBufferHalfFloatExtension=gN(this.gl,r);
}else if(H().get("WEBGL_FORCE_F16_TEXTURES")){
throw new Error("GL context does not support color renderable half floats, yet the environment flag WEBGL_FORCE_F16_TEXTURES is set to true.");
}
}else if(n="EXT_color_buffer_float",_N(this.gl,n)){
this.colorBufferFloatExtension=this.gl.getExtension(n);
}else{
if(!_N(this.gl,r)){
throw new Error("GL context does not support color renderable floats");
}this.colorBufferHalfFloatExtension=this.gl.getExtension(r);
}this.vertexBuffer=function(e){
return function(e,t){
const n=CN(e,(()=>e.createBuffer()),"Unable to create WebGLBuffer");return fN(e,(()=>e.bindBuffer(e.ARRAY_BUFFER,n))),fN(e,(()=>e.bufferData(e.ARRAY_BUFFER,t,e.STATIC_DRAW))),n;
}(e,new Float32Array([-1,1,0,0,1,-1,-1,0,0,0,1,1,0,1,1,1,-1,0,1,0]));
}(this.gl),this.indexBuffer=function(e){
return function(e,t){
const n=CN(e,(()=>e.createBuffer()),"Unable to create WebGLBuffer");return fN(e,(()=>e.bindBuffer(e.ELEMENT_ARRAY_BUFFER,n))),fN(e,(()=>e.bufferData(e.ELEMENT_ARRAY_BUFFER,t,e.STATIC_DRAW))),n;
}(e,new Uint16Array([0,1,2,2,1,3]));
}(this.gl),this.framebuffer=function(e){
return CN(e,(()=>e.createFramebuffer()),"Unable to create WebGLFramebuffer.");
}(this.gl),this.textureConfig=pN(this.gl,this.textureHalfFloatExtension);
}get debug(){
return H().getBool("DEBUG");
}dispose(){
if(this.disposed){
return;
}null!=this.program&&console.warn("Disposing a GPGPUContext that still has a bound WebGLProgram. This is probably a resource leak, delete the program with GPGPUContext.deleteProgram before disposing."),null!=this.outputTexture&&console.warn("Disposing a GPGPUContext that still has a bound output matrix texture.  This is probably a resource leak, delete the output matrix texture with GPGPUContext.deleteMatrixTexture before disposing.");const e=this.gl;fN(e,(()=>e.finish())),fN(e,(()=>e.bindFramebuffer(e.FRAMEBUFFER,null))),fN(e,(()=>e.deleteFramebuffer(this.framebuffer))),fN(e,(()=>e.bindBuffer(e.ARRAY_BUFFER,null))),fN(e,(()=>e.bindBuffer(e.ELEMENT_ARRAY_BUFFER,null))),fN(e,(()=>e.deleteBuffer(this.indexBuffer))),this.disposed=!0;
}createFloat32MatrixTexture(e,t){
return this.throwIfDisposed(),function(e,t,n,r){
const[s,i]=cN(t,n);return p$(e,s,i,f$(r),r.textureFormatFloat,e.FLOAT);
}(this.gl,e,t,this.textureConfig);
}createFloat16MatrixTexture(e,t){
return this.throwIfDisposed(),function(e,t,n,r){
const[s,i]=cN(t,n);return p$(e,s,i,m$(r),r.textureFormatFloat,r.textureTypeHalfFloat);
}(this.gl,e,t,this.textureConfig);
}createUnsignedBytesMatrixTexture(e,t){
return this.throwIfDisposed(),function(e,t,n,r){
const[s,i]=cN(t,n);return p$(e,s,i,g$(r),e.RGBA,e.UNSIGNED_BYTE);
}(this.gl,e,t,this.textureConfig);
}uploadPixelDataToTexture(e,t){
this.throwIfDisposed(),function(e,t,n){
fN(e,(()=>e.bindTexture(e.TEXTURE_2D,t))),n.data instanceof Uint8Array?2===H().getNumber("WEBGL_VERSION")?fN(e,(()=>e.texSubImage2D(e.TEXTURE_2D,0,0,0,n.width,n.height,e.RGBA,e.UNSIGNED_BYTE,n.data))):fN(e,(()=>e.texImage2D(e.TEXTURE_2D,0,e.RGBA,n.width,n.height,0,e.RGBA,e.UNSIGNED_BYTE,n.data))):2===H().getNumber("WEBGL_VERSION")?fN(e,(()=>e.texSubImage2D(e.TEXTURE_2D,0,0,0,e.RGBA,e.UNSIGNED_BYTE,n))):fN(e,(()=>e.texImage2D(e.TEXTURE_2D,0,e.RGBA,e.RGBA,e.UNSIGNED_BYTE,n))),fN(e,(()=>e.bindTexture(e.TEXTURE_2D,null)));
}(this.gl,e,t);
}uploadDenseMatrixToTexture(e,t,n,r){
this.throwIfDisposed(),function(e,t,n,r,s,i){
let a,o,u;fN(e,(()=>e.bindTexture(e.TEXTURE_2D,t))),s instanceof Uint8Array?(a=new Uint8Array(n*r*4),o=e.UNSIGNED_BYTE,u=e.RGBA):(a=new Float32Array(n*r*4),o=e.FLOAT,u=i.internalFormatPackedFloat),a.set(s),2===H().getNumber("WEBGL_VERSION")?fN(e,(()=>e.texSubImage2D(e.TEXTURE_2D,0,0,0,n,r,e.RGBA,o,a))):fN(e,(()=>e.texImage2D(e.TEXTURE_2D,0,u,n,r,0,e.RGBA,o,a))),fN(e,(()=>e.bindTexture(e.TEXTURE_2D,null)));
}(this.gl,e,t,n,r,this.textureConfig);
}createFloat16PackedMatrixTexture(e,t){
return this.throwIfDisposed(),function(e,t,n,r){
const[s,i]=dN(t,n);return p$(e,s,i,x$(r),e.RGBA,r.textureTypeHalfFloat);
}(this.gl,e,t,this.textureConfig);
}createPackedMatrixTexture(e,t){
return this.throwIfDisposed(),function(e,t,n,r){
const[s,i]=dN(t,n);return p$(e,s,i,b$(r),e.RGBA,e.FLOAT);
}(this.gl,e,t,this.textureConfig);
}deleteMatrixTexture(e){
this.throwIfDisposed(),this.outputTexture===e&&(IN(this.gl,this.framebuffer),this.outputTexture=null),fN(this.gl,(()=>this.gl.deleteTexture(e)));
}downloadByteEncodedFloatMatrixFromOutputTexture(e,t,n){
return this.downloadMatrixDriver(e,(()=>function(e,t,n,r){
const[s,i]=cN(t,n),a=new Uint8Array(t*n*4);return fN(e,(()=>e.readPixels(0,0,s,i,r.downloadTextureFormat,e.UNSIGNED_BYTE,a))),new Float32Array(a.buffer);
}(this.gl,t,n,this.textureConfig)));
}downloadPackedMatrixFromBuffer(e,t,n,r,s,i){
return function(e,t,n,r,s,i,a,o){
const u=e,l=new Float32Array(function(e,t){
const[n,r]=dN(e,t);return n*r*4;
}(i,a));return u.bindBuffer(u.PIXEL_PACK_BUFFER,t),u.getBufferSubData(u.PIXEL_PACK_BUFFER,0,l),u.bindBuffer(u.PIXEL_PACK_BUFFER,null),l;
}(this.gl,e,0,0,0,s,i,this.textureConfig);
}downloadFloat32MatrixFromBuffer(e,t){
return function(e,t,n){
const r=e,s=new Float32Array(n);return r.bindBuffer(r.PIXEL_PACK_BUFFER,t),r.getBufferSubData(r.PIXEL_PACK_BUFFER,0,s),r.bindBuffer(r.PIXEL_PACK_BUFFER,null),s;
}(this.gl,e,t);
}createBufferFromTexture(e,t,n){
this.bindTextureToFrameBuffer(e);const r=function(e,t,n,r){
const s=e.createBuffer();fN(e,(()=>e.bindBuffer(e.PIXEL_PACK_BUFFER,s)));const i=16*t*n;return fN(e,(()=>e.bufferData(e.PIXEL_PACK_BUFFER,i,e.STREAM_READ))),fN(e,(()=>e.readPixels(0,0,n,t,e.RGBA,e.FLOAT,0))),fN(e,(()=>e.bindBuffer(e.PIXEL_PACK_BUFFER,null))),s;
}(this.gl,t,n,this.textureConfig);return this.unbindTextureToFrameBuffer(),r;
}createAndWaitForFence(){
const e=this.createFence(this.gl);return this.pollFence(e);
}createFence(e){
let t,n;if(H().getBool("WEBGL_FENCE_API_ENABLED")){
const r=e,s=r.fenceSync(r.SYNC_GPU_COMMANDS_COMPLETE,0);e.flush(),n=()=>{
const e=r.clientWaitSync(s,0,0);return e===r.ALREADY_SIGNALED||e===r.CONDITION_SATISFIED;
},t=s;
}else {
H().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION")>0?(t=this.beginQuery(),this.endQuery(),n=()=>this.isQueryAvailable(t,H().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION"))):n=()=>!0;
}return{query:t,isFencePassed:n};
}downloadMatrixFromPackedTexture(e,t,n){
return this.downloadMatrixDriver(e,(()=>function(e,t,n){
const r=new Float32Array(t*n*4);return fN(e,(()=>e.readPixels(0,0,n,t,e.RGBA,e.FLOAT,r))),r;
}(this.gl,t,n)));
}createProgram(e){
this.throwIfDisposed();const t=this.gl;null==this.vertexShader&&(this.vertexShader=function(e){
const t=zN();return function(e,t){
const n=CN(e,(()=>e.createShader(e.VERTEX_SHADER)),"Unable to create vertex WebGLShader.");if(fN(e,(()=>e.shaderSource(n,t))),fN(e,(()=>e.compileShader(n))),!1===e.getShaderParameter(n,e.COMPILE_STATUS)){
throw console.log(e.getShaderInfoLog(n)),new Error("Failed to compile vertex shader.");
}return n;
}(e,`${t.version}\n    precision highp float;\n    ${t.attribute} vec3 clipSpacePos;\n    ${t.attribute} vec2 uv;\n    ${t.varyingVs} vec2 resultUV;\n\n    void main() {\n      gl_Position = vec4(clipSpacePos, 1);\n      resultUV = uv;\n    }`);
}(t));const n=function(e){
return CN(e,(()=>e.createProgram()),"Unable to create WebGLProgram.");
}(t);fN(t,(()=>t.attachShader(n,this.vertexShader))),fN(t,(()=>t.attachShader(n,e))),function(e,t){
if(fN(e,(()=>e.linkProgram(t))),!H().get("ENGINE_COMPILE_ONLY")&&!1===e.getProgramParameter(t,e.LINK_STATUS)){
throw console.log(e.getProgramInfoLog(t)),new Error("Failed to link vertex and fragment shaders.");
}
}(t,n);const r=Object.assign(n,{vao:this.createVertexArray()});return this.debug&&yN(t,r),r;
}buildVao(e){
this.setProgram(e),this.bindVertexArray(e.vao);const t=this.gl;fN(t,(()=>t.bindBuffer(t.ELEMENT_ARRAY_BUFFER,this.indexBuffer))),function(e,t,n){
fN(e,(()=>e.bindBuffer(e.ARRAY_BUFFER,n))),wN(e,t,"clipSpacePos",n,3,20,0)&&wN(e,t,"uv",n,2,20,12);
}(t,e,this.vertexBuffer);
}deleteProgram(e){
this.throwIfDisposed(),e===this.program&&(this.program=null),null!=e&&(fN(this.gl,(()=>this.gl.deleteProgram(e))),this.deleteVertexArray(e.vao));
}setProgram(e){
this.throwIfDisposed(),this.program=e,null!=this.program&&this.debug&&yN(this.gl,this.program),fN(this.gl,(()=>this.gl.useProgram(e)));
}getUniformLocation(e,t,n=!0){
return this.throwIfDisposed(),n?function(e,t,n){
return CN(e,(()=>e.getUniformLocation(t,n)),'uniform "'+n+'" not present in program.');
}(this.gl,e,t):function(e,t,n){
return e.getUniformLocation(t,n);
}(this.gl,e,t);
}getAttributeLocation(e,t){
return this.throwIfDisposed(),fN(this.gl,(()=>this.gl.getAttribLocation(e,t)));
}getUniformLocationNoThrow(e,t){
return this.throwIfDisposed(),this.gl.getUniformLocation(e,t);
}setInputMatrixTexture(e,t,n){
this.throwIfDisposed(),this.throwIfNoProgram(),vN(this.gl,e,t,n);
}setOutputMatrixTexture(e,t,n){
this.setOutputMatrixTextureDriver(e,n,t);
}setOutputPackedMatrixTexture(e,t,n){
this.throwIfDisposed();const[r,s]=dN(t,n);this.setOutputMatrixTextureDriver(e,r,s);
}setOutputMatrixWriteRegion(e,t,n,r){
this.setOutputMatrixWriteRegionDriver(n,e,r,t);
}setOutputPackedMatrixWriteRegion(e,t,n,r){
throw new Error("setOutputPackedMatrixWriteRegion not implemented.");
}debugValidate(){
null!=this.program&&yN(this.gl,this.program),SN(this.gl);
}executeProgram(){
this.throwIfDisposed(),this.throwIfNoProgram();const e=this.gl;if(this.debug){
const e=this.getVertexArray();console.assert(e===this.program.vao,"VAO changed between setProgram and executeProgram!"),this.debugValidate();
}fN(e,(()=>e.drawElements(e.TRIANGLES,6,e.UNSIGNED_SHORT,0)));
}blockUntilAllProgramsCompleted(){
this.throwIfDisposed(),fN(this.gl,(()=>this.gl.finish()));
}getQueryTimerExtension(){
return null==this.disjointQueryTimerExtension&&(this.disjointQueryTimerExtension=gN(this.gl,2===H().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION")?"EXT_disjoint_timer_query_webgl2":"EXT_disjoint_timer_query")),this.disjointQueryTimerExtension;
}getQueryTimerExtensionWebGL2(){
return this.getQueryTimerExtension();
}getQueryTimerExtensionWebGL1(){
return this.getQueryTimerExtension();
}beginQuery(){
if(2===H().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION")){
const e=this.gl,t=this.getQueryTimerExtensionWebGL2(),n=e.createQuery();return e.beginQuery(t.TIME_ELAPSED_EXT,n),n;
}const e=this.getQueryTimerExtensionWebGL1(),t=e.createQueryEXT();return e.beginQueryEXT(e.TIME_ELAPSED_EXT,t),t;
}endQuery(){
if(2===H().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION")){
const e=this.gl,t=this.getQueryTimerExtensionWebGL2();return void e.endQuery(t.TIME_ELAPSED_EXT);
}const e=this.getQueryTimerExtensionWebGL1();e.endQueryEXT(e.TIME_ELAPSED_EXT);
}async waitForQueryAndGetTime(e){
return await w((()=>this.disposed||this.isQueryAvailable(e,H().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION")))),this.getQueryTime(e,H().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION"));
}getQueryTime(e,t){
if(0===t){
return null;
}if(2===t){
const t=this.gl;return t.getQueryParameter(e,t.QUERY_RESULT)/1e6;
}{const t=this.getQueryTimerExtensionWebGL1();return t.getQueryObjectEXT(e,t.QUERY_RESULT_EXT)/1e6;}
}isQueryAvailable(e,t){
if(0===t){
return!0;
}if(2===t){
const t=this.gl,n=this.getQueryTimerExtensionWebGL2(),r=t.getQueryParameter(e,t.QUERY_RESULT_AVAILABLE);return null==this.disjoint&&(this.disjoint=this.gl.getParameter(n.GPU_DISJOINT_EXT)),r&&!this.disjoint;
}{const t=this.getQueryTimerExtensionWebGL1(),n=t.getQueryObjectEXT(e,t.QUERY_RESULT_AVAILABLE_EXT);return null==this.disjoint&&(this.disjoint=this.gl.getParameter(t.GPU_DISJOINT_EXT)),n&&!this.disjoint;}
}pollFence(e){
return new Promise((t=>{
this.addItemToPoll((()=>e.isFencePassed()),(()=>t()));
}));
}pollItems(){
const e=function(e){
let t=0;for(;t<e.length&&e[t]();++t){}return t-1;
}(this.itemsToPoll.map((e=>e.isDoneFn)));for(let t=0;t<=e;++t){
const{resolveFn:e}=this.itemsToPoll[t];e();
}this.itemsToPoll=this.itemsToPoll.slice(e+1);
}addItemToPoll(e,t){
if(this.itemsToPoll.push({isDoneFn:e,resolveFn:t}),this.itemsToPoll.length>1){
return;
}let n;"setTimeoutCustom"in H().platform&&(n=H().platform.setTimeoutCustom.bind(H().platform)),w((()=>(this.pollItems(),0===this.itemsToPoll.length)),(()=>0),null,n);
}bindTextureToFrameBuffer(e){
this.throwIfDisposed(),kN(this.gl,e,this.framebuffer),this.debug&&SN(this.gl);
}unbindTextureToFrameBuffer(){
null!=this.outputTexture?(kN(this.gl,this.outputTexture,this.framebuffer),this.debug&&SN(this.gl)):IN(this.gl,this.framebuffer);
}downloadMatrixDriver(e,t){
this.bindTextureToFrameBuffer(e);const n=t();return this.unbindTextureToFrameBuffer(),n;
}setOutputMatrixTextureDriver(e,t,n){
this.throwIfDisposed();const r=this.gl;kN(r,e,this.framebuffer),this.debug&&SN(r),this.outputTexture=e,fN(r,(()=>r.viewport(0,0,t,n))),fN(r,(()=>r.scissor(0,0,t,n)));
}setOutputMatrixWriteRegionDriver(e,t,n,r){
this.throwIfDisposed(),fN(this.gl,(()=>this.gl.scissor(e,t,n,r)));
}throwIfDisposed(){
if(this.disposed){
throw new Error("Attempted to use disposed GPGPUContext.");
}
}throwIfNoProgram(){
if(null==this.program){
throw new Error("No GPU program is currently set.");
}
}
}const{addImpl:w$,bincountImpl:v$,bincountReduceImpl:k$,bitwiseAndImpl:I$,castImpl:S$,ceilImpl:C$,concatImpl:N$,equalImpl:$$,expImpl:T$,expm1Impl:E$,floorImpl:R$,gatherNdImpl:A$,gatherV2Impl:F$,greaterImpl:_$,greaterEqualImpl:D$,lessImpl:O$,lessEqualImpl:M$,linSpaceImpl:L$,logImpl:z$,maxImpl:P$,maximumImpl:B$,minimumImpl:U$,multiplyImpl:W$,negImpl:V$,notEqualImpl:G$,prodImpl:j$,raggedGatherImpl:H$,raggedRangeImpl:q$,raggedTensorToTensorImpl:K$,rangeImpl:X$,rsqrtImpl:Y$,scatterImpl:Z$,sigmoidImpl:J$,simpleAbsImpl:Q$,sliceImpl:eT,sparseFillEmptyRowsImpl:tT,sparseReshapeImpl:nT,sparseSegmentReductionImpl:rT,sqrtImpl:sT,staticRegexReplaceImpl:iT,stridedSliceImpl:aT,stringNGramsImpl:oT,stringSplitImpl:uT,stringToHashBucketFastImpl:lT,subImpl:cT,tileImpl:hT,topKImpl:dT,transposeImpl:pT,uniqueImpl:fT}=r;function mT(e,t){
return["x","y","z","w","u","v"].slice(0,t).map((t=>`${e}.${t}`));
}function gT(e,t){
return 1===t?[e]:mT(e,t);
}class bT{
constructor(e){
if(this.variableNames=["A"],this.packedInputs=!1,this.packedOutput=!0,this.outputShape=e,this.rank=e.length,this.enableShapeUniforms=i$(this.outputShape.length),0===this.rank){
this.userCode="\n        void main() {\n          setOutput(vec4(getA(), 0., 0., 0.));\n        }\n      ";
}else{
const e=gT("rc",this.rank),t=QN(this.rank),n=this.getOutOfBoundsCondition(e),r=this.getSetup(e),s=this.getOutput(e);this.userCode=`\n        void main() {\n          ${t} rc = getOutputCoords();\n\n          if(${n}) {\n            setOutput(vec4(0));\n          } else {\n            ${r}\n\n            setOutput(vec4(${s}));\n          }\n        }\n      `;
}
}getSourceCoordsArr(e){
const t=[];for(let n=0;n<=1;n++){
for(let r=0;r<=1;r++){
let s=`${0===n?"r":"rp1"}, ${0===r?"c":"cp1"}`;for(let t=2;t<this.rank;t++){
s=`${e[e.length-1-t]},`+s;
}t.push(s);
}
}return t;
}getOutOfBoundsCondition(e){
if(1===this.rank){
return`rc > ${this.enableShapeUniforms?"outShape":this.outputShape[0]}`;
}let t="";for(let n=this.rank-2;n<this.rank;n++){
t+=`${e[n]} >= ${this.enableShapeUniforms?`outShape[${n}]`:this.outputShape[n]}`,n<this.rank-1&&(t+="||");
}return t;
}getSetup(e){
if(1===this.rank){
return"";
}const t=e.slice(-2),n=this.enableShapeUniforms?`outShape[${this.rank} - 1]`:this.outputShape[this.rank-1],r=this.enableShapeUniforms?`outShape[${this.rank} - 2]`:this.outputShape[this.rank-2];return`\n      int r = ${t[0]};\n      int c = ${t[1]};\n      int rp1 = r + 1;\n      int cp1 = c + 1;\n\n      bool cEdge = cp1 >= ${n};\n      bool rEdge = rp1 >= ${r};\n    `;
}getOutput(e){
const t=this.getSourceCoordsArr(e);return 1===this.rank?`getA(rc), (rc + 1 >= ${this.enableShapeUniforms?"outShape":this.outputShape[0]} ? 0. : getA(rc + 1)), 0, 0`:`getA(${t[0]}),\n            cEdge ? 0. : getA(${t[1]}),\n            rEdge ? 0. : getA(${t[2]}),\n            rEdge || cEdge ? 0. : getA(${t[3]})`;
}
}class xT{
constructor(e,t){
this.variableNames=["A"],this.packedInputs=!0,this.packedOutput=!0,this.customUniforms=[{name:"inputShape",type:"ivec3"}],this.outputShape=e,this.enableShapeUniforms=i$(this.outputShape.length);let n="";for(let e=0;e<4;e++){
let t="thisRC = rc;";e%2==1&&(t+="thisRC.z += 1;"),e>1&&(t+="thisRC.y += 1;"),n+=`\n        ${t}\n        ${e>0?"if(thisRC.y < rows && thisRC.z < cols){":""}\n          int flatIndex = getFlatIndex(thisRC);\n\n          ivec3 inputRC = inputCoordsFromReshapedOutCoords(flatIndex);\n          vec2 inputRCInnerDims = vec2(float(inputRC.y),float(inputRC.z));\n\n          result[${e}] =\n            getChannel(getA(inputRC.x, inputRC.y, inputRC.z), inputRCInnerDims);\n        ${e>0?"}":""}\n      `;
}var r,s;this.userCode=`\n      ${r=t,s=this.enableShapeUniforms,`\n    ivec3 inputCoordsFromReshapedOutCoords(int index) {\n      ${s?function(e,t,n="index"){
const r=function(e,t){
const n=e.length,r=e.map((e=>`${t}[${e}]`)),s=new Array(n-1);s[n-2]=r[n-1];for(let e=n-3;e>=0;--e){
s[e]=`(${s[e+1]} * ${r[e+1]})`;
}return s;
}(e.map(((e,t)=>t)),t);return r.map(((t,s)=>`int ${e[s]} = ${n} / ${r[s]}; ${s===r.length-1?`int ${e[s+1]} = ${n} - ${e[s]} * ${r[s]}`:`index -= ${e[s]} * ${r[s]}`};`)).join("");
}(["r","c","d"],"inputShape"):PN(["r","c","d"],r)}\n      return ivec3(r, c, d);\n    }\n  `}\n      ${this.enableShapeUniforms?"\n  int getFlatIndex(ivec3 coords) {\n    return coords.x * outShapeStrides[0] + coords.y * outShapeStrides[1] + coords.z;\n  }\n":UN(e)}\n\n      void main() {\n        ivec3 rc = getOutputCoords();\n\n        vec4 result = vec4(0.);\n\n        ivec3 thisRC;\n        int rows = ${this.enableShapeUniforms?"outShape[1]":e[1]};\n        int cols = ${this.enableShapeUniforms?"outShape[2]":e[2]};\n\n        ${n}\n\n        setOutput(result);\n      }\n    `;
}
}class yT{
constructor(e){
this.gpgpu=e,this.numUsedTextures=0,this.numFreeTextures=0,this._numBytesAllocated=0,this._numBytesFree=0,this.freeTextures={},this.usedTextures={},this.logEnabled=!1;
}acquireTexture(e,t,n){
const r=vT(t,n),s=kT(e,r,n);s in this.freeTextures||(this.freeTextures[s]=[]),s in this.usedTextures||(this.usedTextures[s]=[]);const i=wT(e,r,this.gpgpu.gl,this.gpgpu.textureConfig,n);if(this.freeTextures[s].length>0){
this.numFreeTextures--,this.numUsedTextures++,this._numBytesFree-=i,this.log();const e=this.freeTextures[s].pop();return this.usedTextures[s].push(e),e;
}let a;return r===lN.PACKED_2X2_FLOAT32?a=this.gpgpu.createPackedMatrixTexture(e[0],e[1]):r===lN.PACKED_2X2_FLOAT16?a=this.gpgpu.createFloat16PackedMatrixTexture(e[0],e[1]):r===lN.UNPACKED_FLOAT32?a=this.gpgpu.createFloat32MatrixTexture(e[0],e[1]):r===lN.UNPACKED_FLOAT16?a=this.gpgpu.createFloat16MatrixTexture(e[0],e[1]):r===lN.PACKED_4X1_UNSIGNED_BYTE&&(a=this.gpgpu.createUnsignedBytesMatrixTexture(e[0],e[1])),this.usedTextures[s].push(a),this.numUsedTextures++,this._numBytesAllocated+=i,this.log(),a;
}releaseTexture(e,t,n,r){
if(null==this.freeTextures){
return;
}const s=vT(n,r),i=kT(t,s,r);i in this.freeTextures||(this.freeTextures[i]=[]);const a=wT(t,s,this.gpgpu.gl,this.gpgpu.textureConfig,r),o=H().getNumber("WEBGL_DELETE_TEXTURE_THRESHOLD");-1!==o&&this._numBytesAllocated>o?(this.gpgpu.deleteMatrixTexture(e.texture),this._numBytesAllocated-=a):(this.freeTextures[i].push(e),this.numFreeTextures++,this._numBytesFree+=a),this.numUsedTextures--;const u=this.usedTextures[i],l=u&&u.indexOf(e);if(null==l||l<0){
throw new Error("Cannot release a texture that was never provided by this texture manager");
}u[l]=u[u.length-1],u.pop(),this.log();
}log(){
if(!this.logEnabled){
return;
}const e=this.numFreeTextures+this.numUsedTextures;console.log("Free/Used",`${this.numFreeTextures} / ${this.numUsedTextures}`,`(${e})`);const t=this._numBytesFree/this._numBytesAllocated;console.log(`Bytes allocated: ${this._numBytesAllocated}`),console.log(`Bytes unused: ${this._numBytesFree} (${Math.round(100*t)}%)`);
}get numBytesAllocated(){
return this._numBytesAllocated;
}get numBytesFree(){
return this._numBytesFree;
}getNumUsedTextures(){
return this.numUsedTextures;
}getNumFreeTextures(){
return this.numFreeTextures;
}dispose(){
if(null!=this.freeTextures){
for(const e in this.freeTextures){
this.freeTextures[e].forEach((e=>{
this.gpgpu.deleteMatrixTexture(e.texture);
}));
}for(const e in this.usedTextures){
this.usedTextures[e].forEach((e=>{
this.gpgpu.deleteMatrixTexture(e.texture);
}));
}this.freeTextures=null,this.usedTextures=null,this.numUsedTextures=0,this.numFreeTextures=0,this._numBytesAllocated=0,this._numBytesFree=0;
}
}
}function wT(e,t,n,r,s){
const i=function(e,t){
switch(e){
case lN.PACKED_2X2_FLOAT32:return b$(t);case lN.PACKED_2X2_FLOAT16:return x$(t);case lN.UNPACKED_FLOAT32:return f$(t);case lN.UNPACKED_FLOAT16:return m$(t);case lN.PACKED_4X1_UNSIGNED_BYTE:return g$(t);default:throw new Error(`Unknown physical texture type ${e}`);
}
}(t,r);let a;if(s){
const[t,n]=dN(e[0],e[1]);a=t*n;
}else{
const[t,n]=cN(e[0],e[1]);a=t*n;
}const o=function(e,t){
const n=e;if(t===n.R32F){
return 4;
}if(t===n.R16F){
return 2;
}if(t===n.RGBA32F){
return 16;
}if(t===e.RGBA){
return 16;
}if(t===n.RGBA16F){
return 8;
}if(t===n.RGBA8){
return 4;
}throw new Error(`Unknown internal format ${t}`);
}(n,i);return a*o;
}function vT(e,t){
if(e===uN.UPLOAD){
return lN.PACKED_2X2_FLOAT32;
}if(e===uN.RENDER||null==e){
return function(e){
return H().getBool("WEBGL_RENDER_FLOAT32_ENABLED")?e?lN.PACKED_2X2_FLOAT32:lN.UNPACKED_FLOAT32:e?lN.PACKED_2X2_FLOAT16:lN.UNPACKED_FLOAT16;
}(t);
}if(e===uN.DOWNLOAD||e===uN.PIXELS){
return lN.PACKED_4X1_UNSIGNED_BYTE;
}throw new Error(`Unknown logical texture type ${e}`);
}function kT(e,t,n){
return`${e[0]}_${e[1]}_${t}_${n}`;
}class IT{
constructor(e,t){
this.variableNames=["A"],this.outputShape=e,this.enableShapeUniforms=i$(this.outputShape.length),this.userCode=`\n      float unaryOperation(float x) {\n        ${t}\n      }\n\n      void main() {\n        float x = getAAtOutCoords();\n        float y = unaryOperation(x);\n\n        setOutput(y);\n      }\n    `;
}
}const ST="if (isnan(x)) return x;",CT="return x;",NT="return abs(x);",$T="return (x >= 0.0) ? x : (exp(x) - 1.0);",TT=ST+"\n  return (x < 0.0) ? 0.0 : x;\n",ET=ST+"\n  return (x < 0.0) ? 0.0 : min(6.0, x);\n",RT="return x;",AT="return 1.0 / (1.0 + exp(-1.0 * x));",FT="return x;",_T="\n  vec4 result;\n\n  result.r = (x.r >= 0.0) ? x.r : (exp(x.r) - 1.0);\n  result.g = (x.g >= 0.0) ? x.g : (exp(x.g) - 1.0);\n  result.b = (x.b >= 0.0) ? x.b : (exp(x.b) - 1.0);\n  result.a = (x.a >= 0.0) ? x.a : (exp(x.a) - 1.0);\n\n  return result;\n",DT="\n  vec4 result = x * vec4(greaterThanEqual(x, vec4(0.0)));\n  bvec4 isNaN = isnan(x);\n\n  result.r = isNaN.r ? x.r : result.r;\n  result.g = isNaN.g ? x.g : result.g;\n  result.b = isNaN.b ? x.b : result.b;\n  result.a = isNaN.a ? x.a : result.a;\n\n  return result;\n",OT="\n  vec4 result = min(x, vec4(6.)) * vec4(greaterThanEqual(x, vec4(0.0)));\n  bvec4 isNaN = isnan(x);\n\n  result.r = isNaN.r ? x.r : result.r;\n  result.g = isNaN.g ? x.g : result.g;\n  result.b = isNaN.b ? x.b : result.b;\n  result.a = isNaN.a ? x.a : result.a;\n\n  return result;\n",MT="return 1.0 / (1.0 + exp(-1.0 * x));";class LT{
constructor(e,t){
this.variableNames=["A"],this.packedInputs=!0,this.packedOutput=!0,this.outputShape=e,this.enableShapeUniforms=i$(this.outputShape.length),this.userCode=`\n      vec4 unaryOperation(vec4 x) {\n        ${t}\n      }\n\n      void main() {\n        vec4 x = getAAtOutCoords();\n        vec4 y = unaryOperation(x);\n\n        setOutput(y);\n      }\n    `;
}
}class zT{
constructor(e){
this.variableNames=["A"],this.packedInputs=!0,this.packedOutput=!1,this.outputShape=e,this.enableShapeUniforms=i$(this.outputShape.length);const t=e.length,n=gT("rc",t),r=QN(t),s=function(e,t){
if(1===e){
return"rc";
}let n="";for(let r=0;r<e;r++){
n+=t[r],r<e-1&&(n+=",");
}return n;
}(t,n),i=n.slice(-2),a=t<=1?"rc":`vec2(${i.join(",")})`;this.userCode=`\n      void main() {\n        ${r} rc = getOutputCoords();\n        vec4 packedInput = getA(${s});\n\n        setOutput(getChannel(packedInput, ${a}));\n      }\n    `;
}
}const PT=Uc,BT={},UT=H().getNumber("CPU_HANDOFF_SIZE_THRESHOLD");class WT extends a{
nextDataId(){
return WT.nextDataId++;
}constructor(e){
if(super(),this.pendingRead=new WeakMap,this.pendingDisposal=new WeakSet,this.dataRefCount=new WeakMap,this.numBytesInGPU=0,this.uploadWaitMs=0,this.downloadWaitMs=0,this.lastGlFlushTime=0,this.warnedAboutMemory=!1,this.pendingDeletes=0,this.disposed=!1,!H().getBool("HAS_WEBGL")){
throw new Error("WebGL is not supported on this device");
}let t;if(null!=e){
if(e instanceof y$){
t=e;
}else{
const n=aN(H().getNumber("WEBGL_VERSION"),e);t=new y$(n);
}this.binaryCache={},this.gpgpuCreatedLocally=!1;
}else{
const e=aN(H().getNumber("WEBGL_VERSION"));t=new y$(e),this.binaryCache=((n=H().getNumber("WEBGL_VERSION"))in BT||(BT[n]={}),BT[n]),this.gpgpuCreatedLocally=!0;
}var n;this.gpgpu=t,this.canvas=this.gpgpu.gl.canvas,this.textureManager=new yT(this.gpgpu),this.numMBBeforeWarning=null==H().global.screen?1024:H().global.screen.height*H().global.screen.width*window.devicePixelRatio*600/1024/1024,this.texData=new i(this,gi());
}numDataIds(){
return this.texData.numDataIds()-this.pendingDeletes;
}writeTexture(e,t,n,r,s,i){
const a=this.makeTensorInfo(t,n),o=this.texData.get(a.dataId);o.isPacked=!1,o.texture={texture:e,texShape:[r,s]},o.texShape=[r,s];const u=TN(t),l=new h$(u,!1,i),c=this.runWebGLProgram(l,[a],n,[[r,s]]);return c.shape=t,o.texture=null,this.disposeIntermediateTensorInfo(a),c.dataId;
}write(e,t,n){
if((H().getBool("WEBGL_CHECK_NUMERICAL_PROBLEMS")||H().getBool("DEBUG"))&&this.checkNumericalProblems(e),"complex64"===n&&null!=e){
throw new Error("Cannot write to a complex64 dtype. Please use tf.complex(real, imag).");
}const r={id:this.nextDataId()};return this.texData.set(r,{shape:t,dtype:n,values:e,usage:uN.UPLOAD,refCount:1}),r;
}refCount(e){
return this.texData.has(e)?this.texData.get(e).refCount:0;
}incRef(e){
this.texData.get(e).refCount++;
}decRef(e){
this.texData.has(e)&&this.texData.get(e).refCount--;
}move(e,t,n,r,s){
if(H().getBool("DEBUG")&&this.checkNumericalProblems(t),"complex64"===r){
throw new Error("Cannot write to a complex64 dtype. Please use tf.complex(real, imag).");
}this.texData.set(e,{shape:n,dtype:r,values:t,usage:uN.UPLOAD,refCount:s});
}disposeIntermediateTensorInfo(e){
this.disposeData(e.dataId);
}readSync(e){
const t=this.texData.get(e),{values:n,dtype:r,complexTensorInfos:s,slice:i,shape:a,isPacked:o}=t;if(null!=i){
let t;t=o?new LT(a,RT):new IT(a,RT);const n=this.runWebGLProgram(t,[{dataId:e,shape:a,dtype:r}],r),s=this.readSync(n.dataId);return this.disposeIntermediateTensorInfo(n),s;
}if(null!=n){
return this.convertAndCacheOnCPU(e);
}if("string"===r){
return n;
}const u=null!=this.activeTimers;let l,c;return u&&(l=Dr()),c="complex64"===r?ic(this.readSync(s.real.dataId),this.readSync(s.imag.dataId)):this.getValuesFromTexture(e),u&&(this.downloadWaitMs+=Dr()-l),this.convertAndCacheOnCPU(e,c);
}async read(e){
if(this.pendingRead.has(e)){
const t=this.pendingRead.get(e);return new Promise((e=>t.push(e)));
}const t=this.texData.get(e),{values:n,shape:r,slice:s,dtype:i,complexTensorInfos:a,isPacked:o}=t;if(null!=s){
let t;t=o?new LT(r,RT):new IT(r,RT);const n=this.runWebGLProgram(t,[{dataId:e,shape:r,dtype:i}],i),s=this.read(n.dataId);return this.disposeIntermediateTensorInfo(n),s;
}if(null!=n){
return this.convertAndCacheOnCPU(e);
}if(H().getBool("DEBUG")&&!H().getBool("WEBGL_DOWNLOAD_FLOAT_ENABLED")&&2===H().getNumber("WEBGL_VERSION")){
throw new Error("tensor.data() with WEBGL_DOWNLOAD_FLOAT_ENABLED=false and WEBGL_VERSION=2 not yet supported.");
}let u,l,c=null;if("complex64"!==i&&H().get("WEBGL_BUFFER_SUPPORTED")){
u=this.decode(e);const t=this.texData.get(u.dataId);c=this.gpgpu.createBufferFromTexture(t.texture.texture,...hN(r));
}if(this.pendingRead.set(e,[]),"complex64"!==i&&await this.gpgpu.createAndWaitForFence(),"complex64"===i){
const e=await Promise.all([this.read(a.real.dataId),this.read(a.imag.dataId)]);l=ic(e[0],e[1]);
}else if(null==c){
l=this.getValuesFromTexture(e);
}else{
const e=m(r);l=this.gpgpu.downloadFloat32MatrixFromBuffer(c,e);
}if(null!=u&&this.disposeIntermediateTensorInfo(u),null!=c){
const e=this.gpgpu.gl;fN(e,(()=>e.deleteBuffer(c)));
}const h=this.convertAndCacheOnCPU(e,l),d=this.pendingRead.get(e);return this.pendingRead.delete(e),d.forEach((e=>e(h))),this.pendingDisposal.has(e)&&(this.pendingDisposal.delete(e),this.disposeData(e)&&gi().removeDataId(e,this),this.pendingDeletes--),h;
}readToGPU(e,t={}){
const n=this.texData.get(e),{values:r,shape:s,slice:i,dtype:a,isPacked:o,texture:u}=n;if("complex64"===a){
throw new Error("Does not support reading texture for complex64 dtype.");
}if(null!=i){
let n;n=o?new LT(s,RT):new IT(s,RT);const r=this.runWebGLProgram(n,[{dataId:e,shape:s,dtype:a}],a),i=this.readToGPU(r,t);return this.disposeIntermediateTensorInfo(r),i;
}if(null==u){
throw null!=r?new Error("Data is not on GPU but on CPU."):new Error("There is no data on GPU or CPU.");
}const l=this.decode(e,t.customTexShape),c=gi().makeTensorFromTensorInfo(l),h=this.texData.get(l.dataId);return Object.assign({tensorRef:c},h.texture);
}bufferSync(e){
const t=this.readSync(e.dataId);if("string"===e.dtype){
try{
const n=t.map((e=>Mr(e)));return pi(e.shape,e.dtype,n);
}catch(e){
throw new Error("Failed to decode encoded string bytes into utf-8");
}
}return pi(e.shape,e.dtype,t);
}checkNumericalProblems(e){
if(null!=e){
for(let t=0;t<e.length;t++){
const n=e[t];if(!mN(n)){
if(H().getBool("WEBGL_RENDER_FLOAT32_CAPABLE")){
throw Error(`The value ${n} cannot be represented with your current settings. Consider enabling float32 rendering: 'tf.env().set('WEBGL_RENDER_FLOAT32_ENABLED', true);'`);
}throw Error(`The value ${n} cannot be represented on this device.`);
}
}
}
}getValuesFromTexture(e){
const{shape:t,dtype:n,isPacked:r}=this.texData.get(e),s=m(t);if(H().getBool("WEBGL_DOWNLOAD_FLOAT_ENABLED")){
const n=this.decode(e),r=this.texData.get(n.dataId),i=this.gpgpu.downloadMatrixFromPackedTexture(r.texture.texture,...hN(t)).subarray(0,s);return this.disposeIntermediateTensorInfo(n),i;
}const i=H().getBool("WEBGL_PACK")&&!0===r,a=i?TN(t):t,o=i?new l$(a):new u$(a),u=this.runWebGLProgram(o,[{shape:a,dtype:n,dataId:e}],"float32"),l=this.texData.get(u.dataId),c=this.gpgpu.downloadByteEncodedFloatMatrixFromOutputTexture(l.texture.texture,l.texShape[0],l.texShape[1]).subarray(0,s);return this.disposeIntermediateTensorInfo(u),c;
}timerAvailable(){
return H().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE")>0;
}time(e){
const t=this.activeTimers,n=[];let r=!1;null==this.programTimersStack?(this.programTimersStack=n,r=!0):this.activeTimers.push(n),this.activeTimers=n,e();const s=zr(this.activeTimers.map((e=>e.query))).filter((e=>null!=e)),i=zr(this.activeTimers.map((e=>e.name))).filter((e=>null!=e));this.activeTimers=t,r&&(this.programTimersStack=null);const a={uploadWaitMs:this.uploadWaitMs,downloadWaitMs:this.downloadWaitMs,kernelMs:null,wallMs:null};return(async()=>{
if(H().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE")>0){
const e=await Promise.all(s);a.kernelMs=function(e){
let t=0;for(let n=0;n<e.length;n++){
t+=e[n];
}return t;
}(e),a.getExtraProfileInfo=()=>e.map(((e,t)=>({name:i[t],ms:e}))).map((e=>`${e.name}: ${e.ms}`)).join(", ");
}else {
a.kernelMs={error:"WebGL query timers are not supported in this environment."};
}return this.uploadWaitMs=0,this.downloadWaitMs=0,a;
})();
}memory(){
return{unreliable:!1,numBytesInGPU:this.numBytesInGPU,numBytesInGPUAllocated:this.textureManager.numBytesAllocated,numBytesInGPUFree:this.textureManager.numBytesFree};
}startTimer(){
return H().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE")>0?this.gpgpu.beginQuery():{startMs:Dr(),endMs:null};
}endTimer(e){
return H().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE")>0?(this.gpgpu.endQuery(),e):(e.endMs=Dr(),e);
}async getQueryTime(e){
if(H().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE")>0){
return this.gpgpu.waitForQueryAndGetTime(e);
}const t=e;return t.endMs-t.startMs;
}disposeData(e,t=!1){
if(this.pendingDisposal.has(e)){
return!1;
}if(!this.texData.has(e)){
return!0;
}if(t?this.texData.get(e).refCount=0:this.texData.get(e).refCount--,!t&&this.texData.get(e).refCount>0){
return!1;
}if(this.pendingRead.has(e)){
return this.pendingDisposal.add(e),this.pendingDeletes++,!1;
}this.releaseGPUData(e);const{complexTensorInfos:n}=this.texData.get(e);return null!=n&&(this.disposeData(n.real.dataId,t),this.disposeData(n.imag.dataId,t)),this.texData.delete(e),!0;
}releaseGPUData(e){
const{texture:t,dtype:n,texShape:r,usage:s,isPacked:i,slice:a}=this.texData.get(e),o=a&&a.origDataId||e,u=this.dataRefCount.get(o);u>1?this.dataRefCount.set(o,u-1):(this.dataRefCount.delete(o),null!=t&&(this.numBytesInGPU-=this.computeBytes(r,n),this.textureManager.releaseTexture(t,r,s,i)));const l=this.texData.get(e);l.texture=null,l.texShape=null,l.isPacked=!1,l.slice=null;
}getTexture(e){
return this.uploadToGPU(e),this.texData.get(e).texture.texture;
}getDataInfo(e){
return this.texData.get(e);
}shouldExecuteOnCPU(e,t=UT){
return H().getBool("WEBGL_CPU_FORWARD")&&e.every((e=>null==this.texData.get(e.dataId).texture&&m(e.shape)<t));
}getGPGPUContext(){
return this.gpgpu;
}where(e){
or("tf.where() in webgl locks the UI thread. Call tf.whereAsync() instead");const t=e.dataSync();return PT(e.shape,t);
}packedUnaryOp(e,t,n){
const r=new LT(e.shape,t),s=this.compileAndRun(r,[e],n);return gi().makeTensorFromTensorInfo(s);
}abs(e){
if(this.shouldExecuteOnCPU([e])&&"complex64"!==e.dtype){
const t=Q$(this.texData.get(e.dataId).values);return this.makeOutput(e.shape,e.dtype,t);
}if(H().getBool("WEBGL_PACK_UNARY_OPERATIONS")){
return this.packedUnaryOp(e,NT,e.dtype);
}const t=new IT(e.shape,NT),n=this.compileAndRun(t,[e]);return gi().makeTensorFromTensorInfo(n);
}makeTensorInfo(e,t,n){
let r;if("string"===t&&null!=n&&n.length>0&&T(n[0])){
const s=n.map((e=>Or(e)));r=this.write(s,e,t);
}else {
r=this.write(n,e,t);
}return this.texData.get(r).usage=null,{dataId:r,shape:e,dtype:t};
}makeOutput(e,t,n){
return gi().makeTensorFromTensorInfo(this.makeTensorInfo(e,t,n),this);
}unpackTensor(e){
const t=new zT(e.shape);return this.runWebGLProgram(t,[e],e.dtype);
}packTensor(e){
const t=new bT(e.shape);return this.runWebGLProgram(t,[e],e.dtype,null,!0);
}packedReshape(e,t){
const n=[NN(e.shape),...$N(e.shape)],r={dtype:e.dtype,shape:n,dataId:e.dataId},s=[NN(t),...$N(t)],i=new xT(s,n),a=[n],o=this.runWebGLProgram(i,[r],e.dtype,a,!0);return{dataId:o.dataId,shape:t,dtype:o.dtype};
}decode(e,t){
const n=this.texData.get(e),{isPacked:r,shape:s,dtype:i}=n;null!=t&&d(m(s)<=t[0]*t[1]*4,(()=>"customTexShape is too small. Row * Column * 4 should be equal or larger than the size of the tensor data."));const a=TN(s);let o;o=r?new o$(a):new a$(a);const u=[null!=t?t:hN(a)];return{dtype:i,shape:s,dataId:this.runWebGLProgram(o,[{shape:a,dtype:i,dataId:e}],i,u,!0,t).dataId};
}runWebGLProgram(e,t,n,r,s=!1,i){
const a=this.makeTensorInfo(e.outputShape,n),o=this.texData.get(a.dataId);if(e.packedOutput&&(o.isPacked=!0),e.outPackingScheme===oN.DENSE){
const t=null!=i?i:hN(e.outputShape);o.texShape=t.map((e=>2*e));
}if(null!=e.outTexUsage&&(o.usage=e.outTexUsage),0===m(a.shape)){
return o.values=S(a.dtype,0),a;
}const u=[],l=t.map((t=>{
if("complex64"===t.dtype){
throw new Error("GPGPUProgram does not support complex64 input. For complex64 dtypes, please separate the program into real and imaginary parts.");
}let n=this.texData.get(t.dataId);if(null==n.texture){
if(!e.packedInputs&&m(t.shape)<=H().getNumber("WEBGL_SIZE_UPLOAD_UNIFORM")){
return{shape:t.shape,texData:null,isUniform:!0,uniformValues:n.values};
}e.packedInputs&&(n.isPacked=!0,n.shape=t.shape);
}if(this.uploadToGPU(t.dataId),!!n.isPacked!=!!e.packedInputs){
t=n.isPacked?this.unpackTensor(t):this.packTensor(t),u.push(t),n=this.texData.get(t.dataId);
}else if(n.isPacked&&!RN(n.shape,t.shape)){
const e=t,r=t.shape;t.shape=n.shape,t=this.packedReshape(t,r),u.push(t),n=this.texData.get(t.dataId),e.shape=r;
}return{shape:t.shape,texData:n,isUniform:!1};
}));this.uploadToGPU(a.dataId);const c={shape:a.shape,texData:o,isUniform:!1},h=function(e,t,n){
let r="";t.concat(n).forEach((t=>{
const s=null!=t.texData&&null!=t.texData.slice&&t.texData.slice.flatOffset>0;if(e.enableShapeUniforms&&!t.isUniform){
const i=t.texData.texShape,{useSqueezeShape:a,uniformShape:o,keptDims:u}=e$(e.packedInputs,t.shape,i);let l="",c="",h="";if(1===o.length&&e.packedInputs){
const e=[Math.ceil(i[0]/2),Math.ceil(i[1]/2)];l=`${e[0]>1}_${e[1]>1}`;
}else if(2!==o.length||e.packedInputs){
if(o.length>2&&!e.packedInputs){
const e=_(o);h=`${e[0]===i[1]}_${e[e.length-1]===i[1]}`;
}
}else {
c=`${o[0]>1}_${o[1]>1}`;
}const d=t.shape.length,p=2===o.length&&g(t.shape,i),f=1===m(t.shape),b=Gi(t.shape,n.shape),x=!e.packedInputs&&d===n.shape.length&&g(i,n.texData.texShape),y=e.packedInputs||o.length>2?"":`${i[0]>1}_${i[1]>1}`;r+=`${d}_${x}_${a?u:""}_${o.length}_${f}_${b}_${p}_${l}_${c}_${h}_${y}_${s}`;
}else{
const e=t.isUniform?"uniform":t.texData.texShape;r+=`${t.shape}_${e}_${s}`;
}
}));const s=e.userCode;let i=e.constructor.name;return i+="_"+r+"_"+s+`${H().getNumber("WEBGL_VERSION")}`,i;
}(e,l,c),d=this.getAndSaveBinary(h,(()=>function(e,t,n,r){
const s=n.map(((e,n)=>{
const r={logicalShape:e.shape,texShape:e.isUniform?null:e.texData.texShape,isUniform:e.isUniform,isPacked:!e.isUniform&&e.texData.isPacked,flatOffset:null};return null!=e.texData&&null!=e.texData.slice&&e.texData.slice.flatOffset>0&&(r.flatOffset=e.texData.slice.flatOffset),{name:t.variableNames[n],shapeInfo:r};
})),i=s.map((e=>e.shapeInfo)),a={logicalShape:r.shape,texShape:r.texData.texShape,isUniform:!1,isPacked:r.texData.isPacked,flatOffset:null},o=GN(s,a,t),u=function(e,t){
const n=CN(e,(()=>e.createShader(e.FRAGMENT_SHADER)),"Unable to create fragment WebGLShader.");if(fN(e,(()=>e.shaderSource(n,t))),fN(e,(()=>e.compileShader(n))),H().get("ENGINE_COMPILE_ONLY")){
return n;
}if(!1===e.getShaderParameter(n,e.COMPILE_STATUS)){
throw xN(t,e.getShaderInfoLog(n)),new Error("Failed to compile fragment shader.");
}return n;
}(e.gl,o),l=e.createProgram(u);return H().get("ENGINE_COMPILE_ONLY")?{program:t,fragmentShader:u,source:o,webGLProgram:l,inShapeInfos:i,outShapeInfo:a,variablesLocations:null,customUniformLocations:null,infLoc:null,nanLoc:null,outShapeLocation:null,outShapeStridesLocation:null,outTexShapeLocation:null}:(e.buildVao(l),Object.assign({program:t,fragmentShader:u,source:o,webGLProgram:l,inShapeInfos:i,outShapeInfo:a},r$(e,t,l)));
}(this.gpgpu,e,l,c))),p=null!=this.activeTimers;let f;p&&(f=this.startTimer()),H().get("ENGINE_COMPILE_ONLY")||function(e,t,n,r,s){
t.program.enableShapeUniforms||(s$(t.inShapeInfos,n),s$([t.outShapeInfo],[r]));const i=r.texData.texture,a=r.texData.texShape;r.texData.isPacked?e.setOutputPackedMatrixTexture(i.texture,a[0],a[1]):e.setOutputMatrixTexture(i.texture,a[0],a[1]),e.setProgram(t.webGLProgram),e.bindVertexArray(t.webGLProgram.vao),1===H().getNumber("WEBGL_VERSION")&&null!==t.infLoc&&e.gl.uniform1f(t.infLoc,1/0),null!==t.nanLoc&&e.gl.uniform1f(t.nanLoc,NaN);for(let r=0;r<n.length;++r){
const s=n[r],{uniform:i,offset:a,shape:o,texShape:u}=t.variablesLocations[r];if(o){
const{uniformShape:n}=e$(t.program.packedInputs,s.shape,s.texData.texShape);switch(n.length){
case 1:e.gl.uniform1iv(o,new Int32Array(n));break;case 2:e.gl.uniform2iv(o,new Int32Array(n));break;case 3:e.gl.uniform3iv(o,new Int32Array(n));break;case 4:e.gl.uniform4iv(o,new Int32Array(n));
}
}if(u&&e.gl.uniform2i(u,s.texData.texShape[0],s.texData.texShape[1]),null!=i){
if(s.isUniform){
if(m(s.shape)<2){
e.gl.uniform1f(i,s.uniformValues[0]);
}else{
let t=s.uniformValues;t instanceof Float32Array||(t=new Float32Array(t)),e.gl.uniform1fv(i,t);
}
}else {
null!=s.texData.slice&&null!=a&&e.gl.uniform1i(a,s.texData.slice.flatOffset),e.setInputMatrixTexture(s.texData.texture.texture,i,r);
}
}
}const o=t.outShapeLocation;if(o){
switch(r.shape.length){
case 1:e.gl.uniform1iv(o,new Int32Array(r.shape));break;case 2:e.gl.uniform2iv(o,new Int32Array(r.shape));break;case 3:e.gl.uniform3iv(o,new Int32Array(r.shape));break;case 4:e.gl.uniform4iv(o,new Int32Array(r.shape));
}
}if(t.outShapeStridesLocation){
const n=_(r.shape);switch(r.shape.length){
case 2:e.gl.uniform1iv(t.outShapeStridesLocation,new Int32Array(n));break;case 3:e.gl.uniform2iv(t.outShapeStridesLocation,new Int32Array(n));break;case 4:e.gl.uniform3iv(t.outShapeStridesLocation,new Int32Array(n));
}
}if(t.outTexShapeLocation&&e.gl.uniform2i(t.outTexShapeLocation,r.texData.texShape[0],r.texData.texShape[1]),t.program.customUniforms&&s){
for(let n=0;n<t.program.customUniforms.length;++n){
const r=t.program.customUniforms[n],i=t.customUniformLocations[n],a=s[n];if("float"===r.type){
e.gl.uniform1fv(i,a);
}else if("vec2"===r.type){
e.gl.uniform2fv(i,a);
}else if("vec3"===r.type){
e.gl.uniform3fv(i,a);
}else if("vec4"===r.type){
e.gl.uniform4fv(i,a);
}else if("int"===r.type){
e.gl.uniform1iv(i,a);
}else if("ivec2"===r.type){
e.gl.uniform2iv(i,a);
}else if("ivec3"===r.type){
e.gl.uniform3iv(i,a);
}else{
if("ivec4"!==r.type){
throw Error(`uniform type ${r.type} is not supported yet.`);
}e.gl.uniform4iv(i,a);
}
}
}e.executeProgram();
}(this.gpgpu,d,l,c,r),u.forEach((e=>this.disposeIntermediateTensorInfo(e))),p&&(f=this.endTimer(f),this.activeTimers.push({name:e.constructor.name,query:this.getQueryTime(f)}));const b=H().getNumber("WEBGL_FLUSH_THRESHOLD");if(b>0){
const e=Dr();e-this.lastGlFlushTime>b&&(this.gpgpu.gl.flush(),this.lastGlFlushTime=e);
}if(!H().getBool("WEBGL_LAZILY_UNPACK")&&o.isPacked&&!1===s){
const e=this.unpackTensor(a);return this.disposeIntermediateTensorInfo(a),e;
}return a;
}compileAndRun(e,t,n,r,s=!1){
return n=n||t[0].dtype,this.runWebGLProgram(e,t,n,r,s);
}getAndSaveBinary(e,t){
return e in this.binaryCache||(this.binaryCache[e]=t()),this.binaryCache[e];
}getTextureManager(){
return this.textureManager;
}dispose(){
this.disposed||(H().getBool("IS_TEST")||Object.keys(this.binaryCache).forEach((e=>{
this.gpgpu.deleteProgram(this.binaryCache[e].webGLProgram),delete this.binaryCache[e];
})),this.textureManager.dispose(),null!=this.canvas&&"undefined"!=typeof HTMLCanvasElement&&this.canvas instanceof HTMLCanvasElement?this.canvas.remove():this.canvas=null,this.gpgpuCreatedLocally&&(this.gpgpu.program=null,this.gpgpu.dispose()),this.disposed=!0);
}floatPrecision(){
return null==this.floatPrecisionValue&&(this.floatPrecisionValue=xi((()=>{
if(!H().get("WEBGL_RENDER_FLOAT32_ENABLED")){
const e=H().getBool("DEBUG");H().set("DEBUG",!1);const t=this.abs(Ri(1e-8)).dataSync()[0];if(H().set("DEBUG",e),t>0){
return 32;
}
}return 16;
}))),this.floatPrecisionValue;
}epsilon(){
return 32===this.floatPrecision()?1e-7:1e-4;
}uploadToGPU(e){
const t=this.texData.get(e),{shape:n,dtype:r,values:s,texture:i,usage:a,isPacked:o}=t;if(null!=i){
return;
}const u=null!=this.activeTimers;let l;u&&(l=Dr());let h=t.texShape;if(null==h&&(h=function(e,t=!1){
let n=H().getNumber("WEBGL_MAX_TEXTURE_SIZE"),r=H().getNumber("WEBGL_MAX_SIZE_FOR_NARROW_TEXTURE");if(r===1/0&&H().getBool("WEBGL_AUTO_SQUARIFY_NARROW_TEXTURE_SHAPE")&&(r=n/2),t&&(n*=2,r*=2,1===(e=e.map(((t,n)=>n>=e.length-2?c(e[n]):e[n]))).length&&(e=[2,e[0]])),2!==e.length){
const t=I(e);e=t.newShape;
}let s=m(e),i=null;e.length<=1&&s<=n?i=[1,s]:2===e.length&&e[0]<=n&&e[1]<=n?i=e:3===e.length&&e[0]*e[1]<=n&&e[2]<=n?i=[e[0]*e[1],e[2]]:3===e.length&&e[0]<=n&&e[1]*e[2]<=n?i=[e[0],e[1]*e[2]]:4===e.length&&e[0]*e[1]*e[2]<=n&&e[3]<=n?i=[e[0]*e[1]*e[2],e[3]]:4===e.length&&e[0]<=n&&e[1]*e[2]*e[3]<=n&&(i=[e[0],e[1]*e[2]*e[3]]);const a=null!=i&&Math.max(...i)>r&&Math.min(...i)<=(t?2:1)&&Math.min(...i)>0;if(null==i||a){
if(t){
const t=NN(e);let n=2,r=2;e.length&&([n,r]=$N(e)),s=t*(n/2)*(r/2),i=x(s).map((e=>2*e));
}else {
i=x(s);
}
}return i;
}(n,o),t.texShape=h),null!=s){
const e=TN(n);let i,a=h[1],c=h[0];const d=s instanceof Uint8Array||s instanceof Uint8ClampedArray;!o&&d||([a,c]=dN(h[0],h[1])),i=o?new d$(e,d):new h$(e,d);const p=d?[c,a]:h,f=this.makeTensorInfo(p,r),m=this.texData.get(f.dataId);m.usage=d?uN.PIXELS:uN.UPLOAD,m.texShape=p,this.gpgpu.uploadDenseMatrixToTexture(this.getTexture(f.dataId),a,c,s);const g=[[c,a]],b=!0,x=this.runWebGLProgram(i,[f],r,g,b),y=this.texData.get(x.dataId);t.texShape=y.texShape,t.isPacked=y.isPacked,t.usage=y.usage,H().get("ENGINE_COMPILE_ONLY")?this.disposeData(x.dataId):(t.texture=y.texture,t.values=null,this.texData.delete(x.dataId)),this.disposeIntermediateTensorInfo(f),u&&(this.uploadWaitMs+=Dr()-l);
}else{
const e=this.acquireTexture(h,a,r,o);t.texture=e;
}
}convertAndCacheOnCPU(e,t){
const n=this.texData.get(e),{dtype:r}=n;return null!=t&&(n.values=function(e,t){
if("float32"===t||"complex64"===t){
return e;
}if("int32"===t||"bool"===t){
const n="int32"===t?new Int32Array(e.length):new Uint8Array(e.length);for(let t=0;t<n.length;++t){
n[t]=Math.round(e[t]);
}return n;
}throw new Error(`Unknown dtype ${t}`);
}(t,r)),n.values;
}acquireTexture(e,t,n,r){
if(this.numBytesInGPU+=this.computeBytes(e,n),!this.warnedAboutMemory&&this.numBytesInGPU>1024*this.numMBBeforeWarning*1024){
const e=(this.numBytesInGPU/1024/1024).toFixed(2);this.warnedAboutMemory=!0,console.warn(`High memory usage in GPU: ${e} MB, most likely due to a memory leak`);
}return this.textureManager.acquireTexture(e,t,r);
}computeBytes(e,t){
return e[0]*e[1]*$(t);
}checkCompileCompletion(){
for(const[,e]of Object.entries(this.binaryCache)){
this.checkCompletion_(e);
}
}async checkCompileCompletionAsync(){
const e=[];if(this.gpgpu.parallelCompilationExtension){
for(const[,t]of Object.entries(this.binaryCache)){
e.push(this.checkCompletionAsync_(t));
}return Promise.all(e);
}for(const[,t]of Object.entries(this.binaryCache)){
const n=new Promise((e=>{
try{
this.checkCompletion_(t),e(!0);
}catch(e){
throw e;
}
}));e.push(n);
}return Promise.all(e);
}async checkCompletionAsync_(e){
return this.gpgpu.gl.getProgramParameter(e.webGLProgram,this.gpgpu.parallelCompilationExtension.COMPLETION_STATUS_KHR)?this.checkCompletion_(e):(await Al(),this.checkCompletionAsync_(e));
}checkCompletion_(e){
if(!1===this.gpgpu.gl.getProgramParameter(e.webGLProgram,this.gpgpu.gl.LINK_STATUS)){
if(console.log(this.gpgpu.gl.getProgramInfoLog(e.webGLProgram)),!1===this.gpgpu.gl.getShaderParameter(e.fragmentShader,this.gpgpu.gl.COMPILE_STATUS)){
throw xN(e.source,this.gpgpu.gl.getShaderInfoLog(e.fragmentShader)),new Error("Failed to compile fragment shader.");
}throw new Error("Failed to link vertex and fragment shaders.");
}return!0;
}getUniformLocations(){
for(const e of Object.values(this.binaryCache)){
this.gpgpu.buildVao(e.webGLProgram);const{variablesLocations:t,customUniformLocations:n,infLoc:r,nanLoc:s,outShapeLocation:i,outShapeStridesLocation:a,outTexShapeLocation:o}=r$(this.gpgpu,e.program,e.webGLProgram);e.variablesLocations=t,e.customUniformLocations=n,e.infLoc=r,e.nanLoc=s,e.outShapeLocation=i,e.outShapeStridesLocation=a,e.outTexShapeLocation=o;
}
}createTensorFromGPUData(e,t,n){
e.channels=e.channels||"RGBA";const{texture:r,height:s,width:i,channels:a}=e,o=gi().backend;if(!o.gpgpu.gl.isTexture(r)){
throw new Error("The texture is invalid. Also, please make sure the texture and the TFJS WebGL backend are using the same canvas. If you want to use your own custom canvas, you have to create and use the custom TFJS WebGL backend created from the canvas through 'new tf.MathBackendWebGL(customCanvas)'.");
}const u=o.writeTexture(r,t,n,s,i,a);return gi().makeTensorFromDataId(u,t,n,o);
}
}WT.nextDataId=0,Ss()&&vi("webgl",(()=>new WT),2);const VT="\n  if (isnan(a)) return a;\n  if (isnan(b)) return b;\n";class GT{
constructor(e,t,n){
this.variableNames=["A","B"],this.outputShape=Hi(t,n),this.enableShapeUniforms=i$(this.outputShape.length),this.userCode=`\n      float binaryOperation(float a, float b) {\n        ${e}\n      }\n\n      void main() {\n        float a = getAAtOutCoords();\n        float b = getBAtOutCoords();\n        setOutput(binaryOperation(a, b));\n      }\n    `;
}
}const jT="\n  result.r = isNaN.r ? NAN : result.r;\n  result.g = isNaN.g ? NAN : result.g;\n  result.b = isNaN.b ? NAN : result.b;\n  result.a = isNaN.a ? NAN : result.a;\n";class HT{
constructor(e,t,n,r=!1){
this.variableNames=["A","B"],this.supportsBroadcasting=!0,this.packedInputs=!0,this.packedOutput=!0,this.outputShape=Hi(t,n);const s=this.outputShape.length;this.enableShapeUniforms=i$(s);let i="";if(r){
if(0===s||1===m(this.outputShape)){
i="\n          result.y = 0.;\n          result.z = 0.;\n          result.w = 0.;\n        ";
}else if(i=`\n          ${QN(s)} coords = getOutputCoords();\n        `,1===s){
this.enableShapeUniforms?i+="\n            result.y = (coords + 1) >= outShape ? 0. : result.y;\n            result.z = 0.;\n            result.w = 0.;\n          ":i+=`\n            result.y = (coords + 1) >= ${this.outputShape[0]} ? 0. : result.y;\n            result.z = 0.;\n            result.w = 0.;\n          `;
}else{
const e=gT("coords",s);this.enableShapeUniforms?i+=`\n            bool nextRowOutOfBounds =\n              (${e[s-2]} + 1) >= outShape[${s} - 2];\n            bool nextColOutOfBounds =\n              (${e[s-1]} + 1) >= outShape[${s} - 1];\n            result.y = nextColOutOfBounds ? 0. : result.y;\n            result.z = nextRowOutOfBounds ? 0. : result.z;\n            result.w = nextColOutOfBounds || nextRowOutOfBounds ? 0. : result.w;\n          `:i+=`\n            bool nextRowOutOfBounds =\n              (${e[s-2]} + 1) >= ${this.outputShape[s-2]};\n            bool nextColOutOfBounds =\n              (${e[s-1]} + 1) >= ${this.outputShape[s-1]};\n            result.y = nextColOutOfBounds ? 0. : result.y;\n            result.z = nextRowOutOfBounds ? 0. : result.z;\n            result.w = nextColOutOfBounds || nextRowOutOfBounds ? 0. : result.w;\n          `;
}
}this.userCode=`\n      vec4 binaryOperation(vec4 a, vec4 b) {\n        ${e}\n      }\n\n      void main() {\n        vec4 a = getAAtOutCoords();\n        vec4 b = getBAtOutCoords();\n\n        vec4 result = binaryOperation(a, b);\n        ${i}\n\n        setOutput(result);\n      }\n    `;
}
}function qT(e){
const{inputs:t,backend:n}=e,{x:r}=t;return n.incRef(r.dataId),{dataId:r.dataId,shape:r.shape,dtype:r.dtype};
}const KT={kernelName:ht,backendName:"webgl",kernelFunc:qT};function XT(e){
const{inputs:t,backend:n}=e,{real:r,imag:s}=t,i=n.makeTensorInfo(r.shape,"complex64"),a=n.texData.get(i.dataId),o=qT({inputs:{x:r},backend:n}),u=qT({inputs:{x:s},backend:n});return a.complexTensorInfos={real:o,imag:u},i;
}const YT={kernelName:Ie,backendName:"webgl",kernelFunc:XT},ZT="return (a < 0.) ? b * a : a;",JT="\n  vec4 aLessThanZero = vec4(lessThan(a, vec4(0.)));\n  return (aLessThanZero * (b * a)) + ((vec4(1.0) - aLessThanZero) * a);\n",QT={kernelName:bt,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{alpha:i}=r,a=n.makeTensorInfo([],"float32",Fr(i,"float32")),o=H().getBool("WEBGL_PACK_BINARY_OPERATIONS")?new HT(JT,s.shape,a.shape):new GT(ZT,s.shape,a.shape),u=n.runWebGLProgram(o,[s,a],"float32");return n.disposeIntermediateTensorInfo(a),u;
}},eE="return (a < 0.) ? b * a : a;",tE="\n  vec4 aLessThanZero = vec4(lessThan(a, vec4(0.)));\n  return (aLessThanZero * (b * a)) + ((vec4(1.0) - aLessThanZero) * a);\n",nE={kernelName:Jt,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n}=e,{x:r,alpha:s}=t,i=H().getBool("WEBGL_PACK_BINARY_OPERATIONS")?new HT(tE,r.shape,s.shape):new GT(eE,r.shape,s.shape);return n.runWebGLProgram(i,[r,s],"float32");
}},rE="if (isnan(x)) return x;";function sE({opSnippet:e,packedOpSnippet:t,cpuKernelImpl:n,dtype:r}){
return({inputs:s,backend:i})=>{
const{x:a}=s,o=i,u=r||a.dtype;if(o.shouldExecuteOnCPU([a])&&null!=n){
const e=o.texData.get(a.dataId),t=n(e.values,u);return o.makeTensorInfo(a.shape,u,t);
}let l;return l=H().getBool("WEBGL_PACK_UNARY_OPERATIONS")&&null!=t?new LT(a.shape,t):new IT(a.shape,e),o.runWebGLProgram(l,[a],u);
};
}function iE({opSnippet:e,packedOpSnippet:t,checkOutOfBounds:n=!1,supportsComplex:r=!1,cpuKernelImpl:s,dtype:i}){
return({inputs:a,backend:o})=>{
const{a:u,b:l}=a,c=o;if(r&&"complex64"===u.dtype){
const t=c.texData.get(u.dataId),n=c.texData.get(l.dataId),[r,s]=[[t.complexTensorInfos.real,n.complexTensorInfos.real],[t.complexTensorInfos.imag,n.complexTensorInfos.imag]].map((t=>{
const[n,r]=t,s={dataId:n.dataId,dtype:n.dtype,shape:u.shape},i={dataId:r.dataId,dtype:r.dtype,shape:l.shape},a=new GT(e,u.shape,l.shape);return c.runWebGLProgram(a,[s,i],ls(n.dtype,r.dtype));
})),i=XT({inputs:{real:r,imag:s},backend:c});return c.disposeIntermediateTensorInfo(r),c.disposeIntermediateTensorInfo(s),i;
}const h=i||ls(u.dtype,l.dtype);if(("string"===u.dtype||"string"===l.dtype||c.shouldExecuteOnCPU([u,l]))&&null!=s){
const e=c.texData.get(u.dataId).values,t=c.texData.get(l.dataId).values,n="string"===u.dtype?Pc(e):e,r="string"===u.dtype?Pc(t):t,[i,a]=s(u.shape,l.shape,n,r,h),o=c.makeTensorInfo(a,h);return c.texData.get(o.dataId).values=i,o;
}let d;return d=H().getBool("WEBGL_PACK_BINARY_OPERATIONS")&&null!=t?new HT(t,u.shape,l.shape,n):new GT(e,u.shape,l.shape),c.runWebGLProgram(d,[u,l],h);
};
}function aE(e,t=!1){
if("linear"===e){
return t?FT:CT;
}if("relu"===e){
return t?DT:TT;
}if("elu"===e){
return t?_T:$T;
}if("relu6"===e){
return t?OT:ET;
}if("prelu"===e){
return t?tE:eE;
}if("leakyrelu"===e){
return t?JT:ZT;
}if("sigmoid"===e){
return t?MT:AT;
}throw new Error(`Activation ${e} has not been implemented for the WebGL backend.`);
}class oE{
constructor(e,t,n,r=!1,s=!1,i=!1,a=null,o=!1,u=!1){
this.variableNames=["matrixA","matrixB"],this.packedInputs=!0,this.packedOutput=!0,this.outputShape=n,this.enableShapeUniforms=i$(this.outputShape.length);const l=r?e[1]:e[2],c=Math.ceil(l/2),h=r?"i * 2, rc.y":"rc.y, i * 2",d=s?"rc.z, i * 2":"i * 2, rc.z",p=r?["a.xxyy","a.zzww"]:["a.xxzz","a.yyww"],f=s?["b.xzxz","b.ywyw"]:["b.xyxy","b.zwzw"];let m="",g="";a&&(m=o?`vec4 activation(vec4 a) {\n          vec4 b = getPreluActivationWeightsAtOutCoords();\n          ${a}\n        }`:u?`vec4 activation(vec4 a) {\n          vec4 b = getLeakyreluAlphaAtOutCoords();\n          ${a}\n        }`:`vec4 activation(vec4 x) {\n          ${a}\n        }`,g="result = activation(result);");const b=i?"result += getBiasAtOutCoords();":"";i&&this.variableNames.push("bias"),o&&this.variableNames.push("preluActivationWeights"),u&&this.variableNames.push("leakyreluAlpha");let x="rc.x",y="rc.x";e[0]<t[0]?x=`imod(rc.x, ${e[0]})`:t[0]<e[0]&&(y=`imod(rc.x, ${t[0]})`),this.userCode=`\n      ${m}\n      // Don't use uniform for sharedDimensionPacked for performance.\n      const float sharedDimension = ${c}.0;\n\n      vec4 dot2x2ARowBCol(ivec3 rc) {\n        vec4 result = vec4(0);\n        int batchA = ${x};\n        int batchB = ${y};\n        for (int i = 0; i < ${c}; i++) {\n          vec4 a = getMatrixA(batchA, ${h});\n          vec4 b = getMatrixB(batchB, ${d});\n\n          // These swizzled products need to be separately added.\n          // See: https://github.com/tensorflow/tfjs/issues/1735\n          result += (${p[0]} * ${f[0]});\n          result += (${p[1]} * ${f[1]});\n        }\n        return result;\n      }\n\n      void main() {\n        ivec3 rc = getOutputCoords();\n        vec4 result = dot2x2ARowBCol(rc);\n\n        ${b}\n\n        ${g}\n\n        setOutput(result);\n      }\n    `;
}
}const uE={REAL:"return areal * breal - aimag * bimag;",IMAG:"return areal * bimag + aimag * breal;"};class lE{
constructor(e,t,n){
this.variableNames=["AReal","AImag","BReal","BImag"],this.outputShape=Hi(t,n),this.userCode=`\n      float binaryOpComplex(\n          float areal, float aimag, float breal, float bimag) {\n        ${e}\n      }\n\n      void main() {\n        float areal = getARealAtOutCoords();\n        float aimag = getAImagAtOutCoords();\n        float breal = getBRealAtOutCoords();\n        float bimag = getBImagAtOutCoords();\n        setOutput(binaryOpComplex(areal, aimag, breal, bimag));\n      }\n    `;
}
}const cE="return a * b;";function hE(e){
const{inputs:t,backend:n}=e,{a:r,b:s}=t,i=ls(r.dtype,s.dtype);if("complex64"===r.dtype){
const e=n.texData.get(r.dataId),t=n.texData.get(s.dataId),i=new lE(uE.REAL,r.shape,s.shape),a=new lE(uE.IMAG,r.shape,s.shape),o=[{dataId:e.complexTensorInfos.real.dataId,dtype:e.complexTensorInfos.real.dtype,shape:r.shape},{dataId:e.complexTensorInfos.imag.dataId,dtype:e.complexTensorInfos.imag.dtype,shape:r.shape},{dataId:t.complexTensorInfos.real.dataId,dtype:t.complexTensorInfos.real.dtype,shape:s.shape},{dataId:t.complexTensorInfos.imag.dataId,dtype:t.complexTensorInfos.imag.dtype,shape:s.shape}],u=n.runWebGLProgram(i,o,"float32"),l=n.runWebGLProgram(a,o,"float32"),c=XT({inputs:{real:u,imag:l},backend:n});return n.disposeIntermediateTensorInfo(u),n.disposeIntermediateTensorInfo(l),c;
}if(n.shouldExecuteOnCPU([r,s])){
const e=n.texData.get(r.dataId),t=n.texData.get(s.dataId),[a,o]=W$(r.shape,s.shape,e.values,t.values,i),u=n.makeTensorInfo(o,i);return n.texData.get(u.dataId).values=a,u;
}let a;return a=H().getBool("WEBGL_PACK_BINARY_OPERATIONS")?new HT(cE,r.shape,s.shape):new GT(cE,r.shape,s.shape),n.runWebGLProgram(a,[r,s],i);
}const dE={kernelName:Ut,backendName:"webgl",kernelFunc:hE};function pE(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{shape:i}=r,a=n,o=m(s.shape),u=v(i,o),l=m(u);d(o===l,(()=>`The new shape (${u}) has ${l} elements and the old shape (${s.shape}) has ${o} elements. The new shape and old shape must have the same number of elements.`));const c=a.texData.get(s.dataId);return!c.isPacked||RN(s.shape,u)||null!==c.texture&&RN(c.shape,u)?(a.incRef(s.dataId),{dataId:s.dataId,shape:u,dtype:s.dtype}):function(e,t,n){
const r=[NN(e.shape),...$N(e.shape)],s={dtype:e.dtype,shape:r,dataId:e.dataId},i=[NN(t),...$N(t)],a=new xT(i,r),o=[r],u=n.runWebGLProgram(a,[s],e.dtype,o,!0);return{dataId:u.dataId,shape:t,dtype:u.dtype};
}(s,u,a);
}const fE={kernelName:un,backendName:"webgl",kernelFunc:pE};class mE{
constructor(e,t){
this.variableNames=["x"];const{windowSize:n,batchSize:r,inSize:s,outSize:i}=e;this.outputShape=[r,i];const a=4*Math.floor(n/4),o=n%4;let u="sumValue += dot(values, ones);";if(null!=t){
const e=1/t;u=`sumValue += dot(values * ${b(e)?e.toPrecision(2):e}, ones);`;
}let l="";s%n>0&&(l=`\n        if (inIdx < 0 || inIdx >= ${s}) {\n          return 0.0;\n        }\n      `),this.userCode=`\n      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);\n\n      float getValue(int batch, int inIdx) {\n        ${l}\n        return getX(batch, inIdx);\n      }\n\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int batch = coords[0];\n        int outIdx = coords[1];\n        int inOffset = outIdx * ${n};\n\n        float sumValue = 0.0;\n\n        for (int i = 0; i < ${a}; i += 4) {\n          int inIdx = inOffset + i;\n          vec4 values = vec4(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            getValue(batch, inIdx + 2),\n            getValue(batch, inIdx + 3)\n          );\n\n          ${u}\n        }\n\n        int inIdx = inOffset + ${a};\n        if (${1===o}) {\n          vec4 values = vec4(getValue(batch, inIdx), 0.0, 0.0, 0.0);\n\n          ${u}\n        } else if (${2===o}) {\n          vec4 values = vec4(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1), 0.0, 0.0);\n\n          ${u}\n        } else if (${3===o}) {\n          vec4 values = vec4(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            getValue(batch, inIdx + 2), 0.0);\n\n          ${u}\n        }\n        setOutput(sumValue);\n      }\n    `;
}
}class gE{
constructor(e,t){
this.variableNames=["x"];const{windowSize:n,batchSize:r,inSize:s,outSize:i}=e;this.outputShape=[r,i];let a="0.0",o="";"prod"===t?a="1.0":"min"===t?(a="1.0 / 1e-20",o="min"):"max"===t&&(a="-1.0 / 1e-20",o="max");let u=`${t}(${t}(${t}(minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])`;"sum"===t?u="sumValue":"prod"===t?u="prodValue":"all"===t?u="allValue":"any"===t&&(u="anyValue");const l=4*Math.floor(n/4),c=n%4;let h=`\n      if (${"sum"===t}) {\n        sumValue += dot(values, ones);\n      } else if (${"prod"===t}) {\n        vec2 tmp = vec2(values[0], values[1]) * vec2(values[2], values[3]);\n        prodValue *= tmp[0] * tmp[1];\n      } else {\n        minMaxValue = ${o}(values, minMaxValue);\n        if (${"min"===t} || ${"max"===t}) {\n          minMaxValue = ${o}(values, minMaxValue);\n          bvec4 isNaN = isnan(values);\n          if (isNaN.r || isNaN.g || isNaN.b || isNaN.a) {\n            minMaxValue = vec4(NAN);\n          }\n        }\n      }\n    `,d="vec4";"all"===t?(a="1.0",h="\n        bool reducedAllValue = all(values);\n        float floatedReducedAllValue = float(reducedAllValue);\n        allValue = float(allValue >= 1.0 && floatedReducedAllValue >= 1.0);\n      ",d="bvec4"):"any"===t&&(a="0.0",h="\n        bool reducedAnyValue = any(values);\n        float floatedReducedAnyValue = float(reducedAnyValue);\n        anyValue = float(anyValue >= 1.0 || floatedReducedAnyValue >= 1.0);\n      ",d="bvec4");let p="";s%n>0&&(p=`\n        if (inIdx < 0 || inIdx >= ${s}) {\n          return initializationValue;\n        }\n      `),this.userCode=`\n      const float initializationValue = ${a};\n      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);\n\n      float getValue(int batch, int inIdx) {\n        ${p}\n        return getX(batch, inIdx);\n      }\n\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int batch = coords[0];\n        int outIdx = coords[1];\n        int inOffset = outIdx * ${n};\n\n        vec4 minMaxValue = vec4(${a});\n        float prodValue = 1.0;\n        float sumValue = 0.0;\n        float allValue = 1.0;\n        float anyValue = 0.0;\n\n        for (int i = 0; i < ${l}; i += 4) {\n          int inIdx = inOffset + i;\n          ${d} values = ${d}(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            getValue(batch, inIdx + 2),\n            getValue(batch, inIdx + 3)\n          );\n\n          ${h}\n        }\n\n        int inIdx = inOffset + ${l};\n        if (${1===c}) {\n          ${d} values = ${d}(\n            getValue(batch, inIdx),\n            initializationValue,\n            initializationValue,\n            initializationValue\n          );\n\n          ${h}\n        } else if (${2===c}) {\n          ${d} values = ${d}(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            initializationValue,\n            initializationValue\n          );\n\n          ${h}\n        } else if (${3===c}) {\n          ${d} values = ${d}(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            getValue(batch, inIdx + 2),\n            initializationValue\n          );\n\n          ${h}\n        }\n        setOutput(${u});\n      }\n    `;
}
}function bE(e,t,n,r){
const s=function(e){
const t=[];for(;0===t.length||1!==t[t.length-1].outSize;){
const n=t.length?t[t.length-1].outSize:e[1],r=Bl(n);t.push({inSize:n,windowSize:r,outSize:Math.ceil(n/r)});
}return t;
}(e.shape);let i=e;for(let a=0;a<s.length;a++){
const{inSize:o,windowSize:u,outSize:l}=s[a];let c,h;c="mean"===n?0===a?new mE({windowSize:u,inSize:o,batchSize:e.shape[0],outSize:l},o):new mE({windowSize:u,inSize:o,batchSize:e.shape[0],outSize:l}):new gE({windowSize:u,inSize:o,batchSize:e.shape[0],outSize:l},n),h=i,i=r.runWebGLProgram(c,[i],t),h.dataId!==e.dataId&&r.disposeIntermediateTensorInfo(h);
}return i;
}class xE{
constructor(e,t){
this.variableNames=["A"];const n=new Array(e.length);for(let r=0;r<n.length;r++){
n[r]=e[t[r]];
}this.outputShape=n,this.rank=n.length;const r=QN(this.rank),s=function(e){
const t=e.length;if(t>6){
throw Error(`Transpose for rank ${t} is not yet supported`);
}const n=["resRC.x","resRC.y","resRC.z","resRC.w","resRC.u","resRC.v"],r=new Array(t);for(let t=0;t<e.length;t++){
r[e[t]]=n[t];
}return r.join();
}(t);this.userCode=`\n    void main() {\n      ${r} resRC = getOutputCoords();\n      setOutput(getA(${s}));\n    }\n    `;
}
}class yE{
constructor(e,t){
this.variableNames=["A"],this.packedInputs=!0,this.packedOutput=!0;const n=new Array(e.length);for(let r=0;r<n.length;r++){
n[r]=e[t[r]];
}if(this.outputShape=n,this.rank=n.length,this.rank>6){
throw Error(`Packed transpose for rank ${this.rank} is not yet supported.`);
}const r=QN(this.rank),s=mT("rc",this.rank),i=new Array(this.rank);for(let e=0;e<t.length;e++){
i[t[e]]=s[e];
}const a=`vec2(${i.slice(-2).join()})`,o=`++${s[this.rank-1]} < ${n[this.rank-1]}`,u=`getChannel(getA(${i.join()}), ${a})`;this.userCode=`\n    void main() {\n      ${r} rc = getOutputCoords();\n      vec4 result = vec4(0.);\n      result[0] = ${u};\n      if(${o}) {\n        result[1] = ${u};\n      }\n      --${s[this.rank-1]};\n      if(++${s[this.rank-2]} < ${n[this.rank-2]}) {\n        result[2] = ${u};\n        if(${o}) {\n          result[3] = ${u};\n        }\n      }\n      setOutput(result);\n    }\n    `;
}
}function wE(e,t,n){
const r=H().getBool("WEBGL_PACK_ARRAY_OPERATIONS")?new yE(e.shape,t):new xE(e.shape,t);return n.runWebGLProgram(r,[e],e.dtype);
}function vE(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{axis:i,keepDims:a}=r;return function(e,t,n,r){
const s=t,i=e.shape.length,a=k(s,e.shape);let o=a;const u=Uo(o,i),l=null!=u;let c=e;l&&(c=wE(e,u,r),o=Vo(o.length,i)),Bo("sum",o,i);const[h,d]=zo(c.shape,o);let p=h;n&&(p=Po(h,a));const f=m(d),g=pE({inputs:{x:c},attrs:{shape:[m(e.shape)/f,f]},backend:r}),b=bE(g,cs(e.dtype),"sum",r),x=pE({inputs:{x:b},attrs:{shape:p},backend:r});return r.disposeIntermediateTensorInfo(g),r.disposeIntermediateTensorInfo(b),l&&r.disposeIntermediateTensorInfo(c),x;
}(s,i,a,n);
}const kE={kernelName:En,backendName:"webgl",kernelFunc:vE};function IE(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{perm:i}=r,a=n,o=s.shape.length,u=new Array(o);for(let e=0;e<u.length;e++){
u[e]=s.shape[i[e]];
}let l;if(a.shouldExecuteOnCPU([s])){
const e=a.texData.get(s.dataId).values,t=pT(e,s.shape,s.dtype,i,u);l=a.makeTensorInfo(u,s.dtype),a.texData.get(l.dataId).values=t;
}else {
l=wE(s,i,a);
}return l;
}const SE={kernelName:Zn,backendName:"webgl",kernelFunc:IE},CE=1e3;function NE({a:e,b:t,transposeA:n,transposeB:r,backend:s,bias:i=null,preluActivationWeights:a=null,leakyreluAlpha:o=0,activation:u=null}){
const l=e.shape.length,c=t.shape.length,h=n?e.shape[l-2]:e.shape[l-1],p=r?t.shape[c-1]:t.shape[c-2],f=n?e.shape[l-1]:e.shape[l-2],g=r?t.shape[c-2]:t.shape[c-1],b=e.shape.slice(0,-2),x=t.shape.slice(0,-2),y=m(b),w=m(x),v=Hi(e.shape.slice(0,-2),t.shape.slice(0,-2)).concat([f,g]);d(h===p,(()=>`Error in matMul: inner shapes (${h}) and (${p}) of Tensors with shapes ${e.shape} and ${t.shape} and transposeA=${n} and transposeB=${r} must match.`));const k=n?[y,h,f]:[y,f,h],I=r?[w,g,p]:[w,p,g],S=pE({inputs:{x:e},backend:s,attrs:{shape:k}}),C=pE({inputs:{x:t},backend:s,attrs:{shape:I}}),N=[S,C],$=Math.max(y,w),T=n?S.shape[1]:S.shape[2],E=null!=i,R=null!=a,A="leakyrelu"===u,F=null!=u?aE(u,!0):null;let _;if((1===f||1===g)&&T>CE&&!1===(E||R||A||null!=F)){
let e=S,t=C;n&&(e=IE({inputs:{x:S},backend:s,attrs:{perm:[0,2,1]}}),N.push(e)),r&&(t=IE({inputs:{x:C},backend:s,attrs:{perm:[0,2,1]}}),N.push(t));const i=1===g;let a=e;1!==g&&(a=pE({inputs:{x:e},backend:s,attrs:{shape:[$,T,1]}}),N.push(a));const o=1===g?2:1;let u=t;i&&(u=pE({inputs:{x:t},backend:s,attrs:{shape:[$,1,T]}}),N.push(u));const l=hE({inputs:{a,b:u},backend:s});_=vE({inputs:{x:l},backend:s,attrs:{axis:o,keepDims:!0}}),N.push(l);
}else{
const u=ls(e.dtype,t.dtype),l=new oE(k,I,[$,f,g],n,r,E,F,R,A),c=[S,C];if(null!=i&&c.push(i),R&&c.push(a),A){
const e=s.makeTensorInfo([],"float32",Fr(o,"float32"));c.push(e),N.push(e);
}_=s.runWebGLProgram(l,c,u);
}const D=pE({inputs:{x:_},backend:s,attrs:{shape:v}});N.push(_);for(const e of N){
s.disposeIntermediateTensorInfo(e);
}return D;
}const $E={kernelName:sr,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{a:s,b:i,bias:a,preluActivationWeights:o}=t,{transposeA:u,transposeB:l,activation:c,leakyreluAlpha:h}=r;return NE({a:s,b:i,transposeA:u,transposeB:l,backend:n,bias:a,preluActivationWeights:o,leakyreluAlpha:h,activation:c});
}},TE="return abs(x);",EE={kernelName:Z,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n}=e,{x:r}=t;if(n.shouldExecuteOnCPU([r])&&"complex64"!==r.dtype){
const e=n.texData.get(r.dataId),t=Q$(e.values);return n.makeTensorInfo(r.shape,r.dtype,t);
}let s;return s=H().getBool("WEBGL_PACK_UNARY_OPERATIONS")?new LT(r.shape,TE):new IT(r.shape,TE),n.runWebGLProgram(s,[r],r.dtype);
}},RE=sE({opSnippet:ST+"\n  if (abs(x) > 1.) {\n    return NAN;\n  }\n  return acos(x);\n"}),AE={kernelName:J,backendName:"webgl",kernelFunc:RE},FE=sE({opSnippet:ST+"\n  if (x < 1.0) return NAN;\nreturn log(x + sqrt(x * x - 1.0));"}),_E={kernelName:Q,backendName:"webgl",kernelFunc:FE},DE="return a + b;",OE=iE({opSnippet:DE,packedOpSnippet:DE,supportsComplex:!0,cpuKernelImpl:w$}),ME={kernelName:ee,backendName:"webgl",kernelFunc:OE};class LE{
constructor(e,t){
this.outputShape=[],this.outputShape=e,this.variableNames=t.map(((e,t)=>`T${t}`));const n=[];this.variableNames.forEach((e=>{
n.push(`float v${e} = get${e}AtOutCoords();`);
}));const r=this.variableNames.map((e=>`v${e}`)).join(" + ");this.userCode=`\n      void main() {\n        ${n.join("\n        ")}\n\n        float result = ${r};\n        setOutput(result);\n      }\n    `;
}
}class zE{
constructor(e,t){
this.outputShape=[],this.packedInputs=!0,this.packedOutput=!0,this.outputShape=e,this.variableNames=t.map(((e,t)=>`T${t}`));const n=[];this.variableNames.forEach((e=>{
n.push(`vec4 v${e} = get${e}AtOutCoords();`);
}));const r=this.variableNames.map((e=>`v${e}`)).join(" + ");this.userCode=`\n      void main() {\n        ${n.join("\n        ")}\n\n        vec4 result = ${r};\n        setOutput(result);\n      }\n    `;
}
}const PE={kernelName:te,backendName:"webgl",kernelFunc:function e(t){
const{inputs:n,backend:r}=t,s=n;if(1===s.length){
return qT({inputs:{x:s[0]},backend:r});
}if(s.length>H().getNumber("WEBGL_MAX_TEXTURES_IN_SHADER")){
const t=Math.floor(s.length/2),n=e({inputs:s.slice(0,t),backend:r}),i=e({inputs:s.slice(t),backend:r});return e({inputs:[n,i],backend:r});
}const i=s.map((e=>e.dtype)).reduce(((e,t)=>ls(e,t))),a=s.map((e=>e.shape)),o=H().getBool("WEBGL_PACK")?new zE(s[0].shape,a):new LE(s[0].shape,a);return r.runWebGLProgram(o,s,i);
}},BE={kernelName:ne,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{axis:i,keepDims:a}=r,o=s.shape.length,u=k(i,s.shape);let l=u;const c=Uo(l,o);let h=s;null!=c&&(h=IE({inputs:{x:s},backend:n,attrs:{perm:c}}),l=Vo(l.length,o)),Bo("all",l,o);const[d,p]=zo(h.shape,l),f=pE({inputs:{x:h},backend:n,attrs:{shape:[-1,m(p)]}}),g=bE(f,f.dtype,"all",n);let b;return b=pE(a?{inputs:{x:g},backend:n,attrs:{shape:Po(d,u)}}:{inputs:{x:g},backend:n,attrs:{shape:d}}),n.disposeIntermediateTensorInfo(f),n.disposeIntermediateTensorInfo(g),null!=c&&n.disposeIntermediateTensorInfo(h),b;
}},UE={kernelName:re,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{axis:i,keepDims:a}=r,o=s.shape.length,u=k(i,s.shape);let l=u;const c=Uo(l,o);let h=s;null!=c&&(h=IE({inputs:{x:s},backend:n,attrs:{perm:c}}),l=Vo(l.length,o)),Bo("any",l,o);const[d,p]=zo(h.shape,l),f=pE({inputs:{x:h},backend:n,attrs:{shape:[-1,m(p)]}}),g=bE(f,f.dtype,"any",n);let b;return b=pE(a?{inputs:{x:g},backend:n,attrs:{shape:Po(d,u)}}:{inputs:{x:g},backend:n,attrs:{shape:d}}),n.disposeIntermediateTensorInfo(f),n.disposeIntermediateTensorInfo(g),null!=c&&n.disposeIntermediateTensorInfo(h),b;
}};class WE{
constructor(e,t,n){
this.variableNames=["A"];const{windowSize:r,batchSize:s,outSize:i}=e;n||this.variableNames.push("bestIndicesA"),this.outputShape=[s,i];const a="max"===t?">":"<",o=n?"inOffset + i;":"round(getBestIndicesA(batch, inOffset + i));";this.userCode=`\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int batch = coords[0];\n        int outIdx = coords[1];\n        int inOffset = outIdx * ${r};\n\n        int bestIndex = inOffset;\n        float bestValue = getA(batch, bestIndex);\n\n        for (int i = 0; i < ${r}; i++) {\n          int inIdx = ${o};\n          float candidate = getA(batch, inIdx);\n          if (candidate ${a} bestValue) {\n            bestValue = candidate;\n            bestIndex = inIdx;\n          }\n        }\n        setOutput(float(bestIndex));\n      }\n    `;
}
}class VE{
constructor(e,t,n,r){
this.variableNames=["A"],this.packedInputs=!0,this.packedOutput=!0,d(e.length>2,(()=>`Packed arg${n.charAt(0).toUpperCase()+n.slice(1)} supports only inputs with rank above 2.`));const s=e[e.length-1],i=Math.ceil(s/t);this.outputShape=e.slice(0,-1),i>1&&this.outputShape.push(i),r||this.variableNames.push("bestIndicesA");const a=this.outputShape,o=a.length,u=QN(o),l=gT("coords",o);let c,h;if(1===i){
h=o+1;const e=QN(h);c=`\n        ${e} sourceLocR = ${e}(${l.join()}, 0);\n        ++${l[o-1]};\n        ${e} sourceLocG = ${e}(${l.join()}, 0);\n        ++${l[o-2]};\n        ${e} sourceLocA = ${e}(${l.join()}, 0);\n        --${l[o-1]};\n        ${e} sourceLocB = ${e}(${l.join()}, 0);\n        --${l[o-2]};`;
}else {
h=o,c=`\n        ${u} sourceLocR = coords;\n        ++${l[o-1]};\n        ${u} sourceLocG = coords;\n        ++${l[o-2]};\n        ${u} sourceLocA = coords;\n        --${l[o-1]};\n        ${u} sourceLocB = coords;\n        --${l[o-2]};`;
}const p=["x","y","z","w","u","v"].slice(0,h),f="."+p[h-1],m=p.map((e=>"int "+e)),g=gT("sourceLocR",h-1).concat("inIdx.r"),b=gT("sourceLocG",h-1).concat("inIdx.g"),x=gT("sourceLocB",h-1).concat("inIdx.b"),y=gT("sourceLocA",h-1).concat("inIdx.a"),w="max"===n?"greaterThan":"lessThan",v=r?"":`\n          inIdx = round(vec4(getBestIndicesAChannel(${g.join()}),\n                             getBestIndicesAChannel(${b.join()}),\n                             getBestIndicesAChannel(${x.join()}),\n                             getBestIndicesAChannel(${y.join()})));`,k=`vec4(\n            getAChannel(${g.join()}),\n            hasNextCol ? getAChannel(${b.join()}) : 0.,\n            hasNextRow ? getAChannel(${x.join()}) : 0.,\n            hasNextRow && hasNextCol ? getAChannel(${y.join()}) : 0.)`,I=r?"":`\n      float getBestIndicesAChannel(${m.join()}) {\n        return getChannel(getBestIndicesA(${p.join()}),\n                                          vec2(${p.slice(-2).join()}));\n      }`;this.userCode=`\n      float getAChannel(${m.join()}) {\n        return getChannel(getA(${p.join()}),\n                               vec2(${p.slice(-2).join()}));\n      }\n      ${I}\n      void main() {\n        ${u} coords = getOutputCoords();\n        bool hasNextCol = ${l[o-1]} < ${a[o-1]-1};\n        bool hasNextRow = ${l[o-2]} < ${a[o-2]-1};\n        ${c}\n        ivec4 srcIdx = ivec4(sourceLocR${f}, sourceLocG${f},\n          sourceLocB${f}, sourceLocA${f}) * ${t};\n        ivec4 inIdx = srcIdx;\n        vec4 bestIndex = vec4(inIdx);\n        vec4 bestValue = ${k};\n\n        for (int i = 0; i < ${t}; i++) {\n          inIdx = srcIdx;\n          ${v}\n          vec4 candidate = ${k};\n          bvec4 nan = isnan(candidate);\n          bvec4 replace = bvec4(\n            vec4(${w}(candidate, bestValue)) * (vec4(1.0) - vec4(nan)));\n\n          bestValue = vec4(replace.x  ? candidate.x : bestValue.x,\n                           replace.y  ? candidate.y : bestValue.y,\n                           replace.z  ? candidate.z : bestValue.z,\n                           replace.w  ? candidate.w : bestValue.w);\n          bestIndex = mix(bestIndex, vec4(inIdx), vec4(replace));\n          srcIdx++;\n        }\n        setOutput(bestIndex);\n      }\n    `;
}
}function GE(e,t,n,r=null){
let s=t.shape[0],i=t.shape[1];null!=r&&(s=r.shape[0],i=r.shape[1]);const a=Bl(i),o={windowSize:a,inSize:i,batchSize:s,outSize:Math.ceil(i/a)},u=new WE(o,n,null==r),l=[t];null!=r&&l.push(r);const c=e.runWebGLProgram(u,l,"int32");if(1===c.shape[1]){
return c;
}const h=GE(e,t,n,c);return e.disposeIntermediateTensorInfo(c),h;
}function jE(e,t,n,r=null){
const s=null!=r?r.shape:t.shape,i=Bl(s[s.length-1]),a=new VE(s,i,n,null==r),o=null==r?[t]:[t,r],u=e.runWebGLProgram(a,o,"int32");if(u.shape.length===t.shape.length){
const r=jE(e,t,n,u);return e.disposeIntermediateTensorInfo(u),r;
}return u;
}function HE(e,t,n,r){
const s=[n];if(Bo("arg"+r.charAt(0).toUpperCase()+r.slice(1),s,t.shape.length),!H().getBool("WEBGL_PACK_REDUCE")||t.shape.length<=2){
const n=[],i=e.texData.get(t.dataId);let a=t;null!==i&&i.isPacked&&(a=e.unpackTensor(t),n.push(a));const[o,u]=zo(a.shape,s),l=m(u),c=pE({inputs:{x:a},backend:e,attrs:{shape:[-1,l]}});n.push(c);const h=GE(e,c,r);n.push(h);const d=pE({inputs:{x:h},backend:e,attrs:{shape:o}});return n.forEach((t=>e.disposeIntermediateTensorInfo(t))),d;
}return jE(e,t,r);
}const qE={kernelName:se,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{axis:i}=r;let a=k(i,s.shape);const o=Uo(a,s.shape.length);let u=s;const l=[];null!=o&&(u=IE({inputs:{x:s},backend:n,attrs:{perm:o}}),l.push(u),a=Vo(a.length,u.shape.length)),Bo("argMax",[a[0]],u.shape.length);const c=HE(n,u,a[0],"max");return l.forEach((e=>n.disposeIntermediateTensorInfo(e))),c;
}},KE={kernelName:ie,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{axis:i}=r;let a=k(i,s.shape);const o=Uo(a,s.shape.length);let u=s;const l=[];null!=o&&(u=IE({inputs:{x:s},backend:n,attrs:{perm:o}}),l.push(u),a=Vo(a.length,u.shape.length)),Bo("argMin",[a[0]],u.shape.length);const c=HE(n,u,a[0],"min");return l.forEach((e=>n.disposeIntermediateTensorInfo(e))),c;
}},XE=sE({opSnippet:ST+"\n  if (abs(x) > 1.) {\n    return NAN;\n  }\n  return asin(x);\n"}),YE={kernelName:ae,backendName:"webgl",kernelFunc:XE},ZE=sE({opSnippet:ST+"return log(x + sqrt(x * x + 1.0));"}),JE={kernelName:oe,backendName:"webgl",kernelFunc:ZE},QE=sE({opSnippet:ST+"\n  return atan(x);\n"}),eR={kernelName:ue,backendName:"webgl",kernelFunc:QE},tR=iE({opSnippet:VT+"\n  return atan(a, b);\n",packedOpSnippet:"\n  vec4 result = atan(a, b);\n  bvec4 isNaNA = isnan(a);\n  bvec4 isNaNB = isnan(b);\n  bvec4 isNaN = bvec4(isNaNA.x || isNaNB.x, isNaNA.y || isNaNB.y, isNaNA.z || isNaNB.z, isNaNA.w || isNaNB.w);\n  "+jT+"\n  return result;\n"}),nR={kernelName:ce,backendName:"webgl",kernelFunc:tR},rR=sE({opSnippet:ST+"\n  if ((x < -1.0) || (x > 1.0)) return NAN;\nreturn (log(1.0 + x) - log(1.0 - x)) / 2.0;"}),sR={kernelName:le,backendName:"webgl",kernelFunc:rR};class iR{
constructor(e,t,n,r=!1,s=!1){
if(this.variableNames=["x"],"avg"===t&&n){
throw new Error("Cannot compute positions for average pool.");
}const i=e.filterWidth,a=e.strideHeight,o=e.strideWidth,u=e.dilationHeight,l=e.dilationWidth,c=e.effectiveFilterHeight,h=e.effectiveFilterWidth,d=e.padInfo.top,p=e.padInfo.left;this.outputShape=e.outShape;const f="avg"===t,m=`((batch  * ${e.inHeight} + xR) * ${e.inWidth} + xC) * ${e.inChannels} + d`,g=`(xR * ${e.inWidth} + xC) * ${e.inChannels} + d`;let b="0.0";if(f||(b="-1.0 / 1e-20"),n){
const t=">=";return void(this.userCode=`\n        const ivec2 strides = ivec2(${a}, ${o});\n        const ivec2 pads = ivec2(${d}, ${p});\n\n        void main() {\n          ivec4 coords = getOutputCoords();\n          int batch = coords[0];\n          int d = coords[3];\n\n          ivec2 xRCCorner = coords.yz * strides - pads;\n          int xRCorner = xRCCorner.x;\n          int xCCorner = xRCCorner.y;\n\n          // max/min x(?, ?, d) to get y(yR, yC, d).\n          // ? = to be determined\n          float minMaxValue = 0.0;\n          float minMaxValueFound = 0.0;\n          int minMaxPosition = 0;\n          float avgValue = 0.0;\n\n          for (int wR = 0; wR < ${c};\n              wR += ${u}) {\n            int xR = xRCorner + wR;\n\n            if (xR < 0 || xR >= ${e.inHeight}) {\n              continue;\n            }\n\n            for (int wC = 0; wC < ${h};\n                wC += ${l}) {\n              int xC = xCCorner + wC;\n\n              if (xC < 0 || xC >= ${e.inWidth}) {\n                continue;\n              }\n\n              float value = getX(batch, xR, xC, d);\n\n              // If a min / max value has already been found, use it. If not,\n              // use the current value.\n              float currMinMaxValue = mix(\n                  value, minMaxValue, minMaxValueFound);\n              if (value ${t} currMinMaxValue) {\n                minMaxValue = value;\n                minMaxValueFound = 1.0;\n                minMaxPosition = ${r?s?m:g:`wR * ${h} + wC`};\n              }\n            }\n          }\n          setOutput(float(minMaxPosition));\n        }\n      `);
}let x=`${t}(${t}(${t}(minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])`;"avg"===t&&(x="avgValue / max(count, 1.0)");const y=4*Math.floor(i/4),w=i%4,v=`\n      if (${f}) {\n        avgValue += dot(values, ones);\n      } else {\n        minMaxValue = max(values, minMaxValue);\n      }\n    `;this.userCode=`\n      const ivec2 strides = ivec2(${a}, ${o});\n      const ivec2 pads = ivec2(${d}, ${p});\n      const float initializationValue = ${b};\n      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);\n\n      float count = 0.0;\n\n      float getValue(int batch, int xR, int xC, int d) {\n        if (xC < 0 || xC >= ${e.inWidth}) {\n          return initializationValue;\n        }\n        count += 1.0;\n        return getX(batch, xR, xC, d);\n      }\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords[0];\n        int d = coords[3];\n\n        ivec2 xRCCorner = coords.yz * strides - pads;\n        int xRCorner = xRCCorner.x;\n        int xCCorner = xRCCorner.y;\n\n        // max/min x(?, ?, d) to get y(yR, yC, d).\n        // ? = to be determined\n        vec4 minMaxValue = vec4(${b});\n        float avgValue = 0.0;\n        count = 0.0;\n\n        for (int wR = 0; wR < ${c};\n            wR += ${u}) {\n          int xR = xRCorner + wR;\n\n          if (xR < 0 || xR >= ${e.inHeight}) {\n            continue;\n          }\n\n          for (int wC = 0; wC < ${y}; wC += 4) {\n            int xC = xCCorner + wC * ${l};\n\n            vec4 values = vec4(\n              getValue(batch, xR, xC, d),\n              getValue(batch, xR, xC + ${l}, d),\n              getValue(batch, xR, xC + 2 * ${l}, d),\n              getValue(batch, xR, xC + 3 * ${l}, d)\n            );\n\n            ${v}\n          }\n\n          int xC = xCCorner + ${y};\n          if (${1===w}) {\n            vec4 values = vec4(\n              getValue(batch, xR, xC, d),\n              initializationValue,\n              initializationValue,\n              initializationValue\n            );\n\n            ${v}\n          } else if (${2===w}) {\n            vec4 values = vec4(\n              getValue(batch, xR, xC, d),\n              getValue(batch, xR, xC + ${l}, d),\n              initializationValue,\n              initializationValue\n            );\n\n            ${v}\n          } else if (${3===w}) {\n            vec4 values = vec4(\n              getValue(batch, xR, xC, d),\n              getValue(batch, xR, xC + ${l}, d),\n              getValue(batch, xR, xC + 2 * ${l}, d),\n              initializationValue\n            );\n\n            ${v}\n          }\n        }\n        setOutput(${x});\n      }\n    `;
}
}class aR{
constructor(e,t,n,r=!1,s=!1){
if(this.variableNames=["x"],"avg"===t&&n){
throw new Error("Cannot compute positions for average pool.");
}const i=e.filterWidth,a=e.strideDepth,o=e.strideHeight,u=e.strideWidth,l=e.dilationDepth,c=e.dilationHeight,h=e.dilationWidth,d=e.effectiveFilterDepth,p=e.effectiveFilterHeight,f=e.effectiveFilterWidth,m=e.padInfo.front,g=e.padInfo.top,b=e.padInfo.left;this.outputShape=e.outShape;const x="avg"===t;let y="0.0";if(x||(y="-1.0 / 1e-20"),n){
const t=">=";return void(this.userCode=`\n        const ivec3 strides =\n            ivec3(${a}, ${o}, ${u});\n        const ivec3 pads = ivec3(${m}, ${g}, ${b});\n\n        void main() {\n          ivec5 coords = getOutputCoords();\n          int batch = coords.x;\n          int ch = coords.u;\n\n          ivec3 xCorner = ivec3(coords.y, coords.z, coords.w) * strides - pads;\n          int xDCorner = xCorner.x;\n          int xRCorner = xCorner.y;\n          int xCCorner = xCorner.z;\n\n          // max/min x(?, ?, ?, ch) to get y(yD, yR, yC, ch).\n          // ? = to be determined\n          float minMaxValue = 0.0;\n          float minMaxValueFound = 0.0;\n          int minMaxPosition = 0;\n\n          for (int wD = 0; wD < ${d};\n              wD += ${l}) {\n            int xD = xDCorner + wD;\n\n            if (xD < 0 || xD >= ${e.inDepth}) {\n              continue;\n            }\n\n            for (int wR = 0; wR < ${p};\n                wR += ${c}) {\n              int xR = xRCorner + wR;\n\n              if (xR < 0 || xR >= ${e.inHeight}) {\n                continue;\n              }\n\n              for (int wC = 0; wC < ${f};\n                  wC += ${h}) {\n                int xC = xCCorner + wC;\n\n                if (xC < 0 || xC >= ${e.inWidth}) {\n                  continue;\n                }\n\n                float value = getX(batch, xD, xR, xC, ch);\n\n                // If a min / max value has already been found, use it. If not,\n                // use the current value.\n                float currMinMaxValue = mix(\n                    value, minMaxValue, minMaxValueFound);\n                if (value ${t} currMinMaxValue) {\n                  minMaxValue = value;\n                  minMaxValueFound = 1.0;\n                  minMaxPosition = ${r?s?`(((batch * ${e.inDepth} + xD) * ${e.inHeight} + xR) * ${e.inWidth} + xC) * ${e.inChannels} + ch`:`((xD * ${e.inHeight} + xR) * ${e.inWidth} + xC) * ${e.inChannels} + ch`:`wD * ${p} * ${f} +\n                      wR * ${f} + wC`};\n                }\n              }\n            }\n          }\n          setOutput(float(minMaxPosition));\n        }\n      `);
}let w=`${t}(${t}(${t}(minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])`;"avg"===t&&(w="avgValue / max(count, 1.0)");const v=4*Math.floor(i/4),k=i%4,I=`\n      if (${x}) {\n        avgValue += dot(values, ones);\n      } else {\n        minMaxValue = max(values, minMaxValue);\n      }\n    `;this.userCode=`\n      const ivec3 strides =\n        ivec3(${a}, ${o}, ${u});\n      const ivec3 pads = ivec3(${m}, ${g}, ${b});\n      const float initializationValue = ${y};\n      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);\n\n      float count = 0.0;\n\n      float getValue(int batch, int xD, int xR, int xC, int ch) {\n        if (xC < 0 || xC >= ${e.inWidth}) {\n          return initializationValue;\n        }\n        count += 1.0;\n        return getX(batch, xD, xR, xC, ch);\n      }\n\n      void main() {\n        ivec5 coords = getOutputCoords();\n        int batch = coords.x;\n        int ch = coords.u;\n\n        ivec3 xCorner = ivec3(coords.y, coords.z, coords.w) * strides - pads;\n        int xDCorner = xCorner.x;\n        int xRCorner = xCorner.y;\n        int xCCorner = xCorner.z;\n\n        // max/min x(?, ?, ?, d) to get y(yD, yR, yC, ch).\n        // ? = to be determined\n        vec4 minMaxValue = vec4(${y});\n        float avgValue = 0.0;\n        count = 0.0;\n\n        for (int wD = 0; wD < ${d};\n            wD += ${l}) {\n          int xD = xDCorner + wD;\n\n          if (xD < 0 || xD >= ${e.inDepth}) {\n            continue;\n          }\n\n          for (int wR = 0; wR < ${p};\n            wR += ${c}) {\n            int xR = xRCorner + wR;\n\n            if (xR < 0 || xR >= ${e.inHeight}) {\n              continue;\n            }\n\n            for (int wC = 0; wC < ${v}; wC += 4) {\n              int xC = xCCorner + wC * ${h};\n\n              vec4 values = vec4(\n                getValue(batch, xD, xR, xC, ch),\n                getValue(batch, xD, xR, xC + ${h}, ch),\n                getValue(batch, xD, xR, xC + 2 * ${h}, ch),\n                getValue(batch, xD, xR, xC + 3 * ${h}, ch)\n              );\n\n              ${I}\n            }\n\n            int xC = xCCorner + ${v};\n            if (${1===k}) {\n              vec4 values = vec4(\n                getValue(batch, xD, xR, xC, ch),\n                initializationValue,\n                initializationValue,\n                initializationValue\n              );\n\n              ${I}\n            } else if (${2===k}) {\n              vec4 values = vec4(\n                getValue(batch, xD, xR, xC, ch),\n                getValue(batch, xD, xR, xC + ${h}, ch),\n                initializationValue,\n                initializationValue\n              );\n\n              ${I}\n            } else if (${3===k}) {\n              vec4 values = vec4(\n                getValue(batch, xD, xR, xC, ch),\n                getValue(batch, xD, xR, xC + ${h}, ch),\n                getValue(batch, xD, xR, xC + 2 * ${h}, ch),\n                initializationValue\n              );\n\n              ${I}\n            }\n          }\n        }\n        setOutput(${w});\n      }\n    `;
}
}const oR={kernelName:he,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t;MN(s,"avgPool");const{filterSize:i,strides:a,pad:o,dimRoundingMode:u}=r;d(Pa(a,1),(()=>`Error in avgPool: Either strides or dilations must be 1. Got strides ${a} and dilations '1'`));const l=Ea(s.shape,i,a,1,o,u);if(1===l.filterWidth&&1===l.filterHeight&&g(l.inShape,l.outShape)){
return qT({inputs:{x:s},backend:n});
}const c=new iR(l,"avg",!1);return n.runWebGLProgram(c,[s],"float32");
}},uR={kernelName:pe,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{filterSize:i,strides:a,pad:o,dimRoundingMode:u,dataFormat:l}=r,c=Ra(s.shape,i,a,[1,1,1],o,u,l),h=new aR(c,"avg",!1);return n.runWebGLProgram(h,[s],"float32");
}};class lR{
constructor(e){
this.variableNames=["dy"],this.outputShape=e.inShape;const t=e.filterHeight,n=e.filterWidth,r=e.strideHeight,s=e.strideWidth,i=e.dilationHeight,a=e.dilationWidth,o=e.effectiveFilterHeight,u=e.effectiveFilterWidth,l=o-1-e.padInfo.top,c=u-1-e.padInfo.left,h=1/(t*n);this.userCode=`\n      const ivec2 pads = ivec2(${l}, ${c});\n      const float avgMultiplier = float(${h});\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n\n        ivec2 dyRCCorner = coords.yz - pads;\n        int dyRCorner = dyRCCorner.x;\n        int dyCCorner = dyRCCorner.y;\n\n        // Convolve dy(?, ?, d) with pos mask(:, :, d) to get dx(xR, xC, d).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        for (int wR = 0; wR < ${o};\n            wR += ${i}) {\n          float dyR = float(dyRCorner + wR) / ${r}.0;\n\n          if (dyR < 0.0 || dyR >= ${e.outHeight}.0 || fract(dyR) > 0.0) {\n            continue;\n          }\n          int idyR = int(dyR);\n\n          for (int wC = 0; wC < ${u};\n            wC+= ${a}) {\n            float dyC = float(dyCCorner + wC) / ${s}.0;\n\n            if (dyC < 0.0 || dyC >= ${e.outWidth}.0 ||\n                fract(dyC) > 0.0) {\n              continue;\n            }\n            int idyC = int(dyC);\n\n            float dyValue = getDy(b, idyR, idyC, d);\n\n            dotProd += dyValue * avgMultiplier;\n          }\n        }\n        setOutput(dotProd);\n      }\n    `;
}
}class cR{
constructor(e){
this.variableNames=["dy"],this.outputShape=e.inShape;const t=e.filterDepth,n=e.filterHeight,r=e.filterWidth,s=e.strideDepth,i=e.strideHeight,a=e.strideWidth,o=e.dilationDepth,u=e.dilationHeight,l=e.dilationWidth,c=e.effectiveFilterDepth,h=e.effectiveFilterHeight,d=e.effectiveFilterWidth,p=c-1-e.padInfo.front,f=h-1-e.padInfo.top,m=d-1-e.padInfo.left,g=1/(t*n*r);this.userCode=`\n      const ivec3 pads = ivec3(${p}, ${f}, ${m});\n      const float avgMultiplier = float(${g});\n\n      void main() {\n        ivec5 coords = getOutputCoords();\n        int batch = coords.x;\n        int ch = coords.u;\n\n        ivec3 dyCorner = ivec3(coords.y, coords.z, coords.w) - pads;\n        int dyDCorner = dyCorner.x;\n        int dyRCorner = dyCorner.y;\n        int dyCCorner = dyCorner.z;\n\n        // Convolve dy(?, ?, ?, d) with pos mask(:, :, :, ch) to get\n        // dx(xD, xR, xC, ch).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n\n        for (int wD = 0; wD < ${c};\n            wD += ${o}) {\n          float dyD = float(dyDCorner + wD) / ${s}.0;\n\n          if (dyD < 0.0 || dyD >= ${e.outDepth}.0 || fract(dyD) > 0.0) {\n            continue;\n          }\n          int idyD = int(dyD);\n\n          for (int wR = 0; wR < ${h};\n              wR += ${u}) {\n            float dyR = float(dyRCorner + wR) / ${i}.0;\n\n            if (dyR < 0.0 || dyR >= ${e.outHeight}.0 ||\n                fract(dyR) > 0.0) {\n              continue;\n            }\n            int idyR = int(dyR);\n\n            for (int wC = 0; wC < ${d};\n                wC += ${l}) {\n              float dyC = float(dyCCorner + wC) / ${a}.0;\n\n              if (dyC < 0.0 || dyC >= ${e.outWidth}.0 ||\n                  fract(dyC) > 0.0) {\n                continue;\n              }\n              int idyC = int(dyC);\n\n              float dyValue = getDy(batch, idyD, idyR, idyC, ch);\n\n              dotProd += dyValue * avgMultiplier;\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    `;
}
}const hR={kernelName:fe,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{dy:s,input:i}=t,a=i,{filterSize:o,strides:u,pad:l,dimRoundingMode:c}=r,h=Ra(a.shape,o,u,[1,1,1],l,c),d=new cR(h);return n.runWebGLProgram(d,[s],a.dtype);
}},dR={kernelName:de,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{dy:s,input:i}=t,a=i;MN([s,i],"avgPoolGrad");const{filterSize:o,strides:u,pad:l}=r,c=Ea(a.shape,o,u,1,l),h=new lR(c);return n.runWebGLProgram(h,[s],a.dtype);
}},pR={kernelName:me,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{a:s,b:i}=t,{transposeA:a,transposeB:o}=r;return NE({a:s,b:i,transposeA:a,transposeB:o,backend:n});
}};class fR{
constructor(e,t,n,r,s,i){
this.outputShape=[],this.variableNames=["x","mean","variance"],Hi(e,t),Hi(e,n);let a="0.0";null!=r&&(Hi(e,r),this.variableNames.push("offset"),a="getOffsetAtOutCoords()");let o="1.0";null!=s&&(Hi(e,s),this.variableNames.push("scale"),o="getScaleAtOutCoords()"),this.outputShape=e,this.userCode=`\n      void main() {\n        float x = getXAtOutCoords();\n        float mean = getMeanAtOutCoords();\n        float variance = getVarianceAtOutCoords();\n        float offset = ${a};\n        float scale = ${o};\n        float inv = scale * inversesqrt(variance + float(${i}));\n        setOutput(dot(vec3(x, -mean, offset), vec3(inv, inv, 1)));\n      }\n    `;
}
}class mR{
constructor(e,t,n,r,s,i){
this.packedInputs=!0,this.packedOutput=!0,this.variableNames=["x","mean","variance"],Hi(e,t),Hi(e,n);let a="vec4(0.0)";null!=r&&(Hi(e,r),this.variableNames.push("offset"),a="getOffsetAtOutCoords()");let o="vec4(1.0)";null!=s&&(Hi(e,s),this.variableNames.push("scale"),o="getScaleAtOutCoords()"),this.outputShape=e,this.userCode=`\n      void main() {\n        vec4 offset = ${a};\n        vec4 scale = ${o};\n\n        vec4 x = getXAtOutCoords();\n        vec4 mean = getMeanAtOutCoords();\n        vec4 variance = getVarianceAtOutCoords();\n\n        vec4 inv = scale * inversesqrt(variance + vec4(${i}));\n\n        setOutput((x - mean) * inv + offset);\n      }\n    `;
}
}const gR={kernelName:at,backendName:"webgl",kernelFunc:({inputs:e,backend:t,attrs:n})=>{
const{x:r,mean:s,variance:i,offset:a,scale:o}=e;d(s.shape.length===i.shape.length,(()=>"Batch normalization gradient requires mean and variance to have equal ranks.")),d(null==a||s.shape.length===a.shape.length,(()=>"Batch normalization gradient requires mean and offset to have equal ranks.")),d(null==o||s.shape.length===o.shape.length,(()=>"Batch normalization gradient requires mean and scale to have equal ranks."));let{varianceEpsilon:u}=n;null==u&&(u=.001);const l=[r,s,i];let c=null;null!=a&&(c=a.shape,l.push(a));let h=null;null!=o&&(h=o.shape,l.push(o));const p=H().getBool("WEBGL_PACK_NORMALIZATION")?new mR(r.shape,s.shape,i.shape,c,h,u):new fR(r.shape,s.shape,i.shape,c,h,u);return t.runWebGLProgram(p,l,l[0].dtype);
}};class bR{
constructor(e){
this.variableNames=["source"],this.outputShape=e,this.rank=e.length;const t=QN(this.rank);this.customUniforms=[{name:"start",arrayIndex:this.rank,type:"int"}];const n=function(e){
if(1===e){
return"sourceLoc";
}if(e<=6){
return xR.slice(0,e).map((e=>"sourceLoc."+e)).join(",");
}throw Error(`Slicing for rank ${e} is not yet supported`);
}(this.rank);let r;r=`\n        ${t} sourceLoc;\n        ${t} coords = getOutputCoords();\n        ${e.map(((e,t)=>`sourceLoc.${xR[t]} = start[${t}] + coords.${xR[t]};`)).join("\n")}\n      `,this.userCode=`\n      void main() {\n        ${r}\n        setOutput(getSource(${n}));\n      }\n    `;
}
}const xR=["x","y","z","w","u","v"];class yR{
constructor(e){
this.variableNames=["source"],this.packedInputs=!0,this.packedOutput=!0,this.outputShape=e,this.rank=e.length,this.customUniforms=[{name:"start",arrayIndex:this.rank,type:"int"}];const t=QN(this.rank),n=gT("coords",this.rank),r=gT("sourceLoc",this.rank),s=1===this.rank?"sourceLoc":`vec2(${r.slice(-2).join()})`,i=`getChannel(getSource(${r.join()}), ${s})`,a=`\n      result.x = ${i};\n      if (++${n[this.rank-1]} < ${e[this.rank-1]}) {\n        ++${r[this.rank-1]};\n        result.y = ${i};\n        --${r[this.rank-1]};\n      }\n    `,o=1===this.rank?"":`\n      --${n[this.rank-1]};\n      if (++${n[this.rank-2]} < ${e[this.rank-2]}) {\n        ++${r[this.rank-2]};\n        result.z = ${i};\n        if (++${n[this.rank-1]} < ${e[this.rank-1]}) {\n          ++${r[this.rank-1]};\n          result.w = ${i};\n        }\n      }\n    `,u=this.rank<=4?`sourceLoc = coords +\n            ${t}(${e.map(((e,t)=>`start[${t}]`)).join()});`:e.map(((e,t)=>`${r[t]} = ${n[t]} + start[${t}];`)).join("\n");this.userCode=`\n      void main() {\n        ${t} coords = getOutputCoords();\n        ${t} sourceLoc;\n        ${u}\n        vec4 result = vec4(0.);\n        ${a}\n        ${o}\n        setOutput(result);\n      }\n    `;
}
}function wR(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{begin:i,size:a}=r,[o,u]=ka(s,i,a);if(ua(s,o,u),0===m(u)){
return n.makeTensorInfo(u,s.dtype,[]);
}if(n.shouldExecuteOnCPU([s])||"string"===s.dtype){
const e=n.texData.get(s.dataId),t=eT(e.values,o,u,s.shape,s.dtype);return n.makeTensorInfo(u,s.dtype,t);
}const{isPacked:l}=n.texData.get(s.dataId),c=wa(s.shape,o,u);if(l||!c){
const e=H().getBool("WEBGL_PACK_ARRAY_OPERATIONS")?new yR(u):new bR(u),t=[o];return n.runWebGLProgram(e,[s],s.dtype,t);
}return n.uploadToGPU(s.dataId),function(e,t,n,r){
const s=r.texData.get(e.dataId),i=r.makeTensorInfo(n,e.dtype),a=r.texData.get(i.dataId);Object.assign(a,s),a.refCount=1,a.shape=n,a.dtype=e.dtype;let o=va(t,_(e.shape));s.slice&&(o+=s.slice.flatOffset),a.slice={flatOffset:o,origDataId:s.slice&&s.slice.origDataId||e.dataId};const u=r.dataRefCount.get(a.slice.origDataId)||1;return r.dataRefCount.set(a.slice.origDataId,u+1),i;
}(s,o,u,n);
}const vR={kernelName:kn,backendName:"webgl",kernelFunc:wR},kR={kernelName:ge,backendName:"webgl",kernelFunc:e=>{
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{blockShape:i,crops:a}=r;d(s.shape.length<=4,(()=>"batchToSpaceND for rank > 4 with a WebGL backend not implemented yet"));const o=i.reduce(((e,t)=>e*t)),u=Wl(s.shape,i,o),l=Vl(u.length,i.length),c=Gl(s.shape,i,o),h=jl(a,i.length),p=Hl(c,a,i.length),f=[],m=pE({inputs:{x:s},backend:n,attrs:{shape:u}}),g=IE({inputs:{x:m},backend:n,attrs:{perm:l}}),b=pE({inputs:{x:g},backend:n,attrs:{shape:c}}),x=wR({inputs:{x:b},backend:n,attrs:{begin:h,size:p}});return f.push(m),f.push(g),f.push(b),f.forEach((e=>n.disposeIntermediateTensorInfo(e))),x;
}},IR={kernelName:be,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s,weights:i}=t,{size:a}=r,o=n.readSync(s.dataId),u=n.readSync(i.dataId),l=v$(o,u,i.dtype,i.shape,a);return n.makeTensorInfo([a],i.dtype,l);
}},SR={kernelName:xe,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n}=e,{a:r,b:s}=t,i=H().getBool("WEBGL_PACK_BINARY_OPERATIONS"),a=H().getNumber("WEBGL_VERSION");if(n.shouldExecuteOnCPU([r,s])||1===a){
const e=n.texData.get(r.dataId).values,t=n.texData.get(s.dataId).values,[i,a]=I$(r.shape,s.shape,e,t,r.dtype),o=n.makeTensorInfo(a,r.dtype);return n.texData.get(o.dataId).values=i,o;
}let o;return o=i?new HT("\n  int r = int(a.r) & int(b.r);\n  int g = int(a.g) & int(b.g);\n  int rb = int(a.b) & int(b.b);\n  int ra = int(a.a) & int(b.a);\n  return vec4(r, g, rb, ra);\n",r.shape,s.shape,!1):new GT("\n  return float(int(a.r) & int(b.r));\n",r.shape,s.shape),n.runWebGLProgram(o,[r,s],r.dtype);
}},CR={kernelName:ye,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n}=e,{s0:r,s1:s}=t,i=n.readSync(r.dataId),a=n.readSync(s.dataId),o=Hi(Array.from(i),Array.from(a));return n.makeTensorInfo([o.length],"int32",Int32Array.from(o));
}},NR=iE({opSnippet:"return float(a != b);",cpuKernelImpl:G$,dtype:"bool"}),$R={kernelName:Vt,backendName:"webgl",kernelFunc:NR};function TR(e){
const{inputs:t,backend:n}=e,{input:r}=t;return qT({inputs:{x:n.texData.get(r.dataId).complexTensorInfos.real},backend:n});
}const ER={kernelName:sn,backendName:"webgl",kernelFunc:TR},RR={kernelName:we,backendName:"webgl",kernelFunc:function e(t){
const{inputs:n,backend:r,attrs:s}=t,{x:i}=n,{dtype:a}=s;if("complex64"===a){
if("complex64"===i.dtype){
return qT({inputs:{x:i},backend:r});
}const t=Ko(i.shape),n=e({inputs:{x:i},backend:r,attrs:{dtype:"float32"}}),s=XT({inputs:{real:n,imag:t},backend:r});return t.dispose(),r.disposeIntermediateTensorInfo(n),s;
}if("complex64"===i.dtype){
const t=TR({inputs:{input:i},backend:r}),n=e({inputs:{x:t},backend:r,attrs:{dtype:a}});return r.disposeIntermediateTensorInfo(t),n;
}if(!N(i.dtype,a)){
const e=qT({inputs:{x:i},backend:r});return{dataId:e.dataId,shape:e.shape,dtype:a};
}if(r.shouldExecuteOnCPU([i])){
const e=r.texData.get(i.dataId).values,[t,n,s]=S$(e,i.shape,i.dtype,a);return r.makeTensorInfo(t,n,s);
}if("int32"===a){
return function(e,t){
const n=new IT(e.shape,"return float(int(x));"),r=t.runWebGLProgram(n,[e],"int32");return{dataId:r.dataId,shape:r.shape,dtype:r.dtype};
}(i,r);
}if("bool"===a){
const e=r.makeTensorInfo([],"bool",S("bool",1)),t=NR({inputs:{a:i,b:e},backend:r});return r.disposeIntermediateTensorInfo(e),t;
}throw new Error(`Error in Cast: failed to cast ${i.dtype} to ${a}`);
}},AR="return ceil(x);",FR=sE({opSnippet:AR,packedOpSnippet:AR,cpuKernelImpl:C$}),_R={kernelName:ve,backendName:"webgl",kernelFunc:FR};class DR{
constructor(e){
this.variableNames=["A"],this.customUniforms=[{name:"minVal",type:"float"},{name:"maxVal",type:"float"}],this.outputShape=e,this.userCode="\n\n      void main() {\n        float value = getAAtOutCoords();\n        if (isnan(value)) {\n          setOutput(value);\n          return;\n        }\n\n        setOutput(clamp(value, minVal, maxVal));\n      }\n    ";
}
}class OR{
constructor(e){
this.variableNames=["A"],this.packedInputs=!0,this.packedOutput=!0,this.customUniforms=[{name:"minVal",type:"float"},{name:"maxVal",type:"float"}],this.outputShape=e,this.userCode="\n      void main() {\n        vec4 value = getAAtOutCoords();\n\n        if (any(isnan(value))) {\n          setOutput(value);\n          return;\n        }\n\n        setOutput(clamp(value, vec4(minVal), vec4(maxVal)));\n      }\n    ";
}
}const MR={kernelName:ke,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{clipValueMin:i,clipValueMax:a}=r;let o;o=H().getBool("WEBGL_PACK_CLIP")?new OR(s.shape):new DR(s.shape);const u=[[i],[a]];return n.runWebGLProgram(o,[s],s.dtype,u);
}};class LR{
constructor(e){
this.variableNames=["real","imag"],this.outputShape=e,this.userCode="\n      void main() {\n        float re = abs(getRealAtOutCoords());\n        float im = abs(getImagAtOutCoords());\n        float mx = max(re, im);\n\n        // sadly the length function in glsl is not underflow-safe\n        // (at least not on Intel GPUs). So the safe solution is\n        // to ensure underflow-safety in all cases.\n        setOutput(\n          mx == 0.0 ? 0.0 : mx * length(vec2(1, min(re, im)/mx))\n        );\n      }\n    ";
}
}function zR(e,t){
return{dataId:t.dataId,dtype:t.dtype,shape:e.shape};
}const PR={kernelName:Se,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n}=e,{x:r}=t,s=n.texData.get(r.dataId),i=new LR(r.shape),a=[zR(r,s.complexTensorInfos.real),zR(r,s.complexTensorInfos.imag)];return n.runWebGLProgram(i,a,a[0].dtype);
}};class BR{
constructor(e){
this.outputShape=[],this.outputShape=_l(e,1),this.variableNames=e.map(((e,t)=>`T${t}`));const t=new Array(e.length-1);t[0]=e[0][1];for(let n=1;n<t.length;n++){
t[n]=t[n-1]+e[n][1];
}const n=[`if (yC < ${t[0]}) setOutput(getT0(yR, yC));`];for(let e=1;e<t.length;e++){
const r=t[e-1];n.push(`else if (yC < ${t[e]}) setOutput(getT${e}(yR, yC-${r}));`);
}const r=t.length,s=t[t.length-1];n.push(`else setOutput(getT${r}(yR, yC-${s}));`),this.userCode=`\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int yR = coords.x;\n        int yC = coords.y;\n\n        ${n.join("\n        ")}\n      }\n    `;
}
}class UR{
constructor(e,t){
this.packedInputs=!0,this.packedOutput=!0,this.outputShape=[],this.outputShape=_l(e,t);const n=this.outputShape,r=n.length,s=QN(r),i=gT("coords",r),a=["x","y","z","w","u","v"].slice(0,r);this.variableNames=e.map(((e,t)=>`T${t}`));const o=new Array(e.length-1);o[0]=e[0][t];for(let n=1;n<o.length;n++){
o[n]=o[n-1]+e[n][t];
}const u=a[t],l=a.slice(-2),c=a.join();let h=`if (${u} < ${o[0]}) {\n        return getChannel(\n            getT0(${c}), vec2(${l.join()}));\n        }`;for(let e=1;e<o.length;e++){
const t=o[e-1];h+=`\n        if (${u} < ${o[e]}  && ${u} >= ${o[e-1]}) {\n          return getChannel(\n            getT${e}(${WR(a,u,t)}),\n            vec2(${WR(l,u,t)}));\n        }`;
}const d=o.length,p=o[o.length-1];h+=`\n        return getChannel(\n          getT${d}(${WR(a,u,p)}),\n          vec2(${WR(l,u,p)}));`,this.userCode=`\n      float getValue(${a.map((e=>"int "+e))}) {\n        ${h}\n      }\n\n      void main() {\n        ${s} coords = getOutputCoords();\n        vec4 result = vec4(getValue(${i}), 0., 0., 0.);\n\n        ${i[r-1]} = ${i[r-1]} + 1;\n        if (${i[r-1]} < ${n[r-1]}) {\n          result.g = getValue(${i});\n        }\n\n        ${i[r-2]} = ${i[r-2]} + 1;\n        if (${i[r-2]} < ${n[r-2]}) {\n          result.a = getValue(${i});\n        }\n\n        ${i[r-1]} = ${i[r-1]} - 1;\n        if (${i[r-2]} < ${n[r-2]} &&\n            ${i[r-1]} < ${n[r-1]}) {\n          result.b = getValue(${i});\n        }\n        setOutput(result);\n      }\n    `;
}
}function WR(e,t,n){
const r=e.indexOf(t);return e.map(((e,t)=>t===r?`${e} - ${n}`:e)).join();
}function VR(e){
const{inputs:t,backend:n}=e,{input:r}=t;return qT({inputs:{x:n.texData.get(r.dataId).complexTensorInfos.imag},backend:n});
}const GR={kernelName:pt,backendName:"webgl",kernelFunc:VR};function jR(e,t,n){
const r=e[0].dtype;if("complex64"===r){
const r=e.map((e=>TR({inputs:{input:e},backend:n}))),s=e.map((e=>VR({inputs:{input:e},backend:n}))),i=jR(r,t,n),a=jR(s,t,n),o=XT({inputs:{real:i,imag:a},backend:n});return r.forEach((e=>n.disposeIntermediateTensorInfo(e))),s.forEach((e=>n.disposeIntermediateTensorInfo(e))),n.disposeIntermediateTensorInfo(i),n.disposeIntermediateTensorInfo(a),o;
}let s=n.shouldExecuteOnCPU(e);if("string"===r&&(s=!0),s){
const s=e.map((e=>{
const r=m(e.shape.slice(t));return pE({inputs:{x:e},backend:n,attrs:{shape:[-1,r]}});
})),i=s.map((e=>({vals:n.readSync(e.dataId),shape:e.shape}))),a=_l(s.map((e=>e.shape)),1),o=1===s[0].shape[0],u=N$(i,a,r,o),l=_l(e.map((e=>e.shape)),t),c=n.makeTensorInfo(l,r,u);return s.forEach((e=>n.disposeIntermediateTensorInfo(e))),c;
}const i=e.filter((e=>m(e.shape)>0)),a=H().getBool("WEBGL_PACK_ARRAY_OPERATIONS")&&i[0].shape.length>1;if(1===i.length){
const t=a?new IT(e[0].shape,RT):new LT(e[0].shape,RT);return n.runWebGLProgram(t,e,r);
}const o=H().getNumber("WEBGL_MAX_TEXTURES_IN_SHADER");if(i.length>o){
const e=[];for(let r=0;r<i.length;r+=o){
const s=i.slice(r,r+o);e.push(jR(s,t,n));
}const r=jR(e,t,n);for(const t of e){
n.disposeIntermediateTensorInfo(t);
}return r;
}if(a){
const e=new UR(i.map((e=>e.shape)),t);return n.runWebGLProgram(e,i,r);
}const{tensors2D:u,outShape:l}=function(e,t,n){
const r=_l(e.map((e=>e.shape)),t);return{tensors2D:e.map((e=>pE({inputs:{x:e},attrs:{shape:[-1,m(e.shape.slice(t))]},backend:n}))),outShape:r};
}(i,t,n),c=new BR(u.map((e=>e.shape))),h=n.runWebGLProgram(c,u,r);u.forEach((e=>n.disposeIntermediateTensorInfo(e)));const d=pE({inputs:{x:h},attrs:{shape:l},backend:n});return n.disposeIntermediateTensorInfo(h),d;
}function HR(e){
const{inputs:t,backend:n,attrs:r}=e,{axis:s}=r,i=k(s,t[0].shape)[0];Fl(t.map((e=>e.shape)),i);const a=_l(t.map((e=>e.shape)),i);if(0===m(a)){
return n.makeTensorInfo(a,t[0].dtype,[]);
}const o=t.filter((e=>m(e.shape)>0));return 1===o.length?qT({inputs:{x:o[0]},backend:n}):jR(o,i,n);
}const qR={kernelName:Ce,backendName:"webgl",kernelFunc:HR};class KR{
constructor(e,t=!1,n=null,r=!1,s=!1){
this.variableNames=["x","W"],this.outputShape=e.outShape;const i=e.padInfo.top,a=e.padInfo.left,o=e.strideHeight,u=e.strideWidth,l=e.dilationHeight,c=e.dilationWidth,h=e.filterHeight,d=e.filterWidth,p=4*Math.floor(e.inChannels/4),f=e.inChannels%4,m="channelsLast"===e.dataFormat,g=m?1:2,b=m?2:3,x=m?3:1;let y="",w="";n&&(y=r?`float activation(float a) {\n          float b = getPreluActivationWeightsAtOutCoords();\n          ${n}\n        }`:s?`float activation(float a) {\n          float b = getLeakyreluAlphaAtOutCoords();\n          ${n}\n        }`:`\n          float activation(float x) {\n            ${n}\n          }\n        `,w="result = activation(result);");const v=t?"result += getBiasAtOutCoords();":"";t&&this.variableNames.push("bias"),r&&this.variableNames.push("preluActivationWeights"),s&&this.variableNames.push("leakyreluAlpha"),this.userCode=`\n      ${y}\n\n      const ivec2 strides = ivec2(${o}, ${u});\n      const ivec2 pads = ivec2(${i}, ${a});\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords[0];\n        int d2 = coords[${x}];\n\n        ivec2 xRCCorner =\n            ivec2(coords[${g}], coords[${b}]) * strides - pads;\n        int xRCorner = xRCCorner.x;\n        int xCCorner = xRCCorner.y;\n\n        // Convolve x(?, ?, d1) with w(:, :, d1, d2) to get y(yR, yC, d2).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        for (int wR = 0; wR < ${h}; wR++) {\n          int xR = xRCorner + wR * ${l};\n\n          if (xR < 0 || xR >= ${e.inHeight}) {\n            continue;\n          }\n\n          for (int wC = 0; wC < ${d}; wC++) {\n            int xC = xCCorner + wC * ${c};\n\n            if (xC < 0 || xC >= ${e.inWidth}) {\n              continue;\n            }\n\n            for (int d1 = 0; d1 < ${p}; d1 += 4) {\n              vec4 wValues = vec4(\n                getW(wR, wC, d1, d2),\n                getW(wR, wC, d1 + 1, d2),\n                getW(wR, wC, d1 + 2, d2),\n                getW(wR, wC, d1 + 3, d2)\n              );\n\n              if (${m}) {\n                vec4 xValues = vec4(\n                  getX(batch, xR, xC, d1),\n                  getX(batch, xR, xC, d1 + 1),\n                  getX(batch, xR, xC, d1 + 2),\n                  getX(batch, xR, xC, d1 + 3)\n                );\n                dotProd += dot(xValues, wValues);\n              } else {\n                vec4 xValues = vec4(\n                  getX(batch, d1, xR, xC),\n                  getX(batch, d1 + 1, xR, xC),\n                  getX(batch, d1 + 2, xR, xC),\n                  getX(batch, d1 + 3, xR, xC)\n                );\n                dotProd += dot(xValues, wValues);\n              }\n            }\n\n            if (${1===f}) {\n\n              if (${m}) {\n                dotProd +=\n                    getX(batch, xR, xC, ${p}) *\n                    getW(wR, wC, ${p}, d2);\n              } else {\n                dotProd +=\n                    getX(batch, ${p}, xR, xC) *\n                    getW(wR, wC, ${p}, d2);\n              }\n\n            } else if (${2===f}) {\n              vec2 wValues = vec2(\n                getW(wR, wC, ${p}, d2),\n                getW(wR, wC, ${p} + 1, d2)\n              );\n\n              if (${m}) {\n                vec2 xValues = vec2(\n                  getX(batch, xR, xC, ${p}),\n                  getX(batch, xR, xC, ${p} + 1)\n                );\n                dotProd += dot(xValues, wValues);\n              } else {\n                vec2 xValues = vec2(\n                  getX(batch, ${p}, xR, xC),\n                  getX(batch, ${p} + 1, xR, xC)\n                );\n                dotProd += dot(xValues, wValues);\n              }\n\n            } else if (${3===f}) {\n              vec3 wValues = vec3(\n                getW(wR, wC, ${p}, d2),\n                getW(wR, wC, ${p} + 1, d2),\n                getW(wR, wC, ${p} + 2, d2)\n              );\n\n              if (${m}) {\n                vec3 xValues = vec3(\n                  getX(batch, xR, xC, ${p}),\n                  getX(batch, xR, xC, ${p} + 1),\n                  getX(batch, xR, xC, ${p} + 2)\n                );\n                dotProd += dot(xValues, wValues);\n              } else {\n                vec3 xValues = vec3(\n                  getX(batch, ${p}, xR, xC),\n                  getX(batch, ${p} + 1, xR, xC),\n                  getX(batch, ${p} + 2, xR, xC)\n                );\n                dotProd += dot(xValues, wValues);\n              }\n\n            }\n          }\n        }\n\n        float result = dotProd;\n        ${v}\n        ${w}\n        setOutput(result);\n      }\n    `;
}
}class XR{
constructor(e){
this.variableNames=["x","W"],this.outputShape=e.outShape;const t=e.padInfo.front,n=e.padInfo.top,r=e.padInfo.left,s=e.strideDepth,i=e.strideHeight,a=e.strideWidth,o=e.dilationDepth,u=e.dilationHeight,l=e.dilationWidth,c=e.filterDepth,h=e.filterHeight,d=e.filterWidth,p=4*Math.floor(e.inChannels/4),f=e.inChannels%4;this.userCode=`\n      const ivec3 strides = ivec3(${s}, ${i}, ${a});\n      const ivec3 pads = ivec3(${t}, ${n}, ${r});\n\n      void main() {\n        ivec5 coords = getOutputCoords();\n        int batch = coords.x;\n        int d2 = coords.u;\n\n        ivec3 xFRCCorner = ivec3(coords.y, coords.z, coords.w) * strides - pads;\n        int xFCorner = xFRCCorner.x;\n        int xRCorner = xFRCCorner.y;\n        int xCCorner = xFRCCorner.z;\n\n        // Convolve x(?, ?, ?, d1) with w(:, :, :, d1, d2) to get\n        // y(yF, yR, yC, d2). ? = to be determined. : = across all\n        // values in that axis.\n        float dotProd = 0.0;\n        for (int wF = 0; wF < ${c}; wF++) {\n          int xF = xFCorner + wF * ${o};\n\n          if (xF < 0 || xF >= ${e.inDepth}) {\n            continue;\n          }\n\n          for (int wR = 0; wR < ${h}; wR++) {\n            int xR = xRCorner + wR * ${u};\n\n            if (xR < 0 || xR >= ${e.inHeight}) {\n              continue;\n            }\n\n            for (int wC = 0; wC < ${d}; wC++) {\n              int xC = xCCorner + wC * ${l};\n\n              if (xC < 0 || xC >= ${e.inWidth}) {\n                continue;\n              }\n\n              for (int d1 = 0; d1 < ${p}; d1 += 4) {\n                vec4 xValues = vec4(\n                  getX(batch, xF, xR, xC, d1),\n                  getX(batch, xF, xR, xC, d1 + 1),\n                  getX(batch, xF, xR, xC, d1 + 2),\n                  getX(batch, xF, xR, xC, d1 + 3)\n                );\n                vec4 wValues = vec4(\n                  getW(wF, wR, wC, d1, d2),\n                  getW(wF, wR, wC, d1 + 1, d2),\n                  getW(wF, wR, wC, d1 + 2, d2),\n                  getW(wF, wR, wC, d1 + 3, d2)\n                );\n\n                dotProd += dot(xValues, wValues);\n              }\n\n              if (${1===f}) {\n                dotProd +=\n                  getX(batch, xF, xR, xC, ${p}) *\n                  getW(wF, wR, wC, ${p}, d2);\n              } else if (${2===f}) {\n                vec2 xValues = vec2(\n                  getX(batch, xF, xR, xC, ${p}),\n                  getX(batch, xF, xR, xC, ${p} + 1)\n                );\n                vec2 wValues = vec2(\n                  getW(wF, wR, wC, ${p}, d2),\n                  getW(wF, wR, wC, ${p} + 1, d2)\n                );\n                dotProd += dot(xValues, wValues);\n              } else if (${3===f}) {\n                vec3 xValues = vec3(\n                  getX(batch, xF, xR, xC, ${p}),\n                  getX(batch, xF, xR, xC, ${p} + 1),\n                  getX(batch, xF, xR, xC, ${p} + 2)\n                );\n                vec3 wValues = vec3(\n                  getW(wF, wR, wC, ${p}, d2),\n                  getW(wF, wR, wC, ${p} + 1, d2),\n                  getW(wF, wR, wC, ${p} + 2, d2)\n                );\n                dotProd += dot(xValues, wValues);\n              }\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    `;
}
}class YR{
constructor(e,t=!1,n=null,r=!1,s=!1){
this.variableNames=["x","W"],this.packedInputs=!0,this.packedOutput=!0,this.customUniforms=[{name:"pads",type:"ivec2"},{name:"strides",type:"ivec2"},{name:"dilations",type:"ivec2"},{name:"inDims",type:"ivec2"}],this.outputShape=e.outShape,this.enableShapeUniforms=i$(this.outputShape.length);const i=e.padInfo.left,a=e.strideWidth,o=e.dilationWidth,u=e.filterHeight,l=e.filterWidth,h=l;let d="\n       int xR; int xC; int xCOffset;\n       vec4 wTexel; vec4 previous; vec4 final;";for(let e=0;e<l;e++){
d+=`\n           vec4 xTexelC${2*e};\n           int xTexelC${2*e}Ready;\n           vec4 xTexelC${2*e+1};\n           int xTexelC${2*e+1}Ready;\n           vec4 xC${e};`;
}d+=`\n     for (int r = 0; r < ${u}; r++) {\n      for (int d1 = 0; d1 < ${e.inChannels}; d1 += 2) {\n       `;for(let e=0;e<l;e++){
d+=`\n           xTexelC${2*e} = vec4(0.0);\n           xTexelC${2*e}Ready = 0;\n           xTexelC${2*e+1} = vec4(0.0);\n           xTexelC${2*e+1}Ready = 0;\n           xC${e} = vec4(0.0);`;
}d+="\n         xR = xRCorner + r * dilations[0];\n         if (xR >=0 && xR < inDims[0]) {\n       ";for(let t=0;t<(h+1)/2;t++){
const n=2*t;if(d+=`\n           xC = xCCorner + ${n*o};\n           `,1===a){
if(n<l&&(i%2==1?(d+=`\n                 xCOffset = xC + 1;\n                 if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${n}Ready == 0) {\n                   xTexelC${n} = getX(batch, xR, xCOffset, d1);\n\n                   // Need to manually clear unused channels in case\n                   // we're reading from recycled texture.\n                   if (xCOffset + 1 >= inDims[1]) {\n                     xTexelC${n}.zw = vec2(0.0);\n                   }\n                   xTexelC${n}Ready = 1;\n                 }\n               `,d+=1===o&&n>0?`\n                 xC${n} = vec4(xTexelC${n-2}.zw, xTexelC${n}.xy);\n                 `:`\n                   xCOffset = xC + 1 - 2;\n\n                   if (xCOffset >= 0 && xCOffset < inDims[1]) {\n                     previous = getX(batch, xR, xCOffset, d1);\n\n                     // Need to manually clear unused channels in case\n                     // we're reading from recycled texture.\n                     if (xCOffset + 1 >= inDims[1]) {\n                       previous.zw = vec2(0.0);\n                     }\n\n                     xC${n} = vec4(previous.zw, xTexelC${n}.xy);\n                   } else {\n                     xC${n} = vec4(0.0, 0.0, xTexelC${n}.xy);\n                   }\n                   `):d+=`\n                 if (xC >= 0 && xC < inDims[1] && xTexelC${n}Ready == 0) {\n                   xTexelC${n} = getX(batch, xR, xC, d1);\n                   if (xC + 1 >= inDims[1]) {\n                     xTexelC${n}.zw = vec2(0.0);\n                   }\n                   xTexelC${n}Ready = 1;\n                 }\n\n                 xC${n} = xTexelC${n};\n                 `,n+1<l)){
const e=i%2==0?c(o):o;o%2==0&&i%2==1||o%2!=0&&i%2!=1?(d+=`\n                   xCOffset = xC + imod(pads[1], 2) + ${e};\n\n                   if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${n+1}Ready == 0) {\n                     xTexelC${n+1} = getX(batch, xR, xCOffset, d1);\n\n                     // Need to manually clear unused channels in case\n                     // we're reading from recycled texture.\n                     if (xCOffset + 1 >= inDims[1]) {\n                       xTexelC${n+1}.zw = vec2(0.0);\n                     }\n                     xTexelC${n+1}Ready = 1;\n                   }\n                   `,d+=o>1?`\n                     xCOffset -= 2;\n                     if (xCOffset >= 0 && xCOffset < inDims[1]) {\n                      previous = getX(batch, xR, xCOffset, d1);\n                      xC${n+1} = vec4(previous.zw, xTexelC${n+1}.xy);\n                     } else {\n                      xC${n+1} = vec4(0.0, 0.0, xTexelC${n+1}.xy);\n                     }\n                     `:`\n                     xC${n+1} = vec4(xTexelC${n}.zw, xTexelC${n+1}.xy);\n                     `):d+=1===e?`\n                     xC${n+1} = xTexelC${n};\n                     `:`\n                     xCOffset = xC + ${e};\n\n                     if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${n+1}Ready == 0) {\n                       xTexelC${n+1} = getX(batch, xR, xCOffset, d1);\n                       if (xCOffset + 1 >= inDims[1]) {\n                         xTexelC${n+1}.zw = vec2(0.0);\n                       }\n                       xTexelC${n+1}Ready = 1;\n                     }\n\n                     xC${n+1} = xTexelC${n+1};\n                     `;
}
}else {
n<l&&(i%2==1?(d+=`\n                 xCOffset = xC + 1 - strides[1];\n                 if(xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${n}Ready == 0) {\n                   xTexelC${n} = getX(batch, xR, xCOffset, d1);\n                   // Need to manually clear unused channels in case\n                   // we're reading from recycled texture.\n                   if (xCOffset + 1 >= inDims[1]) {\n                     xTexelC${n}.zw = vec2(0.0);\n                   }\n                   xTexelC${n}Ready = 1;\n                 }\n\n                 if(xC + 1 >= 0 && xC + 1 < inDims[1] && xTexelC${n+1}Ready == 0) {\n                   xTexelC${n+1} = getX(batch, xR, xC + 1, d1);\n                   // Need to manually clear unused channels in case\n                   // we're reading from recycled texture.\n                   if (xC + 2 >= inDims[1]) {\n                     xTexelC${n+1}.zw = vec2(0.0);\n                   }\n                   xTexelC${n+1}Ready = 1;\n                 }\n\n                 xC${n} = vec4(xTexelC${n}.zw, xTexelC${n+1}.zw);\n               `,n+1<l&&(d+=`\n                   final = vec4(0.0);\n                   xCOffset = xC + 1 + strides[1];\n                   if(xCOffset >= 0 && xCOffset < inDims[1]) {\n                     final = getX(batch, xR, xCOffset, d1);\n                   }\n                   xC${n+1} = vec4(xTexelC${n+1}.xy, final.xy);\n                 `)):(d+=`\n                 if(xC >= 0 && xC < inDims[1] && xTexelC${n}Ready == 0) {\n                   xTexelC${n} = getX(batch, xR, xC, d1);\n                   if (xC + 1 >= inDims[1]) {\n                     xTexelC${n}.zw = vec2(0.0);\n                   }\n                   xTexelC${n}Ready = 1;\n                 }\n\n                 xCOffset = xC + strides[1];\n                 if(xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${n+1}Ready == 0) {\n                   xTexelC${n+1} = getX(batch, xR, xCOffset, d1);\n                   if (xCOffset + 1 >= inDims[1]) {\n                     xTexelC${n+1}.zw = vec2(0.);\n                   }\n                   xTexelC${n+1}Ready = 1;\n                 }\n\n                 xC${n} = vec4(\n                   xTexelC${n}.xy, xTexelC${n+1}.xy);\n               `,n+1<l&&(d+=`\n                   xC${n+1} = vec4(xTexelC${n}.zw, xTexelC${n+1}.zw);\n                 `)));
}n<l&&(d+=`\n             wTexel = getW(r, ${n}, d1, d2);\n             dotProd += xC${n}.xxzz * vec4(wTexel.xy, wTexel.xy);\n             if(d1 + 1 < ${e.inChannels}) {\n               dotProd += xC${n}.yyww * vec4(wTexel.zw, wTexel.zw);\n             }\n           `,n+1<l&&(d+=`\n               wTexel = getW(r, ${n+1}, d1, d2);\n               dotProd += xC${n+1}.xxzz * vec4(wTexel.xy, wTexel.xy);\n               if(d1 + 1 < ${e.inChannels}) {\n                 dotProd += xC${n+1}.yyww * vec4(wTexel.zw, wTexel.zw);\n               }\n             `));
}d+="\n     }\n   ",d+="\n     }\n   ",d+="\n     }\n   ";let p="",f="";n&&(p=r?`vec4 activation(vec4 a) {\n           vec4 b = getPreluActivationWeightsAtOutCoords();\n           ${n}\n         }`:s?`vec4 activation(vec4 a) {\n           vec4 b = getLeakyreluAlphaAtOutCoords();\n           ${n}\n         }`:`vec4 activation(vec4 x) {\n           ${n}\n         }`,f="result = activation(result);");const m=t?"result += getBiasAtOutCoords();":"";t&&this.variableNames.push("bias"),r&&this.variableNames.push("preluActivationWeights"),s&&this.variableNames.push("leakyreluAlpha"),this.userCode=`\n       ${p}\n\n       void main() {\n         ivec4 coords = getOutputCoords();\n         int batch = coords.x;\n         ivec2 xRCCorner = coords.yz * strides - pads;\n         int d2 = coords.w;\n         int xRCorner = xRCCorner.x;\n         int xCCorner = xRCCorner.y;\n\n         //intialize dotProd with a small epsilon seems to reduce GPU accuracy loss.\n         vec4 dotProd = vec4(0.000000000000001);\n\n         ${d}\n\n         vec4 result = dotProd - vec4(0.000000000000001);\n         ${m}\n         ${f}\n         setOutput(result);\n       }\n     `;
}
}class ZR{
constructor(e,t){
this.variableNames=["A"],this.packedInputs=!0,this.packedOutput=!0,this.customUniforms=[{name:"inputShape",type:"ivec4"},{name:"pad",type:"ivec2"},{name:"stride",type:"ivec2"},{name:"dilation",type:"ivec2"},{name:"inChannels",type:"int"},{name:"itemsPerBlockRow",type:"int"},{name:"outWidth",type:"int"}],this.outputShape=e,this.enableShapeUniforms=i$(this.outputShape.length);const{dataFormat:n}=t,r=zN(),s="channelsLast"===n,i=s?1:2,a=s?2:3,o=this.enableShapeUniforms?"if(blockIndex < outShape[2] && pos < outShape[1]) {":`if(blockIndex < ${e[2]} && pos < ${e[1]}) {`;let u="";for(let e=0;e<=1;e++){
for(let t=0;t<=1;t++){
u+=`\n          blockIndex = rc.z + ${t};\n          pos = rc.y + ${e};\n\n          ${o}\n            offsetY = int(blockIndex / outWidth) * stride[0] - pad[0];\n            d0 = offsetY + dilation[0] * (pos / itemsPerBlockRow);\n\n            if(d0 < inputShape[${i}] && d0 >= 0) {\n              // Use custom imod instead mod. On Intel GPU, mod may generate\n              // unexpected value.\n              // https://github.com/tensorflow/tfjs/issues/5447\n              offsetX = imod(blockIndex, outWidth) * stride[1] - pad[1];\n              d1 = offsetX + dilation[1] * (imod(pos, itemsPerBlockRow) /\n                  inChannels);\n\n              if(d1 < inputShape[${a}] && d1 >= 0) {\n\n                ch = imod(pos, inChannels);\n\n                if (${s}) {\n                  innerDims = vec2(d1, ch);\n                  result[${2*e+t}] = getChannel(\n                    getA(rc.x, d0, int(innerDims.x),\n                    int(innerDims.y)), innerDims);\n                } else {\n                  innerDims = vec2(d0, d1);\n                  result[${2*e+t}] = getChannel(\n                    getA(rc.x, ch, int(innerDims.x),\n                    int(innerDims.y)), innerDims);\n                }\n              }\n            }\n          }\n        `;
}
}this.userCode=`\n      void main() {\n        ivec3 rc = getOutputCoords();\n\n        vec4 result = vec4(0);\n\n        int blockIndex, pos, offsetY, d0, offsetX, d1, ch;\n        vec2 innerDims;\n\n        ${u}\n\n        ${r.output} = result;\n      }\n    `;
}
}function JR(e,t){
const n=e.length;return n>=3?t?[...e.slice(0,-3),e[n-3]*e[n-2],e[n-1]]:[...e.slice(0,-3),e[n-3],e[n-2]*e[n-1]]:!t&&1===n&&e[0]>1?[e[0],1]:null;
}function QR({x:e,filter:t,convInfo:n,backend:r,bias:s=null,preluActivationWeights:i=null,leakyreluAlpha:a=0,activation:o=null}){
const u=e.shape,l=r.texData.get(e.dataId),c=n.inChannels,h=u[0]*u[1]*u[2],p=n.outChannels,f="channelsLast"===n.dataFormat;let m;const b=[];if(null!=i){
const e=JR(i.shape,f);null!=e&&(i=pE({inputs:{x:i},backend:r,attrs:{shape:e}}),b.push(i));
}if(null!=s){
const e=JR(s.shape,f);null!=e&&(s=pE({inputs:{x:s},backend:r,attrs:{shape:e}}),b.push(s));
}if((1!==h&&1!==p||!(c>CE))&&l.isPacked&&f&&null!=l.texture&&u[2]%2!=0&&g(l.shape.slice(-3),u.slice(-3))){
const c=u[0]*u[1]*(u[2]+1),h={dataId:e.dataId,shape:[1,c,n.inChannels],dtype:e.dtype},p=l.shape;l.shape=l.shape.slice(),l.shape[l.shape.length-2]++,d(RN(l.shape,h.shape),(()=>`packed reshape ${l.shape} to ${h.shape} isn't free`));const f=pE({inputs:{x:t},backend:r,attrs:{shape:[1,n.inChannels,n.outChannels]}});b.push(f);const g=NE({a:h,b:f,backend:r,transposeA:!1,transposeB:!1,bias:s,activation:o,preluActivationWeights:i,leakyreluAlpha:a}),x=r.texData.get(g.dataId);d(x.isPacked,(()=>"batchMatMul result is expected to be packed")),l.shape=p,x.shape=n.outShape,m=qT({inputs:{x:g},backend:r}),m.shape=n.outShape,b.push(g);
}else{
const u=n.outHeight*n.outWidth,l=pE({inputs:{x:e},backend:r,attrs:{shape:f?[n.batchSize,u,n.inChannels]:[n.batchSize,n.inChannels,u]}}),c=pE({inputs:{x:t},backend:r,attrs:{shape:[1,n.inChannels,n.outChannels]}}),h=NE({a:f?l:c,b:f?c:l,transposeA:!f,transposeB:!1,backend:r,bias:s,activation:o,preluActivationWeights:i,leakyreluAlpha:a});m=pE({inputs:{x:h},backend:r,attrs:{shape:n.outShape}}),b.push(l),b.push(c),b.push(h);
}for(const e of b){
r.disposeIntermediateTensorInfo(e);
}return m;
}function eA({x:e,filter:t,convInfo:n,backend:r,bias:s=null,preluActivationWeights:i=null,leakyreluAlpha:a=0,activation:o=null}){
const{filterWidth:u,filterHeight:l,inChannels:c,outWidth:h,outHeight:d,dataFormat:p}=n,f="channelsLast"===p,g=u*l*c,b=d*h,x=[n.batchSize,g,b],y=[];if(null!=i){
const e=JR(i.shape,f);null!=e&&(i=pE({inputs:{x:i},backend:r,attrs:{shape:e}}),y.push(i));
}if(null!=s){
const e=JR(s.shape,f);null!=e&&(s=pE({inputs:{x:s},backend:r,attrs:{shape:e}}),y.push(s));
}const w=pE({inputs:{x:t},backend:r,attrs:{shape:[1,g,m(t.shape)/g]}});y.push(w);const v=new ZR(x,n),k=[e.shape,[n.padInfo.top,n.padInfo.left],[n.strideHeight,n.strideWidth],[n.dilationHeight,n.dilationWidth],[n.inChannels],[n.filterWidth*n.inChannels],[n.outWidth]],I=r.runWebGLProgram(v,[e],"float32",k),S=pE({inputs:{x:I},backend:r,attrs:{shape:x}});y.push(I),y.push(S);const C=null!=s,N=null!=i,$="leakyrelu"===o,T=o?aE(o,!0):null,E=new oE(f?S.shape:w.shape,f?w.shape:S.shape,f?[n.batchSize,b,n.outChannels]:[n.batchSize,n.outChannels,b],!0,!1,C,T,N,$),R=f?[S,w]:[w,S];if(s&&R.push(s),N&&R.push(i),$){
const e=r.makeTensorInfo([],"float32",Fr(a,"float32"));R.push(e),y.push(e);
}const A=r.runWebGLProgram(E,R,"float32"),F=pE({inputs:{x:A},backend:r,attrs:{shape:n.outShape}});y.push(A);for(const e of y){
r.disposeIntermediateTensorInfo(e);
}return F;
}const tA={kernelName:Ne,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s,filter:i}=t,{strides:a,pad:o,dataFormat:u,dilations:l,dimRoundingMode:c}=r,h=Ua(u),d=Aa(s.shape,i.shape,a,l,o,c,!1,h);let p;if(1!==d.filterHeight||1!==d.filterWidth||1!==d.dilationHeight||1!==d.dilationWidth||1!==d.strideHeight||1!==d.strideWidth||"SAME"!==d.padInfo.type&&"VALID"!==d.padInfo.type){
if(d.strideWidth<=2&&"channelsLast"===h&&H().getBool("WEBGL_EXP_CONV")){
const e=new YR(d),t=[[d.padInfo.top,d.padInfo.left],[d.strideHeight,d.strideWidth],[d.dilationHeight,d.dilationWidth],[d.inHeight,d.inWidth]];p=n.runWebGLProgram(e,[s,i],"float32",t);
}else if(H().getBool("WEBGL_CONV_IM2COL")){
p=eA({x:s,filter:i,convInfo:d,backend:n});
}else{
const e=new KR(d);p=n.runWebGLProgram(e,[s,i],"float32");
}
}else {
p=QR({x:s,filter:i,convInfo:d,backend:n});
}const f=pE({inputs:{x:p},backend:n,attrs:{shape:d.outShape}});return n.disposeIntermediateTensorInfo(p),f;
}};class nA{
constructor(e){
this.variableNames=["x","dy"],this.outputShape=e.filterShape;const t=e.strideHeight,n=e.strideWidth,r=e.padInfo.top,s=e.padInfo.left,i="channelsLast"===e.dataFormat;this.userCode=`\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int wR = coords.x;\n        int wC = coords.y;\n        int d1 = coords.z;\n        int d2 = coords.w;\n\n        // Convolve x(?, ?, d1) with dy(:, :, d2) to get dw(wR, wC, d1, d2).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n\n        for (int b = 0; b < ${e.batchSize}; b++) {\n          for (int yR = 0; yR < ${e.outHeight}; yR++) {\n            int xR = wR + yR * ${t} - ${r};\n\n            if (xR < 0 || xR >= ${e.inHeight}) {\n              continue;\n            }\n\n            for (int yC = 0; yC < ${e.outWidth}; yC++) {\n              int xC = wC + yC * ${n} - ${s};\n\n              if (xC < 0 || xC >= ${e.inWidth}) {\n                continue;\n              }\n\n              ${i?"float dyValue = getDy(b, yR, yC, d2);\n              float xValue = getX(b, xR, xC, d1);\n              dotProd += (xValue * dyValue);":"float dyValue = getDy(b, d2, yR, yC);\n              float xValue = getX(b, d1, xR, xC);\n              dotProd += (xValue * dyValue);"}\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    `;
}
}class rA{
constructor(e){
this.variableNames=["dy","W"],this.outputShape=e.inShape;const t=e.filterHeight,n=e.filterWidth,r=e.strideHeight,s=e.strideWidth,i="channelsLast"===e.dataFormat,a=t-1-e.padInfo.top,o=n-1-e.padInfo.left,u=i?1:2,l=i?2:3,c=i?3:1;this.userCode=`\n      const ivec2 pads = ivec2(${a}, ${o});\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords[0];\n        int d1 = coords[${c}];\n\n        ivec2 dyCorner = ivec2(coords[${u}], coords[${l}]) - pads;\n        int dyRCorner = dyCorner.x;\n        int dyCCorner = dyCorner.y;\n\n        // Convolve dy(?, ?, d2) with w(:, :, d1, d2) to compute dx(xR, xC, d1).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        for (int wR = 0; wR < ${t}; wR++) {\n          float dyR = float(dyRCorner + wR) / ${r}.0;\n\n          if (dyR < 0.0 || dyR >= ${e.outHeight}.0 || fract(dyR) > 0.0) {\n            continue;\n          }\n          int idyR = int(dyR);\n\n          int wRPerm = ${t} - 1 - wR;\n\n          for (int wC = 0; wC < ${n}; wC++) {\n            float dyC = float(dyCCorner + wC) / ${s}.0;\n\n            if (dyC < 0.0 || dyC >= ${e.outWidth}.0 ||\n                fract(dyC) > 0.0) {\n              continue;\n            }\n            int idyC = int(dyC);\n\n            int wCPerm = ${n} - 1 - wC;\n\n            for (int d2 = 0; d2 < ${e.outChannels}; d2++) {\n\n              if (${i}) {\n                float xValue = getDy(batch, idyR, idyC, d2);\n                float wValue = getW(wRPerm, wCPerm, d1, d2);\n                dotProd += xValue * wValue;\n              } else {\n                float xValue = getDy(batch, d2, idyR, idyC);\n                float wValue = getW(wRPerm, wCPerm, d1, d2);\n                dotProd += xValue * wValue;\n              }\n\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    `;
}
}class sA{
constructor(e){
this.variableNames=["x","dy"],this.outputShape=e.filterShape;const t=e.strideDepth,n=e.strideHeight,r=e.strideWidth,s=e.padInfo.front,i=e.padInfo.top,a=e.padInfo.left;this.userCode=`\n      void main() {\n        ivec5 coords = getOutputCoords();\n        int wF = coords.x;\n        int wR = coords.y;\n        int wC = coords.z;\n        int d1 = coords.w;\n        int d2 = coords.u;\n\n        float dotProd = 0.0;\n\n        for (int b = 0; b < ${e.batchSize}; b++) {\n          for (int yF = 0; yF < ${e.outDepth}; yF++) {\n            int xF = wF + yF * ${t} - ${s};\n\n            if (xF < 0 || xF >= ${e.inDepth}) {\n              continue;\n            }\n\n            for (int yR = 0; yR < ${e.outHeight}; yR++) {\n              int xR = wR + yR * ${n} - ${i};\n\n              if (xR < 0 || xR >= ${e.inHeight}) {\n                continue;\n              }\n\n              for (int yC = 0; yC < ${e.outWidth}; yC++) {\n                int xC = wC + yC * ${r} - ${a};\n\n                if (xC < 0 || xC >= ${e.inWidth}) {\n                  continue;\n                }\n\n                float dyValue = getDy(b, yF, yR, yC, d2);\n                float xValue = getX(b, xF, xR, xC, d1);\n                dotProd += (xValue * dyValue);\n              }\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    `;
}
}class iA{
constructor(e){
this.variableNames=["dy","W"],this.outputShape=e.inShape;const t=e.filterDepth,n=e.filterHeight,r=e.filterWidth,s=e.strideDepth,i=e.strideHeight,a=e.strideWidth,o=t-1-e.padInfo.front,u=n-1-e.padInfo.top,l=r-1-e.padInfo.left;this.userCode=`\n      const ivec3 pads = ivec3(${o}, ${u}, ${l});\n\n      void main() {\n        ivec5 coords = getOutputCoords();\n        int batch = coords.x;\n        int d1 = coords.u;\n\n\n        ivec3 dyCorner = ivec3(coords.y, coords.z, coords.w) - pads;\n        int dyFCorner = dyCorner.x;\n        int dyRCorner = dyCorner.y;\n        int dyCCorner = dyCorner.z;\n\n        float dotProd = 0.0;\n        for (int wF = 0; wF < ${t}; wF++) {\n          float dyF = float(dyFCorner + wF) / ${s}.0;\n\n          if (dyF < 0.0 || dyF >= ${e.outDepth}.0 || fract(dyF) > 0.0) {\n            continue;\n          }\n          int idyF = int(dyF);\n\n          int wFPerm = ${t} - 1 - wF;\n\n          for (int wR = 0; wR < ${n}; wR++) {\n            float dyR = float(dyRCorner + wR) / ${i}.0;\n\n            if (dyR < 0.0 || dyR >= ${e.outHeight}.0 ||\n              fract(dyR) > 0.0) {\n              continue;\n            }\n            int idyR = int(dyR);\n\n            int wRPerm = ${n} - 1 - wR;\n\n            for (int wC = 0; wC < ${r}; wC++) {\n              float dyC = float(dyCCorner + wC) / ${a}.0;\n\n              if (dyC < 0.0 || dyC >= ${e.outWidth}.0 ||\n                  fract(dyC) > 0.0) {\n                continue;\n              }\n              int idyC = int(dyC);\n\n              int wCPerm = ${r} - 1 - wC;\n\n              for (int d2 = 0; d2 < ${e.outChannels}; d2++) {\n                float xValue = getDy(batch, idyF, idyR, idyC, d2);\n                float wValue = getW(wFPerm, wRPerm, wCPerm, d1, d2);\n                dotProd += xValue * wValue;\n              }\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    `;
}
}const aA={kernelName:$e,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s,dy:i}=t,{strides:a,pad:o,dataFormat:u,dimRoundingMode:l,filterShape:c}=r,h=Ua(u),d=Aa(s.shape,c,a,1,o,l,!1,h),p=new nA(d);return n.runWebGLProgram(p,[s,i],"float32");
}};class oA{
constructor(e){
this.variableNames=["dy","W"],this.packedInputs=!0,this.packedOutput=!0,this.customUniforms=[{name:"strides",type:"vec2"}],this.outputShape=e.inShape,this.enableShapeUniforms=i$(this.outputShape.length);const t=e.filterHeight,n=e.filterWidth,r=t-1-e.padInfo.top,s=n-1-e.padInfo.left;this.userCode=`\n      const ivec2 pads = ivec2(${r}, ${s});\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords[0];\n        int d1 = coords[3];\n\n        ivec2 dyCorner = ivec2(coords[1], coords[2]) - pads;\n        int dyRCorner = dyCorner.x;\n        int dyCCorner = dyCorner.y;\n\n        vec4 result = vec4(0.);\n        for (int wR = 0; wR < ${t}; wR++) {\n          float dyR = float(dyRCorner + wR) / strides[0];\n          if (dyR < 0.0 || dyR >= ${e.outHeight}.0 || fract(dyR) > 0.0) {\n            continue;\n          }\n          int idyR = int(dyR);\n          int wRPerm = ${t} - 1 - wR;\n\n          for (int wC = 0; wC < ${n}; wC++) {\n            int wCPerm = ${n} - 1 - wC;\n\n            float dyC = float(dyCCorner + wC) / strides[1];\n            bool idyCVal = (dyC >= 0.0) && (dyC < ${e.outWidth}.0)\n              && (fract(dyC) == 0.0);\n            int idyC = int(dyC);\n\n            float dyC2 = float(dyCCorner + wC + 1) / strides[1];\n            bool idyCVal2 = (dyC2 >= 0.0) && (dyC2 < ${e.outWidth}.0)\n              && (fract(dyC2) == 0.0);\n            int idyC2 = int(dyC2);\n\n            if (idyCVal && idyCVal2) {\n              for (int d2 = 0; d2 < ${e.outChannels}; d2 += 2) {\n                vec4 wValue = getW(wRPerm, wCPerm, d1, d2);\n                vec4 dySample = getDy(batch, idyR, idyC, d2);\n                vec4 dySample2 = (idyC / 2 == idyC2 / 2) ?\n                  dySample : getDy(batch, idyR, idyC2, d2);\n\n                vec2 dyValue = mod(float(idyC), 2.) == 0. ?\n                  dySample.xy : dySample.zw;\n                result.xy += vec2(dot(dyValue, wValue.xy),\n                  dot(dyValue, wValue.zw));\n\n                dyValue = mod(float(idyC2), 2.) == 0. ?\n                  dySample2.xy : dySample2.zw;\n                result.zw += vec2(dot(dyValue, wValue.xy),\n                  dot(dyValue, wValue.zw));\n              }\n            } else if (idyCVal) {\n              for (int d2 = 0; d2 < ${e.outChannels}; d2 += 2) {\n                vec4 wValue = getW(wRPerm, wCPerm, d1, d2);\n                vec4 dySample = getDy(batch, idyR, idyC, d2);\n                vec2 dyValue = mod(float(idyC), 2.) == 0. ?\n                  dySample.xy : dySample.zw;\n                result.xy += vec2(dot(dyValue, wValue.xy),\n                  dot(dyValue, wValue.zw));\n              }\n            } else if (idyCVal2) {\n              for (int d2 = 0; d2 < ${e.outChannels}; d2 += 2) {\n                vec4 wValue = getW(wRPerm, wCPerm, d1, d2);\n                vec4 dySample = getDy(batch, idyR, idyC2, d2);\n                vec2 dyValue = mod(float(idyC2), 2.) == 0. ?\n                  dySample.xy : dySample.zw;\n                result.zw += vec2(dot(dyValue, wValue.xy),\n                  dot(dyValue, wValue.zw));\n              }\n            }\n          }\n        }\n        setOutput(result);\n      }\n    `;
}
}const uA={kernelName:Te,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{dy:s,filter:i}=t,{inputShape:a,strides:o,pad:u,dataFormat:l,dimRoundingMode:c}=r,h=Ua(l),d=Aa(a,i.shape,o,1,u,c,!1,h);if(H().getBool("WEBGL_PACK")&&"channelsLast"===h){
const e=[[d.strideHeight,d.strideWidth]],t=new oA(d);return n.runWebGLProgram(t,[s,i],"float32",e);
}{const e=new rA(d);return n.runWebGLProgram(e,[s,i],"float32");}
}},lA={kernelName:Ee,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s,filter:i}=t,{strides:a,pad:o,dilations:u}=r,l=Fa(s.shape,i.shape,a,u,o),c=new XR(l);return n.runWebGLProgram(c,[s,i],"float32");
}},cA={kernelName:Re,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s,dy:i}=t,{strides:a,pad:o,filterShape:u}=r,l=Fa(s.shape,u,a,1,o),c=new sA(l);return n.runWebGLProgram(c,[s,i],"float32");
}},hA={kernelName:Ae,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{dy:s,filter:i}=t,{pad:a,strides:o,inputShape:u}=r,l=Fa(u,i.shape,o,1,a),c=new iA(l);return n.runWebGLProgram(c,[s,i],"float32");
}},dA=sE({opSnippet:rE+"\n  return cos(x);\n",packedOpSnippet:`\n  vec4 result = cos(x);\n  bvec4 isNaN = isnan(x);\n  ${jT}\n  return result;\n`}),pA={kernelName:Fe,backendName:"webgl",kernelFunc:dA},fA=sE({opSnippet:"\n  float e2x = exp(-x);\n  return (e2x + 1.0 / e2x) / 2.0;\n"}),mA={kernelName:_e,backendName:"webgl",kernelFunc:fA};class gA{
constructor(e,t,n,r,s){
this.variableNames=["Image","Boxes","BoxInd"],this.outputShape=[];const[i,a,o,u]=e,[l]=t,[c,h]=n;this.outputShape=[l,c,h,u];const d="bilinear"===r?1:0,[p,f]=[a-1+".0",o-1+".0"],[m,g,b]=c>1?[""+(a-1)/(c-1),"(y2-y1) * height_ratio",`y1*${p} + float(y)*(height_scale)`]:["0.0","0.0",`0.5 * (y1+y2) * ${p}`],[x,y,w]=h>1?[""+(o-1)/(h-1),"(x2-x1) * width_ratio",`x1*${f} + float(x)*(width_scale)`]:["0.0","0.0",`0.5 * (x1+x2) * ${f}`];this.userCode=`\n      const float height_ratio = float(${m});\n      const float width_ratio = float(${x});\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int y = coords[1];\n        int x = coords[2];\n        int d = coords[3];\n\n        // get box vals\n        float y1 = getBoxes(b,0);\n        float x1 = getBoxes(b,1);\n        float y2 = getBoxes(b,2);\n        float x2 = getBoxes(b,3);\n\n        // get image in batch index\n        int bInd = round(getBoxInd(b));\n        if(bInd < 0 || bInd >= ${i}) {\n          return;\n        }\n\n        float height_scale = ${g};\n        float width_scale = ${y};\n\n        float in_y = ${b};\n        if( in_y < 0.0 || in_y > ${p} ) {\n          setOutput(float(${s}));\n          return;\n        }\n        float in_x = ${w};\n        if( in_x < 0.0 || in_x > ${f} ) {\n          setOutput(float(${s}));\n          return;\n        }\n\n        vec2 sourceFracIndexCR = vec2(in_x,in_y);\n        if(${d} == 1) {\n          // Compute the four integer indices.\n          ivec2 sourceFloorCR = ivec2(sourceFracIndexCR);\n          ivec2 sourceCeilCR = ivec2(ceil(sourceFracIndexCR));\n\n          float topLeft = getImage(b, sourceFloorCR.y, sourceFloorCR.x, d);\n          float bottomLeft = getImage(b, sourceCeilCR.y, sourceFloorCR.x, d);\n          float topRight = getImage(b, sourceFloorCR.y, sourceCeilCR.x, d);\n          float bottomRight = getImage(b, sourceCeilCR.y, sourceCeilCR.x, d);\n\n          vec2 fracCR = sourceFracIndexCR - vec2(sourceFloorCR);\n\n          float top = topLeft + (topRight - topLeft) * fracCR.x;\n          float bottom = bottomLeft + (bottomRight - bottomLeft) * fracCR.x;\n          float newValue = top + (bottom - top) * fracCR.y;\n          setOutput(newValue);\n        } else {\n          // Compute the coordinators of nearest neighbor point.\n          ivec2 sourceNearestCR = ivec2(floor(\n            sourceFracIndexCR + vec2(0.5,0.5)));\n          float newValue = getImage(b, sourceNearestCR.y, sourceNearestCR.x, d);\n          setOutput(newValue);\n        }\n      }\n    `;
}
}const bA={kernelName:Me,backendName:"webgl",kernelFunc:e=>{
const{inputs:t,backend:n,attrs:r}=e,{image:s,boxes:i,boxInd:a}=t,{cropSize:o,method:u,extrapolationValue:l}=r,c=new gA(s.shape,i.shape,o,u,l);return n.runWebGLProgram(c,[s,i,a],"float32");
}};var xA;!function(e){
e.Prod="*",e.Sum="+";
}(xA||(xA={}));class yA{
constructor(e,t,n,r){
this.op=e,this.outputShape=t,this.variableNames=["x"],this.customUniforms=[{name:"index",type:"float"}];const s=this.outputShape.length,i=this.op===xA.Prod?"1.0":"0.0",a=n?i:`getX(${wA(s,"coords",this.op)})`,o=this.outputShape[this.outputShape.length-1];let u="",l="";n?(u=r?"end != "+(o-1):"end != 0",l=r?"end + 1":"end - 1"):(u=r?`end + pow2 < ${o}`:"end >= pow2",l=r?"end + pow2":"end - pow2"),this.userCode=`\n      void main() {\n        ${QN(s)} coords = getOutputCoords();\n        int end = ${vA(s,"coords",this.op)};\n        float val = ${a};\n        int pow2 = int(pow(2.0, index));\n        if (${u}) {\n          int idx = ${l};\n          ${vA(s,"coords",this.op)} = idx;\n          val ${this.op}= getX(${wA(s,"coords",this.op)});\n        }\n        setOutput(val);\n      }\n    `;
}
}function wA(e,t,n){
if(1===e){
return`${t}`;
}if(2===e){
return`${t}.x, ${t}.y`;
}if(3===e){
return`${t}.x, ${t}.y, ${t}.z`;
}if(4===e){
return`${t}.x, ${t}.y, ${t}.z, ${t}.w`;
}throw new Error(`Cumulative ${n} for rank ${e} is not yet supported`);
}function vA(e,t,n){
if(1===e){
return`${t}`;
}if(2===e){
return`${t}.y`;
}if(3===e){
return`${t}.z`;
}if(4===e){
return`${t}.w`;
}throw new Error(`Cumulative ${n} for rank ${e} is not yet supported`);
}function kA(e,t,n,r,s,i){
const a=t.shape.length,o=Uo([r],a);let u=t;null!=o&&(u=IE({inputs:{x:t},backend:n,attrs:{perm:o}}));const l=Vo(1,a)[0];if(l!==a-1){
throw new Error(`WebGL cumprod shader expects an inner-most axis=${t.shape.length-1} but got axis=${r}`);
}const c=u.shape[l];let h=qT({inputs:{x:u},backend:n});for(let t=0;t<=Math.ceil(Math.log2(c))-1;t++){
const r=new yA(e,u.shape,!1,i),s=[[t]],a=h;h=n.runWebGLProgram(r,[h],h.dtype,s),n.disposeIntermediateTensorInfo(a);
}if(s){
const t=new yA(e,u.shape,s,i),r=h;h=n.runWebGLProgram(t,[h],h.dtype),n.disposeIntermediateTensorInfo(r);
}if(null!=o){
const e=IE({inputs:{x:h},backend:n,attrs:{perm:Wo(o)}});return n.disposeIntermediateTensorInfo(h),n.disposeIntermediateTensorInfo(u),e;
}return h;
}const IA={kernelName:De,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{axis:i,exclusive:a,reverse:o}=r;return kA(xA.Prod,s,n,i,a,o);
}},SA={kernelName:Oe,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{axis:i,exclusive:a,reverse:o}=r;return kA(xA.Sum,s,n,i,a,o);
}},CA={kernelName:Le,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s,weights:i}=t,{size:a,binaryOutput:o}=r;if(1===s.shape.length){
const e=n.readSync(s.dataId),t=n.readSync(i.dataId),r=v$(e,t,i.dtype,i.shape,a);return n.makeTensorInfo([a],i.dtype,r);
}if(2===s.shape.length){
const e=n.bufferSync(s),t=n.bufferSync(i),r=k$(e,t,a,o);return n.makeTensorInfo(r.shape,i.dtype,r.values);
}throw new Error(`Error in denseBincount: input must be at most rank 2, but got rank${s.shape.length}.`);
}};class NA{
constructor(e,t,n){
this.variableNames=["x"],this.outputShape=[],this.outputShape=e,this.blockSize=t,this.dataFormat=n,this.userCode=`\n    void main() {\n      ivec4 coords = getOutputCoords();\n      int b = coords[0];\n      int h = ${this.getHeightCoordString()};\n      int w = ${this.getWidthCoordString()};\n      int d = ${this.getDepthCoordString()};\n\n      int in_h = h / ${t};\n      int offset_h = imod(h, ${t});\n      int in_w = w / ${t};\n      int offset_w = imod(w, ${t});\n      int offset_d = (offset_h * ${t} + offset_w) *\n        ${this.getOutputDepthSize()};\n      int in_d = d + offset_d;\n\n      float result = ${this.getInputSamplingString()};\n      setOutput(result);\n    }\n  `;
}getHeightCoordString(){
return"NHWC"===this.dataFormat?"coords[1]":"coords[2]";
}getWidthCoordString(){
return"NHWC"===this.dataFormat?"coords[2]":"coords[3]";
}getDepthCoordString(){
return"NHWC"===this.dataFormat?"coords[3]":"coords[1]";
}getOutputDepthSize(){
return"NHWC"===this.dataFormat?this.outputShape[3]:this.outputShape[1];
}getInputSamplingString(){
return"NHWC"===this.dataFormat?"getX(b, in_h, in_w, in_d)":"getX(b, in_d, in_h, in_w)";
}
}const $A={kernelName:ze,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{blockSize:i,dataFormat:a}=r,o=s.shape[0],u=("NHWC"===a?s.shape[1]:s.shape[2])*i,l=("NHWC"===a?s.shape[2]:s.shape[3])*i,c=("NHWC"===a?s.shape[3]:s.shape[1])/(i*i),h=new NA("NHWC"===a?[o,u,l,c]:[o,c,u,l],i,a);return n.runWebGLProgram(h,[s],s.dtype);
}};class TA{
constructor(e,t=!1,n=null,r=!1,s=!1){
this.variableNames=["x","W"],this.customUniforms=[{name:"pads",type:"ivec2"},{name:"strides",type:"ivec2"},{name:"dilations",type:"ivec2"},{name:"inDims",type:"ivec2"}],this.outputShape=e.outShape,this.enableShapeUniforms=i$(this.outputShape.length);const i=e.filterHeight,a=e.filterWidth,o=e.outChannels/e.inChannels;let u="",l="";n&&(u=r?`float activation(float a) {\n          float b = getPreluActivationWeightsAtOutCoords();\n          ${n}\n        }`:s?`float activation(float a) {\n          float b = getLeakyreluAlphaAtOutCoords();\n          ${n}\n        }`:`\n          float activation(float x) {\n            ${n}\n          }\n        `,l="result = activation(result);");const c=t?"result += getBiasAtOutCoords();":"";t&&this.variableNames.push("bias"),r&&this.variableNames.push("preluActivationWeights"),s&&this.variableNames.push("leakyreluAlpha"),this.userCode=`\n      ${u}\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords.x;\n        ivec2 xRCCorner = coords.yz * strides - pads;\n        int d2 = coords.w;\n        int d1 = d2 / ${o};\n        int q = d2 - d1 * ${o};\n\n        int xRCorner = xRCCorner.x;\n        int xCCorner = xRCCorner.y;\n\n        // Convolve x(?, ?, d1) with w(:, :, d1, q) to get y(yR, yC, d2).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        // TO DO(dsmilkov): Flatten the two for loops and vec4 the operations.\n        for (int wR = 0; wR < ${i}; wR++) {\n          int xR = xRCorner + wR * dilations[0];\n\n          if (xR < 0 || xR >= inDims[0]) {\n            continue;\n          }\n\n          for (int wC = 0; wC < ${a}; wC++) {\n            int xC = xCCorner + wC * dilations[1];\n\n            if (xC < 0 || xC >= inDims[1]) {\n              continue;\n            }\n\n            float xVal = getX(batch, xR, xC, d1);\n            float wVal = getW(wR, wC, d1, q);\n            dotProd += xVal * wVal;\n          }\n        }\n\n        float result = dotProd;\n        ${c}\n        ${l}\n        setOutput(result);\n      }\n    `;
}
}class EA{
constructor(e,t=!1,n=null,r=!1,s=!1){
this.variableNames=["x","W"],this.packedInputs=!0,this.packedOutput=!0,this.customUniforms=[{name:"pads",type:"ivec2"},{name:"strides",type:"ivec2"},{name:"dilations",type:"ivec2"},{name:"inDims",type:"ivec2"}],this.outputShape=e.outShape,this.enableShapeUniforms=i$(this.outputShape.length);const i=e.outChannels/e.inChannels,a=e.padInfo.left,o=e.strideWidth,u=e.dilationWidth,l=e.filterHeight,h=e.filterWidth,d=h;let p="\n      int xR; int xC; int xCOffset;\n      vec4 wTexel; vec4 previous; vec4 final;";for(let e=0;e<h;e++){
p+=`\n          vec4 xTexelC${2*e};\n          int xTexelC${2*e}Ready;\n          vec4 xTexelC${2*e+1};\n          int xTexelC${2*e+1}Ready;\n          vec4 xC${e};`;
}p+=`\n    for (int r = 0; r < ${l}; r++) {\n      `;for(let e=0;e<h;e++){
p+=`\n          xTexelC${2*e} = vec4(0.0);\n          xTexelC${2*e}Ready = 0;\n          xTexelC${2*e+1} = vec4(0.0);\n          xTexelC${2*e+1}Ready = 0;\n          xC${e} = vec4(0.0);`;
}p+="\n        xR = xRCorner + r * dilations[0];\n        if (xR >=0 && xR < inDims[0]) {\n      ";for(let e=0;e<(d+1)/2;e++){
const t=2*e;if(p+=`\n          xC = xCCorner + ${t*u};\n          `,1===o){
if(t<h&&(a%2==1?(p+=`\n                xCOffset = xC + 1;\n                if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${t}Ready == 0) {\n                  xTexelC${t} = getX(batch, xR, xCOffset, d1);\n\n                  // Need to manually clear unused channels in case\n                  // we're reading from recycled texture.\n                  if (xCOffset + 1 >= inDims[1]) {\n                    xTexelC${t}.zw = vec2(0.0);\n                  }\n                  xTexelC${t}Ready = 1;\n                }\n              `,p+=1===u&&t>0?`\n                xC${t} = vec4(xTexelC${t-2}.zw, xTexelC${t}.xy);\n                `:`\n                  xCOffset = xC + 1 - 2;\n\n                  if (xCOffset >= 0 && xCOffset < inDims[1]) {\n                    previous = getX(batch, xR, xCOffset, d1);\n\n                    // Need to manually clear unused channels in case\n                    // we're reading from recycled texture.\n                    if (xCOffset + 1 >= inDims[1]) {\n                      previous.zw = vec2(0.0);\n                    }\n\n                    xC${t} = vec4(previous.zw, xTexelC${t}.xy);\n                  } else {\n                    xC${t} = vec4(0.0, 0.0, xTexelC${t}.xy);\n                  }\n                  `):p+=`\n                if (xC >= 0 && xC < inDims[1] && xTexelC${t}Ready == 0) {\n                  xTexelC${t} = getX(batch, xR, xC, d1);\n                  if (xC + 1 >= inDims[1]) {\n                    xTexelC${t}.zw = vec2(0.0);\n                  }\n                  xTexelC${t}Ready = 1;\n                }\n\n                xC${t} = xTexelC${t};\n                `,t+1<h)){
const e=a%2==0?c(u):u;u%2==0&&a%2==1||u%2!=0&&a%2!=1?(p+=`\n                  xCOffset = xC + imod(pads[1], 2) + ${e};\n\n                  if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${t+1}Ready == 0) {\n                    xTexelC${t+1} = getX(batch, xR, xCOffset, d1);\n\n                    // Need to manually clear unused channels in case\n                    // we're reading from recycled texture.\n                    if (xCOffset + 1 >= inDims[1]) {\n                      xTexelC${t+1}.zw = vec2(0.0);\n                    }\n                    xTexelC${t+1}Ready = 1;\n                  }\n                  `,p+=u>1?`\n                    xCOffset -= 2;\n                    if (xCOffset >= 0 && xCOffset < inDims[1]) {\n                     previous = getX(batch, xR, xCOffset, d1);\n                     xC${t+1} = vec4(previous.zw, xTexelC${t+1}.xy);\n                    } else {\n                     xC${t+1} = vec4(0.0, 0.0, xTexelC${t+1}.xy);\n                    }\n                    `:`\n                    xC${t+1} = vec4(xTexelC${t}.zw, xTexelC${t+1}.xy);\n                    `):p+=1===e?`\n                    xC${t+1} = xTexelC${t};\n                    `:`\n                    xCOffset = xC + ${e};\n\n                    if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${t+1}Ready == 0) {\n                      xTexelC${t+1} = getX(batch, xR, xCOffset, d1);\n                      if (xCOffset + 1 >= inDims[1]) {\n                        xTexelC${t+1}.zw = vec2(0.0);\n                      }\n                      xTexelC${t+1}Ready = 1;\n                    }\n\n                    xC${t+1} = xTexelC${t+1};\n                    `;
}
}else {
t<h&&(a%2==1?(p+=`\n                xCOffset = xC + 1 - strides[1];\n                if(xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${t}Ready == 0) {\n                  xTexelC${t} = getX(batch, xR, xCOffset, d1);\n                  // Need to manually clear unused channels in case\n                  // we're reading from recycled texture.\n                  if (xCOffset + 1 >= inDims[1]) {\n                    xTexelC${t}.zw = vec2(0.0);\n                  }\n                  xTexelC${t}Ready = 1;\n                }\n\n                if(xC + 1 >= 0 && xC + 1 < inDims[1] && xTexelC${t+1}Ready == 0) {\n                  xTexelC${t+1} = getX(batch, xR, xC + 1, d1);\n                  // Need to manually clear unused channels in case\n                  // we're reading from recycled texture.\n                  if (xC + 2 >= inDims[1]) {\n                    xTexelC${t+1}.zw = vec2(0.0);\n                  }\n                  xTexelC${t+1}Ready = 1;\n                }\n\n                xC${t} = vec4(xTexelC${t}.zw, xTexelC${t+1}.zw);\n              `,t+1<h&&(p+=`\n                  final = vec4(0.0);\n                  xCOffset = xC + 1 + strides[1];\n                  if(xCOffset >= 0 && xCOffset < inDims[1]) {\n                    final = getX(batch, xR, xCOffset, d1);\n                  }\n                  xC${t+1} = vec4(xTexelC${t+1}.xy, final.xy);\n                `)):(p+=`\n                if(xC >= 0 && xC < inDims[1] && xTexelC${t}Ready == 0) {\n                  xTexelC${t} = getX(batch, xR, xC, d1);\n                  if (xC + 1 >= inDims[1]) {\n                    xTexelC${t}.zw = vec2(0.0);\n                  }\n                  xTexelC${t}Ready = 1;\n                }\n\n                xCOffset = xC + strides[1];\n                if(xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${t+1}Ready == 0) {\n                  xTexelC${t+1} = getX(batch, xR, xCOffset, d1);\n                  if (xCOffset + 1 >= inDims[1]) {\n                    xTexelC${t+1}.zw = vec2(0.);\n                  }\n                  xTexelC${t+1}Ready = 1;\n                }\n\n                xC${t} = vec4(\n                  xTexelC${t}.xy, xTexelC${t+1}.xy);\n              `,t+1<h&&(p+=`\n                  xC${t+1} = vec4(xTexelC${t}.zw, xTexelC${t+1}.zw);\n                `)));
}t<h&&(p+=`\n            wTexel = getW(r, ${t}, d1, q);\n            dotProd += xC${t} * vec4(wTexel.xz, wTexel.xz);\n          `,t+1<h&&(p+=`\n              wTexel = getW(r, ${t+1}, d1, q);\n              dotProd += xC${t+1} * vec4(wTexel.xz, wTexel.xz);\n            `));
}p+="\n    }\n  ",p+="\n      }\n    ";let f="",m="";n&&(f=r?`vec4 activation(vec4 a) {\n          vec4 b = getPreluActivationWeightsAtOutCoords();\n          ${n}\n        }`:s?`vec4 activation(vec4 a) {\n          vec4 b = getLeakyreluAlphaAtOutCoords();\n          ${n}\n        }`:`vec4 activation(vec4 x) {\n          ${n}\n        }`,m="result = activation(result);");const g=t?"result += getBiasAtOutCoords();":"";t&&this.variableNames.push("bias"),r&&this.variableNames.push("preluActivationWeights"),s&&this.variableNames.push("leakyreluAlpha"),this.userCode=`\n      ${f}\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords.x;\n        ivec2 xRCCorner = coords.yz * strides - pads;\n        int d2 = coords.w;\n        int d1 = d2 / ${i};\n        int q = d2 - d1 * ${i};\n        int xRCorner = xRCCorner.x;\n        int xCCorner = xRCCorner.y;\n\n        //intialize dotProd with a small epsilon seems to reduce GPU accuracy loss.\n        vec4 dotProd = vec4(0.000000000000001);\n\n        ${p}\n\n        vec4 result = dotProd - vec4(0.000000000000001);\n        ${g}\n        ${m}\n        setOutput(result);\n      }\n    `;
}
}const RA={kernelName:Pe,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s,filter:i}=t,{strides:a,pad:o,dilations:u,dimRoundingMode:l}=r;let c=u;null==c&&(c=[1,1]),d(Pa(a,c),(()=>`Error in depthwiseConv2d: Either strides or dilations must be 1. Got strides ${a} and dilations '${c}'`));const h=Aa(s.shape,i.shape,a,c,o,l,!0);let p;p=H().getBool("WEBGL_PACK_DEPTHWISECONV")&&h.strideWidth<=2&&h.outChannels/h.inChannels==1?new EA(h):new TA(h);const f=[[h.padInfo.top,h.padInfo.left],[h.strideHeight,h.strideWidth],[h.dilationHeight,h.dilationWidth],[h.inHeight,h.inWidth]];return n.runWebGLProgram(p,[s,i],"float32",f);
}};class AA{
constructor(e){
this.variableNames=["x","dy"],this.outputShape=e.filterShape;const t=e.strideHeight,n=e.strideWidth,r=e.padInfo.top,s=e.padInfo.left,i=e.outChannels/e.inChannels;this.userCode=`\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int wR = coords.x;\n        int wC = coords.y;\n        int d1 = coords.z;\n        int dm = coords.w;\n        int d2 = d1 * ${i} + dm;\n\n        float dotProd = 0.0;\n\n        // TO DO: Vec4 over the batch size\n        for (int b = 0; b < ${e.batchSize}; b++) {\n          for (int yR = 0; yR < ${e.outHeight}; yR++) {\n            int xR = wR + yR * ${t} - ${r};\n\n            if (xR < 0 || xR >= ${e.inHeight}) {\n              continue;\n            }\n\n            for (int yC = 0; yC < ${e.outWidth}; yC++) {\n              int xC = wC + yC * ${n} - ${s};\n\n              if (xC < 0 || xC >= ${e.inWidth}) {\n                continue;\n              }\n\n              float dyValue = getDy(b, yR, yC, d2);\n              float xValue = getX(b, xR, xC, d1);\n              dotProd += (xValue * dyValue);\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    `;
}
}class FA{
constructor(e){
this.variableNames=["dy","W"],this.outputShape=e.inShape;const t=e.filterHeight,n=e.filterWidth,r=e.strideHeight,s=e.strideWidth,i=t-1-e.padInfo.top,a=n-1-e.padInfo.left,o=e.outChannels/e.inChannels;this.userCode=`\n      const ivec2 pads = ivec2(${i}, ${a});\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords[0];\n        int d1 = coords[3];\n        ivec2 dyCorner = coords.yz - pads;\n        int dyRCorner = dyCorner.x;\n        int dyCCorner = dyCorner.y;\n\n        float dotProd = 0.0;\n\n        for (int wR = 0; wR < ${t}; wR++) {\n          float dyR = float(dyRCorner + wR) / ${r}.0;\n\n          if (dyR < 0.0 || dyR >= ${e.outHeight}.0 || fract(dyR) > 0.0) {\n            continue;\n          }\n          int idyR = int(dyR);\n\n          int wRPerm = ${t} - 1 - wR;\n\n          for (int wC = 0; wC < ${n}; wC++) {\n            float dyC = float(dyCCorner + wC) / ${s}.0;\n\n            if (dyC < 0.0 || dyC >= ${e.outWidth}.0 ||\n                fract(dyC) > 0.0) {\n              continue;\n            }\n            int idyC = int(dyC);\n\n            int wCPerm = ${n} - 1 - wC;\n\n            // TO DO: Vec4 over the channelMul\n            for (int dm = 0; dm < ${o}; dm++) {\n              int d2 = d1 * ${o} + dm;\n              float xValue = getDy(batch, idyR, idyC, d2);\n              float wValue = getW(wRPerm, wCPerm, d1, dm);\n              dotProd += xValue * wValue;\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    `;
}
}const _A={kernelName:Be,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s,dy:i}=t,{strides:a,dilations:o,pad:u,dimRoundingMode:l,filterShape:c}=r,h=Aa(s.shape,c,a,o,u,l,!0),d=new AA(h);return n.runWebGLProgram(d,[s,i],"float32");
}},DA={kernelName:Ue,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{dy:s,filter:i}=t,{strides:a,dilations:o,pad:u,dimRoundingMode:l,inputShape:c}=r,h=Aa(c,i.shape,a,o,u,l,!0),d=new FA(h);return n.runWebGLProgram(d,[s,i],"float32");
}};class OA{
constructor(e){
this.variableNames=["X"],this.outputShape=[e,e],this.userCode="\n      void main() {\n          ivec2 coords = getOutputCoords();\n          float val = coords[0] == coords[1] ? getX(coords[0]) : 0.0;\n          setOutput(val);\n      }\n    ";
}
}const MA={kernelName:We,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n}=e,{x:r}=t,s=[...r.shape,...r.shape],i=m(r.shape),a=pE({inputs:{x:r},backend:n,attrs:{shape:[i]}}),o=new OA(i),u=n.runWebGLProgram(o,[a],a.dtype),l=pE({inputs:{x:u},backend:n,attrs:{shape:s}});return n.disposeIntermediateTensorInfo(a),n.disposeIntermediateTensorInfo(u),l;
}};class LA{
constructor(e){
this.variableNames=["x","W"],this.outputShape=e.outShape;const{inHeight:t,inWidth:n,padInfo:r,strideHeight:s,strideWidth:i,filterHeight:a,filterWidth:o,dilationHeight:u,dilationWidth:l}=e,{top:c,left:h}=r;this.userCode=`\n      const ivec2 strides = ivec2(${s}, ${i});\n      const ivec2 pads = ivec2(${c}, ${h});\n      const float neg_infinity = -3.4e38;\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords.x;\n        int d1 = coords.w;\n        ivec2 outTopLeftCorner =\n            coords.yz * strides - pads;\n        int hBeg = outTopLeftCorner.x;\n        int wBeg = outTopLeftCorner.y;\n\n        float curVal = neg_infinity;\n        for (int h = 0; h < ${a}; h++) {\n          int hIn = hBeg + h * ${u};\n\n          if (hIn >= 0 && hIn < ${t}) {\n            for (int w = 0; w < ${o}; w++) {\n              int wIn = wBeg + w * ${l};\n\n              if (wIn >= 0 && wIn < ${n}) {\n                float xVal = getX(batch, hIn, wIn, d1);\n                float wVal = getW(h, w, d1);\n\n                float val = xVal + wVal;\n                if (val > curVal) {\n                  curVal = val;\n                }\n              }\n            }\n          }\n        }\n\n        float result = curVal;\n        setOutput(result);\n      }\n    `;
}
}const zA={kernelName:Ve,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s,filter:i}=t,{strides:a,pad:o,dilations:u}=r,l=Ta(s.shape,i.shape,a,o,"NHWC",u);let c;const h=new LA(l);c=n.runWebGLProgram(h,[s,i],"float32");const d=pE({inputs:{x:c},backend:n,attrs:{shape:l.outShape}});return n.disposeIntermediateTensorInfo(c),d;
}},PA={kernelName:qe,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{equation:s}=r,i=t,{allDims:a,summedDims:o,idDims:u}=bc(s,i.length);yc(a.length,u,i);const{path:l,steps:c}=wc(o,u),h=c.length;let d=null,p=a.length;const f=[];for(let e=0;e<h;++e){
for(const t of c[e]){
const{permutationIndices:e,expandDims:r}=xc(p,u[t]);let s;vc(e)?s=i[t]:(s=IE({inputs:{x:i[t]},backend:n,attrs:{perm:e}}),f.push(s));const a=s.shape.slice();for(let e=0;e<r.length;++e){
a.splice(r[e],0,1);
}g(s.shape,a)||(s=pE({inputs:{x:s},backend:n,attrs:{shape:a}}),f.push(s)),null===d?d=s:(d=hE({inputs:{a:s,b:d},backend:n}),f.push(d));
}e<h-1&&(l[e]>=0&&(d=vE({inputs:{x:d},backend:n,attrs:{axis:l[e]-(a.length-p),keepDims:!1}}),f.push(d)),p--);
}for(const e of f){
e!==d&&n.disposeIntermediateTensorInfo(e);
}return d;
}},BA=sE({opSnippet:"return (x >= 0.0) ? x : (exp(x) - 1.0);",packedOpSnippet:"\n  vec4 result;\n\n  result.r = (x.r >= 0.0) ? x.r : (exp(x.r) - 1.0);\n  result.g = (x.g >= 0.0) ? x.g : (exp(x.g) - 1.0);\n  result.b = (x.b >= 0.0) ? x.b : (exp(x.b) - 1.0);\n  result.a = (x.a >= 0.0) ? x.a : (exp(x.a) - 1.0);\n\n  return result;\n"}),UA={kernelName:Ke,backendName:"webgl",kernelFunc:BA},WA={kernelName:Xe,backendName:"webgl",kernelFunc:e=>{
const{inputs:t,backend:n}=e,{dy:r,y:s}=t,i=H().getBool("WEBGL_PACK_BINARY_OPERATIONS")?new HT("\n  vec4 bGTEZero = vec4(greaterThanEqual(b, vec4(0.)));\n  return (bGTEZero * a) + ((vec4(1.0) - bGTEZero) * (a * (b + vec4(1.0))));\n",r.shape,s.shape):new GT("return (b >= 0.0) ? a : a * (b + 1.0);",r.shape,s.shape);return n.runWebGLProgram(i,[r,s],r.dtype);
}},VA=iE({opSnippet:"return float(a == b);",packedOpSnippet:"\n  return vec4(equal(a, b));\n",dtype:"bool",cpuKernelImpl:$$}),GA={kernelName:Ze,backendName:"webgl",kernelFunc:VA},jA=sE({opSnippet:`\n  // Error function is calculated approximately with elementary function.\n  // See "Handbook of Mathematical Functions with Formulas,\n  // Graphs, and Mathematical Tables", Abramowitz and Stegun.\n  float p = ${Ql};\n  float a1 = ${ec};\n  float a2 = ${tc};\n  float a3 = ${nc};\n  float a4 = ${rc};\n  float a5 = ${sc};\n\n  float sign = sign(x);\n  x = abs(x);\n  float t = 1.0 / (1.0 + p * x);\n  return sign * (1.0 - (((((a5*t + a4)*t) + a3)*t + a2)*t + a1)*t*exp(-x*x));\n`}),HA={kernelName:Ye,backendName:"webgl",kernelFunc:jA},qA=sE({opSnippet:rE+"\n  return exp(x);\n",packedOpSnippet:"\n  vec4 result = exp(x);\n  bvec4 isNaN = isnan(x);\n  result.r = isNaN.r ? x.r : result.r;\n  result.g = isNaN.g ? x.g : result.g;\n  result.b = isNaN.b ? x.b : result.b;\n  result.a = isNaN.a ? x.a : result.a;\n\n  return result;\n",cpuKernelImpl:T$,dtype:"float32"}),KA={kernelName:Je,backendName:"webgl",kernelFunc:qA};function XA(e){
const{inputs:t,attrs:n,backend:r}=e,{dim:s}=n,{input:i}=t,a=i.shape.length,o=i.shape.slice();let u=s;return s<0&&(d(-(a+1)<=s,(()=>`Axis must be in the interval [${-(a+1)}, ${a}]`)),u=a+s+1),o.splice(u,0,1),pE({inputs:{x:i},backend:r,attrs:{shape:o}});
}const YA={kernelName:Qe,backendName:"webgl",kernelFunc:XA},ZA="return exp(x) - 1.0;",JA=sE({opSnippet:ZA,packedOpSnippet:ZA,cpuKernelImpl:E$}),QA={kernelName:et,backendName:"webgl",kernelFunc:JA};class eF{
constructor(e,t,n){
this.variableNames=["real","imag"];const r=t[1];this.outputShape=t;const s=n?`2.0 * ${Math.PI}`:`-2.0 * ${Math.PI}`,i=n?`${r}.0`:"1.0";let a;if("real"===e){
a="return real * expR - imag * expI;";
}else{
if("imag"!==e){
throw new Error(`FFT component must be either "real" or "imag", got ${e}.`);
}a="return real * expI + imag * expR;";
}this.userCode=`\n      const float exponentMultiplier = ${s};\n\n      float unaryOpComplex(float real, float expR, float imag, float expI) {\n        ${a}\n      }\n\n      float mulMatDFT(int batch, int index) {\n        float indexRatio = float(index) / float(${r});\n        float exponentMultiplierTimesIndexRatio =\n            exponentMultiplier * indexRatio;\n\n        float result = 0.0;\n\n        for (int i = 0; i < ${r}; i++) {\n          // x = (-2|2 * PI / N) * index * i;\n          float x = exponentMultiplierTimesIndexRatio * float(i);\n          float expR = cos(x);\n          float expI = sin(x);\n          float real = getReal(batch, i);\n          float imag = getImag(batch, i);\n\n          result +=\n              unaryOpComplex(real, expR, imag, expI) / ${i};\n        }\n\n        return result;\n      }\n\n      void main() {\n        ivec2 coords = getOutputCoords();\n        setOutput(mulMatDFT(coords[0], coords[1]));\n      }\n    `;
}
}function tF(e,t,n){
const r=n.texData.get(e.dataId),s=m(e.shape),i=e.shape[e.shape.length-1],a=pE({inputs:{x:e},backend:n,attrs:{shape:[s/i,i]}}),o=a.shape,u=new eF("real",o,t),l=new eF("imag",o,t),c=[{dataId:r.complexTensorInfos.real.dataId,dtype:r.complexTensorInfos.real.dtype,shape:o},{dataId:r.complexTensorInfos.imag.dataId,dtype:r.complexTensorInfos.imag.dtype,shape:o}],h=n.runWebGLProgram(u,c,"float32"),d=n.runWebGLProgram(l,c,"float32"),p=XT({inputs:{real:h,imag:d},backend:n});n.disposeIntermediateTensorInfo(h),n.disposeIntermediateTensorInfo(d);const f=pE({inputs:{x:p},backend:n,attrs:{shape:e.shape}});return n.disposeIntermediateTensorInfo(a),n.disposeIntermediateTensorInfo(p),f;
}const nF={kernelName:tt,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n}=e,{input:r}=t;return tF(r,!1,n);
}};class rF{
constructor(e,t){
this.outputShape=[],this.customUniforms=[{name:"value",type:"float"}],this.variableNames=["x"],this.outputShape=e,this.userCode="\n      void main() {\n        // Input can be obtained from uniform value.\n        setOutput(value);\n      }\n    ";
}
}function sF(e){
const{backend:t,attrs:n}=e,{shape:r,value:s}=n;let{dtype:i}=n;if(i=i||R(s),"string"===i){
const e=C(i,m(r));return e.fill(s),t.makeTensorInfo(r,i,e);
}{const e=new rF(r,s),n=[[s]];return t.runWebGLProgram(e,[],i,n);}
}const iF={kernelName:nt,backendName:"webgl",kernelFunc:sF};class aF{
constructor(e){
this.variableNames=["Image"],this.outputShape=[];const t=e[2];this.outputShape=e,this.userCode=`\n        void main() {\n          ivec4 coords = getOutputCoords();\n          int x = coords[2];\n\n          int coordX = ${t} - x - 1;\n          float outputValue;\n          if(coordX >= 0 && coordX < ${t}) {\n            outputValue = getImage(coords[0], coords[1], coordX, coords[3]);\n          } else {\n            outputValue = getImage(coords[0], coords[1], coords[2], coords[3]);\n          }\n          setOutput(outputValue);\n        }\n    `;
}
}const oF={kernelName:rt,backendName:"webgl",kernelFunc:({inputs:e,backend:t})=>{
const{image:n}=e,r=t,s=new aF(n.shape);return r.runWebGLProgram(s,[n],n.dtype);
}},uF="return floor(x);",lF=sE({opSnippet:uF,packedOpSnippet:uF,cpuKernelImpl:R$}),cF={kernelName:st,backendName:"webgl",kernelFunc:lF},hF=iE({opSnippet:"\n  float s = sign(a) * sign(b);\n  int ia = round(a);\n  int ib = round(b);\n  if (ib != 0) {\n    // Windows (D3D) wants guaranteed non-zero int division at compile-time.\n    return float(idiv(ia, ib, s));\n  } else {\n    return NAN;\n  }\n",packedOpSnippet:"\n  ivec4 ia = round(a);\n  ivec4 ib = round(b);\n  bvec4 cond = notEqual(ib, ivec4(0));\n  ivec4 result = ivec4(0);\n  vec4 s = sign(a) * sign(b);\n\n  // Windows (D3D) wants guaranteed non-zero int division at compile-time.\n  if (cond[0]) {\n    result[0] = idiv(ia[0], ib[0], s[0]);\n  }\n  if (cond[1]) {\n    result[1] = idiv(ia[1], ib[1], s[1]);\n  }\n  if (cond[2]) {\n    result[2] = idiv(ia[2], ib[2], s[2]);\n  }\n  if (cond[3]) {\n    result[3] = idiv(ia[3], ib[3], s[3]);\n  }\n  return vec4(result);\n",dtype:"int32"}),dF={kernelName:it,backendName:"webgl",kernelFunc:hF};class pF{
constructor(e){
this.variableNames=["A"];const t=zN(),[n,r]=e;this.outputShape=e,this.userCode=`\n      void main() {\n        ivec3 coords = getOutputCoords();\n        int texR = coords[0];\n        int texC = coords[1];\n        int depth = coords[2];\n        vec2 uv = (vec2(texC, texR) + halfCR) / vec2(${r}.0, ${n}.0);\n\n        vec4 values = ${t.texture2D}(A, uv);\n        float value;\n        if (depth == 0) {\n          value = values.r;\n        } else if (depth == 1) {\n          value = values.g;\n        } else if (depth == 2) {\n          value = values.b;\n        } else if (depth == 3) {\n          value = values.a;\n        }\n\n        setOutput(floor(value * 255.0 + 0.5));\n      }\n    `;
}
}class fF{
constructor(e){
this.variableNames=["A"],this.packedInputs=!1,this.packedOutput=!0;const t=zN(),[n,r]=e;this.outputShape=e,this.userCode=`\n      void main() {\n        ivec3 coords = getOutputCoords();\n        int texR = coords[0];\n        int texC = coords[1];\n        int depth = coords[2];\n\n        vec4 result = vec4(0.);\n\n        for(int row=0; row<=1; row++) {\n          for(int col=0; col<=1; col++) {\n            texC = coords[1] + row;\n            depth = coords[2] + col;\n\n            vec2 uv = (vec2(texC, texR) + halfCR) /\n                       vec2(${r}.0, ${n}.0);\n            vec4 values = ${t.texture2D}(A, uv);\n            float value;\n            if (depth == 0) {\n              value = values.r;\n            } else if (depth == 1) {\n              value = values.g;\n            } else if (depth == 2) {\n              value = values.b;\n            } else if (depth == 3) {\n              value = values.a;\n            }\n\n            result[row * 2 + col] = floor(value * 255.0 + 0.5);\n          }\n        }\n\n        ${t.output} = result;\n      }\n    `;
}
}const mF={kernelName:"FromPixels",backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e;let{pixels:s}=t;const{numChannels:i}=r,a="undefined"!=typeof HTMLVideoElement&&s instanceof HTMLVideoElement,o="undefined"!=typeof HTMLImageElement&&s instanceof HTMLImageElement,[u,l]=a?[s.videoWidth,s.videoHeight]:[s.width,s.height],c=[l,u],h=[l,u,i];if(o||a){
const e=H().getBool("CANVAS2D_WILL_READ_FREQUENTLY_FOR_GPU");null!=gF&&e===bF||(bF=e,gF=document.createElement("canvas").getContext("2d",{willReadFrequently:bF})),gF.canvas.width=u,gF.canvas.height=l,gF.drawImage(s,0,0,u,l),s=gF.canvas;
}const d=n.makeTensorInfo(c,"int32");n.texData.get(d.dataId).usage=uN.PIXELS,n.gpgpu.uploadPixelDataToTexture(n.getTexture(d.dataId),s);const p=H().getBool("WEBGL_PACK")?new fF(h):new pF(h),f=n.runWebGLProgram(p,[d],"int32");return n.disposeData(d.dataId),f;
}};let gF,bF=H().getBool("CANVAS2D_WILL_READ_FREQUENTLY_FOR_GPU");const xF={kernelName:ir,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s,filter:i,bias:a,preluActivationWeights:o}=t,{strides:u,pad:l,dataFormat:c,dilations:h,dimRoundingMode:d,activation:p,leakyreluAlpha:f}=r,m=Ua(c),g=Aa(s.shape,i.shape,u,h,l,d,!1,m);let b;const x=[],y=null!=a,w=null!=o,v="leakyrelu"===p,k=()=>{
const e=[s,i],t=(e,t)=>{
if("NCHW"===t&&1===e.shape.length&&1!==e.shape[0]){
const t=pE({inputs:{x:e},backend:n,attrs:{shape:[e.shape[0],1,1]}});return x.push(t),t;
}return e;
};if(y&&e.push(t(a,c)),w&&e.push(t(o,c)),v){
const t=n.makeTensorInfo([],"float32",Fr(f,"float32"));e.push(t),x.push(t);
}return e;
};if(1!==g.filterHeight||1!==g.filterWidth||1!==g.dilationHeight||1!==g.dilationWidth||1!==g.strideHeight||1!==g.strideWidth||"SAME"!==g.padInfo.type&&"VALID"!==g.padInfo.type){
if(g.strideWidth<=2&&"channelsLast"===m&&H().getBool("WEBGL_EXP_CONV")){
const e=p?aE(p,!0):null,t=new YR(g,y,e,w,v),r=[[g.padInfo.top,g.padInfo.left],[g.strideHeight,g.strideWidth],[g.dilationHeight,g.dilationWidth],[g.inHeight,g.inWidth]],s=k();b=n.runWebGLProgram(t,s,"float32",r);
}else if(H().getBool("WEBGL_CONV_IM2COL")){
b=eA({x:s,filter:i,convInfo:g,backend:n,bias:a,activation:p,preluActivationWeights:o,leakyreluAlpha:f});
}else{
const e=p?aE(p,!1):null,t=new KR(g,y,e,w,v),r=k();b=n.runWebGLProgram(t,r,"float32");
}
}else {
b=QR({x:s,filter:i,convInfo:g,backend:n,bias:a,activation:p,preluActivationWeights:o,leakyreluAlpha:f});
}const I=pE({inputs:{x:b},backend:n,attrs:{shape:g.outShape}});return x.push(b),x.forEach((e=>n.disposeIntermediateTensorInfo(e))),I;
}},yF={kernelName:ar,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s,filter:i,bias:a,preluActivationWeights:o}=t,{strides:u,pad:l,dilations:c,dimRoundingMode:h,activation:p,leakyreluAlpha:f}=r,m=[];let g=c;null==g&&(g=[1,1]),d(Pa(u,g),(()=>`Error in depthwiseConv2d: Either strides or dilations must be 1. Got strides ${u} and dilations '${g}'`));const b=Aa(s.shape,i.shape,u,g,l,h,!0),x=H().getBool("WEBGL_PACK_DEPTHWISECONV")&&b.strideWidth<=2&&b.outChannels/b.inChannels==1,y=p?aE(p,x):null,w=[s,i],v=null!=a,k=null!=o,I="leakyrelu"===p;if(v&&w.push(a),k&&w.push(o),I){
const e=n.makeTensorInfo([],"float32",Fr(f,"float32"));w.push(e),m.push(e);
}let S;S=x?new EA(b,v,y,k,I):new TA(b,v,y,k,I);const C=[[b.padInfo.top,b.padInfo.left],[b.strideHeight,b.strideWidth],[b.dilationHeight,b.dilationWidth],[b.inHeight,b.inWidth]],N=n.runWebGLProgram(S,w,"float32",C);return m.forEach((e=>n.disposeIntermediateTensorInfo(e))),N;
}};class wF{
constructor(e,t,n,r){
this.sliceDim=e,this.strides=t,this.paramsShape=r,this.variableNames=["x","indices"],this.outputShape=n;const s=QN(n.length);let i="\n    int index;";for(let e=0;e<this.sliceDim;e++){
i+=`\n          index = round(getIndices(coords[0], ${e}));\n          out_of_bounds = out_of_bounds || index < 0;\n          out_of_bounds = out_of_bounds || index >= ${this.paramsShape[e]};\n          flattenIndex += index * ${this.strides[e]};`;
}this.userCode=`\n         void main() {\n          ${s} coords = getOutputCoords();\n          int flattenIndex = 0;\n          bool out_of_bounds = false;\n\n          ${i}\n\n          setOutput(out_of_bounds ? 0.0 : getX(flattenIndex, coords[1]));\n        }\n      `;
}
}const vF={kernelName:ut,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n}=e,{params:r,indices:s}=t,i=s.shape,a=i[i.length-1],o=m(r.shape),[u,l,c,h]=ql(r,s),d=pE({inputs:{x:s},backend:n,attrs:{shape:[l,a]}}),p=pE({inputs:{x:r},backend:n,attrs:{shape:[m(r.shape)/c,c]}});if(n.shouldExecuteOnCPU([r,s])||"string"===r.dtype){
const e=n.readSync(s.dataId),t=n.bufferSync(r),i=A$(e,t,r.dtype,l,a,c,h,r.shape,o);return n.makeTensorInfo(u,r.dtype,i.values);
}const f=new wF(a,h,[l,c],r.shape),g=n.runWebGLProgram(f,[p,d],p.dtype),b=pE({inputs:{x:g},backend:n,attrs:{shape:u}});return n.disposeIntermediateTensorInfo(d),n.disposeIntermediateTensorInfo(p),n.disposeIntermediateTensorInfo(g),b;
}};class kF{
constructor(e,t){
this.variableNames=["A","indices"],this.outputShape=t,this.rank=t.length;const n=QN(this.rank),r=function(e,t){
const n=["resRC.x","resRC.y","resRC.z","resRC.w"],r=[];for(let t=0;t<e.length;t++){
2===t?r.push("index"):r.push(`${n[t]}`);
}return r.join();
}(e);this.userCode=`\n      void main() {\n        ${n} resRC = getOutputCoords();\n        int index = int(getIndices(resRC.x, resRC.z));\n        float inBounds = (index >= 0) && (index < ${e[2]}) ? 1.0 : 0.0;\n        setOutput(inBounds * getA(${r}));\n      }\n    `;
}
}function IF(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s,indices:i}=t,{axis:a,batchDims:o}=r,u=k(a,s.shape)[0];if(H().get("DEBUG")){
const e=n.readSync(i.dataId),t=s.shape[u];for(let n=0;n<e.length;++n){
const r=e[n];d(r<=t-1&&r>=0,(()=>`GatherV2: the index value ${r} is not in [0, ${t-1}]`));
}
}const l=zc(s,i,u,o),c=m(i.shape),h=[],p=pE({inputs:{x:s},backend:n,attrs:{shape:[l.batchSize,l.outerSize,l.dimSize,l.sliceSize]}}),f=pE({inputs:{x:i},backend:n,attrs:{shape:[l.batchSize,c/l.batchSize]}});h.push(p),h.push(f);const g=[l.batchSize,l.outerSize,c/l.batchSize,l.sliceSize];if(n.shouldExecuteOnCPU([s,i])||"string"===s.dtype){
const e=n.bufferSync(f),t=n.bufferSync(p),r=F$(t,e,g);return h.forEach((e=>n.disposeIntermediateTensorInfo(e))),n.makeTensorInfo(l.outputShape,r.dtype,r.values);
}const b=new kF(p.shape,g),x=n.runWebGLProgram(b,[p,f],p.dtype);h.push(x);const y=pE({inputs:{x},backend:n,attrs:{shape:l.outputShape}});return h.forEach((e=>n.disposeIntermediateTensorInfo(e))),y;
}const SF={kernelName:ot,backendName:"webgl",kernelFunc:IF},CF=iE({opSnippet:"return float(a > b);",packedOpSnippet:"\n  return vec4(greaterThan(a, b));\n",cpuKernelImpl:_$,dtype:"bool"}),NF={kernelName:lt,backendName:"webgl",kernelFunc:CF},$F=iE({opSnippet:"return float(a >= b);",packedOpSnippet:"\n  return vec4(greaterThanEqual(a, b));\n",dtype:"bool",cpuKernelImpl:D$}),TF={kernelName:ct,backendName:"webgl",kernelFunc:$F},EF={kernelName:dt,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n}=e,{input:r}=t;return tF(r,!0,n);
}},RF=sE({opSnippet:"return float(!isnan(x) && !isinf(x));",dtype:"bool"}),AF={kernelName:ft,backendName:"webgl",kernelFunc:RF},FF=sE({opSnippet:"return float(isinf(x));",dtype:"bool"}),_F={kernelName:mt,backendName:"webgl",kernelFunc:FF},DF=sE({opSnippet:"return float(isnan(x));",dtype:"bool"}),OF={kernelName:gt,backendName:"webgl",kernelFunc:DF},MF=iE({opSnippet:"return float(a < b);",packedOpSnippet:"\n  return vec4(lessThan(a, b));\n",cpuKernelImpl:O$,dtype:"bool"}),LF={kernelName:xt,backendName:"webgl",kernelFunc:MF},zF=iE({opSnippet:"return float(a <= b);",packedOpSnippet:"\n  return vec4(lessThanEqual(a, b));\n",cpuKernelImpl:M$,dtype:"bool"}),PF={kernelName:yt,backendName:"webgl",kernelFunc:zF},BF={kernelName:wt,backendName:"webgl",kernelFunc:function(e){
const{backend:t,attrs:n}=e,{start:r,stop:s,num:i}=n,a=L$(r,s,i);return t.makeTensorInfo([a.length],"float32",a);
}},UF=sE({opSnippet:rE+"\n  return x < 0.0 ? 0./0. : log(x);\n",packedOpSnippet:"\n  vec4 result = log(x);\n  bvec4 isNaN = isnan(x);\n  result.r = isNaN.r ? x.r : (x.r < 0.0 ? 0./0. : result.r);\n  result.g = isNaN.g ? x.g : (x.g < 0.0 ? 0./0. : result.g);\n  result.b = isNaN.b ? x.b : (x.b < 0.0 ? 0./0. : result.b);\n  result.a = isNaN.a ? x.a : (x.a < 0.0 ? 0./0. : result.a);\n  return result;\n",cpuKernelImpl:z$}),WF={kernelName:vt,backendName:"webgl",kernelFunc:UF},VF=sE({opSnippet:rE+"\n  return log(1.0 + x);\n"}),GF={kernelName:kt,backendName:"webgl",kernelFunc:VF},jF=iE({opSnippet:"return float(a >= 1.0 && b >= 1.0);",packedOpSnippet:"\n  return vec4(\n    vec4(greaterThanEqual(a, vec4(1.0))) *\n    vec4(greaterThanEqual(b, vec4(1.0))));\n",dtype:"bool"}),HF={kernelName:It,backendName:"webgl",kernelFunc:jF},qF=sE({opSnippet:"return float(!(x >= 1.0));"}),KF={kernelName:St,backendName:"webgl",kernelFunc:qF},XF=iE({opSnippet:"return float(a >= 1.0 || b >= 1.0);",packedOpSnippet:"\n  return min(\n    vec4(greaterThanEqual(a, vec4(1.0))) +\n    vec4(greaterThanEqual(b, vec4(1.0))),\n    vec4(1.0));\n",dtype:"bool"}),YF={kernelName:Ct,backendName:"webgl",kernelFunc:XF};class ZF{
constructor(e,t,n,r,s){
this.variableNames=["x"],this.outputShape=[];const i=t,a=e[3]-1;let o;this.outputShape=e;const u=`float(${n}) + float(${r}) * sum`;o=.5===s?`inversesqrt(${u})`:1===s?`1.0/(${u})`:`exp(log(${u}) * float(-${s}));`,this.userCode=`\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int r = coords[1];\n        int c = coords[2];\n        int d = coords[3];\n        float x = getX(b, r, c, d);\n        float sum = 0.0;\n        for (int j = -${i}; j <= ${i}; j++) {\n          int idx = d + j;\n          if (idx >= 0 && idx <=  ${a}) {\n            float z = getX(b, r, c, idx);\n            sum += z * z;\n          }\n        }\n        float val = x * ${o};\n        setOutput(val);\n      }\n    `;
}
}class JF{
constructor(e,t,n,r,s){
this.variableNames=["x"],this.outputShape=[],this.packedInputs=!0,this.packedOutput=!0;const i=t,a=e[3]-1;let o;this.outputShape=e;const u=`float(${n}) + float(${r}) * sum`;o=.5===s?`inversesqrt(${u})`:1===s?`1.0/(${u})`:`exp(log(${u}) * float(-${s}));`,this.userCode=`\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords.x;\n        int r = coords.y;\n        int c = coords.z;\n        int d = coords.w;\n\n        bool hasNextCol = d < ${this.outputShape[3]};\n        bool hasNextRow = c < ${this.outputShape[2]};\n\n        vec4 sum = vec4(0.);\n        vec4 xFragAtOutputCoords = getX(b, r, c, d);\n\n        vec4 xAtOutputCoords = vec4(\n          getChannel(xFragAtOutputCoords, vec2(c, d)),\n          hasNextCol ?\n            getChannel(xFragAtOutputCoords, vec2(c, d + 1)) : 0.0,\n          hasNextRow ?\n            getChannel(xFragAtOutputCoords , vec2(c + 1, d)) : 0.0,\n          (hasNextRow && hasNextCol) ?\n            getChannel(xFragAtOutputCoords, vec2(c + 1, d + 1)) : 0.0\n        );\n\n        int firstChannel = d - ${i};\n        vec2 cache = vec2(0.);\n        if(firstChannel >= 0){\n          vec4 firstChannelFrag = getX(b, r, c, firstChannel);\n          cache.x = getChannel(firstChannelFrag, vec2(c, firstChannel));\n            if(hasNextRow){\n              cache.y = getChannel(firstChannelFrag, vec2(c + 1, firstChannel));\n            }\n        }\n\n        ivec2 depth = ivec2(d, d + 1);\n        for (int j = - ${i}; j <= ${i}; j++) {\n          ivec2 idx = depth + j;\n          bvec2 aboveLowerBound = greaterThanEqual(idx, ivec2(0));\n          bvec2 belowUpperBound = lessThanEqual(idx, ivec2(${a}));\n\n          bool depthInRange = aboveLowerBound.x && belowUpperBound.x;\n          bool depthPlusOneInRange = aboveLowerBound.y && belowUpperBound.y;\n\n          if(depthInRange || depthPlusOneInRange){\n            vec4 z = vec4(0.);\n            vec4 xFragAtCurrentDepth;\n            z.xz = cache.xy;\n            if(depthPlusOneInRange && hasNextCol){\n              xFragAtCurrentDepth = idx.y != d ?\n                getX(b, r, c, idx.y) : xFragAtOutputCoords;\n              z.y = getChannel(xFragAtCurrentDepth, vec2(c, idx.y));\n              if(hasNextRow){\n                z.w = getChannel(xFragAtCurrentDepth, vec2(c + 1, idx.y));\n              }\n            }\n            cache.xy = z.yw;\n            sum += z * z;\n          }\n        }\n        vec4 result = xAtOutputCoords * ${o};\n        setOutput(result);\n      }\n    `;
}
}const QF={kernelName:Nt,backendName:"webgl",kernelFunc:e=>{
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{depthRadius:i,bias:a,alpha:o,beta:u}=r,l=H().getBool("WEBGL_PACK_NORMALIZATION")?new JF(s.shape,i,a,o,u):new ZF(s.shape,i,a,o,u);return n.runWebGLProgram(l,[s],s.dtype);
}};class e_{
constructor(e,t,n,r,s){
this.variableNames=["inputImage","outputImage","dy"],this.outputShape=[],this.outputShape=e,this.depth=e[3],this.depthRadius=t,this.bias=n,this.alpha=r,this.beta=s,this.userCode=`\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int r = coords[1];\n        int c = coords[2];\n\n        float result = 0.0;\n        for (int d = 0; d < ${this.depth}; ++d) {\n          int depthBegin = int(max(0.0, float(d - ${t})));\n          int depthEnd = int(min(float(${this.depth}),\n              float(d + ${t} + 1)));\n\n          const int MIN_DEPTH_BEGIN = 0;\n          const int MAX_DEPTH_END = ${this.depth};\n\n          float norm = 0.0;\n          for (int k = MIN_DEPTH_BEGIN; k < MAX_DEPTH_END; ++k) {\n            if (k < depthBegin){\n              continue;\n            }\n            else if (k >= depthBegin && k < depthEnd) {\n              norm += getInputImage(b, r, c, k) * getInputImage(b, r, c, k);\n            }\n            else {\n              break;\n            }\n          }\n\n          norm = float(${r}) * norm + float(${n});\n\n          for(int k = MIN_DEPTH_BEGIN; k < MAX_DEPTH_END; ++k){\n            if (k < depthBegin){\n              continue;\n            }\n            else if (k >= depthBegin && k < depthEnd){\n              float dyi = -2.0 * float(${r})\n                * float(${s})\n                * getInputImage(b, r, c, k) * getOutputImage(b, r, c, d)\n                / norm;\n              if (k == d) {\n                dyi += pow(norm, -1.0 * ${s});\n              }\n              if (k == coords[3]) {\n                dyi *= getDy(b, r, c, d);\n                result += dyi;\n              }\n            }\n            else {\n              break;\n            }\n          }\n      }\n      setOutput(result);\n      }\n    `;
}
}const t_={kernelName:$t,backendName:"webgl",kernelFunc:e=>{
const{inputs:t,backend:n,attrs:r}=e,{x:s,y:i,dy:a}=t,{depthRadius:o,bias:u,alpha:l,beta:c}=r,h=new e_(s.shape,o,u,l,c);return n.runWebGLProgram(h,[s,i,a],s.dtype);
}};function n_(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{reductionIndices:i,keepDims:a}=r,o=s.shape.length,u=k(i,s.shape);let l=u;const c=Uo(l,o),h=null!=c,d=n.shouldExecuteOnCPU([s]);let p=s;if(h){
if(d){
const e=n.texData.get(p.dataId).values,t=new Array(o);for(let e=0;e<t.length;e++){
t[e]=s.shape[c[e]];
}const r=pT(e,s.shape,s.dtype,c,t);p=n.makeTensorInfo(t,s.dtype),n.texData.get(p.dataId).values=r;
}else {
p=wE(s,c,n);
}l=Vo(l.length,o);
}Bo("max",l,o);const[f,g]=zo(p.shape,l);let b,x=f;if(a&&(x=Po(f,u)),d){
const e=n.texData.get(p.dataId).values,t=P$(e,m(g),x,s.dtype);b=n.makeTensorInfo(x,s.dtype),n.texData.get(b.dataId).values=t;
}else {
b=function(e,t,n,r){
const s=m(t),i=pE({inputs:{x:e},attrs:{shape:[m(e.shape)/s,s]},backend:r}),a=bE(i,e.dtype,"max",r),o=pE({inputs:{x:a},attrs:{shape:n},backend:r});return r.disposeIntermediateTensorInfo(i),r.disposeIntermediateTensorInfo(a),o;
}(p,g,x,n);
}return h&&n.disposeIntermediateTensorInfo(p),b;
}const r_={kernelName:Tt,backendName:"webgl",kernelFunc:n_},s_=iE({opSnippet:VT+"\n  return max(a, b);\n",packedOpSnippet:"\n  vec4 result = vec4(max(a, b));\n  bvec4 isNaNA = isnan(a);\n  bvec4 isNaNB = isnan(b);\n  bvec4 isNaN = bvec4(isNaNA.x || isNaNB.x, isNaNA.y || isNaNB.y, isNaNA.z || isNaNB.z, isNaNA.w || isNaNB.w);\n  "+jT+"\n  return result;\n",cpuKernelImpl:B$}),i_={kernelName:Et,backendName:"webgl",kernelFunc:s_},a_={kernelName:Rt,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t;MN(s,"maxPool");const{filterSize:i,strides:a,pad:o,dimRoundingMode:u}=r;d(Pa(a,1),(()=>`Error in maxPool: Either strides or dilations must be 1. Got strides ${a} and dilations '1'`));const l=Ea(s.shape,i,a,1,o,u);if(1===l.filterWidth&&1===l.filterHeight&&g(l.inShape,l.outShape)){
return qT({inputs:{x:s},backend:n});
}const c=new iR(l,"max",!1);return n.runWebGLProgram(c,[s],s.dtype);
}},o_={kernelName:Ft,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{filterSize:i,strides:a,pad:o,dataFormat:u,dimRoundingMode:l}=r,c=Ra(s.shape,i,a,[1,1,1],o,l,u),h=new aR(c,"max",!1);return n.runWebGLProgram(h,[s],s.dtype);
}};class u_{
constructor(e){
this.variableNames=["dy","maxPos"],this.outputShape=e.inShape;const t=e.strideHeight,n=e.strideWidth,r=e.dilationHeight,s=e.effectiveFilterHeight,i=e.effectiveFilterWidth,a=s-1-e.padInfo.top,o=i-1-e.padInfo.left,u=s*i-1;this.userCode=`\n      const ivec2 pads = ivec2(${a}, ${o});\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n\n        ivec2 dyRCCorner = coords.yz - pads;\n        int dyRCorner = dyRCCorner.x;\n        int dyCCorner = dyRCCorner.y;\n\n        // Convolve dy(?, ?, d) with pos mask(:, :, d) to get dx(xR, xC, d).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        for (int wR = 0; wR < ${s};\n          wR += ${r}) {\n          float dyR = float(dyRCorner + wR) / ${t}.0;\n\n          if (dyR < 0.0 || dyR >= ${e.outHeight}.0 || fract(dyR) > 0.0) {\n            continue;\n          }\n          int idyR = int(dyR);\n\n          for (int wC = 0; wC < ${i}; wC++) {\n            float dyC = float(dyCCorner + wC) / ${n}.0;\n\n            if (dyC < 0.0 || dyC >= ${e.outWidth}.0 ||\n                fract(dyC) > 0.0) {\n              continue;\n            }\n            int idyC = int(dyC);\n\n            float dyValue = getDy(b, idyR, idyC, d);\n            int maxPosValue = ${u} - int(getMaxPos(b, idyR, idyC, d));\n\n            // Get the current value, check it against the value from the\n            // position matrix.\n            int curPosValue = wR * ${i} + wC;\n            float mask = float(maxPosValue == curPosValue ? 1.0 : 0.0);\n\n            dotProd += dyValue * mask;\n          }\n        }\n        setOutput(dotProd);\n      }\n    `;
}
}class l_{
constructor(e){
this.variableNames=["dy","maxPos"],this.outputShape=e.inShape;const t=e.strideDepth,n=e.strideHeight,r=e.strideWidth,s=e.dilationDepth,i=e.dilationHeight,a=e.dilationWidth,o=e.effectiveFilterDepth,u=e.effectiveFilterHeight,l=e.effectiveFilterWidth,c=o-1-e.padInfo.front,h=u-1-e.padInfo.top,d=l-1-e.padInfo.left,p=o*u*l-1;this.userCode=`\n      const ivec3 pads = ivec3(${c}, ${h}, ${d});\n\n      void main() {\n        ivec5 coords = getOutputCoords();\n        int batch = coords.x;\n        int ch = coords.u;\n\n        ivec3 dyCorner = ivec3(coords.y, coords.z, coords.w) - pads;\n        int dyDCorner = dyCorner.x;\n        int dyRCorner = dyCorner.y;\n        int dyCCorner = dyCorner.z;\n\n        // Convolve dy(?, ?, ?, ch) with pos mask(:, :, :, d) to get\n        // dx(xD, xR, xC, ch).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n\n        for (int wD = 0; wD < ${o};\n           wD += ${s}) {\n          float dyD = float(dyDCorner + wD) / ${t}.0;\n\n          if (dyD < 0.0 || dyD >= ${e.outDepth}.0 || fract(dyD) > 0.0) {\n            continue;\n          }\n          int idyD = int(dyD);\n\n          for (int wR = 0; wR < ${u};\n              wR += ${i}) {\n            float dyR = float(dyRCorner + wR) / ${n}.0;\n\n            if (dyR < 0.0 || dyR >= ${e.outHeight}.0 ||\n                fract(dyR) > 0.0) {\n              continue;\n            }\n            int idyR = int(dyR);\n\n            for (int wC = 0; wC < ${l};\n                wC += ${a}) {\n              float dyC = float(dyCCorner + wC) / ${r}.0;\n\n              if (dyC < 0.0 || dyC >= ${e.outWidth}.0 ||\n                  fract(dyC) > 0.0) {\n                continue;\n              }\n              int idyC = int(dyC);\n\n              float dyValue = getDy(batch, idyD, idyR, idyC, ch);\n              int maxPosValue = ${p} -\n                  int(getMaxPos(batch, idyD, idyR, idyC, ch));\n\n              // Get the current value, check it against the value from the\n              // position matrix.\n              int curPosValue =\n                  wD * ${u} * ${l} +\n                  wR * ${l} + wC;\n              float mask = float(maxPosValue == curPosValue ? 1.0 : 0.0);\n\n              dotProd += dyValue * mask;\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    `;
}
}const c_={kernelName:_t,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{dy:s,input:i}=t,a=i,{filterSize:o,strides:u,pad:l,dimRoundingMode:c}=r,h=Ra(a.shape,o,u,[1,1,1],l,c),d=new aR(h,"max",!0),p=n.runWebGLProgram(d,[a],a.dtype),f=new l_(h),m=n.runWebGLProgram(f,[s,p],a.dtype);return n.disposeIntermediateTensorInfo(p),m;
}},h_={kernelName:At,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{dy:s,input:i,output:a}=t,o=i;MN([i,a],"maxPoolGrad");const{filterSize:u,strides:l,pad:c,dimRoundingMode:h}=r,d=Ea(o.shape,u,l,1,c,h),p=new iR(d,"max",!0),f=n.runWebGLProgram(p,[o],o.dtype),m=new u_(d),g=n.runWebGLProgram(m,[s,f],o.dtype);return n.disposeIntermediateTensorInfo(f),g;
}},d_={kernelName:Dt,backendName:"webgl",kernelFunc:({inputs:e,attrs:t,backend:n})=>{
const{x:r}=e,{filterSize:s,strides:i,pad:a,includeBatchInIndex:o}=t,u=n;d(4===r.shape.length,(()=>`Error in maxPool: input must be rank 4 but got rank ${r.shape.length}.`));const l=[1,1];d(Pa(i,l),(()=>`Error in maxPool: Either strides or dilations must be 1. Got strides ${i} and dilations '${l}'`));const c=Ea(r.shape,s,i,l,a),[h,p]=function(e,t,n,r){
let s=new iR(n,"max",!1);const i=r.runWebGLProgram(s,[e],"float32");return s=new iR(n,"max",!0,!0,t),[i,r.runWebGLProgram(s,[e],"float32")];
}(r,o,c,u);return[h,p];
}},p_={kernelName:Ot,backendName:"webgl",kernelFunc:({inputs:e,attrs:t,backend:n})=>{
const{x:r}=e,{keepDims:s,axis:i}=t,a=n,o=r.shape.length,u=k(i,r.shape);let l=u;const c=Uo(l,o),h=null!=c,d=a.shouldExecuteOnCPU([r]),p=[];let f=r;if(h){
if(d){
const e=a.texData.get(f.dataId).values,t=new Array(o);for(let e=0;e<t.length;e++){
t[e]=r.shape[c[e]];
}const n=pT(e,r.shape,r.dtype,c,t);f=a.makeTensorInfo(t,r.dtype),a.texData.get(f.dataId).values=n;
}else {
f=wE(r,c,a);
}p.push(f),l=Vo(l.length,o);
}Bo("sum",l,o);const[g,b]=zo(f.shape,l);let x=g;s&&(x=Po(g,u));const y=function(e,t,n,r){
const s=m(t),i=pE({inputs:{x:e},attrs:{shape:[m(e.shape)/s,s]},backend:r}),a=bE(i,"float32","mean",r),o=pE({inputs:{x:a},attrs:{shape:n},backend:r});return r.disposeIntermediateTensorInfo(i),r.disposeIntermediateTensorInfo(a),o;
}(f,b,x,a);for(const e of p){
a.disposeIntermediateTensorInfo(e);
}return y;
}},f_={kernelName:Mt,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{axis:i,keepDims:a}=r,o=s.shape.length,u=k(i,s.shape);let l=u;const c=Uo(l,o);let h=s;null!=c&&(h=IE({inputs:{x:s},backend:n,attrs:{perm:c}}),l=Vo(l.length,s.shape.length)),Bo("min",l,o);const[d,p]=zo(h.shape,l),f=pE({inputs:{x:h},backend:n,attrs:{shape:[-1,m(p)]}}),g=bE(f,f.dtype,"min",n);let b;return b=pE(a?{inputs:{x:g},backend:n,attrs:{shape:Po(d,u)}}:{inputs:{x:g},backend:n,attrs:{shape:d}}),n.disposeIntermediateTensorInfo(f),n.disposeIntermediateTensorInfo(g),null!=c&&n.disposeIntermediateTensorInfo(h),b;
}},m_=iE({opSnippet:VT+"\n  return min(a, b);\n",packedOpSnippet:"\n  vec4 result = vec4(min(a, b));\n  bvec4 isNaNA = isnan(a);\n  bvec4 isNaNB = isnan(b);\n  bvec4 isNaN = bvec4(isNaNA.x || isNaNB.x, isNaNA.y || isNaNB.y, isNaNA.z || isNaNB.z, isNaNA.w || isNaNB.w);\n  "+jT+"\n  return result;\n",cpuKernelImpl:U$}),g_={kernelName:Lt,backendName:"webgl",kernelFunc:m_};class b_{
constructor(e,t,n){
this.variableNames=["x"],this.outputShape=t.map(((t,n)=>t[0]+e[n]+t[1]));const r=e.length,s=QN(r),i=t.map((e=>e[0])).join(","),a=t.map(((t,n)=>t[0]+e[n])).join(","),o=["coords[0]","coords[1]","coords[2]","coords[3]"].slice(0,r),u="reflect"===n?0:1;this.userCode=1!==r?`\n      ${s} start = ${s}(${i});\n      ${s} end = ${s}(${a});\n\n      void main() {\n        ${s} outC = getOutputCoords();\n        for (int i = 0; i < ${r}; i++) {\n          if (outC[i] < start[i]) {\n            outC[i] = start[i] * 2 - outC[i] - ${u};\n          } else if(outC[i] >= end[i]) {\n            outC[i] = (end[i] - 1) * 2 - outC[i] + ${u};\n          }\n        }\n        ${s} coords = outC - start;\n        setOutput(getX(${o}));\n      }\n    `:`\n        int start = ${i};\n        int end = ${a};\n\n        void main() {\n          int outC = getOutputCoords();\n          if (outC < start) {\n            outC = start * 2 - outC - ${u};\n          } else if(outC >= end) {\n            outC = (end - 1) * 2 - outC + ${u};\n          }\n          setOutput(getX(outC - start));\n        }\n      `;
}
}class x_{
constructor(e,t,n){
this.variableNames=["x"],this.packedInputs=!0,this.packedOutput=!0,this.outputShape=t.map(((t,n)=>t[0]+e[n]+t[1]));const r=e.length,s=QN(r),i=t.map((e=>e[0])).join(","),a=t.map(((t,n)=>t[0]+e[n])).join(","),o=gT("rc",r),u=gT("source",r),l=`${o[r-1]} < ${this.outputShape[r-1]}`,c=1===r?"source":`vec2(${u.slice(-2).join()})`,h="reflect"===n?0:1;let d="";if(1===r){
const e=`\n        ${s} source = rc;\n        if (source < start) {\n          source = start * 2 - source - ${h};\n        } else if (source >= end) {\n          source = (end - 1) * 2 - source + ${h};\n        }\n        source -= start;\n      `;d=`\n        ${s} rc = outputLoc;\n        ${e}\n        result[0] = getChannel(getX(${u.join()}), ${c});\n        ${o[r-1]} += 1;\n        if(${l}) {\n          ${e}\n          result[1] = getChannel(getX(${u.join()}), ${c});\n        }\n      `;
}else{
const e=`\n        ${s} source = rc;\n        ${s} lt = ${s}(lessThan(source, start));\n        ${s} gte = ${s}(greaterThanEqual(source, end));\n        ${s} orig = 1 - (lt + gte);\n        source = orig * source +\n                lt * (start * 2 - source - ${h}) +\n                gte * ((end - 1) * 2 - source + ${h});\n        source -= start;\n      `;d=`\n        ${s} rc = outputLoc;\n        ${e}\n        result[0] = getChannel(getX(${u.join()}), ${c});\n        ${o[r-1]} += 1;\n        if(${l}) {\n          ${e}\n          result[1] = getChannel(getX(${u.join()}), ${c});\n        }\n        rc = outputLoc;\n        ${o[r-2]} += 1;\n        if(${o[r-2]} < ${this.outputShape[r-2]}) {\n          ${e}\n          result[2] = getChannel(getX(${u.join()}), ${c});\n          ${o[r-1]} += 1;\n          if(${l}) {\n            ${e}\n            result[3] = getChannel(getX(${u.join()}), ${c});\n          }\n        }\n      `;
}this.userCode=`\n      const ${s} start = ${s}(${i});\n      const ${s} end = ${s}(${a});\n\n      void main() {\n        ${s} outputLoc = getOutputCoords();\n        vec4 result = vec4(0.);\n        ${d}\n        setOutput(result);\n      }\n    `;
}
}const y_={kernelName:zt,backendName:"webgl",kernelFunc:({inputs:e,backend:t,attrs:n})=>{
const{x:r}=e,{paddings:s,mode:i}=n,a=H().getBool("WEBGL_PACK_ARRAY_OPERATIONS")?new x_(r.shape,s,i):new b_(r.shape,s,i);return t.runWebGLProgram(a,[r],r.dtype);
}},w_=iE({opSnippet:"if (b == 0.0) return NAN;\n  return mod(a, b);",packedOpSnippet:"\n  vec4 result = mod(a, b);\n  bvec4 isNaN = equal(b, vec4(0.0));\n  "+jT+"\n  return result;\n"}),v_={kernelName:Pt,backendName:"webgl",kernelFunc:w_};class k_{
constructor(e,t,n){
this.variableNames=["probs"],this.customUniforms=[{name:"seed",type:"float"}],this.outputShape=[e,n],this.userCode=`\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int batch = coords[0];\n\n        float r = random(seed);\n        float cdf = 0.0;\n\n        for (int i = 0; i < ${t-1}; i++) {\n          cdf += getProbs(batch, i);\n\n          if (r < cdf) {\n            setOutput(float(i));\n            return;\n          }\n        }\n\n        // If no other event happened, last event happened.\n        setOutput(float(${t-1}));\n      }\n    `;
}
}const I_=iE({opSnippet:"\nif (a == b) {\n  return 1.0;\n};\nreturn a / b;",packedOpSnippet:"\n  // vec4 one = vec4(equal(a, b));\n  // return one + (vec4(1.0) - one) * a / b;\n  vec4 result = a / b;\n  if(a.x == b.x) {\n    result.x = 1.;\n  }\n  if(a.y == b.y) {\n    result.y = 1.;\n  }\n  if(a.z == b.z) {\n    result.z = 1.;\n  }\n  if(a.w == b.w) {\n    result.w = 1.;\n  }\n\n  return result;\n",checkOutOfBounds:!0}),S_={kernelName:He,backendName:"webgl",kernelFunc:I_},C_="return a - b;",N_=iE({opSnippet:C_,packedOpSnippet:C_,supportsComplex:!0,cpuKernelImpl:cT}),$_={kernelName:jn,backendName:"webgl",kernelFunc:N_};function T_(e){
const{inputs:t,backend:n,attrs:r}=e,{logits:s}=t,{dim:i}=r,a=k([i],s.shape),o=n_({inputs:{x:s},backend:n,attrs:{reductionIndices:a,keepDims:!1}}),u=Po(o.shape,a),l=pE({inputs:{x:o},backend:n,attrs:{shape:u}}),c=N_({inputs:{a:s,b:l},backend:n}),h=qA({inputs:{x:c},backend:n}),d=vE({inputs:{x:h},backend:n,attrs:{axis:a,keepDims:!1}}),p=pE({inputs:{x:d},backend:n,attrs:{shape:u}}),f=I_({inputs:{a:h,b:p},backend:n});return n.disposeIntermediateTensorInfo(o),n.disposeIntermediateTensorInfo(l),n.disposeIntermediateTensorInfo(c),n.disposeIntermediateTensorInfo(h),n.disposeIntermediateTensorInfo(d),n.disposeIntermediateTensorInfo(p),f;
}const E_={kernelName:Fn,backendName:"webgl",kernelFunc:T_},R_={kernelName:Bt,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{logits:s}=t,{numSamples:i,seed:a,normalized:o}=r,u=o?s:T_({inputs:{logits:s},backend:n,attrs:{dim:s.shape.length-1}}),l=u.shape[0],c=u.shape[1],h=new k_(l,c,i),d=[[a]],p=n.runWebGLProgram(h,[u],"int32",d);return o||n.disposeIntermediateTensorInfo(u),p;
}},A_=ST+"\n  return -x;\n",F_={kernelName:Wt,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n}=e,{x:r}=t;if(n.shouldExecuteOnCPU([r])){
const e=n.texData.get(r.dataId),[t,s]=V$(e.values,r.shape,r.dtype);return n.makeTensorInfo(s,r.dtype,t);
}let s;return s=H().getBool("WEBGL_PACK_UNARY_OPERATIONS")?new LT(r.shape,"\n  vec4 result = -x;\n  bvec4 isNaN = isnan(x);\n\n  result.r = isNaN.r ? x.r : result.r;\n  result.g = isNaN.g ? x.g : result.g;\n  result.b = isNaN.b ? x.b : result.b;\n  result.a = isNaN.a ? x.a : result.a;\n\n  return result;\n"):new IT(r.shape,A_),n.runWebGLProgram(s,[r],r.dtype);
}},__=tl,D_={kernelName:Gt,backendName:"webgl",kernelFunc:function(e){
or("tf.nonMaxSuppression() in webgl locks the UI thread. Call tf.nonMaxSuppressionAsync() instead");const{inputs:t,backend:n,attrs:r}=e,{boxes:s,scores:i}=t,{maxOutputSize:a,iouThreshold:o,scoreThreshold:u}=r,l=n.readSync(s.dataId),c=n.readSync(i.dataId),{selectedIndices:h}=__(l,c,a,o,u);return n.makeTensorInfo([h.length],"int32",new Int32Array(h));
}},O_=nl,M_={kernelName:jt,backendName:"webgl",kernelFunc:function(e){
or("tf.nonMaxSuppression() in webgl locks the UI thread. Call tf.nonMaxSuppressionAsync() instead");const{inputs:t,backend:n,attrs:r}=e,{boxes:s,scores:i}=t,{maxOutputSize:a,iouThreshold:o,scoreThreshold:u,padToMaxOutputSize:l}=r,c=n.readSync(s.dataId),h=n.readSync(i.dataId),{selectedIndices:d,validOutputs:p}=O_(c,h,a,o,u,l);return[n.makeTensorInfo([d.length],"int32",new Int32Array(d)),n.makeTensorInfo([],"int32",new Int32Array([p]))];
}},L_=rl,z_={kernelName:Ht,backendName:"webgl",kernelFunc:function(e){
or("tf.nonMaxSuppression() in webgl locks the UI thread. Call tf.nonMaxSuppressionAsync() instead");const{inputs:t,backend:n,attrs:r}=e,{boxes:s,scores:i}=t,{maxOutputSize:a,iouThreshold:o,scoreThreshold:u,softNmsSigma:l}=r,c=n.readSync(s.dataId),h=n.readSync(i.dataId),d=a,p=o,f=u,m=l,{selectedIndices:g,selectedScores:b}=L_(c,h,d,p,f,m);return[n.makeTensorInfo([g.length],"int32",new Int32Array(g)),n.makeTensorInfo([b.length],"float32",new Float32Array(b))];
}};class P_{
constructor(e,t,n,r){
this.variableNames=["indices"],this.outputShape=[e,t],this.userCode=`\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int index = round(getIndices(coords.x));\n        setOutput(mix(float(${r}), float(${n}),\n                      float(index == coords.y)));\n      }\n    `;
}
}const B_={kernelName:Kt,backendName:"webgl",kernelFunc:e=>{
const{inputs:t,backend:n,attrs:r}=e,{indices:s}=t,{dtype:i,depth:a,onValue:o,offValue:u}=r,l=m(s.shape),c=new P_(l,a,o,u),h=pE({inputs:{x:s},backend:n,attrs:{shape:[l]}}),d=n.runWebGLProgram(c,[h],i);n.disposeIntermediateTensorInfo(h);const p=pE({inputs:{x:d},backend:n,attrs:{shape:[...s.shape,a]}});return n.disposeIntermediateTensorInfo(d),p;
}};function U_(e){
const{inputs:t,backend:n}=e,{x:r}=t;if("complex64"===r.dtype){
const e=TR({inputs:{input:r},backend:n}),t=U_({inputs:{x:e},backend:n}),s=VR({inputs:{input:r},backend:n}),i=U_({inputs:{x:s},backend:n}),a=XT({inputs:{real:t,imag:i},backend:n});return n.disposeIntermediateTensorInfo(e),n.disposeIntermediateTensorInfo(t),n.disposeIntermediateTensorInfo(s),n.disposeIntermediateTensorInfo(i),a;
}return sF({attrs:{shape:r.shape,dtype:r.dtype,value:"string"===r.dtype?"":0},backend:n});
}const W_={kernelName:tr,backendName:"webgl",kernelFunc:U_},V_={kernelName:qt,backendName:"webgl",kernelFunc:function e(t){
const{inputs:n,backend:r}=t,{x:s}=n;if("string"===s.dtype){
throw new Error("onesLike is not supported under string dtype");
}if("complex64"===s.dtype){
const t=TR({inputs:{input:s},backend:r}),n=e({inputs:{x:t},backend:r}),i=VR({inputs:{input:s},backend:r}),a=U_({inputs:{x:i},backend:r}),o=XT({inputs:{real:n,imag:a},backend:r});return r.disposeIntermediateTensorInfo(t),r.disposeIntermediateTensorInfo(n),r.disposeIntermediateTensorInfo(i),r.disposeIntermediateTensorInfo(a),o;
}return sF({attrs:{shape:s.shape,dtype:s.dtype,value:1},backend:r});
}},G_={kernelName:Xt,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{axis:s}=r;if(1===t.length){
return XA({inputs:{input:t[0]},backend:n,attrs:{dim:s}});
}const i=t[0].shape,a=t[0].dtype;t.forEach((e=>{
p(i,e.shape,"All tensors passed to stack must have matching shapes"),d(a===e.dtype,(()=>"All tensors passed to stack must have matching dtypes"));
}));const o=[],u=HR({inputs:t.map((e=>{
const t=XA({inputs:{input:e},backend:n,attrs:{dim:s}});return o.push(t),t;
})),backend:n,attrs:{axis:s}});return o.forEach((e=>n.disposeIntermediateTensorInfo(e))),u;
}};class j_{
constructor(e,t,n){
this.variableNames=["x"],this.customUniforms=[{name:"value",type:"float"}],this.outputShape=t.map(((t,n)=>t[0]+e[n]+t[1]));const r=e.length,s=QN(r),i=t.map((e=>e[0])).join(","),a=t.map(((t,n)=>t[0]+e[n])).join(","),o=["coords[0]","coords[1]","coords[2]","coords[3]"].slice(0,r);this.userCode=1!==r?`\n      ${s} start = ${s}(${i});\n      ${s} end = ${s}(${a});\n\n      void main() {\n        ${s} outC = getOutputCoords();\n        if (any(lessThan(outC, start)) || any(greaterThanEqual(outC, end))) {\n          setOutput(value);\n        } else {\n          ${s} coords = outC - start;\n          setOutput(getX(${o}));\n        }\n      }\n    `:`\n        int start = ${i};\n        int end = ${a};\n\n        void main() {\n          int outC = getOutputCoords();\n          if (outC < start || outC >= end) {\n            setOutput(value);\n          } else {\n            setOutput(getX(outC - start));\n          }\n        }\n      `;
}
}class H_{
constructor(e,t,n){
this.variableNames=["x"],this.packedInputs=!0,this.packedOutput=!0,this.customUniforms=[{name:"value",type:"float"}],this.outputShape=t.map(((t,n)=>t[0]+e[n]+t[1]));const r=e.length,s=QN(r),i=t.map((e=>e[0])).join(","),a=t.map(((t,n)=>t[0]+e[n])).join(","),o=gT("rc",r),u=gT("source",r),l=`${o[r-1]} < ${this.outputShape[r-1]}`,c=1===r?"source":`vec2(${u.slice(-2).join()})`,h=[`${s} rc = outputLoc;`,`${o[r-1]} += 1;\n       if(${l}) {\n      `,1===r?"":`}\n       rc = outputLoc;\n       ${o[r-2]} += 1;\n       if(${o[r-2]} < ${this.outputShape[r-2]}) {`,1===r?"":`  ${o[r-1]} += 1;\n         if(${l}) {`],d=1===r?"rc < start || rc >= end":"any(lessThan(rc, start)) || any(greaterThanEqual(rc, end))";let p="";for(let e=0,t=1===r?2:4;e<t;e++){
p+=`\n        ${h[e]}\n        if (${d}) {\n          result[${e}] = float(value);\n        } else {\n          ${s} source = rc - start;\n          result[${e}] = getChannel(getX(${u.join()}), ${c});\n        }\n      `;
}p+=1===r?"} ":"}}",this.userCode=`\n      const ${s} start = ${s}(${i});\n      const ${s} end = ${s}(${a});\n\n      void main() {\n        ${s} outputLoc = getOutputCoords();\n        vec4 result = vec4(0.);\n        ${p}\n        setOutput(result);\n      }\n    `;
}
}const q_=e=>{
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{paddings:i,constantValue:a}=r;if(0===m(s.shape)){
const e=i.map(((e,t)=>e[0]+s.shape[t]+e[1]));return sF({backend:n,attrs:{shape:e,value:a,dtype:s.dtype}});
}const o=H().getBool("WEBGL_PACK_ARRAY_OPERATIONS")?new H_(s.shape,i,a):new j_(s.shape,i,a),u=[[a]];return n.runWebGLProgram(o,[s],s.dtype,u);
},K_={kernelName:Yt,backendName:"webgl",kernelFunc:q_},X_=iE({opSnippet:"\n  if(a < 0.0 && floor(b) < b){\n    return NAN;\n  }\n  if (b == 0.0) {\n    return 1.0;\n  }\n  return (round(mod(b, 2.0)) != 1) ?\n      pow(abs(a), b) : sign(a) * pow(abs(a), b);\n",packedOpSnippet:"\n  // isModRound1 has 1 for components with round(mod(b, 2.0)) == 1, 0 otherwise.\n  vec4 isModRound1 = vec4(equal(round(mod(b, 2.0)), ivec4(1)));\n  vec4 multiplier = sign(a) * isModRound1 + (vec4(1.0) - isModRound1);\n  vec4 result = multiplier * pow(abs(a), b);\n\n  // Ensure that a^0 = 1, including 0^0 = 1 as this correspond to TF and JS\n  bvec4 isExpZero = equal(b, vec4(0.0));\n  result.r = isExpZero.r ? 1.0 : result.r;\n  result.g = isExpZero.g ? 1.0 : result.g;\n  result.b = isExpZero.b ? 1.0 : result.b;\n  result.a = isExpZero.a ? 1.0 : result.a;\n\n  bvec4 isNaN1 = lessThan(a, vec4(0.0));\n  bvec4 isNaN2 = lessThan(floor(b), b);\n  bvec4 isNaN = bvec4(isNaN1.x && isNaN2.x, isNaN1.y && isNaN2.y, isNaN1.z && isNaN2.z, isNaN1.w && isNaN2.w);\n  "+jT+"\n  return result;\n"}),Y_={kernelName:Zt,backendName:"webgl",kernelFunc:X_},Z_={kernelName:Qt,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{axis:i,keepDims:a}=r,o=s.shape.length,u=[],l=k(i,s.shape);let c=l;const h=Uo(c,o);let d,p=s;if(null!=h&&(p=IE({inputs:{x:s},backend:n,attrs:{perm:h}}),c=Vo(c.length,o),u.push(p)),Bo("prod",c,o),n.shouldExecuteOnCPU([p])){
const e=n.texData.get(p.dataId).values,{outVals:t,outShape:r,outDtype:s}=j$(p.shape,p.dtype,e,c);d=n.makeTensorInfo(r,s,t);
}else{
const[e,t]=zo(p.shape,c),r=m(t),i=pE({inputs:{x:p},backend:n,attrs:{shape:[-1,r]}}),a=bE(i,cs(s.dtype),"prod",n);d=pE({inputs:{x:a},backend:n,attrs:{shape:e}}),u.push(i),u.push(a);
}if(a){
u.push(d);const e=Po(d.shape,l);d=pE({inputs:{x:d},backend:n,attrs:{shape:e}});
}return u.forEach((e=>n.disposeIntermediateTensorInfo(e))),d;
}},J_={kernelName:en,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{paramsNestedSplits:s,paramsDenseValues:i,indices:a}=t,{outputRaggedRank:o}=r,u=s.map((e=>n.readSync(e.dataId))),l=s.map((e=>e.shape)),c=n.readSync(i.dataId),h=n.readSync(a.dataId),[d,p,f]=H$(u,l,c,i.shape,i.dtype,h,a.shape,o),m=d.map((e=>n.makeTensorInfo([e.length],"int32",e))),g=n.makeTensorInfo(f,i.dtype,p);return m.concat([g]);
}},Q_={kernelName:tn,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n}=e,{starts:r,limits:s,deltas:i}=t,a=n.readSync(r.dataId),o=n.readSync(s.dataId),u=n.readSync(i.dataId),[l,c]=q$(a,r.shape,r.dtype,o,s.shape,u,i.shape);return[n.makeTensorInfo([l.length],"int32",l),n.makeTensorInfo([c.length],r.dtype,c)];
}},eD={kernelName:nn,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{shape:s,values:i,defaultValue:a,rowPartitionTensors:o}=t,{rowPartitionTypes:u}=r,l=n.readSync(s.dataId),c=n.readSync(i.dataId),h=n.readSync(a.dataId),d=o.map((e=>n.readSync(e.dataId))),p=o.map((e=>e.shape)),[f,m]=K$(l,s.shape,c,i.shape,i.dtype,h,a.shape,d,p,u);return n.makeTensorInfo(f,i.dtype,m);
}},tD=e=>{
const{backend:t,attrs:n}=e,{start:r,stop:s,step:i,dtype:a}=n,o=X$(r,s,i,a);return t.makeTensorInfo([o.length],a,o);
},nD={kernelName:rn,backendName:"webgl",kernelFunc:tD},rD=sE({opSnippet:"return 1.0 / x;"}),sD={kernelName:an,backendName:"webgl",kernelFunc:rD},iD=sE({opSnippet:ST+"\n  return (x < 0.0) ? 0.0 : x;\n",packedOpSnippet:"\n  vec4 result = x * vec4(greaterThanEqual(x, vec4(0.0)));\n  bvec4 isNaN = isnan(x);\n\n  result.r = isNaN.r ? x.r : result.r;\n  result.g = isNaN.g ? x.g : result.g;\n  result.b = isNaN.b ? x.b : result.b;\n  result.a = isNaN.a ? x.a : result.a;\n\n  return result;\n"}),aD={kernelName:on,backendName:"webgl",kernelFunc:iD},oD=sE({opSnippet:ST+"\n  return (x < 0.0) ? 0.0 : min(6.0, x);\n",packedOpSnippet:"\n  vec4 result = min(x, vec4(6.)) * vec4(greaterThanEqual(x, vec4(0.0)));\n  bvec4 isNaN = isnan(x);\n\n  result.r = isNaN.r ? x.r : result.r;\n  result.g = isNaN.g ? x.g : result.g;\n  result.b = isNaN.b ? x.b : result.b;\n  result.a = isNaN.a ? x.a : result.a;\n\n  return result;\n"}),uD={kernelName:pn,backendName:"webgl",kernelFunc:oD};class lD{
constructor(e,t,n,r,s){
this.variableNames=["A"],this.outputShape=[];const[i,a,o,u]=e;this.outputShape=[i,t,n,u];const l=[r&&t>1?a-1:a,r&&n>1?o-1:o],c=[r&&t>1?t-1:t,r&&n>1?n-1:n];let h;h=s?"(vec2(yRC) + vec2(0.5)) * effectiveInputOverOutputRatioRC - vec2(0.5)":"vec2(yRC) * effectiveInputOverOutputRatioRC",this.userCode=`\n      const vec2 effectiveInputOverOutputRatioRC = vec2(\n          ${l[0]/c[0]},\n          ${l[1]/c[1]});\n      const vec2 inputShapeRC = vec2(${a}.0, ${o}.0);\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        ivec2 yRC = coords.yz;\n\n        // Fractional source index.\n        vec2 sourceFracIndexRC = ${h};\n\n        // Compute the four integer indices.\n        ivec2 sourceFloorRC = ivec2(max(sourceFracIndexRC, vec2(0.0)));\n        ivec2 sourceCeilRC = ivec2(\n          min(inputShapeRC - 1.0, ceil(sourceFracIndexRC)));\n\n        float topLeft = getA(b, sourceFloorRC.x, sourceFloorRC.y, d);\n        float bottomLeft = getA(b, sourceCeilRC.x, sourceFloorRC.y, d);\n        float topRight = getA(b, sourceFloorRC.x, sourceCeilRC.y, d);\n        float bottomRight = getA(b, sourceCeilRC.x, sourceCeilRC.y, d);\n\n        vec2 fracRC = sourceFracIndexRC - vec2(sourceFloorRC);\n\n        float top = topLeft + (topRight - topLeft) * fracRC.y;\n        float bottom = bottomLeft + (bottomRight - bottomLeft) * fracRC.y;\n        float newValue = top + (bottom - top) * fracRC.x;\n\n        setOutput(newValue);\n      }\n    `;
}
}class cD{
constructor(e,t,n,r,s){
this.variableNames=["A"],this.packedInputs=!0,this.packedOutput=!0,this.outputShape=[];const[i,a,o,u]=e;this.outputShape=[i,t,n,u];const l=[r&&t>1?a-1:a,r&&n>1?o-1:o],c=[r&&t>1?t-1:t,r&&n>1?n-1:n];let h;h=s?"(vec3(yRC) + vec3(0.5)) * effectiveInputOverOutputRatioRC - vec3(0.5)":"vec3(yRC) * effectiveInputOverOutputRatioRC",this.userCode=`\n      const vec3 effectiveInputOverOutputRatioRC = vec3(\n          ${l[0]/c[0]},\n          ${l[1]/c[1]},\n          ${l[1]/c[1]});\n      const vec3 inputShapeRC = vec3(${a}.0, ${o}.0,\n                                     ${o}.0);\n\n      float getAValue(int b, int r, int c, int d) {\n        return getChannel(getA(b, r, c, d), vec2(c, d));\n      }\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        // Calculate values for next column in yRC.z.\n        ivec3 yRC = coords.yzz + ivec3(0, 0, 1);\n\n        // Fractional source index.\n        vec3 sourceFracIndexRC = ${h};\n\n        // Compute the four integer indices.\n        ivec3 sourceFloorRC = ivec3(max(sourceFracIndexRC, vec3(0.0)));\n        ivec3 sourceCeilRC = ivec3(\n          min(inputShapeRC - 1.0, ceil(sourceFracIndexRC)));\n\n        // Should we calculate next column and row elements in 2x2 packed cell.\n        bool hasNextCol = d < ${u-1};\n        bool hasNextRow = coords.z < ${n-1};\n\n        // In parallel, construct four corners for all four components in\n        // packed 2x2 cell.\n        vec4 topLeft = vec4(\n          getAValue(b, sourceFloorRC.x, sourceFloorRC.y, d),\n          hasNextCol ? getAValue(b, sourceFloorRC.x, sourceFloorRC.y, d + 1)\n                     : 0.0,\n          hasNextRow ? getAValue(b, sourceFloorRC.x, sourceFloorRC.z, d)\n                     : 0.0,\n          (hasNextRow && hasNextCol) ?\n            getAValue(b, sourceFloorRC.x, sourceFloorRC.z, d + 1) : 0.0);\n\n        vec4 bottomLeft = vec4(\n          getAValue(b, sourceCeilRC.x, sourceFloorRC.y, d),\n          hasNextCol ? getAValue(b, sourceCeilRC.x, sourceFloorRC.y, d + 1)\n                     : 0.0,\n          hasNextRow ? getAValue(b, sourceCeilRC.x, sourceFloorRC.z, d)\n                     : 0.0,\n          (hasNextRow && hasNextCol) ?\n            getAValue(b, sourceCeilRC.x, sourceFloorRC.z, d + 1) : 0.0);\n\n        vec4 topRight = vec4(\n          getAValue(b, sourceFloorRC.x, sourceCeilRC.y, d),\n          hasNextCol ? getAValue(b, sourceFloorRC.x, sourceCeilRC.y, d + 1)\n                     : 0.0,\n          hasNextRow ? getAValue(b, sourceFloorRC.x, sourceCeilRC.z, d)\n                     : 0.0,\n          (hasNextRow && hasNextCol) ?\n            getAValue(b, sourceFloorRC.x, sourceCeilRC.z, d + 1) : 0.0);\n\n        vec4 bottomRight = vec4(\n          getAValue(b, sourceCeilRC.x, sourceCeilRC.y, d),\n          hasNextCol ? getAValue(b, sourceCeilRC.x, sourceCeilRC.y, d + 1)\n                     : 0.0,\n          hasNextRow ? getAValue(b, sourceCeilRC.x, sourceCeilRC.z, d)\n                     : 0.0,\n          (hasNextRow && hasNextCol) ?\n            getAValue(b, sourceCeilRC.x, sourceCeilRC.z, d + 1) : 0.0);\n\n        vec3 fracRC = sourceFracIndexRC - vec3(sourceFloorRC);\n\n        vec4 top = mix(topLeft, topRight, fracRC.yyzz);\n        vec4 bottom = mix(bottomLeft, bottomRight, fracRC.yyzz);\n        vec4 newValue = mix(top, bottom, fracRC.x);\n\n        setOutput(newValue);\n      }\n    `;
}
}const hD={kernelName:hn,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{images:s}=t,{alignCorners:i,halfPixelCenters:a,size:o}=r,[u,l]=o,c=H().getBool("WEBGL_PACK_IMAGE_OPERATIONS")?new cD(s.shape,u,l,i,a):new lD(s.shape,u,l,i,a);return n.runWebGLProgram(c,[s],"float32");
}};class dD{
constructor(e,t,n){
this.variableNames=["dy"],this.outputShape=[],this.outputShape=t;const[,r,s]=t,[,i,a]=e,o=[n&&i>1?r-1:r,n&&a>1?s-1:s],u=[n&&i>1?i-1:i,n&&a>1?a-1:a],l=o[0]/u[0],c=o[1]/u[1],h=1/l,d=1/c,p=2*Math.ceil(h)+2,f=2*Math.ceil(d)+2;this.userCode=`\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        int r = coords[1];\n        int c = coords[2];\n\n        float accumulator = 0.0;\n\n        const float heightScale = float(${l});\n        const float widthScale = float(${c});\n\n        const float invHeightScale = float(${h});\n        const float invWidthScale = float(${d});\n\n        const int winHeight = int(${p});\n        const int winWidth = int(${f});\n\n        // Compute bounds for where in dy we will look\n        float startRLerp = floor(float(r) * invHeightScale);\n        int startDyR = int(startRLerp - float(winHeight / 2));\n\n        float startCLerp = floor(float(c) * invWidthScale);\n        int startDyC = int(startCLerp - float(winWidth / 2));\n\n        // Loop over dy\n        for (int dyROffset = 0; dyROffset < winHeight; dyROffset++) {\n          int dyR = dyROffset + startDyR;\n\n          // Guard against the window exceeding the bounds of dy\n          if (dyR < 0 || dyR >= ${i}) {\n            continue;\n          }\n\n          for (int dyCOffset = 0; dyCOffset < winWidth; dyCOffset++) {\n            int dyC = dyCOffset + startDyC;\n\n            // Guard against the window exceeding the bounds of dy\n            if (dyC < 0 || dyC >= ${a}) {\n              continue;\n            }\n\n            float dxR = float(dyR) * heightScale;\n            int topDxRIndex = int(floor(dxR));\n            int bottomDxRIndex = int(min(ceil(dxR), ${r-1}.0));\n            float dxRLerp = dxR - float(topDxRIndex);\n            float inverseDxRLerp = 1.0 - dxRLerp;\n\n            float dxC = float(dyC) * widthScale;\n            int leftDxCIndex = int(floor(dxC));\n            int rightDxCIndex = int(min(ceil(dxC), ${s-1}.0));\n            float dxCLerp = dxC - float(leftDxCIndex);\n            float inverseDxCLerp = 1.0 - dxCLerp;\n\n            if (r == topDxRIndex && c == leftDxCIndex) {\n              // topLeft\n              accumulator +=\n                getDy(b, dyR, dyC, d) * inverseDxRLerp * inverseDxCLerp;\n            }\n\n            if (r == topDxRIndex && c == rightDxCIndex) {\n              // topRight\n              accumulator += getDy(b, dyR, dyC, d) * inverseDxRLerp * dxCLerp;\n            }\n\n            if (r == bottomDxRIndex && c == leftDxCIndex) {\n              // bottomLeft\n              accumulator += getDy(b, dyR, dyC, d) * dxRLerp * inverseDxCLerp;\n            }\n\n            if (r == bottomDxRIndex && c == rightDxCIndex) {\n              // bottomRight\n              accumulator += getDy(b, dyR, dyC, d) * dxRLerp * dxCLerp;\n            }\n          }\n        }\n        // End loop over dy\n\n        setOutput(accumulator);\n      }\n    `;
}
}const pD={kernelName:dn,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{images:s,dy:i}=t,{alignCorners:a}=r,o=new dD(i.shape,s.shape,a);return n.runWebGLProgram(o,[i],i.dtype);
}};class fD{
constructor(e,t,n,r,s){
this.variableNames=["A"],this.outputShape=[];const[i,a,o,u]=e;this.outputShape=[i,t,n,u];const l=[r&&t>1?a-1:a,r&&n>1?o-1:o],c=[r&&t>1?t-1:t,r&&n>1?n-1:n],h=r?"0.5":"0.0";let d;d=s?"max((vec2(yRC) + vec2(0.5)) * effectiveInputOverOutputRatioRC, vec2(0.0))":"vec2(yRC) * effectiveInputOverOutputRatioRC",this.userCode=`\n      const vec2 effectiveInputOverOutputRatioRC = vec2(\n          ${l[0]/c[0]},\n          ${l[1]/c[1]});\n      const vec2 inputShapeRC = vec2(${a}.0, ${o}.0);\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        ivec2 yRC = coords.yz;\n\n        // Fractional source index.\n        vec2 sourceFracIndexRC = ${d};\n\n        // Compute the coordinators of nearest neighbor point.\n        ivec2 sourceNearestRC = ivec2(\n          min(inputShapeRC - 1.0, floor(sourceFracIndexRC + ${h})));\n        float newValue = getA(b, sourceNearestRC.x, sourceNearestRC.y, d);\n\n        setOutput(newValue);\n      }\n    `;
}
}class mD{
constructor(e,t,n,r,s){
this.variableNames=["A"],this.packedInputs=!0,this.packedOutput=!0,this.outputShape=[];const[i,a,o,u]=e;this.outputShape=[i,t,n,u];const l=[r&&t>1?a-1:a,r&&n>1?o-1:o],c=[r&&t>1?t-1:t,r&&n>1?n-1:n],h=r?"0.5":"0.0";let d;d=s?"max((vec3(yRC) + vec3(0.5)) * effectiveInputOverOutputRatioRC, vec3(0.0))":"vec3(yRC) * effectiveInputOverOutputRatioRC",this.userCode=`\n      const vec3 effectiveInputOverOutputRatioRC = vec3(\n          ${l[0]/c[0]},\n          ${l[1]/c[1]},\n          ${l[1]/c[1]});\n      const vec3 inputShapeRC = vec3(${a}.0, ${o}.0,\n                                     ${o}.0);\n\n      float getAValue(int b, int r, int c, int d) {\n        return getChannel(getA(b, r, c, d), vec2(c, d));\n      }\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        // Calculate values for next column in yRC.z.\n        ivec3 yRC = coords.yzz + ivec3(0, 0, 1);\n\n        // Fractional source index.\n        vec3 sourceFracIndexRC = ${d};\n\n        // Compute the coordinators of nearest neighbor point.\n        ivec3 sourceNearestRC = ivec3(\n          min(inputShapeRC - 1.0, floor(sourceFracIndexRC + ${h})));\n\n        // Should we calculate next column and row elements in 2x2 packed cell.\n        bool hasNextCol = d < ${u-1};\n        bool hasNextRow = coords.z < ${n-1};\n\n        vec4 newValue = vec4(\n          getAValue(b, sourceNearestRC.x, sourceNearestRC.y, d),\n          hasNextCol ? getAValue(b, sourceNearestRC.x, sourceNearestRC.y, d + 1)\n                     : 0.0,\n          hasNextRow ? getAValue(b, sourceNearestRC.x, sourceNearestRC.z, d)\n                     : 0.0,\n          (hasNextRow && hasNextCol) ?\n            getAValue(b, sourceNearestRC.x, sourceNearestRC.z, d + 1) : 0.0);\n\n        setOutput(newValue);\n      }\n    `;
}
}const gD={kernelName:ln,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{images:s}=t,{alignCorners:i,halfPixelCenters:a,size:o}=r,[u,l]=o,c=H().getBool("WEBGL_PACK_IMAGE_OPERATIONS")?new mD(s.shape,u,l,i,a):new fD(s.shape,u,l,i,a);return n.runWebGLProgram(c,[s],s.dtype);
}};class bD{
constructor(e,t,n){
this.variableNames=["dy"],this.outputShape=[],this.outputShape=t;const[,r,s]=t,[,i,a]=e,o=[n&&i>1?r-1:r,n&&a>1?s-1:s],u=[n&&i>1?i-1:i,n&&a>1?a-1:a],l=o[0]/u[0],c=o[1]/u[1],h=1/l,d=1/c,p=2*Math.ceil(h)+2,f=2*Math.ceil(d)+2;this.userCode=`\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        int r = coords[1];\n        int c = coords[2];\n\n        float accumulator = 0.0;\n\n        const float heightScale = float(${l});\n        const float widthScale = float(${c});\n\n        const float invHeightScale = float(${h});\n        const float invWidthScale = float(${d});\n\n        const int winHeight = int(${p});\n        const int winWidth = int(${f});\n\n        // Compute bounds for where in dy we will look\n        float startRLerp = floor(float(r) * invHeightScale);\n        int startDyR = int(floor(startRLerp - float(winHeight / 2)));\n\n        float startCLerp = floor(float(c) * invWidthScale);\n        int startDyC = int(floor(startCLerp - float(winWidth / 2)));\n\n        // Loop over dy\n        for (int dyROffset = 0; dyROffset < winHeight; dyROffset++) {\n          int dyR = dyROffset + startDyR;\n\n          // Guard against the window exceeding the bounds of dy\n          if (dyR < 0 || dyR >= ${i}) {\n            continue;\n          }\n\n          for (int dyCOffset = 0; dyCOffset < winWidth; dyCOffset++) {\n            int dyC = dyCOffset + startDyC;\n\n            // Guard against the window exceeding the bounds of dy\n            if (dyC < 0 || dyC >= ${a}) {\n              continue;\n            }\n\n            float sourceFracRow =\n              float(${o[0]}) *\n                (float(dyR) / float(${u[0]}));\n\n            float sourceFracCol =\n                float(${o[1]}) *\n                  (float(dyC) / float(${u[1]}));\n\n            int sourceNearestRow = int(min(\n                float(int(${r}) - 1),\n                ${n} ? float(round(sourceFracRow)) :\n                                  float(floor(sourceFracRow))));\n\n            int sourceNearestCol = int(min(\n                float(int(${s}) - 1),\n                ${n} ? float(round(sourceFracCol)) :\n                                  float(floor(sourceFracCol))));\n\n            if (r == sourceNearestRow && c == sourceNearestCol) {\n              accumulator += getDy(b, dyR, dyC, d);\n            }\n          }\n        }\n        // End loop over dy\n\n        setOutput(accumulator);\n      }\n    `;
}
}const xD={kernelName:cn,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{images:s,dy:i}=t,{alignCorners:a}=r,o=new bD(i.shape,s.shape,a);return n.runWebGLProgram(o,[i],i.dtype);
}};class yD{
constructor(e,t){
this.variableNames=["x"];const n=e.length;if(n>4){
throw new Error(`WebGL backend: Reverse of rank-${n} tensor is not yet supported`);
}if(this.outputShape=e,1===n){
return void(this.userCode=`\n        void main() {\n          int coord = getOutputCoords();\n          setOutput(getX(${e[0]} - coord - 1));\n        }\n      `);
}const r=e.map(((n,r)=>(n=>-1!==t.indexOf(n)&&1!==e[n]?`${e[n]} - coords[${n}] - 1`:`coords[${n}]`)(r))).join(","),s=QN(n);this.userCode=`\n      void main() {\n        ${s} coords = getOutputCoords();\n        setOutput(getX(${r}));\n      }\n    `;
}
}class wD{
constructor(e,t){
this.variableNames=["x"],this.packedInputs=!0,this.packedOutput=!0;const n=e.length;if(n>4){
throw new Error(`WebGL backend: Reverse of rank-${n} tensor is not yet supported`);
}this.outputShape=e;const r=gT("rc",n),s=`${r[n-1]} + 1 < ${this.outputShape[n-1]}`,i=`${r[n-2]} + 1 < ${this.outputShape[n-2]}`,a=QN(n);function o(n){
const r=e.map(((r,s)=>function(n,r){
return-1!==t.indexOf(n)&&1!==e[n]?`${e[n]} - ${r[n]} - 1`:`${r[n]}`;
}(s,n)));return`getChannel(getX(${r.join(",")}), vec2(${r.slice(-2).join(",")}))`;
}this.userCode=1===n?`\n        void main(){\n          int rc = getOutputCoords();\n          vec4 result = vec4(0.);\n          result.r = getChannel(getX(${e[0]} - rc - 1),\n            ${e[0]} - rc - 1);\n          if(${s}){\n              result.g = getChannel(getX(${e[0]} - (rc  + 1) - 1),\n                ${e[0]} - (rc  + 1) - 1);\n          }\n          setOutput(result);\n        }\n      `:`\n        void main() {\n          ${a} rc = getOutputCoords();\n          vec4 result = vec4(0.);\n          result.r = ${function(e){
return o(e);
}(r.slice())};\n          if(${s}){\n            result.g = ${function(e){
return e[n-1]="("+e[n-1]+" + 1)",o(e);
}(r.slice())};\n          }\n          if(${i}) {\n            result.b = ${function(e){
return e[n-2]="("+e[n-2]+" + 1)",o(e);
}(r.slice())};\n            if(${s}) {\n              result.a = ${function(e){
return e[n-1]="("+e[n-1]+" + 1)",e[n-2]="("+e[n-2]+" + 1)",o(e);
}(r.slice())};\n            }\n          }\n          setOutput(result);\n        }\n    `;
}
}const vD={kernelName:fn,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{dims:i}=r,a=s.shape.length,o=k(i,s.shape);if(0===a){
return qT({inputs:{x:s},backend:n});
}const u=H().getBool("WEBGL_PACK_ARRAY_OPERATIONS")?new wD(s.shape,o):new yD(s.shape,o);return n.runWebGLProgram(u,[s],s.dtype);
}};class kD{
constructor(e,t){
this.variableNames=["Image"],this.outputShape=[],this.customUniforms=[{name:"params",type:"vec4"}];const n=e[1],r=e[2];this.outputShape=e;let s="";s="number"==typeof t?`float outputValue = ${t.toFixed(2)};`:`\n        vec3 fill = vec3(${t.join(",")});\n        float outputValue = fill[coords[3]];`,this.userCode=`\n        void main() {\n          ivec4 coords = getOutputCoords();\n          int x = coords[2];\n          int y = coords[1];\n          float coordXFloat = (float(x) - params[0]) * params[3] -\n            (float(y) - params[1]) * params[2];\n          float coordYFloat = (float(x) - params[0]) * params[2] +\n            (float(y) - params[1]) * params[3];\n          int coordX = int(round(coordXFloat + params[0]));\n          int coordY = int(round(coordYFloat + params[1]));\n          ${s}\n          if(coordX >= 0 && coordX < ${r} && coordY >= 0 && coordY < ${n}) {\n            outputValue = getImage(coords[0], coordY, coordX, coords[3]);\n          }\n          setOutput(outputValue);\n        }\n    `;
}
}const ID={kernelName:rr,backendName:"webgl",kernelFunc:({inputs:e,attrs:t,backend:n})=>{
const{image:r}=e,{radians:s,fillValue:i,center:a}=t,o=n,u=new kD(r.shape,i),[l,c]=Ul(a,r.shape[1],r.shape[2]),h=[[l,c,Math.sin(s),Math.cos(s)]];return o.runWebGLProgram(u,[r],r.dtype,h);
}},SD=sE({opSnippet:"\n  // OpenGL ES does not support round function.\n  // The algorithm is based on banker's rounding.\n  float base = floor(x);\n  if ((x - base) < 0.5) {\n    return floor(x);\n  } else if ((x - base) > 0.5) {\n    return ceil(x);\n  } else {\n    if (mod(base, 2.0) == 0.0) {\n      return base;\n    } else {\n      return base + 1.0;\n    }\n  }\n"}),CD={kernelName:mn,backendName:"webgl",kernelFunc:SD},ND=sE({opSnippet:"return inversesqrt(x);",cpuKernelImpl:Y$}),$D={kernelName:gn,backendName:"webgl",kernelFunc:ND};class TD{
constructor(e,t,n,r,s,i,a=!0,o=!1){
this.variableNames=["updates","indices","defaultValue"],this.outputShape=i;const u=QN(s.length),l=QN(i.length);let c="";1===n?c="i":2===n&&(c="i, j");const h=`getIndices(${c})`;let d="";1===r?d="i":2===r&&(d="i, coords[1]");const p=`getUpdates(${d})`;let f="";o&&(f="coords[0], coords[1]");const m=`getDefaultValue(${f})`,g=t>1?"strides[j]":"strides";this.userCode=`\n        ${u} strides = ${u}(${s});\n\n        void main() {\n          ${l} coords = getOutputCoords();\n          float sum = 0.0;\n          bool found = false;\n          for (int i = 0; i < ${e}; i++) {\n            int flattenedIndex = 0;\n            for (int j = 0; j < ${t}; j++) {\n              int index = round(${h});\n              flattenedIndex += index * ${g};\n            }\n            if (flattenedIndex == coords[0]) {\n              sum += ${p};\n              found = true;\n            }\n          }\n          setOutput(mix(${m}, sum, float(found)));\n        }\n      `;
}
}class ED{
constructor(e,t,n,r,s,i,a=!0,o=!1){
this.variableNames=["updates","indices","defaultValue"],this.packedInputs=!0,this.packedOutput=!0,this.outputShape=i;const u=QN(s.length),l=QN(i.length);let c="";1===n?c="i":2===n&&(c="i, j");const h=`getIndices(${c})`;let d="";1===r?d="i":2===r&&(d="i, coords[1]");const p=`getUpdates(${d})`;let f="";o&&(f="coords[0], coords[1]");const m=`getDefaultValue(${f})`,g=t>1?"strides[j]":"strides",b=t>1?"strides[j + 1]":"strides";this.userCode=`\n        ${u} strides = ${u}(${s});\n\n        void main() {\n          ${l} coords = getOutputCoords();\n          vec4 sum = vec4(0.);\n          vec4 found = vec4(0.);\n          for (int i = 0; i < ${e}; i+=2) {\n            ivec2 flattenedIndex = ivec2(0);\n            for (int j = 0; j < ${t}; j+=2) {\n              ivec4 index = round(${h});\n              flattenedIndex += index.xz * ${g};\n              if (j + 1 < ${t}) {\n                flattenedIndex += index.yw * ${b};\n              }\n            }\n            if (flattenedIndex[0] == coords[0] || flattenedIndex[1] == coords[0] ||\n                flattenedIndex[0] == coords[0] + 1 || flattenedIndex[1] == coords[0] + 1) {\n              vec4 updVals = ${p};\n              if (flattenedIndex[0] == coords[0]) {\n                sum.xy += updVals.xy;\n                found.xy = vec2(1.);\n              } else if (flattenedIndex[0] == coords[0] + 1) {\n                sum.zw += updVals.xy;\n                found.zw = vec2(1.);\n              }\n              if (flattenedIndex[1] == coords[0]) {\n                sum.xy += updVals.zw;\n                found.xy = vec2(1.);\n              } else if (flattenedIndex[1] == coords[0] + 1) {\n                sum.zw += updVals.zw;\n                found.zw = vec2(1.);\n              }\n            }\n          }\n          setOutput(mix(${m}, sum, found));\n        }\n      `;
}
}const RD={kernelName:bn,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{indices:s,updates:i}=t,{shape:a}=r,{sliceRank:o,numUpdates:u,sliceSize:l,strides:c,outputSize:h}=Yl(0,s,a),d=[h/l,l];if(0===h){
return n.makeTensorInfo(a,s.dtype);
}const p=pE({inputs:{x:s},backend:n,attrs:{shape:[u,o]}}),f=pE({inputs:{x:i},backend:n,attrs:{shape:[u,l]}}),m=n.makeTensorInfo([],"float32",new Float32Array([0]));let g;g=H().getBool("WEBGL_PACK")?new ED(u,o,p.shape.length,f.shape.length,c,d):new TD(u,o,p.shape.length,f.shape.length,c,d);const b=n.runWebGLProgram(g,[f,p,m],f.dtype),x=pE({inputs:{x:b},backend:n,attrs:{shape:a}});return n.disposeIntermediateTensorInfo(p),n.disposeIntermediateTensorInfo(f),n.disposeIntermediateTensorInfo(b),n.disposeIntermediateTensorInfo(m),x;
}};class AD{
constructor(e,t,n,r){
this.variableNames=["sortedSequence","values"],this.customUniforms=[{name:"numInputs",type:"int"}],this.outputShape=[e,n];const s=`for (int i = 0; i < ${Math.ceil(Math.log2(t+1))}; ++i) { if (left >= right) break;`,i=2===H().getNumber("WEBGL_VERSION")?"while (left < right) {":s,a="left"===r?"<":"<=";this.userCode=`\n       int findBound(int batch, float value) {\n         int left = 0;\n         int right = numInputs;\n         int mid;\n         ${i}\n           mid = (left + right) / 2;\n           if (getSortedSequence(batch, mid) ${a} value) {\n             left = mid + 1;\n           } else {\n             right = mid;\n           }\n         }\n         return right;\n       }\n\n       void main() {\n         ivec2 coords = getOutputCoords();\n         int batch = coords[0];\n         int valueIndex = coords[1];\n\n         float value = getValues(batch, valueIndex);\n\n         setOutput(float(findBound(batch, value)));\n       }\n     `;
}
}const FD={kernelName:yn,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{sortedSequence:s,values:i}=t,{side:a}=r,o=new AD(s.shape[0],s.shape[1],i.shape[1],a),u=[[s.shape[1]]];return n.runWebGLProgram(o,[s,i],"int32",u);
}};class _D{
constructor(e,t,n){
let r,s;if(this.variableNames=["c","a","b"],this.outputShape=t,n>4){
throw Error(`Where for rank ${n} is not yet supported`);
}if(1===n){
s="resRC",r="resRC";
}else{
const n=["resRC.x","resRC.y","resRC.z","resRC.w"],i=[],a=[];for(let r=0;r<t.length;r++){
a.push(`${n[r]}`),r<e&&i.push(`${n[r]}`);
}r=i.join(),s=a.join();
}const i=QN(n);this.userCode=`\n      void main() {\n        ${i} resRC = getOutputCoords();\n        float cVal = getC(${r});\n        if (cVal >= 1.0) {\n          setOutput(getA(${s}));\n        } else {\n          setOutput(getB(${s}));\n        }\n      }\n    `;
}
}const DD={kernelName:wn,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n}=e,{condition:r,t:s,e:i}=t,a=new _D(r.shape.length,s.shape,s.shape.length);return n.runWebGLProgram(a,[r,s,i],ls(s.dtype,i.dtype));
}},OD=sE({opSnippet:`\n  // Stable and Attracting Fixed Point (0, 1) for Normalized Weights.\n  // see: https://arxiv.org/abs/1706.02515\n  float scaleAlpha = ${Zl};\n  float scale = ${Jl};\n  return (x >= 0.0) ? scale * x : scaleAlpha * (exp(x) - 1.0);\n`}),MD={kernelName:vn,backendName:"webgl",kernelFunc:OD},LD=sE({opSnippet:rE+"\n  return 1.0 / (1.0 + exp(-1.0 * x));\n",packedOpSnippet:"\n  vec4 result = 1.0 / (1.0 + exp(-1.0 * x));\n  bvec4 isNaN = isnan(x);\n\n  result.r = isNaN.r ? x.r : result.r;\n  result.g = isNaN.g ? x.g : result.g;\n  result.b = isNaN.b ? x.b : result.b;\n  result.a = isNaN.a ? x.a : result.a;\n\n  return result;\n",cpuKernelImpl:J$}),zD={kernelName:Nn,backendName:"webgl",kernelFunc:LD},PD=sE({opSnippet:"\n  if (isnan(x)) { return 0.0; }\n  return sign(x);\n"}),BD={kernelName:Cn,backendName:"webgl",kernelFunc:PD},UD=sE({opSnippet:rE+"\n  return sin(x);\n",packedOpSnippet:`\n  vec4 result = sin(x);\n  bvec4 isNaN = isnan(x);\n  ${jT}\n  return result;\n`}),WD={kernelName:In,backendName:"webgl",kernelFunc:UD},VD=sE({opSnippet:"\n  float e2x = exp(x);\n  return (e2x - 1.0 / e2x) / 2.0;\n"}),GD={kernelName:Sn,backendName:"webgl",kernelFunc:VD},jD=sE({opSnippet:"\n  float epsilon = 1.1920928955078125e-7;\n  float threshold = log(epsilon) + 2.0;\n\n  bool too_large = x > -threshold;\n  bool too_small = x < threshold;\n\n  float result;\n  float exp_x = exp(x);\n\n  if (too_large){\n    result = x;\n  }\n  else if (too_small){\n    result = exp_x;\n  }\n  else{\n    result = log(exp_x + 1.0);\n  }\n  return result;\n"}),HD={kernelName:$n,backendName:"webgl",kernelFunc:jD},qD={kernelName:Rn,backendName:"webgl",kernelFunc:e=>{
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{blockShape:i,paddings:a}=r;d(s.shape.length<=4,(()=>"spaceToBatchND for rank > 4 with a WebGL backend not implemented yet"));const o=i.reduce(((e,t)=>e*t)),u=[[0,0]];u.push(...a);for(let e=1+i.length;e<s.shape.length;++e){
u.push([0,0]);
}const l=[],c=q_({inputs:{x:s},backend:n,attrs:{paddings:u,constantValue:0}}),h=Wl(c.shape,i,o,!1),p=Vl(h.length,i.length,!1),f=Gl(c.shape,i,o,!1),m=pE({inputs:{x:c},backend:n,attrs:{shape:h}}),g=IE({inputs:{x:m},backend:n,attrs:{perm:p}}),b=pE({inputs:{x:g},backend:n,attrs:{shape:f}});return l.push(c),l.push(m),l.push(g),l.forEach((e=>n.disposeIntermediateTensorInfo(e))),b;
}},KD={kernelName:_n,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n}=e,{indices:r,values:s,denseShape:i,defaultValue:a}=t;if(1!==i.shape.length){
throw new Error(`Dense shape must be a vector, saw:\n         ${i.shape}`);
}if(2!==r.shape.length){
throw new Error(`Indices must be a matrix, saw:\n         ${r.shape}`);
}if(1!==s.shape.length){
throw new Error(`Values must be a vector, saw:\n         ${s.shape}`);
}if(0!==a.shape.length){
throw new Error(`Default value must be a scalar, saw:\n        ${a.shape}`);
}const o=n.readSync(r.dataId),u=n.readSync(s.dataId),l=n.readSync(i.dataId),c=n.readSync(a.dataId)[0],[h,d,p,f,m]=tT(o,r.shape,r.dtype,u,s.dtype,l,c);return[n.makeTensorInfo(d,r.dtype,h),n.makeTensorInfo([d[0]],s.dtype,p),n.makeTensorInfo([f.length],"bool",new Uint8Array(f.map((e=>Number(e))))),n.makeTensorInfo([m.length],r.dtype,new Int32Array(m))];
}},XD={kernelName:Dn,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n}=e,{inputIndices:r,inputShape:s,newShape:i}=t;if(2!==r.shape.length){
throw new Error(`Input indices should be a matrix but received shape ${r.shape}`);
}if(1!==s.shape.length){
throw new Error(`Input shape should be a vector but received shape ${s.shape}`);
}if(1!==i.shape.length){
throw new Error(`Target shape should be a vector but received shape ${i.shape}`);
}const a=Array.from(n.readSync(s.dataId)),o=n.readSync(r.dataId),u=Array.from(n.readSync(i.dataId)),[l,c,h]=nT(o,r.shape,r.dtype,a,u);return[n.makeTensorInfo(c,r.dtype,l),n.makeTensorInfo([h.length],i.dtype,new Int32Array(h))];
}},YD={kernelName:On,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n}=e,{data:r,indices:s,segmentIds:i}=t;if(r.shape.length<1){
throw new Error("Data should be at least 1 dimensional but received scalar");
}if(1!==s.shape.length){
throw new Error(`Indices should be a vector but received shape\n              ${s.shape}`);
}if(1!==i.shape.length){
throw new Error(`Segment ids should be a vector but received shape\n              ${i.shape}`);
}const a=n.readSync(r.dataId),o=n.readSync(s.dataId),u=n.readSync(i.dataId),[l,c]=rT(a,r.shape,r.dtype,o,u,!0);return n.makeTensorInfo(c,r.dtype,l);
}},ZD={kernelName:Mn,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n}=e,{data:r,indices:s,segmentIds:i}=t;if(r.shape.length<1){
throw new Error("Data should be at least 1 dimensional but received scalar");
}if(1!==s.shape.length){
throw new Error(`Indices should be a vector but received shape\n             ${s.shape}`);
}if(1!==i.shape.length){
throw new Error(`Segment ids should be a vector but received shape\n             ${i.shape}`);
}const a=n.readSync(r.dataId),o=n.readSync(s.dataId),u=n.readSync(i.dataId),[l,c]=rT(a,r.shape,r.dtype,o,u);return n.makeTensorInfo(c,r.dtype,l);
}},JD={kernelName:Ln,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{sparseIndices:s,sparseValues:i,defaultValue:a}=t,{outputShape:o}=r,{sliceRank:u,numUpdates:l,sliceSize:c,strides:h,outputSize:d}=Yl(0,s,o);if("string"===i.dtype){
const e=n.bufferSync(s),t=n.bufferSync(i),r=Mr(n.readSync(a.dataId)[0]),p=Z$(e,t,o,d,c,l,u,h,r,!1);return n.makeTensorInfo(o,p.dtype,p.values);
}const p=new TD(l,u,s.shape.length,i.shape.length,h,[d,1],!1),f=n.runWebGLProgram(p,[i,s,a],i.dtype),m=pE({inputs:{x:f},backend:n,attrs:{shape:o}});return n.disposeIntermediateTensorInfo(f),m;
}},QD={kernelName:An,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{numOrSizeSplits:i,axis:a}=r,o=k(a,s.shape)[0],u=Ic(s,i,o),l=s.shape.length,c=new Array(l).fill(0),h=s.shape.slice();return u.map((e=>{
const t=[...h];t[o]=e;const r=wR({inputs:{x:s},backend:n,attrs:{begin:c,size:t}});return c[o]+=e,r;
}));
}},eO="return sqrt(x);",tO=sE({opSnippet:eO,packedOpSnippet:eO,cpuKernelImpl:sT}),nO={kernelName:Tn,backendName:"webgl",kernelFunc:tO},rO={kernelName:Pn,backendName:"webgl",kernelFunc:sE({opSnippet:"return x * x;"})},sO="return (a - b) * (a - b);",iO=iE({opSnippet:sO,packedOpSnippet:sO}),aO={kernelName:zn,backendName:"webgl",kernelFunc:iO},oO={kernelName:Bn,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t;if("string"!==s.dtype){
throw new Error("Input must be of datatype string");
}const i=Pc(n.readSync(s.dataId)),a=iT(i,"string",r);return n.makeTensorInfo(s.shape,"string",a);
}},uO={kernelName:nr,backendName:"webgl",kernelFunc:function({inputs:e,attrs:t,backend:n}){
const{x:r}=e,s=ST+`\n    return x > 0.0 ? 1.0 : float(${t.alpha});\n  `,i=new IT(r.shape,s);return n.runWebGLProgram(i,[r],r.dtype);
}};class lO{
constructor(e,t,n){
this.variableNames=["x"],this.outputShape=n;const r=n.length,s=QN(n.length),i=QN(n.length);let a="";if(1===r){
a="coords * strides + begin";
}else{
let e=0;a=n.map(((t,r)=>(e++,1===n.length?`coords * strides[${r}] + begin[${r}]`:`coords[${e-1}] * strides[${r}] + begin[${r}]`))).join(",");
}this.userCode=`\n      ${s} begin = ${s}(${e});\n      ${s} strides = ${s}(${t});\n\n      void main() {\n        ${i} coords = getOutputCoords();\n        setOutput(getX(${a}));\n      }\n    `;
}
}const cO={kernelName:Un,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{begin:i,end:a,strides:o,beginMask:u,endMask:l,ellipsisMask:c,newAxisMask:h,shrinkAxisMask:p}=r,{finalShapeSparse:f,finalShape:m,isIdentity:g,sliceDim0:b,isSimpleSlice:x,begin:y,end:w,strides:v}=Ia(s.shape,i,a,o,u,l,c,h,p);let k;if(g){
k=pE({inputs:{x:s},backend:n,attrs:{shape:m}});
}else if(b||x){
d(s.shape.length>=1,(()=>`Input must have rank at least 1, got: ${s.shape.length}`));const e=ca(y,w,v),t=wR({inputs:{x:s},backend:n,attrs:{begin:y,size:e}});k=pE({inputs:{x:t},backend:n,attrs:{shape:m}}),n.disposeIntermediateTensorInfo(t);
}else if(n.shouldExecuteOnCPU([s])){
const e=n.readSync(s.dataId),t=pi(s.shape,s.dtype,e),r=aT(f,t,v,y);k=n.makeTensorInfo(m,s.dtype,r.values);
}else{
const e=new lO(y,v,f);k=n.runWebGLProgram(e,[s],s.dtype);
}const I=pE({inputs:{x:k},backend:n,attrs:{shape:m}});return n.disposeIntermediateTensorInfo(k),I;
}},hO={kernelName:Wn,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{separator:s,nGramWidths:i,leftPad:a,rightPad:o,padWidth:u,preserveShortSequences:l}=r,{data:c,dataSplits:h}=t,d=n.readSync(c.dataId),p=n.readSync(h.dataId),[f,m]=oT(d,p,s,i,a,o,u,l);return[n.makeTensorInfo([f.length],"string",f),n.makeTensorInfo(h.shape,"int32",m)];
}},dO={kernelName:Vn,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{skipEmpty:s}=r,{input:i,delimiter:a}=t;if("string"!==i.dtype){
throw new Error("Input must be of datatype string");
}if(1!==i.shape.length){
throw new Error(`Input must be a vector, got shape: ${i.shape}`);
}if(0!==a.shape.length){
throw new Error(`Delimiter must be a scalar, got shape: ${a.shape}`);
}const o=n.readSync(i.dataId),u=n.readSync(a.dataId)[0],[l,c,h]=uT(o,u,s),d=c.length;return[n.makeTensorInfo([d,2],"int32",l),n.makeTensorInfo([d],"string",c),n.makeTensorInfo([2],"int32",new Int32Array(h))];
}},pO={kernelName:Gn,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{numBuckets:s}=r,{input:i}=t;if("string"!==i.dtype){
throw new Error("Input must be of datatype string");
}if(s<=0){
throw new Error("Number of buckets must be at least 1");
}const a=n.readSync(i.dataId),o=lT(a,s);return n.makeTensorInfo(i.shape,"int32",o);
}},fO=sE({opSnippet:"return tan(x);"}),mO={kernelName:Hn,backendName:"webgl",kernelFunc:fO},gO=sE({opSnippet:"\n  float e2x = exp(-2.0 * abs(x));\n  return sign(x) * (1.0 - e2x) / (1.0 + e2x);\n"}),bO={kernelName:qn,backendName:"webgl",kernelFunc:gO},xO={kernelName:xn,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{tensor:s,indices:i,updates:a}=t,{}=r,{sliceRank:o,numUpdates:u,sliceSize:l,strides:c,outputSize:h}=Yl(0,i,s.shape),d=[h/l,l];if(0===h){
return n.makeTensorInfo(s.shape,i.dtype);
}const p=pE({inputs:{x:i},backend:n,attrs:{shape:[u,o]}}),f=pE({inputs:{x:a},backend:n,attrs:{shape:[u,l]}}),m=pE({inputs:{x:s},backend:n,attrs:{shape:d}}),g=new TD(u,o,p.shape.length,f.shape.length,c,d,!1,!0),b=n.runWebGLProgram(g,[f,p,m],m.dtype),x=pE({inputs:{x:b},backend:n,attrs:{shape:s.shape}});return n.disposeIntermediateTensorInfo(p),n.disposeIntermediateTensorInfo(f),n.disposeIntermediateTensorInfo(m),n.disposeIntermediateTensorInfo(b),x;
}};class yO{
constructor(e,t){
this.variableNames=["A"];const n=new Array(e.length);for(let r=0;r<n.length;r++){
n[r]=e[r]*t[r];
}this.outputShape=n,this.rank=n.length;const r=QN(this.rank),s=function(e){
const t=e.length;if(t>5){
throw Error(`Tile for rank ${t} is not yet supported`);
}if(1===t){
return`imod(resRC, ${e[0]})`;
}const n=["resRC.x","resRC.y","resRC.z","resRC.w","resRC.u"],r=[];for(let t=0;t<e.length;t++){
r.push(`imod(${n[t]}, ${e[t]})`);
}return r.join();
}(e);this.userCode=`\n      void main() {\n        ${r} resRC = getOutputCoords();\n        setOutput(getA(${s}));\n      }\n    `;
}
}function wO(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{reps:i}=r;if("string"===s.dtype||s.shape.length>5){
const e=n.readSync(s.dataId),t="string"===s.dtype?e.map((e=>Mr(e))):e,r=pi(s.shape,s.dtype,t),a=hT(r,i);return n.makeTensorInfo(a.shape,a.dtype,a.values);
}const a=new yO(s.shape,i);return n.runWebGLProgram(a,[s],s.dtype);
}const vO={kernelName:Kn,backendName:"webgl",kernelFunc:wO};class kO{
constructor(e){
this.variableNames=["x","indices"],this.customUniforms=[{name:"n",type:"int"},{name:"firstPass",type:"int"},{name:"negativeInf",type:"float"},{name:"dir",type:"int"},{name:"inc",type:"int"}],this.outputShape=e,this.userCode="\n       void main() {\n         ivec2 coords = getOutputCoords();\n         int batch = coords[0];\n         int elemIdx = coords[1];\n\n         // We compare elements pair-wise within a group of size 2 * inc.\n         // The comparing rule for each group alternates between ascending\n         // and descending. Within each group, we compare each pair at\n         // positions i and i+inc. To decide whether an element at position i\n         // is x0 or x1, we mod it by 2 * inc, if the result is smaller than\n         // inc, it is in the first half of the group, we denote it as x0,\n         // otherwise we denote it as x1.\n         // For example, as shown in the Bitonic top K paper referenced above,\n         // Figure5(a) shows that element[1] is in the\n         // second half of the group when group size is 2, but it is in the\n         // first half of the group when group size is 4.\n\n         bool isFirstInPair = imod(elemIdx, 2 * inc) < inc;\n         int i = isFirstInPair ? elemIdx : elemIdx - inc;\n\n         int i0 = firstPass == 1 ? i : int(getIndices(batch, i));\n         int i1 = firstPass == 1 ? i + inc : int(getIndices(batch, i + inc));\n         float x0 = i0 < n ? getX(batch, i0) : negativeInf;\n         float x1 = i1 < n ? getX(batch, i1) : negativeInf;\n\n         // Denotes which direction indices are in (ascending or descending).\n         bool reverse = imod(elemIdx, 2 * dir) >= dir;\n         bool isGreater = x0 > x1 || (x0 == x1 && i1 > i0);\n         if (reverse == isGreater) { // Elements in opposite order of direction\n           int iTemp = i0;\n           i0 = i1;\n           i1 = iTemp;\n         }\n         if (isFirstInPair) {\n            setOutput(float(i0));\n         } else {\n            setOutput(float(i1));\n         }\n       }\n     ";
}
}class IO{
constructor(e){
this.variableNames=["x","indices"],this.customUniforms=[{name:"n",type:"int"},{name:"firstPass",type:"int"},{name:"k",type:"int"}],this.outputShape=e,this.userCode="\n    void main() {\n         // Takes max of indices (0, k), (1, k + 1), (2, k + 2) ...\n         ivec2 coords = getOutputCoords();\n         int batch = coords[0];\n         int elemIdx = coords[1];\n\n         // The output size is half of the previous size.\n         // If the previous sequence is | | | | _ _ _ _  | | | |  _ _ _ _ (k=4),\n         // we only need to output the indices at positions |, the indices at\n         // positions _ can be thrown away, see Figure5(b) After Phase 2\n         // (Merge phase) in the Bitonic Top K paper referenced above.\n         // For example, the paper shows we only need to output the orange bars.\n         // The output sequence should look like this | | | | | | | |.\n         // Because the sequence is halved, to map the output index back\n         // to the previous sequence to find the corresponding value,\n         // we need to double the index. When we double the index,\n         // we basically interpolate a position, so 2i looks like\n         // | _ | _ | _ | _ | _ | _ | _. We move the | to the first k position\n         // of each 2k positions by - elemIdx % k. E.g. for output at\n         // index 4,5,6,7, we want to get the corresponding element at\n         // original index 8,9,10,11, for output at index 8,9,10,11,\n         // we want to get the corresponding element at original index\n         // 16,17,18,19, so on and so forth.\n\n         int i = elemIdx < k ? elemIdx : (elemIdx * 2 - imod(elemIdx, k));\n         int i0 = firstPass == 1 ? i : int(getIndices(batch, i));\n         int i1 = firstPass == 1 ? i + k : int(getIndices(batch, i + k));\n\n         float x0 = getX(batch, i0);\n         float x1 = i1 < n ? getX(batch, i1) : x0;\n\n         setOutput(x0 >= x1 ? float(i0) : float(i1));\n       }\n     ";
}
}function SO(e,t){
null!==t&&e.disposeIntermediateTensorInfo(t);
}function CO(e){
let t=1;for(;t<e;){
t*=2;
}return t;
}const NO={kernelName:Xn,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s}=t,{k:i,sorted:a}=r,o=H().getNumber("TOPK_LAST_DIM_CPU_HANDOFF_SIZE_THRESHOLD"),u=H().getNumber("TOPK_K_CPU_HANDOFF_THRESHOLD"),l=s.shape,c=l[l.length-1];if(n.shouldExecuteOnCPU([s])||c<o||i>u){
const e=n.readSync(s.dataId),[t,r]=dT(e,l,s.dtype,i,a);return[n.makeTensorInfo(t.shape,t.dtype,t.values),n.makeTensorInfo(r.shape,r.dtype,r.values)];
}if(0===i){
return l[l.length-1]=0,[n.makeTensorInfo(l,s.dtype,[]),n.makeTensorInfo(l,"int32",[])];
}if(1===c){
return[s,sF({attrs:{shape:l,dtype:"int32",value:0},backend:n})];
}const h=n.texData.get(s.dataId),d=null!==h&&h.isPacked,p=d?n.unpackTensor(s):s,f=m(l)/c,g=pE({inputs:{x:p},attrs:{shape:[f,c]},backend:n});d&&SO(n,p);const b=CO(i),x=CO(c);let y=null;const w=()=>null===y?[g,g]:[g,y],v=(e,t,r)=>{
const s=w(),i=new kO(r),a=[[c],[null===y?1:0],[Number.NEGATIVE_INFINITY],[e],[t]],o=y;y=n.runWebGLProgram(i,s,"int32",a),SO(n,o);
};for(let e=1;e<b;e*=2){
const t=2*e;for(let n=e;n>=1;n/=2){
v(t,n,[f,x]);
}
}for(let e=x;e>b;e/=2){
const t=w(),r=new IO([f,e/2]),s=[[c],[null===y?1:0],[b]],i=y;y=n.runWebGLProgram(r,t,"int32",s),SO(n,i);const a=b/2,o=2*a;for(let e=a;e>=1;e/=2){
v(o,e,y.shape);
}
}let k=y;y=wR({inputs:{x:y},backend:n,attrs:{begin:0,size:[f,i]}}),SO(n,k);let I=IF({inputs:{x:g,indices:y},backend:n,attrs:{axis:1,batchDims:1}});SO(n,g);const S=l.slice(0,-1);S.push(i),k=y,y=pE({inputs:{x:y},attrs:{shape:S},backend:n}),SO(n,k);const C=I;return I=pE({inputs:{x:I},attrs:{shape:S},backend:n}),SO(n,C),[I,y];
}};class $O{
constructor(e,t,n,r,s,i){
this.variableNames=["Image","Transforms"],this.outputShape=i;const a="nearest"===n?1:2;let o;switch(r){
case"constant":default:o=1;break;case"reflect":o=2;break;case"wrap":o=3;break;case"nearest":o=4;
}this.userCode=`\n            float mapCoord(float outCoord, float len) {\n              float inCoord = outCoord;\n              if(${o} == 2) {\n                if (inCoord < 0.0) {\n                  if (len <= 1.0) {\n                    inCoord = 0.0;\n                  } else {\n                    float sz2 = 2.0 * len;\n                    if (inCoord < sz2) {\n                      inCoord = sz2 * float(int(float(-inCoord / sz2))) +\n                      inCoord;\n                    }\n                    inCoord = inCoord < -len ? inCoord + sz2 : -inCoord - 1.0;\n                  }\n                } else if (inCoord > len - 1.0) {\n                  if (len <= 1.0) {\n                    inCoord = 0.0;\n                  } else {\n                    float sz2 = 2.0 * len;\n                    inCoord -= sz2 * float(int(float(inCoord / sz2)));\n                    if (inCoord >= len) {\n                      inCoord = sz2 - inCoord - 1.0;\n                    }\n                  }\n                }\n                return clamp(inCoord, 0.0, len - 1.0);\n              } else if (${o} == 3) {\n                if (inCoord < 0.0) {\n                  if (len <= 1.0) {\n                    inCoord = 0.0;\n                  } else {\n                    float sz = len - 1.0;\n                    inCoord += len * (float(int(float(-inCoord / sz))) + 1.0);\n                  }\n                } else if (inCoord > len - 1.0) {\n                  if (len <= 1.0) {\n                    inCoord = 0.0;\n                  } else {\n                    float sz = len - 1.0;\n                    inCoord -= len * float(int(float(inCoord / sz)));\n                  }\n                }\n                return clamp(inCoord, 0.0, len - 1.0);\n              } else if (${o} == 4) {\n                return clamp(outCoord, 0.0, len - 1.0);\n              } else {\n                return outCoord;\n              }\n            }\n\n            float readWithFillValue(int batch, int coordY, int coordX,\n              int channel) {\n              float outputValue;\n              if (0 <= coordY && coordY < ${e} && 0 <= coordX && coordX < ${t}) {\n                  outputValue = getImage(batch, coordY, coordX, channel);\n              } else {\n                outputValue = float(${s});\n              }\n              return outputValue;\n            }\n\n            void main() {\n              ivec4 coords = getOutputCoords();\n              float outputValue;\n              int batch = coords[0];\n              int x = coords[2];\n              int y = coords[1];\n              int channel = coords[3];\n              float xf = float(x);\n              float yf = float(y);\n              float a1 = getTransforms(batch, 0);\n              float a2 = getTransforms(batch, 1);\n              float a3 = getTransforms(batch, 2);\n              float b1 = getTransforms(batch, 3);\n              float b2 = getTransforms(batch, 4);\n              float b3 = getTransforms(batch, 5);\n              float c1 = getTransforms(batch, 6);\n              float c2 = getTransforms(batch, 7);\n              float projection = c1 * xf + c2 * yf + 1.0;\n              if (projection == 0.0) {\n                outputValue = float(${s});\n              } else {\n                float inX = (a1 * xf + a2 * yf + a3) / projection;\n                float inY = (b1 * xf + b2 * yf + b3) / projection;\n                float mapX = mapCoord(inX, float(${t}));\n                float mapY = mapCoord(inY, float(${e}));\n\n                if (${a} == 1) {\n                  int coordY = int(round(mapY));\n                  int coordX = int(round(mapX));\n                  outputValue = readWithFillValue(batch, coordY, coordX,\n                    channel);\n                } else {\n                  float yFloor = floor(mapY);\n                  float xFloor = floor(mapX);\n                  float yCeil = yFloor + 1.0;\n                  float xCeil = xFloor + 1.0;\n                  float valueYFloor = (xCeil - mapX) *\n                  readWithFillValue(batch, int(yFloor), int(xFloor), channel) +\n                  (mapX - xFloor) *\n                  readWithFillValue(batch, int(yFloor), int(xCeil), channel);\n                  float valueYCeil = (xCeil - mapX) *\n                  readWithFillValue(batch, int(yCeil), int(xFloor), channel) +\n                  (mapX - xFloor) *\n                  readWithFillValue(batch, int(yCeil), int(xCeil), channel);\n                  outputValue = (yCeil - mapY) * valueYFloor +\n                  (mapY - yFloor) * valueYCeil;\n                }\n              }\n              setOutput(outputValue);\n            }\n        `;
}
}const TO={kernelName:Yn,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{image:s,transforms:i}=t,{interpolation:a,fillMode:o,fillValue:u,outputShape:l}=r,[c,h,d,p]=s.shape,[f,m]=null!=l?l:[h,d],g=new $O(h,d,a,o,u,[c,f,m,p]);return n.runWebGLProgram(g,[s,i],"float32");
}},EO={kernelName:Jn,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,attrs:n,backend:r}=e,{axis:s}=n,{x:i}=t;MN(i,"unique"),console.warn("WARNING: ","UI might be locked temporarily as data is being downloaded");const a=r.readSync(i.dataId),{outputValues:o,outputShape:u,indices:l}=fT(a,s,i.shape,i.dtype);return[r.makeTensorInfo(u,i.dtype,o),r.makeTensorInfo([l.length],"int32",l)];
}},RO={kernelName:Qn,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{value:s}=t;let{axis:i}=r;i<0&&(i+=s.shape.length);const a=s,o=a.shape.length,u=s.shape[i],l=new Array(o-1);let c=0;for(let e=0;e<o;e++){
e!==i&&(l[c++]=a.shape[e]);
}const h=[],d=new Array(o).fill(0),p=a.shape.slice();p[i]=1;const f=new Array(u);for(let e=0;e<f.length;e++){
d[i]=e;const t=wR({inputs:{x:a},backend:n,attrs:{begin:d,size:p}}),r=pE({inputs:{x:t},backend:n,attrs:{shape:l}});f[e]=r,h.push(t);
}return h.forEach((e=>n.disposeIntermediateTensorInfo(e))),f;
}};class AO{
constructor(e,t){
this.variableNames=["x","segmentIds"];const n=e.windowSize,r=e.batchSize,s=e.inSize,i=e.numSegments,a=i*Math.ceil(s/n);this.outputShape=[r,a];const o=4*Math.floor(n/4),u=n%4,l="\n        sumValue += dot(values, segFilter);\n    ";let c="";s%n>0&&(c=`\n        if (inIdx < 0 || inIdx >= ${s}) {\n          return initializationValue;\n        }\n      `);let h="";s%n>0&&(h=`\n        if (inIdx < 0 || inIdx >= ${s}) {\n          return -1.0;\n        }\n      `),this.userCode=`\n      const float initializationValue = 0.0;\n\n      float getValue(int batch, int inIdx) {\n        ${c}\n        return getX(batch, inIdx);\n      }\n\n      float getSegmentIdAtIndex(int inIdx) {\n        ${h}\n        return getSegmentIds(inIdx);\n      }\n\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int batch = coords[0];\n        int outIdx = coords[1];\n        int inOffset = int(floor(float(outIdx) / float(\n          ${i})) * float(${n}));\n        int currentSeg = int(mod(float(outIdx), float(${i})));\n\n        float sumValue = 0.0;\n\n        for (int i = 0; i < ${o}; i += 4) {\n          int inIdx = inOffset + i;\n          vec4 values = vec4(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            getValue(batch, inIdx + 2),\n            getValue(batch, inIdx + 3)\n          );\n\n          vec4 segFilter = vec4(\n            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 2)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 3)) == currentSeg ? 1 : 0\n          );\n\n          ${l}\n        }\n\n        int inIdx = inOffset + ${o};\n        if (${1===u}) {\n          vec4 values = vec4(\n            getValue(batch, inIdx),\n            initializationValue,\n            initializationValue,\n            initializationValue\n          );\n\n          int inIdxSeg = int(getSegmentIdAtIndex(inIdx));\n\n          vec4 segFilter = vec4(\n            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,\n            0,\n            0,\n            0\n          );\n\n          ${l}\n        } else if (${2===u}) {\n          vec4 values = vec4(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            initializationValue,\n            initializationValue\n          );\n\n          vec4 segFilter = vec4(\n            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,\n              0,\n              0\n          );\n\n          ${l}\n        } else if (${3===u}) {\n          vec4 values = vec4(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            getValue(batch, inIdx + 2),\n            initializationValue\n          );\n\n          vec4 segFilter = vec4(\n            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 2)) == currentSeg ? 1 : 0,\n            0\n          );\n\n          ${l}\n        }\n        setOutput(sumValue);\n      }\n    `;
}
}const FO=[$E,EE,AE,_E,ME,PE,BE,UE,qE,KE,YE,JE,eR,nR,sR,oR,uR,hR,dR,pR,gR,kR,IR,SR,CR,RR,_R,MR,YT,PR,qR,tA,aA,uA,lA,cA,hA,pA,mA,bA,IA,SA,CA,$A,RA,_A,DA,MA,zA,PA,UA,WA,GA,HA,KA,YA,QA,nF,iF,oF,cF,dF,mF,xF,yF,vF,SF,NF,TF,KT,EF,GR,AF,_F,OF,QT,LF,PF,BF,WF,GF,HF,KF,YF,QF,t_,r_,i_,a_,o_,c_,h_,d_,p_,f_,g_,y_,v_,R_,dE,F_,D_,M_,z_,$R,B_,V_,G_,K_,Y_,nE,Z_,J_,Q_,eD,nD,ER,S_,sD,aD,uD,fE,hD,pD,gD,xD,vD,ID,CD,$D,RD,FD,DD,MD,zD,BD,WD,GD,vR,E_,HD,qD,KD,XD,YD,ZD,JD,QD,nO,rO,aO,oO,uO,cO,hO,dO,pO,$_,kE,mO,bO,xO,vO,NO,TO,SE,EO,RO,{kernelName:er,backendName:"webgl",kernelFunc:function(e){
const{inputs:t,backend:n,attrs:r}=e,{x:s,segmentIds:i}=t,{numSegments:a}=r,o=s.shape.length,u=[];let l=0;const c=Uo([l],o);let h=s;null!=c&&(h=IE({inputs:{x:s},backend:n,attrs:{perm:c}}),u.push(h),l=Vo(1,o)[0]);const d=Lc(h.shape,l,a),p=m([h.shape[l]]),f=pE({inputs:{x:h},backend:n,attrs:{shape:[-1,p]}});u.push(f);const g=cs(s.dtype),b=(e,t,r,s,i)=>{
const a=e.shape[0],o=e.shape[1],l=Mc(o,i),c=new AO({windowSize:l,inSize:o,batchSize:a,numSegments:i},t),h=n.compileAndRun(c,[e,r],s);if(u.push(h),h.shape[1]===i){
return h;
}const d=tD({backend:n,attrs:{start:0,stop:i,step:1,dtype:"float32"}}),p=wO({inputs:{x:d},backend:n,attrs:{reps:[o/l]}});return u.push(d),u.push(p),b(h,t,p,s,i);
},x=pE({inputs:{x:b(f,"unsortedSegmentSum",i,g,a)},backend:n,attrs:{shape:d}});let y=x;if(null!=c){
u.push(x);const e=Wo(c);y=IE({inputs:{x:y},backend:n,attrs:{perm:e}});
}return u.forEach((e=>n.disposeIntermediateTensorInfo(e))),y;
}},W_];for(const e of FO){
fr(e);
}class _O{
static resize(e){
const{image:t,ratio:n}=e,r=Math.round(t.width*n),s=Math.round(t.height*n),i=new Uint8Array(r*s);for(let e=0;e<r;e++){
let a=Math.round(1*e/n),o=Math.round(1*(e+1)/n)-1;o>=t.width&&(o=t.width-1);for(let u=0;u<s;u++){
let s=Math.round(1*u/n),l=Math.round(1*(u+1)/n)-1;l>=t.height&&(l=t.height-1);let c=0,h=0;for(let e=a;e<=o;e++){
for(let n=s;n<=l;n++){
c+=1*t.data[n*t.width+e],h+=1;
}
}i[u*r+e]=Math.floor(c/h);
}
}return{data:i,width:r,height:s};
}upsampleBilinear(e){
const{image:t,padOneWidth:n,padOneHeight:r}=e,{width:s,height:i,data:a}=t,o=2*t.width+(n?1:0),u=2*t.height+(r?1:0),l=new Float32Array(o*u);for(let e=0;e<o;e++){
const t=.5*e-.25;let n=Math.floor(t),r=Math.ceil(t);n<0&&(n=0),r>=s&&(r=s-1);for(let c=0;c<u;c++){
const u=.5*c-.25;let h=Math.floor(u),d=Math.ceil(u);h<0&&(h=0),d>=i&&(d=i-1);const p=(r-t)*(d-u)*a[h*s+n]+(r-t)*(u-h)*a[d*s+n]+(t-n)*(d-u)*a[h*s+r]+(t-n)*(u-h)*a[d*s+r];l[c*o+e]=p;
}
}return{data:l,width:o,height:u};
}simpleUpsampleBilinear(e){
const{image:t,padOneWidth:n,padOneHeight:r}=e,{width:s,height:i,data:a}=t,o=2*t.width+(n?1:0),u=2*t.height+(r?1:0),l=new Float32Array(o*u);for(let e=0;e<s;e++){
for(let t=0;t<i;t++){
const n=.25*a[t*s+e],r=Math.floor(t/2)*o+Math.floor(e/2);l[r]+=n,l[r+1]+=n,l[r+o]+=n,l[r+o+1]+=n;
}
}return{data:l,width:o,height:u};
}
}class DO{
static buildImageList(e){
const t=[];let n=100/Math.min(e.width,e.height);for(;;){
if(t.push(n),n*=Math.pow(2,1/3),n>=.95){
n=1;break;
}
}t.push(n),t.reverse();const r=[];for(let n=0;n<t.length;n++){
r.push(Object.assign(_O.resize({image:e,ratio:t[n]}),{scale:t[n]}));
}return r;
}static buildTrackingImageList(e){
const t=Math.min(e.width,e.height),n=[],r=[];n.push(256/t),n.push(128/t);for(const t of n){
r.push(Object.assign(_O.resize({image:e,ratio:t}),{scale:t}));
}return r;
}
}class OO{
constructor(e=1234){
this.seed=e;
}arrayShuffle(e){
const{arr:t,sampleSize:n}=e;for(let e=0;e<n;e++){
this.seed=(214013*this.seed+2531011)%(1<<31);let n=this.seed>>16&32767;n%=t.length;let r=t[e];t[e]=t[n],t[n]=r;
}return t;
}nextInt(e){
this.seed=(214013*this.seed+2531011)%(1<<31);let t=this.seed>>16&32767;return t%=e,t;
}
}class MO{
get distance(){
return this._distance;
}constructor(e){
this._distance=0,this._distance=this.compute(e);
}static compute(e){
const{v1:t,v2:n}=e;let r=0;for(let e=0;e<t.length;e++){
let s=(t[e]^n[e])>>>0;r+=this.parallelBitCount(s);
}return r;
}static parallelBitCount(e){
let t=e-(e>>1&1431655765);return t=(t>>2&858993459)+(858993459&t),t=(t>>4)+t&252645135,t=(t>>8)+t&16711935,t=(t>>16)+t&65535,t;
}compute(e){
return MO.compute(e);
}
}class LO{
build(e){
const{points:t}=e,n=[];for(let e=0;e<t.length;e++){
n.push(e);
}const r=new OO;return{rootNode:this.builder({points:t,pointIndexes:n,randomizer:r,centerPointIndex:null})};
}builder(e){
const{points:t,pointIndexes:n,randomizer:r,centerPointIndex:s}=e;let i=n.length<=8||n.length<=16;const a={};if(!i){
const e=this.computeKMeloids({points:t,pointIndexes:n,randomizer:r});for(let t=0;t<e.length;t++){
void 0===a[n[e[t]]]&&(a[n[e[t]]]=[]),a[n[e[t]]].push(n[t]);
}
}1===Object.keys(a).length&&(i=!0);const o={centerPointIndex:s};if(i){
o.leaf=!0,o.pointIndexes=[];for(const e of n){
o.pointIndexes.push(e);
}return o;
}return o.leaf=!1,o.children=[],Object.keys(a).forEach((e=>{
o.children.push(this.builder({points:t,pointIndexes:a[e],randomizer:r,centerPointIndex:parseInt(e)}));
})),o;
}computeKMeloids(e){
const{points:t,pointIndexes:n,randomizer:r}=e,s=[];for(let e=0;e<n.length;e++){
s.push(e);
}let i=Number.MAX_SAFE_INTEGER,a=-1;const o=[];for(let e=0;e<128;e++){
r.arrayShuffle({arr:s,sampleSize:8});let u=0;const l=[];for(let e=0;e<n.length;e++){
let r=Number.MAX_SAFE_INTEGER;for(let i=0;i<8;i++){
const a=n[s[i]],o=MO.compute({v1:t[n[e]].descriptors,v2:t[a].descriptors});o<r&&(l[e]=s[i],r=o);
}u+=r;
}o.push(l),u<i&&(i=u,a=e);
}return o[a];
}
}var zO=function(e,t,n,r){
return new(n||(n=Promise))((function(s,i){
function a(e){
try{
u(r.next(e));
}catch(e){
i(e);
}
}function o(e){
try{
u(r.throw(e));
}catch(e){
i(e);
}
}function u(e){
var t;e.done?s(e.value):(t=e.value,t instanceof n?t:new n((function(e){
e(t);
}))).then(a,o);
}u((r=r.apply(e,t||[])).next());
}));
};class PO{
constructor(e){
this.Detector=e;
}compileImageTargets(e,t){
return zO(this,void 0,void 0,(function*(){
const n=yield this.compileImageTargetsRaw(e,t);return this.encodeData(n);
}));
}compileImageTargetsRaw(e,t){
return new Promise((n=>zO(this,void 0,void 0,(function*(){
const r=[],s=[];for(const t of e){
const e=t,n=this.createProcessCanvas(e).getContext("2d");n.drawImage(e,0,0,e.width,e.height);const s=n.getImageData(0,0,e.width,e.height),i=new Uint8Array(e.width*e.height);for(let e=0;e<i.length;e++){
const t=4*e;i[e]=Math.floor((s.data[t]+s.data[t+1]+s.data[t+2])/3);
}const a={data:i,height:e.height,width:e.width};r.push(a);
}const i=50/r.length;let a=0;for(const e of r){
const n=e,r=DO.buildImageList(n),o=i/r.length,u=yield this.extractMatchingFeatures(r,(()=>{
a+=o,t(a);
}));s.push({targetImage:n,imageList:r,matchingData:u});
}for(let e=0;e<r.length;e++){
const t=DO.buildTrackingImageList(r[e]);s[e].trackingImageList=t;
}const o=yield this.compileTrack({progressCallback:t,targetImages:r,basePercent:50});for(let e=0;e<r.length;e++){
s[e].trackingData=o[e];
}n(s);
}))));
}encodeData(e){
const t=[];for(const n of e){
t.push({targetImage:{width:n.targetImage.width,height:n.targetImage.height},trackingData:n.trackingData,matchingData:n.matchingData});
}const n={v:2,dataList:t};return s.encode(n);
}importData(e){
const t=s.decode(new Uint8Array(e));if(!t.v||2!==t.v){
return console.error("Your compiled .aryelit might be outdated. Please recompile"),[];
}const{dataList:n}=t,r=[];for(const e of n){
r.push({targetImage:e.targetImage,trackingData:e.trackingData,matchingData:e.matchingData});
}return r;
}extractMatchingFeatures(e,t){
return zO(this,void 0,void 0,(function*(){
const n=[];for(let r=0;r<e.length;r++){
const s=e[r],i=new this.Detector(s.width,s.height);yield Al(),xi((()=>{
const e=Ds(s.data,[s.data.length],"float32").reshape([s.height,s.width]),{featurePoints:a}=i.detect(e),o=a.filter((e=>e.maxima)),u=a.filter((e=>!e.maxima)),l=new LO,c=l.build({points:o}),h=l.build({points:u});n.push({maximaPoints:o,minimaPoints:u,maximaPointsCluster:c,minimaPointsCluster:h,width:s.width,height:s.height,scale:s.scale}),t(r);
}));
}return n;
}));
}
}const BO=document.currentScript,UO=BO?new URL(BO.src):"",WO=UO?UO.href.split("?")[0].split("/").slice(0,-1).concat(["compiler.worker.js"]).join("/"):"compiler.worker.js",VO=UO?new URLSearchParams(UO.search):null,GO=(null==VO?void 0:VO.get("worker"))||WO;var jO=__webpack_require__(397),HO=__webpack_require__.n(jO);const qO=[{sigma:.55,points:[[-1,0],[-.5,-.866025],[.5,-.866025],[1,-0],[.5,.866025],[-.5,.866025]]},{sigma:.475,points:[[0,.930969],[-.806243,.465485],[-.806243,-.465485],[-0,-.930969],[.806243,-.465485],[.806243,.465485]]},{sigma:.4,points:[[.847306,-0],[.423653,.733789],[-.423653,.733789],[-.847306,0],[-.423653,-.733789],[.423653,-.733789]]},{sigma:.325,points:[[-0,-.741094],[.641806,-.370547],[.641806,.370547],[0,.741094],[-.641806,.370547],[-.641806,-.370547]]},{sigma:.25,points:[[-.595502,0],[-.297751,-.51572],[.297751,-.51572],[.595502,-0],[.297751,.51572],[-.297751,.51572]]},{sigma:.175,points:[[0,.362783],[-.314179,.181391],[-.314179,-.181391],[-0,-.362783],[.314179,-.181391],[.314179,.181391]]},{sigma:.1,points:[[0,0]]}],KO=[];for(const e of qO){
const t=e.sigma;for(const n of e.points){
KO.push([t,n[0],n[1]]);
}
}const XO=2*Math.sqrt(2);class YO{
constructor(e,t){
for(this.numOctaves=0,this.tensorCaches={};e>=2&&t>=2&&(e/=2,t/=2,this.numOctaves++,3!==this.numOctaves);){}
}exponentialLeastSquares(e,t){
const[n,r]=e,s=HO().linspace(n,r,1e5),i=s.map((e=>Math.exp(e))),a=s.map((e=>{
const n=[];for(let r=0;r<=t;r++){
n.push(Math.pow(e,r));
}return n;
}));return HO().solve(HO().dot(HO().transpose(a),a),HO().dot(HO().transpose(a),i));
}computeCoefficients(e,t){
const n=[-e,e];return this.exponentialLeastSquares(n,t);
}detect(e){
const t=[];for(let n=0;n<this.numOctaves;n++){
const r=0===n?this.applyFilter(e):this.downsampleBilinear(t[n-1][t[n-1].length-1]),s=this.applyFilter(r);t.push([r,s]);
}const n=[];for(let e=0;e<this.numOctaves;e++){
const r=this.differenceImageBinomial(t[e][0],t[e][1]);n.push(r);
}const r=[];for(let e=1;e<this.numOctaves-1;e++){
const t=this.buildExtrema(n[e-1],n[e],n[e+1]);r.push(t);
}const s=this.applyPrune(r),i=this.computeLocalization(s,n),a=this.computeOrientationHistograms(i,t),o=this.smoothHistograms(a),u=this.computeExtremaAngles(o),l=this.computeExtremaFreak(t,i,u),c=this.computeFreakDescriptors(l),h=i.arraySync(),d=u.arraySync(),p=c.arraySync();t.forEach((e=>e.forEach((e=>e.dispose())))),n.forEach((e=>e&&e.dispose())),r.forEach((e=>e.dispose())),i.dispose(),a.dispose(),o.dispose(),u.dispose(),l.dispose(),c.dispose();const f=[];for(let e=0;e<h.length;e++){
if(0==h[e][0]){
continue;
}const t=[],n=256,r=65536,s=16777216;for(let i=0;i<p[e].length;i+=4){
let a=p[e][i]*s+p[e][i+1]*r+p[e][i+2]*n+p[e][i+3];t.push(a);
}const i=h[e][1],a=h[e][2],o=h[e][3]*Math.pow(2,i)+Math.pow(2,i-1)-.5,u=a*Math.pow(2,i)+Math.pow(2,i-1)-.5,l=Math.pow(2,i);f.push({maxima:h[e][0]>0,x:o,y:u,scale:l,angle:d[e],descriptors:t});
}return{featurePoints:f};
}computeFreakDescriptors(e){
if(!this.tensorCaches.computeFreakDescriptors){
const t=[],n=[];for(let r=0;r<e.shape[1];r++){
for(let s=r+1;s<e.shape[1];s++){
t.push(r),n.push(s);
}
}const r=Ds(t,[t.length]).cast("int32"),s=Ds(n,[n.length]).cast("int32");this.tensorCaches.computeFreakDescriptors={positionT:wi(yu([r,s],1))};
}const{positionT:t}=this.tensorCaches.computeFreakDescriptors;return xi((()=>gi().runKernel("ComputeFreakDescriptors",{extremaFreaks:e,positionT:t})));
}computeExtremaFreak(e,t,n){
this.tensorCaches._computeExtremaFreak||xi((()=>{
const e=Ds(KO);this.tensorCaches._computeExtremaFreak={freakPointsT:wi(e)};
}));const{freakPointsT:r}=this.tensorCaches._computeExtremaFreak,s=[];for(let t=1;t<e.length;t++){
s.push(e[t][1]);
}return xi((()=>gi().runKernel("ComputeExtremaFreak",{gaussianImagesT:s,prunedExtrema:t,prunedExtremaAngles:n,freakPointsT:r,pyramidImagesLength:e.length})));
}computeExtremaAngles(e){
return xi((()=>gi().runKernel("ComputeExtremaAngles",{histograms:e})));
}computeOrientationHistograms(e,t){
const n=[];for(let e=1;e<t.length;e++){
n.push(t[e][1]);
}this.tensorCaches.orientationHistograms||xi((()=>{
const e=-1/(2*XO*XO),t=1.5*XO,n=Math.ceil(t),r=this.computeCoefficients(t,6),s=[];for(let i=-n;i<=n;i++){
for(let a=-n;a<=n;a++){
const n=a*a+i*i;if(n<=t*t){
const t=n*e;let o=(r[0]+t*(r[1]+t*(r[2]+t*(r[3]+t*(r[4]+t*r[5])))))*r[6];s.push([i,a,o]);
}
}
}this.tensorCaches.orientationHistograms={radialPropertiesT:wi(Ds(s,[s.length,3]))};
}));const{radialPropertiesT:r}=this.tensorCaches.orientationHistograms;return xi((()=>gi().runKernel("ComputeOrientationHistograms",{gaussianImagesT:n,prunedExtremaT:e,radialPropertiesT:r,pyramidImagesLength:t.length})));
}smoothHistograms(e){
return xi((()=>gi().runKernel("SmoothHistograms",{histograms:e})));
}computeLocalization(e,t){
return xi((()=>{
const n=gi().runKernel("ComputeLocalization",{prunedExtremaList:e,dogPyramidImagesT:t}).arraySync(),r=[];for(let e=0;e<n.length;e++){
r.push([]);for(const t of n[e]){
r[e].push([]);
}
}const s=[];for(let t=0;t<e.length;t++){
s[t]=[e[t][0],e[t][1],e[t][2],e[t][3]];
}for(let e=0;e<s.length;e++){
if(0===s[e][0]){
continue;
}const t=n[e],r=.5*(t[1][2]-t[1][0]),i=.5*(t[2][1]-t[0][1]),a=t[1][2]+t[1][0]-2*t[1][1],o=t[2][1]+t[0][1]-2*t[1][1],u=.25*(t[0][0]+t[2][2]-t[0][2]-t[2][0]),l=a*o-u*u,c=(o*-r+-u*-i)/l,h=(-u*-r+a*-i)/l,d=s[e][2]+h,p=s[e][3]+c;Math.abs(l)<1e-4||(s[e][2]=d,s[e][3]=p);
}return Ds(s,[s.length,s[0].length],"float32");
}));
}applyPrune(e){
const t=[],n=[];for(let e=0;e<16;e++){
n.push([]),t.push([]);for(let r=0;r<5;r++){
n[e].push([0,0,0,0]),t[e].push(0);
}
}xi((()=>{
for(let r=0;r<e.length;r++){
const s=r+1,i=gi().runKernel("ExtremaReduction",{extremaResultT:e[r]}),a=i.arraySync(),o=i.shape[0],u=i.shape[1],l=2*u/4,c=2*o/4;for(let e=0;e<o;e++){
for(let r=0;r<u;r++){
const i=a[e][r];if(0==i){
continue;
}const o=i%1e3,u=Math.floor(Math.abs(i)/1e3),h=2*r+(2===u||3===u?1:0),d=2*e+(1===u||3===u?1:0),p=Math.floor(h/l),f=4*Math.floor(d/c)+p,m=Math.abs(o);let g=5;for(;g>=1&&m>t[f][g-1];){
g-=1;
}if(g<5){
for(let e=4;e>=g+1;e--){
t[f][e]=t[f][e-1],n[f][e][0]=n[f][e-1][0],n[f][e][1]=n[f][e-1][1],n[f][e][2]=n[f][e-1][2],n[f][e][3]=n[f][e-1][3];
}t[f][g]=m,n[f][g][0]=o,n[f][g][1]=s,n[f][g][2]=d,n[f][g][3]=h;
}
}
}
}
}));const r=[];for(let e=0;e<16;e++){
for(let t=0;t<5;t++){
r.push(n[e][t]);
}
}return r;
}buildExtrema(e,t,n){
return xi((()=>gi().runKernel("BuildExtrema",{image0:e,image1:t,image2:n})));
}differenceImageBinomial(e,t){
return xi((()=>{
if(e.size!==t.size){
const n=e.size===Math.min(e.size,t.size)?e:t;t=t.slice(0,n.shape),e=e.slice(0,n.shape);
}return e.sub(t);
}));
}applyFilter(e){
return xi((()=>gi().runKernel("BinomialFilter",{image:e})));
}downsampleBilinear(e){
return xi((()=>gi().runKernel("DownsampleBilinear",{image:e})));
}
}const ZO={},JO={kernelName:"BinomialFilter",backendName:"webgl",kernelFunc:e=>{
const t=e.inputs.image,n=e.backend,[r,s]=function(e){
const t=e.shape[1],n="w"+t;if(!ZO.hasOwnProperty(n)){
const r=e.shape[0],s={variableNames:["p"],outputShape:[r,t],userCode:"\n        void main() {\n          ivec2 coords = getOutputCoords();\n\n          float sum = getP(coords[0], coords[1]-2);\n          sum += getP(coords[0], coords[1]-1) * 4.;\n          sum += getP(coords[0], coords[1]) * 6.;\n          sum += getP(coords[0], coords[1]+1) * 4.;\n          sum += getP(coords[0], coords[1]+2);\n          setOutput(sum);\n        }\n      "},i={variableNames:["p"],outputShape:[r,t],userCode:"\n        void main() {\n          ivec2 coords = getOutputCoords();\n\n          float sum = getP(coords[0]-2, coords[1]);\n          sum += getP(coords[0]-1, coords[1]) * 4.;\n          sum += getP(coords[0], coords[1]) * 6.;\n          sum += getP(coords[0]+1, coords[1]) * 4.;\n          sum += getP(coords[0]+2, coords[1]);\n          sum /= 255.; //256\n          setOutput(sum);\n        }\n      "};ZO[n]=[s,i];
}return ZO[n];
}(t),i=n.runWebGLProgram(r,[t],t.dtype),a=n.runWebGLProgram(s,[i],t.dtype);return n.disposeIntermediateTensorInfo(i),a;
}},QO={},eM={kernelName:"BuildExtrema",backendName:"webgl",kernelFunc:e=>{
let{image0:t,image1:n,image2:r}=e.inputs;const s=e.backend,i=function(e){
const t=e.shape[1],n="w"+t;if(!QO.hasOwnProperty(n)){
const r=e.shape[0],s={variableNames:["image0","image1","image2"],outputShape:[r,t],userCode:`\n        void main() {\n          ivec2 coords = getOutputCoords();\n    \n          int y = coords[0];\n          int x = coords[1];\n    \n          float value = getImage1(y, x);\n    \n          // Step 1: find local maxima/minima\n          if (value * value < 9.) {\n            setOutput(0.);\n            return;\n          }\n          if (y < 7 || y > ${r-1-7}) {\n            setOutput(0.);\n            return;\n          }\n          if (x < 7 || x > ${t-1-7}) {\n            setOutput(0.);\n            return;\n          }\n    \n          bool isMax = true;\n          bool isMin = true;\n          for (int dy = -1; dy <= 1; dy++) {\n            for (int dx = -1; dx <= 1; dx++) {\n              float value0 = getImage0(y+dy, x+dx);\n              float value1 = getImage1(y+dy, x+dx);\n              float value2 = getImage2(y+dy, x+dx);\n    \n        if (value < value0 || value < value1 || value < value2) {\n          isMax = false;\n        }\n        if (value > value0 || value > value1 || value > value2) {\n          isMin = false;\n        }\n            }\n          }\n    \n          if (!isMax && !isMin) {\n            setOutput(0.);\n            return;\n          }\n    \n          // compute edge score and reject based on threshold\n          float dxx = getImage1(y, x+1) + getImage1(y, x-1) - 2. * getImage1(y, x);\n          float dyy = getImage1(y+1, x) + getImage1(y-1, x) - 2. * getImage1(y, x);\n          float dxy = 0.25 * (getImage1(y-1,x-1) + getImage1(y+1,x+1) - getImage1(y-1,x+1) - getImage1(y+1,x-1));\n    \n          float det = (dxx * dyy) - (dxy * dxy);\n    \n          if (abs(det) < 0.0001) { // determinant undefined. no solution\n            setOutput(0.);\n            return;\n          }\n    \n          float edgeScore = (dxx + dyy) * (dxx + dyy) / det;\n    \n          if (abs(edgeScore) >= 6.25 ) {\n            setOutput(0.);\n            return;\n          }\n          setOutput(getImage1(y,x));\n        }\n      `};QO[n]=s;
}return QO[n];
}(n);return t=gi().runKernel("DownsampleBilinear",{image:t}),r=gi().runKernel("UpsampleBilinear",{image:r,targetImage:n}),s.runWebGLProgram(i,[t,n,r],n.dtype);
}},tM={},nM={kernelName:"ComputeExtremaAngles",backendName:"webgl",kernelFunc:e=>{
const{histograms:t}=e.inputs,n=e.backend,r=function(e){
const t=e.shape[0];if(!tM.hasOwnProperty(t)){
const n={variableNames:["histogram"],outputShape:[e.shape[0]],userCode:`\n            void main() {\n                int featureIndex = getOutputCoords();\n\n                int maxIndex = 0;\n                for (int i = 1; i < 36; i++) {\n                    if (getHistogram(featureIndex, i) > getHistogram(featureIndex, maxIndex)) {\n                        maxIndex = i;\n                    }\n                }\n\n                int prev = imod(maxIndex - 1 + 36, 36);\n                int next = imod(maxIndex + 1, 36);\n\n                /**\n                 * Fit a quadratic to 3 points. The system of equations is:\n                 *\n                 * y0 = A*x0^2 + B*x0 + C\n                 * y1 = A*x1^2 + B*x1 + C\n                 * y2 = A*x2^2 + B*x2 + C\n                 *\n                 * This system of equations is solved for A,B,C.\n                 */\n                float p10 = float(maxIndex - 1);\n                float p11 = getHistogram(featureIndex, prev); \n                float p20 = float(maxIndex);\n                float p21 = getHistogram(featureIndex, maxIndex); \n                float p30 = float(maxIndex + 1);\n                float p31 = getHistogram(featureIndex, next); \n\n                float d1 = (p30-p20)*(p30-p10);\n                float d2 = (p10-p20)*(p30-p10);\n                float d3 = p10-p20;\n\n                // If any of the denominators are zero then, just use maxIndex.\n                    float fbin = float(maxIndex);\n                if ( abs(d1) > 0.00001 && abs(d2) > 0.00001 && abs(d3) > 0.00001) {\n                float a = p10*p10;\n                float b = p20*p20;\n\n                // Solve for the coefficients A,B,C\n                float A = ((p31-p21)/d1)-((p11-p21)/d2);\n                float B = ((p11-p21)+(A*(b-a)))/d3;\n                float C = p11-(A*a)-(B*p10);\n                fbin = -B / (2. * A);\n                }\n\n                float an = 2.0 *${Math.PI} * (fbin + 0.5) / 36. - ${Math.PI};\n                setOutput(an);\n            }\n            `};tM[t]=n;
}return tM[t];
}(t);return n.runWebGLProgram(r,[t],t.dtype);
}},rM={},sM={kernelName:"ComputeExtremaFreak",backendName:"webgl",kernelFunc:e=>{
const{gaussianImagesT:t,prunedExtrema:n,prunedExtremaAngles:r,freakPointsT:s,pyramidImagesLength:i}=e.inputs,a=e.backend,o=function(e,t){
const n=`${e}|${t.shape[0]}`;if(!rM.hasOwnProperty(n)){
const r=[];for(let t=1;t<e;t++){
r.push("image"+t);
}let s="float getPixel(int octave, int y, int x) {";for(let t=1;t<e;t++){
s+=`\n  if (octave == ${t}) {\n\treturn getImage${t}(y, x);\n  }\n`;
}s+="}";const i={variableNames:[...r,"extrema","angles","freakPoints"],outputShape:[t.shape[0],KO.length],userCode:`\n  ${s}\n  void main() {\n\tivec2 coords = getOutputCoords();\n\tint featureIndex = coords[0];\n\tint freakIndex = coords[1];\n\n\tfloat freakSigma = getFreakPoints(freakIndex, 0);\n\tfloat freakX = getFreakPoints(freakIndex, 1);\n\tfloat freakY = getFreakPoints(freakIndex, 2);\n\n\tint octave = int(getExtrema(featureIndex, 1));\n\tfloat inputY = getExtrema(featureIndex, 2);\n\tfloat inputX = getExtrema(featureIndex, 3);\n\tfloat inputAngle = getAngles(featureIndex);\n\tfloat cos = 7. * cos(inputAngle);\n\tfloat sin = 7. * sin(inputAngle);\n\n\tfloat yp = inputY + freakX * sin + freakY * cos;\n\tfloat xp = inputX + freakX * cos + freakY * -sin;\n\n\tint x0 = int(floor(xp));\n\tint x1 = x0 + 1;\n\tint y0 = int(floor(yp));\n\tint y1 = y0 + 1;\n\n\tfloat f1 = getPixel(octave, y0, x0);\n\tfloat f2 = getPixel(octave, y0, x1);\n\tfloat f3 = getPixel(octave, y1, x0);\n\tfloat f4 = getPixel(octave, y1, x1);\n\n\tfloat x1f = float(x1);\n\tfloat y1f = float(y1);\n\tfloat x0f = float(x0);\n\tfloat y0f = float(y0);\n\n\t// ratio for interpolation between four neighboring points\n\tfloat value = (x1f - xp) * (y1f - yp) * f1\n\t\t+ (xp - x0f) * (y1f - yp) * f2\n\t\t+ (x1f - xp) * (yp - y0f) * f3\n\t\t+ (xp - x0f) * (yp - y0f) * f4;\n\n\tsetOutput(value);\n  }\n`};rM[n]=i;
}return rM[n];
}(i,n);return a.runWebGLProgram(o,[...t,n,r,s],"float32");
}},iM=(KO.length-1)*KO.length/2,aM=Math.ceil(iM/8),oM={},uM={kernelName:"ComputeFreakDescriptors",backendName:"webgl",kernelFunc:e=>{
const{extremaFreaks:t,positionT:n}=e.inputs,{backend:r}=e,s=function(e){
const t=`${e.shape[0]}`;if(!oM.hasOwnProperty(t)){
const n={variableNames:["freak","p"],outputShape:[e.shape[0],aM],userCode:`\n  void main() {\n    ivec2 coords = getOutputCoords();\n    int featureIndex = coords[0];\n    int descIndex = coords[1] * 8;\n\n    int sum = 0;\n    for (int i = 0; i < 8; i++) {\n      if (descIndex + i >= ${iM}) {\n        continue;\n      }\n\n      int p1 = int(getP(descIndex + i, 0));\n      int p2 = int(getP(descIndex + i, 1));\n\n      float v1 = getFreak(featureIndex, p1);\n      float v2 = getFreak(featureIndex, p2);\n\n      if (v1 < v2 + 0.01) {\n        sum += int(pow(2.0, float(7 - i)));\n      }\n    }\n    setOutput(float(sum));\n  }\n`};oM[t]=n;
}return oM[t];
}(t);return r.runWebGLProgram(s,[t,n],"int32");
}},lM={},cM={kernelName:"ComputeLocalization",backendName:"webgl",kernelFunc:e=>{
const{prunedExtremaList:t,dogPyramidImagesT:n}=e.inputs,r=e.backend,s=function(e,t){
const n=`${e}|${t}`;if(!lM.hasOwnProperty(n)){
const r=[];let s="float getPixel(int octave, int y, int x) {";for(let t=1;t<e;t++){
r.push("image"+t),s+=`\n\t\t\t\tif (octave == ${t}) {\n\t\t\t\t\treturn getImage${t}(y, x);\n\t\t\t\t}\n\t\t\t`;
}s+="}",lM[n]={variableNames:[...r,"extrema"],outputShape:[t,3,3],userCode:`\n\t\t\t${s}\n\t\t\n\t\t\tvoid main() {\n\t\t\t\tivec3 coords = getOutputCoords();\n\t\t\t\tint featureIndex = coords[0];\n\t\t\t\tfloat score = getExtrema(featureIndex, 0);\n\t\t\t\tif (score == 0.0) {\n\t\t\t\t\treturn;\n\t\t\t\t}\n\t\t\n\t\t\t\tint dy = coords[1]-1;\n\t\t\t\tint dx = coords[2]-1;\n\t\t\t\tint octave = int(getExtrema(featureIndex, 1));\n\t\t\t\tint y = int(getExtrema(featureIndex, 2));\n\t\t\t\tint x = int(getExtrema(featureIndex, 3));\n\t\t\t\tsetOutput(getPixel(octave, y+dy, x+dx));\n\t\t\t}\n\t\t\t`};
}return lM[n];
}(n.length,t.length),i=Ds(t,[t.length,t[0].length],"int32");return r.runWebGLProgram(s,[...n.slice(1),i],n[0].dtype);
}},hM={},dM={kernelName:"ComputeOrientationHistograms",backendName:"webgl",kernelFunc:e=>{
const{gaussianImagesT:t,prunedExtremaT:n,radialPropertiesT:r,pyramidImagesLength:s}=e.inputs,i=e.backend,[a,o]=function(e,t,n){
const r=`${n}|${e.shape[0]}|${t.shape[0]}`;if(!hM.hasOwnProperty(r)){
const s=[];for(let e=1;e<n;e++){
s.push("image"+e);
}let i="float getPixel(int octave, int y, int x) {";for(let e=1;e<n;e++){
i+=`\n            if (octave == ${e}) {\n                return getImage${e}(y, x);\n            }\n            `;
}i+="}";const a={variableNames:[...s,"extrema","radial"],outputShape:[e.shape[0],t.shape[0],2],userCode:`\n                ${i}\n\n                void main() {\n                    ivec3 coords = getOutputCoords();\n                    int featureIndex = coords[0];\n                    int radialIndex = coords[1];\n                    int propertyIndex = coords[2];\n\n                    int radialY = int(getRadial(radialIndex, 0));\n                    int radialX = int(getRadial(radialIndex, 1));\n                    float radialW = getRadial(radialIndex, 2);\n\n                    int octave = int(getExtrema(featureIndex, 1));\n                    int y = int(getExtrema(featureIndex, 2));\n                    int x = int(getExtrema(featureIndex, 3));\n\n                    int xp = x + radialX;\n                    int yp = y + radialY;\n\n                    float dy = getPixel(octave, yp+1, xp) - getPixel(octave, yp-1, xp);\n                    float dx = getPixel(octave, yp, xp+1) - getPixel(octave, yp, xp-1);\n\n                    if (propertyIndex == 0) {\n                    // be careful that atan(0, 0) gives 1.57 instead of 0 (different from js), but doesn't matter here, coz magnitude is 0\n                    \n                    float angle = atan(dy, dx) + ${Math.PI};\n                    float fbin = angle * 36. * 0.159154943091895;\n                    setOutput(fbin);\n                    return;\n                    }\n\n                    if (propertyIndex == 1) {\n                        float mag = sqrt(dx * dx + dy * dy);\n                        float magnitude = radialW * mag;\n                        setOutput(magnitude);\n                        return;\n                    }\n                }\n\n                `},o={variableNames:["fbinMag"],outputShape:[e.shape[0],36],userCode:`\n            void main() {\n                ivec2 coords = getOutputCoords();\n                int featureIndex = coords[0];\n                int binIndex = coords[1];\n\n                float sum = 0.;\n                for (int i = 0; i < ${t.shape[0]}; i++) {\n                    float fbin = getFbinMag(featureIndex, i, 0);\n                    int bin = int(floor(fbin - 0.5));\n                    int b1 = imod(bin + 36, 36);\n                    int b2 = imod(bin + 1 + 36, 36);\n\n                    if (b1 == binIndex || b2 == binIndex) {\n                        float magnitude = getFbinMag(featureIndex, i, 1);\n                        float w2 = fbin - float(bin) - 0.5;\n                        float w1 = w2 * -1. + 1.;\n\n                        if (b1 == binIndex) {\n                            sum += w1 * magnitude;\n                        }\n                        if (b2 == binIndex) {\n                            sum += w2 * magnitude;\n                        }\n                    }\n                }\n                setOutput(sum);\n            }\n            `};hM[r]=[a,o];
}return hM[r];
}(n,r,s),u=i.runWebGLProgram(a,[...t,n,r],r.dtype),l=i.runWebGLProgram(o,[u],r.dtype);return i.disposeIntermediateTensorInfo(u),l;
}},pM={},fM={kernelName:"DownsampleBilinear",backendName:"webgl",kernelFunc:e=>{
const t=e.inputs.image,n=e.backend,r=function(e){
const t=e.shape[0],n=e.shape[1],r="w"+n;if(!pM.hasOwnProperty(r)){
const e={variableNames:["p"],outputShape:[Math.floor(t/2),Math.floor(n/2)],userCode:"\n            void main() {\n                ivec2 coords = getOutputCoords();\n                int y = coords[0] * 2;\n                int x = coords[1] * 2;\n        \n                float sum = getP(y, x) * 0.25;\n                sum += getP(y+1,x) * 0.25; \n                sum += getP(y, x+1) * 0.25; \n                sum += getP(y+1,x+1) * 0.25;\n                setOutput(sum);\n            }\n            "};pM[r]=e;
}return pM[r];
}(t);return n.runWebGLProgram(r,[t],t.dtype);
}},mM={kernelName:"ExtremaReduction",backendName:"webgl",kernelFunc:e=>{
const{extremaResultT:t}=e.inputs,n=e.backend,r=t.shape[0],s=t.shape[1],i={variableNames:["extrema"],outputShape:[Math.floor(r/2),Math.floor(s/2)],userCode:"\n\t\t  void main() {\n\t\t\tivec2 coords = getOutputCoords();\n\t\t\tint y = coords[0] * 2;\n\t\t\tint x = coords[1] * 2;\n  \n\t\t\tfloat location = 0.0;\n\t\t\tfloat values = getExtrema(y, x);\n  \n\t\t\tif (getExtrema(y+1, x) != 0.0) {\n\t\t\t  location = 1.0;\n\t\t  values = getExtrema(y+1, x);\n\t\t\t}\n\t\t\telse if (getExtrema(y, x+1) != 0.0) {\n\t\t\t  location = 2.0;\n\t\t  values = getExtrema(y, x+1);\n\t\t\t}\n\t\t\telse if (getExtrema(y+1, x+1) != 0.0) {\n\t\t\t  location = 3.0;\n\t\t  values = getExtrema(y+1, x+1);\n\t\t\t}\n  \n\t\t\tif (values < 0.0) {\n\t\t\t  setOutput(location * -1000.0 + values);\n\t\t\t} else {\n\t\t\t  setOutput(location * 1000.0 + values);\n\t\t\t}\n\t\t  }\n\t\t"};return n.runWebGLProgram(i,[t],t.dtype);
}},gM={},bM={kernelName:"SmoothHistograms",backendName:"webgl",kernelFunc:e=>{
let{histograms:t}=e.inputs;const n=e.backend,r=function(e){
const t=`h${e.shape[0]}`;if(!gM.hasOwnProperty(t)){
const n={variableNames:["histogram"],outputShape:[e.shape[0],36],userCode:"\n\n    const float PI = 3.141592653589793;\n            void main() {\n                ivec2 coords = getOutputCoords();\n\n                int featureIndex = coords[0];\n                int binIndex = coords[1];\n\n                float sigma = 2.0 * sqrt(2.0);\n      float weightPrev =\n        exp(float(-(1 * 1)) / float((2.0 * sigma * sigma))) /\n        (sigma * sqrt(2.0 * PI));\n      float weightCurrent =\n        exp(float(-(0 * 0)) / float(2.0 * sigma * sigma)) /\n        (sigma * sqrt(2.0 * PI));\n      float weightNext =\n        exp(float(-(1 * 1)) / float(2.0 * sigma * sigma)) /\n        (sigma * sqrt(2.0 * PI));\n      float weightSum = weightPrev + weightCurrent + weightNext;\n      int prevBin = imod(\n        binIndex - 1 + 36,\n        36\n      );\n      int nextBin = imod(binIndex + 1, 36);\n      float result =\n        (weightPrev / weightSum) * getHistogram(featureIndex, prevBin) +\n        (weightCurrent / weightSum) * getHistogram(featureIndex, binIndex) +\n        (weightNext / weightSum) * getHistogram(featureIndex, nextBin);\n                /*\n                int prevBin = imod(binIndex - 1 + 36, 36);\n                int nextBin = imod(binIndex + 1, 36);\n                float result = 0.274068619061197 * getHistogram(featureIndex, prevBin) + 0.451862761877606 * getHistogram(featureIndex, binIndex) + 0.274068619061197 * getHistogram(featureIndex, nextBin);\n                */\n                setOutput(result);\n            }\n            "};gM[t]=n;
}return gM[t];
}(t);for(let e=0;e<5;e++){
const s=t;t=n.runWebGLProgram(r,[t],t.dtype),e>0&&n.disposeIntermediateTensorInfo(s);
}return t;
}},xM={},yM={kernelName:"UpsampleBilinear",backendName:"webgl",kernelFunc:e=>{
const{image:t,targetImage:n}=e.inputs,r=e.backend,s=function(e,t){
const n="w"+e.shape[1];if(!xM.hasOwnProperty(n)){
const e={variableNames:["p"],outputShape:[t.shape[0],t.shape[1]],userCode:"\n              void main() {\n                ivec2 coords = getOutputCoords();\n                int j = coords[0];\n                int i = coords[1];\n        \n                float sj = 0.5 * float(j) - 0.25; \n                float si = 0.5 * float(i) - 0.25;\n        \n                float sj0 = floor(sj);\n                float sj1 = ceil(sj);\n                float si0 = floor(si);\n                float si1 = ceil(si);\n        \n                int sj0I = int(sj0);\n                int sj1I = int(sj1);\n                int si0I = int(si0);\n                int si1I = int(si1);\n        \n                float sum = 0.0;\n                sum += getP(sj0I, si0I) * (si1 - si) * (sj1 - sj);\n                sum += getP(sj1I, si0I) * (si1 - si) * (sj - sj0);\n                sum += getP(sj0I, si1I) * (si - si0) * (sj1 - sj);\n                sum += getP(sj1I, si1I) * (si - si0) * (sj - sj0);\n                setOutput(sum);\n              }\n            "};xM[n]=e;
}return xM[n];
}(t,n);return r.runWebGLProgram(s,[t],t.dtype);
}};fr(JO),fr(eM),fr(nM),fr(sM),fr(uM),fr(cM),fr(dM),fr(fM),fr(mM),fr(bM),fr(yM);const wM=window;wM.ARYEL||(wM.ARYEL={}),wM.ARYEL.Image||(wM.ARYEL.Image={Compiler:class extends PO{
constructor(e,t){
var n;super(e),this.workerPath=GO,this.workerPath=null!==(n=null==t?void 0:t.workerPath)&&void 0!==n?n:this.workerPath;
}createProcessCanvas(e){
const t=document.createElement("canvas");return t.width=e.width,t.height=e.height,t;
}compileTrack(e){
return new Promise(((t,n)=>{
const r=new Worker(this.workerPath);r.onmessage=n=>{
"progress"===n.data.type?e.progressCallback(e.basePercent+n.data.percent*e.basePercent/100):"compileDone"===n.data.type&&t(n.data.list);
},r.postMessage({type:"compile",targetImages:e.targetImages});
}));
}
},Detector:class extends YO{}});
})();
})();